import _defineProperty2 from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties2 from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray2 from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread2 from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized2 from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _toConsumableArray2 from "/var/lib/jenkins/workspace/hosted-implementations-deploy/implementations/madewell-student/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useRef, useCallback, useEffect, useMemo, cloneElement, Component, useLayoutEffect, useReducer, PureComponent, useState, forwardRef, useImperativeHandle, Fragment as Fragment$4, Suspense as Suspense$4 } from 'react';
import { FormattedHTMLMessage, injectIntl, FormattedMessage, IntlProvider } from 'react-intl';
import 'react-intl/locale-data/en.js';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var clone_1 = createCommonjsModule(function (module) {
  var clone = function () {
    function _instanceof(obj, type) {
      return type != null && obj instanceof type;
    }

    var nativeMap;

    try {
      nativeMap = Map;
    } catch (_) {
      // maybe a reference error because no `Map`. Give it a dummy value that no
      // value will ever be an instanceof.
      nativeMap = function nativeMap() {};
    }

    var nativeSet;

    try {
      nativeSet = Set;
    } catch (_) {
      nativeSet = function nativeSet() {};
    }

    var nativePromise;

    try {
      nativePromise = Promise;
    } catch (_) {
      nativePromise = function nativePromise() {};
    }
    /**
     * Clones (copies) an Object using deep copying.
     *
     * This function supports circular references by default, but if you are certain
     * there are no circular references in your object, you can save some CPU time
     * by calling clone(obj, false).
     *
     * Caution: if `circular` is false and `parent` contains circular references,
     * your program may enter an infinite loop and crash.
     *
     * @param `parent` - the object to be cloned
     * @param `circular` - set to true if the object to be cloned may contain
     *    circular references. (optional - true by default)
     * @param `depth` - set to a number if the object is only to be cloned to
     *    a particular depth. (optional - defaults to Infinity)
     * @param `prototype` - sets the prototype to be used when cloning an object.
     *    (optional - defaults to parent prototype).
     * @param `includeNonEnumerable` - set to true if the non-enumerable properties
     *    should be cloned as well. Non-enumerable properties on the prototype
     *    chain will be ignored. (optional - false by default)
    */


    function clone(parent, circular, depth, prototype, includeNonEnumerable) {
      if (typeof circular === 'object') {
        depth = circular.depth;
        prototype = circular.prototype;
        includeNonEnumerable = circular.includeNonEnumerable;
        circular = circular.circular;
      } // maintain two arrays for circular references, where corresponding parents
      // and children have the same index


      var allParents = [];
      var allChildren = [];
      var useBuffer = typeof Buffer != 'undefined';
      if (typeof circular == 'undefined') circular = true;
      if (typeof depth == 'undefined') depth = Infinity; // recurse this function so we don't reset allParents and allChildren

      function _clone(parent, depth) {
        // cloning null always returns null
        if (parent === null) return null;
        if (depth === 0) return parent;
        var child;
        var proto;

        if (typeof parent != 'object') {
          return parent;
        }

        if (_instanceof(parent, nativeMap)) {
          child = new nativeMap();
        } else if (_instanceof(parent, nativeSet)) {
          child = new nativeSet();
        } else if (_instanceof(parent, nativePromise)) {
          child = new nativePromise(function (resolve, reject) {
            parent.then(function (value) {
              resolve(_clone(value, depth - 1));
            }, function (err) {
              reject(_clone(err, depth - 1));
            });
          });
        } else if (clone.__isArray(parent)) {
          child = [];
        } else if (clone.__isRegExp(parent)) {
          child = new RegExp(parent.source, __getRegExpFlags(parent));
          if (parent.lastIndex) child.lastIndex = parent.lastIndex;
        } else if (clone.__isDate(parent)) {
          child = new Date(parent.getTime());
        } else if (useBuffer && Buffer.isBuffer(parent)) {
          if (Buffer.allocUnsafe) {
            // Node.js >= 4.5.0
            child = Buffer.allocUnsafe(parent.length);
          } else {
            // Older Node.js versions
            child = new Buffer(parent.length);
          }

          parent.copy(child);
          return child;
        } else if (_instanceof(parent, Error)) {
          child = Object.create(parent);
        } else {
          if (typeof prototype == 'undefined') {
            proto = Object.getPrototypeOf(parent);
            child = Object.create(proto);
          } else {
            child = Object.create(prototype);
            proto = prototype;
          }
        }

        if (circular) {
          var index = allParents.indexOf(parent);

          if (index != -1) {
            return allChildren[index];
          }

          allParents.push(parent);
          allChildren.push(child);
        }

        if (_instanceof(parent, nativeMap)) {
          parent.forEach(function (value, key) {
            var keyChild = _clone(key, depth - 1);

            var valueChild = _clone(value, depth - 1);

            child.set(keyChild, valueChild);
          });
        }

        if (_instanceof(parent, nativeSet)) {
          parent.forEach(function (value) {
            var entryChild = _clone(value, depth - 1);

            child.add(entryChild);
          });
        }

        for (var i in parent) {
          var attrs;

          if (proto) {
            attrs = Object.getOwnPropertyDescriptor(proto, i);
          }

          if (attrs && attrs.set == null) {
            continue;
          }

          child[i] = _clone(parent[i], depth - 1);
        }

        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(parent);

          for (var i = 0; i < symbols.length; i++) {
            // Don't need to worry about cloning a symbol because it is a primitive,
            // like a number or string.
            var symbol = symbols[i];
            var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);

            if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
              continue;
            }

            child[symbol] = _clone(parent[symbol], depth - 1);

            if (!descriptor.enumerable) {
              Object.defineProperty(child, symbol, {
                enumerable: false
              });
            }
          }
        }

        if (includeNonEnumerable) {
          var allPropertyNames = Object.getOwnPropertyNames(parent);

          for (var i = 0; i < allPropertyNames.length; i++) {
            var propertyName = allPropertyNames[i];
            var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);

            if (descriptor && descriptor.enumerable) {
              continue;
            }

            child[propertyName] = _clone(parent[propertyName], depth - 1);
            Object.defineProperty(child, propertyName, {
              enumerable: false
            });
          }
        }

        return child;
      }

      return _clone(parent, depth);
    }
    /**
     * Simple flat clone using prototype, accepts only objects, usefull for property
     * override on FLAT configuration object (no nested props).
     *
     * USE WITH CAUTION! This may not behave as you wish if you do not know how this
     * works.
     */


    clone.clonePrototype = function clonePrototype(parent) {
      if (parent === null) return null;

      var c = function c() {};

      c.prototype = parent;
      return new c();
    }; // private utility functions


    function __objToStr(o) {
      return Object.prototype.toString.call(o);
    }

    clone.__objToStr = __objToStr;

    function __isDate(o) {
      return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }

    clone.__isDate = __isDate;

    function __isArray(o) {
      return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }

    clone.__isArray = __isArray;

    function __isRegExp(o) {
      return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }

    clone.__isRegExp = __isRegExp;

    function __getRegExpFlags(re) {
      var flags = '';
      if (re.global) flags += 'g';
      if (re.ignoreCase) flags += 'i';
      if (re.multiline) flags += 'm';
      return flags;
    }

    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
  }();

  if (module.exports) {
    module.exports = clone;
  }
});

function deepClone(obj) {
  return clone_1(obj);
}
/**
 * Avoid "can't access property of undefined" errors in a more readable way.
 * @param fn Function that wraps a nested property access
 * @param defaultVal Optional - the value to return if property access failed
 */


function getSafe(fn, defaultVal) {
  try {
    return fn();
  } catch (e) {
    return defaultVal;
  }
}
/**
 * Performs a deep merge of `source` into `target`.
 * Mutates `target` only but not its objects and arrays.
 *
 * @author inspired from https://gist.github.com/ahtcx/0cd94e62691f539160b32ecda18af3d6#gistcomment-3120712
 */


function deepMerge() {
  var isObject = function isObject(obj) {
    return obj && typeof obj === 'object';
  };

  function deepMergeInner(target, source) {
    Object.keys(source).forEach(function (key) {
      var targetValue = target[key];
      var sourceValue = source[key];

      if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
        target[key] = targetValue.concat(sourceValue); // eslint-disable-line
      } else if (isObject(targetValue) && isObject(sourceValue)) {
        target[key] = deepMergeInner(Object.assign({}, targetValue), sourceValue); // eslint-disable-line
      } else {
        target[key] = sourceValue; // eslint-disable-line
      }
    });
    return target;
  }

  for (var _len5 = arguments.length, objects = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    objects[_key5] = arguments[_key5];
  }

  if (objects.length < 2) {
    throw new Error('deepMerge: this function expects at least 2 objects to be provided');
  }

  if (objects.some(function (object) {
    return !isObject(object);
  })) {
    throw new Error('deepMerge: all values should be of type "object"');
  }

  var target = objects.shift();
  var source; // eslint-disable-next-line

  while (source = objects.shift()) {
    deepMergeInner(target, source);
  }

  return target;
}

var logLevel = 4; // default

var prefix = '';
var logLevels = {
  info: 1,
  log: 2,
  warn: 3,
  error: 4
};
var colors = {
  info: '#26c1db',
  log: '#09f979',
  warn: '#f6b13f',
  error: '#e12046'
};
var standardStyles = 'color: white; font-weight: bold; padding: 2px 10px;';
var reduxStore;

var logAPIResponseTime = function logAPIResponseTime(url, time) {
  if (window.NREUM) {
    window.NREUM.addPageAction('API-calls-timing', {
      api_call: url,
      api_response_time: time
    });
  } else {
    warn('Off-site logging not available.');
  }
};

var isError = function isError(e) {
  return e && e.stack && e.message;
};
/**
 * @param error Primary, details error message or full error object
 * @param errorMessageGroup Use this to group error messages together with a string that does not vary as frequently.
 *      Do not pass programId, verificationId, etc
 */


var error = function error(err, errorMessageGroup) {
  if (logLevel <= 4) {
    if (!err) {
      console.error(new Error('An error must be supplied'));
      return;
    }

    var errorObj;
    if (typeof err === 'string') errorObj = new Error(err);
    if (isError(err)) errorObj = err;
    if (!errorObj) errorObj = new Error('Unknown error');
    var usefulAttributes = {
      errorMessageGroup: errorMessageGroup
    };

    try {
      if (reduxStore && reduxStore.getState) {
        var state = reduxStore.getState();
        var errorIds = getSafe(function () {
          return state.verificationResponse.errorIds;
        });
        usefulAttributes = {
          errorMessageGroup: errorMessageGroup,
          programId: getSafe(function () {
            return state.programId;
          }),
          isLoading: getSafe(function () {
            return state.isLoading;
          }),
          isErrored: getSafe(function () {
            return state.isErrored;
          }),
          errorIdsFromVerRsp: Array.isArray(errorIds) ? errorIds.join : undefined,
          verificationId: getSafe(function () {
            return state.verificationResponse.verificationId;
          }),
          currentStep: getSafe(function () {
            return state.verificationResponse.currentStep;
          }),
          locale: getSafe(function () {
            return state.programTheme.intl.locale;
          }),
          isTestMode: getSafe(function () {
            return state.programTheme.isTestMode;
          }),
          openOrgSearchEnabled: getSafe(function () {
            return state.programTheme.openOrgSearchEnabled;
          }),
          jslibVerActual: getSafe(function () {
            return window.sheerIdPubV;
          }, '?'),
          jslibVerRequested: getSafe(function () {
            return window.sheerIdReqV;
          }, '?')
        };
      }
    } catch (e) {
      // Some invokers of logger.error() don't use redux
      console.warn('Unable to assemble useful error attributes', e); // eslint-disable-line
    }

    try {
      if (window.NREUM) {
        window.NREUM.noticeError(errorObj, usefulAttributes);
      } else {
        // Some customers can't install New Relic so this is not an error:
        warn('Off-site logging not available.'); // eslint-disable-line
      }
    } catch (e) {
      console.error('Unable to send error to remote service', e); // eslint-disable-line
    }

    console.error("%c".concat(prefix, " error"), "background: ".concat(colors.error, ";").concat(standardStyles), errorObj, usefulAttributes); // eslint-disable-line
  }
};

var warn = function warn() {
  if (logLevel <= 3) {
    var _console;

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    (_console = console).warn.apply(_console, ["%c".concat(prefix, " warn"), "background: ".concat(colors.warn, ";").concat(standardStyles)].concat(args)); // eslint-disable-line

  }
};

var log = function log() {
  if (logLevel <= 2) {
    var _console2;

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    (_console2 = console).log.apply(_console2, ["%c".concat(prefix, " log"), "background: ".concat(colors.log, ";").concat(standardStyles)].concat(args)); // eslint-disable-line

  }
};

var info = function info() {
  if (logLevel <= 1) {
    var _console3;

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    (_console3 = console).log.apply(_console3, ["%c".concat(prefix, " info"), "background: ".concat(colors.info, ";").concat(standardStyles)].concat(args)); // eslint-disable-line

  }
};

var logger = {
  error: error,
  warn: warn,
  log: log,
  info: info,
  logAPIResponseTime: logAPIResponseTime,
  setLogLevel: function setLogLevel(desiredLogLevel) {
    if (!logLevels.hasOwnProperty(desiredLogLevel)) {
      throw new Error("Unknown logLevel '".concat(desiredLogLevel, "'"));
    }

    logLevel = logLevels[desiredLogLevel];
    console.log("%c".concat(prefix, " log level set to ").concat(desiredLogLevel), "background: ".concat(colors[desiredLogLevel], ";").concat(standardStyles));
  },
  setPrefix: function setPrefix(thisPrefix) {
    prefix = thisPrefix;
  },
  init: function init(store) {
    reduxStore = store;
  }
};
/**
 * @description List of locales supported by the library, for runtime checks.
 */

var Locales = ['ar', 'bg', 'cs', 'da', 'de', 'el', 'en-GB', 'en-US', 'es-ES', 'es', 'fi', 'fr-CA', 'fr', 'ga', 'hr', 'hu', 'id', 'it', 'iw', 'ja', 'ko', 'lo', 'lt', 'ms', 'nl', 'no', 'pl', 'pt-BR', 'pt', 'ru', 'sk', 'sl', 'sr', 'sv', 'th', 'tr', 'zh-HK', 'zh'];
var VerificationStepsEnum;

(function (VerificationStepsEnum) {
  VerificationStepsEnum["collectStudentPersonalInfo"] = "collectStudentPersonalInfo";
  VerificationStepsEnum["collectTeacherPersonalInfo"] = "collectTeacherPersonalInfo";
  VerificationStepsEnum["collectMemberPersonalInfo"] = "collectMemberPersonalInfo";
  VerificationStepsEnum["collectMilitaryStatus"] = "collectMilitaryStatus";
  VerificationStepsEnum["collectActiveMilitaryPersonalInfo"] = "collectActiveMilitaryPersonalInfo";
  VerificationStepsEnum["collectInactiveMilitaryPersonalInfo"] = "collectInactiveMilitaryPersonalInfo";
  VerificationStepsEnum["collectSeniorPersonalInfo"] = "collectSeniorPersonalInfo";
  VerificationStepsEnum["collectAgePersonalInfo"] = "collectAgePersonalInfo";
  VerificationStepsEnum["collectFirstResponderPersonalInfo"] = "collectFirstResponderPersonalInfo";
  VerificationStepsEnum["collectMedicalProfessionalPersonalInfo"] = "collectMedicalProfessionalPersonalInfo";
  VerificationStepsEnum["collectEmployeePersonalInfo"] = "collectEmployeePersonalInfo";
  VerificationStepsEnum["collectSocialSecurityNumber"] = "collectSocialSecurityNumber";
  VerificationStepsEnum["cancelSocialSecurityNumber"] = "cancelSocialSecurityNumber";
  VerificationStepsEnum["collectDriverLicensePersonalInfo"] = "collectDriverLicensePersonalInfo";
  VerificationStepsEnum["collectGeneralIdentityPersonalInfo"] = "collectGeneralIdentityPersonalInfo";
  VerificationStepsEnum["collectHybridIdentityPersonalInfo"] = "collectHybridIdentityPersonalInfo";
  VerificationStepsEnum["collectLicensedProfessionalPersonalInfo"] = "collectLicensedProfessionalPersonalInfo";
  VerificationStepsEnum["collectMoverPersonalInfo"] = "collectMoverPersonalInfo";
  VerificationStepsEnum["docUpload"] = "docUpload";
  VerificationStepsEnum["pending"] = "pending";
  VerificationStepsEnum["docReviewLimitExceeded"] = "docReviewLimitExceeded";
  VerificationStepsEnum["success"] = "success";
  VerificationStepsEnum["error"] = "error";
  VerificationStepsEnum["sso"] = "sso";
  VerificationStepsEnum["smsLoop"] = "smsLoop";
  VerificationStepsEnum["emailLoop"] = "emailLoop";
  VerificationStepsEnum["cancelEmailLoop"] = "cancelEmailLoop";
})(VerificationStepsEnum || (VerificationStepsEnum = {}));

var VerificationSteps = Object.values(VerificationStepsEnum); // For runtime checks
// This depends on all collect steps starting with the string 'collect' if that
// stops being true this will need to change.

var CollectInfoSteps = VerificationSteps.filter(function (step) {
  return step.startsWith('collect');
});
var TryAgainStepsEnum;

(function (TryAgainStepsEnum) {
  TryAgainStepsEnum["docUpload"] = "docUpload";
  TryAgainStepsEnum["pending"] = "pending";
  TryAgainStepsEnum["error"] = "error";
})(TryAgainStepsEnum || (TryAgainStepsEnum = {}));

var TryAgainSteps = Object.values(TryAgainStepsEnum); // For runtime checks

var MockStepsEnum;

(function (MockStepsEnum) {
  MockStepsEnum["loading"] = "loading";
  MockStepsEnum["collect"] = "collect";
})(MockStepsEnum || (MockStepsEnum = {}));

var MockSteps = [].concat(_toConsumableArray2(Object.values(VerificationStepsEnum)), _toConsumableArray2(Object.values(MockStepsEnum)));
var SegmentToStepMap;

(function (SegmentToStepMap) {
  SegmentToStepMap["student"] = "collectStudentPersonalInfo";
  SegmentToStepMap["military"] = "collectActiveMilitaryPersonalInfo";
  SegmentToStepMap["teacher"] = "collectTeacherPersonalInfo";
  SegmentToStepMap["firstResponder"] = "collectFirstResponderPersonalInfo";
  SegmentToStepMap["senior"] = "collectSeniorPersonalInfo";
  SegmentToStepMap["age"] = "collectAgePersonalInfo";
  SegmentToStepMap["medical"] = "collectMedicalProfessionalPersonalInfo";
  SegmentToStepMap["recentMover"] = "collectMoverPersonalInfo";
  SegmentToStepMap["licensedProfessional"] = "collectLicensedProfessionalPersonalInfo";
})(SegmentToStepMap || (SegmentToStepMap = {}));

var SegmentEnum;

(function (SegmentEnum) {
  SegmentEnum["STUDENT"] = "student";
  SegmentEnum["MILITARY"] = "military";
  SegmentEnum["TEACHER"] = "teacher";
  SegmentEnum["MEMBER"] = "member";
  SegmentEnum["SENIOR"] = "senior";
  SegmentEnum["AGE"] = "age";
  SegmentEnum["FIRST_RESPONDER"] = "firstResponder";
  SegmentEnum["MEDICAL"] = "medical";
  SegmentEnum["EMPLOYMENT"] = "employment";
  SegmentEnum["IDENTITY"] = "identity";
  SegmentEnum["LICENSED_PROFESSIONAL"] = "licensedProfessional";
  SegmentEnum["RECENT_MOVER"] = "recentMover";
})(SegmentEnum || (SegmentEnum = {}));

var Segments = Object.values(SegmentEnum); // For runtime checks

var SubSegmentEnum;

(function (SubSegmentEnum) {
  SubSegmentEnum["ACTIVE_DUTY"] = "activeDuty";
  SubSegmentEnum["VETERAN"] = "veteran";
  SubSegmentEnum["RESERVIST"] = "reservist";
  SubSegmentEnum["MILITARY_RETIREE"] = "retiree";
  SubSegmentEnum["MILITARY_FAMILY"] = "militaryFamily";
  SubSegmentEnum["FIREFIGHTER"] = "fireFighter";
  SubSegmentEnum["POLICE"] = "police";
  SubSegmentEnum["EMT"] = "emt";
  SubSegmentEnum["NURSE"] = "nurse";
  SubSegmentEnum["DRIVER_LICENSE"] = "driverLicense";
  SubSegmentEnum["GENERAL_IDENTITY"] = "generalIdentity";
  SubSegmentEnum["HYBRID_IDENTITY"] = "hybridIdentity";
  SubSegmentEnum["HOME_BUYER"] = "homeBuyer";
  SubSegmentEnum["OTHER_MOVER"] = "otherMover";
  SubSegmentEnum["LICENSED_COSMETOLOGIST"] = "licensedCosmetologist";
  SubSegmentEnum["LICENSED_REAL_ESTATE_AGENT"] = "licensedRealEstateAgent";
  SubSegmentEnum["VETERINARIAN"] = "Veterinarian";
})(SubSegmentEnum || (SubSegmentEnum = {}));

Object.values(SubSegmentEnum); // For runtime checks

var MilitaryStatusDefaultMessagesEnum;

(function (MilitaryStatusDefaultMessagesEnum) {
  MilitaryStatusDefaultMessagesEnum["ACTIVE_DUTY"] = "Active Duty";
  MilitaryStatusDefaultMessagesEnum["MILITARY_RETIREE"] = "Military Retiree";
  MilitaryStatusDefaultMessagesEnum["RESERVIST"] = "Reservist or National Guard";
  MilitaryStatusDefaultMessagesEnum["VETERAN"] = "Military Veteran or Retiree";
  MilitaryStatusDefaultMessagesEnum["MILITARY_FAMILY"] = "Military Family";
})(MilitaryStatusDefaultMessagesEnum || (MilitaryStatusDefaultMessagesEnum = {}));

var militaryReservistOrgNames = ['Air Force Reserve', 'Air National Guard', 'Army Reserve', 'Army National Guard', 'Coast Guard Reserve', 'Marine Corps Forces Reserve', 'Navy Reserve'];
var FirstResponderStatusDefaultMessagesEnum;

(function (FirstResponderStatusDefaultMessagesEnum) {
  FirstResponderStatusDefaultMessagesEnum["FIREFIGHTER"] = "Firefighter";
  FirstResponderStatusDefaultMessagesEnum["POLICE"] = "Police";
  FirstResponderStatusDefaultMessagesEnum["EMT"] = "EMT";
})(FirstResponderStatusDefaultMessagesEnum || (FirstResponderStatusDefaultMessagesEnum = {}));

var MedicalProfessionalStatusDefaultMessagesEnum;

(function (MedicalProfessionalStatusDefaultMessagesEnum) {
  MedicalProfessionalStatusDefaultMessagesEnum["NURSE"] = "Nurse";
  MedicalProfessionalStatusDefaultMessagesEnum["DOCTOR"] = "Doctor";
  MedicalProfessionalStatusDefaultMessagesEnum["OTHER_HEALTH_WORKER"] = "Other Health Worker";
  MedicalProfessionalStatusDefaultMessagesEnum["DENTIST"] = "Dentist";
  MedicalProfessionalStatusDefaultMessagesEnum["PHARMACIST"] = "Pharmacist";
})(MedicalProfessionalStatusDefaultMessagesEnum || (MedicalProfessionalStatusDefaultMessagesEnum = {}));

var RecentMoverStatusDefaultMessagesEnum;

(function (RecentMoverStatusDefaultMessagesEnum) {
  RecentMoverStatusDefaultMessagesEnum["HOME_BUYER"] = "Home Buyer";
  RecentMoverStatusDefaultMessagesEnum["OTHER_MOVER"] = "Other Mover";
})(RecentMoverStatusDefaultMessagesEnum || (RecentMoverStatusDefaultMessagesEnum = {}));

Object.values(MilitaryStatusDefaultMessagesEnum); // For runtime checks

Object.values(FirstResponderStatusDefaultMessagesEnum); // For runtime checks

Object.values(MedicalProfessionalStatusDefaultMessagesEnum); // For runtime checks

Object.values(RecentMoverStatusDefaultMessagesEnum); // For runtime checks

var FieldIdEnum;

(function (FieldIdEnum) {
  FieldIdEnum["firstName"] = "firstName";
  FieldIdEnum["lastName"] = "lastName";
  FieldIdEnum["memberId"] = "memberId";
  FieldIdEnum["organization"] = "organization";
  FieldIdEnum["birthDate"] = "birthDate";
  FieldIdEnum["email"] = "email";
  FieldIdEnum["phoneNumber"] = "phoneNumber";
  FieldIdEnum["postalCode"] = "postalCode";
  FieldIdEnum["address1"] = "address1";
  FieldIdEnum["city"] = "city";
  FieldIdEnum["country"] = "country";
  FieldIdEnum["state"] = "state";
  FieldIdEnum["dischargeDate"] = "dischargeDate";
  FieldIdEnum["docUpload"] = "docUpload";
  FieldIdEnum["status"] = "status";
  FieldIdEnum["statuses"] = "statuses";
  FieldIdEnum["marketConsentValue"] = "marketConsentValue";
  FieldIdEnum["socialSecurityNumber"] = "socialSecurityNumber";
  FieldIdEnum["carrierConsentValue"] = "carrierConsentValue";
  FieldIdEnum["driverLicenseNumber"] = "driverLicenseNumber";
})(FieldIdEnum || (FieldIdEnum = {}));

var FieldIds = Object.values(FieldIdEnum); // For runtime checks

var HookNameEnum;

(function (HookNameEnum) {
  HookNameEnum["ON_VERIFICATION_READY"] = "ON_VERIFICATION_READY";
  HookNameEnum["ON_VERIFICATION_SUCCESS"] = "ON_VERIFICATION_SUCCESS";
  HookNameEnum["ON_VERIFICATION_STEP_CHANGE"] = "ON_VERIFICATION_STEP_CHANGE";
})(HookNameEnum || (HookNameEnum = {}));

var HookNames = Object.values(HookNameEnum);
/**
 * Add to the list of known locales for more helpful runtime checks.
 */

var registerAdditionalLocales = function registerAdditionalLocales(locales) {
  logger.info("Registering additional locales ".concat(locales.join(', ')));
  Locales.push.apply(Locales, _toConsumableArray2(locales));
};

var StateEnum;

(function (StateEnum) {
  StateEnum["AK"] = "AK";
  StateEnum["AL"] = "AL";
  StateEnum["AR"] = "AR";
  StateEnum["AZ"] = "AZ";
  StateEnum["CA"] = "CA";
  StateEnum["CO"] = "CO";
  StateEnum["CT"] = "CT";
  StateEnum["DC"] = "DC";
  StateEnum["DE"] = "DE";
  StateEnum["FL"] = "FL";
  StateEnum["GA"] = "GA";
  StateEnum["HI"] = "HI";
  StateEnum["IA"] = "IA";
  StateEnum["ID"] = "ID";
  StateEnum["IL"] = "IL";
  StateEnum["IN"] = "IN";
  StateEnum["KS"] = "KS";
  StateEnum["KY"] = "KY";
  StateEnum["LA"] = "LA";
  StateEnum["MA"] = "MA";
  StateEnum["MD"] = "MD";
  StateEnum["ME"] = "ME";
  StateEnum["MI"] = "MI";
  StateEnum["MN"] = "MN";
  StateEnum["MO"] = "MO";
  StateEnum["MS"] = "MS";
  StateEnum["MT"] = "MT";
  StateEnum["NC"] = "NC";
  StateEnum["ND"] = "ND";
  StateEnum["NE"] = "NE";
  StateEnum["NH"] = "NH";
  StateEnum["NJ"] = "NJ";
  StateEnum["NM"] = "NM";
  StateEnum["NV"] = "NV";
  StateEnum["NY"] = "NY";
  StateEnum["OH"] = "OH";
  StateEnum["OK"] = "OK";
  StateEnum["OR"] = "OR";
  StateEnum["PA"] = "PA";
  StateEnum["RI"] = "RI";
  StateEnum["SC"] = "SC";
  StateEnum["SD"] = "SD";
  StateEnum["TN"] = "TN";
  StateEnum["TX"] = "TX";
  StateEnum["UT"] = "UT";
  StateEnum["VA"] = "VA";
  StateEnum["VT"] = "VT";
  StateEnum["WA"] = "WA";
  StateEnum["WI"] = "WI";
  StateEnum["WV"] = "WV";
  StateEnum["WY"] = "WY";
})(StateEnum || (StateEnum = {}));

var toggleSelection = function toggleSelection() {
  var selection = document.getSelection();

  if (!selection.rangeCount) {
    return function () {};
  }

  var active = document.activeElement;
  var ranges = [];

  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) {
    // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' && selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function (range) {
        selection.addRange(range);
      });
    }

    active && active.focus();
  };
};

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
      message,
      reselectPrevious,
      range,
      selection,
      mark,
      success = false;

  if (!options) {
    options = {};
  }

  debug = options.debug || false;

  try {
    reselectPrevious = toggleSelection();
    range = document.createRange();
    selection = document.getSelection();
    mark = document.createElement("span");
    mark.textContent = text; // reset user styles for span element

    mark.style.all = "unset"; // prevents scrolling to the end of the page

    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)"; // used to preserve spaces and line breaks

    mark.style.whiteSpace = "pre"; // do not inherit user-select (it may be `none`)

    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function (e) {
      e.stopPropagation();

      if (options.format) {
        e.preventDefault();

        if (typeof e.clipboardData === "undefined") {
          // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
          window.clipboardData.setData(format, text);
        } else {
          // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }

      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });
    document.body.appendChild(mark);
    range.selectNodeContents(mark);
    selection.addRange(range);
    var successful = document.execCommand("copy");

    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }

    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");

    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }

    reselectPrevious();
  }

  return success;
}

var copyToClipboard = copy;
/**
 * Wrap a button or link with copy-to-clipboard behavior.
 *
 * Example Use:
    <CopyToClipboard textToCopy={htmlSource} notificationText={<FormattedMessage id="copied" />}>
        <LinkButton ... />
    </CopyToClipboard>
 */

var twoSeconds = 2000;
var classNameHidden = 'sid-to-clipboard__notification-text sid-to-clipboard__notification-text--hidden';
var classNameVisible = 'sid-to-clipboard__notification-text sid-to-clipboard__notification-text--visible';

var CopyToClipboard = /*#__PURE__*/function (_React$Component) {
  _inherits(CopyToClipboard, _React$Component);

  function CopyToClipboard(props) {
    var _this8;

    _classCallCheck(this, CopyToClipboard);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(CopyToClipboard).call(this, props));
    _this8.doCopy = _this8.doCopy.bind(_assertThisInitialized2(_assertThisInitialized2(_this8)));
    _this8.state = {
      isShowing: false
    };

    if (props.notificationTimeout) {
      _this8.notificationTimeout = props.notificationTimeout;
    } else {
      _this8.notificationTimeout = twoSeconds;
    }

    return _this8;
  }

  _createClass(CopyToClipboard, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutRef);
    }
  }, {
    key: "doCopy",
    value: function doCopy() {
      var _this9 = this;

      var textToCopy = this.props.textToCopy;
      copyToClipboard(textToCopy);
      this.setState(function () {
        return {
          isShowing: true
        };
      });
      clearTimeout(this.timeoutRef);
      this.timeoutRef = setTimeout(function () {
        _this9.setState(function () {
          return {
            isShowing: false
          };
        });
      }, this.notificationTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var isShowing = this.state.isShowing;
      var _this$props2 = this.props,
          notificationText = _this$props2.notificationText,
          children = _this$props2.children;
      return React.createElement("div", {
        className: "sid-to-clipboard"
      }, React.createElement("div", {
        className: "".concat(isShowing ? classNameVisible : classNameHidden)
      }, notificationText || 'Copied'), React.createElement("div", {
        onClick: this.doCopy,
        onKeyPress: this.doCopy,
        role: "button",
        tabIndex: 0,
        className: "sid-h-link-like sid-to-clipboard__clickable-text sid-link"
      }, children || 'Copy'));
    }
  }]);

  return CopyToClipboard;
}(React.Component);

var ResponseTimeLogger = /*#__PURE__*/function () {
  function ResponseTimeLogger(url) {
    _classCallCheck(this, ResponseTimeLogger);

    this.url = url;
    this.start = Date.now();
  }

  _createClass(ResponseTimeLogger, [{
    key: "logNow",
    value: function logNow() {
      // eslint-disable-next-line
      var result;

      if (window.NREUM) {
        result = {
          api_call: this.url,
          api_response_time: Date.now() - this.start
        };
        window.NREUM.addPageAction('API-calls-timing', result);
      } else {
        logger.warn('Off-site logging not available.');
      }

      return result;
    }
  }]);

  return ResponseTimeLogger;
}();

var ensureTrailingSlash = function ensureTrailingSlash(url) {
  return url.replace(/\/?$/, '/');
};

var getQueryParamsFromUrl = function getQueryParamsFromUrl(url) {
  var newUrl = new URL(url || window.location.toString());
  return new URLSearchParams(newUrl.search.slice(1));
};

var getVerificationIdFromQueryString = function getVerificationIdFromQueryString(queryString) {
  var verificationIdQueryParameter = 'verificationId';
  var queryStringParameters = new URLSearchParams(queryString);
  var verificationId = queryStringParameters.get(verificationIdQueryParameter);

  if (typeof verificationId === 'string' && verificationId.length === 0) {
    return null;
  }

  return verificationId;
};

var getTrackingIdFromQueryString = function getTrackingIdFromQueryString(queryString) {
  var trackingIdQueryParameter = 'trackingId';
  var queryStringParameters = new URLSearchParams(queryString);
  var trackingId = queryStringParameters.get(trackingIdQueryParameter);

  if (typeof trackingId === 'string' && trackingId.length === 0) {
    return null;
  }

  return trackingId;
};

var getDomainFromUrl = function getDomainFromUrl(url) {
  var domain = url;

  try {
    domain = new URL(url).hostname;
  } catch (e) {
    logger.warn(e);
  }

  return domain.replace(/(www\.)?/, '');
};

var customValidators = {};
var customValidatorFields = [];

var setCustomValidator = function setCustomValidator(validatorField, newValidator) {
  logger.log("customValidator registering \n".concat(newValidator, "\n for custom field '").concat(validatorField, "'"));
  customValidators[validatorField] = newValidator;
  customValidatorFields.push(validatorField);
};

var getCustomValidator = function getCustomValidator(validatorField) {
  if (customValidators[validatorField]) {
    logger.log("getCustomValidator returning '".concat(validatorField, "'"));
    return customValidators[validatorField];
  }

  logger.error("Custom validator for field '".concat(validatorField, "' does not exist.\n        Has a custom validator been registered using the setCustomValidator method?"), 'getCustomValidator');
  return null;
};

var customValidatorExists$1 = function customValidatorExists$1(validatorField) {
  return customValidatorFields.indexOf(validatorField) > -1;
};

var removeCustomValidator = function removeCustomValidator(validatorField) {
  delete customValidators[validatorField];
  var validatorIndex = customValidatorFields.indexOf(validatorField);

  if (validatorIndex !== -1) {
    customValidatorFields.splice(validatorIndex, 1);
  } else {
    logger.error("Custom validator for field '".concat(validatorField, "' has not been removed."), 'removeCustomValidator');
  }
};

var getCustomValidatorFields = function getCustomValidatorFields() {
  return customValidatorFields;
};

var resetCustomValidators = function resetCustomValidators() {
  customValidators = {};
  customValidatorFields = [];
  logger.info('Custom validators have been reset');
};

var assertValidVerificationStepName = function assertValidVerificationStepName(candidate) {
  // TODO - only in dev mode
  if (VerificationSteps.indexOf(candidate) < 0) {
    throw new Error("Expected valid verification step name but received \"".concat(candidate, "\"."));
  }
};

var assertValidMockStepName = function assertValidMockStepName(candidate) {
  // TODO - only in dev mode
  if (MockSteps.indexOf(candidate) < 0) {
    throw new Error("Expected valid verification step name but received \"".concat(candidate, "\"."));
  }
};

var assertValidSegmentName = function assertValidSegmentName(candidate) {
  // TODO - only in dev mode
  if (Segments.indexOf(candidate) < 0) {
    throw new Error("Expected valid segment name but received \"".concat(candidate, "\"."));
  }
};

var assertValidLocale = function assertValidLocale(locale) {
  if (!isValidLocale(locale)) {
    throw new Error("Invalid locale ".concat(locale, ", expected one of ").concat(Locales.join(', ')));
  }
};

var isValidLocale = function isValidLocale(locale) {
  return Locales.indexOf(locale) > -1;
};

var assertValidHtmlElement = function assertValidHtmlElement(element) {
  if (!(element && element.nodeType === Node.ELEMENT_NODE)) {
    throw new Error("Expected argument of type Node.ELEMENT_NODE but received \"".concat(typeof element, " ").concat(element.nodeType, "\""));
  }
};

var assertValidProgramId = function assertValidProgramId(programId) {
  assertValidDatabaseId(programId);
};

var assertValidFieldId = function assertValidFieldId(candidate) {
  var customValidatorFields = getCustomValidatorFields();

  if (FieldIds.indexOf(candidate) < 0 && customValidatorFields.indexOf(candidate) < 0) {
    throw new Error("Expected valid field ID but received ".concat(candidate, ".\n            Valid FieldIds are [").concat(FieldIds.join(', '), ", ").concat(customValidatorFields.join(', '), "]"));
  }
};

var assertValidTryAgainStep = function assertValidTryAgainStep(candidate) {
  if (TryAgainSteps.indexOf(candidate) < 0) {
    throw new Error("Expected valid try again step but received ".concat(candidate, ". Valid TryAgainSteps are [").concat(TryAgainSteps.join(', '), "]"));
  }
};

var assertValidHook = function assertValidHook(hook) {
  assertValidHookName(hook.name);
  assertValidFunction(hook.callback);
};

var assertValidHookName = function assertValidHookName(candidate) {
  if (HookNames.indexOf(candidate) < 0) {
    throw new Error("Expected valid hook name but received ".concat(candidate, ". Valid HookNames are [").concat(HookNames.join(', '), "]"));
  }
};

var assertValidFunction = function assertValidFunction(candidate) {
  if (typeof candidate !== 'function') {
    throw new Error("Expected type \"function\", but received ".concat(typeof candidate));
  }
};

var assertValidTrackingId = function assertValidTrackingId(candidate) {
  if (typeof candidate !== 'string') {
    throw new Error("Expected trackingId to be a string, but received ".concat(typeof candidate, " instead."));
  }

  if (candidate.length < 1) {
    throw new Error('Expected trackingId string length greather than 0.');
  }
};

var assertValidConversionRequest = function assertValidConversionRequest(candidate) {
  if (typeof candidate !== 'object') {
    throw new Error("Expected conversion request to be an object, but received ".concat(typeof candidate, " instead."));
  }

  if (candidate.hasOwnProperty('amount') && typeof candidate.amount !== 'number') {
    throw new Error('Expected conversion request property "amount" to have type number.');
  }
};

var assertValidDatabaseId = function assertValidDatabaseId(candidate) {
  var validId = new RegExp('^[0-9a-fA-F]{24}$');

  if (!validId.test(candidate)) {
    throw new Error("Invalid databaseId \"".concat(candidate, "\". Expected a 24-digit hexadecimal string."));
  }
};

var DEFAULT_LOCALE = 'en-US';
var DEFAULT_CDN_BASE_URL = 'https://cdn.jsdelivr.net/npm/@sheerid/jslib@1/';
var ACCEPTED_DOC_MIME_TYPES = ['image/png', 'image/gif', 'image/jpg', 'image/jpeg', 'image/bmp', 'application/pdf'];
var MAX_DOC_UPLOAD_DOCS_ALLOWED = 3;
var UPLOAD_FILE_PREFIX = 'file';
var QUERY_STRING_STEP_OVERRIDE = 'mockStep';
var QUERY_STRING_SEGMENT_OVERRIDE = 'mockSegment';
var QUERY_STRING_SUBSEGMENT_OVERRIDE = 'mockSubSegment';
var QUERY_STRING_ERRORID_OVERRIDE = 'mockErrorId';
var QUERY_STRING_PREV_STEP_OVERRIDE = 'mockPreviousStep';
var QUERY_STRING_INSTALL_PAGE_URL = 'installPageUrl';
var SSN_STRING_LENGTH = 9;
var DEFAULT_MINIMUM_ORG_SEARCH_VALUE_LENGTH = 1;
var DEFAULT_PRIVACY_POLICY_HOST = 'www.sheerid.com';
var DEFAULT_PRIVACY_POLICY_URL = 'https://www.sheerid.com/privacy-policy/';
var SHEERID = 'SheerID';
var requestOrganizationConstants = {
  MAX_RESULT_SIZE: 25,
  ORG_TYPES: 'UNIVERSITY,HIGH_SCHOOL,K12',
  DEFAULT_ORG_TYPES: 'UNIVERSITY',
  URL_REGEX: /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,10}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
  SCHOOL_HOUSE_URL: 'https://s3.amazonaws.com/com.sheerid.resources/common/images/requestOrganization/school.svg',
  SHEERID_LOGO_URL: 'https://s3.amazonaws.com/com.sheerid.resources/common/images/requestOrganization/logo.svg',
  FEEDBACK_FORM_URL: 'https://verify.sheerid.com/verification-support/feedback.html?token='
};
var HTTP_REQUEST_TIMEOUT = 10000;
var iframeClassNames = {
  INLINE_IFRAME_CONTENT: 'sid-inline-iframe',
  MODAL_WRAPPER: 'sid-modal__wrapper',
  MODAL_IFRAME: 'sid-modal__iframe',
  OVERLAY: 'sid-modal__overlay',
  CLOSE_BUTTON: 'sid-modal__close-button',
  CLOSE_TEXT: 'sid-modal__close-text',
  CLOSE_ICON: 'sid-modal__close-icon'
};
var iframeConstants = {
  CLASS_NAMES: iframeClassNames,
  DEFAULT_MOBILE_THRESHOLD_WIDTH: 620,
  MODAL_OPACITY_TRANSITION_PERIOD: 300
};
var restOptions = {
  serviceUrl: 'https://services.sheerid.com/',
  resources: {
    verification: 'rest/v2/verification/',
    program: {
      base: 'rest/v2/program/',
      theme: 'theme',
      organization: 'organization'
    },
    conversion: {
      base: 'rest/v2/conversion/'
    }
  }
};
var cookieOptions = {
  enabled: true,
  secure: true,
  expires: 7
};
var defaultOptions = {
  restApi: restOptions,
  mockStep: undefined,
  mockSubSegment: undefined,
  mockErrorId: undefined,
  installPageUrl: undefined,
  mockResponse: undefined,
  doFetchTheme: true,
  logLevel: 'error',
  locale: null,
  messages: {},
  messagesWithLocale: {},
  urlFaq: 'https://offers.sheerid.com/sheerid/help-center/',
  urlStudentFaq: 'https://verify.sheerid.com/student-faq/',
  urlSeniorFaq: 'https://verify.sheerid.com/us-senior-faq/',
  urlAgeFaq: 'https://verify.sheerid.com/us-age-faq/',
  urlMilitaryFaq: 'https://verify.sheerid.com/military-faq/',
  urlTeacherFaq: 'https://verify.sheerid.com/us-teacher-faq/',
  urlMemberFaq: 'https://verify.sheerid.com/membership-faq/',
  urlFirstResponderFaq: 'https://verify.sheerid.com/first-responder-faq/',
  urlMedicalFaq: 'https://verify.sheerid.com/us-medical-faq/',
  urlEmploymentFaq: 'https://verify.sheerid.com/employment-faq/',
  urlIdentityFaq: 'https://verify.sheerid.com/identity-faq/',
  urlLicensedProfessionalFaq: 'https://verify.sheerid.com/professions-faq/',
  urlAddSchoolFaq: 'https://verify.sheerid.com/add-school-request-faq/',
  urlAddSchoolForm: 'https://offers.sheerid.com/sheerid/add-school-request/',
  privacyPolicyUrl: undefined,
  cookies: cookieOptions,
  useFingerprinting: false,
  verificationId: undefined,
  minimumOrganizationSearchLength: DEFAULT_MINIMUM_ORG_SEARCH_VALUE_LENGTH,
  httpRequestTimeout: HTTP_REQUEST_TIMEOUT
};

var options$1 = _objectSpread2({}, defaultOptions);

var getOptions = function getOptions() {
  return options$1;
};

var resetOptions = function resetOptions() {
  options$1 = _objectSpread2({}, defaultOptions);
};

var setOptions = function setOptions(newOptions) {
  if (newOptions.hasOwnProperty('logLevel')) {
    try {
      logger.setLogLevel(newOptions.logLevel);
    } catch (e) {
      console.error(e);
    }

    options$1.logLevel = newOptions.logLevel; // keep options in sync with logger
  }

  if (newOptions.hasOwnProperty('restApi')) {
    var restApiOptions = newOptions.restApi;

    if (restApiOptions.hasOwnProperty('serviceUrl')) {
      var newUrl = ensureTrailingSlash(newOptions.restApi.serviceUrl);
      options$1.restApi.serviceUrl = newUrl;
      logger.info("option \"serviceUrl\" set to ".concat(options$1.restApi.serviceUrl));
    }
  }

  if (newOptions.hasOwnProperty(QUERY_STRING_STEP_OVERRIDE)) {
    assertValidMockStepName(newOptions[QUERY_STRING_STEP_OVERRIDE]);
    options$1[QUERY_STRING_STEP_OVERRIDE] = newOptions[QUERY_STRING_STEP_OVERRIDE];
    logger.info("option \"".concat(QUERY_STRING_STEP_OVERRIDE, "\" set to ").concat(options$1[QUERY_STRING_STEP_OVERRIDE]));
  }

  if (newOptions.hasOwnProperty(QUERY_STRING_PREV_STEP_OVERRIDE)) {
    assertValidMockStepName(newOptions[QUERY_STRING_STEP_OVERRIDE]);
    options$1[QUERY_STRING_PREV_STEP_OVERRIDE] = newOptions[QUERY_STRING_PREV_STEP_OVERRIDE];
    logger.info("option \"".concat(QUERY_STRING_PREV_STEP_OVERRIDE, "\" set to ").concat(options$1[QUERY_STRING_PREV_STEP_OVERRIDE]));
  }

  if (newOptions.hasOwnProperty(QUERY_STRING_SEGMENT_OVERRIDE)) {
    options$1[QUERY_STRING_SEGMENT_OVERRIDE] = newOptions[QUERY_STRING_SEGMENT_OVERRIDE];
    logger.info("option \"".concat(QUERY_STRING_SEGMENT_OVERRIDE, "\" set to ").concat(options$1[QUERY_STRING_SEGMENT_OVERRIDE]));
  }

  if (newOptions.hasOwnProperty(QUERY_STRING_SUBSEGMENT_OVERRIDE)) {
    options$1[QUERY_STRING_SUBSEGMENT_OVERRIDE] = newOptions[QUERY_STRING_SUBSEGMENT_OVERRIDE];
    logger.info("option \"".concat(QUERY_STRING_SUBSEGMENT_OVERRIDE, "\" set to ").concat(options$1[QUERY_STRING_SUBSEGMENT_OVERRIDE]));
  }

  if (newOptions.hasOwnProperty(QUERY_STRING_ERRORID_OVERRIDE)) {
    options$1[QUERY_STRING_ERRORID_OVERRIDE] = newOptions[QUERY_STRING_ERRORID_OVERRIDE];
    logger.info("option \"".concat(QUERY_STRING_ERRORID_OVERRIDE, "\" set to ").concat(options$1[QUERY_STRING_ERRORID_OVERRIDE]));
  }

  if (newOptions.hasOwnProperty(QUERY_STRING_INSTALL_PAGE_URL)) {
    options$1[QUERY_STRING_INSTALL_PAGE_URL] = newOptions[QUERY_STRING_INSTALL_PAGE_URL];
    logger.info("option \"".concat(QUERY_STRING_INSTALL_PAGE_URL, "\" set to ").concat(options$1[QUERY_STRING_INSTALL_PAGE_URL]));
  }

  if (newOptions.hasOwnProperty('mockResponse')) {
    options$1.mockResponse = deepClone(newOptions.mockResponse);
    logger.info('option "mockResponse" set to', options$1.mockResponse);
  }

  if (newOptions.hasOwnProperty('messages')) {
    options$1.messagesWithLocale = _objectSpread2({}, options$1.messagesWithLocale, {
      'en-US': newOptions.messages
    });
    logger.warn('option "messages" has been deprecated and replaced with "messagesWithLocale". Messages have been set for locale "en-US" using: ', options$1.messagesWithLocale, '\nThese messages will override existing messages of the same key for "en-US" locale.');
  }

  if (newOptions.hasOwnProperty('messagesWithLocale')) {
    options$1.messagesWithLocale = deepMerge({}, options$1.messagesWithLocale, newOptions.messagesWithLocale);

    if (newOptions && newOptions.messagesWithLocale) {
      registerAdditionalLocales(Object.keys(newOptions.messagesWithLocale));
    }

    logger.info('option "messagesWithLocale" set to', options$1.messagesWithLocale);
  }

  if (newOptions.hasOwnProperty('locale')) {
    assertValidLocale(newOptions.locale);
    options$1.locale = newOptions.locale;
    logger.info("option \"locale\" set to ".concat(options$1.locale));
  }

  if (newOptions.hasOwnProperty('urlStudentFaq')) {
    // assertValidUrl(newOptions.urlStudentFaq);
    options$1.urlStudentFaq = newOptions.urlStudentFaq;
    logger.info("option \"urlStudentFaq\" set to ".concat(options$1.urlStudentFaq));
  }

  if (newOptions.hasOwnProperty('urlSeniorFaq')) {
    // assertValidUrl(newOptions.urlSeniorFaq);
    options$1.urlSeniorFaq = newOptions.urlSeniorFaq;
    logger.info("option \"urlSeniorFaq\" set to ".concat(options$1.urlSeniorFaq));
  }

  if (newOptions.hasOwnProperty('urlMilitaryFaq')) {
    // assertValidUrl(newOptions.urlMilitaryFaq);
    options$1.urlMilitaryFaq = newOptions.urlMilitaryFaq;
    logger.info("option \"urlMilitaryFaq\" set to ".concat(options$1.urlMilitaryFaq));
  }

  if (newOptions.hasOwnProperty('urlTeacherFaq')) {
    // assertValidUrl(newOptions.urlTeacherFaq);
    options$1.urlTeacherFaq = newOptions.urlTeacherFaq;
    logger.info("option \"urlTeacherFaq\" set to ".concat(options$1.urlTeacherFaq));
  }

  if (newOptions.hasOwnProperty('urlMemberFaq')) {
    // assertValidUrl(newOptions.urlMemberFaq);
    options$1.urlMemberFaq = newOptions.urlMemberFaq;
    logger.info("option \"urlMemberFaq\" set to ".concat(options$1.urlMemberFaq));
  }

  if (newOptions.hasOwnProperty('urlMedicalFaq')) {
    options$1.urlMedicalFaq = newOptions.urlMedicalFaq;
    logger.info("option \"urlMedicalFaq\" set to ".concat(options$1.urlMedicalFaq));
  }

  if (newOptions.hasOwnProperty('urlEmploymentFaq')) {
    options$1.urlEmploymentFaq = newOptions.urlEmploymentFaq;
    logger.info("option \"urlEmploymentFaq\" set to ".concat(options$1.urlEmploymentFaq));
  }

  if (newOptions.hasOwnProperty('urlAddSchoolFaq')) {
    options$1.urlAddSchoolFaq = newOptions.urlAddSchoolFaq;
    logger.info("option \"urlAddSchoolFaq\" set to ".concat(options$1.urlAddSchoolFaq));
  }

  if (newOptions.hasOwnProperty('urlAddSchoolForm')) {
    options$1.urlAddSchoolForm = newOptions.urlAddSchoolForm;
    logger.info("option \"urlAddSchoolForm\" set to ".concat(options$1.urlAddSchoolForm));
  }

  if (newOptions.hasOwnProperty('doFetchTheme')) {
    options$1.doFetchTheme = newOptions.doFetchTheme;
    logger.info("option \"doFetchTheme\" set to ".concat(options$1.doFetchTheme));
  }

  if (newOptions.hasOwnProperty('cookies')) {
    options$1.cookies = _objectSpread2({}, options$1.cookies, newOptions.cookies);
    logger.info('option "cookies" set to', options$1.cookies);
  }

  if (newOptions.hasOwnProperty('useFingerprinting')) {
    options$1.useFingerprinting = newOptions.useFingerprinting;
    logger.info('option "useFingerprinting" set to', options$1.useFingerprinting);
  }

  if (newOptions.hasOwnProperty('marketConsent')) {
    options$1.marketConsent = newOptions.marketConsent;
    logger.info('option "market consent" set to', options$1.marketConsent);
  }

  if (newOptions.hasOwnProperty('verificationId')) {
    options$1.verificationId = newOptions.verificationId;
    logger.info('option "verificationId" set to', options$1.verificationId);
  }

  if (newOptions.hasOwnProperty('minimumOrganizationSearchLength')) {
    options$1.minimumOrganizationSearchLength = newOptions.minimumOrganizationSearchLength;
    logger.info('option "minimumOrganizationSearchLength" set to', options$1.minimumOrganizationSearchLength);
  }

  if (newOptions.hasOwnProperty('customCss')) {
    options$1.customCss = newOptions.customCss;
    logger.info('option "customCss" set to', options$1.customCss);
  }

  if (newOptions.hasOwnProperty('logoUrl')) {
    options$1.logoUrl = newOptions.logoUrl;
    logger.info('option "logoUrl" set to', options$1.logoUrl);
  }

  if (newOptions.hasOwnProperty('httpRequestTimeout')) {
    options$1.httpRequestTimeout = newOptions.httpRequestTimeout;
    logger.info('option "httpRequestTimeout" set to', options$1.httpRequestTimeout);
  }

  if (newOptions.hasOwnProperty('privacyPolicyUrl')) {
    options$1.privacyPolicyUrl = newOptions.privacyPolicyUrl;
    logger.info('option "privacyPolicyUrl" set to', options$1.privacyPolicyUrl);
  }
};

var defaultJsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};
var defaultFileUploadHeaders = {
  Accept: 'application/json'
};

var fetchWithTimeout = function fetchWithTimeout(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timeout = getOptions().httpRequestTimeout;
  return new Promise(function (resolve, reject) {
    var timeoutTimer = setTimeout(function () {
      var networkErrorId = 'requestTimeout';
      reject(new Error(networkErrorId));
    }, timeout);
    return fetch(url, options).then(resolve, function (error) {
      logger.error("Failed to fetch ".concat(url), error);
      var networkErrorId = 'failedToFetch';
      reject(new Error(networkErrorId));
    }).finally(function () {
      clearTimeout(timeoutTimer);
    });
  });
};

var PostJson = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, body) {
    var headers,
        timeLog,
        response,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = _args.length > 2 && _args[2] !== undefined ? _args[2] : defaultJsonHeaders;
            timeLog = new ResponseTimeLogger(url);
            _context.next = 4;
            return fetchWithTimeout(url, {
              headers: headers,
              method: 'POST',
              body: JSON.stringify(body)
            });

          case 4:
            response = _context.sent;
            _context.next = 7;
            return processResponse(response, timeLog);

          case 7:
            return _context.abrupt("return", _context.sent);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function PostJson(_x, _x2) {
    return _ref14.apply(this, arguments);
  };
}();

var DeleteJson = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
    var headers,
        timeLog,
        response,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            headers = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : defaultJsonHeaders;
            timeLog = new ResponseTimeLogger(url);
            _context2.next = 4;
            return fetchWithTimeout(url, {
              headers: headers,
              method: 'DELETE'
            });

          case 4:
            response = _context2.sent;
            _context2.next = 7;
            return processResponse(response, timeLog);

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function DeleteJson(_x3) {
    return _ref15.apply(this, arguments);
  };
}();

var GetJson = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url) {
    var headers,
        timeLog,
        response,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            headers = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : defaultJsonHeaders;
            timeLog = new ResponseTimeLogger(url);
            _context3.next = 4;
            return fetchWithTimeout(url, {
              headers: headers,
              method: 'GET'
            });

          case 4:
            response = _context3.sent;
            _context3.next = 7;
            return processResponse(response, timeLog);

          case 7:
            return _context3.abrupt("return", _context3.sent);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function GetJson(_x4) {
    return _ref16.apply(this, arguments);
  };
}();

var GetResponse = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url) {
    var headers,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            headers = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : defaultJsonHeaders;
            _context4.next = 3;
            return fetchWithTimeout(url, {
              headers: headers,
              method: 'GET'
            });

          case 3:
            return _context4.abrupt("return", _context4.sent);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function GetResponse(_x5) {
    return _ref17.apply(this, arguments);
  };
}();

var createFormData = function createFormData(files) {
  var formData = new FormData();
  files.forEach(function (file, index) {
    if (file) {
      formData.append("file".concat(index), file);
    }
  });
  return formData;
};

var PostFiles = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, files) {
    var headers,
        timeLog,
        formData,
        response,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            headers = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : defaultFileUploadHeaders;
            timeLog = new ResponseTimeLogger(url);
            logger.info("PostFiles posting to ".concat(url), files);
            formData = createFormData(files);
            _context5.next = 6;
            return fetch(url, {
              headers: headers,
              method: 'POST',
              body: formData
            });

          case 6:
            response = _context5.sent;
            _context5.next = 9;
            return processResponse(response, timeLog);

          case 9:
            return _context5.abrupt("return", _context5.sent);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function PostFiles(_x6, _x7) {
    return _ref18.apply(this, arguments);
  };
}();

var processResponse = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(response, timeLog) {
    var responseData;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return response.json();

          case 3:
            responseData = _context6.sent;
            _context6.next = 9;
            break;

          case 6:
            _context6.prev = 6;
            _context6.t0 = _context6["catch"](0);
            // Handle 204 response
            responseData = Promise.resolve({});

          case 9:
            _context6.prev = 9;
            timeLog.logNow();
            logger.info('Response received', responseData);
            return _context6.finish(9);

          case 13:
            return _context6.abrupt("return", responseData);

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 6, 9, 13]]);
  }));

  return function processResponse(_x8, _x9) {
    return _ref19.apply(this, arguments);
  };
}();

var getVerificationUrl$1 = function getVerificationUrl$1() {
  return "".concat(getOptions().restApi.serviceUrl).concat(getOptions().restApi.resources.verification);
};

var getVerificationStatusUrl = function getVerificationStatusUrl(verificationId) {
  return "".concat(getVerificationUrl$1()).concat(verificationId);
};

var getNewVerificationRequestUrl = function getNewVerificationRequestUrl() {
  return getVerificationUrl$1();
};

var getProgramThemeUrl = function getProgramThemeUrl(programId) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var baseUrl = "".concat(getOptions().restApi.serviceUrl).concat(getOptions().restApi.resources.program.base).concat(programId, "/").concat(getOptions().restApi.resources.program.theme);

  if (locale) {
    return "".concat(baseUrl, "?locale=").concat(locale);
  }

  return "".concat(baseUrl);
};

var getAddSchoolRequestUrl = function getAddSchoolRequestUrl() {
  return "".concat(getOptions().restApi.serviceUrl, "rest/v2/organization/addSchool/");
};

var getNewSmsCodeResendUrl = function getNewSmsCodeResendUrl(verificationId) {
  return "".concat(getOptions().restApi.serviceUrl, "rest/v2/verification/").concat(verificationId, "/step/smsLoop/retry");
};

var getNewEmailCodeResendUrl = function getNewEmailCodeResendUrl(verificationId) {
  return "".concat(getOptions().restApi.serviceUrl, "rest/v2/verification/").concat(verificationId, "/step/emailLoop/retry");
};

var getFieldsToCollectUrl = function getFieldsToCollectUrl(verificationId, stepName) {
  return "".concat(getOptions().restApi.serviceUrl, "rest/v2/verification/").concat(verificationId, "/").concat(stepName, "/fields");
};
/**
 * Get the version that was actually used
 * Comes from the contents of sheerid.js. The build process adds it there.
 * e.g. 1.59.0 or 1.46.0-alpha.575
 */


var getPublishedVersion = function getPublishedVersion() {
  return window.sheerIdPubV;
};
/**
 * Replace a CDN URL's dist tag with a more specific version
 */


var urlMajorToSpecific = function urlMajorToSpecific(cdnUrl, specificVersion) {
  return ensureTrailingSlash(specificVersion ? cdnUrl.replace(/@(?!sheerid)[^/]*/gi, "@".concat(specificVersion)) : cdnUrl);
};

var getCurrentUrl = function getCurrentUrl() {
  return document.location.href;
};

var getInstallPageUrl = function getInstallPageUrl() {
  try {
    var parsed = new URLSearchParams(window.location.search);

    if (parsed.get(QUERY_STRING_INSTALL_PAGE_URL)) {
      return decodeURIComponent(parsed.get(QUERY_STRING_INSTALL_PAGE_URL));
    }

    if (getOptions()[QUERY_STRING_INSTALL_PAGE_URL]) {
      return getOptions()[QUERY_STRING_INSTALL_PAGE_URL];
    }
  } catch (e) {
    logger.error(e);
  }

  return getCurrentUrl();
};
/**
 * Get the canonical URL from which to load all other jslib files
 */


var getSheerIdScriptBasePath = function getSheerIdScriptBasePath() {
  var basePath;

  try {
    var scriptSrc = window.sheerIdCurrentScript.getAttribute('src');
    basePath = scriptSrc.substr(0, scriptSrc.lastIndexOf('/')); // drop the filename
  } catch (e) {
    if (document.location.hostname !== 'localhost') {
      logger.error(e);
    }
  }

  if (!basePath) {
    if (document.location.hostname === 'localhost') {
      basePath = document.location.origin;
    } else {
      basePath = DEFAULT_CDN_BASE_URL;
      logger.error('No window.sheerIdCurrentScript, is document.currentScript unsupported?');
    }
  }

  return ensureTrailingSlash(urlMajorToSpecific(basePath, getPublishedVersion()));
};

var country = 'country';
var name = 'name';

function fetchProgramOrganizations(_x10, _x11, _x12, _x13) {
  return _fetchProgramOrganizations.apply(this, arguments);
}

function _fetchProgramOrganizations() {
  _fetchProgramOrganizations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(orgSearchUrl, searchTerm, countryCode, searchTags) {
    var searchUrl, origin, pathname, search, searchParams, url;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            if (orgSearchUrl) {
              _context44.next = 2;
              break;
            }

            return _context44.abrupt("return", Promise.resolve([]));

          case 2:
            searchUrl = new URL(orgSearchUrl);
            origin = searchUrl.origin, pathname = searchUrl.pathname, search = searchUrl.search;
            searchParams = new URLSearchParams(search);
            searchParams.set(name, searchTerm);

            if (countryCode) {
              searchParams.set(country, countryCode);
            }

            if (searchTags) {
              searchParams.set('tags', searchTags);
            }

            url = "".concat(origin).concat(pathname, "?").concat(searchParams.toString());
            return _context44.abrupt("return", fetchOrganization(url));

          case 10:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44);
  }));
  return _fetchProgramOrganizations.apply(this, arguments);
}

function fetchOrganization(_x14) {
  return _fetchOrganization.apply(this, arguments);
}

function _fetchOrganization() {
  _fetchOrganization = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(url) {
    var responseEntries;
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            _context45.prev = 0;
            _context45.next = 3;
            return GetJson(url);

          case 3:
            responseEntries = _context45.sent;
            return _context45.abrupt("return", responseEntries.map(function (entry) {
              return mapOrg(entry);
            }));

          case 7:
            _context45.prev = 7;
            _context45.t0 = _context45["catch"](0);
            logger.error(_context45.t0, 'failed to fetchOrganization');

          case 10:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45, null, [[0, 7]]);
  }));
  return _fetchOrganization.apply(this, arguments);
}

function mapOrg(sourceOrg) {
  return {
    id: sourceOrg.id,
    idExtended: sourceOrg.idExtended === undefined ? sourceOrg.id.toString() : sourceOrg.idExtended,
    name: sourceOrg.name
  };
}

var fetchRequestOrganizations = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(url) {
    var timeLog, response, responseData;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            timeLog = new ResponseTimeLogger(url);
            _context7.next = 3;
            return fetch(url, {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              method: 'GET'
            });

          case 3:
            response = _context7.sent;

            if (!(response.status >= 400)) {
              _context7.next = 6;
              break;
            }

            throw new Error('An error occurred');

          case 6:
            _context7.prev = 6;
            _context7.next = 9;
            return response.json();

          case 9:
            responseData = _context7.sent;
            _context7.next = 15;
            break;

          case 12:
            _context7.prev = 12;
            _context7.t0 = _context7["catch"](6);
            // Handle 204 response
            responseData = Promise.resolve({});

          case 15:
            _context7.prev = 15;
            timeLog.logNow();
            logger.info('Response received', responseData);
            return _context7.finish(15);

          case 19:
            return _context7.abrupt("return", responseData);

          case 20:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[6, 12, 15, 19]]);
  }));

  return function fetchRequestOrganizations(_x15) {
    return _ref20.apply(this, arguments);
  };
}();

function addSchool(_x16) {
  return _addSchool.apply(this, arguments);
}

function _addSchool() {
  _addSchool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(request) {
    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            _context46.next = 2;
            return PostJson(getAddSchoolRequestUrl(), request);

          case 2:
            return _context46.abrupt("return", _context46.sent);

          case 3:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46);
  }));
  return _addSchool.apply(this, arguments);
}

var submitAddSchoolRequest = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(canSubmitForm, requestOrganizationService, dispatch) {
    var viewModel, body;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            viewModel = requestOrganizationService.viewModel;

            if (canSubmitForm()) {
              _context8.next = 3;
              break;
            }

            return _context8.abrupt("return");

          case 3:
            body = {
              programId: requestOrganizationService.programId,
              firstName: viewModel.firstName,
              lastName: viewModel.lastName,
              email: viewModel.email,
              schoolName: viewModel.orgName,
              schoolDomain: viewModel.orgDomain,
              schoolCountry: viewModel.countryChoice.value
            };
            _context8.prev = 4;
            updateIsLoading(dispatch, true);
            _context8.next = 8;
            return addSchool(body).then(function () {
              updateIsLoading(dispatch, false);
              dispatch({
                type: 'SET_SUBMIT',
                payload: true
              });
            });

          case 8:
            _context8.next = 14;
            break;

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](4);
            logger.error(_context8.t0, 'submitAddSchoolRequest');
            dispatch({
              type: 'SET_ERROR',
              payload: true
            });

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[4, 10]]);
  }));

  return function submitAddSchoolRequest(_x17, _x18, _x19) {
    return _ref21.apply(this, arguments);
  };
}();

var updateIsLoading = function updateIsLoading(dispatch, isLoading) {
  dispatch({
    type: 'SET_LOADING',
    payload: isLoading
  });
};

var getOrgNameWithoutLocation = function getOrgNameWithoutLocation(organizationName) {
  // Matches parenthetical text that displays location after the org name
  var regex = /(\s\([A-Za-z]+(?: [A-Za-z]+)*),+ ([A-Za-z]+\))/;
  return organizationName.replace(regex, '');
};

var eligibleSchoolIconSrc = 'https://s3.amazonaws.com/com.sheerid.resources/common/images/requestOrganization/doc-right.svg';

var OrganizationResultComponent = function OrganizationResultComponent(_ref22) {
  var organization = _ref22.organization,
      isEligible = _ref22.isEligible;
  return isEligible ? React.createElement("div", {
    className: "sid-search-result"
  }, React.createElement("img", {
    src: eligibleSchoolIconSrc,
    alt: "School Icon"
  }), ' ', organization.name, React.createElement(CopyToClipboard, {
    textToCopy: getOrgNameWithoutLocation(organization.name),
    notificationText: React.createElement(FormattedHTMLMessage, {
      id: "copied",
      defaultMessage: "Copied"
    })
  }, React.createElement("div", {
    className: "sid-copy-to-clipboard-front"
  }), React.createElement("div", {
    className: "sid-copy-to-clipboard-back"
  }))) : React.createElement("div", {
    className: "sid-search-result"
  }, React.createElement("div", {
    className: "sid-oval"
  }, React.createElement("div", {
    className: "sid-inner-x"
  }, "x")), ' ', organization.name);
};
/**
 * Return a unique array of primitive members
 * Sorts the array
 * @private
 */


function arrayUnique(array) {
  return array.sort().filter(function (item, pos, ary) {
    return !pos || item !== ary[pos - 1];
  });
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */


var isBuffer = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

var flat = flatten$1;
flatten$1.flatten = flatten$1;
flatten$1.unflatten = unflatten;

function flatten$1(target, opts) {
  opts = opts || {};
  var delimiter = opts.delimiter || '.';
  var maxDepth = opts.maxDepth;
  var output = {};

  function step(object, prev, currentDepth) {
    currentDepth = currentDepth || 1;
    Object.keys(object).forEach(function (key) {
      var value = object[key];
      var isarray = opts.safe && Array.isArray(value);
      var type = Object.prototype.toString.call(value);
      var isbuffer = isBuffer(value);
      var isobject = type === '[object Object]' || type === '[object Array]';
      var newKey = prev ? prev + delimiter + key : key;

      if (!isarray && !isbuffer && isobject && Object.keys(value).length && (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1);
      }

      output[newKey] = value;
    });
  }

  step(target);
  return output;
}

function unflatten(target, opts) {
  opts = opts || {};
  var delimiter = opts.delimiter || '.';
  var overwrite = opts.overwrite || false;
  var result = {};
  var isbuffer = isBuffer(target);

  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target;
  } // safely ensure that the key is
  // an integer.


  function getkey(key) {
    var parsedKey = Number(key);
    return isNaN(parsedKey) || key.indexOf('.') !== -1 || opts.object ? key : parsedKey;
  }

  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length;
  });
  sortedKeys.forEach(function (key) {
    var split = key.split(delimiter);
    var key1 = getkey(split.shift());
    var key2 = getkey(split[0]);
    var recipient = result;

    while (key2 !== undefined) {
      if (key1 === '__proto__') {
        return;
      }

      var type = Object.prototype.toString.call(recipient[key1]);
      var isobject = type === '[object Object]' || type === '[object Array]'; // do not write over falsey, non-undefined values if overwrite is false

      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return;
      }

      if (overwrite && !isobject || !overwrite && recipient[key1] == null) {
        recipient[key1] = typeof key2 === 'number' && !opts.object ? [] : {};
      }

      recipient = recipient[key1];

      if (split.length > 0) {
        key1 = getkey(split.shift());
        key2 = getkey(split[0]);
      }
    } // unflatten again for 'messy objects'


    recipient[key1] = unflatten(target[key], opts);
  });
  return result;
}

var flat_1 = flat.flatten;
var enUSMessages = {
  "defaultMessages.ACTIVE_DUTY": "Active Duty",
  "defaultMessages.DENTIST": "Dentist",
  "defaultMessages.DOCTOR": "Doctor",
  "defaultMessages.EMT": "EMT",
  "defaultMessages.FIREFIGHTER": "Firefighter",
  "defaultMessages.HOME_BUYER": "Home Buyer",
  "defaultMessages.LICENSED_COSMETOLOGIST": "Licensed Cosmetologist",
  "defaultMessages.LICENSED_REAL_ESTATE_AGENT": "Licensed Real Estate Agent",
  "defaultMessages.MILITARY_FAMILY": "Military Family",
  "defaultMessages.MILITARY_RETIREE": "Military Retiree",
  "defaultMessages.NURSE": "Nurse",
  "defaultMessages.OTHER_HEALTH_WORKER": "Other Health Worker",
  "defaultMessages.OTHER_MOVER": "Other Mover",
  "defaultMessages.PHARMACIST": "Pharmacist",
  "defaultMessages.POLICE": "Police",
  "defaultMessages.RESERVIST": "Reservist or National Guard",
  "defaultMessages.VETERAN": "Military Veteran or Retiree",
  "defaultMessages.VETERINARIAN": "Veterinarian",
  "defaultMessages.address": "Address",
  "defaultMessages.addressPlaceholder": "Address*",
  "defaultMessages.birthDate": "Date of birth",
  "defaultMessages.branchOfService": "Branch of service",
  "defaultMessages.branchOfServicePlaceholder": "Branch Of Service*",
  "defaultMessages.changeLanguage": "Change language",
  "defaultMessages.city": "City",
  "defaultMessages.cityPlaceholder": "City*",
  "defaultMessages.company": "Company",
  "defaultMessages.companyPlaceholder": "Company*",
  "defaultMessages.copied": "Copied",
  "defaultMessages.countries.AD": "Andorra",
  "defaultMessages.countries.AE": "United Arab Emirates",
  "defaultMessages.countries.AF": "Afghanistan",
  "defaultMessages.countries.AG": "Antigua and Barbuda",
  "defaultMessages.countries.AI": "Anguilla",
  "defaultMessages.countries.AL": "Albania",
  "defaultMessages.countries.AM": "Armenia",
  "defaultMessages.countries.AN": "Netherlands Antilles",
  "defaultMessages.countries.AO": "Angola",
  "defaultMessages.countries.AR": "Argentina",
  "defaultMessages.countries.AS": "American Samoa",
  "defaultMessages.countries.AT": "Austria",
  "defaultMessages.countries.AU": "Australia",
  "defaultMessages.countries.AW": "Aruba",
  "defaultMessages.countries.AZ": "Azerbaijan",
  "defaultMessages.countries.BA": "Bosnia-Herzegovina",
  "defaultMessages.countries.BB": "Barbados",
  "defaultMessages.countries.BD": "Bangladesh",
  "defaultMessages.countries.BE": "Belgium",
  "defaultMessages.countries.BF": "Burkina Faso",
  "defaultMessages.countries.BG": "Bulgaria",
  "defaultMessages.countries.BH": "Bahrain",
  "defaultMessages.countries.BI": "Burundi",
  "defaultMessages.countries.BJ": "Benin",
  "defaultMessages.countries.BM": "Bermuda",
  "defaultMessages.countries.BN": "Brunei Darussalam",
  "defaultMessages.countries.BO": "Bolivia",
  "defaultMessages.countries.BR": "Brazil",
  "defaultMessages.countries.BS": "Bahamas",
  "defaultMessages.countries.BT": "Bhutan",
  "defaultMessages.countries.BV": "Bouvet Island",
  "defaultMessages.countries.BW": "Botswana",
  "defaultMessages.countries.BY": "Belarus",
  "defaultMessages.countries.BZ": "Belize",
  "defaultMessages.countries.CA": "Canada",
  "defaultMessages.countries.CD": "Democratic Republic of Congo",
  "defaultMessages.countries.CF": "Central African Republic",
  "defaultMessages.countries.CG": "Congo",
  "defaultMessages.countries.CH": "Switzerland",
  "defaultMessages.countries.CI": "Ivory Coast (Cote D'Ivoire)",
  "defaultMessages.countries.CK": "Cook Islands",
  "defaultMessages.countries.CL": "Chile",
  "defaultMessages.countries.CM": "Cameroon",
  "defaultMessages.countries.CN": "China",
  "defaultMessages.countries.CO": "Colombia",
  "defaultMessages.countries.CR": "Costa Rica",
  "defaultMessages.countries.CU": "Cuba",
  "defaultMessages.countries.CV": "Cape Verde",
  "defaultMessages.countries.CY": "Cyprus",
  "defaultMessages.countries.CZ": "Czech Republic",
  "defaultMessages.countries.DE": "Germany",
  "defaultMessages.countries.DJ": "Djibouti",
  "defaultMessages.countries.DK": "Denmark",
  "defaultMessages.countries.DM": "Dominica",
  "defaultMessages.countries.DO": "Dominican Republic",
  "defaultMessages.countries.DZ": "Algeria",
  "defaultMessages.countries.EC": "Ecuador",
  "defaultMessages.countries.EE": "Estonia",
  "defaultMessages.countries.EG": "Egypt",
  "defaultMessages.countries.EH": "Western Sahara",
  "defaultMessages.countries.ER": "Eritrea",
  "defaultMessages.countries.ES": "Spain",
  "defaultMessages.countries.ET": "Ethiopia",
  "defaultMessages.countries.FI": "Finland",
  "defaultMessages.countries.FJ": "Fiji",
  "defaultMessages.countries.FK": "Falkland Islands",
  "defaultMessages.countries.FM": "Micronesia",
  "defaultMessages.countries.FO": "Faroe Islands",
  "defaultMessages.countries.FR": "France",
  "defaultMessages.countries.GA": "Gabon",
  "defaultMessages.countries.GB": "United Kingdom",
  "defaultMessages.countries.GD": "Grenada",
  "defaultMessages.countries.GE": "Georgia",
  "defaultMessages.countries.GF": "French Guyana",
  "defaultMessages.countries.GH": "Ghana",
  "defaultMessages.countries.GI": "Gibraltar",
  "defaultMessages.countries.GL": "Greenland",
  "defaultMessages.countries.GM": "Gambia",
  "defaultMessages.countries.GN": "Guinea",
  "defaultMessages.countries.GP": "Guadeloupe (French)",
  "defaultMessages.countries.GQ": "Equatorial Guinea",
  "defaultMessages.countries.GR": "Greece",
  "defaultMessages.countries.GS": "South Georgia & South Sandwich Islands",
  "defaultMessages.countries.GT": "Guatemala",
  "defaultMessages.countries.GU": "Guam (USA)",
  "defaultMessages.countries.GW": "Guinea Bissau",
  "defaultMessages.countries.GY": "Guyana",
  "defaultMessages.countries.HK": "Hong Kong",
  "defaultMessages.countries.HM": "Heard and McDonald Islands",
  "defaultMessages.countries.HN": "Honduras",
  "defaultMessages.countries.HR": "Croatia",
  "defaultMessages.countries.HT": "Haiti",
  "defaultMessages.countries.HU": "Hungary",
  "defaultMessages.countries.ID": "Indonesia",
  "defaultMessages.countries.IE": "Ireland",
  "defaultMessages.countries.IL": "Israel",
  "defaultMessages.countries.IN": "India",
  "defaultMessages.countries.IO": "British Indian Ocean Territory",
  "defaultMessages.countries.IQ": "Iraq",
  "defaultMessages.countries.IR": "Iran",
  "defaultMessages.countries.IS": "Iceland",
  "defaultMessages.countries.IT": "Italy",
  "defaultMessages.countries.JM": "Jamaica",
  "defaultMessages.countries.JO": "Jordan",
  "defaultMessages.countries.JP": "Japan",
  "defaultMessages.countries.KE": "Kenya",
  "defaultMessages.countries.KG": "Kyrgyzstan",
  "defaultMessages.countries.KH": "Cambodia",
  "defaultMessages.countries.KI": "Kiribati",
  "defaultMessages.countries.KM": "Comoros",
  "defaultMessages.countries.KN": "Saint Kitts & Nevis Anguilla",
  "defaultMessages.countries.KP": "North Korea",
  "defaultMessages.countries.KR": "South Korea",
  "defaultMessages.countries.KW": "Kuwait",
  "defaultMessages.countries.KY": "Cayman Islands",
  "defaultMessages.countries.KZ": "Kazakhstan",
  "defaultMessages.countries.LA": "Laos",
  "defaultMessages.countries.LB": "Lebanon",
  "defaultMessages.countries.LC": "Saint Lucia",
  "defaultMessages.countries.LI": "Liechtenstein",
  "defaultMessages.countries.LK": "Sri Lanka",
  "defaultMessages.countries.LR": "Liberia",
  "defaultMessages.countries.LS": "Lesotho",
  "defaultMessages.countries.LT": "Lithuania",
  "defaultMessages.countries.LU": "Luxembourg",
  "defaultMessages.countries.LV": "Latvia",
  "defaultMessages.countries.LY": "Libya",
  "defaultMessages.countries.MA": "Morocco",
  "defaultMessages.countries.MC": "Monaco",
  "defaultMessages.countries.MD": "Moldavia",
  "defaultMessages.countries.ME": "Montenegro",
  "defaultMessages.countries.MG": "Madagascar",
  "defaultMessages.countries.MH": "Marshall Islands",
  "defaultMessages.countries.MK": "Macedonia",
  "defaultMessages.countries.ML": "Mali",
  "defaultMessages.countries.MM": "Myanmar",
  "defaultMessages.countries.MN": "Mongolia",
  "defaultMessages.countries.MO": "Macau",
  "defaultMessages.countries.MP": "Northern Mariana Islands",
  "defaultMessages.countries.MQ": "Martinique (French)",
  "defaultMessages.countries.MR": "Mauritania",
  "defaultMessages.countries.MS": "Montserrat",
  "defaultMessages.countries.MT": "Malta",
  "defaultMessages.countries.MU": "Mauritius",
  "defaultMessages.countries.MV": "Maldives",
  "defaultMessages.countries.MW": "Malawi",
  "defaultMessages.countries.MX": "Mexico",
  "defaultMessages.countries.MY": "Malaysia",
  "defaultMessages.countries.MZ": "Mozambique",
  "defaultMessages.countries.NA": "Namibia",
  "defaultMessages.countries.NC": "New Caledonia (French)",
  "defaultMessages.countries.NE": "Niger",
  "defaultMessages.countries.NF": "Norfolk Island",
  "defaultMessages.countries.NG": "Nigeria",
  "defaultMessages.countries.NI": "Nicaragua",
  "defaultMessages.countries.NL": "Netherlands",
  "defaultMessages.countries.NO": "Norway",
  "defaultMessages.countries.NP": "Nepal",
  "defaultMessages.countries.NR": "Nauru",
  "defaultMessages.countries.NU": "Niue",
  "defaultMessages.countries.NZ": "New Zealand",
  "defaultMessages.countries.OM": "Oman",
  "defaultMessages.countries.PA": "Panama",
  "defaultMessages.countries.PE": "Peru",
  "defaultMessages.countries.PF": "Polynesia (French)",
  "defaultMessages.countries.PG": "Papua New Guinea",
  "defaultMessages.countries.PH": "Philippines",
  "defaultMessages.countries.PK": "Pakistan",
  "defaultMessages.countries.PL": "Poland",
  "defaultMessages.countries.PM": "Saint Pierre and Miquelon",
  "defaultMessages.countries.PN": "Pitcairn Island",
  "defaultMessages.countries.PR": "Puerto Rico",
  "defaultMessages.countries.PS": "Palestine",
  "defaultMessages.countries.PT": "Portugal",
  "defaultMessages.countries.PW": "Palau",
  "defaultMessages.countries.PY": "Paraguay",
  "defaultMessages.countries.QA": "Qatar",
  "defaultMessages.countries.RE": "Reunion (French)",
  "defaultMessages.countries.RO": "Romania",
  "defaultMessages.countries.RS": "Serbia",
  "defaultMessages.countries.RU": "Russian Federation",
  "defaultMessages.countries.RW": "Rwanda",
  "defaultMessages.countries.SA": "Saudi Arabia",
  "defaultMessages.countries.SB": "Solomon Islands",
  "defaultMessages.countries.SC": "Seychelles",
  "defaultMessages.countries.SD": "Sudan",
  "defaultMessages.countries.SE": "Sweden",
  "defaultMessages.countries.SG": "Singapore",
  "defaultMessages.countries.SH": "Saint Helena",
  "defaultMessages.countries.SI": "Slovenia",
  "defaultMessages.countries.SK": "Slovak Republic",
  "defaultMessages.countries.SL": "Sierra Leone",
  "defaultMessages.countries.SM": "San Marino",
  "defaultMessages.countries.SN": "Senegal",
  "defaultMessages.countries.SO": "Somalia",
  "defaultMessages.countries.SR": "Suriname",
  "defaultMessages.countries.SS": "South Sudan",
  "defaultMessages.countries.ST": "Saint Tome (Sao Tome) and Principe",
  "defaultMessages.countries.SV": "El Salvador",
  "defaultMessages.countries.SY": "Syria",
  "defaultMessages.countries.SZ": "Swaziland",
  "defaultMessages.countries.TC": "Turks and Caicos Islands",
  "defaultMessages.countries.TD": "Chad",
  "defaultMessages.countries.TF": "French Southern Territories",
  "defaultMessages.countries.TG": "Togo",
  "defaultMessages.countries.TH": "Thailand",
  "defaultMessages.countries.TJ": "Tajikistan",
  "defaultMessages.countries.TK": "Tokelau",
  "defaultMessages.countries.TL": "Timor-Leste",
  "defaultMessages.countries.TM": "Turkmenistan",
  "defaultMessages.countries.TN": "Tunisia",
  "defaultMessages.countries.TO": "Tonga",
  "defaultMessages.countries.TR": "Turkey",
  "defaultMessages.countries.TT": "Trinidad and Tobago",
  "defaultMessages.countries.TV": "Tuvalu",
  "defaultMessages.countries.TW": "Taiwan",
  "defaultMessages.countries.TZ": "Tanzania",
  "defaultMessages.countries.UA": "Ukraine",
  "defaultMessages.countries.UG": "Uganda",
  "defaultMessages.countries.UM": "USA Minor Outlying Islands",
  "defaultMessages.countries.US": "United States",
  "defaultMessages.countries.UY": "Uruguay",
  "defaultMessages.countries.UZ": "Uzbekistan",
  "defaultMessages.countries.VA": "Vatican City State",
  "defaultMessages.countries.VC": "Saint Vincent & Grenadines",
  "defaultMessages.countries.VE": "Venezuela",
  "defaultMessages.countries.VG": "Virgin Islands (British)",
  "defaultMessages.countries.VI": "Virgin Islands (USA)",
  "defaultMessages.countries.VN": "Vietnam",
  "defaultMessages.countries.VU": "Vanuatu",
  "defaultMessages.countries.WF": "Wallis and Futuna Islands",
  "defaultMessages.countries.WS": "Samoa",
  "defaultMessages.countries.XK": "Kosovo",
  "defaultMessages.countries.YE": "Yemen",
  "defaultMessages.countries.YT": "Mayotte",
  "defaultMessages.countries.ZA": "South Africa",
  "defaultMessages.countries.ZM": "Zambia",
  "defaultMessages.countries.ZW": "Zimbabwe",
  "defaultMessages.country": "Country",
  "defaultMessages.countryPlaceholder": "Country*",
  "defaultMessages.dateTime.20_MIN": "20 minutes",
  "defaultMessages.dateTime.24_HRS": "24 hours",
  "defaultMessages.dateTime.2_DAY": "2 days",
  "defaultMessages.dateTime.2_HRS": "2 hours",
  "defaultMessages.dateTime.2_MIN": "2 minutes",
  "defaultMessages.dateTime.3_DAY": "3 days",
  "defaultMessages.dateTime.A_FEW_DAYS": "a few days",
  "defaultMessages.dateTime.A_FEW_HOURS": "a few hours",
  "defaultMessages.dateTime.A_FEW_MINUTES": "a few minutes",
  "defaultMessages.dateTime.A_HALF_HOUR": "half an hour",
  "defaultMessages.dateTime.april": "April",
  "defaultMessages.dateTime.august": "August",
  "defaultMessages.dateTime.day": "Day",
  "defaultMessages.dateTime.december": "December",
  "defaultMessages.dateTime.february": "February",
  "defaultMessages.dateTime.january": "January",
  "defaultMessages.dateTime.july": "July",
  "defaultMessages.dateTime.june": "June",
  "defaultMessages.dateTime.march": "March",
  "defaultMessages.dateTime.may": "May",
  "defaultMessages.dateTime.month": "Month",
  "defaultMessages.dateTime.november": "November",
  "defaultMessages.dateTime.october": "October",
  "defaultMessages.dateTime.september": "September",
  "defaultMessages.dateTime.year": "Year",
  "defaultMessages.dischargeDate": "Discharge date",
  "defaultMessages.driverLicenseNumber": "Driver license number",
  "defaultMessages.driverLicenseNumberPlaceholder": "Driver license number*",
  "defaultMessages.driverLicenseState": "Driver license state",
  "defaultMessages.emailAddress": "Email address",
  "defaultMessages.emailAddressPlaceholder": "Email address*",
  "defaultMessages.error": "Error",
  "defaultMessages.errorId.apiRateLimitExceeded": "Unable to process your request at this time, please try again later",
  "defaultMessages.errorId.dischargeDateBeforeBirthDate": "Discharge Date before birthdate",
  "defaultMessages.errorId.docReviewLimitExceeded": "Document review limit exceeded",
  "defaultMessages.errorId.expiredEmailLoopToken": "We are sorry, the page you requested cannot be found. The URL may be incorrect or the page you're looking for is no longer available.",
  "defaultMessages.errorId.expiredProgram": "Due to tremendous demand, the offer is no longer available. Please check tomorrow to see if it is available.",
  "defaultMessages.errorId.expiredSMSCode": "Verification code expired",
  "defaultMessages.errorId.expiredVerification": "This verification is expired. Please submit a new verification.",
  "defaultMessages.errorId.failedToFetch": "Failed HTTP request",
  "defaultMessages.errorId.fraudRulesReject": "We're unable to verify you using the information submitted. Please check your information for accuracy, and only use your own mobile device or computer.<br><br>Still having trouble? <a href=\"{feedbackUrl}&pid={programId}&locale={locale}\">Contact SheerID's support team</a> to confirm your identity.",
  "defaultMessages.errorId.futureBirthDate": "Future birthdate",
  "defaultMessages.errorId.futureDischargeDate": "Future discharge date",
  "defaultMessages.errorId.inactiveProgram": "Due to tremendous demand, the offer is no longer available. Please check tomorrow to see if it is available.",
  "defaultMessages.errorId.internalServerError": "Internal server error",
  "defaultMessages.errorId.invalidAddress": "Invalid address",
  "defaultMessages.errorId.invalidApiToken": "Provided API token was invalid or empty",
  "defaultMessages.errorId.invalidBirthDate": "Invalid birth date",
  "defaultMessages.errorId.invalidCity": "Invalid city",
  "defaultMessages.errorId.invalidCountry": "Invalid country",
  "defaultMessages.errorId.invalidDischargeDate": "Invalid discharge date",
  "defaultMessages.errorId.invalidDocUploadToken": "Provided document upload token is not valid",
  "defaultMessages.errorId.invalidDriverLicenseNumber": "Invalid driver license number",
  "defaultMessages.errorId.invalidEmail": "Invalid email",
  "defaultMessages.errorId.invalidEmailLoopToken": "We are sorry, the page you requested cannot be found. The URL may be incorrect or the page you're looking for is no longer available.",
  "defaultMessages.errorId.invalidFileSizeEmpty": "One or more files is empty",
  "defaultMessages.errorId.invalidFileSizeMax": "One or more files is too large (max: 10MB)",
  "defaultMessages.errorId.invalidFirstName": "Invalid first name",
  "defaultMessages.errorId.invalidFirstResponderStatus": "Invalid first responder status",
  "defaultMessages.errorId.invalidLastName": "Invalid last name",
  "defaultMessages.errorId.invalidMemberId": "Invalid ID Number",
  "defaultMessages.errorId.invalidMilitaryStatus": "Invalid military status",
  "defaultMessages.errorId.invalidNumberOfFiles": "Maximum number of files exceeded (max: 5)",
  "defaultMessages.errorId.invalidOptIn": "Must be selected to continue",
  "defaultMessages.errorId.invalidOrganization": "You must select an organization from the list",
  "defaultMessages.errorId.invalidPhoneNumber": "Invalid mobile number",
  "defaultMessages.errorId.invalidPostalCode": "Invalid postal code",
  "defaultMessages.errorId.invalidProgram": "Invalid program",
  "defaultMessages.errorId.invalidRequest": "Invalid request",
  "defaultMessages.errorId.invalidSMSCode": "Verification code could not be validated",
  "defaultMessages.errorId.invalidSocialSecurityNumber": "Invalid SSN",
  "defaultMessages.errorId.invalidState": "Invalid state",
  "defaultMessages.errorId.invalidStatus": "Invalid status",
  "defaultMessages.errorId.invalidStatuses": "Invalid status",
  "defaultMessages.errorId.invalidStep": "Invalid step",
  "defaultMessages.errorId.marketConsentRequired": "Market consent required",
  "defaultMessages.errorId.maxMetadataLengthExceeded": "Maximum length of metadata value exceeded",
  "defaultMessages.errorId.maxMetadataValuesExceeded": "Maximum number of metadata values exceeded",
  "defaultMessages.errorId.noProgram": "No program found",
  "defaultMessages.errorId.noRemainingRewardCodes": "Due to tremendous demand, the offer is no longer available. Please check tomorrow to see if it is available.",
  "defaultMessages.errorId.noValidFiles": "No valid files",
  "defaultMessages.errorId.noVerification": "No verification found",
  "defaultMessages.errorId.notApproved": "Not approved",
  "defaultMessages.errorId.notFound": "Not found",
  "defaultMessages.errorId.outsideAgePerson": "Birthdate is not eligible for this offer.",
  "defaultMessages.errorId.requestTimeout": "Request timeout",
  "defaultMessages.errorId.simulatedError": "This is a simulated error",
  "defaultMessages.errorId.unauthorizedDomain": "Unauthorized domain",
  "defaultMessages.errorId.underagePerson": "Persons under age 16 are not eligible for this offer.",
  "defaultMessages.errorId.unknownError": "Unknown Error",
  "defaultMessages.errorId.unsupportedDocMimeType": "One or more files is an unsupported format",
  "defaultMessages.errorId.verificationLimitExceeded": "We're glad you're enthusiastic, but it looks like you've already redeemed or attempted to redeem this offer.",
  "defaultMessages.firstName": "First name",
  "defaultMessages.firstNamePlaceholder": "First name*",
  "defaultMessages.firstResponderInfoShared": "Information entered here will be used for verification purposes. ",
  "defaultMessages.getHelp": "Get help",
  "defaultMessages.howDoesReviewWork": "How does review work?",
  "defaultMessages.howDoesVerifyingWork": "How does verifying work?",
  "defaultMessages.infoShared1": "By clicking, I consent to processing my information for the purpose of verifying my eligibility as described within the {privacyPolicyLink}",
  "defaultMessages.infoShared2": ". I understand that my information will be shared with {companyName}. ",
  "defaultMessages.informationTransferredToUS": "Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.",
  "defaultMessages.lastName": "Last name",
  "defaultMessages.lastNamePlaceholder": "Last name*",
  "defaultMessages.limitExceededError": "Verification Limit Exceeded",
  "defaultMessages.loading": "Loading...",
  "defaultMessages.locales.ar": "Arabic",
  "defaultMessages.locales.bg": "Bulgarian",
  "defaultMessages.locales.cs": "Czech",
  "defaultMessages.locales.da": "Danish",
  "defaultMessages.locales.de": "German",
  "defaultMessages.locales.el": "Greek",
  "defaultMessages.locales.en-GB": "English (UK)",
  "defaultMessages.locales.en-US": "English",
  "defaultMessages.locales.es": "Spanish",
  "defaultMessages.locales.es-ES": "Spanish (Spain)",
  "defaultMessages.locales.fi": "Finnish",
  "defaultMessages.locales.fr": "French",
  "defaultMessages.locales.fr-CA": "French (Canadian)",
  "defaultMessages.locales.ga": "Irish",
  "defaultMessages.locales.hr": "Croatian",
  "defaultMessages.locales.hu": "Hungarian",
  "defaultMessages.locales.id": "Indonesian",
  "defaultMessages.locales.it": "Italian",
  "defaultMessages.locales.iw": "Hebrew",
  "defaultMessages.locales.ja": "Japanese",
  "defaultMessages.locales.ko": "Korean",
  "defaultMessages.locales.lo": "Lao",
  "defaultMessages.locales.lt": "Lithuanian",
  "defaultMessages.locales.ms": "Malay",
  "defaultMessages.locales.nl": "Dutch",
  "defaultMessages.locales.no": "Norwegian",
  "defaultMessages.locales.pl": "Polish",
  "defaultMessages.locales.pt": "Portuguese",
  "defaultMessages.locales.pt-BR": "Portuguese (Brazil)",
  "defaultMessages.locales.ru": "Russia",
  "defaultMessages.locales.sk": "Slovak",
  "defaultMessages.locales.sl": "Slovenian",
  "defaultMessages.locales.sr": "Serbian",
  "defaultMessages.locales.sv": "Swedish",
  "defaultMessages.locales.th": "Thai",
  "defaultMessages.locales.tr": "Turkish",
  "defaultMessages.locales.zh": "Chinese (Traditional)",
  "defaultMessages.locales.zh-HK": "Chinese (Hong Kong)",
  "defaultMessages.lowRewardPool": "<span class='sid-fire-emoji'>&#128293;</span> Only {offersRemaining} offers left!",
  "defaultMessages.memberId": "ID Number",
  "defaultMessages.memberIdPlaceholder": "ID Number*",
  "defaultMessages.militaryFamilyCardNote": "Note: this offer is only available to military family members with a Dependent ID card.",
  "defaultMessages.militaryInfoShared": "Information entered here will be used for verification purposes. ",
  "defaultMessages.militaryStatus": "Military status",
  "defaultMessages.noOptions": "No options",
  "defaultMessages.optIn": "Yes, send me {company} marketing communications about exclusive sales, special offers, latest products and more",
  "defaultMessages.optional": "Optional",
  "defaultMessages.organization": "Organization",
  "defaultMessages.organizationPlaceholder": "Organization*",
  "defaultMessages.personalInformation": "Personal Information",
  "defaultMessages.personalOrSchoolIsFine": "Personal or school email is fine",
  "defaultMessages.phoneNumber": "Mobile Number",
  "defaultMessages.phoneNumberExplanation": "Optional - get text notifications of status updates",
  "defaultMessages.phoneNumberWarnMessage1": "By submitting this form with a mobile number, you consent to receive SMS/text messages for verification purposes. Standard phone carrier text messaging (SMS) and data rates may apply.",
  "defaultMessages.phoneNumberWarnMessage2": "You authorize your mobile service provider to disclose your mobile number and certain account information to SheerID, solely for identity verification and to avoid fraud.",
  "defaultMessages.phoneUsPlaceholder": "555-555-5555",
  "defaultMessages.postalCode": "Postal code",
  "defaultMessages.postalCodeExplanation": "Use the location on file with your licensing body",
  "defaultMessages.postalCodePlaceholder": "Postal code*",
  "defaultMessages.poweredBy": "Verification services powered by SheerID",
  "defaultMessages.privacyPolicy": "Privacy Policy",
  "defaultMessages.proceed": "Proceed",
  "defaultMessages.requestSchool": "Don't see your school? Request to have it added.",
  "defaultMessages.requiredFields": "All fields are required",
  "defaultMessages.school": "School",
  "defaultMessages.schoolName": "University / College name",
  "defaultMessages.schoolNamePlaceholder": "University / College name*",
  "defaultMessages.sheeridFaqs": "SheerID FAQs",
  "defaultMessages.smsCodePlaceholder": "SMS Code*",
  "defaultMessages.ssn": "Social Security Number",
  "defaultMessages.ssnPlaceholder": "000-00-0000",
  "defaultMessages.state": "State",
  "defaultMessages.statePlaceholder": "State*",
  "defaultMessages.states.AK": "Alaska",
  "defaultMessages.states.AL": "Alabama",
  "defaultMessages.states.AR": "Arkansas",
  "defaultMessages.states.AZ": "Arizona",
  "defaultMessages.states.CA": "California",
  "defaultMessages.states.CO": "Colorado",
  "defaultMessages.states.CT": "Connecticut",
  "defaultMessages.states.DC": "District of Columbia",
  "defaultMessages.states.DE": "Delaware",
  "defaultMessages.states.FL": "Florida",
  "defaultMessages.states.GA": "Georgia",
  "defaultMessages.states.HI": "Hawaii",
  "defaultMessages.states.IA": "Iowa",
  "defaultMessages.states.ID": "Idaho",
  "defaultMessages.states.IL": "Illinois",
  "defaultMessages.states.IN": "Indiana",
  "defaultMessages.states.KS": "Kansas",
  "defaultMessages.states.KY": "Kentucky",
  "defaultMessages.states.LA": "Louisiana",
  "defaultMessages.states.MA": "Massachusettes",
  "defaultMessages.states.MD": "Maryland",
  "defaultMessages.states.ME": "Maine",
  "defaultMessages.states.MI": "Michigan",
  "defaultMessages.states.MN": "Minnesota",
  "defaultMessages.states.MO": "Missouri",
  "defaultMessages.states.MS": "Mississippi",
  "defaultMessages.states.MT": "Montana",
  "defaultMessages.states.NC": "North Carolina",
  "defaultMessages.states.ND": "North Dakota",
  "defaultMessages.states.NE": "Nebraska",
  "defaultMessages.states.NH": "New Hampshire",
  "defaultMessages.states.NJ": "New Jersey",
  "defaultMessages.states.NM": "New Mexico",
  "defaultMessages.states.NV": "Nevada",
  "defaultMessages.states.NY": "New York",
  "defaultMessages.states.OH": "Ohio",
  "defaultMessages.states.OK": "Oklahoma",
  "defaultMessages.states.OR": "Oregon",
  "defaultMessages.states.PA": "Pennsylvania",
  "defaultMessages.states.RI": "Rhode Island",
  "defaultMessages.states.SC": "South Carolina",
  "defaultMessages.states.SD": "South Dakota",
  "defaultMessages.states.TN": "Tennessee",
  "defaultMessages.states.TX": "Texas",
  "defaultMessages.states.UT": "Utah",
  "defaultMessages.states.VA": "Virginia",
  "defaultMessages.states.VT": "Vermont",
  "defaultMessages.states.WA": "Washington",
  "defaultMessages.states.WI": "Wisconsin",
  "defaultMessages.states.WV": "West Virginia",
  "defaultMessages.states.WY": "Wyoming",
  "defaultMessages.status": "Status",
  "defaultMessages.statusPlaceholder": "Status*",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdExplanation": "Your Professional Membership Registration Number",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdLabel": "Registration Number",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerExplanation": "Your Professional Membership Registration Number",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerLabel": "Registration Number",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberExplanation": "Your Professional Membership Registration Number",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberLabel": "Global Location Number",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoExplanation": "Your Professional Membership Registration Number",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoLabel": "Registration Number",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberExplanation": "Your Professional Membership Registration Number",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberLabel": "Registration Number",
  "defaultMessages.step.collectSocialSecurityNumber.selectOption": "Select an option",
  "defaultMessages.step.collectSocialSecurityNumber.title": "Enter your social security number",
  "defaultMessages.step.collectSocialSecurityNumber.uploadDoc": "Upload a document",
  "defaultMessages.step.collectSocialSecurityNumber.uploadInstead": "Upload a document instead",
  "defaultMessages.step.collectSocialSecurityNumber.useSsn": "Verify using your social security number",
  "defaultMessages.step.docUpload.acceptableUploadExamples": "Acceptable examples include:",
  "defaultMessages.step.docUpload.acceptableUploads.age.birthCertificate": "Your birth certificate",
  "defaultMessages.step.docUpload.acceptableUploads.age.driversLicense": "Your drivers license",
  "defaultMessages.step.docUpload.acceptableUploads.age.passport": "Your passport",
  "defaultMessages.step.docUpload.acceptableUploads.age.stateId": "Your state-issued ID",
  "defaultMessages.step.docUpload.acceptableUploads.employment.employeeIdCard": "Employee ID Card",
  "defaultMessages.step.docUpload.acceptableUploads.employment.officialLetter": "An official letter",
  "defaultMessages.step.docUpload.acceptableUploads.employment.payStub": "Pay stub from within last 60 days",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.idCard": "ID Card",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.letter": "An official letter",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.payStub": "Pay stub from within last 60 days",
  "defaultMessages.step.docUpload.acceptableUploads.licensedProfessional.license": "Certificate of license",
  "defaultMessages.step.docUpload.acceptableUploads.medical.idCard": "Nursing ID card with expiration date",
  "defaultMessages.step.docUpload.acceptableUploads.medical.licenseCertificate": "Certificate of license",
  "defaultMessages.step.docUpload.acceptableUploads.medical.photoPayStub": "Photo ID and recent Pay Stub",
  "defaultMessages.step.docUpload.acceptableUploads.member.idCard": "Membership Document",
  "defaultMessages.step.docUpload.acceptableUploads.member.payStub": "Pay stub from within last 90 days",
  "defaultMessages.step.docUpload.acceptableUploads.military.activeDuty": "Any document that proves you are currently serving as active duty in the armed forces for 30 days or more",
  "defaultMessages.step.docUpload.acceptableUploads.military.dependent": "Any document that proves you are a Registered Military Dependent",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservistA": "Any document that shows you are currently serving in a reserve component of the armed forces",
  "defaultMessages.step.docUpload.acceptableUploads.military.retiree": "Any document that proves you are a retiree from the armed forces",
  "defaultMessages.step.docUpload.acceptableUploads.military.veteran": "Any document that proves you met the qualifications of military service and were honorably discharged",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.changeOfAddress": "U.S. Postal Service change of address confirmation letter",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.mortgageDeed": "Mortgage deed",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.rentalAgreement": "Lease or rental agreement",
  "defaultMessages.step.docUpload.acceptableUploads.senior.birthCertificate": "Your birth certificate",
  "defaultMessages.step.docUpload.acceptableUploads.senior.driversLicense": "Your drivers license",
  "defaultMessages.step.docUpload.acceptableUploads.senior.passport": "Your passport",
  "defaultMessages.step.docUpload.acceptableUploads.senior.stateId": "Your state-issued ID",
  "defaultMessages.step.docUpload.acceptableUploads.student.classSchedule": "Class schedule",
  "defaultMessages.step.docUpload.acceptableUploads.student.idCard": "School ID card with expiration date",
  "defaultMessages.step.docUpload.acceptableUploads.student.tuitionReceipt": "Tuition receipt",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.idCard": "Teacher ID card with valid date",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.payStub": "Pay stub from within last 60 days",
  "defaultMessages.step.docUpload.acceptedTypes": "File must be .jpg .jpeg .png .pdf .gif or .bmp",
  "defaultMessages.step.docUpload.addFile": "Add file",
  "defaultMessages.step.docUpload.cancelButtonLabel": "Cancel",
  "defaultMessages.step.docUpload.fileInstructions": "Drag &amp; drop your files here or <span class=\"sid-dropzone-wrap--link\">browse</span>",
  "defaultMessages.step.docUpload.nameChanged": "If your name has changed since the document was issued, upload a 2nd document showing your official name change.",
  "defaultMessages.step.docUpload.rejectedSubtitle": "We were unable to confirm your eligibility due to:",
  "defaultMessages.step.docUpload.rejectionReasons.CUSTOM_VALUE_OTHER": "The document is insufficient for establishing eligibility for this offer",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_DATE_OTHER": "The document is insufficient for establishing eligibility for this offer",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_EXPIRED": "The document has already expired or was issued too far in the past. Please upload a more recent document.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_HANDWRITTEN": "We cannot accept handwritten documents.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_LIKELY_FRAUD": "The document is insufficient for establishing eligibility for this offer.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED": "The document you submitted is missing an issue date or was issued too far in the past.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED_FACULTY": "The document you submitted does not prove employment in the current academic year.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_PASSWORD_PROTECTED": "We are unable to accept password protected documents.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_STATUS_OTHER": "The document is insufficient for establishing eligibility for this offer",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_TOO_FUTURE": "The date shown in the document is too far in the future. Please upload a more recent document, which proves your current status.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNREADABLE": "The document was unreadable due to poor image quality. Please make sure you have a clearly legible image that's bright and crisp, and try submitting again.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNSUPPORTED": "The document is not official or on the list of accepted document types.",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_VALID_OTHER": "The document is insufficient for establishing eligibility for this offer",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_JOB_TITLE": "The job title shown in the document is not eligible for this offer.",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_ORGANIZATION": "The organization on the document you submitted is not eligible for this offer.",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT": "High School Students are not eligible for this offer.",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_CUSTOM_VALUE": "The document is missing information needed to establish your eligibility for this offer.",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_DOCUMENT_DATE": "The date(s) shown in the document are insufficient to prove your current status. Please upload a document that includes a recent month and year.",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_STATUS": "The document does not prove you are a status eligible for this offer.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_BIRTHDATE": "The birthdate on the document does not match the birthdate you entered on your verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_COMPANY_NAME_OR_ADDRESS": "The company name or address in your document does not match what you entered on the verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_CUSTOM_VALUE": "Some information shown in the document does not match what you entered in the verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION": "The organization name on the document(s) you submitted does not match the organization you listed on the verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_COUNTRY": "The country shown in your document does not match the country you entered on your verification form",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_NAME": "The organization name on the document does not match the organization name you entered on your verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_FIRST_NAME": "The first name on the document does not match the first name you entered on your verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_LAST_NAME": "The last name on the document does not match the last name you entered on your verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_NAME": "The information on the document you submitted does not match the first and/or last name submitted on the verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_STATUS": "The status on the document does not match the status you entered on your verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_CUSTOM_VALUE": "The document is missing information needed to establish your eligibility for this offer.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_DOCUMENT_DATE": "A current date is missing. Please upload an official, dated document that proves your current status.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION": "The document you submitted does not provide all of the information necessary to determine eligibility for this offer.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES": "The document you submitted is does not show affiliation to an eligible branch of the United States Armed Forces.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_BIRTHDATE": "Your birthdate is missing.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_ORGANIZATION_NAME": "Your organization name is missing.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_PERSON_NAME": "The document you submitted is missing a first and/or last name.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_UNIVERSITY_ENROLLMENT": "The document you submitted does not prove enrollment in the current term.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_OR_MISMATCH_JOB_TITLE": "The job title on the document you submitted is missing or does not match what you entered on the verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_FIRST_NAME": "Your first name is missing.",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_LAST_NAME": "Your last name is missing.",
  "defaultMessages.step.docUpload.rejectionReasons.ORGANIZATION_NAME_OTHER": "The document is insufficient for establishing eligibility for this offer",
  "defaultMessages.step.docUpload.rejectionReasons.OTHER_CONTACT_US": "We are having problems verifying your eligibility for the offer. Please contact SheerID customer service for help: customerservice@sheerid.com",
  "defaultMessages.step.docUpload.rejectionReasons.OUT_OF_RANGE_BIRTHDATE": "Your birthdate is outside the acceptable range of this offer. ",
  "defaultMessages.step.docUpload.rejectionReasons.PAYSTUB_OUTDATED_LAST_30_DAYS": "Please upload a paystub that was issued within the last 30 days.",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_BIRTHDATE_OTHER": "The document is insufficient for establishing eligibility for this offer",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIELD_MISMATCH": "A field in the document provided did not match with what was provided on the verification form.",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIRST_NAME_OTHER": "The document is insufficient for establishing eligibility for this offer",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_LAST_NAME_OTHER": "The document is insufficient for establishing eligibility for this offer",
  "defaultMessages.step.docUpload.submitButtonLabel": "Continue",
  "defaultMessages.step.docUpload.uploadInfo.affiliation": "Your current affiliation with that organization",
  "defaultMessages.step.docUpload.uploadInfo.age.birthDate": "Your date of birth",
  "defaultMessages.step.docUpload.uploadInfo.employment.company": "Your company",
  "defaultMessages.step.docUpload.uploadInfo.employment.currentAffiliation": "Your current affiliation with that company",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.currentAffiliation": "Your current affiliation with that organization",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.license": "Your status or license as a First Responder",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.organization": "Your organization",
  "defaultMessages.step.docUpload.uploadInfo.fullName": "Your full name",
  "defaultMessages.step.docUpload.uploadInfo.identity.validDate": "A currently valid date",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.licenseStatus": "Your professional license and/or certification status",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.validDate": "A currently valid date",
  "defaultMessages.step.docUpload.uploadInfo.medical.status": "Your medical professional status",
  "defaultMessages.step.docUpload.uploadInfo.medical.validDate": "A currently valid date",
  "defaultMessages.step.docUpload.uploadInfo.military.currentAffiliation": "Your current affiliation with the armed services",
  "defaultMessages.step.docUpload.uploadInfo.military.dischargeDate": "Your discharge date (if applicable)",
  "defaultMessages.step.docUpload.uploadInfo.military.serviceBranch": "Your branch of service",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsDependent": "Please upload a Dependent ID card that clearly shows your first name, last name, valid dates and status",
  "defaultMessages.step.docUpload.uploadInfo.organization": "Your organization",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.address": "Your new address",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.validDate": "A valid date for your recent move",
  "defaultMessages.step.docUpload.uploadInfo.senior.birthDate": "Your date of birth",
  "defaultMessages.step.docUpload.uploadInfo.student.enrollmentDate": "Date proving enrollment for the current term (or within the last 3 months)",
  "defaultMessages.step.docUpload.uploadInfo.student.school": "Your school",
  "defaultMessages.step.docUpload.uploadInfo.teacher.currentSchoolYear": "A date in the current school year",
  "defaultMessages.step.docUpload.uploadInfo.teacher.school": "Your school",
  "defaultMessages.step.emailLoop.errors.resend": "Error sending email",
  "defaultMessages.step.emailLoop.resendButton": "Re-send",
  "defaultMessages.step.emailLoop.skipEmail": "Unable to retrieve this email? Click ",
  "defaultMessages.step.emailLoop.skipEmail2": " to proceed.",
  "defaultMessages.step.emailLoop.skipEmailCTA": "here",
  "defaultMessages.step.emailLoop.subtitle2": "Please check for an email from us (verify@sheerid.com) for all the details.",
  "defaultMessages.step.emailLoop.subtitleWithEmail": "An email has been sent to {email} with a personalized link to complete the verification process.",
  "defaultMessages.step.emailLoop.subtitleWithoutEmail": "An email has been sent to your email account with a personalized link to complete the verification process.",
  "defaultMessages.step.emailLoop.successResend": "Email re-sent successfully.",
  "defaultMessages.step.emailLoop.title": "Check your email",
  "defaultMessages.step.error.errorId.expiredProgram.buttonText": "See More Offers",
  "defaultMessages.step.error.errorId.expiredProgram.title": "Offer Sold Out!",
  "defaultMessages.step.error.errorId.inactiveProgram.buttonText": "See More Offers",
  "defaultMessages.step.error.errorId.inactiveProgram.title": "Offer Sold Out!",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.buttonText": "See More Offers",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.title": "Offer Sold Out!",
  "defaultMessages.step.error.errorId.verificationLimitExceeded.title": "Verification Limit Exceeded",
  "defaultMessages.step.pending.docDiffLang": "We identified your document is in a different language.",
  "defaultMessages.step.pending.subtitle": "SheerID is reviewing your documents, to confirm your status. This process may take up to {maxReviewTime}.",
  "defaultMessages.step.pending.subtitle2": "Wait here or let us notify you of the outcome.",
  "defaultMessages.step.pending.subtitle3": "You will be contacted via email.",
  "defaultMessages.step.pending.subtitleAlt": "SheerID is reviewing your documents, to confirm your status.",
  "defaultMessages.step.pending.subtitleCountdown": "Hang tight while we upload and scan your documents.",
  "defaultMessages.step.pending.titleCountdown": "Processing",
  "defaultMessages.step.pending.titleReview": "Reviewing",
  "defaultMessages.step.pending.turnaroundTime": "Turnaround time for your language is typically {estReviewTime}, and in rare times of high volume may take up to {maxReviewTime}.",
  "defaultMessages.step.personalInfo.verifyingSubtitle": "This should only take a minute",
  "defaultMessages.step.personalInfo.verifyingTitle": "Verifying your status",
  "defaultMessages.step.smsLoop.errors.codeExpired": "Verification code could not be validated.",
  "defaultMessages.step.smsLoop.errors.codeResendLimit": "Maximum number of re-tries has been reached.",
  "defaultMessages.step.smsLoop.errors.codeVerification": "Verification code could not be validated.",
  "defaultMessages.step.smsLoop.errors.resend": "Error sending the SMS message",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber1": "Incorrect number? Click ",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber2": "here ",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber3": "to return to {companyName}",
  "defaultMessages.step.smsLoop.resendButton": "Re-send",
  "defaultMessages.step.smsLoop.submitButton": "Submit",
  "defaultMessages.step.smsLoop.successResend": "SMS message re-sent successfully",
  "defaultMessages.step.smsLoop.titleWithNumber": "We've sent an SMS message to the mobile number ending in {number}. Enter your code here.",
  "defaultMessages.step.smsLoop.titleWithoutNumber": "We've sent an SMS to your mobile number. Please enter the code here.",
  "defaultMessages.step.smsLoop.verificationCode": "Verification Code",
  "defaultMessages.step.sso.cancel": "Upload documents",
  "defaultMessages.step.sso.login": "Sign in to my school",
  "defaultMessages.step.sso.subtitle": "Please sign in to your school's web portal. It will open in a new tab.",
  "defaultMessages.step.sso.subtitle2": "Can't sign in to your email?",
  "defaultMessages.step.sso.title": "Verify using your school credentials",
  "defaultMessages.step.success.copyCouponCode": "Copy Coupon code",
  "defaultMessages.step.success.emailNotification": "We have emailed you a copy so you can use your new code now or later. Look for the email from verify@sheerid.com.",
  "defaultMessages.step.success.verificationOnly": "\n                SheerID handles verification only.\n                Now that you've been approved, please direct all questions about the\n                promotion terms and/or code use to {companyName} customer service.\n            ",
  "defaultMessages.studentInfoShared": "Information entered here will be used for verification purposes and shared with {companyName}. ",
  "defaultMessages.tryAgain": "Try again",
  "defaultMessages.universityName": "University name",
  "defaultMessages.verificationPurposesOnly": "Used for verification purposes only",
  "defaultMessages.verifyAndContinue": "Verify and continue",
  "defaultMessages.verifyMyEmploymentStatus": "Verify My Employee Status",
  "defaultMessages.verifyMyFirstResponderStatus": "Verify My First Responder Status",
  "defaultMessages.verifyMyIdentityStatus": "Verify My Identity",
  "defaultMessages.verifyMyLicensedProfessionalStatus": "Verify My Licensed Professional Status",
  "defaultMessages.verifyMyMedicalProfessionalStatus": "Verify My Medical Professional Status",
  "defaultMessages.verifyMyMembershipStatus": "Verify My Membership Status",
  "defaultMessages.verifyMyMilitaryStatus": "Verify My Military Status",
  "defaultMessages.verifyMyMoverStatus": "Verify My New Mover Status",
  "defaultMessages.verifyMyStudentStatus": "Verify My Student Status",
  "defaultMessages.verifyMyTeacherStatus": "Verify My Teacher Status",
  "requestOrganizationMessages.changeLanguage": "Change language",
  "requestOrganizationMessages.completeRequest": "Don't see your school in the list of eligible or ineligible schools? Complete your request",
  "requestOrganizationMessages.copied": "Copied",
  "requestOrganizationMessages.country": "Where do you go to school?",
  "requestOrganizationMessages.description": "Please fill out the form below. Schools submitted are not guaranteed to be added, but all requests are researched and considered by SheerID.",
  "requestOrganizationMessages.eligibleOrgs": "Eligible schools. Click the icon to copy name then return to the verification form:",
  "requestOrganizationMessages.errorId.invalidCountry": "Field is required",
  "requestOrganizationMessages.errorId.invalidEmail": "Invalid Email",
  "requestOrganizationMessages.errorId.invalidField": "Field is invalid",
  "requestOrganizationMessages.errorId.invalidFirstName": "Invalid first name",
  "requestOrganizationMessages.errorId.invalidLastName": "Invalid last name",
  "requestOrganizationMessages.errorId.invalidUrl": "Invalid URL",
  "requestOrganizationMessages.errorId.requiredField": "Field is required",
  "requestOrganizationMessages.errorId.tooManyResults": "Your search returned too many results, please refine your search and try again",
  "requestOrganizationMessages.faq": "SheerID Add School Request FAQ",
  "requestOrganizationMessages.fields.countryPlaceholder": "Select Country",
  "requestOrganizationMessages.fields.domainLabel": "School website",
  "requestOrganizationMessages.fields.domainPlaceholder": "www.myschool.edu",
  "requestOrganizationMessages.fields.orgNameLabel": "School name",
  "requestOrganizationMessages.fields.orgNamePlaceholder": "My school",
  "requestOrganizationMessages.ineligibleOrgs": "Ineligible Schools. We are sorry, people from these schools are not eligible for this offer:",
  "requestOrganizationMessages.noCountry": "Don't see your school’s country or region? You are not eligible for this offer.",
  "requestOrganizationMessages.none": "None",
  "requestOrganizationMessages.poweredBy": "Verification services powered by SheerID",
  "requestOrganizationMessages.searchByOrgName": "Don't see your school? Search by name.",
  "requestOrganizationMessages.step.error.contactUs": "contact us",
  "requestOrganizationMessages.step.error.description": "Sorry we are not able to process your request. Please try again later.",
  "requestOrganizationMessages.step.error.seeingProblem": "If you keep seeing this problem <a class='sid-link' href='{feedbackUrl}&pid={programId}' target='_blank'>contact us</a>.",
  "requestOrganizationMessages.step.error.title": "An unexpected error occurred",
  "requestOrganizationMessages.step.success.description": "As a reminder, each request is evaluated by SheerID against the requirements set by this offer. There is no guarantee that your school will be added. The evaluation process takes up to 7 business days.",
  "requestOrganizationMessages.step.success.title": "Thank you for submitting your school request",
  "requestOrganizationMessages.submit": "Submit",
  "requestOrganizationMessages.title": "Request to Add School",
  "segmentMessages.age.emailExplanation": "Needed to send you your unique code",
  "segmentMessages.age.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying age.\n            <br><br>\n            Documents are used only for verifying your current age and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
  "segmentMessages.age.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.age.step.docUpload.title": "We need your license or passport",
  "segmentMessages.age.step.docUpload.uploadInstructions": "Upload a government-issued document that shows",
  "segmentMessages.age.step.personalInfo.howDoesVerifyingWorkDetails": "\n            To be eligible for this offer, you must be of a certain age.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify your age. SheerID only collects information that assists in\n            verifying your eligibility. Additional information or documentation may be requested.",
  "segmentMessages.age.step.personalInfo.subtitle": "Verify your current age.",
  "segmentMessages.age.step.personalInfo.title": "Unlock Your Special Offer",
  "segmentMessages.age.step.personalInfo.tryAgain.subtitle": "Your full name and birthdate must match what is on your government-issued documents.",
  "segmentMessages.age.step.personalInfo.tryAgain.title": "Check Your Name & Birthdate",
  "segmentMessages.age.step.personalInfo.verifyingTitle": "Verifying your age",
  "segmentMessages.age.step.success.redirectButtonText": "Use code now",
  "segmentMessages.age.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.age.step.success.title": "You've been verified",
  "segmentMessages.employment.emailExplanation": "Use your work email if you have one",
  "segmentMessages.employment.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying employees.\n            <br><br>\n            Documents are used only for verify your employment status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
  "segmentMessages.employment.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.employment.step.docUpload.title": "We need more information",
  "segmentMessages.employment.step.docUpload.uploadInstructions": "Upload an official document that shows",
  "segmentMessages.employment.step.personalInfo.howDoesVerifyingWorkDetails": "{companyName} has set up this special offer for all current employees of select companies.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are currently employed. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
  "segmentMessages.employment.step.personalInfo.subtitle": "Verify you're a current employee at an eligible company.",
  "segmentMessages.employment.step.personalInfo.title": "Unlock this Employment-Only Offer",
  "segmentMessages.employment.step.personalInfo.tryAgain.subtitle": "The information you have provided should match your official documents.",
  "segmentMessages.employment.step.personalInfo.tryAgain.title": "Check the information that you have provided",
  "segmentMessages.employment.step.personalInfo.verifyingTitle": "Verifying your employment status",
  "segmentMessages.employment.step.sso.cancel": "Upload proof of employment",
  "segmentMessages.employment.step.sso.login": "Sign in to my email",
  "segmentMessages.employment.step.sso.subtitle": "Please sign in to your company's email portal. It will open in a new tab.",
  "segmentMessages.employment.step.sso.subtitle2": "Can't sign in to your email?",
  "segmentMessages.employment.step.sso.title": "Verify using your company-provided email credentials",
  "segmentMessages.employment.step.success.redirectButtonText": "Use code now",
  "segmentMessages.employment.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.employment.step.success.title": "You've been verified",
  "segmentMessages.firstResponder.emailExplanation": "Needed to send you your unique code",
  "segmentMessages.firstResponder.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying first responders.\n            <br><br>\n            Documents are used only for verifying your first responder status is current and will be permanently deleted after review is finalized.\n            They will not be shared with {companyName}",
  "segmentMessages.firstResponder.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.firstResponder.step.docUpload.title": "We need your ID",
  "segmentMessages.firstResponder.step.docUpload.uploadInstructions": "Upload an official document that shows",
  "segmentMessages.firstResponder.step.personalInfo.howDoesVerifyingWorkDetails": "\n            This offer is available to all US first responders and emergency personnel - including law enforcement,\n            EMTs, paramedics, and firefighters.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are an active first responder. SheerID\n            only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
  "segmentMessages.firstResponder.step.personalInfo.subtitle": "Verify you're an active first responder.",
  "segmentMessages.firstResponder.step.personalInfo.title": "Unlock this 1st Responder-Only Offer",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.subtitle": "Your full name, organization name, and email must match what is on record with your agency.",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.title": "Check Your Name, Email & Organization",
  "segmentMessages.firstResponder.step.personalInfo.verifyingTitle": "Verifying your first responder status",
  "segmentMessages.firstResponder.step.success.redirectButtonText": "Use code now",
  "segmentMessages.firstResponder.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.firstResponder.step.success.title": "You've been verified",
  "segmentMessages.identity.emailExplanation": "Needed to send you your unique code",
  "segmentMessages.identity.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying identity.\n            <br><br>\n            Documents are used only for verifying your current eligibility and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
  "segmentMessages.identity.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.identity.step.docUpload.title": "We need your driver license",
  "segmentMessages.identity.step.docUpload.uploadInstructions": "Upload a government-issued document that shows",
  "segmentMessages.identity.step.personalInfo.howDoesVerifyingWorkDetails": "\n            To be eligible for this offer, you must have a valid driver license.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify your identity. SheerID only collects information that assists in\n            verifying your eligibility. Additional information or documentation may be requested.",
  "segmentMessages.identity.step.personalInfo.subtitle": "Verify your current identity.",
  "segmentMessages.identity.step.personalInfo.title": "Unlock Your Special Offer",
  "segmentMessages.identity.step.personalInfo.tryAgain.subtitle": "Your information must match what is on your government-issued document(s).",
  "segmentMessages.identity.step.personalInfo.tryAgain.title": "Check Your Name & other fields",
  "segmentMessages.identity.step.personalInfo.verifyingTitle": "Verifying your identity",
  "segmentMessages.identity.step.success.redirectButtonText": "Use code now",
  "segmentMessages.identity.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.identity.step.success.title": "You've been verified",
  "segmentMessages.licensedProfessional.emailExplanation": "Needed to send you your unique code",
  "segmentMessages.licensedProfessional.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying licensed professionals.\n            <br><br>\n            Documents are used only for verifying your licensure or certification status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
  "segmentMessages.licensedProfessional.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.licensedProfessional.step.docUpload.title": "We need your professional license or certificate",
  "segmentMessages.licensedProfessional.step.docUpload.uploadInstructions": "Upload a government-issued document that shows",
  "segmentMessages.licensedProfessional.step.personalInfo.howDoesVerifyingWorkDetails": "\n            To be eligible for this offer, you must hold a current professional license in your specified field. Eligible fields are shown in the Status selector of this form.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are a licensed professional.\n            SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
  "segmentMessages.licensedProfessional.step.personalInfo.subtitle": "\"Verify you have a professional license in your field.",
  "segmentMessages.licensedProfessional.step.personalInfo.title": "Unlock this Special Offer",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.subtitle": "Your information must match what is on your government-issued document(s).",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.title": "Check Your Name & other fields",
  "segmentMessages.licensedProfessional.step.personalInfo.verifyingTitle": "Verifying your license",
  "segmentMessages.licensedProfessional.step.success.redirectButtonText": "Use code now",
  "segmentMessages.licensedProfessional.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.licensedProfessional.step.success.title": "You've been verified",
  "segmentMessages.medical.emailExplanation": "Use your work email if you have one",
  "segmentMessages.medical.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying\n                    medical professionals.<br><br>Documents are used only for verifying your medical professional status is\n                    current and will be permanently deleted after review is finalized. They will not be shared with {companyName}.",
  "segmentMessages.medical.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.medical.step.docUpload.title": "We need more information",
  "segmentMessages.medical.step.docUpload.uploadInstructions": "Upload an official document that shows",
  "segmentMessages.medical.step.personalInfo.howDoesVerifyingWorkDetails": "To be eligible for this offer, you must (1) be a medical professional currently licensed in the United States\n                    and (2) be a member of an eligible branch of the medical profession. Eligible branches are shown in the Status\n                    selector of this form.<br><br>{companyName} uses SheerID, a trusted partner, to verify that you are a medical professional.\n                    SheerID only collects information that assists in verifying your eligibility.\n                    Additional information or documentation may be requested.",
  "segmentMessages.medical.step.personalInfo.subtitle": "Verify you're a licensed medical professional.",
  "segmentMessages.medical.step.personalInfo.title": "Unlock this Medical Professional-Only Offer",
  "segmentMessages.medical.step.personalInfo.tryAgain.subtitle": "Your first and last name, birthdate and organization must match what is on your official documents.",
  "segmentMessages.medical.step.personalInfo.tryAgain.title": "Check your Name, Birthdate & Organization",
  "segmentMessages.medical.step.personalInfo.verifyingTitle": "Verifying your medical professional status",
  "segmentMessages.medical.step.sso.login": "Sign into my employer web portal",
  "segmentMessages.medical.step.sso.subtitle": "Please sign into your employer's web portal. It will open in a new tab.",
  "segmentMessages.medical.step.sso.title": "Verify your Healthcare status",
  "segmentMessages.medical.step.success.redirectButtonText": "Use code now",
  "segmentMessages.medical.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.medical.step.success.title": "You've been verified",
  "segmentMessages.member.emailExplanation": "Needed to send you your unique code",
  "segmentMessages.member.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying members.\n            <br><br>\n            Documents are used only to verify that your membership status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
  "segmentMessages.member.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.member.step.docUpload.title": "We need more information",
  "segmentMessages.member.step.docUpload.uploadInstructions": "Upload an official document that shows",
  "segmentMessages.member.step.personalInfo.howDoesVerifyingWorkDetails": "{companyName} has set up this special offer for all current members of select organizations.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are currently employed. SheerID only collects\n            information that assists in verifying your eligibility. Additional information or documentation may be requested.",
  "segmentMessages.member.step.personalInfo.subtitle": "Verify you're a current member of an eligible organization.",
  "segmentMessages.member.step.personalInfo.title": "Unlock this Members-Only Offer",
  "segmentMessages.member.step.personalInfo.tryAgain.subtitle": "The information you have provided should match your official documents.",
  "segmentMessages.member.step.personalInfo.tryAgain.title": "Check the information that you have provided",
  "segmentMessages.member.step.personalInfo.verifyingTitle": "Verifying your membership status",
  "segmentMessages.member.step.success.redirectButtonText": "Use code now",
  "segmentMessages.member.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.member.step.success.title": "You've been verified",
  "segmentMessages.military.emailExplanation": "Personal email address is recommended",
  "segmentMessages.military.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying military.\n            <br><br>\n            Documents are used only for verifying your military status is current and will be permanently deleted after review is finalized.\n            They will not be shared with {companyName}",
  "segmentMessages.military.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.military.step.docUpload.title": "We need more information",
  "segmentMessages.military.step.docUpload.uploadInstructions": "Upload your government-issued document that shows:",
  "segmentMessages.military.step.personalInfo.howDoesVerifyingWorkDetails": "\n            This offer is available to military personnel who have served or are currently serving in the United States Armed Forces.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are a member of the military. SheerID only collects information\n            that assists in verifying your eligibility. Additional information or documentation may be requested.",
  "segmentMessages.military.step.personalInfo.subtitle": "Verify you're a member of the armed forces.",
  "segmentMessages.military.step.personalInfo.title": "Unlock this Military-Only Offer",
  "segmentMessages.military.step.personalInfo.tryAgain.subtitle": "Enter your first and last name on the form as it appears on your military document(s). Keep in mind that may be your given name.",
  "segmentMessages.military.step.personalInfo.tryAgain.title": "Check Your Name & Birthdate",
  "segmentMessages.military.step.personalInfo.verifyingTitle": "Verifying your military status",
  "segmentMessages.military.step.success.redirectButtonText": "Use code now",
  "segmentMessages.military.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.military.step.success.title": "You've been verified",
  "segmentMessages.recentMover.emailExplanation": "Needed to send you your unique code",
  "segmentMessages.recentMover.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying recent movers.\n                <br/><br/>\n                Documents are used only for verifying that you've recently moved and will will be permanently deleted after review is finalized. They will not be shared with {companyName}.",
  "segmentMessages.recentMover.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.recentMover.step.docUpload.title": "We need some more info",
  "segmentMessages.recentMover.step.docUpload.uploadInstructions": "Upload an official document that shows",
  "segmentMessages.recentMover.step.personalInfo.howDoesVerifyingWorkDetails": "\n                To be eligible for this offer, you must have moved to a new address within the last 60 days.\n                <br><br>\n                {companyName} uses SheerID, a trusted partner, to verify that you have recently moved. SheerID only\n                collects information that assists in verifying your eligibility.\n                Additional information or documentation may be requested.",
  "segmentMessages.recentMover.step.personalInfo.subtitle": "Verify you have recently moved.",
  "segmentMessages.recentMover.step.personalInfo.title": "Unlock this Special Offer",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.subtitle": "Your first and last name and address must match what is on your official documents.",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.title": "Check Your Name & Address Information",
  "segmentMessages.recentMover.step.personalInfo.verifyingTitle": "Verifying your moving status",
  "segmentMessages.recentMover.step.success.redirectButtonText": "Use code now",
  "segmentMessages.recentMover.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.recentMover.step.success.title": "You've been verified",
  "segmentMessages.senior.emailExplanation": "Needed to send you your unique code",
  "segmentMessages.senior.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying age.\n            <br><br>\n            Documents are used only for verifying your current age and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
  "segmentMessages.senior.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.senior.step.docUpload.title": "We need your license or passport",
  "segmentMessages.senior.step.docUpload.uploadInstructions": "Upload a government-issued document that shows",
  "segmentMessages.senior.step.personalInfo.howDoesVerifyingWorkDetails": "\n            To be eligible for this offer, you must be of a certain age.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify your age. SheerID only collects information that assists in\n            verifying your eligibility. Additional information or documentation may be requested.",
  "segmentMessages.senior.step.personalInfo.subtitle": "Verify your current age.",
  "segmentMessages.senior.step.personalInfo.title": "Unlock Your Special Offer",
  "segmentMessages.senior.step.personalInfo.tryAgain.subtitle": "Your full name and birthdate must match what is on your government-issued documents.",
  "segmentMessages.senior.step.personalInfo.tryAgain.title": "Check Your Name & Birthdate",
  "segmentMessages.senior.step.personalInfo.verifyingTitle": "Verifying your age",
  "segmentMessages.senior.step.success.redirectButtonText": "Use code now",
  "segmentMessages.senior.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.senior.step.success.title": "You've been verified",
  "segmentMessages.student.emailExplanation": "Needed to send you your unique code",
  "segmentMessages.student.schoolName": "University / college name",
  "segmentMessages.student.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying students.\n                <br/><br/>\n                Documents are used only for verifying your student status is current and will be permanently deleted after review is finalized.",
  "segmentMessages.student.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.student.step.docUpload.title": "We need your ID & class schedule",
  "segmentMessages.student.step.docUpload.uploadInstructions": "Upload your school-issued document that shows",
  "segmentMessages.student.step.personalInfo.howDoesVerifyingWorkDetails": "\n                To be eligible for this offer, you must currently be enrolled in a degree\n                or certificate-granting, accredited school of education.\n                <br><br>\n                {companyName} uses SheerID, a trusted partner, to verify that you are a current student. SheerID only\n                collects information that assists in verifying your eligibility.\n                Additional information or documentation may be requested.",
  "segmentMessages.student.step.personalInfo.subtitle": "Verify you're a student at a degree-granting school.",
  "segmentMessages.student.step.personalInfo.title": "Unlock this Student-Only Offer",
  "segmentMessages.student.step.personalInfo.tryAgain.subtitle": "Your full name and birthdate must match what is on your official school records.",
  "segmentMessages.student.step.personalInfo.tryAgain.title": "Check Your Name & Birthdate",
  "segmentMessages.student.step.personalInfo.verifyingTitle": "Verifying your student status",
  "segmentMessages.student.step.sso.cancel": "Upload Proof of Enrollment",
  "segmentMessages.student.step.success.redirectButtonText": "Use code now",
  "segmentMessages.student.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.student.step.success.title": "You've been verified",
  "segmentMessages.teacher.emailExplanation": "Must be your school-issued email address",
  "segmentMessages.teacher.schoolName": "School name",
  "segmentMessages.teacher.step.docUpload.howDoesVerifyingWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying teachers.\n                <br><br>\n                Documents are used only for verifying your teacher or faculty status is current and will be permanently\n                deleted after review is finalized. They will not be shared with {companyName}",
  "segmentMessages.teacher.step.docUpload.subtitle": "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
  "segmentMessages.teacher.step.docUpload.title": "We need more information",
  "segmentMessages.teacher.step.docUpload.uploadInstructions": "Upload your school-issued document that shows",
  "segmentMessages.teacher.step.personalInfo.howDoesVerifyingWorkDetails": "\n            To be eligible for this offer, you must currently be employed as a teacher, faculty or staff at a K-12\n            school or university in the United States.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are a current teacher, faculty or staff\n            member. SheerID only collects information that assists in verifying your eligibility. Additional information\n            or documentation may be requested.",
  "segmentMessages.teacher.step.personalInfo.subtitle": "Verify you're a teacher, faculty or staff at a K-12 or degree-granting university.",
  "segmentMessages.teacher.step.personalInfo.title": "Unlock this Teaching Staff-Only Offer",
  "segmentMessages.teacher.step.personalInfo.tryAgain.subtitle": "Your full name and email address must match what is on record with your school.",
  "segmentMessages.teacher.step.personalInfo.tryAgain.title": "Check Your Name & Email",
  "segmentMessages.teacher.step.personalInfo.verifyingTitle": "Verifying your teacher status",
  "segmentMessages.teacher.step.success.redirectButtonText": "Use code now",
  "segmentMessages.teacher.step.success.subtitle": "Here is your personal coupon code. It is unique to you and can only be used once.",
  "segmentMessages.teacher.step.success.title": "You've been verified"
};

var prepareMsgsModule = function prepareMsgsModule(localizedMessages) {
  var nonEmptyMessages = Object.keys(localizedMessages).reduce(function (messages, currentKey) {
    if (localizedMessages[currentKey]) {
      messages[currentKey] = localizedMessages[currentKey]; // eslint-disable-line
    }

    return messages;
  }, {});
  return flat_1.unflatten(nonEmptyMessages);
};
/**
 * @private
 * NOTE: webpack will not import chunks recursively, or with more than one variable in the path.
 * Here we're using a fully statically-defined import, for reliability.
 */


var getMessagesModuleByLocale = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(locale) {
    var localizedMessages;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.t0 = locale;
            _context9.next = _context9.t0 === 'ar' ? 3 : _context9.t0 === 'bg' ? 7 : _context9.t0 === 'cs' ? 11 : _context9.t0 === 'da' ? 15 : _context9.t0 === 'de' ? 19 : _context9.t0 === 'el' ? 23 : _context9.t0 === 'en-GB' ? 27 : _context9.t0 === 'en-US' ? 31 : _context9.t0 === 'es-ES' ? 33 : _context9.t0 === 'es' ? 37 : _context9.t0 === 'fi' ? 41 : _context9.t0 === 'fr-CA' ? 45 : _context9.t0 === 'fr' ? 49 : _context9.t0 === 'ga' ? 53 : _context9.t0 === 'hr' ? 57 : _context9.t0 === 'hu' ? 61 : _context9.t0 === 'id' ? 65 : _context9.t0 === 'it' ? 69 : _context9.t0 === 'iw' ? 73 : _context9.t0 === 'ja' ? 77 : _context9.t0 === 'ko' ? 81 : _context9.t0 === 'lo' ? 85 : _context9.t0 === 'lt' ? 89 : _context9.t0 === 'ms' ? 93 : _context9.t0 === 'nl' ? 97 : _context9.t0 === 'no' ? 101 : _context9.t0 === 'pl' ? 105 : _context9.t0 === 'pt-BR' ? 109 : _context9.t0 === 'pt' ? 113 : _context9.t0 === 'ru' ? 117 : _context9.t0 === 'sk' ? 121 : _context9.t0 === 'sl' ? 125 : _context9.t0 === 'sr' ? 129 : _context9.t0 === 'sv' ? 133 : _context9.t0 === 'th' ? 137 : _context9.t0 === 'tr' ? 141 : _context9.t0 === 'zh-HK' ? 145 : _context9.t0 === 'zh' ? 149 : 153;
            break;

          case 3:
            _context9.next = 5;
            return import(
            /* webpackChunkName: "messages_ar" */
            './es6/ar-45218d09.es.js').then(function (m) {
              return m.default;
            });

          case 5:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 7:
            _context9.next = 9;
            return import(
            /* webpackChunkName: "messages_bg" */
            './es6/bg-9fc8dc83.es.js').then(function (m) {
              return m.default;
            });

          case 9:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 11:
            _context9.next = 13;
            return import(
            /* webpackChunkName: "messages_cs" */
            './es6/cs-405794db.es.js').then(function (m) {
              return m.default;
            });

          case 13:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 15:
            _context9.next = 17;
            return import(
            /* webpackChunkName: "messages_da" */
            './es6/da-aa14f8b8.es.js').then(function (m) {
              return m.default;
            });

          case 17:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 19:
            _context9.next = 21;
            return import(
            /* webpackChunkName: "messages_de" */
            './es6/de-85ee9944.es.js').then(function (m) {
              return m.default;
            });

          case 21:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 23:
            _context9.next = 25;
            return import(
            /* webpackChunkName: "messages_el" */
            './es6/el-578ba48b.es.js').then(function (m) {
              return m.default;
            });

          case 25:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 27:
            _context9.next = 29;
            return import(
            /* webpackChunkName: "messages_en-GB" */
            './es6/en-GB-f4994296.es.js').then(function (m) {
              return m.default;
            });

          case 29:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 31:
            localizedMessages = enUSMessages;
            return _context9.abrupt("break", 155);

          case 33:
            _context9.next = 35;
            return import(
            /* webpackChunkName: "messages_es-ES" */
            './es6/es-ES-356fb969.es.js').then(function (m) {
              return m.default;
            });

          case 35:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 37:
            _context9.next = 39;
            return import(
            /* webpackChunkName: "messages_es" */
            './es6/es-00de3342.es.js').then(function (m) {
              return m.default;
            });

          case 39:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 41:
            _context9.next = 43;
            return import(
            /* webpackChunkName: "messages_fi" */
            './es6/fi-fb16dee9.es.js').then(function (m) {
              return m.default;
            });

          case 43:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 45:
            _context9.next = 47;
            return import(
            /* webpackChunkName: "messages_fr-CA" */
            './es6/fr-CA-0d541b88.es.js').then(function (m) {
              return m.default;
            });

          case 47:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 49:
            _context9.next = 51;
            return import(
            /* webpackChunkName: "messages_fr" */
            './es6/fr-f339b695.es.js').then(function (m) {
              return m.default;
            });

          case 51:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 53:
            _context9.next = 55;
            return import(
            /* webpackChunkName: "messages_ga" */
            './es6/ga-2ef75556.es.js').then(function (m) {
              return m.default;
            });

          case 55:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 57:
            _context9.next = 59;
            return import(
            /* webpackChunkName: "messages_hr" */
            './es6/hr-9ea6b84e.es.js').then(function (m) {
              return m.default;
            });

          case 59:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 61:
            _context9.next = 63;
            return import(
            /* webpackChunkName: "messages_hu" */
            './es6/hu-f8d0f7b3.es.js').then(function (m) {
              return m.default;
            });

          case 63:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 65:
            _context9.next = 67;
            return import(
            /* webpackChunkName: "messages_id" */
            './es6/id-20cc43df.es.js').then(function (m) {
              return m.default;
            });

          case 67:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 69:
            _context9.next = 71;
            return import(
            /* webpackChunkName: "messages_it" */
            './es6/it-6e1647cb.es.js').then(function (m) {
              return m.default;
            });

          case 71:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 73:
            _context9.next = 75;
            return import(
            /* webpackChunkName: "messages_iw" */
            './es6/iw-9da3d502.es.js').then(function (m) {
              return m.default;
            });

          case 75:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 77:
            _context9.next = 79;
            return import(
            /* webpackChunkName: "messages_ja" */
            './es6/ja-fdb63bed.es.js').then(function (m) {
              return m.default;
            });

          case 79:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 81:
            _context9.next = 83;
            return import(
            /* webpackChunkName: "messages_ko" */
            './es6/ko-600681df.es.js').then(function (m) {
              return m.default;
            });

          case 83:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 85:
            _context9.next = 87;
            return import(
            /* webpackChunkName: "messages_lo" */
            './es6/lo-b13786ca.es.js').then(function (m) {
              return m.default;
            });

          case 87:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 89:
            _context9.next = 91;
            return import(
            /* webpackChunkName: "messages_lt" */
            './es6/lt-86bcff40.es.js').then(function (m) {
              return m.default;
            });

          case 91:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 93:
            _context9.next = 95;
            return import(
            /* webpackChunkName: "messages_ms" */
            './es6/ms-6cf76c5f.es.js').then(function (m) {
              return m.default;
            });

          case 95:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 97:
            _context9.next = 99;
            return import(
            /* webpackChunkName: "messages_nl" */
            './es6/nl-1840217b.es.js').then(function (m) {
              return m.default;
            });

          case 99:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 101:
            _context9.next = 103;
            return import(
            /* webpackChunkName: "messages_no" */
            './es6/no-39cdc2f9.es.js').then(function (m) {
              return m.default;
            });

          case 103:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 105:
            _context9.next = 107;
            return import(
            /* webpackChunkName: "messages_pl" */
            './es6/pl-61f6449b.es.js').then(function (m) {
              return m.default;
            });

          case 107:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 109:
            _context9.next = 111;
            return import(
            /* webpackChunkName: "messages_pt-BR" */
            './es6/pt-BR-b8d159b3.es.js').then(function (m) {
              return m.default;
            });

          case 111:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 113:
            _context9.next = 115;
            return import(
            /* webpackChunkName: "messages_pt" */
            './es6/pt-5fd522ff.es.js').then(function (m) {
              return m.default;
            });

          case 115:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 117:
            _context9.next = 119;
            return import(
            /* webpackChunkName: "messages_ru" */
            './es6/ru-5b8abbc8.es.js').then(function (m) {
              return m.default;
            });

          case 119:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 121:
            _context9.next = 123;
            return import(
            /* webpackChunkName: "messages_sk" */
            './es6/sk-e1b4e309.es.js').then(function (m) {
              return m.default;
            });

          case 123:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 125:
            _context9.next = 127;
            return import(
            /* webpackChunkName: "messages_sl" */
            './es6/sl-bfb1e97c.es.js').then(function (m) {
              return m.default;
            });

          case 127:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 129:
            _context9.next = 131;
            return import(
            /* webpackChunkName: "messages_sr" */
            './es6/sr-55cd6511.es.js').then(function (m) {
              return m.default;
            });

          case 131:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 133:
            _context9.next = 135;
            return import(
            /* webpackChunkName: "messages_sv" */
            './es6/sv-65116117.es.js').then(function (m) {
              return m.default;
            });

          case 135:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 137:
            _context9.next = 139;
            return import(
            /* webpackChunkName: "messages_th" */
            './es6/th-152afbae.es.js').then(function (m) {
              return m.default;
            });

          case 139:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 141:
            _context9.next = 143;
            return import(
            /* webpackChunkName: "messages_tr" */
            './es6/tr-85a3c50d.es.js').then(function (m) {
              return m.default;
            });

          case 143:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 145:
            _context9.next = 147;
            return import(
            /* webpackChunkName: "messages_zh-HK" */
            './es6/zh-HK-2ded2e8e.es.js').then(function (m) {
              return m.default;
            });

          case 147:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 149:
            _context9.next = 151;
            return import(
            /* webpackChunkName: "messages_zh" */
            './es6/zh-c84d40ec.es.js').then(function (m) {
              return m.default;
            });

          case 151:
            localizedMessages = _context9.sent;
            return _context9.abrupt("break", 155);

          case 153:
            logger.warn("getMessagesModuleByLocale: Unable to load messages for ".concat(locale, ", falling back to en-US"));
            localizedMessages = enUSMessages;

          case 155:
            return _context9.abrupt("return", prepareMsgsModule(localizedMessages));

          case 156:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getMessagesModuleByLocale(_x20) {
    return _ref23.apply(this, arguments);
  };
}();

var getMessagesModuleByLocaleUsingFetch = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(locale) {
    var rsp, jsonData;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return fetch("".concat(getSheerIdScriptBasePath(), "localized-messages/").concat(locale, ".json"), {
              headers: {
                'Content-Type': 'text/plain'
              }
            });

          case 2:
            rsp = _context10.sent;
            jsonData = {};
            _context10.prev = 4;
            _context10.next = 7;
            return rsp.json();

          case 7:
            jsonData = _context10.sent;
            _context10.next = 13;
            break;

          case 10:
            _context10.prev = 10;
            _context10.t0 = _context10["catch"](4);
            logger.error(_context10.t0);

          case 13:
            return _context10.abrupt("return", prepareMsgsModule(jsonData));

          case 14:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[4, 10]]);
  }));

  return function getMessagesModuleByLocaleUsingFetch(_x21) {
    return _ref24.apply(this, arguments);
  };
}();
/**
 * @description Pluck only the messages we want to override defaults with.
 * Empty string values like `""` are allowed so messages can be hidden.
 * Messages with `undefined` values are omitted.
 *
 * @private
 */


var getThemeMessages$1 = function getThemeMessages$1(msgs) {
  var flatThemeMsgs = flat_1(msgs);
  var returnMsgs = {};
  Object.keys(flatThemeMsgs).forEach(function (key) {
    if (typeof flatThemeMsgs[key] === 'string') {
      returnMsgs[key] = flatThemeMsgs[key];
    }
  });
  return returnMsgs;
};

var getOptionsMessages = function getOptionsMessages(locale) {
  var optionalMessages = {};

  if (getOptions().messagesWithLocale[locale]) {
    optionalMessages = getOptions().messagesWithLocale[locale];
  }

  return optionalMessages;
};
/**
 * @todo tests
 * @private
 */


var countryToLocale = function countryToLocale(country) {
  var locale;

  switch (country) {
    case 'US':
      locale = 'en-US';
      break;

    default:
      locale = 'en-US';
  }

  return locale;
};
/**
 * Map old locales (Java 7) to new standards
 * @private
 */


var modernizeLocale = function modernizeLocale(locale) {
  return locale === 'iw' ? 'he' : locale;
}; // for now only Hebrew needs to be futurized

/**
 * @description Get all messages for a given locale.
 *      Return a flattened messages object, where properties are dot-string style.
 */


var getMessages = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(locale, programThemeMessages, segment) {
    var usedLocale, messagesModule, defaultMessages, hasSegmentMessages, segmentSpecificMessages, optionsMessages, cleanFlatThemeMessages, defaultLocaleMessages, messages;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            usedLocale = locale;

            if (!isValidLocale(usedLocale)) {
              logger.error("Invalid locale ".concat(usedLocale, ", falling back to ").concat(DEFAULT_LOCALE, " for the verification form"), 'Invalid locale');
              usedLocale = DEFAULT_LOCALE;
            }

            if (!(window.sheerIdEs5 === 'true')) {
              _context11.next = 8;
              break;
            }

            _context11.next = 5;
            return getMessagesModuleByLocaleUsingFetch(usedLocale);

          case 5:
            messagesModule = _context11.sent;
            _context11.next = 11;
            break;

          case 8:
            _context11.next = 10;
            return getMessagesModuleByLocale(usedLocale);

          case 10:
            messagesModule = _context11.sent;

          case 11:
            defaultMessages = messagesModule ? messagesModule.defaultMessages : {};
            hasSegmentMessages = messagesModule && messagesModule.segmentMessages;
            segmentSpecificMessages = segment && hasSegmentMessages ? messagesModule.segmentMessages[segment] : {};
            optionsMessages = getOptionsMessages(usedLocale);
            cleanFlatThemeMessages = programThemeMessages && usedLocale === DEFAULT_LOCALE ? getThemeMessages$1(programThemeMessages) : {}; // For non en-US locales, we'll merge en-US messages as a base

            if (!(usedLocale !== DEFAULT_LOCALE)) {
              _context11.next = 22;
              break;
            }

            _context11.next = 19;
            return getMessages(DEFAULT_LOCALE, programThemeMessages, segment);

          case 19:
            _context11.t0 = _context11.sent;
            _context11.next = 23;
            break;

          case 22:
            _context11.t0 = {};

          case 23:
            defaultLocaleMessages = _context11.t0;
            // Flatten these before object.assign so they are dot-props, so nested objects aren't overwritten, deleting properties
            messages = Object.assign({}, defaultLocaleMessages, defaultMessages ? flat_1(defaultMessages) : {}, segmentSpecificMessages ? flat_1(segmentSpecificMessages) : {}, cleanFlatThemeMessages, optionsMessages ? flat_1(optionsMessages) : {});
            return _context11.abrupt("return", messages);

          case 26:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getMessages(_x22, _x23, _x24) {
    return _ref25.apply(this, arguments);
  };
}();
/**
 * @todo tests
 * @description Get all messages for a given locale.
 *      Return a flattened messages object, where properties are dot-string style.
 * @private
 */


var getRequestOrgMessages = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(locale) {
    var usedLocale, messagesModule, defaultMessages, requestOrganizationMessages, optionsMessages, defaultLocaleMessages, messages;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            usedLocale = locale;

            if (!isValidLocale(usedLocale)) {
              logger.error("Invalid locale ".concat(usedLocale, ", falling back to ").concat(DEFAULT_LOCALE, " for the requestOrg form"), 'Invalid locale');
              usedLocale = DEFAULT_LOCALE;
            }

            _context12.next = 4;
            return getMessagesModuleByLocale(usedLocale);

          case 4:
            messagesModule = _context12.sent;
            defaultMessages = messagesModule ? messagesModule.defaultMessages : {};
            requestOrganizationMessages = messagesModule ? messagesModule.requestOrganizationMessages : {};
            optionsMessages = getOptionsMessages(usedLocale); // For non en-US locales, we'll merge en-US messages as a base

            if (!(usedLocale !== DEFAULT_LOCALE)) {
              _context12.next = 14;
              break;
            }

            _context12.next = 11;
            return getRequestOrgMessages(DEFAULT_LOCALE);

          case 11:
            _context12.t0 = _context12.sent;
            _context12.next = 15;
            break;

          case 14:
            _context12.t0 = {};

          case 15:
            defaultLocaleMessages = _context12.t0;
            // Flatten these before object.assign so they are dot-props, so nested objects aren't overwritten, deleting properties
            messages = Object.assign({}, defaultLocaleMessages, defaultMessages ? flat_1(defaultMessages) : {}, requestOrganizationMessages ? flat_1(requestOrganizationMessages) : {}, optionsMessages ? flat_1(optionsMessages) : {});
            return _context12.abrupt("return", messages);

          case 18:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function getRequestOrgMessages(_x25) {
    return _ref26.apply(this, arguments);
  };
}();
/**
 * @description Retrieves the locale used to display the verification form. It will attempt to bring the best default by looking at these places:
 * - Retrieve from previous user selection in ChangeLocaleComponent
 * - Retrieve based on the country selected
 * - Retrieve from Options
 * - Retrieve from the URL
 * - Retrieve from the VerificationResponse
 * - Retrieve library DEFAULT_LOCALE
 * If found a locale but is not supported by the library, it'll return DEFAULT_LOCALE instead.
 */


var getLocaleSafely = function getLocaleSafely(viewModel, verificationResponse) {
  function getLocaleFromViewModel(viewModel) {
    return getSafe(function () {
      return viewModel.localeChoice.value;
    });
  }

  function getLocaleFromCountrySelection(viewModel) {
    var country = getSafe(function () {
      return viewModel.countryChoice.value;
    });
    return country ? countryToLocale(country) : undefined;
  }

  function getLocaleFromUrl() {
    var b = getQueryParamsFromUrl(window.location.href);
    var queryParamLocale = b.get('locale');
    return queryParamLocale || undefined;
  }

  function getLocaleFromVerificationResponse(verificationResponse) {
    return getSafe(function () {
      return verificationResponse.locale;
    });
  }

  var locale = getLocaleFromViewModel(viewModel) || getLocaleFromCountrySelection(viewModel) || getOptions().locale || getLocaleFromUrl() || getLocaleFromVerificationResponse(verificationResponse) || DEFAULT_LOCALE;

  try {
    assertValidLocale(locale);
    return locale;
  } catch (error) {
    return DEFAULT_LOCALE;
  }
};

var getRequestOrganizationLocale = function getRequestOrganizationLocale() {
  var programTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var urlParams = new URLSearchParams(window.location.search);
  var locale;

  if (urlParams.get('locale')) {
    locale = urlParams.get('locale');
  } else {
    locale = getOptions().locale;
  }

  if (programTheme) {
    try {
      locale = programTheme.intl.locale;
    } catch (e) {
      logger.error(e, 'Error accessing programTheme.intl.locale. Did the shape of an object/type change?');
    }

    if (!isValidLocale(locale)) {
      logger.warn("Invalid locale \"".concat(locale, "\" received from server. Using fallback \"").concat(getOptions().locale, "\" instead."));
      locale = getOptions().locale;
    }
  }

  if (!isValidLocale(locale)) {
    logger.warn("Invalid locale ".concat(locale, ", falling back to en-US"));
    locale = 'en-US';
  }

  return locale;
};

var standardizeLocale = function standardizeLocale(locale) {
  return locale === 'id' ? 'in' : locale.replace('-', '_');
};

var getCompanyName = function getCompanyName(programTheme) {
  var companyName = '{Company}'; // Show literal string "{Company}" so implementor is prompted to fix by adding in my.sheerid.com

  try {
    companyName = programTheme.intl.messages.companyName;

    if (!(typeof companyName === 'string' && companyName.length > 0)) {
      throw new Error('Invalid companyName');
    }
  } catch (e) {
    // Property access or invalid company name error
    logger.warn('companyName not found. Please sign in to my.sheerid.com to set.');
  }

  return companyName;
};

var defaultMarketConsent = {
  enabled: false,
  required: false,
  message: ''
};
var defaultMetadata$1 = Object.freeze({
  enabled: false,
  keys: []
});

var getMetadataConfig = function getMetadataConfig(programTheme) {
  var customMetadata = deepClone(defaultMetadata$1);

  try {
    if (getSafe(function () {
      return programTheme.config.customMetadata.enabled;
    })) {
      customMetadata = programTheme.config.customMetadata;
    }
  } catch (e) {
    logger.warn('No custom metadata provided by the server.');
  }

  if (getOptions().customMetadata) {
    customMetadata = getOptions().customMetadata;
  }

  return customMetadata;
};

var getMarketConsent = function getMarketConsent(programTheme) {
  var marketConsent = _objectSpread2({}, defaultMarketConsent);

  try {
    if (programTheme.config.marketConsent) {
      marketConsent = programTheme.config.marketConsent;
    }
  } catch (e) {
    // market consent is not coming for this program from server. Default will be used
    logger.warn('Server did not provided a market consent config. Default will be used');
  }

  if (getOptions().marketConsent) {
    marketConsent = getOptions().marketConsent;
  }

  return marketConsent;
};

var getThemeMessages = function getThemeMessages(programTheme) {
  var themeMessages;

  try {
    themeMessages = programTheme.intl.messages;
  } catch (e) {
    logger.warn('Unable to get theme messages from ', programTheme);
  }

  return themeMessages;
};

var getCustomCss = function getCustomCss(programTheme) {
  return getOptions().customCss || programTheme.customCss;
};

var getLogoUrl = function getLogoUrl(programTheme) {
  var options = getOptions();
  return options.hasOwnProperty('logoUrl') ? options.logoUrl : programTheme.logoUrl;
};

var getPrivacyPolicyUrl = function getPrivacyPolicyUrl(programTheme) {
  var options = getOptions();
  return options.privacyPolicyUrl || programTheme.privacyPolicyUrl;
};

var getPrivacyPolicyCompanyName = function getPrivacyPolicyCompanyName(programTheme, intl) {
  var privacyPolicyHostName = '';

  try {
    privacyPolicyHostName = new URL(getPrivacyPolicyUrl(programTheme)).hostname;
  } catch (_) {
    logger.warn('Invalid Privacy Policy URL ', privacyPolicyHostName);
  }

  if (privacyPolicyHostName === DEFAULT_PRIVACY_POLICY_HOST) {
    return SHEERID;
  }

  return intl.formatMessage({
    id: 'companyName',
    defaultMessage: '{companyName}'
  });
};
/**
 * @description Return locales configured in MySheerID for this program, or specified in Javascript options.
 */


var getAvailableLocales = function getAvailableLocales(programTheme) {
  var configuredLocales = ['en-US'];
  var themeLocales = [];

  try {
    themeLocales = programTheme.config.locales;
  } catch (e) {
    logger.warn('Unable to get configured locales from programTheme');
  }

  var optionsLocales = getLocalesFromOptions(getOptions());
  configuredLocales = [].concat(_toConsumableArray2(themeLocales), _toConsumableArray2(optionsLocales));
  return arrayUnique(configuredLocales);
};
/**
 * @private
 */


var getLocalesFromOptions = function getLocalesFromOptions(options) {
  if (options && options.messagesWithLocale) {
    return Object.keys(options.messagesWithLocale);
  }

  return [];
};
/**
 * @description Safely return the countries that were chosen/configured in MySheerID for this program.
 * Otherwise, return US as default.
 */


var getConfiguredCountries = function getConfiguredCountries(programTheme) {
  try {
    if (programTheme && programTheme.config && programTheme.config.countries) {
      return programTheme.config.countries;
    } // Old location for this property, may be returned from the server
    // @ts-ignore


    if (programTheme.intl.messages.step.personalInfo.countries) {
      var availableCountries = []; // @ts-ignore

      for (var countryCode in programTheme.intl.messages.step.personalInfo.countries) {
        // eslint-disable-line
        availableCountries.push(countryCode);
      }

      return availableCountries;
    }
  } catch (e) {
    logger.warn('Unable to get configured countries');
  }

  return ['US'];
};
/**
 * @description Safely return the states that were chosen/configured in MySheerID for this program.
 */


var getConfiguredStates = function getConfiguredStates(programTheme) {
  try {
    if (programTheme && programTheme.config && programTheme.config.states && programTheme.config.states.length > 0) {
      return programTheme.config.states;
    }
  } catch (e) {
    logger.warn('Unable to get configured states');
  }

  return Object.keys(StateEnum);
};

var getEstimatedReviewTime = function getEstimatedReviewTime(programTheme) {
  var ewt;

  try {
    // Added in API ver 2.5.x, may not be present for all
    ewt = programTheme.config.estimatedReviewTime;
  } catch (e) {
    ewt = 'A_FEW_HOURS';
  }

  return ewt;
};

var getMaxReviewTime = function getMaxReviewTime(programTheme) {
  var mrt;

  try {
    // Added in API ver 2.5.x, may not be present for all
    mrt = programTheme.config.maxReviewTime;
  } catch (e) {
    mrt = '2_HRS';
  }

  return mrt;
};

var options = getOptions();

var getFaqUrl = function getFaqUrl() {
  var keyName = 'urlFaq';

  if (!options.hasOwnProperty(keyName)) {
    logger.error("Can't find an option for '".concat(keyName, "'"), 'Option not found');
  }

  return options[keyName];
};

var getFaqLink = function getFaqLink(programTheme, segment, programId, locale) {
  var faqInTheme;

  try {
    faqInTheme = programTheme.config.customFaqLink;
  } catch (e) {
    faqInTheme = '';
  }

  return !faqInTheme || faqInTheme === '' ? "".concat(getFaqUrl(), "?pid=").concat(programId, "&locale=").concat(standardizeLocale(locale)) : faqInTheme;
};

var getOrgSearchCountryTags = function getOrgSearchCountryTags(programTheme, country) {
  return getSafe(function () {
    return programTheme.config.orgSearchCountryTags[country].join(',');
  }, '');
};

var RequestOrganizationErrorComponent = function RequestOrganizationErrorComponent(_ref27) {
  var requestOrganizationService = _ref27.requestOrganizationService;
  var programTheme = requestOrganizationService.programTheme;
  var programId = requestOrganizationService.programId;
  var logoUrl = programTheme ? getLogoUrl(programTheme) : null;
  return React.createElement("div", {
    className: "sid-l-container--extra-wide sid-l-space-btm-lg sid-l-container"
  }, React.createElement("div", {
    className: "sid-logo sid-l-horz-center sid-l-space-top-lg"
  }, React.createElement("img", {
    className: "sid-logo__img",
    alt: "Logo",
    src: logoUrl || requestOrganizationConstants.SHEERID_LOGO_URL
  })), React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement("div", {
    className: "sid-logo sid-l-space-top-lg"
  }, React.createElement("img", {
    className: "sid-logo__icon",
    alt: "Error",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/requestOrganization/circle-exclamation.svg"
  })), React.createElement("div", {
    className: "sid-title"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.error.title",
    defaultMessage: "An unexpected error occurred"
  })), React.createElement("div", {
    className: "sid-soft-font-color"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.error.description",
    defaultMessage: "Sorry we are not able to process your request. Please try again later."
  })), React.createElement("div", {
    className: "sid-soft-font-color"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.error.seeingProblem",
    defaultMessage: "DM If you keep seeing this problem <a class='sid-link' href='{feedbackUrl}&pid={programId}' target='_blank' rel='noopener noreferrer'>contact us</a>.",
    values: {
      programId: programId,
      feedbackUrl: requestOrganizationConstants.FEEDBACK_FORM_URL
    }
  }))));
};

var FormWrapperComponent = function FormWrapperComponent(_ref28) {
  var children = _ref28.children;
  return React.createElement("div", {
    className: "sid sid-form-wrapper"
  }, children);
};
/**
 * TODO - preamble
 *
 * Empty objects, useful for initializing
 */


var coreFieldsEmpty = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: ''
};
var withLocaleAndCountryEmpty = {
  countryChoice: undefined,
  localeChoice: {
    value: undefined,
    label: undefined
  }
};
var withFieldsToSkipValidationEmpty = {
  fieldsToSkipValidation: undefined
}; // TODO use Object.freeze here

var stuPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  birthDate: '',
  organization: {
    id: 0,
    name: ''
  },
  metadata: {
    marketConsentValue: false
  }
}); // TODO use Object.freeze here


var seniorPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  birthDate: '',
  postalCode: '',
  metadata: {
    marketConsentValue: false
  }
});

var agePInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  birthDate: '',
  postalCode: '',
  phoneNumber: '',
  country: 'US',
  metadata: {
    marketConsentValue: false,
    carrierConsentValue: false
  }
}); // TODO use Object.freeze here


var teaPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  birthDate: '',
  organization: {
    id: 0,
    name: ''
  },
  metadata: {
    marketConsentValue: false
  }
});

var memberInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, {
  birthDate: '',
  phoneNumber: '',
  memberId: '',
  organization: {
    id: 0,
    name: ''
  },
  metadata: {
    marketConsentValue: false
  }
});

var activeMilitaryPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  birthDate: '',
  organization: {
    id: 0,
    name: ''
  },
  status: undefined,
  metadata: {
    marketConsentValue: false
  }
});

var inactiveMilitaryPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  birthDate: '',
  dischargeDate: '',
  organization: {
    id: 0,
    name: ''
  },
  status: undefined,
  metadata: {
    marketConsentValue: false
  }
});

var firstResponderPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  birthDate: '',
  organization: {
    id: 0,
    name: ''
  },
  status: undefined,
  metadata: {
    marketConsentValue: false
  }
});

var medicalProfessionalPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  birthDate: '',
  postalCode: '',
  organization: {
    id: 0,
    name: ''
  },
  status: undefined,
  country: undefined,
  metadata: {
    marketConsentValue: false
  },
  memberId: undefined
});

var employmentPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  postalCode: '',
  organization: {
    id: 0,
    name: ''
  },
  address1: '',
  city: '',
  state: '',
  metadata: {
    marketConsentValue: false
  }
});

var driverLicensePInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withFieldsToSkipValidationEmpty, withLocaleAndCountryEmpty, {
  state: '',
  driverLicenseNumber: '',
  metadata: {
    marketConsentValue: false
  }
});

var generalIdentityPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withFieldsToSkipValidationEmpty, withLocaleAndCountryEmpty, {
  birthDate: '',
  address1: '',
  city: '',
  state: '',
  postalCode: '',
  metadata: {
    marketConsentValue: false
  }
});

var hybridIdentityPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withFieldsToSkipValidationEmpty, withLocaleAndCountryEmpty, {
  birthDate: '',
  address1: '',
  city: '',
  state: '',
  postalCode: '',
  metadata: {
    marketConsentValue: false
  },
  driverLicenseNumber: ''
});

var licensedProfessionalPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withFieldsToSkipValidationEmpty, withLocaleAndCountryEmpty, {
  birthDate: '',
  postalCode: '',
  organization: {
    id: 0,
    name: ''
  },
  statuses: [],
  metadata: {
    marketConsentValue: false
  }
});

var moverPInfoReqEmpty = _objectSpread2({}, coreFieldsEmpty, withFieldsToSkipValidationEmpty, withLocaleAndCountryEmpty, {
  address1: '',
  postalCode: '',
  statuses: [],
  metadata: {
    marketConsentValue: false
  }
}); // TODO use Object.freeze here


var docUploadEmpty = _objectSpread2({}, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  file1: undefined,
  file2: undefined,
  file3: undefined
});

var ssoEmpty = _objectSpread2({}, withLocaleAndCountryEmpty, withFieldsToSkipValidationEmpty, {
  isSSOActive: false
});

var socialSecurityEmpty = _objectSpread2({}, withLocaleAndCountryEmpty, {
  socialSecurityNumber: undefined
});

var smsLoopEmpty = _objectSpread2({}, withLocaleAndCountryEmpty, {
  smsCode: '',
  phoneNumber: undefined
});

var emailLoopEmpty = _objectSpread2({}, withLocaleAndCountryEmpty, {
  emailToken: ''
});

var emptyViewModel = _objectSpread2({}, withLocaleAndCountryEmpty);

var initialErrorStructure = {
  firstName: undefined,
  lastName: undefined,
  memberId: undefined,
  email: undefined,
  phoneNumber: undefined,
  birthDate: undefined,
  organization: undefined,
  postalCode: undefined,
  address1: undefined,
  city: undefined,
  country: undefined,
  state: undefined,
  dischargeDate: undefined,
  docUpload: undefined,
  status: undefined,
  statuses: undefined,
  socialSecurityNumber: undefined,
  marketConsentValue: undefined,
  carrierConsentValue: undefined,
  smsCode: undefined,
  driverLicenseNumber: undefined
};

var getAllEmptyViewModels = function getAllEmptyViewModels() {
  return {
    collectStudentPersonalInfo: deepClone(stuPInfoReqEmpty),
    collectTeacherPersonalInfo: deepClone(teaPInfoReqEmpty),
    collectMemberPersonalInfo: deepClone(memberInfoReqEmpty),
    collectMilitaryStatus: deepClone(activeMilitaryPInfoReqEmpty),
    collectActiveMilitaryPersonalInfo: deepClone(activeMilitaryPInfoReqEmpty),
    collectInactiveMilitaryPersonalInfo: deepClone(inactiveMilitaryPInfoReqEmpty),
    collectSeniorPersonalInfo: deepClone(seniorPInfoReqEmpty),
    collectAgePersonalInfo: deepClone(agePInfoReqEmpty),
    collectFirstResponderPersonalInfo: deepClone(firstResponderPInfoReqEmpty),
    collectMedicalProfessionalPersonalInfo: deepClone(medicalProfessionalPInfoReqEmpty),
    collectEmployeePersonalInfo: deepClone(employmentPInfoReqEmpty),
    collectSocialSecurityNumber: deepClone(socialSecurityEmpty),
    collectDriverLicensePersonalInfo: deepClone(driverLicensePInfoReqEmpty),
    collectGeneralIdentityPersonalInfo: deepClone(generalIdentityPInfoReqEmpty),
    collectHybridIdentityPersonalInfo: deepClone(hybridIdentityPInfoReqEmpty),
    collectLicensedProfessionalPersonalInfo: deepClone(licensedProfessionalPInfoReqEmpty),
    collectMoverPersonalInfo: deepClone(moverPInfoReqEmpty),
    docUpload: deepClone(docUploadEmpty),
    cancelEmailLoop: deepClone(emailLoopEmpty),
    sso: deepClone(ssoEmpty),
    smsLoop: deepClone(smsLoopEmpty),
    emailLoop: deepClone(emailLoopEmpty),
    pending: deepClone(emptyViewModel),
    success: deepClone(emptyViewModel),
    error: deepClone(emptyViewModel),
    cancelSocialSecurityNumber: deepClone(emptyViewModel),
    docReviewLimitExceeded: deepClone(emptyViewModel)
  };
};

var getFieldValidationErrorsEmpty = function getFieldValidationErrorsEmpty() {
  return deepClone(initialErrorStructure);
};

var getExtendedFieldValidationErrorsEmpty = function getExtendedFieldValidationErrorsEmpty() {
  var customValidatorFieldsEmpty = {};
  var customValidatorFields = getCustomValidatorFields();

  if (customValidatorFields) {
    var _iterator = _createForOfIteratorHelper(customValidatorFields),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var field = _step.value;
        customValidatorFieldsEmpty[field] = undefined;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return customValidatorFieldsEmpty;
};

var GetEmptyTheme = function GetEmptyTheme() {
  return {
    intl: {
      locale: getLocaleSafely(),
      // @ts-ignore
      messages: {}
    },
    customCss: ''
  };
};

var requestOrganizationEmpty = _objectSpread2({}, withLocaleAndCountryEmpty, {
  orgDomain: '',
  orgName: '',
  firstName: '',
  lastName: '',
  email: '',
  displayResults: false,
  searchByOrgName: false,
  completeRequest: false,
  eligibleOrgs: [],
  ineligibleOrgs: [],
  orgCountryError: null,
  orgDomainError: null,
  orgNameError: null,
  firstNameError: null,
  lastNameError: null,
  emailError: null,
  isSearching: false
});

var getEmptyRequestOrganizationViewModel = function getEmptyRequestOrganizationViewModel() {
  var requestOrganizationEmptyClone = deepClone(requestOrganizationEmpty);
  return requestOrganizationEmptyClone;
};

function n$5(n) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), e = 1; e < t; e++) {
    r[e - 1] = arguments[e];
  }

  if ("production" !== process.env.NODE_ENV) {
    var i = Y[n],
        o = i ? "function" == typeof i ? i.apply(null, r) : i : "unknown error nr: " + n;
    throw Error("[Immer] " + o);
  }

  throw Error("[Immer] minified error nr: " + n + (r.length ? " " + r.map(function (n) {
    return "'" + n + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}

function t$4(n) {
  return !!n && !!n[Q];
}

function r$5(n) {
  return !!n && (function (n) {
    if (!n || "object" != typeof n) return !1;
    var t = Object.getPrototypeOf(n);
    if (null === t) return !0;
    var r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
    return r === Object || "function" == typeof r && Function.toString.call(r) === Z;
  }(n) || Array.isArray(n) || !!n[L] || !!n.constructor[L] || s(n) || v$4(n));
}

function i(n, t, r) {
  void 0 === r && (r = !1), 0 === o(n) ? (r ? Object.keys : nn)(n).forEach(function (e) {
    r && "symbol" == typeof e || t(e, n[e], n);
  }) : n.forEach(function (r, e) {
    return t(e, r, n);
  });
}

function o(n) {
  var t = n[Q];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(n) ? 1 : s(n) ? 2 : v$4(n) ? 3 : 0;
}

function u$1(n, t) {
  return 2 === o(n) ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t);
}

function a(n, t) {
  return 2 === o(n) ? n.get(t) : n[t];
}

function f$4(n, t, r) {
  var e = o(n);
  2 === e ? n.set(t, r) : 3 === e ? (n.delete(t), n.add(r)) : n[t] = r;
}

function c$4(n, t) {
  return n === t ? 0 !== n || 1 / n == 1 / t : n != n && t != t;
}

function s(n) {
  return X && n instanceof Map;
}

function v$4(n) {
  return q$4 && n instanceof Set;
}

function p$4(n) {
  return n.o || n.t;
}

function l$4(n) {
  if (Array.isArray(n)) return Array.prototype.slice.call(n);
  var t = tn(n);
  delete t[Q];

  for (var r = nn(t), e = 0; e < r.length; e++) {
    var i = r[e],
        o = t[i];
    !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[i] = {
      configurable: !0,
      writable: !0,
      enumerable: o.enumerable,
      value: n[i]
    });
  }

  return Object.create(Object.getPrototypeOf(n), t);
}

function d$4(n, e) {
  return void 0 === e && (e = !1), y$4(n) || t$4(n) || !r$5(n) ? n : (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h$4), Object.freeze(n), e && i(n, function (n, t) {
    return d$4(t, !0);
  }, !0), n);
}

function h$4() {
  n$5(2);
}

function y$4(n) {
  return null == n || "object" != typeof n || Object.isFrozen(n);
}

function b$4(t) {
  var r = rn[t];
  return r || n$5(18, t), r;
}

function m$4(n, t) {
  rn[n] || (rn[n] = t);
}

function _() {
  return "production" === process.env.NODE_ENV || U || n$5(0), U;
}

function j(n, t) {
  t && (b$4("Patches"), n.u = [], n.s = [], n.v = t);
}

function O(n) {
  g$4(n), n.p.forEach(S), n.p = null;
}

function g$4(n) {
  n === U && (U = n.l);
}

function w$4(n) {
  return U = {
    p: [],
    l: U,
    h: n,
    m: !0,
    _: 0
  };
}

function S(n) {
  var t = n[Q];
  0 === t.i || 1 === t.i ? t.j() : t.O = !0;
}

function P(t, e) {
  e._ = e.p.length;
  var i = e.p[0],
      o = void 0 !== t && t !== i;
  return e.h.g || b$4("ES5").S(e, t, o), o ? (i[Q].P && (O(e), n$5(4)), r$5(t) && (t = M(e, t), e.l || x$4(e, t)), e.u && b$4("Patches").M(i[Q], t, e.u, e.s)) : t = M(e, i, []), O(e), e.u && e.v(e.u, e.s), t !== H$1 ? t : void 0;
}

function M(n, t, r) {
  if (y$4(t)) return t;
  var e = t[Q];
  if (!e) return i(t, function (i, o) {
    return A$4(n, e, t, i, o, r);
  }, !0), t;
  if (e.A !== n) return t;
  if (!e.P) return x$4(n, e.t, !0), e.t;

  if (!e.I) {
    e.I = !0, e.A._--;
    var o = 4 === e.i || 5 === e.i ? e.o = l$4(e.k) : e.o;
    i(3 === e.i ? new Set(o) : o, function (t, i) {
      return A$4(n, e, o, t, i, r);
    }), x$4(n, o, !1), r && n.u && b$4("Patches").R(e, r, n.u, n.s);
  }

  return e.o;
}

function A$4(e, i, o, a, c, s) {
  if ("production" !== process.env.NODE_ENV && c === o && n$5(5), t$4(c)) {
    var v = M(e, c, s && i && 3 !== i.i && !u$1(i.D, a) ? s.concat(a) : void 0);
    if (f$4(o, a, v), !t$4(v)) return;
    e.m = !1;
  }

  if (r$5(c) && !y$4(c)) {
    if (!e.h.F && e._ < 1) return;
    M(e, c), i && i.A.l || x$4(e, c);
  }
}

function x$4(n, t, r) {
  void 0 === r && (r = !1), n.h.F && n.m && d$4(t, r);
}

function z$4(n, t) {
  var r = n[Q];
  return (r ? p$4(r) : n)[t];
}

function I$1(n, t) {
  if (t in n) for (var r = Object.getPrototypeOf(n); r;) {
    var e = Object.getOwnPropertyDescriptor(r, t);
    if (e) return e;
    r = Object.getPrototypeOf(r);
  }
}

function k$4(n) {
  n.P || (n.P = !0, n.l && k$4(n.l));
}

function E$1(n) {
  n.o || (n.o = l$4(n.t));
}

function R(n, t, r) {
  var e = s(t) ? b$4("MapSet").N(t, r) : v$4(t) ? b$4("MapSet").T(t, r) : n.g ? function (n, t) {
    var r = Array.isArray(n),
        e = {
      i: r ? 1 : 0,
      A: t ? t.A : _(),
      P: !1,
      I: !1,
      D: {},
      l: t,
      t: n,
      k: null,
      o: null,
      j: null,
      C: !1
    },
        i = e,
        o = en;
    r && (i = [e], o = on);
    var u = Proxy.revocable(i, o),
        a = u.revoke,
        f = u.proxy;
    return e.k = f, e.j = a, f;
  }(t, r) : b$4("ES5").J(t, r);
  return (r ? r.A : _()).p.push(e), e;
}

function D$1(e) {
  return t$4(e) || n$5(22, e), function n(t) {
    if (!r$5(t)) return t;
    var e,
        u = t[Q],
        c = o(t);

    if (u) {
      if (!u.P && (u.i < 4 || !b$4("ES5").K(u))) return u.t;
      u.I = !0, e = F$1(t, c), u.I = !1;
    } else e = F$1(t, c);

    return i(e, function (t, r) {
      u && a(u.t, t) === r || f$4(e, t, n(r));
    }), 3 === c ? new Set(e) : e;
  }(e);
}

function F$1(n, t) {
  switch (t) {
    case 2:
      return new Map(n);

    case 3:
      return Array.from(n);
  }

  return l$4(n);
}

function N() {
  function r(n, t) {
    var r = s[n];
    return r ? r.enumerable = t : s[n] = r = {
      configurable: !0,
      enumerable: t,
      get: function get() {
        var t = this[Q];
        return "production" !== process.env.NODE_ENV && f(t), en.get(t, n);
      },
      set: function set(t) {
        var r = this[Q];
        "production" !== process.env.NODE_ENV && f(r), en.set(r, n, t);
      }
    }, r;
  }

  function e(n) {
    for (var t = n.length - 1; t >= 0; t--) {
      var r = n[t][Q];
      if (!r.P) switch (r.i) {
        case 5:
          a(r) && k$4(r);
          break;

        case 4:
          o(r) && k$4(r);
      }
    }
  }

  function o(n) {
    for (var t = n.t, r = n.k, e = nn(r), i = e.length - 1; i >= 0; i--) {
      var o = e[i];

      if (o !== Q) {
        var a = t[o];
        if (void 0 === a && !u$1(t, o)) return !0;
        var f = r[o],
            s = f && f[Q];
        if (s ? s.t !== a : !c$4(f, a)) return !0;
      }
    }

    var v = !!t[Q];
    return e.length !== nn(t).length + (v ? 0 : 1);
  }

  function a(n) {
    var t = n.k;
    if (t.length !== n.t.length) return !0;
    var r = Object.getOwnPropertyDescriptor(t, t.length - 1);
    return !(!r || r.get);
  }

  function f(t) {
    t.O && n$5(3, JSON.stringify(p$4(t)));
  }

  var s = {};
  m$4("ES5", {
    J: function J(n, t) {
      var e = Array.isArray(n),
          i = function (n, t) {
        if (n) {
          for (var e = Array(t.length), i = 0; i < t.length; i++) {
            Object.defineProperty(e, "" + i, r(i, !0));
          }

          return e;
        }

        var o = tn(t);
        delete o[Q];

        for (var u = nn(o), a = 0; a < u.length; a++) {
          var f = u[a];
          o[f] = r(f, n || !!o[f].enumerable);
        }

        return Object.create(Object.getPrototypeOf(t), o);
      }(e, n),
          o = {
        i: e ? 5 : 4,
        A: t ? t.A : _(),
        P: !1,
        I: !1,
        D: {},
        l: t,
        t: n,
        k: i,
        o: null,
        O: !1,
        C: !1
      };

      return Object.defineProperty(i, Q, {
        value: o,
        writable: !0
      }), i;
    },
    S: function S(n, r, o) {
      o ? t$4(r) && r[Q].A === n && e(n.p) : (n.u && function n(t) {
        if (t && "object" == typeof t) {
          var r = t[Q];

          if (r) {
            var e = r.t,
                o = r.k,
                f = r.D,
                c = r.i;
            if (4 === c) i(o, function (t) {
              t !== Q && (void 0 !== e[t] || u$1(e, t) ? f[t] || n(o[t]) : (f[t] = !0, k$4(r)));
            }), i(e, function (n) {
              void 0 !== o[n] || u$1(o, n) || (f[n] = !1, k$4(r));
            });else if (5 === c) {
              if (a(r) && (k$4(r), f.length = !0), o.length < e.length) for (var s = o.length; s < e.length; s++) {
                f[s] = !1;
              } else for (var v = e.length; v < o.length; v++) {
                f[v] = !0;
              }

              for (var p = Math.min(o.length, e.length), l = 0; l < p; l++) {
                void 0 === f[l] && n(o[l]);
              }
            }
          }
        }
      }(n.p[0]), e(n.p));
    },
    K: function K(n) {
      return 4 === n.i ? o(n) : a(n);
    }
  });
}

var G$1,
    U,
    W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
    X = "undefined" != typeof Map,
    q$4 = "undefined" != typeof Set,
    B$1 = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
    H$1 = W ? Symbol.for("immer-nothing") : ((G$1 = {})["immer-nothing"] = !0, G$1),
    L = W ? Symbol.for("immer-draftable") : "__$immer_draftable",
    Q = W ? Symbol.for("immer-state") : "__$immer_state",
    Y = {
  0: "Illegal state",
  1: "Immer drafts cannot have computed properties",
  2: "This object has been frozen and should not be mutated",
  3: function _(n) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
  },
  4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  5: "Immer forbids circular references",
  6: "The first or second argument to `produce` must be a function",
  7: "The third argument to `produce` must be a function or undefined",
  8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
  10: "The given draft is already finalized",
  11: "Object.defineProperty() cannot be used on an Immer draft",
  12: "Object.setPrototypeOf() cannot be used on an Immer draft",
  13: "Immer only supports deleting array indices",
  14: "Immer only supports setting array indices and the 'length' property",
  15: function _(n) {
    return "Cannot apply patch, path doesn't resolve: " + n;
  },
  16: 'Sets cannot have "replace" patches.',
  17: function _(n) {
    return "Unsupported patch operation: " + n;
  },
  18: function _(n) {
    return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
  },
  20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
  21: function _(n) {
    return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
  },
  22: function _(n) {
    return "'current' expects a draft, got: " + n;
  },
  23: function _(n) {
    return "'original' expects a draft, got: " + n;
  },
  24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
},
    Z = "" + Object.prototype.constructor,
    nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (n) {
  return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames,
    tn = Object.getOwnPropertyDescriptors || function (n) {
  var t = {};
  return nn(n).forEach(function (r) {
    t[r] = Object.getOwnPropertyDescriptor(n, r);
  }), t;
},
    rn = {},
    en = {
  get: function get(n, t) {
    if (t === Q) return n;
    var e = p$4(n);
    if (!u$1(e, t)) return function (n, t, r) {
      var e,
          i = I$1(t, r);
      return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
    }(n, e, t);
    var i = e[t];
    return n.I || !r$5(i) ? i : i === z$4(n.t, t) ? (E$1(n), n.o[t] = R(n.A.h, i, n)) : i;
  },
  has: function has(n, t) {
    return t in p$4(n);
  },
  ownKeys: function ownKeys(n) {
    return Reflect.ownKeys(p$4(n));
  },
  set: function set(n, t, r) {
    var e = I$1(p$4(n), t);
    if (null == e ? void 0 : e.set) return e.set.call(n.k, r), !0;

    if (!n.P) {
      var i = z$4(p$4(n), t),
          o = null == i ? void 0 : i[Q];
      if (o && o.t === r) return n.o[t] = r, n.D[t] = !1, !0;
      if (c$4(r, i) && (void 0 !== r || u$1(n.t, t))) return !0;
      E$1(n), k$4(n);
    }

    return n.o[t] === r && "number" != typeof r && (void 0 !== r || t in n.o) || (n.o[t] = r, n.D[t] = !0, !0);
  },
  deleteProperty: function deleteProperty(n, t) {
    return void 0 !== z$4(n.t, t) || t in n.t ? (n.D[t] = !1, E$1(n), k$4(n)) : delete n.D[t], n.o && delete n.o[t], !0;
  },
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(n, t) {
    var r = p$4(n),
        e = Reflect.getOwnPropertyDescriptor(r, t);
    return e ? {
      writable: !0,
      configurable: 1 !== n.i || "length" !== t,
      enumerable: e.enumerable,
      value: r[t]
    } : e;
  },
  defineProperty: function defineProperty() {
    n$5(11);
  },
  getPrototypeOf: function getPrototypeOf(n) {
    return Object.getPrototypeOf(n.t);
  },
  setPrototypeOf: function setPrototypeOf() {
    n$5(12);
  }
},
    on = {};

i(en, function (n, t) {
  on[n] = function () {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), on.deleteProperty = function (t, r) {
  return "production" !== process.env.NODE_ENV && isNaN(parseInt(r)) && n$5(13), en.deleteProperty.call(this, t[0], r);
}, on.set = function (t, r, e) {
  return "production" !== process.env.NODE_ENV && "length" !== r && isNaN(parseInt(r)) && n$5(14), en.set.call(this, t[0], r, e, t[0]);
};

var un = function () {
  function e(t) {
    var e = this;
    this.g = B$1, this.F = !0, this.produce = function (t, i, o) {
      if ("function" == typeof t && "function" != typeof i) {
        var u = i;
        i = t;
        var a = e;
        return function (n) {
          var t = this;
          void 0 === n && (n = u);

          for (var r = arguments.length, e = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
            e[o - 1] = arguments[o];
          }

          return a.produce(n, function (n) {
            var r;
            return (r = i).call.apply(r, [t, n].concat(e));
          });
        };
      }

      var f;

      if ("function" != typeof i && n$5(6), void 0 !== o && "function" != typeof o && n$5(7), r$5(t)) {
        var c = w$4(e),
            s = R(e, t, void 0),
            v = !0;

        try {
          f = i(s), v = !1;
        } finally {
          v ? O(c) : g$4(c);
        }

        return "undefined" != typeof Promise && f instanceof Promise ? f.then(function (n) {
          return j(c, o), P(n, c);
        }, function (n) {
          throw O(c), n;
        }) : (j(c, o), P(f, c));
      }

      if (!t || "object" != typeof t) {
        if ((f = i(t)) === H$1) return;
        return void 0 === f && (f = t), e.F && d$4(f, !0), f;
      }

      n$5(21, t);
    }, this.produceWithPatches = function (n, t) {
      return "function" == typeof n ? function (t) {
        for (var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
          i[o - 1] = arguments[o];
        }

        return e.produceWithPatches(t, function (t) {
          return n.apply(void 0, [t].concat(i));
        });
      } : [e.produce(n, t, function (n, t) {
        r = n, i = t;
      }), r, i];
      var r, i;
    }, "boolean" == typeof (null == t ? void 0 : t.useProxies) && this.setUseProxies(t.useProxies), "boolean" == typeof (null == t ? void 0 : t.autoFreeze) && this.setAutoFreeze(t.autoFreeze);
  }

  var i = e.prototype;
  return i.createDraft = function (e) {
    r$5(e) || n$5(8), t$4(e) && (e = D$1(e));
    var i = w$4(this),
        o = R(this, e, void 0);
    return o[Q].C = !0, g$4(i), o;
  }, i.finishDraft = function (t, r) {
    var e = t && t[Q];
    "production" !== process.env.NODE_ENV && (e && e.C || n$5(9), e.I && n$5(10));
    var i = e.A;
    return j(i, r), P(void 0, i);
  }, i.setAutoFreeze = function (n) {
    this.F = n;
  }, i.setUseProxies = function (t) {
    t && !B$1 && n$5(20), this.g = t;
  }, i.applyPatches = function (n, r) {
    var e;

    for (e = r.length - 1; e >= 0; e--) {
      var i = r[e];

      if (0 === i.path.length && "replace" === i.op) {
        n = i.value;
        break;
      }
    }

    var o = b$4("Patches").$;
    return t$4(n) ? o(n, r) : this.produce(n, function (n) {
      return o(n, r.slice(e + 1));
    });
  }, e;
}(),
    an = new un(),
    fn = an.produce;

an.produceWithPatches.bind(an);
an.setAutoFreeze.bind(an);
an.setUseProxies.bind(an);
an.applyPatches.bind(an);
an.createDraft.bind(an);
an.finishDraft.bind(an);

var requestOrganizationReducer = function requestOrganizationReducer(state, action) {
  switch (action.type) {
    case 'PROGRAM_ID':
      return _objectSpread2({}, state, {
        programId: action.payload
      });

    case 'PROGRAM_THEME':
      return _objectSpread2({}, state, {
        programTheme: action.payload
      });

    case 'UPDATE_VIEW_MODEL':
      var viewModel = fn(state.viewModel, function (draft) {
        return _objectSpread2({}, draft, action.payload);
      });
      return _objectSpread2({}, state, {
        viewModel: viewModel
      });

    case 'SET_MESSAGES':
      return _objectSpread2({}, state, {
        messages: action.payload
      });

    case 'SET_LOCALE':
      return _objectSpread2({}, state, {
        locale: action.payload
      });

    case 'SET_ERROR':
      return _objectSpread2({}, state, {
        error: action.payload
      });

    case 'SET_SUBMIT':
      return _objectSpread2({}, state, {
        submitted: action.payload
      });

    case 'SET_INITIALIZED':
      return _objectSpread2({}, state, {
        isInitialized: action.payload
      });

    case 'SET_LOADING':
      var loading = state.isLoading + (action.payload ? 1 : -1);
      return _objectSpread2({}, state, {
        isLoading: loading > 0 ? loading : 0
      });

    default:
      return state;
  }
};

var initialState$2 = Object.freeze({
  viewModel: getEmptyRequestOrganizationViewModel(),
  programTheme: undefined,
  programId: undefined,
  submitted: false,
  error: undefined,
  locale: undefined,
  messages: undefined,
  isLoading: 1,
  isInitialized: false
});

var getInitialState$3 = function getInitialState$3() {
  return deepClone(initialState$2);
};

var RequestOrganizationStore = function RequestOrganizationStore(_ref29) {
  var children = _ref29.children;

  var _React$useReducer = React.useReducer(requestOrganizationReducer, getInitialState$3()),
      _React$useReducer2 = _slicedToArray2(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  return React.createElement(RequestOrganizationContext.Provider, {
    value: [state, dispatch]
  }, children);
};

var RequestOrganizationContext = React.createContext([getInitialState$3(), function () {}]);

var CustomTextWrapper = function CustomTextWrapper(_ref30) {
  var dangerouslySetInnerHTML = _ref30.dangerouslySetInnerHTML,
      props = _objectWithoutProperties2(_ref30, ["dangerouslySetInnerHTML"]);

  return dangerouslySetInnerHTML ? React.createElement("span", Object.assign({
    dangerouslySetInnerHTML: dangerouslySetInnerHTML
  }, props)) : React.createElement(React.Fragment, Object.assign({}, props));
};

var RequestOrganizationSuccessComponent = function RequestOrganizationSuccessComponent(_ref31) {
  var requestOrganizationService = _ref31.requestOrganizationService;
  var programTheme = requestOrganizationService.programTheme;
  return React.createElement("div", {
    className: "sid-l-container--extra-wide sid-l-space-btm-lg sid-l-container"
  }, React.createElement("div", {
    className: "sid-logo sid-l-horz-center sid-l-space-top-lg"
  }, React.createElement("img", {
    className: "sid-logo__img",
    alt: "Logo",
    src: programTheme && getLogoUrl(programTheme) ? getLogoUrl(programTheme) : requestOrganizationConstants.SHEERID_LOGO_URL
  })), React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement("div", {
    className: "sid-logo sid-l-space-top-lg"
  }, React.createElement("img", {
    className: "sid-logo__icon",
    alt: "Success",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/requestOrganization/circle-check.svg"
  })), React.createElement("div", {
    className: "sid-title"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.success.title",
    defaultMessage: "Thank you for submitting your school request"
  })), React.createElement("div", {
    className: "sid-soft-font-color"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.success.description",
    defaultMessage: "As a reminder, each request is evaluated by SheerID against the requirements set by this offer. There is no guarantee that your school will be added. The evaluation process takes up to 7 business days."
  }))));
};

var CountryCode;

(function (CountryCode) {
  CountryCode["UK"] = "UK";
  CountryCode["GB"] = "GB";
  CountryCode["JE"] = "JE";
  CountryCode["GG"] = "GG";
  CountryCode["IM"] = "IM";
  CountryCode["US"] = "US";
  CountryCode["CA"] = "CA";
  CountryCode["IE"] = "IE";
  CountryCode["DE"] = "DE";
  CountryCode["JP"] = "JP";
  CountryCode["FR"] = "FR";
  CountryCode["AU"] = "AU";
  CountryCode["IT"] = "IT";
  CountryCode["CH"] = "CH";
  CountryCode["AT"] = "AT";
  CountryCode["ES"] = "ES";
  CountryCode["NL"] = "NL";
  CountryCode["BE"] = "BE";
  CountryCode["DK"] = "DK";
  CountryCode["SE"] = "SE";
  CountryCode["NO"] = "NO";
  CountryCode["BR"] = "BR";
  CountryCode["PT"] = "PT";
  CountryCode["FI"] = "FI";
  CountryCode["AX"] = "AX";
  CountryCode["KR"] = "KR";
  CountryCode["CN"] = "CN";
  CountryCode["TW"] = "TW";
  CountryCode["SG"] = "SG";
  CountryCode["DZ"] = "DZ";
  CountryCode["AD"] = "AD";
  CountryCode["AR"] = "AR";
  CountryCode["AM"] = "AM";
  CountryCode["AZ"] = "AZ";
  CountryCode["BH"] = "BH";
  CountryCode["BD"] = "BD";
  CountryCode["BB"] = "BB";
  CountryCode["BY"] = "BY";
  CountryCode["BM"] = "BM";
  CountryCode["BA"] = "BA";
  CountryCode["IO"] = "IO";
  CountryCode["BN"] = "BN";
  CountryCode["BG"] = "BG";
  CountryCode["KH"] = "KH";
  CountryCode["CV"] = "CV";
  CountryCode["CL"] = "CL";
  CountryCode["CR"] = "CR";
  CountryCode["HR"] = "HR";
  CountryCode["CY"] = "CY";
  CountryCode["CZ"] = "CZ";
  CountryCode["DO"] = "DO";
  CountryCode["EC"] = "EC";
  CountryCode["EG"] = "EG";
  CountryCode["EE"] = "EE";
  CountryCode["FO"] = "FO";
  CountryCode["GE"] = "GE";
  CountryCode["GR"] = "GR";
  CountryCode["GL"] = "GL";
  CountryCode["GT"] = "GT";
  CountryCode["HT"] = "HT";
  CountryCode["HN"] = "HN";
  CountryCode["HU"] = "HU";
  CountryCode["IS"] = "IS";
  CountryCode["IN"] = "IN";
  CountryCode["ID"] = "ID";
  CountryCode["IL"] = "IL";
  CountryCode["JO"] = "JO";
  CountryCode["KZ"] = "KZ";
  CountryCode["KE"] = "KE";
  CountryCode["KW"] = "KW";
  CountryCode["LA"] = "LA";
  CountryCode["LV"] = "LV";
  CountryCode["LB"] = "LB";
  CountryCode["LI"] = "LI";
  CountryCode["LT"] = "LT";
  CountryCode["LU"] = "LU";
  CountryCode["MK"] = "MK";
  CountryCode["MY"] = "MY";
  CountryCode["MV"] = "MV";
  CountryCode["MT"] = "MT";
  CountryCode["MU"] = "MU";
  CountryCode["MX"] = "MX";
  CountryCode["MD"] = "MD";
  CountryCode["MC"] = "MC";
  CountryCode["MA"] = "MA";
  CountryCode["NP"] = "NP";
  CountryCode["NZ"] = "NZ";
  CountryCode["NI"] = "NI";
  CountryCode["NG"] = "NG";
  CountryCode["OM"] = "OM";
  CountryCode["PK"] = "PK";
  CountryCode["PY"] = "PY";
  CountryCode["PH"] = "PH";
  CountryCode["PL"] = "PL";
  CountryCode["PR"] = "PR";
  CountryCode["RO"] = "RO";
  CountryCode["RU"] = "RU";
  CountryCode["SM"] = "SM";
  CountryCode["SA"] = "SA";
  CountryCode["SN"] = "SN";
  CountryCode["SK"] = "SK";
  CountryCode["SI"] = "SI";
  CountryCode["ZA"] = "ZA";
  CountryCode["LK"] = "LK";
  CountryCode["TJ"] = "TJ";
  CountryCode["TH"] = "TH";
  CountryCode["TN"] = "TN";
  CountryCode["TR"] = "TR";
  CountryCode["TM"] = "TM";
  CountryCode["UA"] = "UA";
  CountryCode["UY"] = "UY";
  CountryCode["UZ"] = "UZ";
  CountryCode["VA"] = "VA";
  CountryCode["VE"] = "VE";
  CountryCode["ZM"] = "ZM";
  CountryCode["AS"] = "AS";
  CountryCode["CC"] = "CC";
  CountryCode["CK"] = "CK";
  CountryCode["RS"] = "RS";
  CountryCode["ME"] = "ME";
  CountryCode["CS"] = "CS";
  CountryCode["YU"] = "YU";
  CountryCode["CX"] = "CX";
  CountryCode["ET"] = "ET";
  CountryCode["FK"] = "FK";
  CountryCode["NF"] = "NF";
  CountryCode["FM"] = "FM";
  CountryCode["GF"] = "GF";
  CountryCode["GN"] = "GN";
  CountryCode["GP"] = "GP";
  CountryCode["GS"] = "GS";
  CountryCode["GU"] = "GU";
  CountryCode["GW"] = "GW";
  CountryCode["HM"] = "HM";
  CountryCode["IQ"] = "IQ";
  CountryCode["KG"] = "KG";
  CountryCode["LR"] = "LR";
  CountryCode["LS"] = "LS";
  CountryCode["MG"] = "MG";
  CountryCode["MH"] = "MH";
  CountryCode["MN"] = "MN";
  CountryCode["MP"] = "MP";
  CountryCode["MQ"] = "MQ";
  CountryCode["NC"] = "NC";
  CountryCode["NE"] = "NE";
  CountryCode["VI"] = "VI";
  CountryCode["PF"] = "PF";
  CountryCode["PG"] = "PG";
  CountryCode["PM"] = "PM";
  CountryCode["PN"] = "PN";
  CountryCode["PW"] = "PW";
  CountryCode["RE"] = "RE";
  CountryCode["SH"] = "SH";
  CountryCode["SJ"] = "SJ";
  CountryCode["SO"] = "SO";
  CountryCode["SZ"] = "SZ";
  CountryCode["TC"] = "TC";
  CountryCode["WF"] = "WF";
  CountryCode["XK"] = "XK";
  CountryCode["YT"] = "YT";
  CountryCode["INTL"] = "INTL";
})(CountryCode || (CountryCode = {})); // TODO: Remove CountryCode.UK in next major version release


var POSTCODE_REGEXES = new Map([[CountryCode.UK, /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i], [CountryCode.GB, /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i], [CountryCode.JE, /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/], [CountryCode.GG, /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/], [CountryCode.IM, /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/], [CountryCode.US, /^([0-9]{5})(?:-([0-9]{4}))?$/], [CountryCode.CA, /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\s*([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/i], [CountryCode.IE, /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/], [CountryCode.DE, /^\d{5}$/], [CountryCode.JP, /^\d{3}-\d{4}$/], [CountryCode.FR, /^\d{2}[ ]?\d{3}$/], [CountryCode.AU, /^\d{4}$/], [CountryCode.IT, /^\d{5}$/], [CountryCode.CH, /^\d{4}$/], [CountryCode.AT, /^(?!0)\d{4}$/], [CountryCode.ES, /^\d{5}$/], [CountryCode.NL, /^\d{4}[ ]?[A-Z]{2}$/], [CountryCode.BE, /^\d{4}$/], [CountryCode.DK, /^\d{4}$/], [CountryCode.SE, /^(SE-)?\d{3}[ ]?\d{2}$/], [CountryCode.NO, /^\d{4}$/], [CountryCode.BR, /^\d{5}[\-]?\d{3}$/], [CountryCode.PT, /^\d{4}([\-]\d{3})?$/], [CountryCode.FI, /^(FI-|AX-)?\d{5}$/], [CountryCode.AX, /^22\d{3}$/], [CountryCode.KR, /^\d{5}$/], [CountryCode.CN, /^\d{6}$/], [CountryCode.TW, /^\d{3}(\d{2})?$/], [CountryCode.SG, /^\d{6}$/], [CountryCode.DZ, /^\d{5}$/], [CountryCode.AD, /^AD\d{3}$/], [CountryCode.AR, /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/], [CountryCode.AM, /^(37)?\d{4}$/], [CountryCode.AZ, /^\d{4}$/], [CountryCode.BH, /^((1[0-2]|[2-9])\d{2})?$/], [CountryCode.BD, /^\d{4}$/], [CountryCode.BB, /^(BB\d{5})?$/], [CountryCode.BY, /^\d{6}$/], [CountryCode.BM, /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/], [CountryCode.BA, /^\d{5}$/], [CountryCode.IO, /^BBND 1ZZ$/], [CountryCode.BN, /^[A-Z]{2}[ ]?\d{4}$/], [CountryCode.BG, /^\d{4}$/], [CountryCode.KH, /^\d{5}$/], [CountryCode.CV, /^\d{4}$/], [CountryCode.CL, /^\d{7}$/], [CountryCode.CR, /^\d{4,5}|\d{3}-\d{4}$/], [CountryCode.HR, /^(HR-)?\d{5}$/], [CountryCode.CY, /^\d{4}$/], [CountryCode.CZ, /^\d{3}[ ]?\d{2}$/], [CountryCode.DO, /^\d{5}$/], [CountryCode.EC, /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/], [CountryCode.EG, /^\d{5}$/], [CountryCode.EE, /^\d{5}$/], [CountryCode.FO, /^\d{3}$/], [CountryCode.GE, /^\d{4}$/], [CountryCode.GR, /^\d{3}[ ]?\d{2}$/], [CountryCode.GL, /^39\d{2}$/], [CountryCode.GT, /^\d{5}$/], [CountryCode.HT, /^\d{4}$/], [CountryCode.HN, /^(?:\d{5})?$/], [CountryCode.HU, /^\d{4}$/], [CountryCode.IS, /^\d{3}$/], [CountryCode.IN, /^\d{6}$/], [CountryCode.ID, /^\d{5}$/], [CountryCode.IL, /^\d{5,7}$/], [CountryCode.JO, /^\d{5}$/], [CountryCode.KZ, /^\d{6}$/], [CountryCode.KE, /^\d{5}$/], [CountryCode.KW, /^\d{5}$/], [CountryCode.LA, /^\d{5}$/], [CountryCode.LV, /^(LV-)?\d{4}$/], [CountryCode.LB, /^(\d{4}([ ]?\d{4})?)?$/], [CountryCode.LI, /^(948[5-9])|(949[0-7])$/], [CountryCode.LT, /^(LT-)?\d{5}$/], [CountryCode.LU, /^(L-)?\d{4}$/], [CountryCode.MK, /^\d{4}$/], [CountryCode.MY, /^\d{5}$/], [CountryCode.MV, /^\d{5}$/], [CountryCode.MT, /^[A-Z]{3}[ ]?\d{2,4}$/], [CountryCode.MU, /^((\d|[A-Z])\d{4})?$/], [CountryCode.MX, /^\d{5}$/], [CountryCode.MD, /^\d{4}$/], [CountryCode.MC, /^980\d{2}$/], [CountryCode.MA, /^\d{5}$/], [CountryCode.NP, /^\d{5}$/], [CountryCode.NZ, /^\d{4}$/], [CountryCode.NI, /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/], [CountryCode.NG, /^(\d{6})?$/], [CountryCode.OM, /^(PC )?\d{3}$/], [CountryCode.PK, /^\d{5}$/], [CountryCode.PY, /^\d{4}$/], [CountryCode.PH, /^\d{4}$/], [CountryCode.PL, /^\d{2}-\d{3}$/], [CountryCode.PR, /^00[679]\d{2}([ \-]\d{4})?$/], [CountryCode.RO, /^\d{6}$/], [CountryCode.RU, /^\d{6}$/], [CountryCode.SM, /^4789\d$/], [CountryCode.SA, /^\d{5}$/], [CountryCode.SN, /^\d{5}$/], [CountryCode.SK, /^\d{3}[ ]?\d{2}$/], [CountryCode.SI, /^(SI-)?\d{4}$/], [CountryCode.ZA, /^\d{4}$/], [CountryCode.LK, /^\d{5}$/], [CountryCode.TJ, /^\d{6}$/], [CountryCode.TH, /^\d{5}$/], [CountryCode.TN, /^\d{4}$/], [CountryCode.TR, /^\d{5}$/], [CountryCode.TM, /^\d{6}$/], [CountryCode.UA, /^\d{5}$/], [CountryCode.UY, /^\d{5}$/], [CountryCode.UZ, /^\d{6}$/], [CountryCode.VA, /^00120$/], [CountryCode.VE, /^\d{4}$/], [CountryCode.ZM, /^\d{5}$/], [CountryCode.AS, /^96799$/], [CountryCode.CC, /^6799$/], [CountryCode.CK, /^\d{4}$/], [CountryCode.RS, /^\d{5,6}$/], [CountryCode.ME, /^8\d{4}$/], [CountryCode.CS, /^\d{5}$/], [CountryCode.YU, /^\d{5}$/], [CountryCode.CX, /^6798$/], [CountryCode.ET, /^\d{4}$/], [CountryCode.FK, /^FIQQ 1ZZ$/], [CountryCode.NF, /^2899$/], [CountryCode.FM, /^(9694[1-4])([ \-]\d{4})?$/], [CountryCode.GF, /^9[78]3\d{2}$/], [CountryCode.GN, /^\d{3}$/], [CountryCode.GP, /^9[78][01]\d{2}$/], [CountryCode.GS, /^SIQQ 1ZZ$/], [CountryCode.GU, /^969[123]\d([ \-]\d{4})?$/], [CountryCode.GW, /^\d{4}$/], [CountryCode.HM, /^\d{4}$/], [CountryCode.IQ, /^\d{5}$/], [CountryCode.KG, /^\d{6}$/], [CountryCode.LR, /^\d{4}$/], [CountryCode.LS, /^\d{3}$/], [CountryCode.MG, /^\d{3}$/], [CountryCode.MH, /^969[67]\d([ \-]\d{4})?$/], [CountryCode.MN, /^\d{6}$/], [CountryCode.MP, /^9695[012]([ \-]\d{4})?$/], [CountryCode.MQ, /^9[78]2\d{2}$/], [CountryCode.NC, /^988\d{2}$/], [CountryCode.NE, /^\d{4}$/], [CountryCode.VI, /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/], [CountryCode.PF, /^987\d{2}$/], [CountryCode.PG, /^\d{3}$/], [CountryCode.PM, /^9[78]5\d{2}$/], [CountryCode.PN, /^PCRN 1ZZ$/], [CountryCode.PW, /^96940$/], [CountryCode.RE, /^9[78]4\d{2}$/], [CountryCode.SH, /^(ASCN|STHL) 1ZZ$/], [CountryCode.SJ, /^\d{4}$/], [CountryCode.SO, /^\d{5}$/], [CountryCode.SZ, /^[HLMS]\d{3}$/], [CountryCode.TC, /^TKCA 1ZZ$/], [CountryCode.WF, /^986\d{2}$/], [CountryCode.XK, /^\d{5}$/], [CountryCode.YT, /^976\d{2}$/], [CountryCode.INTL, /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/i]]);

var postcodeValidator = function postcodeValidator(postcode, country) {
  if (!POSTCODE_REGEXES.has(country)) {
    // throw Error if country code is unrecognised
    throw Error("Invalid country code: ".concat(country));
  }

  return POSTCODE_REGEXES.get(country).test(postcode);
};

var postcodeValidatorExistsForCountry = function postcodeValidatorExistsForCountry(country) {
  return POSTCODE_REGEXES.has(country);
};

var overridenValidators = {};

var overrideValidator = function overrideValidator(validatorField, newValidator) {
  logger.log("overrideValidator registering ".concat(newValidator, " for '").concat(validatorField, "'"));
  overridenValidators[validatorField] = newValidator;
};

var getOverridenValidator = function getOverridenValidator(validatorField) {
  if (overridenValidators[validatorField]) {
    logger.log("getOverridenValidator returning '".concat(validatorField, "'"));
    return overridenValidators[validatorField];
  }

  return null;
};

var resetOverriddenValidators = function resetOverriddenValidators() {
  overridenValidators = {};
  logger.info('Overridden validators have been reset');
};

var DECIMAL_RADIX = 10;
var ADOLESCENT_AGE = 16;
var MIN_BIRTHYEAR = 1900;
var MAX_BIRTHYEAR = 3000;
var VALID_PHONE_NUMBER_REGEXPS = [/^\+?0*\d{10,}(x[0-9]{0,5})?$/, /(^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$)/];

var validateMetadata = function validateMetadata(metadata) {
  var metadataKeyCount = Object.keys(metadata).length; // TOOD: Other metadata restrictions?

  if (metadataKeyCount > 20) {
    logger.error('Invalid number of metadata keys (max 20)', 'metadata keys');
    return false;
  }

  return true;
};

var ensureMaxMetadataKeyValueLengths = function ensureMaxMetadataKeyValueLengths(metadata) {
  var modifiedMetadata = {}; // TODO fix next line
  // eslint-disable-next-line

  for (var key in metadata) {
    var newKey = key;
    var newValue = metadata[key];

    if (newValue.length > 256) {
      logger.warn("Truncating metadata value '".concat(metadata[key], "' for key '").concat(newKey, "' (max length 256 characters)."));
      newValue = newValue.substring(0, 256);
    }

    if (newKey.length > 256) {
      logger.warn("Truncating metadata key '".concat(key, "' (max length 256 characters)."));
      newKey = newKey.substring(0, 256);
    }

    modifiedMetadata[newKey] = newValue;
  }

  return modifiedMetadata;
};

var getFieldValidationErrors = function getFieldValidationErrors(viewModel, formValidationOptions) {
  var fieldValidationErrors = getEmptyFieldValidationErrors();
  var metadata = getSafe(function () {
    return viewModel.metadata;
  }, null); // TODO fix next line
  // eslint-disable-next-line

  for (var fieldId in fieldValidationErrors) {
    if (viewModel.hasOwnProperty(fieldId)) {
      var fieldsToSkip = getSafe(function () {
        return viewModel.fieldsToSkipValidation;
      });

      if (Array.isArray(fieldsToSkip) && fieldsToSkip.indexOf(fieldId) > -1) {
        continue;
      }

      var fieldValue = viewModel[fieldId] ? viewModel[fieldId] : '';
      fieldValidationErrors[fieldId] = validateFieldById(fieldId, fieldValue, formValidationOptions);
    } else if (metadata !== null && typeof metadata === 'object' && metadata.hasOwnProperty(fieldId)) {
      var _fieldValue = metadata[fieldId] ? metadata[fieldId] : '';

      fieldValidationErrors[fieldId] = validateFieldById(fieldId, _fieldValue, formValidationOptions);
    }
  }

  return fieldValidationErrors;
};

var isFormFilled = function isFormFilled(viewModel, formValidationOptions) {
  var customValidatorFields = getCustomValidatorFields(); // TODO fix next line
  // eslint-disable-next-line

  for (var fieldId in viewModel) {
    var fieldValue = viewModel[fieldId] ? viewModel[fieldId] : '';
    var isFieldSkipped = viewModel.fieldsToSkipValidation && viewModel.fieldsToSkipValidation.includes(fieldId);

    if (FieldIdEnum[fieldId] && typeof validateFieldById(fieldId, fieldValue, formValidationOptions) === 'string' && !isFieldSkipped) {
      return false;
    }
  }

  var metadata = getSafe(function () {
    return viewModel.metadata;
  }, null);

  if (metadata !== null) {
    // TODO fix next line
    // eslint-disable-next-line
    for (var _fieldId in metadata) {
      var _fieldValue2 = metadata[_fieldId] !== undefined ? metadata[_fieldId] : '';

      if (customValidatorFields.includes(_fieldId) && typeof getCustomValidator(_fieldId)(_fieldValue2, formValidationOptions) === 'string') {
        return false;
      }
    }
  }

  return true;
};

var isFormErrored = function isFormErrored(currentFieldValidationErrors) {
  // TODO fix next line
  // eslint-disable-next-line
  for (var field in currentFieldValidationErrors) {
    if (currentFieldValidationErrors[field]) {
      logger.info("Field '".concat(field, "' has errorId '").concat(currentFieldValidationErrors[field], "'"));
      return true;
    }
  }

  return false;
};

var getValidationError = function getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions) {
  if (overriddenValidator) {
    logger.info("Using overridden validator for field '".concat(fieldId, "'"));
    return overriddenValidator(value, formValidationOptions);
  }

  return defaultValidator(value, formValidationOptions);
};

var getEmptyFieldValidationErrors = function getEmptyFieldValidationErrors() {
  var emptyFieldValidationErrors = getFieldValidationErrorsEmpty();
  var emptyExtendedFieldValidationErrors = getExtendedFieldValidationErrorsEmpty();

  var fieldValidationErrors = _objectSpread2({}, emptyFieldValidationErrors, emptyExtendedFieldValidationErrors);

  return fieldValidationErrors;
};

var getCustomValidationError = function getCustomValidationError(fieldId, value, formValidationOptions) {
  var customValidator = getCustomValidator(fieldId);
  logger.info("Using custom validator for custom field '".concat(fieldId, "'"));
  return customValidator ? customValidator(value, formValidationOptions) : undefined;
};

var customValidatorExists = function customValidatorExists(fieldId) {
  var customValidatorFields = getCustomValidatorFields();

  if (customValidatorFields.length && customValidatorFields.indexOf(fieldId) >= 0) {
    return true;
  }

  return false;
};

var getFirstNameValidationError = function getFirstNameValidationError(value) {
  var invalidError = 'invalidFirstName';

  if (value === undefined || !isValidName(value)) {
    return invalidError;
  }
};

var getLastNameValidationError = function getLastNameValidationError(value) {
  var invalidError = 'invalidLastName';

  if (value === undefined || !isValidName(value)) {
    return invalidError;
  }
};

var getMemberIdError = function getMemberIdError() {
  return undefined;
};

var getCountryValidationError = function getCountryValidationError(value) {
  var invalidError = 'invalidCountry';

  if (!value) {
    return invalidError;
  }
};

var getEmailValidationError = function getEmailValidationError(value) {
  var invalidError = 'invalidEmail';
  var VALID_EMAIL_REGEXP = /(^\s*?[A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+)*@([A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&''*+\/=?^_`{|}~-]+)+|\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])\s*?$)/;

  if (value === undefined || !VALID_EMAIL_REGEXP.test(value)) {
    return invalidError;
  }
};

var getPhoneNumberValidationError = function getPhoneNumberValidationError(failIfValueFalsy) {
  return function (value) {
    var invalidPhoneNumber = 'invalidPhoneNumber';

    if (failIfValueFalsy && !value) {
      return invalidPhoneNumber;
    }

    var matchedPatterns = VALID_PHONE_NUMBER_REGEXPS.filter(function (regexp) {
      return regexp.test(value);
    });

    if (value && matchedPatterns.length === 0) {
      return invalidPhoneNumber;
    }
  };
};

var getPhoneNumberValidator = function getPhoneNumberValidator(formValidationOptions) {
  return getPhoneNumberValidationError(formValidationOptions && formValidationOptions.smsLoopEnabled);
};

var getOrganizationValidationError = function getOrganizationValidationError(value) {
  var invalidError = 'invalidOrganization';

  if (value.id === undefined || Number.isNaN(value.id) || value.source !== 'EMPLOYER' && value.id < 0 || value.source === 'EMPLOYER' && (value.id > -1 || !value.idExtended) || value.id === 0 && value.name.length <= 0) {
    return invalidError;
  }
};

var isBirthDateEmpty = function isBirthDateEmpty(birthDate) {
  var noUndefined = birthDate.split('undefined').join('');
  return noUndefined.length <= 2;
};

var getBirthDateValidationError = function getBirthDateValidationError(value, formValidationOptions) {
  var invalidError = 'invalidBirthDate';
  var underagePersonError = 'underagePerson';
  var futureBirthDateError = 'futureBirthDate';
  var outsideAgeError = 'outsideAgePerson';

  if (getSafe(function () {
    return formValidationOptions.currentStep === 'collectMemberPersonalInfo';
  })) {
    if (value === undefined || value === '' || isBirthDateEmpty(value)) return;

    if (!isValidDateFormat(value) || !isValidDate(value)) {
      return invalidError;
    }
  } else if (value === undefined || !isValidDateFormat(value) || !isValidDate(value)) {
    return invalidError;
  }

  if (getSafe(function () {
    return formValidationOptions.minAge;
  }) && getSafe(function () {
    return formValidationOptions.maxAge;
  })) {
    return isAgeOutsideRange(value, formValidationOptions.minAge, formValidationOptions.maxAge) ? outsideAgeError : null;
  }

  if (isFutureDate(value)) {
    return futureBirthDateError;
  }

  if (isUnderageDate(value)) {
    return underagePersonError;
  }
};

var getFileValidationError = function getFileValidationError(file) {
  var hasFileExtension = function hasFileExtension(fileName) {
    return fileName && fileName.includes('.');
  };

  var noValidFilesError = 'noValidFiles';
  var invalidFileSizeMaxError = 'invalidFileSizeMax';
  var invalidFileSizeEmptyError = 'invalidFileSizeEmpty';
  var unsupportedDocMimeTypeError = 'unsupportedDocMimeType';
  var FILE_SIZE_10MB = 10485760;
  var validFileTypes = ACCEPTED_DOC_MIME_TYPES;

  if (file === undefined) {
    return noValidFilesError;
  } // If no extension, allow upload so API can determine if valid mime type


  if (hasFileExtension(file.name) && !validFileTypes.includes(file.type)) {
    return unsupportedDocMimeTypeError;
  }

  if (file.size > FILE_SIZE_10MB) {
    return invalidFileSizeMaxError;
  }

  if (file.size <= 0) {
    return invalidFileSizeEmptyError;
  }
};

var getPostalCodeValidationError = function getPostalCodeValidationError(value, formValidationOptions) {
  var invalidPostalCode = 'invalidPostalCode';
  var countryCode = getSafe(function () {
    return formValidationOptions.viewModel.countryChoice.value;
  }, 'US');

  if (isValidPostalCode(countryCode, value)) {
    return;
  }

  return invalidPostalCode;
};

var getAddress1ValidationError = function getAddress1ValidationError(value) {
  var invalidError = 'invalidAddress';

  if (!value) {
    return invalidError;
  }
};

var getCityValidationError = function getCityValidationError(value) {
  var invalidError = 'invalidCity';

  if (!value) {
    return invalidError;
  }
};

var getStateValidationError = function getStateValidationError(value) {
  var invalidError = 'invalidState';

  if (!isValidState(value)) {
    return invalidError;
  }
};

var getDischargeDateValidationError = function getDischargeDateValidationError(value, formValidationOptions) {
  var invalidDischargeDate = 'invalidDischargeDate';
  var futureDischargeDate = 'futureDischargeDate';
  var dischargeDateBeforeBirthDate = 'dischargeDateBeforeBirthDate';

  if (value === undefined || !isValidDateFormat(value) || !isValidDate(value)) {
    return invalidDischargeDate;
  }

  if (isFutureDate(value)) {
    return futureDischargeDate;
  }

  var dischargeDate = new Date(value);
  var birthDate = new Date(formValidationOptions.viewModel.birthDate);

  if (dischargeDate < birthDate) {
    return dischargeDateBeforeBirthDate;
  }
};

var getSsnValidationError = function getSsnValidationError(value) {
  var invalidSocialSecurityNumber = 'invalidSocialSecurityNumber';

  if (value.toString().length !== SSN_STRING_LENGTH) {
    return invalidSocialSecurityNumber;
  }
};

var getDriverLicenseNumberValidationError = function getDriverLicenseNumberValidationError(value) {
  var invalidDriverLicenseNumber = 'invalidDriverLicenseNumber';
  var VALID_DRIVER_LICENSE_REGEXP = /^[A-Za-z0-9-\*]{1,100}$/; // '*' is sometimes used in WA state

  if (value === undefined || !VALID_DRIVER_LICENSE_REGEXP.test(value)) {
    return invalidDriverLicenseNumber;
  }
};

var getStatusesValidationError = function getStatusesValidationError(value) {
  var invalidStatuses = 'invalidStatuses';

  if (!value || !isValidLicensedProfessionalStatus(value)) {
    return invalidStatuses;
  }
};

var isValidMilitaryStatus = function isValidMilitaryStatus(value) {
  var validMilitaryStatuses = ['ACTIVE_DUTY', 'VETERAN', 'RESERVIST', 'MILITARY_RETIREE', 'MILITARY_FAMILY'];

  if (validMilitaryStatuses.indexOf(value) >= 0) {
    return true;
  }

  return false;
};

var isValidFirstResponderStatus = function isValidFirstResponderStatus(value) {
  var validFirstResponderStatuses = ['FIREFIGHTER', 'POLICE', 'EMT'];

  if (validFirstResponderStatuses.indexOf(value) >= 0) {
    return true;
  }

  return false;
};

var isValidMedicalProfessionalStatus = function isValidMedicalProfessionalStatus(value) {
  var validMedicalProfessionalStatuses = ['NURSE', 'DOCTOR', 'OTHER_HEALTH_WORKER', 'DENTIST', 'PHARMACIST'];

  if (validMedicalProfessionalStatuses.indexOf(value) >= 0) {
    return true;
  }

  return false;
};

var getStatusValidationError = function getStatusValidationError(value) {
  var invalidStatus = 'invalidStatus';

  if (!value || !isValidMilitaryStatus(value) && !isValidFirstResponderStatus(value) && !isValidMedicalProfessionalStatus(value)) {
    return invalidStatus;
  }
};

var isValidLicensedProfessionalStatus = function isValidLicensedProfessionalStatus(value) {
  return value.length > 0;
};

var isValidName = function isValidName(value) {
  // eslint-disable-next-line
  var VALID_NAME_REGEXP = /((?:[A-Z_a-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u052F\u0531-\u0556\u0559\u0560-\u0588\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05EF-\u05F2\u0610-\u061A\u0620-\u065F\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06DF-\u06E4\u06ED-\u06EF\u06EA-\u06ED\u06FA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07CA-\u07F5\u07FA\u07FD\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D3-\u08E1\u08E3-\u0963\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u09FC\u09FE\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0C00-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u103F\u1050-\u108F\u109A-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u180B-\u180D\u1820-\u1878\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F\u1AA7\u1AB0-\u1ABE\u1B00-\u1B4B\u1B6B-\u1B73\u1B80-\u1BAF\u1BBA-\u1BF3\u1C00-\u1C37\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA672\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8E0-\uA8F7\uA8FB\uA8FD-\uA8FF\uA90A-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF\uA9E0-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD27\uDF00-\uDF1C\uDF27\uDF30-\uDF50]|\uD804[\uDC00-\uDC46\uDC82-\uDCBA\uDC7F-\uDC82\uDCD0-\uDCE8\uDD00-\uDD34\uDD44-\uDD46\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDC9-\uDDCC\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3B-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC5E\uDC80-\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE80-\uDEB7\uDF00-\uDF1A\uDF1D-\uDF2B]|\uD806[\uDC00-\uDC3A\uDCA0-\uDCDF\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDE9D\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD98\uDEE0-\uDEF6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFF1]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF])+)/g;
  return VALID_NAME_REGEXP.test(value);
};

var isValidDate = function isValidDate(value) {
  var dateParts = value.split('-');
  var dateYear = parseInt(dateParts[0], DECIMAL_RADIX);
  var dateMonth = parseInt(dateParts[1], DECIMAL_RADIX);
  var dateDay = parseInt(dateParts[2], DECIMAL_RADIX);
  var monthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  if (dateYear < MIN_BIRTHYEAR || dateYear > MAX_BIRTHYEAR || dateMonth <= 0 || dateMonth > 12) {
    return false;
  } // Check for leap years


  if (dateYear % 400 === 0 || dateYear % 100 !== 0 && dateYear % 4 === 0) {
    monthDays[1] = 29;
  }

  if (dateDay <= 0 || dateDay > monthDays[dateMonth - 1]) {
    return false;
  }

  return true;
};

var isValidDateFormat = function isValidDateFormat(value) {
  var VALID_DATE_FORMAT_REGEXP = /^\d{4}[\-\s\/]\d{1,2}[\-\s\/]\d{1,2}$/;

  if (VALID_DATE_FORMAT_REGEXP.test(value)) {
    return true;
  }

  return false;
};

var isFutureDate = function isFutureDate(value) {
  var currentDate = new Date();
  var candidateDate = new Date(value);
  return candidateDate > currentDate;
};

var isUnderageDate = function isUnderageDate(value) {
  var minAge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ADOLESCENT_AGE;
  var birthDateParts = value.split('-');
  var birthDateYear = parseInt(birthDateParts[0], DECIMAL_RADIX);
  var birthDateMonth = parseInt(birthDateParts[1], DECIMAL_RADIX);
  var birthDateDay = parseInt(birthDateParts[2], DECIMAL_RADIX);
  var currentYear = new Date().getFullYear();
  var currentMonth = new Date().getMonth() + 1;
  var currentDay = new Date().getDate();

  if (currentYear - birthDateYear === minAge) {
    if (currentMonth - birthDateMonth < 0) {
      return true;
    }

    if (currentMonth - birthDateMonth === 0) {
      if (currentDay - birthDateDay < 0) {
        return true;
      }
    }
  } else if (currentYear - birthDateYear < minAge) {
    return true;
  }

  return false;
};

var isOverageDate = function isOverageDate(value) {
  var maxAge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 120;
  var birthDateParts = value.split('-');
  var birthDateYear = parseInt(birthDateParts[0], DECIMAL_RADIX);
  var birthDateMonth = parseInt(birthDateParts[1], DECIMAL_RADIX);
  var birthDateDay = parseInt(birthDateParts[2], DECIMAL_RADIX);
  var currentYear = new Date().getFullYear();
  var currentMonth = new Date().getMonth() + 1;
  var currentDay = new Date().getDate();

  if (currentYear - birthDateYear === maxAge) {
    if (currentMonth - birthDateMonth > 0) {
      return true;
    }

    if (currentMonth - birthDateMonth === 0) {
      if (currentDay - birthDateDay > 0) {
        return true;
      }
    }
  } else if (currentYear - birthDateYear > maxAge) {
    return true;
  }

  return false;
};

var isAgeOutsideRange = function isAgeOutsideRange(value, minAge, maxAge) {
  return isUnderageDate(value, minAge) || isOverageDate(value, maxAge);
};

var isValidPostalCode = function isValidPostalCode() {
  var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'US';
  var value = arguments.length > 1 ? arguments[1] : undefined;
  var countryCodeString = countryCode;

  if (postcodeValidatorExistsForCountry(countryCodeString)) {
    return postcodeValidator(value, countryCodeString);
  }

  return false;
};
/**
 * @deprecated Use `isValidPostalCode('US', value)` instead
 *  */


var isValidUsPostalCode = function isValidUsPostalCode(value) {
  return isValidPostalCode('US', value);
};

var isValidState = function isValidState(value) {
  if (!value) {
    return false;
  }

  var validStateCodes = Object.values(StateEnum);

  if (validStateCodes.indexOf(value.toUpperCase()) >= 0) {
    return true;
  }

  return false;
};

var validateFieldById = function validateFieldById(fieldId, value, formValidationOptions) {
  assertValidFieldId(fieldId);
  var defaultValidator;
  var overriddenValidator = getOverridenValidator(fieldId);

  switch (fieldId) {
    case FieldIdEnum.firstName:
      defaultValidator = getFirstNameValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.lastName:
      defaultValidator = getLastNameValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.memberId:
      defaultValidator = getMemberIdError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.email:
      defaultValidator = getEmailValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.phoneNumber:
      defaultValidator = getPhoneNumberValidator(formValidationOptions);
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.organization:
      defaultValidator = getOrganizationValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.birthDate:
      defaultValidator = getBirthDateValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.postalCode:
      defaultValidator = getPostalCodeValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.address1:
      defaultValidator = getAddress1ValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.city:
      defaultValidator = getCityValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.state:
      defaultValidator = getStateValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.country:
      defaultValidator = getCountryValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.dischargeDate:
      defaultValidator = getDischargeDateValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.socialSecurityNumber:
      defaultValidator = getSsnValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.status:
      defaultValidator = getStatusValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.statuses:
      defaultValidator = getStatusesValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.driverLicenseNumber:
      defaultValidator = getDriverLicenseNumberValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    case FieldIdEnum.docUpload:
      defaultValidator = getFileValidationError;
      return getValidationError(fieldId, value, defaultValidator, overriddenValidator, formValidationOptions);

    default:
      if (customValidatorExists(fieldId)) {
        return getCustomValidationError(fieldId, value, formValidationOptions);
      }

  }
};

var refs = [];
var tabRef = null;
/**
 * @private
 */

var setRef = function setRef(fieldId, ref) {
  var newRefObject = {
    fieldId: fieldId,
    ref: ref
  };
  var currentRefIndex = refs.findIndex(function (o) {
    return o.fieldId === fieldId;
  });

  if (currentRefIndex !== -1) {
    refs[currentRefIndex] = newRefObject;
  } else {
    refs.push(newRefObject);
  }
};
/**
 * @private
 */


var getRefs = function getRefs() {
  return refs;
};
/**
 * @private
 */


var getRefByFieldId = function getRefByFieldId(fieldId) {
  var _iterator2 = _createForOfIteratorHelper(refs),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var ref = _step2.value;

      if (ref.fieldId === fieldId) {
        return ref.ref;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  logger.error("A ref for fieldId ".concat(fieldId, " could not be found. Has one been registered using setRef()?"), 'ref error');
  return null;
};
/**
 * @private
 */


var resetRefs = function resetRefs() {
  refs = [];
  logger.info('Refs have been reset');
};
/**
 * @private
 */


var setTabRef = function setTabRef(tab) {
  tabRef = tab;
};
/**
 * @private
 */


var getTabRef = function getTabRef() {
  return tabRef;
};
/**
 * @private
 */


var resetTabRef = function resetTabRef() {
  tabRef = null;
};
/**
 * @private
 */


var closeTabRef = function closeTabRef() {
  if (tabRef !== null) {
    tabRef.close();
    resetTabRef();
  }
};
/**
 * @private
 */


var setFocus = function setFocus(fieldId) {
  var fieldRef = getRefByFieldId(fieldId);

  if (fieldRef) {
    try {
      fieldRef.focus();
    } catch (e) {
      logger.error("The ref '".concat(fieldRef, "' could not be focused. Is the ref an HTMLInputElement or HTMLButtonElement?"), 'ref error');
    }
  } else {
    logger.error("A ref for fieldId '".concat(fieldId, "' could not be found. Has the ref been registered using setRef()?"), 'ref error');
  }
};

var updateViewModelOrganization = function updateViewModelOrganization(organization, verificationService) {
  var viewModel = verificationService.viewModel;
  var nextState = fn(viewModel, function (draft) {
    draft.organization.id = organization.id;
    draft.organization.idExtended = organization.idExtended;
    draft.organization.name = organization.name;

    if (viewModel.organization && viewModel.organization.source !== undefined) {
      draft.organization.source = viewModel.organization.source;
    }
  });
  verificationService.updateViewModel(nextState);
};

var populateViewModelFromQueryParams = function populateViewModelFromQueryParams(verificationService) {
  var viewModel = verificationService.viewModel;
  var queryParams = getQueryParamsFromUrl();
  var nextState = fn(viewModel, function (draft) {
    Object.keys(viewModel).forEach(function (key) {
      if (queryParams.has(key)) {
        draft[key] = queryParams.get(key);
      }
    });
  });
  verificationService.updateViewModel(nextState);
};

var updateFieldValidationErrors = function updateFieldValidationErrors(fieldValidationErrors, verificationService) {
  verificationService.updateFieldValidationErrors(fieldValidationErrors);
};

var updateFieldValidationErrorsByFieldId = function updateFieldValidationErrorsByFieldId(fieldId, value, verificationService) {
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var nextState = fn(fieldValidationErrors, function (draft) {
    if (draft[fieldId]) {
      draft[fieldId] = validateFieldById(fieldId, value, verificationService.formValidationOptions);
    }
  });
  updateFieldValidationErrors(nextState, verificationService);
};

var shouldCollectAddressFields = function shouldCollectAddressFields(countryChoice, countries) {
  return getSafe(function () {
    return countries.length === 1;
  }) && getSafe(function () {
    return countries[0];
  }) === 'US' || getSafe(function () {
    return countryChoice.value === 'US';
  }) || getSafe(function () {
    return countryChoice.value === undefined;
  });
};

var getStatusLabel = function getStatusLabel(intl, status, defaultMessages) {
  if (!status) {
    return '';
  }

  return intl.formatMessage({
    id: status,
    defaultMessage: defaultMessages[status]
  });
};

var getAvailableMilitaryStatuses = function getAvailableMilitaryStatuses(verificationService, intl) {
  var availableStatusesResponse = verificationService.verificationResponse.availableStatuses || verificationService.previousVerificationResponse && verificationService.previousVerificationResponse.availableStatuses;
  var availableStatuses = [];

  if (!availableStatusesResponse) {
    return null;
  }

  availableStatusesResponse.forEach(function (status) {
    availableStatuses.push({
      value: status,
      label: getStatusLabel(intl, status, MilitaryStatusDefaultMessagesEnum)
    });
  });
  return availableStatuses;
};
/**
 * @private
 */


var getFieldDisplayOrderFromRefs = function getFieldDisplayOrderFromRefs() {
  var refs = getRefs();
  var fieldDisplayOrder = [];
  refs.map(function (refObject) {
    return fieldDisplayOrder.push(refObject.fieldId);
  });
  return fieldDisplayOrder;
};
/**
 * HD-638 - focus on year, rather than month (which is an open <select> that covers error msg)
 */


var adjustFirstErroredFieldId = function adjustFirstErroredFieldId(firstErroredFieldId) {
  if (firstErroredFieldId === 'birthDate' || firstErroredFieldId === 'birthDateDay') {
    return 'birthDateYear';
  }

  return firstErroredFieldId;
};
/**
 * @private
 */


var getFirstErroredFieldId = function getFirstErroredFieldId(fieldDisplayOrder, fieldValidationErrors) {
  var firstErroredFieldId;
  fieldDisplayOrder.reverse().forEach(function (field) {
    if (fieldValidationErrors[field]) {
      firstErroredFieldId = field;
      return adjustFirstErroredFieldId(firstErroredFieldId);
    }
  });
  return adjustFirstErroredFieldId(firstErroredFieldId);
};
/**
 * @private
 */


var handleEmailOnKeyDown = function handleEmailOnKeyDown(event) {
  var submitButtonRef = getRefByFieldId('submitButton');

  if (event.key === 'Enter' && submitButtonRef) {
    submitButtonRef.click();
  }
};
/**
 * @private
 */


var handleCountryOnKeyDown = function handleCountryOnKeyDown(event) {
  if (event.key === 'Tab' && !event.shiftKey) {
    event.preventDefault();
    setFocus('organization');
  }
};
/**
 * @public
 */


var submitForm = function submitForm(viewModel, verificationService, step) {
  var currentFieldValidationErrors = getFieldValidationErrors(viewModel, verificationService.formValidationOptions);
  var isFormValid = !isFormErrored(currentFieldValidationErrors);

  if (isFormValid) {
    logger.info("".concat(step, " submitting form"));
    verificationService.submitStep(step, viewModel, verificationService.verificationResponse);
  } else {
    var fieldDisplayOrder = getFieldDisplayOrderFromRefs();
    var firstErroredFieldId = getFirstErroredFieldId(fieldDisplayOrder, currentFieldValidationErrors);
    updateFieldValidationErrors(currentFieldValidationErrors, verificationService);
    setFocus(firstErroredFieldId);
  }
};
/**
 * @public
 * @description Help with commonly-accessed values. Returns the fully-resolved verbiage in the appropriate language.
 * @return {Object}
 */


var getEstAndMaxReviewTimes = function getEstAndMaxReviewTimes(verificationResponse, programTheme, intl) {
  var estReviewTime = intl.formatMessage({
    id: "dateTime.".concat(getSafe(function () {
      return verificationResponse.estimatedReviewTime;
    }) || getEstimatedReviewTime(programTheme)),
    default: 'a few minutes'
  });
  var maxReviewTime = intl.formatMessage({
    id: "dateTime.".concat(getSafe(function () {
      return verificationResponse.maxReviewTime;
    }) || getMaxReviewTime(programTheme)),
    default: '2 hours'
  });
  return {
    estReviewTime: estReviewTime,
    maxReviewTime: maxReviewTime
  };
};
/**
 * @private
 */


var getAvailableCountryChoices = function getAvailableCountryChoices(programTheme, intl) {
  var availableCountries = getConfiguredCountries(programTheme);
  return availableCountries.map(function (countryCode) {
    return {
      value: countryCode,
      label: intl.formatMessage({
        id: "countries.".concat(countryCode),
        defaultMessage: countryCode
      })
    };
  });
};

var getAvailableStateChoices = function getAvailableStateChoices(programTheme, intl) {
  var availableStates = getConfiguredStates(programTheme);
  return availableStates.map(function (stateCode) {
    return {
      value: stateCode,
      label: intl.formatMessage({
        id: "states.".concat(stateCode),
        defaultMessage: stateCode
      })
    };
  });
};

var produceDraftViewModelWithRequiredFields = function produceDraftViewModelWithRequiredFields(previousModel, newRequiredFields, conditionalRequiredFieldKeys) {
  return fn(previousModel, function (draft) {
    conditionalRequiredFieldKeys.forEach(function (requiredFieldKey) {
      if (newRequiredFields.some(function (field) {
        return field.key === requiredFieldKey;
      })) {
        draft[requiredFieldKey] = previousModel[requiredFieldKey] !== undefined ? previousModel[requiredFieldKey] : '';
      } else {
        delete draft[requiredFieldKey];
      }
    });
  });
};
/**
 * @private
 */


var getAvailableLocaleChoices = function getAvailableLocaleChoices(programTheme, intl) {
  var availableLocales = getAvailableLocales(programTheme);
  return availableLocales.map(function (locale) {
    return {
      value: locale,
      label: intl.formatMessage({
        id: "locales.".concat(locale),
        defaultMessage: locale
      })
    };
  });
};
/**
 * @private
 */


var getDefaultCountryChoice = function getDefaultCountryChoice(countryChoices) {
  if (countryChoices.length > 0) {
    return countryChoices[0];
  }

  return {
    value: 'US',
    label: 'United States'
  };
};
/**
 * @private
 */


var produceDraftViewModel = function produceDraftViewModel(previousModel, key, value) {
  return fn(previousModel, function (draft) {
    draft[key] = value;
  });
};

var InputText = function InputText(_ref32) {
  var id = _ref32.id,
      isErrored = _ref32.isErrored,
      _ref32$className = _ref32.className,
      className = _ref32$className === void 0 ? undefined : _ref32$className,
      _ref32$hidePlaceholde = _ref32.hidePlaceholder,
      hidePlaceholder = _ref32$hidePlaceholde === void 0 ? true : _ref32$hidePlaceholde,
      refId = _ref32.refId,
      _ref32$required = _ref32.required,
      required = _ref32$required === void 0 ? false : _ref32$required,
      _ref32$type = _ref32.type,
      type = _ref32$type === void 0 ? 'text' : _ref32$type,
      ariaDescribedBy = _ref32.ariaDescribedBy,
      ariaLabel = _ref32.ariaLabel,
      props = _objectWithoutProperties2(_ref32, ["id", "isErrored", "className", "hidePlaceholder", "refId", "required", "type", "ariaDescribedBy", "ariaLabel"]);

  var internalClassName = '';
  if (className) internalClassName += "".concat(className, " "); // want this first

  internalClassName += 'sid-text-input sid-l-full-width';
  if (hidePlaceholder) internalClassName += ' sid-hidden-placeholder';
  if (required) internalClassName += ' sid-text-input--required';
  if (isErrored) internalClassName += ' sid-text-input--error';
  var finalRefId = refId || id;
  return React.createElement("input", Object.assign({
    className: internalClassName,
    id: "sid-".concat(id),
    name: "sid-".concat(id),
    type: type,
    "aria-describedby": ariaDescribedBy,
    "aria-label": ariaLabel,
    "aria-required": required,
    "aria-invalid": isErrored,
    ref: function ref(input) {
      return setRef(finalRefId, input);
    }
  }, props));
}; // TODO remove injectIntl, unused


var InputTextComponent = injectIntl(InputText);

var FirstName = function FirstName(_ref33) {
  var value = _ref33.value,
      isErrored = _ref33.isErrored,
      _onChange = _ref33.onChange,
      intl = _ref33.intl,
      _ref33$placeholder = _ref33.placeholder,
      placeholder = _ref33$placeholder === void 0 ? '' : _ref33$placeholder;
  return React.createElement("div", {
    className: "sid-field sid-first-name"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-first-name"
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement(FormattedHTMLMessage, {
    id: "firstName",
    defaultMessage: "First name"
  }))), React.createElement(InputTextComponent, {
    id: "first-name",
    isErrored: isErrored,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    placeholder: placeholder || intl.formatMessage({
      id: 'firstNamePlaceholder',
      defaultMessage: 'First Name*'
    }),
    refId: "firstName",
    value: value,
    required: true
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidFirstName",
    defaultMessage: "Invalid first name"
  })) : null);
};

var FirstNameComponent = injectIntl(FirstName);

var LastName = function LastName(_ref34) {
  var value = _ref34.value,
      isErrored = _ref34.isErrored,
      _onChange2 = _ref34.onChange,
      intl = _ref34.intl,
      _ref34$placeholder = _ref34.placeholder,
      placeholder = _ref34$placeholder === void 0 ? '' : _ref34$placeholder;
  return React.createElement("div", {
    className: "sid-field sid-last-name"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-last-name"
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement(FormattedHTMLMessage, {
    id: "lastName",
    defaultMessage: "Last name"
  }))), React.createElement(InputTextComponent, {
    id: "last-name",
    isErrored: isErrored,
    onChange: function onChange(event) {
      return _onChange2(event.target.value);
    },
    placeholder: placeholder || intl.formatMessage({
      id: 'lastNamePlaceholder',
      defaultMessage: 'Last Name*'
    }),
    refId: "lastName",
    value: value,
    required: true
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidLastName",
    defaultMessage: "Invalid last name"
  })) : null);
};

var LastNameComponent = injectIntl(LastName);

var Email = function Email(_ref35) {
  var value = _ref35.value,
      isErrored = _ref35.isErrored,
      _onChange3 = _ref35.onChange,
      explanation = _ref35.explanation,
      intl = _ref35.intl,
      _ref35$onKeyDown = _ref35.onKeyDown,
      onKeyDown = _ref35$onKeyDown === void 0 ? undefined : _ref35$onKeyDown,
      _ref35$placeholder = _ref35.placeholder,
      placeholder = _ref35$placeholder === void 0 ? '' : _ref35$placeholder;
  return React.createElement("div", {
    className: "sid-field sid-email"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-email"
  }, React.createElement("div", {
    className: "sid-field__label-with-explanation sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required"
  }, React.createElement(FormattedHTMLMessage, {
    id: "emailAddress",
    defaultMessage: "Email address"
  })), React.createElement("div", {
    className: "sid-field__label-explanation"
  }, explanation || React.createElement(FormattedHTMLMessage, {
    id: "emailExplanation",
    defaultMessage: "Needed to send you your unique code"
  })))), React.createElement(InputTextComponent, {
    id: "email",
    isErrored: isErrored,
    onChange: function onChange(event) {
      return _onChange3(event.target.value);
    },
    onKeyDown: typeof onKeyDown === 'function' ? function (e) {
      return onKeyDown(e);
    } : undefined,
    placeholder: placeholder || intl.formatMessage({
      id: 'emailAddressPlaceholder',
      defaultMessage: 'Email*'
    }),
    type: "email",
    value: value,
    required: true
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidEmail",
    defaultMessage: "Invalid email"
  })) : null);
};

var EmailComponent = injectIntl(Email);

var RequestOrganizationSearchResultComponent = function RequestOrganizationSearchResultComponent(_ref36) {
  var eligibleOrgs = _ref36.eligibleOrgs,
      ineligibleOrgs = _ref36.ineligibleOrgs;

  var hasMaxResults = function hasMaxResults() {
    return eligibleOrgs.length + ineligibleOrgs.length >= requestOrganizationConstants.MAX_RESULT_SIZE;
  };

  return React.createElement("div", {
    className: "sid-l-space-top-md"
  }, hasMaxResults() ? React.createElement("div", {
    className: "sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.tooManyResults",
    defaultMessage: "Your search returned too many results, please refine your search and try again"
  })) : null, React.createElement("div", null, React.createElement(FormattedHTMLMessage, {
    id: "eligibleOrgs",
    defaultMessage: "Eligible schools. Click the icon to copy name then return to the verification form:"
  })), React.createElement("div", {
    className: "sid-l-space-top-sm"
  }, eligibleOrgs.length > 0 ? eligibleOrgs.map(function (organization) {
    return React.createElement(OrganizationResultComponent, {
      key: organization.id,
      organization: organization,
      isEligible: true
    });
  }) : React.createElement("div", null, React.createElement(FormattedHTMLMessage, {
    id: "none",
    defaultMessage: "None"
  }))), React.createElement("div", {
    className: "sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "ineligibleOrgs",
    defaultMessage: "Ineligible Schools. We are sorry, people from these schools are not eligible for this offer:"
  })), React.createElement("div", {
    className: "sid-l-space-top-sm"
  }, ineligibleOrgs.length > 0 ? ineligibleOrgs.map(function (organization) {
    return React.createElement(OrganizationResultComponent, {
      key: organization.id,
      organization: organization,
      isEligible: false
    });
  }) : React.createElement("div", null, React.createElement(FormattedHTMLMessage, {
    id: "none",
    defaultMessage: "None"
  }))));
};

var SearchFieldComponent = function SearchFieldComponent(_ref37) {
  var name = _ref37.name,
      label = _ref37.label,
      value = _ref37.value,
      placeholder = _ref37.placeholder,
      isErrored = _ref37.isErrored,
      _onChange4 = _ref37.onChange,
      onKeyDown = _ref37.onKeyDown,
      search = _ref37.search;

  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.key === 'Enter') {
      search();
    } else if (onKeyDown) {
      onKeyDown();
    }
  };

  return React.createElement("div", {
    className: "sid-field"
  }, React.createElement("label", {
    htmlFor: "sid-".concat(name)
  }, React.createElement("div", {
    className: "sid-field__label sid-l-space-btm-sm"
  }, label)), React.createElement("div", {
    className: "sid-field-search"
  }, React.createElement("input", {
    className: "sid-text-input sid-text-input--required sid-field-search-input\n                        sid-l-full-width ".concat(isErrored ? 'sid-text-input--error' : ''),
    id: "sid-".concat(name),
    name: "sid-".concat(name),
    type: "text",
    value: value,
    onChange: function onChange(e) {
      return _onChange4(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      return handleOnKeyDown(e);
    },
    placeholder: placeholder
  }), React.createElement("div", {
    tabIndex: 0,
    onClick: function onClick() {
      return search();
    },
    onKeyUp: function onKeyUp() {
      return search();
    },
    role: "button"
  }, React.createElement("img", {
    className: "sid-l-search-icon",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/requestOrganization/search.svg",
    alt: "Search"
  }))), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement("span", null, React.createElement(FormattedHTMLMessage, {
    id: "errorId.".concat(isErrored),
    defaultMessage: "An unexpected error occurred"
  }))) : null);
};

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b$3 = "function" === typeof Symbol && Symbol.for,
    c$3 = b$3 ? Symbol.for("react.element") : 60103,
    d$3 = b$3 ? Symbol.for("react.portal") : 60106,
    e$4 = b$3 ? Symbol.for("react.fragment") : 60107,
    f$3 = b$3 ? Symbol.for("react.strict_mode") : 60108,
    g$3 = b$3 ? Symbol.for("react.profiler") : 60114,
    h$3 = b$3 ? Symbol.for("react.provider") : 60109,
    k$3 = b$3 ? Symbol.for("react.context") : 60110,
    l$3 = b$3 ? Symbol.for("react.async_mode") : 60111,
    m$3 = b$3 ? Symbol.for("react.concurrent_mode") : 60111,
    n$4 = b$3 ? Symbol.for("react.forward_ref") : 60112,
    p$3 = b$3 ? Symbol.for("react.suspense") : 60113,
    q$3 = b$3 ? Symbol.for("react.suspense_list") : 60120,
    r$4 = b$3 ? Symbol.for("react.memo") : 60115,
    t$3 = b$3 ? Symbol.for("react.lazy") : 60116,
    v$3 = b$3 ? Symbol.for("react.block") : 60121,
    w$3 = b$3 ? Symbol.for("react.fundamental") : 60117,
    x$3 = b$3 ? Symbol.for("react.responder") : 60118,
    y$3 = b$3 ? Symbol.for("react.scope") : 60119;

function z$3(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c$3:
        switch (a = a.type, a) {
          case l$3:
          case m$3:
          case e$4:
          case g$3:
          case f$3:
          case p$3:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k$3:
              case n$4:
              case t$3:
              case r$4:
              case h$3:
                return a;

              default:
                return u;
            }

        }

      case d$3:
        return u;
    }
  }
}

function A$3(a) {
  return z$3(a) === m$3;
}

var AsyncMode$2 = l$3;
var ConcurrentMode$2 = m$3;
var ContextConsumer$3 = k$3;
var ContextProvider$3 = h$3;
var Element$3 = c$3;
var ForwardRef$3 = n$4;
var Fragment$3 = e$4;
var Lazy$3 = t$3;
var Memo$3 = r$4;
var Portal$3 = d$3;
var Profiler$3 = g$3;
var StrictMode$3 = f$3;
var Suspense$3 = p$3;

var isAsyncMode$3 = function isAsyncMode$3(a) {
  return A$3(a) || z$3(a) === l$3;
};

var isConcurrentMode$3 = A$3;

var isContextConsumer$3 = function isContextConsumer$3(a) {
  return z$3(a) === k$3;
};

var isContextProvider$3 = function isContextProvider$3(a) {
  return z$3(a) === h$3;
};

var isElement$3 = function isElement$3(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$3;
};

var isForwardRef$3 = function isForwardRef$3(a) {
  return z$3(a) === n$4;
};

var isFragment$3 = function isFragment$3(a) {
  return z$3(a) === e$4;
};

var isLazy$3 = function isLazy$3(a) {
  return z$3(a) === t$3;
};

var isMemo$3 = function isMemo$3(a) {
  return z$3(a) === r$4;
};

var isPortal$3 = function isPortal$3(a) {
  return z$3(a) === d$3;
};

var isProfiler$3 = function isProfiler$3(a) {
  return z$3(a) === g$3;
};

var isStrictMode$3 = function isStrictMode$3(a) {
  return z$3(a) === f$3;
};

var isSuspense$3 = function isSuspense$3(a) {
  return z$3(a) === p$3;
};

var isValidElementType$3 = function isValidElementType$3(a) {
  return "string" === typeof a || "function" === typeof a || a === e$4 || a === m$3 || a === g$3 || a === f$3 || a === p$3 || a === q$3 || "object" === typeof a && null !== a && (a.$$typeof === t$3 || a.$$typeof === r$4 || a.$$typeof === h$3 || a.$$typeof === k$3 || a.$$typeof === n$4 || a.$$typeof === w$3 || a.$$typeof === x$3 || a.$$typeof === y$3 || a.$$typeof === v$3);
};

var typeOf$3 = z$3;
var reactIs_production_min$3 = {
  AsyncMode: AsyncMode$2,
  ConcurrentMode: ConcurrentMode$2,
  ContextConsumer: ContextConsumer$3,
  ContextProvider: ContextProvider$3,
  Element: Element$3,
  ForwardRef: ForwardRef$3,
  Fragment: Fragment$3,
  Lazy: Lazy$3,
  Memo: Memo$3,
  Portal: Portal$3,
  Profiler: Profiler$3,
  StrictMode: StrictMode$3,
  Suspense: Suspense$3,
  isAsyncMode: isAsyncMode$3,
  isConcurrentMode: isConcurrentMode$3,
  isContextConsumer: isContextConsumer$3,
  isContextProvider: isContextProvider$3,
  isElement: isElement$3,
  isForwardRef: isForwardRef$3,
  isFragment: isFragment$3,
  isLazy: isLazy$3,
  isMemo: isMemo$3,
  isPortal: isPortal$3,
  isProfiler: isProfiler$3,
  isStrictMode: isStrictMode$3,
  isSuspense: isSuspense$3,
  isValidElementType: isValidElementType$3,
  typeOf: typeOf$3
};
var reactIs_development$3 = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
reactIs_development$3.AsyncMode;
reactIs_development$3.ConcurrentMode;
reactIs_development$3.ContextConsumer;
reactIs_development$3.ContextProvider;
reactIs_development$3.Element;
reactIs_development$3.ForwardRef;
reactIs_development$3.Fragment;
reactIs_development$3.Lazy;
reactIs_development$3.Memo;
reactIs_development$3.Portal;
reactIs_development$3.Profiler;
reactIs_development$3.StrictMode;
reactIs_development$3.Suspense;
reactIs_development$3.isAsyncMode;
reactIs_development$3.isConcurrentMode;
reactIs_development$3.isContextConsumer;
reactIs_development$3.isContextProvider;
reactIs_development$3.isElement;
reactIs_development$3.isForwardRef;
reactIs_development$3.isFragment;
reactIs_development$3.isLazy;
reactIs_development$3.isMemo;
reactIs_development$3.isPortal;
reactIs_development$3.isProfiler;
reactIs_development$3.isStrictMode;
reactIs_development$3.isSuspense;
reactIs_development$3.isValidElementType;
reactIs_development$3.typeOf;
var reactIs$3 = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$3;
  } else {
    module.exports = reactIs_development$3;
  }
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols$1) {
      symbols = getOwnPropertySymbols$1(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

var printWarning$1 = function printWarning$1() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;
var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs$3.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs$3; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});
propTypes.array;
propTypes.arrayOf;
propTypes.func;
propTypes.number;
propTypes.object;
propTypes.oneOf;
propTypes.oneOfType;
propTypes.string;
propTypes.any;
propTypes.bool;
propTypes.shape;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b$2 = 60103,
    c$2 = 60106,
    d$2 = 60107,
    e$3 = 60108,
    f$2 = 60114,
    g$2 = 60109,
    h$2 = 60110,
    k$2 = 60112,
    l$2 = 60113,
    m$2 = 60120,
    n$3 = 60115,
    p$2 = 60116,
    q$2 = 60121,
    r$3 = 60122,
    u = 60117,
    v$2 = 60129,
    w$2 = 60131;

if ("function" === typeof Symbol && Symbol.for) {
  var x$2 = Symbol.for;
  b$2 = x$2("react.element");
  c$2 = x$2("react.portal");
  d$2 = x$2("react.fragment");
  e$3 = x$2("react.strict_mode");
  f$2 = x$2("react.profiler");
  g$2 = x$2("react.provider");
  h$2 = x$2("react.context");
  k$2 = x$2("react.forward_ref");
  l$2 = x$2("react.suspense");
  m$2 = x$2("react.suspense_list");
  n$3 = x$2("react.memo");
  p$2 = x$2("react.lazy");
  q$2 = x$2("react.block");
  r$3 = x$2("react.server.block");
  u = x$2("react.fundamental");
  v$2 = x$2("react.debug_trace_mode");
  w$2 = x$2("react.legacy_hidden");
}

function y$2(a) {
  if ("object" === typeof a && null !== a) {
    var t = a.$$typeof;

    switch (t) {
      case b$2:
        switch (a = a.type, a) {
          case d$2:
          case f$2:
          case e$3:
          case l$2:
          case m$2:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case h$2:
              case k$2:
              case p$2:
              case n$3:
              case g$2:
                return a;

              default:
                return t;
            }

        }

      case c$2:
        return t;
    }
  }
}

var z$2 = g$2,
    A$2 = b$2,
    B = k$2,
    C = d$2,
    D = p$2,
    E = n$3,
    F = c$2,
    G = f$2,
    H = e$3,
    I = l$2;
var ContextConsumer$2 = h$2;
var ContextProvider$2 = z$2;
var Element$2 = A$2;
var ForwardRef$2 = B;
var Fragment$2 = C;
var Lazy$2 = D;
var Memo$2 = E;
var Portal$2 = F;
var Profiler$2 = G;
var StrictMode$2 = H;
var Suspense$2 = I;

var isAsyncMode$2 = function isAsyncMode$2() {
  return !1;
};

var isConcurrentMode$2 = function isConcurrentMode$2() {
  return !1;
};

var isContextConsumer$2 = function isContextConsumer$2(a) {
  return y$2(a) === h$2;
};

var isContextProvider$2 = function isContextProvider$2(a) {
  return y$2(a) === g$2;
};

var isElement$2 = function isElement$2(a) {
  return "object" === typeof a && null !== a && a.$$typeof === b$2;
};

var isForwardRef$2 = function isForwardRef$2(a) {
  return y$2(a) === k$2;
};

var isFragment$2 = function isFragment$2(a) {
  return y$2(a) === d$2;
};

var isLazy$2 = function isLazy$2(a) {
  return y$2(a) === p$2;
};

var isMemo$2 = function isMemo$2(a) {
  return y$2(a) === n$3;
};

var isPortal$2 = function isPortal$2(a) {
  return y$2(a) === c$2;
};

var isProfiler$2 = function isProfiler$2(a) {
  return y$2(a) === f$2;
};

var isStrictMode$2 = function isStrictMode$2(a) {
  return y$2(a) === e$3;
};

var isSuspense$2 = function isSuspense$2(a) {
  return y$2(a) === l$2;
};

var isValidElementType$2 = function isValidElementType$2(a) {
  return "string" === typeof a || "function" === typeof a || a === d$2 || a === f$2 || a === v$2 || a === e$3 || a === l$2 || a === m$2 || a === w$2 || "object" === typeof a && null !== a && (a.$$typeof === p$2 || a.$$typeof === n$3 || a.$$typeof === g$2 || a.$$typeof === h$2 || a.$$typeof === k$2 || a.$$typeof === u || a.$$typeof === q$2 || a[0] === r$3) ? !0 : !1;
};

var typeOf$2 = y$2;
var reactIs_production_min$2 = {
  ContextConsumer: ContextConsumer$2,
  ContextProvider: ContextProvider$2,
  Element: Element$2,
  ForwardRef: ForwardRef$2,
  Fragment: Fragment$2,
  Lazy: Lazy$2,
  Memo: Memo$2,
  Portal: Portal$2,
  Profiler: Profiler$2,
  StrictMode: StrictMode$2,
  Suspense: Suspense$2,
  isAsyncMode: isAsyncMode$2,
  isConcurrentMode: isConcurrentMode$2,
  isContextConsumer: isContextConsumer$2,
  isContextProvider: isContextProvider$2,
  isElement: isElement$2,
  isForwardRef: isForwardRef$2,
  isFragment: isFragment$2,
  isLazy: isLazy$2,
  isMemo: isMemo$2,
  isPortal: isPortal$2,
  isProfiler: isProfiler$2,
  isStrictMode: isStrictMode$2,
  isSuspense: isSuspense$2,
  isValidElementType: isValidElementType$2,
  typeOf: typeOf$2
};
var reactIs_development$2 = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var REACT_ELEMENT_TYPE = 0xeac7;
      var REACT_PORTAL_TYPE = 0xeaca;
      var REACT_FRAGMENT_TYPE = 0xeacb;
      var REACT_STRICT_MODE_TYPE = 0xeacc;
      var REACT_PROFILER_TYPE = 0xead2;
      var REACT_PROVIDER_TYPE = 0xeacd;
      var REACT_CONTEXT_TYPE = 0xeace;
      var REACT_FORWARD_REF_TYPE = 0xead0;
      var REACT_SUSPENSE_TYPE = 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
      var REACT_MEMO_TYPE = 0xead3;
      var REACT_LAZY_TYPE = 0xead4;
      var REACT_BLOCK_TYPE = 0xead9;
      var REACT_SERVER_BLOCK_TYPE = 0xeada;
      var REACT_FUNDAMENTAL_TYPE = 0xead5;
      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

      if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        symbolFor('react.scope');
        symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
      } // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.


      var enableScopeAPI = false; // Experimental Create Event Handle API.

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }

        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }

        return false;
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      }

      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }

      function isConcurrentMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
          }
        }
        return false;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
reactIs_development$2.ContextConsumer;
reactIs_development$2.ContextProvider;
reactIs_development$2.Element;
reactIs_development$2.ForwardRef;
reactIs_development$2.Fragment;
reactIs_development$2.Lazy;
reactIs_development$2.Memo;
reactIs_development$2.Portal;
reactIs_development$2.Profiler;
reactIs_development$2.StrictMode;
reactIs_development$2.Suspense;
reactIs_development$2.isAsyncMode;
reactIs_development$2.isConcurrentMode;
reactIs_development$2.isContextConsumer;
reactIs_development$2.isContextProvider;
reactIs_development$2.isElement;
reactIs_development$2.isForwardRef;
reactIs_development$2.isFragment;
reactIs_development$2.isLazy;
reactIs_development$2.isMemo;
reactIs_development$2.isPortal;
reactIs_development$2.isProfiler;
reactIs_development$2.isStrictMode;
reactIs_development$2.isSuspense;
reactIs_development$2.isValidElementType;
reactIs_development$2.typeOf;
var reactIs$2 = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$2;
  } else {
    module.exports = reactIs_development$2;
  }
});
reactIs$2.isValidElementType;
reactIs$2.isContextConsumer;
var reactIs_3 = reactIs$2.isForwardRef;

function t$2(t) {
  return "object" == typeof t && null != t && 1 === t.nodeType;
}

function e$2(t, e) {
  return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}

function n$2(t, n) {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    var r = getComputedStyle(t, null);
    return e$2(r.overflowY, n) || e$2(r.overflowX, n) || function (t) {
      var e = function (t) {
        if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;

        try {
          return t.ownerDocument.defaultView.frameElement;
        } catch (t) {
          return null;
        }
      }(t);

      return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
    }(t);
  }

  return !1;
}

function r$2(t, e, n, r, i, o, l, d) {
  return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}

function computeScrollIntoView(e, i) {
  var o = window,
      l = i.scrollMode,
      d = i.block,
      u = i.inline,
      h = i.boundary,
      a = i.skipOverflowHiddenElements,
      c = "function" == typeof h ? h : function (t) {
    return t !== h;
  };
  if (!t$2(e)) throw new TypeError("Invalid target");

  for (var f = document.scrollingElement || document.documentElement, s = [], p = e; t$2(p) && c(p);) {
    if ((p = p.parentElement) === f) {
      s.push(p);
      break;
    }

    null != p && p === document.body && n$2(p) && !n$2(document.documentElement) || null != p && n$2(p, a) && s.push(p);
  }

  for (var m = o.visualViewport ? o.visualViewport.width : innerWidth, g = o.visualViewport ? o.visualViewport.height : innerHeight, w = window.scrollX || pageXOffset, v = window.scrollY || pageYOffset, W = e.getBoundingClientRect(), b = W.height, H = W.width, y = W.top, E = W.right, M = W.bottom, V = W.left, x = "start" === d || "nearest" === d ? y : "end" === d ? M : y + b / 2, I = "center" === u ? V + H / 2 : "end" === u ? E : V, C = [], T = 0; T < s.length; T++) {
    var k = s[T],
        B = k.getBoundingClientRect(),
        D = B.height,
        O = B.width,
        R = B.top,
        X = B.right,
        Y = B.bottom,
        L = B.left;
    if ("if-needed" === l && y >= 0 && V >= 0 && M <= g && E <= m && y >= R && M <= Y && V >= L && E <= X) return C;
    var S = getComputedStyle(k),
        j = parseInt(S.borderLeftWidth, 10),
        q = parseInt(S.borderTopWidth, 10),
        z = parseInt(S.borderRightWidth, 10),
        A = parseInt(S.borderBottomWidth, 10),
        F = 0,
        G = 0,
        J = "offsetWidth" in k ? k.offsetWidth - k.clientWidth - j - z : 0,
        K = "offsetHeight" in k ? k.offsetHeight - k.clientHeight - q - A : 0;
    if (f === k) F = "start" === d ? x : "end" === d ? x - g : "nearest" === d ? r$2(v, v + g, g, q, A, v + x, v + x + b, b) : x - g / 2, G = "start" === u ? I : "center" === u ? I - m / 2 : "end" === u ? I - m : r$2(w, w + m, m, j, z, w + I, w + I + H, H), F = Math.max(0, F + v), G = Math.max(0, G + w);else {
      F = "start" === d ? x - R - q : "end" === d ? x - Y + A + K : "nearest" === d ? r$2(R, Y, D, q, A + K, x, x + b, b) : x - (R + D / 2) + K / 2, G = "start" === u ? I - L - j : "center" === u ? I - (L + O / 2) + J / 2 : "end" === u ? I - X + z + J : r$2(L, X, O, j, z + J, I, I + H, H);
      var N = k.scrollLeft,
          P = k.scrollTop;
      x += P - (F = Math.max(0, Math.min(P + F, k.scrollHeight - D + K))), I += N - (G = Math.max(0, Math.min(N + G, k.scrollWidth - O + J)));
    }
    C.push({
      el: k,
      top: F,
      left: G
    });
  }

  return C;
}

var idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */

function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}

function noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */


function scrollIntoView(node, menuNode) {
  if (!node) {
    return;
  }

  var actions = computeScrollIntoView(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */


function isOrContainsNode(parent, child, environment) {
  var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
  return result;
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */


function debounce$1(fn, time) {
  var timeoutId;

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }

  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }

  wrapper.cancel = cancel;
  return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */


function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}

function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */


function generateId() {
  return String(idCounter++);
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */


function getA11yStatusMessage$1(_ref2) {
  var isOpen = _ref2.isOpen,
      resultCount = _ref2.resultCount,
      previousResultCount = _ref2.previousResultCount;

  if (!isOpen) {
    return '';
  }

  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */


function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ?
  /* istanbul ignore next (preact) */
  arg[0] : arg;

  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */


function isDOMElement(element) {
  return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */


function getElementProps(element) {
  return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */


function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}

var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */

function pickState(state) {
  if (state === void 0) {
    state = {};
  }

  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */


function getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];
    return prevState;
  }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */


function isControlledProp(props, key) {
  return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */


function normalizeArrowKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  /* istanbul ignore next (ie) */

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }

  return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */


function isPlainObject$2(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */


function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0) {
    circular = true;
  }

  if (itemCount === 0) {
    return -1;
  }

  var itemsLastIndex = itemCount - 1;

  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }

  var newIndex = baseIndex + moveAmount;

  if (newIndex < 0) {
    newIndex = circular ? itemsLastIndex : 0;
  } else if (newIndex > itemsLastIndex) {
    newIndex = circular ? 0 : itemsLastIndex;
  }

  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);

  if (nonDisabledNewIndex === -1) {
    return baseIndex >= itemCount ? -1 : baseIndex;
  }

  return nonDisabledNewIndex;
}
/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */


function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);

  if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) {
    return baseIndex;
  }

  if (moveAmount > 0) {
    for (var index = baseIndex + 1; index < itemCount; index++) {
      if (!getItemNodeFromIndex(index).hasAttribute('disabled')) {
        return index;
      }
    }
  } else {
    for (var _index = baseIndex - 1; _index >= 0; _index--) {
      if (!getItemNodeFromIndex(_index).hasAttribute('disabled')) {
        return _index;
      }
    }
  }

  if (circular) {
    return moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
  }

  return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */


function targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }

  return downshiftElements.some(function (contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target, environment) || checkActiveElement && isOrContainsNode(contextNode, environment.document.activeElement, environment));
  });
} // eslint-disable-next-line import/no-mutable-exports


var validateControlledUnchanged = noop;
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  validateControlledUnchanged = function validateControlledUnchanged(state, prevProps, nextProps) {
    var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
    Object.keys(state).forEach(function (propKey) {
      if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the controlled prop \"" + propKey + "\" to be uncontrolled. " + warningDescription);
      } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the uncontrolled prop \"" + propKey + "\" to be controlled. " + warningDescription);
      }
    });
  };
}

var cleanupStatus = debounce$1(function (documentProp) {
  getStatusDiv(documentProp).textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */

function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);

  if (!status) {
    return;
  }

  div.textContent = status;
  cleanupStatus(documentProp);
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */


function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }

  var statusDiv = documentProp.getElementById('a11y-status-message');

  if (statusDiv) {
    return statusDiv;
  }

  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}

var unknown = process.env.NODE_ENV !== "production" ? '__autocomplete_unknown__' : 0;
var mouseUp = process.env.NODE_ENV !== "production" ? '__autocomplete_mouseup__' : 1;
var itemMouseEnter = process.env.NODE_ENV !== "production" ? '__autocomplete_item_mouseenter__' : 2;
var keyDownArrowUp = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_up__' : 3;
var keyDownArrowDown = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_arrow_down__' : 4;
var keyDownEscape = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_escape__' : 5;
var keyDownEnter = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_enter__' : 6;
var keyDownHome = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_home__' : 7;
var keyDownEnd = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_end__' : 8;
var clickItem = process.env.NODE_ENV !== "production" ? '__autocomplete_click_item__' : 9;
var blurInput = process.env.NODE_ENV !== "production" ? '__autocomplete_blur_input__' : 10;
var changeInput = process.env.NODE_ENV !== "production" ? '__autocomplete_change_input__' : 11;
var keyDownSpaceButton = process.env.NODE_ENV !== "production" ? '__autocomplete_keydown_space_button__' : 12;
var clickButton = process.env.NODE_ENV !== "production" ? '__autocomplete_click_button__' : 13;
var blurButton = process.env.NODE_ENV !== "production" ? '__autocomplete_blur_button__' : 14;
var controlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? '__autocomplete_controlled_prop_updated_selected_item__' : 15;
var touchEnd = process.env.NODE_ENV !== "production" ? '__autocomplete_touchend__' : 16;
var stateChangeTypes$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unknown: unknown,
  mouseUp: mouseUp,
  itemMouseEnter: itemMouseEnter,
  keyDownArrowUp: keyDownArrowUp,
  keyDownArrowDown: keyDownArrowDown,
  keyDownEscape: keyDownEscape,
  keyDownEnter: keyDownEnter,
  keyDownHome: keyDownHome,
  keyDownEnd: keyDownEnd,
  clickItem: clickItem,
  blurInput: blurInput,
  changeInput: changeInput,
  keyDownSpaceButton: keyDownSpaceButton,
  clickButton: clickButton,
  blurButton: blurButton,
  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
  touchEnd: touchEnd
});

var Downshift = /*#__PURE__*/function () {
  var Downshift = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Downshift, _Component);

    function Downshift(_props) {
      var _this;

      _this = _Component.call(this, _props) || this; // fancy destructuring + defaults + aliases
      // this basically says each value of state should either be set to
      // the initial value or the default value if the initial value is not provided

      _this.id = _this.props.id || "downshift-" + generateId();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";

      _this.getItemId = _this.props.getItemId || function (index) {
        return _this.id + "-item-" + index;
      };

      _this.input = null;
      _this.items = [];
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];

      _this.internalSetTimeout = function (fn, time) {
        var id = setTimeout(function () {
          _this.timeoutIds = _this.timeoutIds.filter(function (i) {
            return i !== id;
          });
          fn();
        }, time);

        _this.timeoutIds.push(id);
      };

      _this.setItemCount = function (count) {
        _this.itemCount = count;
      };

      _this.unsetItemCount = function () {
        _this.itemCount = null;
      };

      _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }

        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(_extends({
          highlightedIndex: highlightedIndex
        }, otherStateToSet));
      };

      _this.clearSelection = function (cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: '',
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };

      _this.selectItem = function (item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(_extends({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };

      _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];

        if (item == null) {
          return;
        }

        _this.selectItem(item, otherStateToSet, cb);
      };

      _this.selectHighlightedItem = function (otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };

      _this.internalSetState = function (stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === 'function'; // we want to call `onInputValueChange` before the `setState` call
        // so someone controlling the `inputValue` state gets notified of
        // the input change as soon as possible. This avoids issues with
        // preserving the cursor position.
        // See https://github.com/downshift-js/downshift/issues/217 for more info.

        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), stateToSet));
        }

        return _this.setState(function (state) {
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.

          newStateToSet = _this.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
          // what was selected before
          // used to determine if onSelect and onChange callbacks should be called

          isItemSelected = newStateToSet.hasOwnProperty('selectedItem'); // this keeps track of the object we want to call with setState

          var nextState = {}; // this is just used to tell whether the state changed
          // and we're trying to update that state. OR if the selection has changed and we're
          // trying to update the selection

          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }

          newStateToSet.type = newStateToSet.type || unknown;
          Object.keys(newStateToSet).forEach(function (key) {
            // onStateChangeArg should only have the state that is
            // actually changing
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            } // the type is useful for the onStateChangeArg
            // but we don't actually want to set it in internal state.
            // this is an undocumented feature for now... Not all internalSetState
            // calls support it and I'm not certain we want them to yet.
            // But it enables users controlling the isOpen state to know when
            // the isOpen state changes due to mouseup events which is quite handy.


            if (key === 'type') {
              return;
            }

            newStateToSet[key]; // if it's coming from props, then we don't care to set it internally

            if (!isControlledProp(_this.props, key)) {
              nextState[key] = newStateToSet[key];
            }
          }); // if stateToSet is a function, then we weren't able to call onInputValueChange
          // earlier, so we'll call it now that we know what the inputValue state will be.

          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
            _this.props.onInputValueChange(newStateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), newStateToSet));
          }

          return nextState;
        }, function () {
          // call the provided callback if it's a function
          cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
          // we have relevant information to pass them.

          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;

          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }

          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }

          if (onChangeArg !== undefined) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          } // this is currently undocumented and therefore subject to change
          // We'll try to not break it, but just be warned.


          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };

      _this.rootRef = function (node) {
        return _this._rootNode = node;
      };

      _this.getRootProps = function (_temp, _temp2) {
        var _extends2;

        var _ref = _temp === void 0 ? {} : _temp,
            _ref$refKey = _ref.refKey,
            refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
            ref = _ref.ref,
            rest = _objectWithoutPropertiesLoose$1(_ref, ["refKey", "ref"]);

        var _ref2 = _temp2 === void 0 ? {} : _temp2,
            _ref2$suppressRefErro = _ref2.suppressRefError,
            suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro; // this is used in the render to know whether the user has called getRootProps.
        // It uses that to know whether to apply the props automatically


        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;

        var _this$getState = _this.getState(),
            isOpen = _this$getState.isOpen;

        return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : null, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
      };

      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this2.getItemCount();

              if (itemCount > 0) {
                var _this2$getState = _this2.getState(),
                    highlightedIndex = _this2$getState.highlightedIndex;

                var nextHighlightedIndex = getNextWrappingIndex(1, highlightedIndex, itemCount, function (index) {
                  return _this2.getItemNodeFromIndex(index);
                });

                _this2.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this3.getItemCount();

              if (itemCount > 0) {
                var _this3$getState = _this3.getState(),
                    highlightedIndex = _this3$getState.highlightedIndex;

                var nextHighlightedIndex = getNextWrappingIndex(-1, highlightedIndex, itemCount, function (index) {
                  return _this3.getItemNodeFromIndex(index);
                });

                _this3.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          if (event.which === 229) {
            return;
          }

          var _this$getState2 = this.getState(),
              isOpen = _this$getState2.isOpen,
              highlightedIndex = _this$getState2.highlightedIndex;

          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);

            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }

            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset(_extends({
            type: keyDownEscape
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ''
          }));
        }
      };
      _this.buttonKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        ' ': function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        Home: function Home(event) {
          var _this4 = this;

          var _this$getState3 = this.getState(),
              isOpen = _this$getState3.isOpen;

          if (!isOpen) {
            return;
          }

          event.preventDefault();
          var itemCount = this.getItemCount();

          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting downwards from 0 if that's disabled.


          var newHighlightedIndex = getNextNonDisabledIndex(1, 0, itemCount, function (index) {
            return _this4.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          var _this5 = this;

          var _this$getState4 = this.getState(),
              isOpen = _this$getState4.isOpen;

          if (!isOpen) {
            return;
          }

          event.preventDefault();
          var itemCount = this.getItemCount();

          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting upwards from last index if that's disabled.


          var newHighlightedIndex = getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function (index) {
            return _this5.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownEnd
          });
        }
      });

      _this.getToggleButtonProps = function (_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3,
            onClick = _ref3.onClick;

        _ref3.onPress;

        var onKeyDown = _ref3.onKeyDown,
            onKeyUp = _ref3.onKeyUp,
            onBlur = _ref3.onBlur,
            rest = _objectWithoutPropertiesLoose$1(_ref3, ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"]);

        var _this$getState5 = _this.getState(),
            isOpen = _this$getState5.isOpen;

        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return _extends({
          type: 'button',
          role: 'button',
          'aria-label': isOpen ? 'close menu' : 'open menu',
          'aria-haspopup': true,
          'data-toggle': true
        }, eventHandlers, rest);
      };

      _this.buttonHandleKeyUp = function (event) {
        // Prevent click event from emitting in Firefox
        event.preventDefault();
      };

      _this.buttonHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (_this.buttonKeyDownHandlers[key]) {
          _this.buttonKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };

      _this.buttonHandleClick = function (event) {
        event.preventDefault(); // handle odd case for Safari and Firefox which
        // don't give the button the focus properly.

        /* istanbul ignore if (can't reasonably test this) */

        if (_this.props.environment.document.activeElement === _this.props.environment.document.body) {
          event.target.focus();
        } // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
        // when building for production and should therefore have no impact on production code.


        if (process.env.NODE_ENV === 'test') {
          _this.toggleMenu({
            type: clickButton
          });
        } else {
          // Ensure that toggle of menu occurs after the potential blur event in iOS
          _this.internalSetTimeout(function () {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };

      _this.buttonHandleBlur = function (event) {
        var blurTarget = event.target; // Save blur target for comparison with activeElement later
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element

        _this.internalSetTimeout(function () {
          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
          ) {
            _this.reset({
              type: blurButton
            });
          }
        });
      };

      _this.getLabelProps = function (props) {
        return _extends({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };

      _this.getInputProps = function (_temp4) {
        var _ref4 = _temp4 === void 0 ? {} : _temp4,
            onKeyDown = _ref4.onKeyDown,
            onBlur = _ref4.onBlur,
            onChange = _ref4.onChange,
            onInput = _ref4.onInput;

        _ref4.onChangeText;

        var rest = _objectWithoutPropertiesLoose$1(_ref4, ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"]);

        var onChangeKey;
        var eventHandlers = {};
        /* istanbul ignore next (preact) */

        {
          onChangeKey = 'onChange';
        }

        var _this$getState6 = _this.getState(),
            inputValue = _this$getState6.inputValue,
            isOpen = _this$getState6.isOpen,
            highlightedIndex = _this$getState6.highlightedIndex;

        if (!rest.disabled) {
          var _eventHandlers;

          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }

        return _extends({
          'aria-autocomplete': 'list',
          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          'aria-controls': isOpen ? _this.menuId : null,
          'aria-labelledby': _this.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: 'off',
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, rest);
      };

      _this.inputHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (key && _this.inputKeyDownHandlers[key]) {
          _this.inputKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };

      _this.inputHandleChange = function (event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };

      _this.inputHandleBlur = function () {
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
        _this.internalSetTimeout(function () {
          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);

          if (!_this.isMouseDown && !downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };

      _this.menuRef = function (node) {
        _this._menuNode = node;
      };

      _this.getMenuProps = function (_temp5, _temp6) {
        var _extends3;

        var _ref5 = _temp5 === void 0 ? {} : _temp5,
            _ref5$refKey = _ref5.refKey,
            refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
            ref = _ref5.ref,
            props = _objectWithoutPropertiesLoose$1(_ref5, ["refKey", "ref"]);

        var _ref6 = _temp6 === void 0 ? {} : _temp6,
            _ref6$suppressRefErro = _ref6.suppressRefError,
            suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;

        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };

      _this.getItemProps = function (_temp7) {
        var _enabledEventHandlers;

        var _ref7 = _temp7 === void 0 ? {} : _temp7,
            onMouseMove = _ref7.onMouseMove,
            onMouseDown = _ref7.onMouseDown,
            onClick = _ref7.onClick;

        _ref7.onPress;

        var index = _ref7.index,
            _ref7$item = _ref7.item,
            item = _ref7$item === void 0 ? process.env.NODE_ENV === 'production' ?
        /* istanbul ignore next */
        undefined : requiredProp('getItemProps', 'item') : _ref7$item,
            rest = _objectWithoutPropertiesLoose$1(_ref7, ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"]);

        if (index === undefined) {
          _this.items.push(item);

          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }

        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(onMouseMove, function () {
            if (index === _this.getState().highlightedIndex) {
              return;
            }

            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            }); // We never want to manually scroll when changing state based
            // on `onMouseMove` because we will be moving the element out
            // from under the user which is currently scrolling/moving the
            // cursor


            _this.avoidScrolling = true;

            _this.internalSetTimeout(function () {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
            // This prevents the activeElement from being changed
            // to the item so it can remain with the current activeElement
            // which is a more common use case.
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        }), _enabledEventHandlers); // Passing down the onMouseDown handler to prevent redirect
        // of the activeElement if clicking on disabled items

        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return _extends({
          id: _this.getItemId(index),
          role: 'option',
          'aria-selected': _this.getState().highlightedIndex === index
        }, eventHandlers, rest);
      };

      _this.clearItems = function () {
        _this.items = [];
      };

      _this.reset = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref8) {
          var selectedItem = _ref8.selectedItem;
          return _extends({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };

      _this.toggleMenu = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref9) {
          var isOpen = _ref9.isOpen;
          return _extends({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, otherStateToSet);
        }, function () {
          var _this$getState7 = _this.getState(),
              isOpen = _this$getState7.isOpen,
              highlightedIndex = _this$getState7.highlightedIndex;

          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }

          cbToCb(cb)();
        });
      };

      _this.openMenu = function (cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };

      _this.closeMenu = function (cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };

      _this.updateStatus = debounce$1(function () {
        var state = _this.getState();

        var item = _this.items[state.highlightedIndex];

        var resultCount = _this.getItemCount();

        var status = _this.props.getA11yStatusMessage(_extends({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount: resultCount,
          highlightedItem: item
        }, state));

        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);

      var _this$props = _this.props,
          defaultHighlightedIndex = _this$props.defaultHighlightedIndex,
          _this$props$initialHi = _this$props.initialHighlightedIndex,
          _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi,
          defaultIsOpen = _this$props.defaultIsOpen,
          _this$props$initialIs = _this$props.initialIsOpen,
          _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs,
          _this$props$initialIn = _this$props.initialInputValue,
          _inputValue = _this$props$initialIn === void 0 ? '' : _this$props$initialIn,
          _this$props$initialSe = _this$props.initialSelectedItem,
          _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;

      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });

      if (_state.selectedItem != null && _this.props.initialInputValue === undefined) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }

      _this.state = _state;
      return _this;
    }

    var _proto = Downshift.prototype;
    /**
     * Clear all running timeouts
     */

    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function (id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    }
    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */
    ;

    _proto.getState = function getState$1(stateToMerge) {
      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }

      return getState(stateToMerge, this.props);
    };

    _proto.getItemCount = function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      var itemCount = this.items.length;

      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        itemCount = this.props.itemCount;
      }

      return itemCount;
    };

    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
      return this.props.environment.document.getElementById(this.getItemId(index));
    };

    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      /* istanbul ignore else (react-native) */
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };

    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var _this6 = this;

      var itemCount = this.getItemCount();

      var _this$getState8 = this.getState(),
          highlightedIndex = _this$getState8.highlightedIndex;

      if (itemCount > 0) {
        var nextHighlightedIndex = getNextWrappingIndex(amount, highlightedIndex, itemCount, function (index) {
          return _this6.getItemNodeFromIndex(index);
        });
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };

    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState9 = this.getState(),
          highlightedIndex = _this$getState9.highlightedIndex,
          inputValue = _this$getState9.inputValue,
          selectedItem = _this$getState9.selectedItem,
          isOpen = _this$getState9.isOpen;

      var itemToString = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps,
          getToggleButtonProps = this.getToggleButtonProps,
          getLabelProps = this.getLabelProps,
          getMenuProps = this.getMenuProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount,
          setState = this.internalSetState;
      return {
        // prop getters
        getRootProps: getRootProps,
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,
        setState: setState,
        // props
        itemToString: itemToString,
        // derived
        id: id,
        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    } //////////////////////////// ROOT
    ;

    _proto.componentDidMount = function componentDidMount() {
      var _this7 = this;
      /* istanbul ignore if (react-native) */


      if (process.env.NODE_ENV !== 'production' && !false && this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
        validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
      }
      /* istanbul ignore if (react-native) */


      {
        // this.isMouseDown helps us track whether the mouse is currently held down.
        // This is useful when the user clicks on an item in the list, but holds the mouse
        // down long enough for the list to disappear (because the blur event fires on the input)
        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
        // trigger hiding the menu.
        var onMouseDown = function onMouseDown() {
          _this7.isMouseDown = true;
        };

        var onMouseUp = function onMouseUp(event) {
          _this7.isMouseDown = false; // if the target element or the activeElement is within a downshift node
          // then we don't want to reset downshift

          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment);

          if (!contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: mouseUp
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        }; // Touching an element in iOS gives focus and hover states, but touching out of
        // the element will remove hover, and persist the focus state, resulting in the
        // blur event not being triggered.
        // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
        // If the user taps outside of Downshift, the component should be reset,
        // but not if the user is swiping


        var onTouchStart = function onTouchStart() {
          _this7.isTouchMove = false;
        };

        var onTouchMove = function onTouchMove() {
          _this7.isTouchMove = true;
        };

        var onTouchEnd = function onTouchEnd(event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment, false);

          if (!_this7.isTouchMove && !contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: touchEnd
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };

        var environment = this.props.environment;
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);

        this.cleanup = function () {
          _this7.internalClearTimeouts();

          _this7.updateStatus.cancel();

          environment.removeEventListener('mousedown', onMouseDown);
          environment.removeEventListener('mouseup', onMouseUp);
          environment.removeEventListener('touchstart', onTouchStart);
          environment.removeEventListener('touchmove', onTouchMove);
          environment.removeEventListener('touchend', onTouchEnd);
        };
      }
    };

    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
          currentHighlightedIndex = _ref10.highlightedIndex;

      var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
          prevHighlightedIndex = _ref11.highlightedIndex;

      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
      return scrollWhenOpen || scrollWhenNavigating;
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== 'production') {
        validateControlledUnchanged(this.state, prevProps, this.props);
        /* istanbul ignore if (react-native) */

        if (this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
          validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
        }
      }

      if (isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }

      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }
      /* istanbul ignore else (react-native) */


      {
        this.updateStatus();
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    };

    _proto.render = function render() {
      var children = unwrapArray(this.props.children, noop); // because the items are rerendered every time we call the children
      // we clear this out each render and it will be populated again as
      // getItemProps is called.

      this.clearItems(); // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.

      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps

      this.getMenuProps.called = false;
      this.getMenuProps.refKey = undefined;
      this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps

      this.getLabelProps.called = false; // and something similar for getInputProps

      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));

      if (!element) {
        return null;
      }

      if (this.getRootProps.called || this.props.suppressRefError) {
        if (process.env.NODE_ENV !== 'production' && !this.getRootProps.suppressRefError && !this.props.suppressRefError) {
          validateGetRootPropsCalledCorrectly(element, this.getRootProps);
        }

        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return /*#__PURE__*/cloneElement(element, this.getRootProps(getElementProps(element)));
      }
      /* istanbul ignore else */


      if (process.env.NODE_ENV !== 'production') {
        // they didn't apply the root props, but they need to
        // otherwise we can't query around the autocomplete
        throw new Error('downshift: If you return a non-DOM element, you must apply the getRootProps function');
      }
      /* istanbul ignore next */


      return undefined;
    };

    return Downshift;
  }(Component);

  Downshift.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage$1,
    itemToString: function itemToString(i) {
      if (i == null) {
        return '';
      }

      if (process.env.NODE_ENV !== 'production' && isPlainObject$2(i) && !i.hasOwnProperty('toString')) {
        // eslint-disable-next-line no-console
        console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
      }

      return String(i);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment: typeof window === 'undefined'
    /* istanbul ignore next (ssr) */
    ? {} : window,
    stateReducer: function stateReducer(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView: scrollIntoView
  };
  Downshift.stateChangeTypes = stateChangeTypes$3;
  return Downshift;
}();

process.env.NODE_ENV !== "production" ? Downshift.propTypes = {
  children: propTypes.func,
  defaultHighlightedIndex: propTypes.number,
  defaultIsOpen: propTypes.bool,
  initialHighlightedIndex: propTypes.number,
  initialSelectedItem: propTypes.any,
  initialInputValue: propTypes.string,
  initialIsOpen: propTypes.bool,
  getA11yStatusMessage: propTypes.func,
  itemToString: propTypes.func,
  onChange: propTypes.func,
  onSelect: propTypes.func,
  onStateChange: propTypes.func,
  onInputValueChange: propTypes.func,
  onUserAction: propTypes.func,
  onOuterClick: propTypes.func,
  selectedItemChanged: propTypes.func,
  stateReducer: propTypes.func,
  itemCount: propTypes.number,
  id: propTypes.string,
  environment: propTypes.shape({
    addEventListener: propTypes.func,
    removeEventListener: propTypes.func,
    document: propTypes.shape({
      getElementById: propTypes.func,
      activeElement: propTypes.any,
      body: propTypes.any
    })
  }),
  suppressRefError: propTypes.bool,
  scrollIntoView: propTypes.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components

  /* eslint-disable react/no-unused-prop-types */
  selectedItem: propTypes.any,
  isOpen: propTypes.bool,
  inputValue: propTypes.string,
  highlightedIndex: propTypes.number,
  labelId: propTypes.string,
  inputId: propTypes.string,
  menuId: propTypes.string,
  getItemId: propTypes.func
  /* eslint-enable react/no-unused-prop-types */

} : void 0;

function validateGetMenuPropsCalledCorrectly(node, _ref12) {
  var refKey = _ref12.refKey;

  if (!node) {
    // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
  }
}

function validateGetRootPropsCalledCorrectly(element, _ref13) {
  var refKey = _ref13.refKey;
  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);

  if (isComposite && !refKeySpecified && !reactIs_3(element)) {
    // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
  }

  if (!reactIs_3(element) && !getElementProps(element)[refKey]) {
    // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
  }
}

var dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null,
  inputValue: ''
};

function callOnChangeProps(action, state, newState) {
  var props = action.props,
      type = action.type;
  var changes = {};
  Object.keys(state).forEach(function (key) {
    invokeOnChangeHandler(key, action, state, newState);

    if (newState[key] !== state[key]) {
      changes[key] = newState[key];
    }
  });

  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange(_extends({
      type: type
    }, changes));
  }
}

function invokeOnChangeHandler(key, action, state, newState) {
  var props = action.props,
      type = action.type;
  var handler = "on" + capitalizeString(key) + "Change";

  if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) {
    props[handler](_extends({
      type: type
    }, newState));
  }
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */


function stateReducer(s, a) {
  return a.changes;
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */


function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem,
      itemToStringLocal = selectionParameters.itemToString;
  return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : '';
}
/**
 * Debounced call for updating the a11y message.
 */


var updateA11yStatus = debounce$1(function (getA11yMessage, document) {
  setStatus(getA11yMessage(), document);
}, 200); // istanbul ignore next

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

function useElementIds(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? "downshift-" + generateId() : _ref$id,
      labelId = _ref.labelId,
      menuId = _ref.menuId,
      getItemId = _ref.getItemId,
      toggleButtonId = _ref.toggleButtonId,
      inputId = _ref.inputId;
  var elementIdsRef = useRef({
    labelId: labelId || id + "-label",
    menuId: menuId || id + "-menu",
    getItemId: getItemId || function (index) {
      return id + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || id + "-toggle-button",
    inputId: inputId || id + "-input"
  });
  return elementIdsRef.current;
}

function getItemIndex(index, item, items) {
  if (index !== undefined) {
    return index;
  }

  if (items.length === 0) {
    return -1;
  }

  return items.indexOf(item);
}

function itemToString(item) {
  return item ? String(item) : '';
}

function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}

function useLatestRef(val) {
  var ref = useRef(val); // technically this is not "concurrent mode safe" because we're manipulating
  // the value during render (so it's not idempotent). However, the places this
  // hook is used is to support memoizing callbacks which will be called
  // *during* render, so we need the latest values *during* render.
  // If not for this, then we'd probably want to use useLayoutEffect instead.

  ref.current = val;
  return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */


function useEnhancedReducer(reducer, initialState, props) {
  var prevStateRef = useRef();
  var actionRef = useRef();
  var enhancedReducer = useCallback(function (state, action) {
    actionRef.current = action;
    state = getState(state, action.props);
    var changes = reducer(state, action);
    var newState = action.props.stateReducer(state, _extends({}, action, {
      changes: changes
    }));
    return newState;
  }, [reducer]);

  var _useReducer = useReducer(enhancedReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var propsRef = useLatestRef(props);
  var dispatchWithProps = useCallback(function (action) {
    return dispatch(_extends({
      props: propsRef.current
    }, action));
  }, [propsRef]);
  var action = actionRef.current;
  useEffect(function () {
    if (action && prevStateRef.current && prevStateRef.current !== state) {
      callOnChangeProps(action, getState(prevStateRef.current, action.props), state);
    }

    prevStateRef.current = state;
  }, [state, props, action]);
  return [state, dispatchWithProps];
}

var defaultProps$3 = {
  itemToString: itemToString,
  stateReducer: stateReducer,
  getA11ySelectionMessage: getA11ySelectionMessage,
  scrollIntoView: scrollIntoView,
  circularNavigation: false,
  environment: typeof window === 'undefined'
  /* istanbul ignore next (ssr) */
  ? {} : window
};

function getDefaultValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }

  var defaultPropKey = "default" + capitalizeString(propKey);

  if (defaultPropKey in props) {
    return props[defaultPropKey];
  }

  return defaultStateValues[propKey];
}

function getInitialValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }

  if (propKey in props) {
    return props[propKey];
  }

  var initialPropKey = "initial" + capitalizeString(propKey);

  if (initialPropKey in props) {
    return props[initialPropKey];
  }

  return getDefaultValue$1(props, propKey, defaultStateValues);
}

function getInitialState$2(props) {
  var selectedItem = getInitialValue$1(props, 'selectedItem');
  var isOpen = getInitialValue$1(props, 'isOpen');
  var highlightedIndex = getInitialValue$1(props, 'highlightedIndex');
  var inputValue = getInitialValue$1(props, 'inputValue');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

function getHighlightedIndexOnOpen(props, state, offset, getItemNodeFromIndex) {
  var items = props.items,
      initialHighlightedIndex = props.initialHighlightedIndex,
      defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem,
      highlightedIndex = state.highlightedIndex;

  if (items.length === 0) {
    return -1;
  } // initialHighlightedIndex will give value to highlightedIndex on initial state only.


  if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) {
    return initialHighlightedIndex;
  }

  if (defaultHighlightedIndex !== undefined) {
    return defaultHighlightedIndex;
  }

  if (selectedItem) {
    if (offset === 0) {
      return items.indexOf(selectedItem);
    }

    return getNextWrappingIndex(offset, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, false);
  }

  if (offset === 0) {
    return -1;
  }

  return offset < 0 ? items.length - 1 : 0;
}
/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */


function useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
  var mouseAndTouchTrackersRef = useRef({
    isMouseDown: false,
    isTouchMove: false
  });
  useEffect(function () {
    // The same strategy for checking if a click occurred inside or outside downsift
    // as in downshift.js.
    var onMouseDown = function onMouseDown() {
      mouseAndTouchTrackersRef.current.isMouseDown = true;
    };

    var onMouseUp = function onMouseUp(event) {
      mouseAndTouchTrackersRef.current.isMouseDown = false;

      if (isOpen && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment)) {
        handleBlur();
      }
    };

    var onTouchStart = function onTouchStart() {
      mouseAndTouchTrackersRef.current.isTouchMove = false;
    };

    var onTouchMove = function onTouchMove() {
      mouseAndTouchTrackersRef.current.isTouchMove = true;
    };

    var onTouchEnd = function onTouchEnd(event) {
      if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment, false)) {
        handleBlur();
      }
    };

    environment.addEventListener('mousedown', onMouseDown);
    environment.addEventListener('mouseup', onMouseUp);
    environment.addEventListener('touchstart', onTouchStart);
    environment.addEventListener('touchmove', onTouchMove);
    environment.addEventListener('touchend', onTouchEnd);
    return function cleanup() {
      environment.removeEventListener('mousedown', onMouseDown);
      environment.removeEventListener('mouseup', onMouseUp);
      environment.removeEventListener('touchstart', onTouchStart);
      environment.removeEventListener('touchmove', onTouchMove);
      environment.removeEventListener('touchend', onTouchEnd);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, environment]);
  return mouseAndTouchTrackersRef;
}
/* istanbul ignore next */
// eslint-disable-next-line import/no-mutable-exports


var useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
  return noop;
};
/**
 * Custom hook that checks if getter props are called correctly.
 *
 * @param  {...any} propKeys Getter prop names to be handled.
 * @returns {Function} Setter function called inside getter props to set call information.
 */

/* istanbul ignore next */


if (process.env.NODE_ENV !== 'production') {
  useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
    var isInitialMountRef = useRef(true);

    for (var _len = arguments.length, propKeys = new Array(_len), _key = 0; _key < _len; _key++) {
      propKeys[_key] = arguments[_key];
    }

    var getterPropsCalledRef = useRef(propKeys.reduce(function (acc, propKey) {
      acc[propKey] = {};
      return acc;
    }, {}));
    useEffect(function () {
      Object.keys(getterPropsCalledRef.current).forEach(function (propKey) {
        var propCallInfo = getterPropsCalledRef.current[propKey];

        if (isInitialMountRef.current) {
          if (!Object.keys(propCallInfo).length) {
            // eslint-disable-next-line no-console
            console.error("downshift: You forgot to call the " + propKey + " getter function on your component / element.");
            return;
          }
        }

        var suppressRefError = propCallInfo.suppressRefError,
            refKey = propCallInfo.refKey,
            elementRef = propCallInfo.elementRef;

        if ((!elementRef || !elementRef.current) && !suppressRefError) {
          // eslint-disable-next-line no-console
          console.error("downshift: The ref prop \"" + refKey + "\" from " + propKey + " was not applied correctly on your element.");
        }
      });
      isInitialMountRef.current = false;
    });
    var setGetterPropCallInfo = useCallback(function (propKey, suppressRefError, refKey, elementRef) {
      getterPropsCalledRef.current[propKey] = {
        suppressRefError: suppressRefError,
        refKey: refKey,
        elementRef: elementRef
      };
    }, []);
    return setGetterPropCallInfo;
  };
}

function useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
  var isInitialMount = _ref2.isInitialMount,
      highlightedIndex = _ref2.highlightedIndex,
      items = _ref2.items,
      environment = _ref2.environment,
      rest = _objectWithoutPropertiesLoose$1(_ref2, ["isInitialMount", "highlightedIndex", "items", "environment"]); // Sets a11y status message on changes in state.


  useEffect(function () {
    if (isInitialMount) {
      return;
    }

    updateA11yStatus(function () {
      return getA11yMessage(_extends({
        highlightedIndex: highlightedIndex,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length
      }, rest));
    }, environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray);
}

function useScrollIntoView(_ref3) {
  var highlightedIndex = _ref3.highlightedIndex,
      isOpen = _ref3.isOpen,
      itemRefs = _ref3.itemRefs,
      getItemNodeFromIndex = _ref3.getItemNodeFromIndex,
      menuElement = _ref3.menuElement,
      scrollIntoViewProp = _ref3.scrollIntoView; // used not to scroll on highlight by mouse.

  var shouldScrollRef = useRef(true); // Scroll on highlighted item if change comes from keyboard.

  useIsomorphicLayoutEffect(function () {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }

    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedIndex]);
  return shouldScrollRef;
} // eslint-disable-next-line import/no-mutable-exports


var useControlPropsValidator = noop;
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  useControlPropsValidator = function useControlPropsValidator(_ref4) {
    var isInitialMount = _ref4.isInitialMount,
        props = _ref4.props,
        state = _ref4.state; // used for checking when props are moving from controlled to uncontrolled.

    var prevPropsRef = useRef(props);
    useEffect(function () {
      if (isInitialMount) {
        return;
      }

      validateControlledUnchanged(state, prevPropsRef.current, props);
      prevPropsRef.current = props;
    }, [state, props, isInitialMount]);
  };
}
/* eslint-disable complexity */


function downshiftCommonReducer(state, action, stateChangeTypes) {
  var type = action.type,
      props = action.props;
  var changes;

  switch (type) {
    case stateChangeTypes.ItemMouseMove:
      changes = {
        highlightedIndex: action.index
      };
      break;

    case stateChangeTypes.MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;

    case stateChangeTypes.ToggleButtonClick:
    case stateChangeTypes.FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case stateChangeTypes.FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case stateChangeTypes.FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;

    case stateChangeTypes.FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;

    case stateChangeTypes.FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;

    case stateChangeTypes.FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        isOpen: getDefaultValue$1(props, 'isOpen'),
        selectedItem: getDefaultValue$1(props, 'selectedItem'),
        inputValue: getDefaultValue$1(props, 'inputValue')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return _extends({}, state, changes);
}

({
  items: propTypes.array.isRequired,
  itemToString: propTypes.func,
  getA11yStatusMessage: propTypes.func,
  getA11ySelectionMessage: propTypes.func,
  circularNavigation: propTypes.bool,
  highlightedIndex: propTypes.number,
  defaultHighlightedIndex: propTypes.number,
  initialHighlightedIndex: propTypes.number,
  isOpen: propTypes.bool,
  defaultIsOpen: propTypes.bool,
  initialIsOpen: propTypes.bool,
  selectedItem: propTypes.any,
  initialSelectedItem: propTypes.any,
  defaultSelectedItem: propTypes.any,
  id: propTypes.string,
  labelId: propTypes.string,
  menuId: propTypes.string,
  getItemId: propTypes.func,
  toggleButtonId: propTypes.string,
  stateReducer: propTypes.func,
  onSelectedItemChange: propTypes.func,
  onHighlightedIndexChange: propTypes.func,
  onStateChange: propTypes.func,
  onIsOpenChange: propTypes.func,
  environment: propTypes.shape({
    addEventListener: propTypes.func,
    removeEventListener: propTypes.func,
    document: propTypes.shape({
      getElementById: propTypes.func,
      activeElement: propTypes.any,
      body: propTypes.any
    })
  })
});
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */

function getA11yStatusMessage(_ref) {
  var isOpen = _ref.isOpen,
      resultCount = _ref.resultCount,
      previousResultCount = _ref.previousResultCount;

  if (!isOpen) {
    return '';
  }

  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.";
  }

  return '';
}

_extends({}, defaultProps$3, {
  getA11yStatusMessage: getA11yStatusMessage
}); // eslint-disable-next-line import/no-mutable-exports

/* istanbul ignore next */


if (process.env.NODE_ENV !== 'production') ;
process.env.NODE_ENV !== "production" ? '__menu_keydown_arrow_down__' : 0;
process.env.NODE_ENV !== "production" ? '__menu_keydown_arrow_up__' : 1;
process.env.NODE_ENV !== "production" ? '__menu_keydown_escape__' : 2;
process.env.NODE_ENV !== "production" ? '__menu_keydown_home__' : 3;
process.env.NODE_ENV !== "production" ? '__menu_keydown_end__' : 4;
process.env.NODE_ENV !== "production" ? '__menu_keydown_enter__' : 5;
process.env.NODE_ENV !== "production" ? '__menu_keydown_space_button__' : 6;
process.env.NODE_ENV !== "production" ? '__menu_keydown_character__' : 7;
process.env.NODE_ENV !== "production" ? '__menu_blur__' : 8;
process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 9;
process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 10;
process.env.NODE_ENV !== "production" ? '__item_click__' : 11;
process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 12;
process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_down__' : 13;
process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_arrow_up__' : 14;
process.env.NODE_ENV !== "production" ? '__togglebutton_keydown_character__' : 15;
process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 16;
process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 17;
process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 18;
process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 19;
process.env.NODE_ENV !== "production" ? '__function_select_item__' : 20;
process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 21;
process.env.NODE_ENV !== "production" ? '__function_reset__' : 22;
var InputKeyDownArrowDown = process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_down__' : 0;
var InputKeyDownArrowUp = process.env.NODE_ENV !== "production" ? '__input_keydown_arrow_up__' : 1;
var InputKeyDownEscape = process.env.NODE_ENV !== "production" ? '__input_keydown_escape__' : 2;
var InputKeyDownHome = process.env.NODE_ENV !== "production" ? '__input_keydown_home__' : 3;
var InputKeyDownEnd = process.env.NODE_ENV !== "production" ? '__input_keydown_end__' : 4;
var InputKeyDownEnter = process.env.NODE_ENV !== "production" ? '__input_keydown_enter__' : 5;
var InputChange = process.env.NODE_ENV !== "production" ? '__input_change__' : 6;
var InputBlur = process.env.NODE_ENV !== "production" ? '__input_blur__' : 7;
var MenuMouseLeave = process.env.NODE_ENV !== "production" ? '__menu_mouse_leave__' : 8;
var ItemMouseMove = process.env.NODE_ENV !== "production" ? '__item_mouse_move__' : 9;
var ItemClick = process.env.NODE_ENV !== "production" ? '__item_click__' : 10;
var ToggleButtonClick = process.env.NODE_ENV !== "production" ? '__togglebutton_click__' : 11;
var FunctionToggleMenu = process.env.NODE_ENV !== "production" ? '__function_toggle_menu__' : 12;
var FunctionOpenMenu = process.env.NODE_ENV !== "production" ? '__function_open_menu__' : 13;
var FunctionCloseMenu = process.env.NODE_ENV !== "production" ? '__function_close_menu__' : 14;
var FunctionSetHighlightedIndex = process.env.NODE_ENV !== "production" ? '__function_set_highlighted_index__' : 15;
var FunctionSelectItem = process.env.NODE_ENV !== "production" ? '__function_select_item__' : 16;
var FunctionSetInputValue = process.env.NODE_ENV !== "production" ? '__function_set_input_value__' : 17;
var FunctionReset$1 = process.env.NODE_ENV !== "production" ? '__function_reset__' : 18;
var ControlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? '__controlled_prop_updated_selected_item__' : 19;
var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: InputKeyDownArrowDown,
  InputKeyDownArrowUp: InputKeyDownArrowUp,
  InputKeyDownEscape: InputKeyDownEscape,
  InputKeyDownHome: InputKeyDownHome,
  InputKeyDownEnd: InputKeyDownEnd,
  InputKeyDownEnter: InputKeyDownEnter,
  InputChange: InputChange,
  InputBlur: InputBlur,
  MenuMouseLeave: MenuMouseLeave,
  ItemMouseMove: ItemMouseMove,
  ItemClick: ItemClick,
  ToggleButtonClick: ToggleButtonClick,
  FunctionToggleMenu: FunctionToggleMenu,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
  FunctionSelectItem: FunctionSelectItem,
  FunctionSetInputValue: FunctionSetInputValue,
  FunctionReset: FunctionReset$1,
  ControlledPropUpdatedSelectedItem: ControlledPropUpdatedSelectedItem
});

function getInitialState$1(props) {
  var initialState = getInitialState$2(props);
  var selectedItem = initialState.selectedItem;
  var inputValue = initialState.inputValue;

  if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) {
    inputValue = props.itemToString(selectedItem);
  }

  return _extends({}, initialState, {
    inputValue: inputValue
  });
}

var propTypes$1 = {
  items: propTypes.array.isRequired,
  itemToString: propTypes.func,
  getA11yStatusMessage: propTypes.func,
  getA11ySelectionMessage: propTypes.func,
  circularNavigation: propTypes.bool,
  highlightedIndex: propTypes.number,
  defaultHighlightedIndex: propTypes.number,
  initialHighlightedIndex: propTypes.number,
  isOpen: propTypes.bool,
  defaultIsOpen: propTypes.bool,
  initialIsOpen: propTypes.bool,
  selectedItem: propTypes.any,
  initialSelectedItem: propTypes.any,
  defaultSelectedItem: propTypes.any,
  inputValue: propTypes.string,
  defaultInputValue: propTypes.string,
  initialInputValue: propTypes.string,
  id: propTypes.string,
  labelId: propTypes.string,
  menuId: propTypes.string,
  getItemId: propTypes.func,
  inputId: propTypes.string,
  toggleButtonId: propTypes.string,
  stateReducer: propTypes.func,
  onSelectedItemChange: propTypes.func,
  onHighlightedIndexChange: propTypes.func,
  onStateChange: propTypes.func,
  onIsOpenChange: propTypes.func,
  onInputValueChange: propTypes.func,
  environment: propTypes.shape({
    addEventListener: propTypes.func,
    removeEventListener: propTypes.func,
    document: propTypes.shape({
      getElementById: propTypes.func,
      activeElement: propTypes.any,
      body: propTypes.any
    })
  })
};
/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */

function useControlledReducer(reducer, initialState, props) {
  var previousSelectedItemRef = useRef();

  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
      state = _useEnhancedReducer[0],
      dispatch = _useEnhancedReducer[1]; // ToDo: if needed, make same approach as selectedItemChanged from Downshift.


  useEffect(function () {
    if (isControlledProp(props, 'selectedItem')) {
      if (previousSelectedItemRef.current !== props.selectedItem) {
        dispatch({
          type: ControlledPropUpdatedSelectedItem,
          inputValue: props.itemToString(props.selectedItem)
        });
      }

      previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    }
  });
  return [getState(state, props), dispatch];
} // eslint-disable-next-line import/no-mutable-exports


var validatePropTypes$1 = noop;
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  validatePropTypes$1 = function validatePropTypes(options, caller) {
    propTypes.checkPropTypes(propTypes$1, options, 'prop', caller.name);
  };
}

var defaultProps$1 = _extends({}, defaultProps$3, {
  getA11yStatusMessage: getA11yStatusMessage$1,
  circularNavigation: true
});
/* eslint-disable complexity */


function downshiftUseComboboxReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemClick:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;

    case InputKeyDownArrowDown:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }

      break;

    case InputKeyDownArrowUp:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }

      break;

    case InputKeyDownEnter:
      changes = _extends({}, state.isOpen && state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex],
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;

    case InputKeyDownEscape:
      changes = _extends({
        isOpen: false,
        highlightedIndex: -1
      }, !state.isOpen && {
        selectedItem: null,
        inputValue: ''
      });
      break;

    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case InputBlur:
      changes = _extends({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && action.selectItem && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;

    case InputChange:
      changes = {
        isOpen: true,
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        inputValue: action.inputValue
      };
      break;

    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem,
        inputValue: props.itemToString(action.selectedItem)
      };
      break;

    case ControlledPropUpdatedSelectedItem:
      changes = {
        inputValue: action.inputValue
      };
      break;

    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$1);
  }

  return _extends({}, state, changes);
}
/* eslint-enable complexity */


useCombobox.stateChangeTypes = stateChangeTypes$1;

function useCombobox(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  validatePropTypes$1(userProps, useCombobox); // Props defaults and destructuring.

  var props = _extends({}, defaultProps$1, userProps);

  var initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      items = props.items,
      scrollIntoView = props.scrollIntoView,
      environment = props.environment,
      getA11yStatusMessage = props.getA11yStatusMessage,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      itemToString = props.itemToString; // Initial state depending on controlled props.

  var initialState = getInitialState$1(props);

  var _useControlledReducer = useControlledReducer(downshiftUseComboboxReducer, initialState, props),
      state = _useControlledReducer[0],
      dispatch = _useControlledReducer[1];

  var isOpen = state.isOpen,
      highlightedIndex = state.highlightedIndex,
      selectedItem = state.selectedItem,
      inputValue = state.inputValue; // Element refs.

  var menuRef = useRef(null);
  var itemRefs = useRef({});
  var inputRef = useRef(null);
  var toggleButtonRef = useRef(null);
  var comboboxRef = useRef(null);
  var isInitialMountRef = useRef(true); // prevent id re-generation between renders.

  var elementIds = useElementIds(props); // used to keep track of how many items we had on previous cycle.

  var previousResultCountRef = useRef(); // utility callback to get item element.

  var latest = useLatestRef({
    state: state,
    props: props
  });
  var getItemNodeFromIndex = useCallback(function (index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]); // Effects.
  // Sets a11y status message on changes in state.

  useA11yMessageSetter(getA11yStatusMessage, [isOpen, highlightedIndex, inputValue, items], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Sets a11y status message on changes in selectedItem.

  useA11yMessageSetter(getA11ySelectionMessage, [selectedItem], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Scroll on highlighted item if change comes from keyboard.

  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    itemRefs: itemRefs,
    scrollIntoView: scrollIntoView,
    getItemNodeFromIndex: getItemNodeFromIndex
  });
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props: props,
    state: state
  }); // Focus the input on first render if required.

  useEffect(function () {
    var focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;

    if (focusOnOpen && inputRef.current) {
      inputRef.current.focus();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  useEffect(function () {
    if (isInitialMountRef.current) {
      return;
    }

    previousResultCountRef.current = items.length;
  }); // Add mouse/touch events to document.

  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [comboboxRef, menuRef, toggleButtonRef], environment, function () {
    dispatch({
      type: InputBlur,
      selectItem: false
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getInputProps', 'getComboboxProps', 'getMenuProps'); // Make initial ref false.

  useEffect(function () {
    isInitialMountRef.current = false;
  }, []); // Reset itemRefs on close.

  useEffect(function () {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]);
  /* Event handler functions */

  var inputKeyDownHandlers = useMemo(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowDown,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowUp,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Home: function Home(event) {
        if (!latest.current.state.isOpen) {
          return;
        }

        event.preventDefault();
        dispatch({
          type: InputKeyDownHome,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      End: function End(event) {
        if (!latest.current.state.isOpen) {
          return;
        }

        event.preventDefault();
        dispatch({
          type: InputKeyDownEnd,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        var latestState = latest.current.state;

        if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
          dispatch({
            type: InputKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        var latestState = latest.current.state; // if closed or no highlighted index, do nothing.

        if (!latestState.isOpen || latestState.highlightedIndex < 0 || event.which === 229 // if IME composing, wait for next Enter keydown event.
        ) {
          return;
        }

        event.preventDefault();
        dispatch({
          type: InputKeyDownEnter,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      }
    };
  }, [dispatch, latest, getItemNodeFromIndex]); // Getter props.

  var getLabelProps = useCallback(function (labelProps) {
    return _extends({
      id: elementIds.labelId,
      htmlFor: elementIds.inputId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = useCallback(function (_temp, _temp2) {
    var _extends2;

    var _ref = _temp === void 0 ? {} : _temp,
        onMouseLeave = _ref.onMouseLeave,
        _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
        ref = _ref.ref,
        rest = _objectWithoutPropertiesLoose$1(_ref, ["onMouseLeave", "refKey", "ref"]);

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$suppressRefErro = _ref2.suppressRefError,
        suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, function () {
      dispatch({
        type: MenuMouseLeave
      });
    }), _extends2), rest);
  }, [dispatch, setGetterPropCallInfo, elementIds]);
  var getItemProps = useCallback(function (_temp3) {
    var _extends3, _ref4;

    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        item = _ref3.item,
        index = _ref3.index,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
        ref = _ref3.ref,
        onMouseMove = _ref3.onMouseMove,
        onClick = _ref3.onClick;

    _ref3.onPress;

    var rest = _objectWithoutPropertiesLoose$1(_ref3, ["item", "index", "refKey", "ref", "onMouseMove", "onClick", "onPress"]);

    var _latest$current = latest.current,
        latestProps = _latest$current.props,
        latestState = _latest$current.state;
    var itemIndex = getItemIndex(index, item, latestProps.items);

    if (itemIndex < 0) {
      throw new Error('Pass either item or item index in getItemProps!');
    }

    var onSelectKey = 'onClick';
    var customClickHandler = onClick;

    var itemHandleMouseMove = function itemHandleMouseMove() {
      if (index === latestState.highlightedIndex) {
        return;
      }

      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove,
        index: index
      });
    };

    var itemHandleClick = function itemHandleClick() {
      dispatch({
        type: ItemClick,
        index: index
      });

      if (inputRef.current) {
        inputRef.current.focus();
      }
    };

    return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
      }
    }), _extends3.role = 'option', _extends3['aria-selected'] = "" + (itemIndex === latestState.highlightedIndex), _extends3.id = elementIds.getItemId(itemIndex), _extends3), !rest.disabled && (_ref4 = {
      onMouseMove: callAllEventHandlers(onMouseMove, itemHandleMouseMove)
    }, _ref4[onSelectKey] = callAllEventHandlers(customClickHandler, itemHandleClick), _ref4), rest);
  }, [dispatch, latest, shouldScrollRef, elementIds]);
  var getToggleButtonProps = useCallback(function (_temp4) {
    var _extends4;

    var _ref5 = _temp4 === void 0 ? {} : _temp4,
        onClick = _ref5.onClick;

    _ref5.onPress;

    var _ref5$refKey = _ref5.refKey,
        refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
        ref = _ref5.ref,
        rest = _objectWithoutPropertiesLoose$1(_ref5, ["onClick", "onPress", "refKey", "ref"]);

    var toggleButtonHandleClick = function toggleButtonHandleClick() {
      dispatch({
        type: ToggleButtonClick
      });

      if (!latest.current.state.isOpen && inputRef.current) {
        inputRef.current.focus();
      }
    };

    return _extends((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && _extends({}, {
      onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
    }), rest);
  }, [dispatch, latest, elementIds]);
  var getInputProps = useCallback(function (_temp5, _temp6) {
    var _extends5;

    var _ref6 = _temp5 === void 0 ? {} : _temp5,
        onKeyDown = _ref6.onKeyDown,
        onChange = _ref6.onChange,
        onInput = _ref6.onInput,
        onBlur = _ref6.onBlur;

    _ref6.onChangeText;

    var _ref6$refKey = _ref6.refKey,
        refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey,
        ref = _ref6.ref,
        rest = _objectWithoutPropertiesLoose$1(_ref6, ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "refKey", "ref"]);

    var _ref7 = _temp6 === void 0 ? {} : _temp6,
        _ref7$suppressRefErro = _ref7.suppressRefError,
        suppressRefError = _ref7$suppressRefErro === void 0 ? false : _ref7$suppressRefErro;

    setGetterPropCallInfo('getInputProps', suppressRefError, refKey, inputRef);
    var latestState = latest.current.state;

    var inputHandleKeyDown = function inputHandleKeyDown(event) {
      var key = normalizeArrowKey(event);

      if (key && inputKeyDownHandlers[key]) {
        inputKeyDownHandlers[key](event);
      }
    };

    var inputHandleChange = function inputHandleChange(event) {
      dispatch({
        type: InputChange,
        inputValue: event.target.value
      });
    };

    var inputHandleBlur = function inputHandleBlur() {
      /* istanbul ignore else */
      if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
        dispatch({
          type: InputBlur,
          selectItem: true
        });
      }
    };
    /* istanbul ignore next (preact) */


    var onChangeKey = 'onChange';
    var eventHandlers = {};

    if (!rest.disabled) {
      var _eventHandlers;

      eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers);
    }

    return _extends((_extends5 = {}, _extends5[refKey] = handleRefs(ref, function (inputNode) {
      inputRef.current = inputNode;
    }), _extends5.id = elementIds.inputId, _extends5['aria-autocomplete'] = 'list', _extends5['aria-controls'] = elementIds.menuId, _extends5), latestState.isOpen && latestState.highlightedIndex > -1 && {
      'aria-activedescendant': elementIds.getItemId(latestState.highlightedIndex)
    }, {
      'aria-labelledby': elementIds.labelId,
      // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
      // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
      autoComplete: 'off',
      value: latestState.inputValue
    }, eventHandlers, rest);
  }, [dispatch, inputKeyDownHandlers, latest, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds]);
  var getComboboxProps = useCallback(function (_temp7, _temp8) {
    var _extends6;

    var _ref8 = _temp7 === void 0 ? {} : _temp7,
        _ref8$refKey = _ref8.refKey,
        refKey = _ref8$refKey === void 0 ? 'ref' : _ref8$refKey,
        ref = _ref8.ref,
        rest = _objectWithoutPropertiesLoose$1(_ref8, ["refKey", "ref"]);

    var _ref9 = _temp8 === void 0 ? {} : _temp8,
        _ref9$suppressRefErro = _ref9.suppressRefError,
        suppressRefError = _ref9$suppressRefErro === void 0 ? false : _ref9$suppressRefErro;

    setGetterPropCallInfo('getComboboxProps', suppressRefError, refKey, comboboxRef);
    return _extends((_extends6 = {}, _extends6[refKey] = handleRefs(ref, function (comboboxNode) {
      comboboxRef.current = comboboxNode;
    }), _extends6.role = 'combobox', _extends6['aria-haspopup'] = 'listbox', _extends6['aria-owns'] = elementIds.menuId, _extends6['aria-expanded'] = latest.current.state.isOpen, _extends6), rest);
  }, [latest, setGetterPropCallInfo, elementIds]); // returns

  var toggleMenu = useCallback(function () {
    dispatch({
      type: FunctionToggleMenu
    });
  }, [dispatch]);
  var closeMenu = useCallback(function () {
    dispatch({
      type: FunctionCloseMenu
    });
  }, [dispatch]);
  var openMenu = useCallback(function () {
    dispatch({
      type: FunctionOpenMenu
    });
  }, [dispatch]);
  var setHighlightedIndex = useCallback(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = useCallback(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var setInputValue = useCallback(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue,
      inputValue: newInputValue
    });
  }, [dispatch]);
  var reset = useCallback(function () {
    dispatch({
      type: FunctionReset$1
    });
  }, [dispatch]);
  return {
    // prop getters.
    getItemProps: getItemProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getInputProps: getInputProps,
    getComboboxProps: getComboboxProps,
    getToggleButtonProps: getToggleButtonProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    setInputValue: setInputValue,
    selectItem: selectItem,
    reset: reset,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}
/**
 * Returns a message to be added to aria-live region when item is removed.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */


function getA11yRemovalMessage(selectionParameters) {
  var removedSelectedItem = selectionParameters.removedSelectedItem,
      itemToStringLocal = selectionParameters.itemToString;
  return itemToStringLocal(removedSelectedItem) + " has been removed.";
}

({
  selectedItems: propTypes.array,
  initialSelectedItems: propTypes.array,
  defaultSelectedItems: propTypes.array,
  itemToString: propTypes.func,
  getA11yRemovalMessage: propTypes.func,
  stateReducer: propTypes.func,
  activeIndex: propTypes.number,
  initialActiveIndex: propTypes.number,
  defaultActiveIndex: propTypes.number,
  onActiveIndexChange: propTypes.func,
  onSelectedItemsChange: propTypes.func,
  keyNavigationNext: propTypes.string,
  keyNavigationPrevious: propTypes.string,
  environment: propTypes.shape({
    addEventListener: propTypes.func,
    removeEventListener: propTypes.func,
    document: propTypes.shape({
      getElementById: propTypes.func,
      activeElement: propTypes.any,
      body: propTypes.any
    })
  })
});
({
  itemToString: defaultProps$3.itemToString,
  stateReducer: defaultProps$3.stateReducer,
  environment: defaultProps$3.environment,
  getA11yRemovalMessage: getA11yRemovalMessage,
  keyNavigationNext: 'ArrowRight',
  keyNavigationPrevious: 'ArrowLeft'
}); // eslint-disable-next-line import/no-mutable-exports

/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') ;
process.env.NODE_ENV !== "production" ? '__selected_item_click__' : 0;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_delete__' : 1;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_backspace__' : 2;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_next__' : 3;
process.env.NODE_ENV !== "production" ? '__selected_item_keydown_navigation_previous__' : 4;
process.env.NODE_ENV !== "production" ? '__dropdown_keydown_navigation_previous__' : 5;
process.env.NODE_ENV !== "production" ? '__dropdown_keydown_backspace__' : 6;
process.env.NODE_ENV !== "production" ? '__dropdown_click__' : 7;
process.env.NODE_ENV !== "production" ? '__function_add_selected_item__' : 8;
process.env.NODE_ENV !== "production" ? '__function_remove_selected_item__' : 9;
process.env.NODE_ENV !== "production" ? '__function_set_selected_items__' : 10;
process.env.NODE_ENV !== "production" ? '__function_set_active_index__' : 11;
process.env.NODE_ENV !== "production" ? '__function_reset__' : 12;
var ROW_HEIGHT$2 = 42;

var InputSelectList = function InputSelectList(_ref38) {
  var getItemProps = _ref38.getItemProps,
      getMenuProps = _ref38.getMenuProps,
      highlightedIndex = _ref38.highlightedIndex,
      options = _ref38.options,
      itemToString = _ref38.itemToString;
  var fullHeight = options.length * ROW_HEIGHT$2;

  var item = function item(_item, index) {
    return React.createElement("div", Object.assign({
      className: "sid-input-select-list__item ".concat(highlightedIndex === index ? 'sid-input-select-list__item--highlighted' : ''),
      key: index
    }, getItemProps({
      index: index,
      item: _item
    })), itemToString(options[index]));
  };

  return React.createElement("div", Object.assign({
    className: "sid-input-select-list__menu"
  }, getMenuProps(), {
    tabIndex: -1,
    style: {
      height: Math.min(fullHeight, 280)
    }
  }), options.map(function (option, index) {
    return item(option, index);
  }));
};

var InputSelectListComponent = InputSelectList;

var InputSelectButton = function InputSelectButton(_ref39) {
  var clearSelection = _ref39.clearSelection,
      disabled = _ref39.disabled,
      getToggleButtonProps = _ref39.getToggleButtonProps,
      isOpen = _ref39.isOpen,
      buttonRef = _ref39.buttonRef;

  if (clearSelection) {
    return React.createElement("button", {
      "aria-label": "clear selection",
      className: "sid-input-select-button",
      disabled: disabled,
      onClick: clearSelection,
      type: "button",
      tabIndex: 0,
      ref: function ref(input) {
        return setRef(buttonRef, input);
      }
    }, React.createElement("svg", {
      viewBox: "0 0 20 20",
      preserveAspectRatio: "none",
      width: 12,
      fill: "transparent",
      stroke: "#8A8A8A",
      strokeWidth: "1.1px"
    }, React.createElement("path", {
      d: "M1,1 L19,19"
    }), React.createElement("path", {
      d: "M19,1 L1,19"
    })));
  }

  return React.createElement("button", Object.assign({}, getToggleButtonProps(), {
    className: "sid-input-select-button",
    disabled: disabled,
    type: "button",
    tabIndex: 0,
    ref: function ref(input) {
      return setRef(buttonRef, input);
    }
  }), React.createElement("svg", {
    viewBox: "0 0 20 20",
    preserveAspectRatio: "none",
    width: 16,
    fill: "transparent",
    stroke: "#8A8A8A",
    strokeWidth: "1.1px",
    transform: isOpen ? 'rotate(180)' : undefined
  }, React.createElement("path", {
    d: "M1,6 L10,15 L19,6"
  })));
};

var InputSelectButtonComponent = InputSelectButton;
/* eslint-disable indent */

var InputSelect = function InputSelect(_ref40) {
  var className = _ref40.className,
      inputId = _ref40.inputId,
      disabled = _ref40.disabled,
      fieldId = _ref40.fieldId,
      isErrored = _ref40.isErrored,
      options = _ref40.options,
      onKeyDown = _ref40.onKeyDown,
      onChange = _ref40.onChange,
      placeholder = _ref40.placeholder,
      _ref40$suppressPlaceh = _ref40.suppressPlaceholder,
      suppressPlaceholder = _ref40$suppressPlaceh === void 0 ? true : _ref40$suppressPlaceh,
      value = _ref40.value,
      autoFocus = _ref40.autoFocus,
      ariaLabel = _ref40.ariaLabel,
      isRequired = _ref40.isRequired,
      buttonRef = _ref40.buttonRef;

  var itemToString = function itemToString(item) {
    return item ? item.label : '';
  };

  var filterOptions = function filterOptions(options, inputValue) {
    var filteredOptions = options.filter(function (option) {
      return !inputValue || option.label.toLowerCase().includes(inputValue.toLowerCase()) || option.value.toString().toLowerCase().includes(inputValue.toLowerCase());
    });
    return filteredOptions;
  };

  var handleOnBlur = function handleOnBlur(event, selectHighlightedItem, selectedItem) {
    if (!selectedItem || event.currentTarget.value !== selectedItem.label) {
      selectHighlightedItem();
    }
  };

  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
    }
  };

  return React.createElement(Downshift, {
    id: inputId,
    onChange: onChange,
    itemToString: itemToString,
    selectedItem: value && value.value && value.label ? value : '',
    defaultHighlightedIndex: 0
  }, function (_ref41) {
    var clearSelection = _ref41.clearSelection,
        getInputProps = _ref41.getInputProps,
        getItemProps = _ref41.getItemProps,
        getMenuProps = _ref41.getMenuProps,
        getToggleButtonProps = _ref41.getToggleButtonProps,
        highlightedIndex = _ref41.highlightedIndex,
        inputValue = _ref41.inputValue,
        isOpen = _ref41.isOpen,
        openMenu = _ref41.openMenu,
        selectedItem = _ref41.selectedItem,
        selectHighlightedItem = _ref41.selectHighlightedItem;
    return React.createElement("div", {
      className: "sid-input-select-list ".concat(className)
    }, React.createElement("input", Object.assign({}, getInputProps({
      onFocus: function onFocus() {
        return openMenu();
      },
      onBlur: function onBlur(event) {
        return handleOnBlur(event, selectHighlightedItem, selectedItem);
      },
      onKeyDown: function onKeyDown(event) {
        return handleOnKeyDown(event);
      }
    }), {
      // TODO resolve next line. Product needs this to autofocus, but linter says bad for accessibility
      // eslint-disable-next-line
      autoFocus: autoFocus,
      id: inputId,
      className: "sid-l-full-width sid-text-input ".concat(suppressPlaceholder ? 'sid-hidden-placeholder' : '', " ").concat(isErrored ? 'sid-text-input--error' : ''),
      disabled: disabled,
      placeholder: placeholder,
      ref: function ref(input) {
        return setRef(fieldId, input);
      },
      "aria-required": isRequired
    })), React.createElement(InputSelectButtonComponent, {
      disabled: disabled,
      getToggleButtonProps: getToggleButtonProps,
      isOpen: isOpen,
      clearSelection: selectedItem ? clearSelection : undefined,
      buttonRef: buttonRef
    }), isOpen ? React.createElement("div", null, filterOptions(options, inputValue).length > 0 ? React.createElement(InputSelectListComponent, {
      highlightedIndex: highlightedIndex,
      itemToString: itemToString,
      options: filterOptions(options, inputValue),
      getItemProps: getItemProps,
      getMenuProps: getMenuProps
    }) : React.createElement("div", Object.assign({
      className: "sid-input-select-list__menu"
    }, getMenuProps({
      'aria-label': ariaLabel
    })), React.createElement("div", {
      className: "sid-input-select-list__message"
    }, React.createElement(FormattedHTMLMessage, {
      id: "noOptions",
      defaultMessage: "No Options"
    })))) : null);
  });
};

InputSelect.defaultProps = {
  className: undefined,
  disabled: false,
  inputId: undefined,
  isErrored: false,
  onKeyDown: undefined,
  placeholder: '',
  value: undefined
};
var InputSelectComponent = InputSelect;

var Country = function Country(_ref42) {
  var value = _ref42.value,
      isErrored = _ref42.isErrored,
      options = _ref42.options,
      _onChange5 = _ref42.onChange,
      onKeyDown = _ref42.onKeyDown,
      intl = _ref42.intl,
      _ref42$placeholder = _ref42.placeholder,
      placeholder = _ref42$placeholder === void 0 ? '' : _ref42$placeholder,
      _ref42$isRequired = _ref42.isRequired,
      isRequired = _ref42$isRequired === void 0 ? false : _ref42$isRequired;
  return React.createElement("div", {
    className: "sid-field sid-country"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-country"
  }, React.createElement("div", {
    className: "sid-field__label sid-country__label sid-l-space-btm-sm".concat(isRequired ? ' sid-field__label--required' : '')
  }, React.createElement(FormattedHTMLMessage, {
    id: "country",
    defaultMessage: "Country where you go to school"
  }))), React.createElement(InputSelectComponent, {
    fieldId: "country",
    inputId: "sid-country",
    isErrored: isErrored,
    options: options,
    onChange: function onChange(country) {
      return _onChange5(country);
    },
    onKeyDown: onKeyDown,
    placeholder: placeholder || intl.formatMessage({
      id: 'countryPlaceholder',
      defaultMessage: 'Country*'
    }),
    value: value ? {
      value: value.value,
      label: intl.formatMessage({
        id: "countries.".concat(value.value),
        defaultMessage: value.label || value.value
      })
    } : undefined
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidCountry",
    defaultMessage: "Invalid country"
  })) : null);
};

var CountryComponent = injectIntl(Country);
var ROW_HEIGHT$1 = 42;

var SelectList = function SelectList(_ref43) {
  var getItemProps = _ref43.getItemProps,
      getMenuProps = _ref43.getMenuProps,
      highlightedIndex = _ref43.highlightedIndex,
      options = _ref43.options,
      itemToString = _ref43.itemToString;
  var fullHeight = options.length * ROW_HEIGHT$1;

  var item = function item(_item2, index) {
    return React.createElement("div", Object.assign({
      className: "sid-select-list__item ".concat(highlightedIndex === index ? 'sid-select-list__item--highlighted' : ''),
      key: index
    }, getItemProps({
      index: index,
      item: _item2
    })), itemToString(options[index]));
  };

  return React.createElement("div", Object.assign({
    className: "sid-input-select-list__menu"
  }, getMenuProps(), {
    tabIndex: -1,
    style: {
      height: Math.min(fullHeight, 280)
    }
  }), options.map(function (option, index) {
    return item(option, index);
  }));
};

var SelectListComponent = SelectList;

var SelectButton = function SelectButton(_ref44) {
  var getToggleButtonProps = _ref44.getToggleButtonProps,
      isOpen = _ref44.isOpen;
  return React.createElement("button", Object.assign({}, getToggleButtonProps(), {
    className: "sid-select-button",
    type: "button"
  }), React.createElement("svg", {
    viewBox: "0 0 20 20",
    preserveAspectRatio: "none",
    width: 16,
    fill: "transparent",
    stroke: "#979797",
    strokeWidth: "1.1px",
    transform: isOpen ? 'rotate(180)' : undefined
  }, React.createElement("path", {
    d: "M1,6 L10,15 L19,6"
  })));
};

var SelectButtonComponent = SelectButton;

var Select = function Select(_ref45) {
  var className = _ref45.className,
      hideDropDownButton = _ref45.hideDropDownButton,
      isErrored = _ref45.isErrored,
      options = _ref45.options,
      onChange = _ref45.onChange,
      overrideInputClassName = _ref45.overrideInputClassName,
      placeholder = _ref45.placeholder,
      value = _ref45.value;

  var itemToString = function itemToString(item) {
    return item ? item.label : '';
  };

  return React.createElement(Downshift, {
    onChange: onChange,
    itemToString: itemToString,
    initialSelectedItem: value && value.value && value.label ? value : undefined,
    defaultHighlightedIndex: 0
  }, function (_ref46) {
    var getInputProps = _ref46.getInputProps,
        getItemProps = _ref46.getItemProps,
        getMenuProps = _ref46.getMenuProps,
        getToggleButtonProps = _ref46.getToggleButtonProps,
        highlightedIndex = _ref46.highlightedIndex,
        isOpen = _ref46.isOpen,
        openMenu = _ref46.openMenu;
    return React.createElement("div", {
      className: "sid-select-list ".concat(className)
    }, React.createElement("input", Object.assign({}, getInputProps({
      onFocus: openMenu
    }), getToggleButtonProps, {
      className: "\n                        sid-l-full-width\n                        ".concat(overrideInputClassName || 'sid-select-input', "\n                        ").concat(isErrored ? 'sid-select-input--error' : '', "\n                    "),
      placeholder: placeholder,
      readOnly: true
    })), !hideDropDownButton ? React.createElement(SelectButtonComponent, {
      getToggleButtonProps: getToggleButtonProps,
      isOpen: isOpen
    }) : null, isOpen ? React.createElement("div", null, options.length > 0 ? React.createElement(SelectListComponent, {
      highlightedIndex: highlightedIndex,
      itemToString: itemToString,
      options: options,
      getItemProps: getItemProps,
      getMenuProps: getMenuProps
    }) : React.createElement("div", Object.assign({
      className: "sid-select-list__menu"
    }, getMenuProps()), React.createElement("div", {
      className: "sid-select-list__message"
    }, React.createElement(FormattedHTMLMessage, {
      id: "noOptions",
      defaultMessage: "No Options"
    })))) : null);
  });
};

Select.defaultProps = {
  className: undefined,
  hideDropDownButton: false,
  isErrored: false,
  overrideInputClassName: undefined,
  placeholder: '',
  value: undefined
};
var SelectComponent = Select;

var ChangeLocale = function ChangeLocale(_ref47) {
  var value = _ref47.value,
      options = _ref47.options,
      _onChange6 = _ref47.onChange,
      intl = _ref47.intl;
  var newOptions = options.map(function (option) {
    return {
      value: option.value,
      label: intl.formatMessage({
        id: "locales.".concat(option.value),
        defaultMessage: 'Label not found'
      })
    };
  });
  return React.createElement("div", {
    className: "sid-change-locale"
  }, React.createElement("div", {
    className: "sid-field__label sid-change-locale__label "
  }, React.createElement(FormattedHTMLMessage, {
    id: "changeLanguage",
    defaultMessage: "Change language"
  })), React.createElement(SelectComponent, {
    className: "sid-change-locale__select",
    hideDropDownButton: true,
    options: newOptions,
    onChange: function onChange(locale) {
      return _onChange6(locale);
    },
    overrideInputClassName: "sid-change-locale__input",
    value: {
      value: value.value,
      label: intl.formatMessage({
        id: "locales.".concat(value.value),
        defaultMessage: 'Label not found'
      })
    }
  }), React.createElement("div", {
    className: "sid-l-space-btm-sm"
  }));
};

var ChangeLocaleComponent = injectIntl(ChangeLocale);

var LoadingSpinnerComponent = function LoadingSpinnerComponent() {
  return React.createElement("div", {
    className: "sid-spinner"
  }, React.createElement("div", {
    className: "sid-spinner__frame"
  }), React.createElement("div", {
    className: "sid-spinner__frame"
  }), React.createElement("div", {
    className: "sid-spinner__frame"
  }), React.createElement("div", {
    className: "sid-spinner__frame"
  }));
};

var filterOrgsFromParamsUrl = function filterOrgsFromParamsUrl(dynamic, fixed) {
  var eligibleOrgs = [];
  var ineligibleOrgs = [];
  var orgs = dynamic.reduce(function (hashmap, organization) {
    hashmap[organization.name] = true; // eslint-disable-line

    eligibleOrgs.push(organization);
    return hashmap;
  }, {});
  fixed.forEach(function (org) {
    if (!orgs[org.name]) {
      ineligibleOrgs.push(org);
    }
  });
  return [eligibleOrgs, ineligibleOrgs];
};

var RequestOrganizationSearch = function RequestOrganizationSearch(_ref48) {
  var intl = _ref48.intl;

  var _React$useContext = React.useContext(RequestOrganizationContext),
      _React$useContext2 = _slicedToArray2(_React$useContext, 2),
      requestOrganizationService = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var viewModel = requestOrganizationService.viewModel;
  var programTheme = requestOrganizationService.programTheme;
  var localeChoices = getAvailableLocaleChoices(programTheme, intl);
  var defaultLocaleChoice = {
    value: 'en-US',
    label: 'English'
  };
  var countryChoices = getAvailableCountryChoices(programTheme, intl);
  var defaultCountryChoice = getDefaultCountryChoice(countryChoices);

  var updateRequestOrganizationViewModel = function updateRequestOrganizationViewModel(updatedViewModel) {
    dispatch({
      type: 'UPDATE_VIEW_MODEL',
      payload: updatedViewModel
    });
  };

  var updateRequestOrganizationLocale = function updateRequestOrganizationLocale(locale) {
    dispatch({
      type: 'SET_LOCALE',
      payload: locale
    });
  };

  React.useEffect(function () {
    if (!viewModel.countryChoice) {
      updateRequestOrganizationViewModel({
        countryChoice: defaultCountryChoice
      });
    }
  }, []); // country change handler

  React.useEffect(function () {
    if (!viewModel.countryChoice || viewModel.countryChoice.value === null) {
      updateRequestOrganizationViewModel({
        displayResults: false,
        completeRequest: false,
        firstNameError: null,
        lastNameError: null,
        emailError: null,
        eligibleOrgs: [],
        ineligibleOrgs: []
      });
    } else if (viewModel.searchByOrgName) {
      if (viewModel.orgName) {
        searchByOrgName();
      }
    } else if (viewModel.orgDomain) {
      searchByOrgDomain();
    }
  }, [viewModel.countryChoice]);

  var searchOrganizations = /*#__PURE__*/function () {
    var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(dynamicParamsUrl, fixedParamsUrl) {
      var eligibleOrgs, ineligibleOrgs, _yield$Promise$all, _yield$Promise$all2, dynamicParamsResults, fixedParamsResults, _filterOrgsFromParams, _filterOrgsFromParams2, eligibleOrgsFiltered, ineligibleOrgsFiltered;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              eligibleOrgs = [];
              ineligibleOrgs = [];
              updateRequestOrganizationViewModel({
                isSearching: true
              });
              _context13.prev = 3;
              _context13.next = 6;
              return Promise.all([fetchRequestOrganizations(dynamicParamsUrl), fetchRequestOrganizations(fixedParamsUrl)]);

            case 6:
              _yield$Promise$all = _context13.sent;
              _yield$Promise$all2 = _slicedToArray2(_yield$Promise$all, 2);
              dynamicParamsResults = _yield$Promise$all2[0];
              fixedParamsResults = _yield$Promise$all2[1];
              _filterOrgsFromParams = filterOrgsFromParamsUrl(dynamicParamsResults, fixedParamsResults), _filterOrgsFromParams2 = _slicedToArray2(_filterOrgsFromParams, 2), eligibleOrgsFiltered = _filterOrgsFromParams2[0], ineligibleOrgsFiltered = _filterOrgsFromParams2[1];
              eligibleOrgs.push.apply(eligibleOrgs, _toConsumableArray2(eligibleOrgsFiltered));
              ineligibleOrgs.push.apply(ineligibleOrgs, _toConsumableArray2(ineligibleOrgsFiltered));
              _context13.next = 19;
              break;

            case 15:
              _context13.prev = 15;
              _context13.t0 = _context13["catch"](3);
              updateRequestOrganizationViewModel({
                orgDomainError: 'invalidUrl',
                eligibleOrgs: [],
                ineligibleOrgs: [],
                isSearching: false
              });
              return _context13.abrupt("return");

            case 19:
              updateRequestOrganizationViewModel({
                eligibleOrgs: eligibleOrgs,
                ineligibleOrgs: ineligibleOrgs,
                completeRequest: false,
                firstNameError: null,
                lastNameError: null,
                emailError: null,
                displayResults: true,
                isSearching: false
              });

            case 20:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[3, 15]]);
    }));

    return function searchOrganizations(_x26, _x27) {
      return _ref49.apply(this, arguments);
    };
  }();

  var searchByOrgDomain = /*#__PURE__*/function () {
    var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      var orgDomain, _generateSearchOrgUrl, _generateSearchOrgUrl2, dynamicParamsUrl, fixedParamsUrl;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (canSearchByDomain()) {
                _context14.next = 2;
                break;
              }

              return _context14.abrupt("return");

            case 2:
              orgDomain = getDomainFromUrl(viewModel.orgDomain);
              _generateSearchOrgUrl = generateSearchOrgUrl('domain', orgDomain), _generateSearchOrgUrl2 = _slicedToArray2(_generateSearchOrgUrl, 2), dynamicParamsUrl = _generateSearchOrgUrl2[0], fixedParamsUrl = _generateSearchOrgUrl2[1];
              searchOrganizations(dynamicParamsUrl, fixedParamsUrl);

            case 5:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function searchByOrgDomain() {
      return _ref50.apply(this, arguments);
    };
  }();

  var searchByOrgName = /*#__PURE__*/function () {
    var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var _generateSearchOrgUrl3, _generateSearchOrgUrl4, dynamicParamsUrl, fixedParamsUrl;

      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              if (canSearchByOrgName()) {
                _context15.next = 2;
                break;
              }

              return _context15.abrupt("return");

            case 2:
              _generateSearchOrgUrl3 = generateSearchOrgUrl('name', viewModel.orgName), _generateSearchOrgUrl4 = _slicedToArray2(_generateSearchOrgUrl3, 2), dynamicParamsUrl = _generateSearchOrgUrl4[0], fixedParamsUrl = _generateSearchOrgUrl4[1];
              searchOrganizations(dynamicParamsUrl, fixedParamsUrl);

            case 4:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function searchByOrgName() {
      return _ref51.apply(this, arguments);
    };
  }();

  var generateSearchOrgUrl = function generateSearchOrgUrl(searchParamLabel, searchParamContent) {
    var searchUrl = new URL(programTheme.config.orgSearchUrl);
    var country = viewModel.countryChoice.value;
    var searchTags = getOrgSearchCountryTags(programTheme, country);
    var origin = searchUrl.origin,
        pathname = searchUrl.pathname,
        search = searchUrl.search;
    var searchParams = new URLSearchParams(search);
    searchParams.set(searchParamLabel, searchParamContent);
    searchParams.set('country', country);

    if (searchTags) {
      searchParams.set('tags', searchTags);
    }

    return ["".concat(origin).concat(pathname, "?").concat(searchParams.toString()), "".concat(origin).concat(pathname, "?type=").concat(requestOrganizationConstants.ORG_TYPES, "&country=").concat(country, "&").concat(searchParamLabel, "=").concat(searchParamContent)];
  };

  var searchResultSmallEnough = function searchResultSmallEnough() {
    return viewModel.eligibleOrgs.length + viewModel.ineligibleOrgs.length < requestOrganizationConstants.MAX_RESULT_SIZE;
  };

  var domainHasError = function domainHasError() {
    var invalidUrlErrorId = 'invalidUrl';
    var requiredFieldErrorId = 'requiredField'; // TODO fix next line, no nested ternary
    // eslint-disable-next-line

    return viewModel.orgDomain ? requestOrganizationConstants.URL_REGEX.test(viewModel.orgDomain) ? null : invalidUrlErrorId : requiredFieldErrorId;
  };

  var orgNameHasError = function orgNameHasError() {
    return viewModel.orgName ? null : 'requiredField';
  };

  var countryHasError = function countryHasError() {
    return viewModel.countryChoice && viewModel.countryChoice.value ? null : 'requiredField';
  };

  var canSubmitForm = function canSubmitForm() {
    var orgCountryError = countryHasError();
    var orgDomainError = domainHasError();
    var orgNameError = orgNameHasError();
    var firstNameError = validateFieldById('firstName', viewModel.firstName);
    var lastNameError = validateFieldById('lastName', viewModel.lastName);
    var emailError = validateFieldById('email', viewModel.email);
    updateRequestOrganizationViewModel({
      orgCountryError: orgCountryError,
      orgDomainError: orgDomainError,
      orgNameError: orgNameError,
      firstNameError: firstNameError,
      lastNameError: lastNameError,
      emailError: emailError
    });
    return !(orgCountryError || orgDomainError || orgNameError || firstNameError || lastNameError || emailError);
  };

  var canSearchByDomain = function canSearchByDomain() {
    var orgCountryError = countryHasError();
    var orgDomainError = domainHasError();
    updateRequestOrganizationViewModel({
      orgCountryError: orgCountryError,
      orgDomainError: orgDomainError
    });
    return !(orgCountryError || orgDomainError);
  };

  var canSearchByOrgName = function canSearchByOrgName() {
    var orgCountryError = countryHasError();
    var orgNameError = orgNameHasError();
    updateRequestOrganizationViewModel({
      orgCountryError: orgCountryError,
      orgNameError: orgNameError
    });
    return !(orgCountryError || orgNameError);
  };

  var displayOrgNameSearch = function displayOrgNameSearch() {
    return !viewModel.searchByOrgName && viewModel.displayResults;
  };

  var displayCompleteRequest = function displayCompleteRequest() {
    return viewModel.searchByOrgName && viewModel.displayResults && searchResultSmallEnough();
  };

  var logoUrl = programTheme ? getLogoUrl(programTheme) : null;
  return React.createElement("div", {
    className: "sid-l-container--extra-wide sid-l-space-btm-lg sid-l-container"
  }, React.createElement("div", {
    className: "sid-logo sid-l-horz-center sid-l-space-top-lg"
  }, React.createElement("img", {
    className: "sid-logo__img",
    alt: "Logo",
    src: logoUrl || requestOrganizationConstants.SHEERID_LOGO_URL
  })), React.createElement("div", {
    className: "sid-logo sid-l-space-top-md"
  }, React.createElement("img", {
    className: "sid-logo__icon",
    alt: "School House",
    src: requestOrganizationConstants.SCHOOL_HOUSE_URL
  })), localeChoices.length > 1 ? React.createElement(ChangeLocaleComponent, {
    options: localeChoices,
    value: viewModel.localeChoice || defaultLocaleChoice,
    isErrored: false,
    onChange: function onChange(localeChoice) {
      updateRequestOrganizationViewModel({
        localeChoice: localeChoice
      });
      updateRequestOrganizationLocale(localeChoice.value);
    }
  }) : null, React.createElement("div", {
    className: "sid-title"
  }, React.createElement(FormattedHTMLMessage, {
    id: "title",
    defaultMessage: "Request to Add School"
  })), React.createElement("div", {
    className: "sid-soft-font-color"
  }, React.createElement(FormattedHTMLMessage, {
    id: "description",
    defaultMessage: "Please fill out the form below. Schools submitted are not guaranteed to be added, but all requests are researched and considered by SheerID."
  })), React.createElement(CountryComponent, {
    value: viewModel.countryChoice || {},
    isErrored: !!viewModel.orgCountryError,
    onChange: function onChange(countryChoice) {
      updateRequestOrganizationViewModel({
        countryChoice: countryChoice,
        orgCountryError: null
      });
    },
    options: countryChoices,
    placeholder: intl.formatHTMLMessage({
      id: 'fields.countryPlaceholder',
      defaultMessage: 'Select Country'
    })
  }), React.createElement("div", {
    className: "sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "noCountry",
    defaultMessage: "Don't see your school's country? You are not eligible for this offer."
  })), React.createElement("div", {
    className: "".concat(viewModel.searchByOrgName ? 'sid-field-pair' : '')
  }, React.createElement(SearchFieldComponent, {
    name: "org-domain",
    label: intl.formatHTMLMessage({
      id: 'fields.domainLabel',
      defaultMessage: 'School website'
    }),
    placeholder: intl.formatHTMLMessage({
      id: 'fields.domainPlaceholder',
      defaultMessage: 'www.myschool.edu'
    }),
    value: viewModel.orgDomain,
    isErrored: viewModel.orgDomainError,
    onChange: function onChange(orgDomain) {
      updateRequestOrganizationViewModel({
        orgDomain: orgDomain
      });
    },
    onKeyDown: function onKeyDown() {
      if (viewModel.orgDomainError && !domainHasError()) updateRequestOrganizationViewModel({
        orgDomainError: null
      });
    },
    search: searchByOrgDomain
  }), viewModel.searchByOrgName ? React.createElement(SearchFieldComponent, {
    name: "org-name",
    label: intl.formatHTMLMessage({
      id: 'fields.orgNameLabel',
      defaultMessage: 'School name'
    }),
    placeholder: intl.formatHTMLMessage({
      id: 'fields.orgNamePlaceholder',
      defaultMessage: 'My school'
    }),
    value: viewModel.orgName,
    isErrored: viewModel.orgNameError,
    onChange: function onChange(orgName) {
      updateRequestOrganizationViewModel({
        orgName: orgName
      });
    },
    onKeyDown: function onKeyDown() {
      if (viewModel.orgNameError && !orgNameHasError()) updateRequestOrganizationViewModel({
        orgNameError: null
      });
    },
    search: searchByOrgName
  }) : null), viewModel.displayResults ? React.createElement(RequestOrganizationSearchResultComponent, {
    eligibleOrgs: viewModel.eligibleOrgs,
    ineligibleOrgs: viewModel.ineligibleOrgs
  }) : null, displayOrgNameSearch() ? React.createElement("div", {
    className: "sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-h-link-like",
    role: "button",
    tabIndex: 0,
    onKeyUp: function onKeyUp() {
      if (canSearchByDomain()) {
        updateRequestOrganizationViewModel({
          searchByOrgName: true,
          displayResults: false,
          eligibleOrgs: [],
          ineligibleOrgs: []
        });
      }
    },
    onClick: function onClick() {
      if (canSearchByDomain()) {
        updateRequestOrganizationViewModel({
          searchByOrgName: true,
          displayResults: false,
          eligibleOrgs: [],
          ineligibleOrgs: []
        });
      }
    }
  }, React.createElement(FormattedHTMLMessage, {
    id: "searchByOrgName",
    defaultMessage: "Don't see your school? Search by name."
  }))) : null, displayCompleteRequest() ? React.createElement("div", {
    className: "sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-h-link-like",
    tabIndex: 0,
    role: "button",
    onKeyUp: function onKeyUp() {
      if (canSearchByDomain() && canSearchByOrgName()) {
        updateRequestOrganizationViewModel({
          completeRequest: true
        });
      }
    },
    onClick: function onClick() {
      if (canSearchByDomain() && canSearchByOrgName()) {
        updateRequestOrganizationViewModel({
          completeRequest: true
        });
      }
    }
  }, React.createElement(FormattedHTMLMessage, {
    id: "completeRequest",
    defaultMessage: "Don't see your school in the list of eligible or ineligible schools? Complete your request"
  }))) : null, viewModel.completeRequest ? React.createElement("div", {
    className: "sid-complete-request"
  }, React.createElement("div", {
    className: "sid-personal-info"
  }, React.createElement("div", {
    className: "sid-field-pair"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!viewModel.firstNameError,
    onChange: function onChange(newValue) {
      updateRequestOrganizationViewModel({
        firstName: newValue
      });
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!viewModel.lastNameError,
    onChange: function onChange(newValue) {
      updateRequestOrganizationViewModel({
        lastName: newValue
      });
    }
  })), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!viewModel.emailError,
    onChange: function onChange(newValue) {
      updateRequestOrganizationViewModel({
        email: newValue
      });
    },
    explanation: " "
  })), React.createElement("div", {
    className: "sid-l-space-top-lg"
  }, React.createElement("button", {
    type: "submit",
    className: "sid-btn sid-btn--dark",
    onClick: function onClick(e) {
      e.preventDefault();
      submitAddSchoolRequest(canSubmitForm, requestOrganizationService, dispatch);
    }
  }, React.createElement(FormattedHTMLMessage, {
    id: "submit",
    defaultMessage: "Submit"
  })))) : null, viewModel.isSearching ? React.createElement("div", {
    id: "sid-spinner-container",
    className: "sid-l-absolute-center"
  }, React.createElement(LoadingSpinnerComponent, null)) : null);
};

var RequestOrganizationSearchComponent = injectIntl(RequestOrganizationSearch); // eslint-disable-next-line react/prop-types

var LoadingScreenMessage = function LoadingScreenMessage(_ref52) {
  var step = _ref52.step;
  return React.createElement("div", {
    className: "sid-loading-screen__message"
  }, CollectInfoSteps.includes(step) && React.createElement("div", {
    className: "sid-loading-screen__message-header"
  }, React.createElement(FormattedMessage, {
    id: "step.personalInfo.verifyingTitle",
    defaultMessage: "Verifying your status"
  })), React.createElement("div", {
    className: "sid-loading-screen__message-subhead"
  }, React.createElement(FormattedMessage, {
    id: "step.personalInfo.verifyingSubtitle",
    defaultMessage: "This should only take a minute"
  })));
}; // eslint-disable-next-line react/prop-types


var LoadingScreenComponent = function LoadingScreenComponent(_ref53) {
  var step = _ref53.step;
  return React.createElement("div", {
    className: "sid-loading-screen"
  }, React.createElement(LoadingSpinnerComponent, null), step && React.createElement(LoadingScreenMessage, {
    step: step
  }));
};

var overriddenComponents = {};

var overrideComponent = function overrideComponent(componentName, newComponent) {
  logger.log("overrideComponent registering ".concat(componentName));
  overriddenComponents[componentName] = newComponent;
};

var getOverridenComponent = function getOverridenComponent(componentName) {
  if (overriddenComponents[componentName]) {
    logger.log("getOverridenComponent returning ".concat(componentName));
    return overriddenComponents[componentName];
  }

  return null;
};

var resetOverriddenComponents = function resetOverriddenComponents() {
  overriddenComponents = {};
};

var RequestOrganizationLoadStepComponent = function RequestOrganizationLoadStepComponent(_ref54) {
  var requestOrganizationService = _ref54.requestOrganizationService;
  var error = requestOrganizationService.error;
  var submitted = requestOrganizationService.submitted;
  var isLoading = requestOrganizationService.isLoading;
  var OverriddenComponent;

  if (isLoading) {
    return React.createElement(LoadingScreenComponent, null);
  }

  if (error) {
    OverriddenComponent = getOverridenComponent('RequestOrganizationErrorComponent');

    if (OverriddenComponent) {
      return React.createElement(OverriddenComponent, {
        requestOrganizationService: requestOrganizationService
      });
    }

    return React.createElement(RequestOrganizationErrorComponent, {
      requestOrganizationService: requestOrganizationService
    });
  }

  if (submitted) {
    OverriddenComponent = getOverridenComponent('RequestOrganizationSuccessComponent');

    if (OverriddenComponent) {
      return React.createElement(OverriddenComponent, {
        requestOrganizationService: requestOrganizationService
      });
    }

    return React.createElement(RequestOrganizationSuccessComponent, {
      requestOrganizationService: requestOrganizationService
    });
  }

  OverriddenComponent = getOverridenComponent('RequestOrganizationSearchComponent');

  if (OverriddenComponent) {
    return React.createElement(OverriddenComponent, null);
  }

  return React.createElement(RequestOrganizationSearchComponent, null);
};

var NewInnerRequestOrganizationFormComponent = function NewInnerRequestOrganizationFormComponent(_ref55) {
  var locale = _ref55.locale,
      messages = _ref55.messages,
      requestOrganizationService = _ref55.requestOrganizationService;
  return React.createElement(IntlProvider, {
    locale: "en-US",
    key: locale,
    messages: messages,
    textComponent: CustomTextWrapper
  }, React.createElement(RequestOrganizationLoadStepComponent, {
    requestOrganizationService: requestOrganizationService
  }));
};

var firstResponderMessages = {
  emailExplanation: 'Needed to send you your unique code',
  step: {
    personalInfo: {
      title: 'Unlock this 1st Responder-Only Offer',
      subtitle: "Verify you're an active first responder.",
      howDoesVerifyingWorkDetails: "\n            This offer is available to all US first responders and emergency personnel - including law enforcement,\n            EMTs, paramedics, and firefighters.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are an active first responder. SheerID\n            only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check Your Name, Email & Organization',
        subtitle: 'Your full name, organization name, and email must match what is on record with your agency.'
      },
      verifyingTitle: 'Verifying your first responder status'
    },
    docUpload: {
      title: 'We need your ID',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying first responders.\n            <br><br>\n            Documents are used only for verifying your first responder status is current and will be permanently deleted after review is finalized.\n            They will not be shared with {companyName}",
      uploadInstructions: 'Upload an official document that shows'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
};
var militaryMessages = {
  emailExplanation: 'Personal email address is recommended',
  step: {
    personalInfo: {
      title: 'Unlock this Military-Only Offer',
      subtitle: "Verify you're a member of the armed forces.",
      howDoesVerifyingWorkDetails: "\n            This offer is available to military personnel who have served or are currently serving in the United States Armed Forces.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are a member of the military. SheerID only collects information\n            that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check Your Name & Birthdate',
        subtitle: 'Enter your first and last name on the form as it appears on your military document(s). Keep in mind that may be your given name.'
      },
      verifyingTitle: 'Verifying your military status'
    },
    docUpload: {
      title: 'We need more information',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying military.\n            <br><br>\n            Documents are used only for verifying your military status is current and will be permanently deleted after review is finalized.\n            They will not be shared with {companyName}",
      uploadInstructions: 'Upload your government-issued document that shows:'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
};
var seniorMessages = {
  emailExplanation: 'Needed to send you your unique code',
  step: {
    personalInfo: {
      title: 'Unlock Your Special Offer',
      subtitle: 'Verify your current age.',
      howDoesVerifyingWorkDetails: "\n            To be eligible for this offer, you must be of a certain age.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify your age. SheerID only collects information that assists in\n            verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check Your Name & Birthdate',
        subtitle: 'Your full name and birthdate must match what is on your government-issued documents.'
      },
      verifyingTitle: 'Verifying your age'
    },
    docUpload: {
      title: 'We need your license or passport',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying age.\n            <br><br>\n            Documents are used only for verifying your current age and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
      uploadInstructions: 'Upload a government-issued document that shows'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
};
var ageMessages = {
  emailExplanation: 'Needed to send you your unique code',
  step: {
    personalInfo: {
      title: 'Unlock Your Special Offer',
      subtitle: 'Verify your current age.',
      howDoesVerifyingWorkDetails: "\n            To be eligible for this offer, you must be of a certain age.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify your age. SheerID only collects information that assists in\n            verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check Your Name & Birthdate',
        subtitle: 'Your full name and birthdate must match what is on your government-issued documents.'
      },
      verifyingTitle: 'Verifying your age'
    },
    docUpload: {
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying age.\n            <br><br>\n            Documents are used only for verifying your current age and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
      uploadInstructions: 'Upload a government-issued document that shows',
      title: 'We need your license or passport',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
};
var studentMessages = {
  emailExplanation: 'Needed to send you your unique code',
  schoolName: 'University / college name',
  step: {
    personalInfo: {
      title: 'Unlock this Student-Only Offer',
      subtitle: "Verify you're a student at a degree-granting school.",
      howDoesVerifyingWorkDetails: "\n                To be eligible for this offer, you must currently be enrolled in a degree\n                or certificate-granting, accredited school of education.\n                <br><br>\n                {companyName} uses SheerID, a trusted partner, to verify that you are a current student. SheerID only\n                collects information that assists in verifying your eligibility.\n                Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check Your Name & Birthdate',
        subtitle: 'Your full name and birthdate must match what is on your official school records.'
      },
      verifyingTitle: 'Verifying your student status'
    },
    docUpload: {
      title: 'We need your ID & class schedule',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying students.\n                <br/><br/>\n                Documents are used only for verifying your student status is current and will be permanently deleted after review is finalized.",
      uploadInstructions: 'Upload your school-issued document that shows'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    },
    sso: {
      cancel: 'Upload Proof of Enrollment'
    }
  }
};
var teacherMessages = {
  emailExplanation: 'Must be your school-issued email address',
  schoolName: 'School name',
  step: {
    personalInfo: {
      title: 'Unlock this Teaching Staff-Only Offer',
      subtitle: "Verify you're a teacher, faculty or staff at a K-12 or degree-granting university.",
      howDoesVerifyingWorkDetails: "\n            To be eligible for this offer, you must currently be employed as a teacher, faculty or staff at a K-12\n            school or university in the United States.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are a current teacher, faculty or staff\n            member. SheerID only collects information that assists in verifying your eligibility. Additional information\n            or documentation may be requested.",
      tryAgain: {
        title: 'Check Your Name & Email',
        subtitle: 'Your full name and email address must match what is on record with your school.'
      },
      verifyingTitle: 'Verifying your teacher status'
    },
    docUpload: {
      title: 'We need more information',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying teachers.\n                <br><br>\n                Documents are used only for verifying your teacher or faculty status is current and will be permanently\n                deleted after review is finalized. They will not be shared with {companyName}",
      uploadInstructions: 'Upload your school-issued document that shows'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
};
var memberMessages = {
  emailExplanation: 'Needed to send you your unique code',
  step: {
    personalInfo: {
      title: 'Unlock this Members-Only Offer',
      subtitle: "Verify you're a current member of an eligible organization.",
      howDoesVerifyingWorkDetails: "{companyName} has set up this special offer for all current members of select organizations.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are currently employed. SheerID only collects\n            information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check the information that you have provided',
        subtitle: 'The information you have provided should match your official documents.'
      },
      verifyingTitle: 'Verifying your membership status'
    },
    docUpload: {
      title: 'We need more information',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying members.\n            <br><br>\n            Documents are used only to verify that your membership status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
      uploadInstructions: 'Upload an official document that shows'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
};
var medicalMessages = {
  emailExplanation: 'Use your work email if you have one',
  step: {
    personalInfo: {
      title: 'Unlock this Medical Professional-Only Offer',
      subtitle: "Verify you're a licensed medical professional.",
      howDoesVerifyingWorkDetails: "To be eligible for this offer, you must (1) be a medical professional currently licensed in the United States\n                    and (2) be a member of an eligible branch of the medical profession. Eligible branches are shown in the Status\n                    selector of this form.<br><br>{companyName} uses SheerID, a trusted partner, to verify that you are a medical professional.\n                    SheerID only collects information that assists in verifying your eligibility.\n                    Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check your Name, Birthdate & Organization',
        subtitle: 'Your first and last name, birthdate and organization must match what is on your official documents.'
      },
      verifyingTitle: 'Verifying your medical professional status'
    },
    docUpload: {
      title: 'We need more information',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying\n                    medical professionals.<br><br>Documents are used only for verifying your medical professional status is\n                    current and will be permanently deleted after review is finalized. They will not be shared with {companyName}.",
      uploadInstructions: 'Upload an official document that shows'
    },
    sso: {
      title: 'Verify your Healthcare status',
      subtitle: "Please sign into your employer's web portal. It will open in a new tab.",
      login: 'Sign into my employer web portal'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
};
var employmentMessages = {
  emailExplanation: 'Use your work email if you have one',
  step: {
    personalInfo: {
      title: 'Unlock this Employment-Only Offer',
      subtitle: "Verify you're a current employee at an eligible company.",
      howDoesVerifyingWorkDetails: "{companyName} has set up this special offer for all current employees of select companies.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are currently employed. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check the information that you have provided',
        subtitle: 'The information you have provided should match your official documents.'
      },
      verifyingTitle: 'Verifying your employment status'
    },
    docUpload: {
      title: 'We need more information',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying employees.\n            <br><br>\n            Documents are used only for verify your employment status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
      uploadInstructions: 'Upload an official document that shows'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    },
    sso: {
      title: 'Verify using your company-provided email credentials',
      subtitle: "Please sign in to your company's email portal. It will open in a new tab.",
      subtitle2: "Can't sign in to your email?",
      login: 'Sign in to my email',
      cancel: 'Upload proof of employment'
    }
  }
};
var identityMessages = {
  emailExplanation: 'Needed to send you your unique code',
  step: {
    personalInfo: {
      title: 'Unlock Your Special Offer',
      subtitle: 'Verify your current identity.',
      howDoesVerifyingWorkDetails: "\n            To be eligible for this offer, you must have a valid driver license.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify your identity. SheerID only collects information that assists in\n            verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check Your Name & other fields',
        subtitle: 'Your information must match what is on your government-issued document(s).'
      },
      verifyingTitle: 'Verifying your identity'
    },
    docUpload: {
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying identity.\n            <br><br>\n            Documents are used only for verifying your current eligibility and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
      uploadInstructions: 'Upload a government-issued document that shows',
      title: 'We need your driver license',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
};
var licensedProfessionalMessages = {
  emailExplanation: 'Needed to send you your unique code',
  step: {
    personalInfo: {
      title: 'Unlock this Special Offer',
      subtitle: '"Verify you have a professional license in your field.',
      howDoesVerifyingWorkDetails: "\n            To be eligible for this offer, you must hold a current professional license in your specified field. Eligible fields are shown in the Status selector of this form.\n            <br><br>\n            {companyName} uses SheerID, a trusted partner, to verify that you are a licensed professional.\n            SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check Your Name & other fields',
        subtitle: 'Your information must match what is on your government-issued document(s).'
      },
      verifyingTitle: 'Verifying your license'
    },
    docUpload: {
      title: 'We need your professional license or certificate',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying licensed professionals.\n            <br><br>\n            Documents are used only for verifying your licensure or certification status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}",
      uploadInstructions: 'Upload a government-issued document that shows'
    },
    success: {
      title: "You've been verified",
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
};
var moverMessages = {
  emailExplanation: 'Needed to send you your unique code',
  step: {
    personalInfo: {
      title: 'Unlock this Special Offer',
      subtitle: 'Verify you have recently moved.',
      howDoesVerifyingWorkDetails: "\n                To be eligible for this offer, you must have moved to a new address within the last 60 days.\n                <br><br>\n                {companyName} uses SheerID, a trusted partner, to verify that you have recently moved. SheerID only\n                collects information that assists in verifying your eligibility.\n                Additional information or documentation may be requested.",
      tryAgain: {
        title: 'Check Your Name & Address Information',
        subtitle: 'Your first and last name and address must match what is on your official documents.'
      },
      verifyingTitle: 'Verifying your moving status'
    },
    docUpload: {
      title: 'We need some more info',
      subtitle: 'Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.',
      howDoesVerifyingWorkDetails: "Document review is handled by SheerID, a trusted partner who specializes in verifying recent movers.\n                <br/><br/>\n                Documents are used only for verifying that you've recently moved and will will be permanently deleted after review is finalized. They will not be shared with {companyName}.",
      uploadInstructions: 'Upload an official document that shows'
    },
    success: {
      title: 'You\'ve been verified',
      subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
      redirectButtonText: 'Use code now'
    }
  }
}; // ===================== Student Personal Info ====================

var mockStudentPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectStudentPersonalInfo',
  segment: 'student',
  subSegment: null,
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Teacher Personal Info ====================

var mockTeacherPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectTeacherPersonalInfo',
  segment: 'teacher',
  subSegment: null,
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Member Personal Info ====================

var mockMemberPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectMemberPersonalInfo',
  segment: 'member',
  subSegment: null,
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Senior Personal Info ====================

var mockSeniorPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectSeniorPersonalInfo',
  segment: 'senior',
  subSegment: null,
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Age Personal Info ====================

var mockAgePersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectAgePersonalInfo',
  segment: 'age',
  subSegment: null,
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US',
  minAge: 55,
  maxAge: 120
}; // ===================== Military Status ====================

var mockMilitaryStatusResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectMilitaryStatus',
  segment: 'military',
  subSegment: null,
  submissionUrl: '',
  availableStatuses: ['ACTIVE_DUTY'],
  locale: 'en-US'
}; // ===================== Active Military Personal Info ====================

var mockActiveMilitaryPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectActiveMilitaryPersonalInfo',
  segment: 'military',
  subSegment: 'activeDuty',
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Inactive Military Personal Info ====================

var mockInactiveMilitaryPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectInactiveMilitaryPersonalInfo',
  segment: 'military',
  subSegment: 'veteran',
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== First Responder Personal Info ====================

var mockFirstResponderPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectFirstResponderPersonalInfo',
  segment: 'firstResponder',
  subSegment: 'emt',
  submissionUrl: '',
  availableStatuses: ['FIREFIGHTER'],
  instantMatchAttempts: 0,
  locale: 'en-US'
};
var mockMedicalProfessionalPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectMedicalProfessionalPersonalInfo',
  segment: 'medical',
  subSegment: 'nurse',
  submissionUrl: '',
  availableStatuses: ['NURSE'],
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Employment Personal Info ====================

var mockEmploymentPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectEmployeePersonalInfo',
  segment: 'employment',
  subSegment: null,
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Identity Personal Info =========================

var mockDriverLicensePersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectDriverLicensePersonalInfo',
  segment: 'identity',
  subSegment: 'driverLicense',
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
};
var mockGeneralIdentityPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectGeneralIdentityPersonalInfo',
  segment: 'identity',
  subSegment: 'generalIdentity',
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
};
var mockHybridIdentityPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectHybridIdentityPersonalInfo',
  segment: 'identity',
  subSegment: 'generalIdentity',
  submissionUrl: '',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Professionals Personal Info =========================

var mockLicensedProfessionalPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9761',
  currentStep: 'collectLicensedProfessionalPersonalInfo',
  segment: 'licensedProfessional',
  submissionUrl: '',
  subSegment: 'licensedCosmetologists',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Movers Personal Info =========================

var mockMoverPersonalInfoResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9761',
  currentStep: 'collectMoverPersonalInfo',
  segment: 'recentMover',
  submissionUrl: '',
  subSegment: 'homeBuyer',
  instantMatchAttempts: 0,
  locale: 'en-US'
}; // ===================== Social Security Number step ====================

var mockSocialSecurityResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'collectSocialSecurityNumber',
  segment: 'military',
  subSegment: null,
  submissionUrl: '',
  cancelUrl: '',
  locale: 'en-US'
}; // ======================= Step Doc Upload =====================

var mockDocUploadVerificationResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'docUpload',
  segment: 'student',
  subSegment: null,
  submissionUrl: '',
  locale: 'en-US'
}; // ========================= "Step" Success =======================

var mockSuccessResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'success',
  segment: 'student',
  subSegment: null,
  rewardCode: 'MY_REWARD_123',
  locale: 'en-US'
}; // There is no request associated with this step
// ============================ "Step" Error ===========================

var mockErrorResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'error',
  segment: 'student',
  subSegment: null,
  redirectUrl: 'https://sheerid.com',
  errorIds: ['internalServerError'],
  locale: 'en-US'
}; // There is no request associated with this step
// ============================ "Step" Under Review ===========================

var mockPendingResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'pending',
  statusUrl: '',
  segment: 'student',
  subSegment: null,
  locale: 'en-US',
  maxReviewTime: '2_HRS',
  estimatedReviewTime: undefined
}; // There is no request associated with this step
// ======================== "Step" Doc Review Limit Exceeded =======================

var mockDocReviewLimitExceededResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  currentStep: 'error',
  segment: 'student',
  subSegment: null,
  redirectUrl: null,
  errorIds: ['docReviewLimitExceeded'],
  locale: 'en-US'
}; // There is no request associated with this step
// ======================== "Step" SSO =======================

var mockSSOResponse = {
  verificationId: '5a3bffd5e4b05f0b878a9762',
  loginUrl: 'loginUrl',
  cancelUrl: 'cancelUrl',
  currentStep: 'sso',
  segment: 'student',
  subSegment: null,
  locale: 'en-US'
}; // There is no request associated with this step
// ======================== "Step" SMSLoop =======================

var mockSMSLoopResponse = {
  verificationId: '5e2f0bd2d7121162bb849f17',
  submissionUrl: '',
  currentStep: 'smsLoop',
  segment: 'student',
  subSegment: null,
  locale: 'en-US'
};
var mockEmailLoopResponse = {
  verificationId: '5e2f0bd2d7121162bb849f17',
  submissionUrl: '',
  currentStep: 'emailLoop',
  segment: 'student',
  subSegment: null,
  locale: 'en-US',
  canResendEmailLoop: false,
  cancelUrl: ''
};
var mockCancelEmailLoopResponse = {
  verificationId: '5e2f0bd2d7121162bb849f17',
  submissionUrl: '',
  currentStep: 'docUpload',
  segment: 'student',
  subSegment: null,
  locale: 'en-US'
};
var allMockedResponses = {
  collectStudentPersonalInfo: mockStudentPersonalInfoResponse,
  collectTeacherPersonalInfo: mockTeacherPersonalInfoResponse,
  collectMemberPersonalInfo: mockMemberPersonalInfoResponse,
  docUpload: mockDocUploadVerificationResponse,
  success: mockSuccessResponse,
  error: mockErrorResponse,
  pending: mockPendingResponse,
  docReviewLimitExceeded: mockDocReviewLimitExceededResponse,
  collectMilitaryStatus: mockMilitaryStatusResponse,
  collectActiveMilitaryPersonalInfo: mockActiveMilitaryPersonalInfoResponse,
  collectInactiveMilitaryPersonalInfo: mockInactiveMilitaryPersonalInfoResponse,
  collectSeniorPersonalInfo: mockSeniorPersonalInfoResponse,
  collectFirstResponderPersonalInfo: mockFirstResponderPersonalInfoResponse,
  collectEmployeePersonalInfo: mockEmploymentPersonalInfoResponse,
  collectDriverLicensePersonalInfo: mockDriverLicensePersonalInfoResponse,
  collectGeneralIdentityPersonalInfo: mockGeneralIdentityPersonalInfoResponse,
  collectHybridIdentityPersonalInfo: mockHybridIdentityPersonalInfoResponse,
  collectLicensedProfessionalPersonalInfo: mockLicensedProfessionalPersonalInfoResponse,
  collectMoverPersonalInfo: mockMoverPersonalInfoResponse,
  sso: mockSSOResponse,
  smsLoop: mockSMSLoopResponse,
  emailLoop: mockEmailLoopResponse,
  cancelEmailLoop: mockCancelEmailLoopResponse,
  collectSocialSecurityNumber: mockSocialSecurityResponse,
  collectAgePersonalInfo: mockAgePersonalInfoResponse,
  collectMedicalProfessionalPersonalInfo: mockMedicalProfessionalPersonalInfoResponse,
  cancelSocialSecurityNumber: {}
}; // To load a specific step directly, visit e.g. localhost:1234/?step=success

var getRouteOverride = function getRouteOverride() {
  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  try {
    var parsed = new URLSearchParams(window.location.search);
    var step;
    var segment = getSafe(function () {
      return response.segment;
    });

    if (parsed.get(QUERY_STRING_STEP_OVERRIDE)) {
      step = parsed.get(QUERY_STRING_STEP_OVERRIDE);
    } else if (getOptions().mockStep) {
      step = getOptions().mockStep;
    }

    if (step === MockStepsEnum.collect) {
      return SegmentToStepMap[segment];
    }

    return step;
  } catch (e) {
    logger.error(e, 'getRouteOverride');
  }
}; // When loading a specific step, specify a segment


var getSegmentOverride = function getSegmentOverride() {
  try {
    var parsed = new URLSearchParams(window.location.search);

    if (parsed.get(QUERY_STRING_SEGMENT_OVERRIDE)) {
      return parsed.get(QUERY_STRING_SEGMENT_OVERRIDE);
    }

    if (getOptions().mockSegment) {
      return getOptions().mockSegment;
    }
  } catch (e) {
    logger.error(e, 'getSegmentOverride');
  }
}; // When loading a specific step, specify a subsegment


var getSubsegmentOverride = function getSubsegmentOverride() {
  try {
    var parsed = new URLSearchParams(window.location.search);

    if (parsed.get(QUERY_STRING_SUBSEGMENT_OVERRIDE)) {
      return parsed.get(QUERY_STRING_SUBSEGMENT_OVERRIDE);
    }

    if (getOptions().mockSubSegment) {
      return getOptions().mockSubSegment;
    }
  } catch (e) {
    logger.error(e, 'getSubsegmentOverride');
  }
}; // When loading the error step, specify an errorId


var getErrorIdOverride = function getErrorIdOverride() {
  try {
    var parsed = new URLSearchParams(window.location.search);

    if (parsed.get(QUERY_STRING_ERRORID_OVERRIDE)) {
      return parsed.get(QUERY_STRING_ERRORID_OVERRIDE);
    }

    if (getOptions().mockErrorId) {
      return getOptions().mockErrorId;
    }
  } catch (e) {
    logger.error(e, 'getErrorIdOverride');
  }
}; // When loading the error step, specify an errorId


var getPreviousStepOverride = function getPreviousStepOverride() {
  try {
    var parsed = new URLSearchParams(window.location.search);

    if (parsed.get(QUERY_STRING_PREV_STEP_OVERRIDE)) {
      return parsed.get(QUERY_STRING_PREV_STEP_OVERRIDE);
    }

    if (getOptions()[QUERY_STRING_PREV_STEP_OVERRIDE]) {
      return getOptions()[QUERY_STRING_PREV_STEP_OVERRIDE];
    }
  } catch (e) {
    logger.error(e, QUERY_STRING_PREV_STEP_OVERRIDE);
  }
}; // Special case. The loading screen is not a step, so mocking it is a little different.


var isMockingLoading = function isMockingLoading() {
  try {
    var parsed = new URLSearchParams(window.location.search);
    return parsed.get(QUERY_STRING_STEP_OVERRIDE) === MockStepsEnum.loading || getOptions().mockStep === MockStepsEnum.loading;
  } catch (e) {
    logger.error(e, 'isMockingLoading');
    return false;
  }
};
/**
 * Based on page request query params, return a fake response to allow direct access to any step.
 *
 * @param overriddenStep
 * @param serverResponse The actual serverResponse to acquire certain pieces of info from.
 */


var getOverriddenMock = /*#__PURE__*/function () {
  var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(overriddenStep, serverResponse) {
    var mockResponse, errorMock;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            mockResponse = getOptions().mockResponse || allMockedResponses[overriddenStep];

            if (overriddenStep && mockResponse) {
              errorMock = getErrorIdOverride();
              logger.info("getOverriddenMock: mocking ".concat(overriddenStep, " response"));

              if (overriddenStep === VerificationStepsEnum.error && errorMock) {
                mockResponse.errorIds = [errorMock];
              }
            } else {
              mockResponse = null;
              logger.info("\n            getOverriddenMock: not mocking response.\n            You may mock a step response by adding things like ?mockStep=success to your route.\n            ".concat(overriddenStep, "\n        "));
            }

            if (!(mockResponse !== null && serverResponse)) {
              _context16.next = 9;
              break;
            }

            _context16.next = 5;
            return serverResponse;

          case 5:
            mockResponse.segment = serverResponse.segment;
            mockResponse.subSegment = serverResponse.subSegment;

            if (getSegmentOverride()) {
              mockResponse.segment = getSegmentOverride();
              logger.info("getOverriddenMock: mocking segment '".concat(mockResponse.segment, "'"));
            }

            if (getSubsegmentOverride()) {
              mockResponse.subSegment = getSubsegmentOverride();
              logger.info("getOverriddenMock: mocking subSegment '".concat(mockResponse.subSegment, "'"));
            }

          case 9:
            return _context16.abrupt("return", Promise.resolve(mockResponse));

          case 10:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function getOverriddenMock(_x28, _x29) {
    return _ref56.apply(this, arguments);
  };
}();

function fetchExistingVerificationRequest(_x30) {
  return _fetchExistingVerificationRequest.apply(this, arguments);
}

function _fetchExistingVerificationRequest() {
  _fetchExistingVerificationRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(verificationId) {
    var url, response, overriddenStep, mockResponse;
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            _context47.prev = 0;
            logger.info('fetchExistingVerificationRequest: Calling back-end for existing verification request');
            url = getVerificationStatusUrl(verificationId);
            _context47.next = 5;
            return GetJson(url);

          case 5:
            response = _context47.sent;
            overriddenStep = getRouteOverride(response);
            _context47.next = 9;
            return getOverriddenMock(overriddenStep, response);

          case 9:
            mockResponse = _context47.sent;

            if (!mockResponse) {
              _context47.next = 12;
              break;
            }

            return _context47.abrupt("return", mockResponse);

          case 12:
            return _context47.abrupt("return", response);

          case 15:
            _context47.prev = 15;
            _context47.t0 = _context47["catch"](0);
            logger.error(_context47.t0, 'fetchExistingVerificationRequest');

          case 18:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47, null, [[0, 15]]);
  }));
  return _fetchExistingVerificationRequest.apply(this, arguments);
}

var js_cookie = createCommonjsModule(function (module, exports) {
  (function (factory) {
    var registeredInModuleLoader;
    {
      module.exports = factory();
      registeredInModuleLoader = true;
    }

    if (!registeredInModuleLoader) {
      var OldCookies = window.Cookies;
      var api = window.Cookies = factory();

      api.noConflict = function () {
        window.Cookies = OldCookies;
        return api;
      };
    }
  })(function () {
    function extend() {
      var i = 0;
      var result = {};

      for (; i < arguments.length; i++) {
        var attributes = arguments[i];

        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }

      return result;
    }

    function decode(s) {
      return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }

    function init(converter) {
      function api() {}

      function set(key, value, attributes) {
        if (typeof document === 'undefined') {
          return;
        }

        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
        } // We're using "expires" because "max-age" is not supported by IE


        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

        try {
          var result = JSON.stringify(value);

          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }

          stringifiedAttributes += '; ' + attributeName;

          if (attributes[attributeName] === true) {
            continue;
          } // Considers RFC 6265 section 5.2:
          // ...
          // 3.  If the remaining unparsed-attributes contains a %x3B (";")
          //     character:
          // Consume the characters of the unparsed-attributes up to,
          // not including, the first %x3B (";") character.
          // ...


          stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }

        return document.cookie = key + '=' + value + stringifiedAttributes;
      }

      function get(key, json) {
        if (typeof document === 'undefined') {
          return;
        }

        var jar = {}; // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.

        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var i = 0;

        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var cookie = parts.slice(1).join('=');

          if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
          }

          try {
            var name = decode(parts[0]);
            cookie = (converter.read || converter)(cookie, name) || decode(cookie);

            if (json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }

            jar[name] = cookie;

            if (key === name) {
              break;
            }
          } catch (e) {}
        }

        return key ? jar[key] : jar;
      }

      api.set = set;

      api.get = function (key) {
        return get(key, false
        /* read as raw */
        );
      };

      api.getJSON = function (key) {
        return get(key, true
        /* read as json */
        );
      };

      api.remove = function (key, attributes) {
        set(key, '', extend(attributes, {
          expires: -1
        }));
      };

      api.defaults = {};
      api.withConverter = init;
      return api;
    }

    return init(function () {});
  });
});
js_cookie.set;
js_cookie.get;
js_cookie.remove;
/**
 * @description Record a successful conversion, such as an e-commerce purchase or account sign-up, using the verificationId that
 *      a user received while verifying.
 */

var convertByVerificationId = /*#__PURE__*/function () {
  var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(verificationId, conversionRequest) {
    var conversionUrl, fullUrl, conversionResponse;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            assertValidDatabaseId(verificationId);
            assertValidConversionRequest(conversionRequest);
            conversionUrl = "".concat(getOptions().restApi.serviceUrl).concat(getOptions().restApi.resources.conversion.base);
            fullUrl = "".concat(conversionUrl, "verification/").concat(verificationId);
            _context17.next = 6;
            return PostJson(fullUrl, conversionRequest);

          case 6:
            conversionResponse = _context17.sent;
            return _context17.abrupt("return", conversionResponse);

          case 8:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function convertByVerificationId(_x31, _x32) {
    return _ref57.apply(this, arguments);
  };
}();
/**
 * @description Record a successful conversion, such as an e-commerce purchase or account sign-up, using an arbitrary trackingId.
 *      When beginning the verification process, supply a trackingId, such as a customer's ID from an e-commerce platform.
 *      Later, after that customer has completed a purchase, provide that same trackingId and SheerID can correlate the conversion
 *      to that verification attempt.
 *      This allows for high-level reporting on the effectiveness of your SheerID program and account.
 */


var convertByTrackingId = /*#__PURE__*/function () {
  var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(accountId, trackingId, conversionRequest) {
    var conversionUrl, fullUrl, conversionResponse;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            assertValidDatabaseId(accountId);
            assertValidTrackingId(trackingId);
            assertValidConversionRequest(conversionRequest);
            conversionUrl = "".concat(getOptions().restApi.serviceUrl).concat(getOptions().restApi.resources.conversion.base);
            fullUrl = "".concat(conversionUrl, "account/").concat(accountId, "/trackingId/").concat(trackingId);
            _context18.next = 7;
            return PostJson(fullUrl, conversionRequest);

          case 7:
            conversionResponse = _context18.sent;
            return _context18.abrupt("return", conversionResponse);

          case 9:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function convertByTrackingId(_x33, _x34, _x35) {
    return _ref58.apply(this, arguments);
  };
}(); // Create IE + others compatible event handler


var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
var eventer = window[eventMethod];
var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
/**
 * @private
 */

var speakToOuterFrame = function speakToOuterFrame(message) {
  if (window.parent && window.parent.postMessage && typeof window.parent.postMessage === 'function') {
    window.parent.postMessage(message, '*');
  }
};
/**
 * @private
 */


var listenToSheerIdFrame = function listenToSheerIdFrame(callback) {
  assertValidFunction(callback);

  var receiveMessage = function receiveMessage(event) {
    callback(event);
  };

  eventer(messageEvent, receiveMessage, false);
};

var VERIFICATION_ID_COOKIE_NAME = 'sid-verificationId';
var FRAME_MSG_PROPERTY = 'verificationId';
/**
 * @description attempts to record a conversion with SheerID's REST API using a previously-set verificationId (set in a cookie)
 */

var convert = function convert(conversionRequest) {
  var verificationId;

  try {
    verificationId = js_cookie.get(VERIFICATION_ID_COOKIE_NAME);

    if (verificationId) {
      convertByVerificationId(verificationId, conversionRequest);
    } else {
      logger.info('verificationId not found from cookie');
    }
  } catch (e) {
    logger.error(e, 'Conversion error');
  }
};
/**
 * Begin a conversion session recording.
 * Saves verificationId as a cookie for use later.
 * This should be called by the page that has the SheerID <iframe>, not the page that renders the verification form.
 */


var listenForVerificationId = function listenForVerificationId() {
  logger.info('Listening for verificationId');
  listenToSheerIdFrame(onSheerIdFrameMessage);
};
/**
 * @private
 * @todo Note we are _only_ using JSON serialize/parse because https://services.sheerid.com/jsapi/SheerID.js
 *  breaks if it cannot parse a json frame message.
 */


var onSheerIdFrameMessage = function onSheerIdFrameMessage(event) {
  if (event && event.data && typeof event.data === 'object' && event.data.hasOwnProperty(FRAME_MSG_PROPERTY)) {
    var verificationId = event.data[FRAME_MSG_PROPERTY];
    storeConversionVerificationIdCookie(verificationId);
  }
};
/**
 * @private
 */


var storeConversionVerificationIdCookie = function storeConversionVerificationIdCookie(verificationId) {
  var cookieOptions = getOptions().cookies;
  js_cookie.remove(VERIFICATION_ID_COOKIE_NAME, cookieOptions);

  if (cookieOptions.enabled) {
    js_cookie.set(VERIFICATION_ID_COOKIE_NAME, verificationId, cookieOptions);
    logger.info("Set cookie ".concat(VERIFICATION_ID_COOKIE_NAME, " with value ").concat(verificationId));
  } else {
    logger.info('Cookies disabled');
  }
};
/**
 * @private
 */


var saveVerificationIdForConversion = function saveVerificationIdForConversion(verificationId) {
  speakToOuterFrame(_defineProperty2({}, FRAME_MSG_PROPERTY, verificationId)); // also store on *.sheerid.com, for users who are _not_ using an iFrame

  storeConversionVerificationIdCookie(verificationId);
};
/**
 * @private
 */


var resolveTrackingId = function resolveTrackingId() {
  var trackingId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var resolvedTrackingId;

  if (trackingId !== undefined) {
    // trackingId is optional, but if it is provided directly, assert that it's valid.
    resolvedTrackingId = trackingId;
    assertValidTrackingId(trackingId);
  } else {
    // If reading from URL, we should be more forgiving and not error-out if trackingId is invalid.
    var windowQueryString = window.location.search;
    resolvedTrackingId = getTrackingIdFromQueryString(windowQueryString);
  }

  return resolvedTrackingId;
};
/**
 * The public export of conversion-related fuqnctions
 */


var conversion = {
  convert: convert,
  convertByVerificationId: convertByVerificationId,
  convertByTrackingId: convertByTrackingId,
  listenForVerificationId: listenForVerificationId
};
/**
 * TODO - preamble
 */

/**
 * Initiate a new verification attempt with the SheerID REST service.
 *
 * @param programId Your programId from my.sheerid.com
 * @param trackingId Conversion trackingId to associate with this verification attempt.
 */

function fetchNewVerificationRequest(_x36) {
  return _fetchNewVerificationRequest.apply(this, arguments);
}

function _fetchNewVerificationRequest() {
  _fetchNewVerificationRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(programId) {
    var trackingId,
        forceNewVerificationRequest,
        resolvedTrackingId,
        response,
        windowQueryString,
        verificationId,
        url,
        requestBody,
        installPageUrl,
        overriddenStep,
        mockResponse,
        _args48 = arguments;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            trackingId = _args48.length > 1 && _args48[1] !== undefined ? _args48[1] : undefined;
            forceNewVerificationRequest = _args48.length > 2 && _args48[2] !== undefined ? _args48[2] : false;
            resolvedTrackingId = resolveTrackingId(trackingId);
            _context48.prev = 3;
            assertValidProgramId(programId);
            windowQueryString = window.location.search;

            if (!forceNewVerificationRequest) {
              verificationId = getOptions().verificationId || getVerificationIdFromQueryString(windowQueryString);
            }

            if (verificationId) {
              logger.info('fetchNewVerificationRequest: Calling for existing verification request');
              response = fetchExistingVerificationRequest(verificationId);
            }

            if (!(!verificationId || response.currentStep === VerificationStepsEnum.error)) {
              _context48.next = 17;
              break;
            }

            url = getNewVerificationRequestUrl();
            requestBody = {
              programId: programId
            };

            if (resolvedTrackingId) {
              logger.info("Adding trackingId ".concat(resolvedTrackingId));
              requestBody.trackingId = resolvedTrackingId;
            }

            installPageUrl = getInstallPageUrl();

            if (installPageUrl) {
              logger.info("Adding installPageUrl ".concat(installPageUrl));
              requestBody.installPageUrl = installPageUrl;
            }

            _context48.next = 16;
            return PostJson(url, requestBody);

          case 16:
            response = _context48.sent;

          case 17:
            overriddenStep = getRouteOverride(response);
            _context48.next = 20;
            return getOverriddenMock(overriddenStep, response);

          case 20:
            mockResponse = _context48.sent;

            if (!mockResponse) {
              _context48.next = 23;
              break;
            }

            return _context48.abrupt("return", mockResponse);

          case 23:
            return _context48.abrupt("return", response);

          case 26:
            _context48.prev = 26;
            _context48.t0 = _context48["catch"](3);
            logger.error(_context48.t0, 'fetchNewVerificationRequest');
            throw _context48.t0;

          case 30:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48, null, [[3, 26]]);
  }));
  return _fetchNewVerificationRequest.apply(this, arguments);
}

function fetchProgramTheme(_x37, _x38) {
  return _fetchProgramTheme.apply(this, arguments);
}

function _fetchProgramTheme() {
  _fetchProgramTheme = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(programId, locale) {
    var cleanLocale, url;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            if (getOptions().doFetchTheme) {
              _context49.next = 2;
              break;
            }

            return _context49.abrupt("return", GetEmptyTheme());

          case 2:
            logger.info('fetchProgramTheme: Calling back-end for program theme');
            _context49.prev = 3;
            assertValidProgramId(programId);
            if (locale) assertValidLocale(locale);
            cleanLocale = locale || getLocaleSafely();

            if (cleanLocale !== DEFAULT_LOCALE) {
              url = getProgramThemeUrl(programId, cleanLocale);
            } else {
              url = getProgramThemeUrl(programId);
            }

            _context49.next = 10;
            return GetJson(url);

          case 10:
            return _context49.abrupt("return", _context49.sent);

          case 13:
            _context49.prev = 13;
            _context49.t0 = _context49["catch"](3);
            logger.error(_context49.t0, 'fetchProgramTheme');
            throw _context49.t0;

          case 17:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49, null, [[3, 13]]);
  }));
  return _fetchProgramTheme.apply(this, arguments);
}

function getResendNewSmsCode(_x39) {
  return _getResendNewSmsCode.apply(this, arguments);
}

function _getResendNewSmsCode() {
  _getResendNewSmsCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(verificationId) {
    var url, response;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            logger.info('Resending new sms code');
            _context50.prev = 1;
            url = getNewSmsCodeResendUrl(verificationId);
            _context50.next = 5;
            return GetResponse(url);

          case 5:
            response = _context50.sent;
            return _context50.abrupt("return", response);

          case 9:
            _context50.prev = 9;
            _context50.t0 = _context50["catch"](1);
            logger.error(_context50.t0, 'getResendNewSmsCode');

          case 12:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50, null, [[1, 9]]);
  }));
  return _getResendNewSmsCode.apply(this, arguments);
}

function getResendNewEmailCode(_x40) {
  return _getResendNewEmailCode.apply(this, arguments);
}

function _getResendNewEmailCode() {
  _getResendNewEmailCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(verificationId) {
    var url, response;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            logger.info('Resending new email code');
            _context51.prev = 1;
            url = getNewEmailCodeResendUrl(verificationId);
            _context51.next = 5;
            return GetResponse(url);

          case 5:
            response = _context51.sent;
            return _context51.abrupt("return", response);

          case 9:
            _context51.prev = 9;
            _context51.t0 = _context51["catch"](1);
            logger.error(_context51.t0, 'getResendNewEmailCode');

          case 12:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51, null, [[1, 9]]);
  }));
  return _getResendNewEmailCode.apply(this, arguments);
}

function getMockVerificationRequestErrorResponse(errorId) {
  return {
    verificationId: null,
    currentStep: 'error',
    errorIds: [errorId],
    segment: null,
    subSegment: null,
    locale: 'en-US'
  };
} // StudentPersonalInfoViewModel contains multiple keys we don't want so we can't return the full viewModel as the request body


var studentViewModelToRequest = function studentViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    birthDate: viewModel.birthDate,
    email: viewModel.email,
    phoneNumber: viewModel.phoneNumber,
    organization: viewModel.organization,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata
  };
}; // TeacherPersonalInfoViewModel contains multiple keys we don't want so we can't return the full viewModel as the request body


var teacherViewModelToRequest = function teacherViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    birthDate: viewModel.birthDate,
    postalCode: viewModel.postalCode,
    email: viewModel.email,
    phoneNumber: viewModel.phoneNumber,
    organization: viewModel.organization,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata
  };
};

var memberViewModelToRequest = function memberViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    birthDate: viewModel.birthDate,
    memberId: viewModel.memberId,
    email: viewModel.email,
    phoneNumber: viewModel.phoneNumber,
    organization: viewModel.organization,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata,
    address1: viewModel.address1,
    city: viewModel.city,
    state: viewModel.state,
    postalCode: viewModel.postalCode
  };
};

var seniorViewModelToRequest = function seniorViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    birthDate: viewModel.birthDate,
    email: viewModel.email,
    postalCode: viewModel.postalCode,
    phoneNumber: viewModel.phoneNumber,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata
  };
};

var ageViewModelToRequest = function ageViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    birthDate: viewModel.birthDate,
    email: viewModel.email,
    postalCode: viewModel.postalCode !== '' ? viewModel.postalCode : undefined,
    phoneNumber: viewModel.phoneNumber !== '' ? viewModel.phoneNumber : undefined,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    country: viewModel.countryChoice ? viewModel.countryChoice.value : undefined,
    city: viewModel.city !== '' ? viewModel.city : undefined,
    address1: viewModel.address1 !== '' ? viewModel.address1 : undefined,
    metadata: viewModel.metadata
  };
}; // ActiveMilitaryPersonalInfoViewModel contains multiple keys we don't want so we can't return the full viewModel as the request body


var militaryStatusViewModelToRequest = function militaryStatusViewModelToRequest(viewModel) {
  return {
    status: viewModel.status
  };
}; // ActiveMilitaryPersonalInfoViewModel contains 'status' which we don't want in the request so we can't return the full viewModel


var activeMilitaryViewModelToRequest = function activeMilitaryViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    birthDate: viewModel.birthDate,
    email: viewModel.email,
    phoneNumber: viewModel.phoneNumber,
    organization: viewModel.organization,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    country: viewModel.countryChoice ? viewModel.countryChoice.value : undefined,
    metadata: viewModel.metadata
  };
}; // InactiveMilitaryPersonalInfoViewModel contains 'status' which we don't want in the request so we can't return the full viewModel


var inactiveMilitaryViewModelToRequest = function inactiveMilitaryViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    birthDate: viewModel.birthDate,
    email: viewModel.email,
    phoneNumber: viewModel.phoneNumber,
    organization: viewModel.organization,
    dischargeDate: viewModel.dischargeDate,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    country: viewModel.countryChoice ? viewModel.countryChoice.value : undefined,
    metadata: viewModel.metadata
  };
};

var firstResponderViewModelToRequest = function firstResponderViewModelToRequest(viewModel) {
  var request = {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    birthDate: viewModel.birthDate,
    email: viewModel.email,
    status: viewModel.status,
    postalCode: viewModel.postalCode,
    phoneNumber: viewModel.phoneNumber,
    organization: viewModel.organization,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    country: viewModel.countryChoice ? viewModel.countryChoice.value : undefined,
    metadata: viewModel.metadata
  };
  var hasStatuses = viewModel.statuses && Array.isArray(viewModel.statuses) && viewModel.statuses.length > 0;

  if (hasStatuses) {
    request.statuses = viewModel.statuses;
    delete request.status; // API prefers the statuses field only
  }

  if (!(viewModel.status || hasStatuses)) {
    logger.error('Either status or statuses must be provided on First Responder view model');
  }

  return request;
};

var medicalProfessionalViewModelToRequest = function medicalProfessionalViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    birthDate: viewModel.birthDate,
    status: viewModel.status,
    email: viewModel.email,
    postalCode: viewModel.postalCode,
    phoneNumber: viewModel.phoneNumber,
    organization: viewModel.organization,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata,
    country: viewModel.countryChoice ? viewModel.countryChoice.value : undefined,
    memberId: viewModel.memberId
  };
};

var employmentViewModelToRequest = function employmentViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    email: viewModel.email,
    address1: viewModel.address1,
    city: viewModel.city,
    state: viewModel.state,
    postalCode: viewModel.postalCode,
    phoneNumber: viewModel.phoneNumber,
    organization: viewModel.organization,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata
  };
};

var driverLicenseViewModelToRequest = function driverLicenseViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    email: viewModel.email,
    phoneNumber: viewModel.phoneNumber,
    state: viewModel.state,
    driverLicenseNumber: viewModel.driverLicenseNumber,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata
  };
};

var generalIdentityViewModelToRequest = function generalIdentityViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    email: viewModel.email,
    phoneNumber: viewModel.phoneNumber,
    birthDate: viewModel.birthDate,
    address1: viewModel.address1,
    city: viewModel.city,
    state: viewModel.state,
    postalCode: viewModel.postalCode,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata
  };
};

var hybridIdentityViewModelToRequest = function hybridIdentityViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    email: viewModel.email,
    phoneNumber: viewModel.phoneNumber,
    birthDate: viewModel.birthDate,
    address1: viewModel.address1,
    city: viewModel.city,
    state: viewModel.state,
    postalCode: viewModel.postalCode,
    driverLicenseNumber: viewModel.driverLicenseNumber,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata
  };
};

var licensedProfessionalViewModelToRequest = function licensedProfessionalViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    email: viewModel.email,
    phoneNumber: viewModel.phoneNumber,
    birthDate: viewModel.birthDate,
    postalCode: viewModel.postalCode,
    statuses: viewModel.statuses,
    organization: viewModel.organization,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata
  };
};

var moverViewModelToRequest = function moverViewModelToRequest(viewModel) {
  return {
    firstName: viewModel.firstName,
    lastName: viewModel.lastName,
    email: viewModel.email,
    statuses: viewModel.statuses,
    address1: viewModel.address1,
    postalCode: viewModel.postalCode,
    phoneNumber: viewModel.phoneNumber,
    deviceFingerprintHash: viewModel.deviceFingerprintHash,
    locale: viewModel.localeChoice.value,
    metadata: viewModel.metadata
  };
};

var smsLoopViewModelToRequest = function smsLoopViewModelToRequest(viewModel) {
  return {
    smsCode: viewModel.smsCode,
    deviceFingerprintHash: viewModel.deviceFingerprintHash
  };
};

var emailLoopViewModelToRequest = function emailLoopViewModelToRequest(viewModel) {
  return {
    emailToken: viewModel.emailToken,
    deviceFingerprintHash: viewModel.deviceFingerprintHash
  };
};

var socialSecurityViewModelToRequest = function socialSecurityViewModelToRequest(viewModel) {
  if (typeof viewModel.socialSecurityNumber !== 'string' || viewModel.socialSecurityNumber.length < 1) {
    throw new Error('Poorly formed social security number, unable to submit');
  }

  var socialSecurityNumber = Number.parseInt(viewModel.socialSecurityNumber, 10); // Server wants an integer

  var requestBody = {
    socialSecurityNumber: socialSecurityNumber
  };
  return requestBody;
};

var stepToRequest = {
  collectStudentPersonalInfo: studentViewModelToRequest,
  collectSeniorPersonalInfo: seniorViewModelToRequest,
  collectAgePersonalInfo: ageViewModelToRequest,
  collectMilitaryStatus: militaryStatusViewModelToRequest,
  collectActiveMilitaryPersonalInfo: activeMilitaryViewModelToRequest,
  collectInactiveMilitaryPersonalInfo: inactiveMilitaryViewModelToRequest,
  collectFirstResponderPersonalInfo: firstResponderViewModelToRequest,
  collectMedicalProfessionalPersonalInfo: medicalProfessionalViewModelToRequest,
  collectMemberPersonalInfo: memberViewModelToRequest,
  collectEmployeePersonalInfo: employmentViewModelToRequest,
  collectTeacherPersonalInfo: teacherViewModelToRequest,
  collectSocialSecurityNumber: socialSecurityViewModelToRequest,
  collectDriverLicensePersonalInfo: driverLicenseViewModelToRequest,
  collectGeneralIdentityPersonalInfo: generalIdentityViewModelToRequest,
  collectHybridIdentityPersonalInfo: hybridIdentityViewModelToRequest,
  collectLicensedProfessionalPersonalInfo: licensedProfessionalViewModelToRequest,
  collectMoverPersonalInfo: moverViewModelToRequest,
  smsLoop: smsLoopViewModelToRequest,
  emailLoop: emailLoopViewModelToRequest,
  cancelSocialSecurityNumber: null,
  sso: null,
  docUpload: null
};

function submitFromVerificationStep(_x41, _x42, _x43) {
  return _submitFromVerificationStep.apply(this, arguments);
}

function _submitFromVerificationStep() {
  _submitFromVerificationStep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(step, previousResponse, viewModel) {
    var response, _VerificationStepsEnu, docUpload, cancelSocialSecurityNumber, sso, cancelEmailLoop, _requestBody, file1, file2, file3, requestBody;

    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            _VerificationStepsEnu = VerificationStepsEnum, docUpload = _VerificationStepsEnu.docUpload, cancelSocialSecurityNumber = _VerificationStepsEnu.cancelSocialSecurityNumber, sso = _VerificationStepsEnu.sso, cancelEmailLoop = _VerificationStepsEnu.cancelEmailLoop;
            _context52.prev = 1;

            if (!(step === docUpload)) {
              _context52.next = 9;
              break;
            }

            _requestBody = viewModel;
            file1 = _requestBody.file1, file2 = _requestBody.file2, file3 = _requestBody.file3;
            _context52.next = 7;
            return PostFiles(previousResponse.submissionUrl, [file1, file2, file3]);

          case 7:
            response = _context52.sent;
            return _context52.abrupt("return", response);

          case 9:
            if (!(step === cancelSocialSecurityNumber || step === sso)) {
              _context52.next = 14;
              break;
            }

            _context52.next = 12;
            return DeleteJson(previousResponse.cancelUrl);

          case 12:
            response = _context52.sent;
            return _context52.abrupt("return", response);

          case 14:
            if (!(step === cancelEmailLoop)) {
              _context52.next = 19;
              break;
            }

            _context52.next = 17;
            return DeleteJson(previousResponse.cancelUrl);

          case 17:
            response = _context52.sent;
            return _context52.abrupt("return", response);

          case 19:
            requestBody = stepToRequest[step](viewModel);
            _context52.next = 22;
            return PostJson(previousResponse.submissionUrl, requestBody);

          case 22:
            response = _context52.sent;
            return _context52.abrupt("return", response);

          case 26:
            _context52.prev = 26;
            _context52.t0 = _context52["catch"](1);
            logger.error(_context52.t0, 'submitFromVerificationStep'); // At least show the error step...

            return _context52.abrupt("return", getUnrecoverableErrorStep());

          case 30:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52, null, [[1, 26]]);
  }));
  return _submitFromVerificationStep.apply(this, arguments);
}

function getUnrecoverableErrorStep() {
  // TODO build an empty error step response with "unknown error" or some other appropriate error id.
  var response = {
    verificationId: '',
    currentStep: 'error',
    segment: null,
    subSegment: null,
    redirectUrl: null,
    locale: 'en-US',
    errorIds: ['unknownError']
  };
  return response;
}

function submitStep(_x44, _x45, _x46) {
  return _submitStep.apply(this, arguments);
}
/**
 * EXPERIMENTAL - Check which fields are required and optional for a given view model
 */


function _submitStep() {
  _submitStep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(stepName, previousResponse, viewModel) {
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            assertValidVerificationStepName(stepName);

            if (!VerificationStepsEnum[stepName]) {
              _context53.next = 3;
              break;
            }

            return _context53.abrupt("return", submitFromVerificationStep(stepName, previousResponse, viewModel));

          case 3:
            return _context53.abrupt("return", Promise.reject(new Error("Unknown step ".concat(stepName))));

          case 4:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53);
  }));
  return _submitStep.apply(this, arguments);
}

function getFieldsToCollect(_x47, _x48, _x49) {
  return _getFieldsToCollect.apply(this, arguments);
}

function _getFieldsToCollect() {
  _getFieldsToCollect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(verificationId, step, viewModel) {
    var requestBody, response;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            if (!VerificationStepsEnum[step]) {
              _context54.next = 7;
              break;
            }

            requestBody = stepToRequest[step](viewModel);
            _context54.next = 4;
            return PostJson(getFieldsToCollectUrl(verificationId, step), requestBody);

          case 4:
            response = _context54.sent;

            if (response.currentStep === 'error') {
              Promise.reject(new Error("Failed to determine fields to collect: ".concat(response)));
            }

            return _context54.abrupt("return", response);

          case 7:
            return _context54.abrupt("return", Promise.reject(new Error("Unknown step ".concat(step))));

          case 8:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54);
  }));
  return _getFieldsToCollect.apply(this, arguments);
}

var VerificationApiClient = {
  fetchNewVerificationRequest: fetchNewVerificationRequest,
  fetchExistingVerificationRequest: fetchExistingVerificationRequest,
  fetchProgramTheme: fetchProgramTheme,
  getResendNewSmsCode: getResendNewSmsCode,
  getResendNewEmailCode: getResendNewEmailCode,
  submitStep: submitStep
};

var NewRequestOrganizationFormComponent = function NewRequestOrganizationFormComponent(_ref59) {
  var programId = _ref59.programId,
      viewModel = _ref59.viewModel;

  var _React$useContext3 = React.useContext(RequestOrganizationContext),
      _React$useContext4 = _slicedToArray2(_React$useContext3, 2),
      requestOrganizationService = _React$useContext4[0],
      dispatch = _React$useContext4[1];

  var locale = requestOrganizationService.locale;
  var messages = requestOrganizationService.messages;
  React.useEffect(function () {
    if (!requestOrganizationService.locale) {
      var _locale = getRequestOrganizationLocale();

      dispatch({
        type: 'SET_LOCALE',
        payload: _locale
      });
      dispatch({
        type: 'UPDATE_VIEW_MODEL',
        payload: {
          localeChoice: {
            value: _locale,
            label: ''
          }
        }
      });
    }

    if (!requestOrganizationService.programId) {
      dispatch({
        type: 'PROGRAM_ID',
        payload: programId
      });
    }
  }, []);
  React.useEffect(function () {
    if (requestOrganizationService.programId) {
      var fetchTheme = /*#__PURE__*/function () {
        var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
          var result;
          return _regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  _context19.next = 2;
                  return VerificationApiClient.fetchProgramTheme(requestOrganizationService.programId);

                case 2:
                  result = _context19.sent;
                  dispatch({
                    type: 'PROGRAM_THEME',
                    payload: result
                  });

                case 4:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19);
        }));

        return function fetchTheme() {
          return _ref60.apply(this, arguments);
        };
      }();

      fetchTheme();
    }
  }, [requestOrganizationService.programId]);
  React.useEffect(function () {
    var fetchMessages = /*#__PURE__*/function () {
      var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var messages, messagesAction;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                dispatch({
                  type: 'SET_LOADING',
                  payload: true
                });
                _context20.next = 3;
                return getRequestOrgMessages(requestOrganizationService.locale);

              case 3:
                messages = _context20.sent;
                messagesAction = {
                  payload: messages,
                  type: 'SET_MESSAGES'
                };
                dispatch(messagesAction);
                dispatch({
                  type: 'SET_LOADING',
                  payload: false
                });

              case 7:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      return function fetchMessages() {
        return _ref61.apply(this, arguments);
      };
    }();

    if (requestOrganizationService.locale) {
      fetchMessages();
    }
  }, [requestOrganizationService.locale]);
  React.useEffect(function () {
    if (requestOrganizationService.locale && requestOrganizationService.programTheme && !requestOrganizationService.isInitialized) {
      dispatch({
        type: 'SET_INITIALIZED',
        payload: true
      });
      dispatch({
        type: 'SET_LOADING',
        payload: false
      });

      if (viewModel) {
        dispatch({
          type: 'UPDATE_VIEW_MODEL',
          payload: viewModel
        });
      }
    }
  }, [requestOrganizationService]);

  if (!messages) {
    return null;
  }

  return React.createElement(NewInnerRequestOrganizationFormComponent, {
    locale: locale,
    messages: messages,
    requestOrganizationService: requestOrganizationService
  });
};

var RequestOrganizationForm = function RequestOrganizationForm(_ref62) {
  var programId = _ref62.programId,
      viewModel = _ref62.viewModel;
  assertValidProgramId(programId);

  var _React$useContext5 = React.useContext(RequestOrganizationContext),
      _React$useContext6 = _slicedToArray2(_React$useContext5, 2),
      dispatch = _React$useContext6[1];

  dispatch({
    type: 'PROGRAM_ID',
    payload: programId
  });
  return React.createElement(RequestOrganizationStore, null, React.createElement(FormWrapperComponent, null, React.createElement(NewRequestOrganizationFormComponent, {
    programId: programId,
    viewModel: viewModel
  })));
}; // 1. Always open external links with target="_blank" so they work from the iFrame jslib is commonly (but not always) running within
// 2. When using target="_blank", always add rel noopener noreferrer for security.
//    https://stackoverflow.com/questions/50709625/link-with-target-blank-and-rel-noopener-noreferrer-still-vulnerable


var LinkExternal = function LinkExternal(_ref63) {
  var children = _ref63.children,
      restProps = _objectWithoutProperties2(_ref63, ["children"]);

  return React.createElement("a", Object.assign({
    target: "_blank",
    rel: "noopener noreferrer"
  }, restProps), children);
};

var RequestOrganizationFormFooterComponent = function RequestOrganizationFormFooterComponent(_ref64) {
  var faqUrl = _ref64.faqUrl;
  return React.createElement("div", {
    className: "sid-footer"
  }, React.createElement("div", {
    className: "sid-footer__powered-by-container--stacked sid-l-horz-center sid-l-space-top-lg"
  }, React.createElement("div", {
    className: "sid-footer__powered-by--stacked sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "poweredBy",
    defaultMessage: "Verification services powered by SheerID."
  })), React.createElement("div", {
    className: "sid-l-space-top-sm"
  }, React.createElement(LinkExternal, {
    className: "sid-faq sid-link",
    href: faqUrl
  }, React.createElement(FormattedHTMLMessage, {
    id: "faq",
    defaultMessage: "SheerID Add School Request FAQ"
  })))));
};
/**
 * @description The instance that contains callback functions ("hooks") that have been added.
 * @private
 */


var registeredHooks = {};
/**
 * @description Register a callback function (a "hook") that will be called for a given hook name.
 *      Hook names are called at specific points during execution and allow some form of extensibility.
 * @param hookName A specific string, one of the HookName type.
 * @param callback The function to call when the system performs certain actions, described by the hook's name.
 */

var addHook = function addHook(hook) {
  assertValidHook(hook);

  if (!Array.isArray(registeredHooks[hook.name])) {
    registeredHooks[hook.name] = [];
  }

  registeredHooks[hook.name].push(hook);
  return registeredHooks;
};
/**
 * @description Remove a hook
 * @param hookName A specific string, one of the HookName type.
 * @private
 */


var removeHook = function removeHook(hook) {
  try {
    delete registeredHooks[hook];
  } catch (err) {
    logger.warn('Unable to remove hook', hook);
  }

  return registeredHooks;
};
/**
 * @description Retrieve a hook object that has been stored.
 * @param hookName
 */


var getHook = function getHook(hookName) {
  assertValidHookName(hookName);
  return function (value) {
    if (registeredHooks[hookName] && Array.isArray(registeredHooks[hookName]) && registeredHooks[hookName].length > 0) {
      registeredHooks[hookName].forEach(function (hook) {
        if (hook.callback && typeof hook.callback === 'function') {
          hook.callback(_objectSpread2({}, value));
        } else {
          logger.warn('Expected typeof function for hook callback');
        }
      });
    } else {
      // return a no-op function to avoid error "function doesn't exist"
      return function () {};
    }
  };
};
/**
 * Used for unit testing
 * @private
 */


var resetHooks = function resetHooks() {
  registeredHooks = {};
};
/**
 * @description Look for an array of Hook objects that a developer may have provided in the window.sheerId object.
 *     If present, add each to the internal registry of hooks.
 *
 * @private
 * @returns true if any hooks were successfully registered.
 */


var addPredefinedHooks = function addPredefinedHooks() {
  var successCount = 0;
  getSafe(function () {
    return window.sheerId.hooks;
  }, []).forEach(function (hook) {
    try {
      addHook(hook);
    } catch (e) {
      logger.warn('Error adding hook:', hook, e);
    }
  });
  return successCount > 0;
};
/**
 * Return an empty request object as a starting-point for our run-time model
 */


var getEmptyViewModel = function getEmptyViewModel(currentStep) {
  assertValidVerificationStepName(currentStep);
  var emptyViewModel = getAllEmptyViewModels()[currentStep];

  if (!emptyViewModel) {
    logger.log("Can't find \"empty\" for ".concat(currentStep));
    throw new Error('Check for missing empties');
  }

  return emptyViewModel;
};
/**
 * @todo needs tests
 * @private
 */


var handleSubmitResponse = function handleSubmitResponse(verificationResponse, viewModel) {
  var currentStep = verificationResponse.currentStep;

  if (currentStep === VerificationStepsEnum.success) {
    getHook('ON_VERIFICATION_SUCCESS')(verificationResponse);
  } // TODO: Find a better way to persist data between military steps.
  // Ensure the new viewModel for military steps persists data from the previous military step.


  var newViewModel;

  if (currentStep === VerificationStepsEnum.collectActiveMilitaryPersonalInfo) {
    newViewModel = _objectSpread2({}, viewModel, {
      dischargeDate: ''
    });
    delete newViewModel.dischargeDate;
  } else if (currentStep === VerificationStepsEnum.collectInactiveMilitaryPersonalInfo) {
    if (!viewModel.dischargeDate) {
      newViewModel = _objectSpread2({}, viewModel, {
        dischargeDate: ''
      });
    } else {
      newViewModel = viewModel;
    }
  } else if (hasFailedInstantMatch(verificationResponse)) {
    newViewModel = viewModel;
  } else {
    // If not military, and not on the confirm info 'step', get an empty viewModel
    var locale = verificationResponse.locale;
    newViewModel = initViewModel({
      locale: locale,
      previousViewModel: viewModel,
      currentStep: verificationResponse.currentStep
    });
  }

  return newViewModel;
};
/**
 * @private
 */


var hasFailedInstantMatch = function hasFailedInstantMatch(verificationResponse) {
  if (verificationResponse.instantMatchAttempts && verificationResponse.instantMatchAttempts > 0) {
    return true;
  }

  return false;
};
/**
 * @private
 */


var initViewModel = function initViewModel(_ref65) {
  var previousViewModel = _ref65.previousViewModel,
      currentStep = _ref65.currentStep,
      locale = _ref65.locale,
      fingerprint = _ref65.fingerprint,
      country = _ref65.country;
  var viewModel = getEmptyViewModel(currentStep); // Attempt to bring over any previousViewModel values that apply to the new viewModel

  if (previousViewModel) {
    // TODO remove eslint disable and fix
    // eslint-disable-next-line
    for (var key in viewModel) {
      if (previousViewModel.hasOwnProperty(key)) {
        viewModel[key] = previousViewModel[key];
      }
    }
  }

  if (viewModel) {
    if (fingerprint) {
      viewModel.deviceFingerprintHash = fingerprint;
    }

    if (locale) {
      viewModel.localeChoice = {
        value: locale || 'en-US',
        label: ''
      };
    }

    if (country && 'country' in viewModel && viewModel.country === undefined) {
      viewModel.country = country;
    }

    if (country && 'countryChoice' in viewModel && viewModel.countryChoice === undefined) {
      viewModel.countryChoice = {
        value: country,
        label: ''
      };
    }
  }

  return viewModel;
};

var clearUploadedFiles = function clearUploadedFiles(viewModel) {
  if (viewModel) {
    for (var _i2 = 1; _i2 <= MAX_DOC_UPLOAD_DOCS_ALLOWED; _i2 += 1) {
      //  TODO fix next line, remove eslint ignore
      viewModel["".concat(UPLOAD_FILE_PREFIX).concat(_i2)] = undefined; // eslint-disable-line no-param-reassign
    }
  }
};

var collectThreatMetrixProfile = /*#__PURE__*/function () {
  var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(verificationId) {
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            import(
            /* webpackChunkName: "Tmetrix" */
            './es6/index-9928e3e2.es.js').then(function (_ref67) {
              var ThreatMetrix = _ref67.ThreatMetrix;

              if (ThreatMetrix !== undefined && ThreatMetrix.hasOwnProperty('profile') && typeof ThreatMetrix.profile === 'function') {
                var orgId = 'cnl2my47';
                var profilingDomain = 'content.sheerid.com';
                ThreatMetrix.profile(profilingDomain, orgId, verificationId);
              }
            }).catch(function () {// Do nothing - API call will handle this
            });

          case 1:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function collectThreatMetrixProfile(_x50) {
    return _ref66.apply(this, arguments);
  };
}();

var enhanceOrganizationFromTheme = function enhanceOrganizationFromTheme(viewModel, programTheme) {
  if (viewModel && viewModel.hasOwnProperty('organization') && programTheme.config.orgRemoteSource) {
    var cloned = deepClone(viewModel);
    var organization = cloned.organization;
    organization.source = programTheme.config.orgRemoteSource;
    return cloned;
  }

  return viewModel;
};

var determineCountry = function determineCountry(verificationResponse, countries) {
  if (!verificationResponse || !verificationResponse.hasOwnProperty('country') || !verificationResponse.country) {
    return countries[0];
  }

  return verificationResponse.country;
};
/**
 * @private
 */


var scrollToWindowTop = function scrollToWindowTop() {
  window.scrollTo(0, 0);
  logger.info('Scrolling window to coordinates: 0, 0');
};

var fingerprint2 = createCommonjsModule(function (module) {
  /*
  * Fingerprintjs2 2.1.4 - Modern & flexible browser fingerprint library v2
  * https://github.com/fingerprintjs/fingerprintjs
  * Copyright (c) 2020 Valentin Vasilyev (valentin@fingerprintjs.com)
  * Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
  *
  * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  * ARE DISCLAIMED. IN NO EVENT SHALL VALENTIN VASILYEV BE LIABLE FOR ANY
  * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  * THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */

  /*
  * This software contains code from open-source projects:
  * MurmurHash3 by Karan Lyons (https://github.com/karanlyons/murmurHash3.js)
  */

  /* global define */
  (function (name, context, definition) {
    if (typeof window !== 'undefined' && typeof undefined === 'function' && undefined.amd) {
      undefined(definition);
    } else if (module.exports) {
      module.exports = definition();
    } else if (context.exports) {
      context.exports = definition();
    } else {
      context[name] = definition();
    }
  })('Fingerprint2', commonjsGlobal, function () {
    // detect if object is array
    // only implement if no native implementation is available
    if (typeof Array.isArray === 'undefined') {
      Array.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
      };
    } /// MurmurHash3 related functions
    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // added together as a 64bit int (as an array of two 32bit ints).
    //


    var x64Add = function x64Add(m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] + n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] + n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] + n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] + n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }; //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // multiplied together as a 64bit int (as an array of two 32bit ints).
    //


    var x64Multiply = function x64Multiply(m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] * n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] * n[3];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[2] += m[3] * n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] * n[3];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[2] * n[2];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[3] * n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }; //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) rotated left by that number of positions.
    //


    var x64Rotl = function x64Rotl(m, n) {
      n %= 64;

      if (n === 32) {
        return [m[1], m[0]];
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n | m[0] >>> 32 - n];
      } else {
        n -= 32;
        return [m[1] << n | m[0] >>> 32 - n, m[0] << n | m[1] >>> 32 - n];
      }
    }; //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) shifted left by that number of positions.
    //


    var x64LeftShift = function x64LeftShift(m, n) {
      n %= 64;

      if (n === 0) {
        return m;
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n];
      } else {
        return [m[1] << n - 32, 0];
      }
    }; //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // xored together as a 64bit int (as an array of two 32bit ints).
    //


    var x64Xor = function x64Xor(m, n) {
      return [m[0] ^ n[0], m[1] ^ n[1]];
    }; //
    // Given a block, returns murmurHash3's final x64 mix of that block.
    // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
    // only place where we need to right shift 64bit ints.)
    //


    var x64Fmix = function x64Fmix(h) {
      h = x64Xor(h, [0, h[0] >>> 1]);
      h = x64Multiply(h, [0xff51afd7, 0xed558ccd]);
      h = x64Xor(h, [0, h[0] >>> 1]);
      h = x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
      h = x64Xor(h, [0, h[0] >>> 1]);
      return h;
    }; //
    // Given a string and an optional seed as an int, returns a 128 bit
    // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
    //


    var x64hash128 = function x64hash128(key, seed) {
      key = key || '';
      seed = seed || 0;
      var remainder = key.length % 16;
      var bytes = key.length - remainder;
      var h1 = [0, seed];
      var h2 = [0, seed];
      var k1 = [0, 0];
      var k2 = [0, 0];
      var c1 = [0x87c37b91, 0x114253d5];
      var c2 = [0x4cf5ad43, 0x2745937f];

      for (var i = 0; i < bytes; i = i + 16) {
        k1 = [key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24, key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24];
        k2 = [key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24, key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24];
        k1 = x64Multiply(k1, c1);
        k1 = x64Rotl(k1, 31);
        k1 = x64Multiply(k1, c2);
        h1 = x64Xor(h1, k1);
        h1 = x64Rotl(h1, 27);
        h1 = x64Add(h1, h2);
        h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
        k2 = x64Multiply(k2, c2);
        k2 = x64Rotl(k2, 33);
        k2 = x64Multiply(k2, c1);
        h2 = x64Xor(h2, k2);
        h2 = x64Rotl(h2, 31);
        h2 = x64Add(h2, h1);
        h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
      }

      k1 = [0, 0];
      k2 = [0, 0];

      switch (remainder) {
        case 15:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48));
        // fallthrough

        case 14:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40));
        // fallthrough

        case 13:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32));
        // fallthrough

        case 12:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24));
        // fallthrough

        case 11:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16));
        // fallthrough

        case 10:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8));
        // fallthrough

        case 9:
          k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)]);
          k2 = x64Multiply(k2, c2);
          k2 = x64Rotl(k2, 33);
          k2 = x64Multiply(k2, c1);
          h2 = x64Xor(h2, k2);
        // fallthrough

        case 8:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56));
        // fallthrough

        case 7:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48));
        // fallthrough

        case 6:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40));
        // fallthrough

        case 5:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32));
        // fallthrough

        case 4:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24));
        // fallthrough

        case 3:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16));
        // fallthrough

        case 2:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8));
        // fallthrough

        case 1:
          k1 = x64Xor(k1, [0, key.charCodeAt(i)]);
          k1 = x64Multiply(k1, c1);
          k1 = x64Rotl(k1, 31);
          k1 = x64Multiply(k1, c2);
          h1 = x64Xor(h1, k1);
        // fallthrough
      }

      h1 = x64Xor(h1, [0, key.length]);
      h2 = x64Xor(h2, [0, key.length]);
      h1 = x64Add(h1, h2);
      h2 = x64Add(h2, h1);
      h1 = x64Fmix(h1);
      h2 = x64Fmix(h2);
      h1 = x64Add(h1, h2);
      h2 = x64Add(h2, h1);
      return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8);
    };

    var defaultOptions = {
      preprocessor: null,
      audio: {
        timeout: 1000,
        // On iOS 11, audio context can only be used in response to user interaction.
        // We require users to explicitly enable audio fingerprinting on iOS 11.
        // See https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
        excludeIOS11: true
      },
      fonts: {
        swfContainerId: 'fingerprintjs2',
        swfPath: 'flash/compiled/FontList.swf',
        userDefinedFonts: [],
        extendedJsFonts: false
      },
      screen: {
        // To ensure consistent fingerprints when users rotate their mobile devices
        detectScreenOrientation: true
      },
      plugins: {
        sortPluginsFor: [/palemoon/i],
        excludeIE: false
      },
      extraComponents: [],
      excludes: {
        // Unreliable on Windows, see https://github.com/fingerprintjs/fingerprintjs/issues/375
        'enumerateDevices': true,
        // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
        'pixelRatio': true,
        // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
        'doNotTrack': true,
        // uses js fonts already
        'fontsFlash': true,
        // Extensions (including AdBlock) are disabled by default in Incognito mod of Chrome and Firefox
        // See https://github.com/fingerprintjs/fingerprintjs/issues/405
        'adBlock': true
      },
      NOT_AVAILABLE: 'not available',
      ERROR: 'error',
      EXCLUDED: 'excluded'
    };

    var each = function each(obj, iterator) {
      if (Array.prototype.forEach && obj.forEach === Array.prototype.forEach) {
        obj.forEach(iterator);
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          iterator(obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            iterator(obj[key], key, obj);
          }
        }
      }
    };

    var map = function map(obj, iterator) {
      var results = []; // Not using strict equality so that this acts as a
      // shortcut to checking for `null` and `undefined`.

      if (obj == null) {
        return results;
      }

      if (Array.prototype.map && obj.map === Array.prototype.map) {
        return obj.map(iterator);
      }

      each(obj, function (value, index, list) {
        results.push(iterator(value, index, list));
      });
      return results;
    };

    var extendSoft = function extendSoft(target, source) {
      if (source == null) {
        return target;
      }

      var value;
      var key;

      for (key in source) {
        value = source[key];

        if (value != null && !Object.prototype.hasOwnProperty.call(target, key)) {
          target[key] = value;
        }
      }

      return target;
    }; // https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/enumerateDevices


    var enumerateDevicesKey = function enumerateDevicesKey(done, options) {
      if (!isEnumerateDevicesSupported()) {
        return done(options.NOT_AVAILABLE);
      }

      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        done(devices.map(function (device) {
          return 'id=' + device.deviceId + ';gid=' + device.groupId + ';' + device.kind + ';' + device.label;
        }));
      }).catch(function (error) {
        done(error);
      });
    };

    var isEnumerateDevicesSupported = function isEnumerateDevicesSupported() {
      return navigator.mediaDevices && navigator.mediaDevices.enumerateDevices;
    }; // Inspired by and based on https://github.com/cozylife/audio-fingerprint


    var audioKey = function audioKey(done, options) {
      var audioOptions = options.audio;

      if (audioOptions.excludeIOS11 && navigator.userAgent.match(/OS 11.+Version\/11.+Safari/)) {
        // See comment for excludeUserAgent and https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
        return done(options.EXCLUDED);
      }

      var AudioContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;

      if (AudioContext == null) {
        return done(options.NOT_AVAILABLE);
      }

      var context = new AudioContext(1, 44100, 44100);
      var oscillator = context.createOscillator();
      oscillator.type = 'triangle';
      oscillator.frequency.setValueAtTime(10000, context.currentTime);
      var compressor = context.createDynamicsCompressor();
      each([['threshold', -50], ['knee', 40], ['ratio', 12], ['reduction', -20], ['attack', 0], ['release', 0.25]], function (item) {
        if (compressor[item[0]] !== undefined && typeof compressor[item[0]].setValueAtTime === 'function') {
          compressor[item[0]].setValueAtTime(item[1], context.currentTime);
        }
      });
      oscillator.connect(compressor);
      compressor.connect(context.destination);
      oscillator.start(0);
      context.startRendering();
      var audioTimeoutId = setTimeout(function () {
        console.warn('Audio fingerprint timed out. Please report bug at https://github.com/fingerprintjs/fingerprintjs with your user agent: "' + navigator.userAgent + '".');

        context.oncomplete = function () {};

        context = null;
        return done('audioTimeout');
      }, audioOptions.timeout);

      context.oncomplete = function (event) {
        var fingerprint;

        try {
          clearTimeout(audioTimeoutId);
          fingerprint = event.renderedBuffer.getChannelData(0).slice(4500, 5000).reduce(function (acc, val) {
            return acc + Math.abs(val);
          }, 0).toString();
          oscillator.disconnect();
          compressor.disconnect();
        } catch (error) {
          done(error);
          return;
        }

        done(fingerprint);
      };
    };

    var UserAgent = function UserAgent(done) {
      done(navigator.userAgent);
    };

    var webdriver = function webdriver(done, options) {
      done(navigator.webdriver == null ? options.NOT_AVAILABLE : navigator.webdriver);
    };

    var languageKey = function languageKey(done, options) {
      done(navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || options.NOT_AVAILABLE);
    };

    var colorDepthKey = function colorDepthKey(done, options) {
      done(window.screen.colorDepth || options.NOT_AVAILABLE);
    };

    var deviceMemoryKey = function deviceMemoryKey(done, options) {
      done(navigator.deviceMemory || options.NOT_AVAILABLE);
    };

    var pixelRatioKey = function pixelRatioKey(done, options) {
      done(window.devicePixelRatio || options.NOT_AVAILABLE);
    };

    var screenResolutionKey = function screenResolutionKey(done, options) {
      done(getScreenResolution(options));
    };

    var getScreenResolution = function getScreenResolution(options) {
      var resolution = [window.screen.width, window.screen.height];

      if (options.screen.detectScreenOrientation) {
        resolution.sort().reverse();
      }

      return resolution;
    };

    var availableScreenResolutionKey = function availableScreenResolutionKey(done, options) {
      done(getAvailableScreenResolution(options));
    };

    var getAvailableScreenResolution = function getAvailableScreenResolution(options) {
      if (window.screen.availWidth && window.screen.availHeight) {
        var available = [window.screen.availHeight, window.screen.availWidth];

        if (options.screen.detectScreenOrientation) {
          available.sort().reverse();
        }

        return available;
      } // headless browsers


      return options.NOT_AVAILABLE;
    };

    var timezoneOffset = function timezoneOffset(done) {
      done(new Date().getTimezoneOffset());
    };

    var timezone = function timezone(done, options) {
      if (window.Intl && window.Intl.DateTimeFormat) {
        done(new window.Intl.DateTimeFormat().resolvedOptions().timeZone || options.NOT_AVAILABLE);
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var sessionStorageKey = function sessionStorageKey(done, options) {
      done(hasSessionStorage(options));
    };

    var localStorageKey = function localStorageKey(done, options) {
      done(hasLocalStorage(options));
    };

    var indexedDbKey = function indexedDbKey(done, options) {
      done(hasIndexedDB(options));
    };

    var addBehaviorKey = function addBehaviorKey(done) {
      done(!!window.HTMLElement.prototype.addBehavior);
    };

    var openDatabaseKey = function openDatabaseKey(done) {
      done(!!window.openDatabase);
    };

    var cpuClassKey = function cpuClassKey(done, options) {
      done(getNavigatorCpuClass(options));
    };

    var platformKey = function platformKey(done, options) {
      done(getNavigatorPlatform(options));
    };

    var doNotTrackKey = function doNotTrackKey(done, options) {
      done(getDoNotTrack(options));
    };

    var canvasKey = function canvasKey(done, options) {
      if (isCanvasSupported()) {
        done(getCanvasFp(options));
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var webglKey = function webglKey(done, options) {
      if (isWebGlSupported()) {
        done(getWebglFp());
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var webglVendorAndRendererKey = function webglVendorAndRendererKey(done) {
      if (isWebGlSupported()) {
        done(getWebglVendorAndRenderer());
        return;
      }

      done();
    };

    var adBlockKey = function adBlockKey(done) {
      done(getAdBlock());
    };

    var hasLiedLanguagesKey = function hasLiedLanguagesKey(done) {
      done(getHasLiedLanguages());
    };

    var hasLiedResolutionKey = function hasLiedResolutionKey(done) {
      done(getHasLiedResolution());
    };

    var hasLiedOsKey = function hasLiedOsKey(done) {
      done(getHasLiedOs());
    };

    var hasLiedBrowserKey = function hasLiedBrowserKey(done) {
      done(getHasLiedBrowser());
    }; // flash fonts (will increase fingerprinting time 20X to ~ 130-150ms)


    var flashFontsKey = function flashFontsKey(done, options) {
      // we do flash if swfobject is loaded
      if (!hasSwfObjectLoaded()) {
        return done('swf object not loaded');
      }

      if (!hasMinFlashInstalled()) {
        return done('flash not installed');
      }

      if (!options.fonts.swfPath) {
        return done('missing options.fonts.swfPath');
      }

      loadSwfAndDetectFonts(function (fonts) {
        done(fonts);
      }, options);
    }; // kudos to http://www.lalit.org/lab/javascript-css-font-detect/


    var jsFontsKey = function jsFontsKey(done, options) {
      // a font will be compared against all the three default fonts.
      // and if it doesn't match all 3 then that font is not available.
      var baseFonts = ['monospace', 'sans-serif', 'serif'];
      var fontList = ['Andale Mono', 'Arial', 'Arial Black', 'Arial Hebrew', 'Arial MT', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS', 'Bitstream Vera Sans Mono', 'Book Antiqua', 'Bookman Old Style', 'Calibri', 'Cambria', 'Cambria Math', 'Century', 'Century Gothic', 'Century Schoolbook', 'Comic Sans', 'Comic Sans MS', 'Consolas', 'Courier', 'Courier New', 'Geneva', 'Georgia', 'Helvetica', 'Helvetica Neue', 'Impact', 'Lucida Bright', 'Lucida Calligraphy', 'Lucida Console', 'Lucida Fax', 'LUCIDA GRANDE', 'Lucida Handwriting', 'Lucida Sans', 'Lucida Sans Typewriter', 'Lucida Sans Unicode', 'Microsoft Sans Serif', 'Monaco', 'Monotype Corsiva', 'MS Gothic', 'MS Outlook', 'MS PGothic', 'MS Reference Sans Serif', 'MS Sans Serif', 'MS Serif', 'MYRIAD', 'MYRIAD PRO', 'Palatino', 'Palatino Linotype', 'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Light', 'Segoe UI Semibold', 'Segoe UI Symbol', 'Tahoma', 'Times', 'Times New Roman', 'Times New Roman PS', 'Trebuchet MS', 'Verdana', 'Wingdings', 'Wingdings 2', 'Wingdings 3'];

      if (options.fonts.extendedJsFonts) {
        var extendedFontList = ['Abadi MT Condensed Light', 'Academy Engraved LET', 'ADOBE CASLON PRO', 'Adobe Garamond', 'ADOBE GARAMOND PRO', 'Agency FB', 'Aharoni', 'Albertus Extra Bold', 'Albertus Medium', 'Algerian', 'Amazone BT', 'American Typewriter', 'American Typewriter Condensed', 'AmerType Md BT', 'Andalus', 'Angsana New', 'AngsanaUPC', 'Antique Olive', 'Aparajita', 'Apple Chancery', 'Apple Color Emoji', 'Apple SD Gothic Neo', 'Arabic Typesetting', 'ARCHER', 'ARNO PRO', 'Arrus BT', 'Aurora Cn BT', 'AvantGarde Bk BT', 'AvantGarde Md BT', 'AVENIR', 'Ayuthaya', 'Bandy', 'Bangla Sangam MN', 'Bank Gothic', 'BankGothic Md BT', 'Baskerville', 'Baskerville Old Face', 'Batang', 'BatangChe', 'Bauer Bodoni', 'Bauhaus 93', 'Bazooka', 'Bell MT', 'Bembo', 'Benguiat Bk BT', 'Berlin Sans FB', 'Berlin Sans FB Demi', 'Bernard MT Condensed', 'BernhardFashion BT', 'BernhardMod BT', 'Big Caslon', 'BinnerD', 'Blackadder ITC', 'BlairMdITC TT', 'Bodoni 72', 'Bodoni 72 Oldstyle', 'Bodoni 72 Smallcaps', 'Bodoni MT', 'Bodoni MT Black', 'Bodoni MT Condensed', 'Bodoni MT Poster Compressed', 'Bookshelf Symbol 7', 'Boulder', 'Bradley Hand', 'Bradley Hand ITC', 'Bremen Bd BT', 'Britannic Bold', 'Broadway', 'Browallia New', 'BrowalliaUPC', 'Brush Script MT', 'Californian FB', 'Calisto MT', 'Calligrapher', 'Candara', 'CaslonOpnface BT', 'Castellar', 'Centaur', 'Cezanne', 'CG Omega', 'CG Times', 'Chalkboard', 'Chalkboard SE', 'Chalkduster', 'Charlesworth', 'Charter Bd BT', 'Charter BT', 'Chaucer', 'ChelthmITC Bk BT', 'Chiller', 'Clarendon', 'Clarendon Condensed', 'CloisterBlack BT', 'Cochin', 'Colonna MT', 'Constantia', 'Cooper Black', 'Copperplate', 'Copperplate Gothic', 'Copperplate Gothic Bold', 'Copperplate Gothic Light', 'CopperplGoth Bd BT', 'Corbel', 'Cordia New', 'CordiaUPC', 'Cornerstone', 'Coronet', 'Cuckoo', 'Curlz MT', 'DaunPenh', 'Dauphin', 'David', 'DB LCD Temp', 'DELICIOUS', 'Denmark', 'DFKai-SB', 'Didot', 'DilleniaUPC', 'DIN', 'DokChampa', 'Dotum', 'DotumChe', 'Ebrima', 'Edwardian Script ITC', 'Elephant', 'English 111 Vivace BT', 'Engravers MT', 'EngraversGothic BT', 'Eras Bold ITC', 'Eras Demi ITC', 'Eras Light ITC', 'Eras Medium ITC', 'EucrosiaUPC', 'Euphemia', 'Euphemia UCAS', 'EUROSTILE', 'Exotc350 Bd BT', 'FangSong', 'Felix Titling', 'Fixedsys', 'FONTIN', 'Footlight MT Light', 'Forte', 'FrankRuehl', 'Fransiscan', 'Freefrm721 Blk BT', 'FreesiaUPC', 'Freestyle Script', 'French Script MT', 'FrnkGothITC Bk BT', 'Fruitger', 'FRUTIGER', 'Futura', 'Futura Bk BT', 'Futura Lt BT', 'Futura Md BT', 'Futura ZBlk BT', 'FuturaBlack BT', 'Gabriola', 'Galliard BT', 'Gautami', 'Geeza Pro', 'Geometr231 BT', 'Geometr231 Hv BT', 'Geometr231 Lt BT', 'GeoSlab 703 Lt BT', 'GeoSlab 703 XBd BT', 'Gigi', 'Gill Sans', 'Gill Sans MT', 'Gill Sans MT Condensed', 'Gill Sans MT Ext Condensed Bold', 'Gill Sans Ultra Bold', 'Gill Sans Ultra Bold Condensed', 'Gisha', 'Gloucester MT Extra Condensed', 'GOTHAM', 'GOTHAM BOLD', 'Goudy Old Style', 'Goudy Stout', 'GoudyHandtooled BT', 'GoudyOLSt BT', 'Gujarati Sangam MN', 'Gulim', 'GulimChe', 'Gungsuh', 'GungsuhChe', 'Gurmukhi MN', 'Haettenschweiler', 'Harlow Solid Italic', 'Harrington', 'Heather', 'Heiti SC', 'Heiti TC', 'HELV', 'Herald', 'High Tower Text', 'Hiragino Kaku Gothic ProN', 'Hiragino Mincho ProN', 'Hoefler Text', 'Humanst 521 Cn BT', 'Humanst521 BT', 'Humanst521 Lt BT', 'Imprint MT Shadow', 'Incised901 Bd BT', 'Incised901 BT', 'Incised901 Lt BT', 'INCONSOLATA', 'Informal Roman', 'Informal011 BT', 'INTERSTATE', 'IrisUPC', 'Iskoola Pota', 'JasmineUPC', 'Jazz LET', 'Jenson', 'Jester', 'Jokerman', 'Juice ITC', 'Kabel Bk BT', 'Kabel Ult BT', 'Kailasa', 'KaiTi', 'Kalinga', 'Kannada Sangam MN', 'Kartika', 'Kaufmann Bd BT', 'Kaufmann BT', 'Khmer UI', 'KodchiangUPC', 'Kokila', 'Korinna BT', 'Kristen ITC', 'Krungthep', 'Kunstler Script', 'Lao UI', 'Latha', 'Leelawadee', 'Letter Gothic', 'Levenim MT', 'LilyUPC', 'Lithograph', 'Lithograph Light', 'Long Island', 'Lydian BT', 'Magneto', 'Maiandra GD', 'Malayalam Sangam MN', 'Malgun Gothic', 'Mangal', 'Marigold', 'Marion', 'Marker Felt', 'Market', 'Marlett', 'Matisse ITC', 'Matura MT Script Capitals', 'Meiryo', 'Meiryo UI', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Tai Le', 'Microsoft Uighur', 'Microsoft YaHei', 'Microsoft Yi Baiti', 'MingLiU', 'MingLiU_HKSCS', 'MingLiU_HKSCS-ExtB', 'MingLiU-ExtB', 'Minion', 'Minion Pro', 'Miriam', 'Miriam Fixed', 'Mistral', 'Modern', 'Modern No. 20', 'Mona Lisa Solid ITC TT', 'Mongolian Baiti', 'MONO', 'MoolBoran', 'Mrs Eaves', 'MS LineDraw', 'MS Mincho', 'MS PMincho', 'MS Reference Specialty', 'MS UI Gothic', 'MT Extra', 'MUSEO', 'MV Boli', 'Nadeem', 'Narkisim', 'NEVIS', 'News Gothic', 'News GothicMT', 'NewsGoth BT', 'Niagara Engraved', 'Niagara Solid', 'Noteworthy', 'NSimSun', 'Nyala', 'OCR A Extended', 'Old Century', 'Old English Text MT', 'Onyx', 'Onyx BT', 'OPTIMA', 'Oriya Sangam MN', 'OSAKA', 'OzHandicraft BT', 'Palace Script MT', 'Papyrus', 'Parchment', 'Party LET', 'Pegasus', 'Perpetua', 'Perpetua Titling MT', 'PetitaBold', 'Pickwick', 'Plantagenet Cherokee', 'Playbill', 'PMingLiU', 'PMingLiU-ExtB', 'Poor Richard', 'Poster', 'PosterBodoni BT', 'PRINCETOWN LET', 'Pristina', 'PTBarnum BT', 'Pythagoras', 'Raavi', 'Rage Italic', 'Ravie', 'Ribbon131 Bd BT', 'Rockwell', 'Rockwell Condensed', 'Rockwell Extra Bold', 'Rod', 'Roman', 'Sakkal Majalla', 'Santa Fe LET', 'Savoye LET', 'Sceptre', 'Script', 'Script MT Bold', 'SCRIPTINA', 'Serifa', 'Serifa BT', 'Serifa Th BT', 'ShelleyVolante BT', 'Sherwood', 'Shonar Bangla', 'Showcard Gothic', 'Shruti', 'Signboard', 'SILKSCREEN', 'SimHei', 'Simplified Arabic', 'Simplified Arabic Fixed', 'SimSun', 'SimSun-ExtB', 'Sinhala Sangam MN', 'Sketch Rockwell', 'Skia', 'Small Fonts', 'Snap ITC', 'Snell Roundhand', 'Socket', 'Souvenir Lt BT', 'Staccato222 BT', 'Steamer', 'Stencil', 'Storybook', 'Styllo', 'Subway', 'Swis721 BlkEx BT', 'Swiss911 XCm BT', 'Sylfaen', 'Synchro LET', 'System', 'Tamil Sangam MN', 'Technical', 'Teletype', 'Telugu Sangam MN', 'Tempus Sans ITC', 'Terminal', 'Thonburi', 'Traditional Arabic', 'Trajan', 'TRAJAN PRO', 'Tristan', 'Tubular', 'Tunga', 'Tw Cen MT', 'Tw Cen MT Condensed', 'Tw Cen MT Condensed Extra Bold', 'TypoUpright BT', 'Unicorn', 'Univers', 'Univers CE 55 Medium', 'Univers Condensed', 'Utsaah', 'Vagabond', 'Vani', 'Vijaya', 'Viner Hand ITC', 'VisualUI', 'Vivaldi', 'Vladimir Script', 'Vrinda', 'Westminster', 'WHITNEY', 'Wide Latin', 'ZapfEllipt BT', 'ZapfHumnst BT', 'ZapfHumnst Dm BT', 'Zapfino', 'Zurich BlkEx BT', 'Zurich Ex BT', 'ZWAdobeF'];
        fontList = fontList.concat(extendedFontList);
      }

      fontList = fontList.concat(options.fonts.userDefinedFonts); // remove duplicate fonts

      fontList = fontList.filter(function (font, position) {
        return fontList.indexOf(font) === position;
      }); // we use m or w because these two characters take up the maximum width.
      // And we use a LLi so that the same matching fonts can get separated

      var testString = 'mmmmmmmmmmlli'; // we test using 72px font size, we may use any size. I guess larger the better.

      var testSize = '72px';
      var h = document.getElementsByTagName('body')[0]; // div to load spans for the base fonts

      var baseFontsDiv = document.createElement('div'); // div to load spans for the fonts to detect

      var fontsDiv = document.createElement('div');
      var defaultWidth = {};
      var defaultHeight = {}; // creates a span where the fonts will be loaded

      var createSpan = function createSpan() {
        var s = document.createElement('span');
        /*
         * We need this css as in some weird browser this
         * span elements shows up for a microSec which creates a
         * bad user experience
         */

        s.style.position = 'absolute';
        s.style.left = '-9999px';
        s.style.fontSize = testSize; // css font reset to reset external styles

        s.style.fontStyle = 'normal';
        s.style.fontWeight = 'normal';
        s.style.letterSpacing = 'normal';
        s.style.lineBreak = 'auto';
        s.style.lineHeight = 'normal';
        s.style.textTransform = 'none';
        s.style.textAlign = 'left';
        s.style.textDecoration = 'none';
        s.style.textShadow = 'none';
        s.style.whiteSpace = 'normal';
        s.style.wordBreak = 'normal';
        s.style.wordSpacing = 'normal';
        s.innerHTML = testString;
        return s;
      }; // creates a span and load the font to detect and a base font for fallback


      var createSpanWithFonts = function createSpanWithFonts(fontToDetect, baseFont) {
        var s = createSpan();
        s.style.fontFamily = "'" + fontToDetect + "'," + baseFont;
        return s;
      }; // creates spans for the base fonts and adds them to baseFontsDiv


      var initializeBaseFontsSpans = function initializeBaseFontsSpans() {
        var spans = [];

        for (var index = 0, length = baseFonts.length; index < length; index++) {
          var s = createSpan();
          s.style.fontFamily = baseFonts[index];
          baseFontsDiv.appendChild(s);
          spans.push(s);
        }

        return spans;
      }; // creates spans for the fonts to detect and adds them to fontsDiv


      var initializeFontsSpans = function initializeFontsSpans() {
        var spans = {};

        for (var i = 0, l = fontList.length; i < l; i++) {
          var fontSpans = [];

          for (var j = 0, numDefaultFonts = baseFonts.length; j < numDefaultFonts; j++) {
            var s = createSpanWithFonts(fontList[i], baseFonts[j]);
            fontsDiv.appendChild(s);
            fontSpans.push(s);
          }

          spans[fontList[i]] = fontSpans; // Stores {fontName : [spans for that font]}
        }

        return spans;
      }; // checks if a font is available


      var isFontAvailable = function isFontAvailable(fontSpans) {
        var detected = false;

        for (var i = 0; i < baseFonts.length; i++) {
          detected = fontSpans[i].offsetWidth !== defaultWidth[baseFonts[i]] || fontSpans[i].offsetHeight !== defaultHeight[baseFonts[i]];

          if (detected) {
            return detected;
          }
        }

        return detected;
      }; // create spans for base fonts


      var baseFontsSpans = initializeBaseFontsSpans(); // add the spans to the DOM

      h.appendChild(baseFontsDiv); // get the default width for the three base fonts

      for (var index = 0, length = baseFonts.length; index < length; index++) {
        defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth; // width for the default font

        defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight; // height for the default font
      } // create spans for fonts to detect


      var fontsSpans = initializeFontsSpans(); // add all the spans to the DOM

      h.appendChild(fontsDiv); // check available fonts

      var available = [];

      for (var i = 0, l = fontList.length; i < l; i++) {
        if (isFontAvailable(fontsSpans[fontList[i]])) {
          available.push(fontList[i]);
        }
      } // remove spans from DOM


      h.removeChild(fontsDiv);
      h.removeChild(baseFontsDiv);
      done(available);
    };

    var pluginsComponent = function pluginsComponent(done, options) {
      if (isIE()) {
        if (!options.plugins.excludeIE) {
          done(getIEPlugins(options));
        } else {
          done(options.EXCLUDED);
        }
      } else {
        done(getRegularPlugins(options));
      }
    };

    var getRegularPlugins = function getRegularPlugins(options) {
      if (navigator.plugins == null) {
        return options.NOT_AVAILABLE;
      }

      var plugins = []; // plugins isn't defined in Node envs.

      for (var i = 0, l = navigator.plugins.length; i < l; i++) {
        if (navigator.plugins[i]) {
          plugins.push(navigator.plugins[i]);
        }
      } // sorting plugins only for those user agents, that we know randomize the plugins
      // every time we try to enumerate them


      if (pluginsShouldBeSorted(options)) {
        plugins = plugins.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }

          if (a.name < b.name) {
            return -1;
          }

          return 0;
        });
      }

      return map(plugins, function (p) {
        var mimeTypes = map(p, function (mt) {
          return [mt.type, mt.suffixes];
        });
        return [p.name, p.description, mimeTypes];
      });
    };

    var getIEPlugins = function getIEPlugins(options) {
      var result = [];

      if (Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, 'ActiveXObject') || 'ActiveXObject' in window) {
        var names = ['AcroPDF.PDF', // Adobe PDF reader 7+
        'Adodb.Stream', 'AgControl.AgControl', // Silverlight
        'DevalVRXCtrl.DevalVRXCtrl.1', 'MacromediaFlashPaper.MacromediaFlashPaper', 'Msxml2.DOMDocument', 'Msxml2.XMLHTTP', 'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
        'QuickTime.QuickTime', // QuickTime
        'QuickTimeCheckObject.QuickTimeCheck.1', 'RealPlayer', 'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)', 'RealVideo.RealVideo(tm) ActiveX Control (32-bit)', 'Scripting.Dictionary', 'SWCtl.SWCtl', // ShockWave player
        'Shell.UIHelper', 'ShockwaveFlash.ShockwaveFlash', // flash plugin
        'Skype.Detection', 'TDCCtl.TDCCtl', 'WMPlayer.OCX', // Windows media player
        'rmocx.RealPlayer G2 Control', 'rmocx.RealPlayer G2 Control.1']; // starting to detect plugins in IE

        result = map(names, function (name) {
          try {
            // eslint-disable-next-line no-new
            new window.ActiveXObject(name);
            return name;
          } catch (e) {
            return options.ERROR;
          }
        });
      } else {
        result.push(options.NOT_AVAILABLE);
      }

      if (navigator.plugins) {
        result = result.concat(getRegularPlugins(options));
      }

      return result;
    };

    var pluginsShouldBeSorted = function pluginsShouldBeSorted(options) {
      var should = false;

      for (var i = 0, l = options.plugins.sortPluginsFor.length; i < l; i++) {
        var re = options.plugins.sortPluginsFor[i];

        if (navigator.userAgent.match(re)) {
          should = true;
          break;
        }
      }

      return should;
    };

    var touchSupportKey = function touchSupportKey(done) {
      done(getTouchSupport());
    };

    var hardwareConcurrencyKey = function hardwareConcurrencyKey(done, options) {
      done(getHardwareConcurrency(options));
    };

    var hasSessionStorage = function hasSessionStorage(options) {
      try {
        return !!window.sessionStorage;
      } catch (e) {
        return options.ERROR; // SecurityError when referencing it means it exists
      }
    }; // https://bugzilla.mozilla.org/show_bug.cgi?id=781447


    var hasLocalStorage = function hasLocalStorage(options) {
      try {
        return !!window.localStorage;
      } catch (e) {
        return options.ERROR; // SecurityError when referencing it means it exists
      }
    };

    var hasIndexedDB = function hasIndexedDB(options) {
      // IE and Edge don't allow accessing indexedDB in private mode, therefore IE and Edge will have different
      // fingerprints in normal and private modes.
      if (isIEOrOldEdge()) {
        return options.EXCLUDED;
      }

      try {
        return !!window.indexedDB;
      } catch (e) {
        return options.ERROR; // SecurityError when referencing it means it exists
      }
    };

    var getHardwareConcurrency = function getHardwareConcurrency(options) {
      if (navigator.hardwareConcurrency) {
        return navigator.hardwareConcurrency;
      }

      return options.NOT_AVAILABLE;
    };

    var getNavigatorCpuClass = function getNavigatorCpuClass(options) {
      return navigator.cpuClass || options.NOT_AVAILABLE;
    };

    var getNavigatorPlatform = function getNavigatorPlatform(options) {
      if (navigator.platform) {
        return navigator.platform;
      } else {
        return options.NOT_AVAILABLE;
      }
    };

    var getDoNotTrack = function getDoNotTrack(options) {
      if (navigator.doNotTrack) {
        return navigator.doNotTrack;
      } else if (navigator.msDoNotTrack) {
        return navigator.msDoNotTrack;
      } else if (window.doNotTrack) {
        return window.doNotTrack;
      } else {
        return options.NOT_AVAILABLE;
      }
    }; // This is a crude and primitive touch screen detection.
    // It's not possible to currently reliably detect the  availability of a touch screen
    // with a JS, without actually subscribing to a touch event.
    // http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
    // https://github.com/Modernizr/Modernizr/issues/548
    // method returns an array of 3 values:
    // maxTouchPoints, the success or failure of creating a TouchEvent,
    // and the availability of the 'ontouchstart' property


    var getTouchSupport = function getTouchSupport() {
      var maxTouchPoints = 0;
      var touchEvent;

      if (typeof navigator.maxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.maxTouchPoints;
      } else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.msMaxTouchPoints;
      }

      try {
        document.createEvent('TouchEvent');
        touchEvent = true;
      } catch (_) {
        touchEvent = false;
      }

      var touchStart = ('ontouchstart' in window);
      return [maxTouchPoints, touchEvent, touchStart];
    }; // https://www.browserleaks.com/canvas#how-does-it-work


    var getCanvasFp = function getCanvasFp(options) {
      var result = []; // Very simple now, need to make it more complex (geo shapes etc)

      var canvas = document.createElement('canvas');
      canvas.width = 2000;
      canvas.height = 200;
      canvas.style.display = 'inline';
      var ctx = canvas.getContext('2d'); // detect browser support of canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js

      ctx.rect(0, 0, 10, 10);
      ctx.rect(2, 2, 6, 6);
      result.push('canvas winding:' + (ctx.isPointInPath(5, 5, 'evenodd') === false ? 'yes' : 'no'));
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#f60';
      ctx.fillRect(125, 1, 62, 20);
      ctx.fillStyle = '#069'; // https://github.com/fingerprintjs/fingerprintjs/issues/66

      if (options.dontUseFakeFontInCanvas) {
        ctx.font = '11pt Arial';
      } else {
        ctx.font = '11pt no-real-font-123';
      }

      ctx.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 2, 15);
      ctx.fillStyle = 'rgba(102, 204, 0, 0.2)';
      ctx.font = '18pt Arial';
      ctx.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 4, 45); // canvas blending
      // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
      // http://jsfiddle.net/NDYV8/16/

      ctx.globalCompositeOperation = 'multiply';
      ctx.fillStyle = 'rgb(255,0,255)';
      ctx.beginPath();
      ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(0,255,255)';
      ctx.beginPath();
      ctx.arc(100, 50, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(255,255,0)';
      ctx.beginPath();
      ctx.arc(75, 100, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(255,0,255)'; // canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // http://jsfiddle.net/NDYV8/19/

      ctx.arc(75, 75, 75, 0, Math.PI * 2, true);
      ctx.arc(75, 75, 25, 0, Math.PI * 2, true);
      ctx.fill('evenodd');

      if (canvas.toDataURL) {
        result.push('canvas fp:' + canvas.toDataURL());
      }

      return result;
    };

    var getWebglFp = function getWebglFp() {
      var gl;

      var fa2s = function fa2s(fa) {
        gl.clearColor(0.0, 0.0, 0.0, 1.0);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        return '[' + fa[0] + ', ' + fa[1] + ']';
      };

      var maxAnisotropy = function maxAnisotropy(gl) {
        var ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic');

        if (ext) {
          var anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT);

          if (anisotropy === 0) {
            anisotropy = 2;
          }

          return anisotropy;
        } else {
          return null;
        }
      };

      gl = getWebglCanvas();

      if (!gl) {
        return null;
      } // WebGL fingerprinting is a combination of techniques, found in MaxMind antifraud script & Augur fingerprinting.
      // First it draws a gradient object with shaders and convers the image to the Base64 string.
      // Then it enumerates all WebGL extensions & capabilities and appends them to the Base64 string, resulting in a huge WebGL string, potentially very unique on each device
      // Since iOS supports webgl starting from version 8.1 and 8.1 runs on several graphics chips, the results may be different across ios devices, but we need to verify it.


      var result = [];
      var vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}';
      var fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}';
      var vertexPosBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer);
      var vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0]);
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
      vertexPosBuffer.itemSize = 3;
      vertexPosBuffer.numItems = 3;
      var program = gl.createProgram();
      var vshader = gl.createShader(gl.VERTEX_SHADER);
      gl.shaderSource(vshader, vShaderTemplate);
      gl.compileShader(vshader);
      var fshader = gl.createShader(gl.FRAGMENT_SHADER);
      gl.shaderSource(fshader, fShaderTemplate);
      gl.compileShader(fshader);
      gl.attachShader(program, vshader);
      gl.attachShader(program, fshader);
      gl.linkProgram(program);
      gl.useProgram(program);
      program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex');
      program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset');
      gl.enableVertexAttribArray(program.vertexPosArray);
      gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0);
      gl.uniform2f(program.offsetUniform, 1, 1);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems);

      try {
        result.push(gl.canvas.toDataURL());
      } catch (e) {
        /* .toDataURL may be absent or broken (blocked by extension) */
      }

      result.push('extensions:' + (gl.getSupportedExtensions() || []).join(';'));
      result.push('webgl aliased line width range:' + fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE)));
      result.push('webgl aliased point size range:' + fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE)));
      result.push('webgl alpha bits:' + gl.getParameter(gl.ALPHA_BITS));
      result.push('webgl antialiasing:' + (gl.getContextAttributes().antialias ? 'yes' : 'no'));
      result.push('webgl blue bits:' + gl.getParameter(gl.BLUE_BITS));
      result.push('webgl depth bits:' + gl.getParameter(gl.DEPTH_BITS));
      result.push('webgl green bits:' + gl.getParameter(gl.GREEN_BITS));
      result.push('webgl max anisotropy:' + maxAnisotropy(gl));
      result.push('webgl max combined texture image units:' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS));
      result.push('webgl max cube map texture size:' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE));
      result.push('webgl max fragment uniform vectors:' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS));
      result.push('webgl max render buffer size:' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE));
      result.push('webgl max texture image units:' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS));
      result.push('webgl max texture size:' + gl.getParameter(gl.MAX_TEXTURE_SIZE));
      result.push('webgl max varying vectors:' + gl.getParameter(gl.MAX_VARYING_VECTORS));
      result.push('webgl max vertex attribs:' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS));
      result.push('webgl max vertex texture image units:' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS));
      result.push('webgl max vertex uniform vectors:' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS));
      result.push('webgl max viewport dims:' + fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS)));
      result.push('webgl red bits:' + gl.getParameter(gl.RED_BITS));
      result.push('webgl renderer:' + gl.getParameter(gl.RENDERER));
      result.push('webgl shading language version:' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION));
      result.push('webgl stencil bits:' + gl.getParameter(gl.STENCIL_BITS));
      result.push('webgl vendor:' + gl.getParameter(gl.VENDOR));
      result.push('webgl version:' + gl.getParameter(gl.VERSION));

      try {
        // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
        var extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info');

        if (extensionDebugRendererInfo) {
          result.push('webgl unmasked vendor:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL));
          result.push('webgl unmasked renderer:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL));
        }
      } catch (e) {
        /* squelch */
      }

      if (!gl.getShaderPrecisionFormat) {
        loseWebglContext(gl);
        return result;
      }

      each(['FLOAT', 'INT'], function (numType) {
        each(['VERTEX', 'FRAGMENT'], function (shader) {
          each(['HIGH', 'MEDIUM', 'LOW'], function (numSize) {
            each(['precision', 'rangeMin', 'rangeMax'], function (key) {
              var format = gl.getShaderPrecisionFormat(gl[shader + '_SHADER'], gl[numSize + '_' + numType])[key];

              if (key !== 'precision') {
                key = 'precision ' + key;
              }

              var line = ['webgl ', shader.toLowerCase(), ' shader ', numSize.toLowerCase(), ' ', numType.toLowerCase(), ' ', key, ':', format].join('');
              result.push(line);
            });
          });
        });
      });
      loseWebglContext(gl);
      return result;
    };

    var getWebglVendorAndRenderer = function getWebglVendorAndRenderer() {
      /* This a subset of the WebGL fingerprint with a lot of entropy, while being reasonably browser-independent */
      try {
        var glContext = getWebglCanvas();
        var extensionDebugRendererInfo = glContext.getExtension('WEBGL_debug_renderer_info');
        var params = glContext.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL) + '~' + glContext.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL);
        loseWebglContext(glContext);
        return params;
      } catch (e) {
        return null;
      }
    };

    var getAdBlock = function getAdBlock() {
      var ads = document.createElement('div');
      ads.innerHTML = '&nbsp;';
      ads.className = 'adsbox';
      var result = false;

      try {
        // body may not exist, that's why we need try/catch
        document.body.appendChild(ads);
        result = document.getElementsByClassName('adsbox')[0].offsetHeight === 0;
        document.body.removeChild(ads);
      } catch (e) {
        result = false;
      }

      return result;
    };

    var getHasLiedLanguages = function getHasLiedLanguages() {
      // We check if navigator.language is equal to the first language of navigator.languages
      // navigator.languages is undefined on IE11 (and potentially older IEs)
      if (typeof navigator.languages !== 'undefined') {
        try {
          var firstLanguages = navigator.languages[0].substr(0, 2);

          if (firstLanguages !== navigator.language.substr(0, 2)) {
            return true;
          }
        } catch (err) {
          return true;
        }
      }

      return false;
    };

    var getHasLiedResolution = function getHasLiedResolution() {
      return window.screen.width < window.screen.availWidth || window.screen.height < window.screen.availHeight;
    };

    var getHasLiedOs = function getHasLiedOs() {
      var userAgent = navigator.userAgent.toLowerCase();
      var oscpu = navigator.oscpu;
      var platform = navigator.platform.toLowerCase();
      var os; // We extract the OS from the user agent (respect the order of the if else if statement)

      if (userAgent.indexOf('windows phone') >= 0) {
        os = 'Windows Phone';
      } else if (userAgent.indexOf('windows') >= 0 || userAgent.indexOf('win16') >= 0 || userAgent.indexOf('win32') >= 0 || userAgent.indexOf('win64') >= 0 || userAgent.indexOf('win95') >= 0 || userAgent.indexOf('win98') >= 0 || userAgent.indexOf('winnt') >= 0 || userAgent.indexOf('wow64') >= 0) {
        os = 'Windows';
      } else if (userAgent.indexOf('android') >= 0) {
        os = 'Android';
      } else if (userAgent.indexOf('linux') >= 0 || userAgent.indexOf('cros') >= 0 || userAgent.indexOf('x11') >= 0) {
        os = 'Linux';
      } else if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0 || userAgent.indexOf('ipod') >= 0 || userAgent.indexOf('crios') >= 0 || userAgent.indexOf('fxios') >= 0) {
        os = 'iOS';
      } else if (userAgent.indexOf('macintosh') >= 0 || userAgent.indexOf('mac_powerpc)') >= 0) {
        os = 'Mac';
      } else {
        os = 'Other';
      } // We detect if the person uses a touch device


      var mobileDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

      if (mobileDevice && os !== 'Windows' && os !== 'Windows Phone' && os !== 'Android' && os !== 'iOS' && os !== 'Other' && userAgent.indexOf('cros') === -1) {
        return true;
      } // We compare oscpu with the OS extracted from the UA


      if (typeof oscpu !== 'undefined') {
        oscpu = oscpu.toLowerCase();

        if (oscpu.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
          return true;
        } else if (oscpu.indexOf('linux') >= 0 && os !== 'Linux' && os !== 'Android') {
          return true;
        } else if (oscpu.indexOf('mac') >= 0 && os !== 'Mac' && os !== 'iOS') {
          return true;
        } else if ((oscpu.indexOf('win') === -1 && oscpu.indexOf('linux') === -1 && oscpu.indexOf('mac') === -1) !== (os === 'Other')) {
          return true;
        }
      } // We compare platform with the OS extracted from the UA


      if (platform.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
        return true;
      } else if ((platform.indexOf('linux') >= 0 || platform.indexOf('android') >= 0 || platform.indexOf('pike') >= 0) && os !== 'Linux' && os !== 'Android') {
        return true;
      } else if ((platform.indexOf('mac') >= 0 || platform.indexOf('ipad') >= 0 || platform.indexOf('ipod') >= 0 || platform.indexOf('iphone') >= 0) && os !== 'Mac' && os !== 'iOS') {
        return true;
      } else if (platform.indexOf('arm') >= 0 && os === 'Windows Phone') {
        return false;
      } else if (platform.indexOf('pike') >= 0 && userAgent.indexOf('opera mini') >= 0) {
        return false;
      } else {
        var platformIsOther = platform.indexOf('win') < 0 && platform.indexOf('linux') < 0 && platform.indexOf('mac') < 0 && platform.indexOf('iphone') < 0 && platform.indexOf('ipad') < 0 && platform.indexOf('ipod') < 0;

        if (platformIsOther !== (os === 'Other')) {
          return true;
        }
      }

      return typeof navigator.plugins === 'undefined' && os !== 'Windows' && os !== 'Windows Phone';
    };

    var getHasLiedBrowser = function getHasLiedBrowser() {
      var userAgent = navigator.userAgent.toLowerCase();
      var productSub = navigator.productSub; // we extract the browser from the user agent (respect the order of the tests)

      var browser;

      if (userAgent.indexOf('edge/') >= 0 || userAgent.indexOf('iemobile/') >= 0) {
        // Unreliable, different versions use EdgeHTML, Webkit, Blink, etc.
        return false;
      } else if (userAgent.indexOf('opera mini') >= 0) {
        // Unreliable, different modes use Presto, WebView, Webkit, etc.
        return false;
      } else if (userAgent.indexOf('firefox/') >= 0) {
        browser = 'Firefox';
      } else if (userAgent.indexOf('opera/') >= 0 || userAgent.indexOf(' opr/') >= 0) {
        browser = 'Opera';
      } else if (userAgent.indexOf('chrome/') >= 0) {
        browser = 'Chrome';
      } else if (userAgent.indexOf('safari/') >= 0) {
        if (userAgent.indexOf('android 1.') >= 0 || userAgent.indexOf('android 2.') >= 0 || userAgent.indexOf('android 3.') >= 0 || userAgent.indexOf('android 4.') >= 0) {
          browser = 'AOSP';
        } else {
          browser = 'Safari';
        }
      } else if (userAgent.indexOf('trident/') >= 0) {
        browser = 'Internet Explorer';
      } else {
        browser = 'Other';
      }

      if ((browser === 'Chrome' || browser === 'Safari' || browser === 'Opera') && productSub !== '20030107') {
        return true;
      } // eslint-disable-next-line no-eval


      var tempRes = eval.toString().length;

      if (tempRes === 37 && browser !== 'Safari' && browser !== 'Firefox' && browser !== 'Other') {
        return true;
      } else if (tempRes === 39 && browser !== 'Internet Explorer' && browser !== 'Other') {
        return true;
      } else if (tempRes === 33 && browser !== 'Chrome' && browser !== 'AOSP' && browser !== 'Opera' && browser !== 'Other') {
        return true;
      } // We create an error to see how it is handled


      var errFirefox;

      try {
        // eslint-disable-next-line no-throw-literal
        throw 'a';
      } catch (err) {
        try {
          err.toSource();
          errFirefox = true;
        } catch (errOfErr) {
          errFirefox = false;
        }
      }

      return errFirefox && browser !== 'Firefox' && browser !== 'Other';
    };

    var isCanvasSupported = function isCanvasSupported() {
      var elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    };

    var isWebGlSupported = function isWebGlSupported() {
      // code taken from Modernizr
      if (!isCanvasSupported()) {
        return false;
      }

      var glContext = getWebglCanvas();
      var isSupported = !!window.WebGLRenderingContext && !!glContext;
      loseWebglContext(glContext);
      return isSupported;
    };

    var isIE = function isIE() {
      if (navigator.appName === 'Microsoft Internet Explorer') {
        return true;
      } else if (navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)) {
        // IE 11
        return true;
      }

      return false;
    };

    var isIEOrOldEdge = function isIEOrOldEdge() {
      // The properties are checked to be in IE 10, IE 11 and Edge 18 and not to be in other browsers
      return ('msWriteProfilerMark' in window) + ('msLaunchUri' in navigator) + ('msSaveBlob' in navigator) >= 2;
    };

    var hasSwfObjectLoaded = function hasSwfObjectLoaded() {
      return typeof window.swfobject !== 'undefined';
    };

    var hasMinFlashInstalled = function hasMinFlashInstalled() {
      return window.swfobject.hasFlashPlayerVersion('9.0.0');
    };

    var addFlashDivNode = function addFlashDivNode(options) {
      var node = document.createElement('div');
      node.setAttribute('id', options.fonts.swfContainerId);
      document.body.appendChild(node);
    };

    var loadSwfAndDetectFonts = function loadSwfAndDetectFonts(done, options) {
      var hiddenCallback = '___fp_swf_loaded';

      window[hiddenCallback] = function (fonts) {
        done(fonts);
      };

      var id = options.fonts.swfContainerId;
      addFlashDivNode();
      var flashvars = {
        onReady: hiddenCallback
      };
      var flashparams = {
        allowScriptAccess: 'always',
        menu: 'false'
      };
      window.swfobject.embedSWF(options.fonts.swfPath, id, '1', '1', '9.0.0', false, flashvars, flashparams, {});
    };

    var getWebglCanvas = function getWebglCanvas() {
      var canvas = document.createElement('canvas');
      var gl = null;

      try {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      } catch (e) {
        /* squelch */
      }

      if (!gl) {
        gl = null;
      }

      return gl;
    };

    var loseWebglContext = function loseWebglContext(context) {
      var loseContextExtension = context.getExtension('WEBGL_lose_context');

      if (loseContextExtension != null) {
        loseContextExtension.loseContext();
      }
    };

    var components = [{
      key: 'userAgent',
      getData: UserAgent
    }, {
      key: 'webdriver',
      getData: webdriver
    }, {
      key: 'language',
      getData: languageKey
    }, {
      key: 'colorDepth',
      getData: colorDepthKey
    }, {
      key: 'deviceMemory',
      getData: deviceMemoryKey
    }, {
      key: 'pixelRatio',
      getData: pixelRatioKey
    }, {
      key: 'hardwareConcurrency',
      getData: hardwareConcurrencyKey
    }, {
      key: 'screenResolution',
      getData: screenResolutionKey
    }, {
      key: 'availableScreenResolution',
      getData: availableScreenResolutionKey
    }, {
      key: 'timezoneOffset',
      getData: timezoneOffset
    }, {
      key: 'timezone',
      getData: timezone
    }, {
      key: 'sessionStorage',
      getData: sessionStorageKey
    }, {
      key: 'localStorage',
      getData: localStorageKey
    }, {
      key: 'indexedDb',
      getData: indexedDbKey
    }, {
      key: 'addBehavior',
      getData: addBehaviorKey
    }, {
      key: 'openDatabase',
      getData: openDatabaseKey
    }, {
      key: 'cpuClass',
      getData: cpuClassKey
    }, {
      key: 'platform',
      getData: platformKey
    }, {
      key: 'doNotTrack',
      getData: doNotTrackKey
    }, {
      key: 'plugins',
      getData: pluginsComponent
    }, {
      key: 'canvas',
      getData: canvasKey
    }, {
      key: 'webgl',
      getData: webglKey
    }, {
      key: 'webglVendorAndRenderer',
      getData: webglVendorAndRendererKey
    }, {
      key: 'adBlock',
      getData: adBlockKey
    }, {
      key: 'hasLiedLanguages',
      getData: hasLiedLanguagesKey
    }, {
      key: 'hasLiedResolution',
      getData: hasLiedResolutionKey
    }, {
      key: 'hasLiedOs',
      getData: hasLiedOsKey
    }, {
      key: 'hasLiedBrowser',
      getData: hasLiedBrowserKey
    }, {
      key: 'touchSupport',
      getData: touchSupportKey
    }, {
      key: 'fonts',
      getData: jsFontsKey,
      pauseBefore: true
    }, {
      key: 'fontsFlash',
      getData: flashFontsKey,
      pauseBefore: true
    }, {
      key: 'audio',
      getData: audioKey
    }, {
      key: 'enumerateDevices',
      getData: enumerateDevicesKey
    }];

    var Fingerprint2 = function Fingerprint2(options) {
      throw new Error("'new Fingerprint()' is deprecated, see https://github.com/fingerprintjs/fingerprintjs#upgrade-guide-from-182-to-200");
    };

    Fingerprint2.get = function (options, callback) {
      if (!callback) {
        callback = options;
        options = {};
      } else if (!options) {
        options = {};
      }

      extendSoft(options, defaultOptions);
      options.components = options.extraComponents.concat(components);
      var keys = {
        data: [],
        addPreprocessedComponent: function addPreprocessedComponent(key, value) {
          if (typeof options.preprocessor === 'function') {
            value = options.preprocessor(key, value);
          }

          keys.data.push({
            key: key,
            value: value
          });
        }
      };
      var i = -1;

      var chainComponents = function chainComponents(alreadyWaited) {
        i += 1;

        if (i >= options.components.length) {
          // on finish
          callback(keys.data);
          return;
        }

        var component = options.components[i];

        if (options.excludes[component.key]) {
          chainComponents(false); // skip

          return;
        }

        if (!alreadyWaited && component.pauseBefore) {
          i -= 1;
          setTimeout(function () {
            chainComponents(true);
          }, 1);
          return;
        }

        try {
          component.getData(function (value) {
            keys.addPreprocessedComponent(component.key, value);
            chainComponents(false);
          }, options);
        } catch (error) {
          // main body error
          keys.addPreprocessedComponent(component.key, String(error));
          chainComponents(false);
        }
      };

      chainComponents(false);
    };

    Fingerprint2.getPromise = function (options) {
      return new Promise(function (resolve, reject) {
        Fingerprint2.get(options, resolve);
      });
    };

    Fingerprint2.getV18 = function (options, callback) {
      if (callback == null) {
        callback = options;
        options = {};
      }

      return Fingerprint2.get(options, function (components) {
        var newComponents = [];

        for (var i = 0; i < components.length; i++) {
          var component = components[i];

          if (component.value === (options.NOT_AVAILABLE || 'not available')) {
            newComponents.push({
              key: component.key,
              value: 'unknown'
            });
          } else if (component.key === 'plugins') {
            newComponents.push({
              key: 'plugins',
              value: map(component.value, function (p) {
                var mimeTypes = map(p[2], function (mt) {
                  if (mt.join) {
                    return mt.join('~');
                  }

                  return mt;
                }).join(',');
                return [p[0], p[1], mimeTypes].join('::');
              })
            });
          } else if (['canvas', 'webgl'].indexOf(component.key) !== -1 && Array.isArray(component.value)) {
            // sometimes WebGL returns error in headless browsers (during CI testing for example)
            // so we need to join only if the values are array
            newComponents.push({
              key: component.key,
              value: component.value.join('~')
            });
          } else if (['sessionStorage', 'localStorage', 'indexedDb', 'addBehavior', 'openDatabase'].indexOf(component.key) !== -1) {
            if (component.value) {
              newComponents.push({
                key: component.key,
                value: 1
              });
            } else {
              // skip
              continue;
            }
          } else {
            if (component.value) {
              newComponents.push(component.value.join ? {
                key: component.key,
                value: component.value.join(';')
              } : component);
            } else {
              newComponents.push({
                key: component.key,
                value: component.value
              });
            }
          }
        }

        var murmur = x64hash128(map(newComponents, function (component) {
          return component.value;
        }).join('~~~'), 31);
        callback(murmur, newComponents);
      });
    };

    Fingerprint2.x64hash128 = x64hash128;
    Fingerprint2.VERSION = '2.1.4';
    return Fingerprint2;
  });
});
fingerprint2.x64hash128;
fingerprint2.getPromise;
/**
 * @description The user's device fingerprint
 */

var fingerprint;
/**
 * @description Get the digital fingerprint hash for a user, based on various digital signals.
 *              Recommended: call this at least 500ms after page ready
 * @private
 */

var getFingerprint = /*#__PURE__*/function () {
  var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            if (getOptions().useFingerprinting) {
              _context22.next = 2;
              break;
            }

            return _context22.abrupt("return", Promise.resolve(undefined));

          case 2:
            if (!fingerprint) {
              _context22.next = 4;
              break;
            }

            return _context22.abrupt("return", Promise.resolve(fingerprint));

          case 4:
            return _context22.abrupt("return", fingerprint2.getPromise({}).then(function (components) {
              var values = components.map(function (component) {
                return component.value;
              });
              var murmur = fingerprint2.x64hash128(values.join(''), 31);
              fingerprint = murmur;
              return fingerprint;
            }));

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));

  return function getFingerprint() {
    return _ref68.apply(this, arguments);
  };
}();

var defaultMetadata = {};
var metadata = Object.assign({}, defaultMetadata);

var getMetadataFromUrl = function getMetadataFromUrl(paramsFromResponse) {
  var paramsFromQuery = getQueryParamsFromUrl();
  var validatedParams = {};
  paramsFromResponse.forEach(function (element) {
    if (paramsFromQuery.get(element)) {
      validatedParams[element] = paramsFromQuery.get(element);
    }
  });
  return validatedParams;
};

var setMetadata = function setMetadata(newMetadata) {
  // backwards opt-in metadata key. It is supported now as an Option
  if (newMetadata && newMetadata.hasOwnProperty('optin')) {
    setOptions({
      marketConsent: {
        /* keep metadata optin compatibility as string value. Set true any string but false */
        enabled: newMetadata.optin !== 'false',
        required: false,
        message: ''
      }
    });
  }

  var isMetadataValid = validateMetadata(newMetadata);

  if (isMetadataValid) {
    var modifiedMetadata = ensureMaxMetadataKeyValueLengths(newMetadata);
    Object.assign(metadata, modifiedMetadata);
    logger.info('Added metadata: ', modifiedMetadata);
    logger.info('Full metadata: ', metadata);
  } else {
    logger.error('Metadata has not been updated. See previous error(s)');
  }
};

var resetMetadata = function resetMetadata() {
  metadata = Object.assign({}, defaultMetadata);
};

var getMetadata = function getMetadata() {
  return Object.keys(metadata).length > 0 ? deepClone(metadata) : undefined;
};

var events = {
  EVENT_CATEGORY: 'Verification'
};
var isTestValues;

(function (isTestValues) {
  isTestValues["TRUE"] = "true";
  isTestValues["FALSE"] = "false";
})(isTestValues || (isTestValues = {}));

var isTestEmailDomains = ['sheerid.com', 'wizeline.com']; // GA admin config needs to correlate with these dimension index numbers:

var dimensions = {
  verificationId: 'dimension1',
  programId: 'dimension2',
  jslibVersionActual: 'dimension3',
  isTest: 'dimension4'
};

var recordEvent = function recordEvent(step) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  window.ga('send', 'event', events.EVENT_CATEGORY, step, label);
};

var recordViewModelChange = function recordViewModelChange(oldState, newState) {
  try {
    if (newState.verificationResponse.currentStep === VerificationStepsEnum.docUpload) {
      if (oldState.viewModel.file1 === undefined && newState.viewModel.file1 !== undefined) {
        recordEvent(VerificationStepsEnum.docUpload, 'addFiles');
      }
    }
  } catch (e) {
    logger.warn('Failed addFiles event', e);
  }
};

var recordVerificationResponse = function recordVerificationResponse(verificationResponse) {
  try {
    var label = verificationResponse.errorIds && Array.isArray(verificationResponse.errorIds) ? verificationResponse.errorIds.sort().join(',') : undefined;
    recordEvent(verificationResponse.currentStep, label);
  } catch (e) {
    logger.warn('Failed recordVerificationResponse event', e);
  }
};

var setDimension = function setDimension(dimensionName, value) {
  try {
    window.ga('set', dimensions[dimensionName], value);
  } catch (e) {
    logger.warn("Failed to set ".concat(dimensionName), e);
  }
};

var setGaDimensionIsTest = function setGaDimensionIsTest(viewModel) {
  try {
    var email = viewModel.email;

    if (email && isTestEmailDomains.filter(function (domain) {
      return email.indexOf(domain) > -1;
    }).length > 0) {
      setDimension('isTest', isTestValues.TRUE); // Note that this may override previously-sent `programTheme.isTestMode`
    }
  } catch (e) {
    logger.warn('Error setting isTest dimension', e);
  }
};
/**
 * @description Start a new verification "flow"
 * @param dispatch Redux action dispatch
 */


var createFetchNewVerificationRequest = function createFetchNewVerificationRequest(dispatch) {
  return /*#__PURE__*/function () {
    var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(programId, segment, previousViewModel, trackingId, forceNewVerificationRequest) {
      var verificationResponsePromise;
      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return dispatch({
                type: 'IS_LOADING',
                isLoading: true
              });

            case 2:
              _context23.prev = 2;
              verificationResponsePromise = VerificationApiClient.fetchNewVerificationRequest(programId, trackingId, forceNewVerificationRequest);
              return _context23.abrupt("return", createFetchVerificationRequest({
                dispatch: dispatch,
                verificationResponsePromise: verificationResponsePromise,
                programId: programId,
                segment: segment,
                previousViewModel: previousViewModel
              }));

            case 7:
              _context23.prev = 7;
              _context23.t0 = _context23["catch"](2);
              logger.error(_context23.t0, 'fetchNewVerificationRequest');

            case 10:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, null, [[2, 7]]);
    }));

    return function (_x51, _x52, _x53, _x54, _x55) {
      return _ref69.apply(this, arguments);
    };
  }();
};
/**
 * @description Provided with a verificationId, continue verifying someone.
 * @param dispatch Redux action dispatch
 */


var createFetchExistingVerificationRequest = function createFetchExistingVerificationRequest(dispatch) {
  return /*#__PURE__*/function () {
    var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(programId, verificationId, previousVerificationResponse, previousViewModel) {
      var needsLoading,
          verificationResponsePromise,
          _args24 = arguments;
      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              needsLoading = _args24.length > 4 && _args24[4] !== undefined ? _args24[4] : true;

              if (!needsLoading) {
                _context24.next = 4;
                break;
              }

              _context24.next = 4;
              return dispatch({
                type: 'IS_LOADING',
                isLoading: true
              });

            case 4:
              _context24.prev = 4;
              verificationResponsePromise = VerificationApiClient.fetchExistingVerificationRequest(verificationId);
              return _context24.abrupt("return", createFetchVerificationRequest({
                dispatch: dispatch,
                verificationResponsePromise: verificationResponsePromise,
                programId: programId,
                previousViewModel: previousViewModel,
                previousVerificationResponse: previousVerificationResponse
              }));

            case 9:
              _context24.prev = 9;
              _context24.t0 = _context24["catch"](4);
              logger.error(_context24.t0, 'fetchExistingVerificationRequest');

            case 12:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, null, [[4, 9]]);
    }));

    return function (_x56, _x57, _x58, _x59) {
      return _ref70.apply(this, arguments);
    };
  }();
};

var segmentChanged = function segmentChanged(currentSegment, nextSegment) {
  if (!nextSegment) {
    return false;
  }

  return !!(currentSegment && currentSegment !== nextSegment);
};

var currentStepChanged = function currentStepChanged(previousVerificationResponse, verificationResponse) {
  return !previousVerificationResponse || previousVerificationResponse.currentStep !== verificationResponse.currentStep;
};
/**
 * @description Await several items (new/existing verification request, program theme, etc) then update central state (redux).
 * Timing and order is very important within this function as it is bootstrapping most of the application.
 *
 * @param dispatch Redux action dispatch
 * @param verificationResponsePromise Either a new or existing verification server request.
 * @param programId
 * @param previousViewModel Optional
 * @private
 */


var createFetchVerificationRequest = /*#__PURE__*/function () {
  var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_ref71) {
    var dispatch, verificationResponsePromise, programId, segment, previousViewModel, previousVerificationResponse, fingerprintPromise, programThemePromise, verificationResponse, programTheme, locale, themeMessages, messagesPromise, nextSegment, orgList, orgListPromise, updatedPreviousViewModel, previousSegment, _fingerprint, _verificationResponse, currentStep, countries, _country, viewModel, messages;

    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            dispatch = _ref71.dispatch, verificationResponsePromise = _ref71.verificationResponsePromise, programId = _ref71.programId, segment = _ref71.segment, previousViewModel = _ref71.previousViewModel, previousVerificationResponse = _ref71.previousVerificationResponse;
            _context25.prev = 1;
            fingerprintPromise = getFingerprint();
            programThemePromise = VerificationApiClient.fetchProgramTheme(programId);
            _context25.next = 6;
            return Promise.all([verificationResponsePromise, programThemePromise]).then(function (responses) {
              var _responses = _slicedToArray2(responses, 2);

              verificationResponse = _responses[0];
              programTheme = _responses[1];
            }).catch(function (error) {
              verificationResponse = getMockVerificationRequestErrorResponse(error.message);
              programTheme = GetEmptyTheme();
            });

          case 6:
            logger.info('verificationResponse received: ', verificationResponse);
            locale = getLocaleSafely(previousViewModel, verificationResponse);
            themeMessages = getThemeMessages(programTheme);
            messagesPromise = getMessages(locale, themeMessages, verificationResponse.segment);
            nextSegment = verificationResponse.segment;
            orgList = null;

            if (!(nextSegment === SegmentEnum.MILITARY)) {
              _context25.next = 18;
              break;
            }

            orgListPromise = fetchProgramOrganizations(programTheme.config.orgSearchUrl, '');
            _context25.next = 16;
            return orgListPromise;

          case 16:
            orgList = _context25.sent;
            logger.info('orgList received: ', orgList);

          case 18:
            clearUploadedFiles(previousViewModel); // Need to remove the file elements from state since deepClone cannot clone them

            updatedPreviousViewModel = deepClone(previousViewModel);
            previousSegment = previousVerificationResponse ? previousVerificationResponse.segment : segment;

            if (!segmentChanged(previousSegment, nextSegment)) {
              _context25.next = 26;
              break;
            }

            logger.info('segment changed: ', previousSegment, nextSegment);
            _context25.next = 25;
            return doViewModelReset(dispatch)(verificationResponse);

          case 25:
            updatedPreviousViewModel = undefined;

          case 26:
            _context25.next = 28;
            return fingerprintPromise;

          case 28:
            _fingerprint = _context25.sent;
            _verificationResponse = verificationResponse, currentStep = _verificationResponse.currentStep;
            countries = getConfiguredCountries(programTheme);
            _country = determineCountry(verificationResponse, countries);
            viewModel = initViewModel({
              currentStep: currentStep,
              fingerprint: _fingerprint,
              locale: locale,
              country: _country,
              previousViewModel: updatedPreviousViewModel
            });
            viewModel = enhanceOrganizationFromTheme(viewModel, programTheme);

            if (currentStepChanged(previousVerificationResponse, verificationResponse)) {
              getHook('ON_VERIFICATION_STEP_CHANGE')(verificationResponse);

              if (previousVerificationResponse && previousVerificationResponse.currentStep === 'sso' && verificationResponse.currentStep !== 'sso' && verificationResponse.currentStep !== 'pending') {
                // PROM-773 since we're no-longer on step sso (here in tab1), close the sso tab (tab2) we opened previously
                closeTabRef();
              }
            }

            if (programTheme.threatMetrixEnabled) {
              collectThreatMetrixProfile(verificationResponse.verificationId);
            }

            saveVerificationIdForConversion(verificationResponse.verificationId);

            if (viewModel && viewModel.hasOwnProperty('metadata')) {
              viewModel.metadata = _objectSpread2({}, viewModel.metadata, getMetadataFromUrl(getMetadataConfig(programTheme).keys));
            }

            _context25.next = 40;
            return messagesPromise;

          case 40:
            messages = _context25.sent;
            return _context25.abrupt("return", Promise.all([dispatch({
              verificationResponse: verificationResponse,
              type: 'VERIFICATION_RESPONSE'
            }), dispatch({
              viewModel: viewModel,
              type: 'VIEW_MODEL'
            }), dispatch({
              programTheme: programTheme,
              type: 'PROGRAM_THEME'
            }), dispatch({
              messages: messages,
              type: 'SET_MESSAGES'
            }), dispatch({
              type: 'IS_LOADING',
              isLoading: false
            }), dispatch({
              orgList: orgList,
              type: 'PRE_LOAD_ORGS'
            }), dispatch({
              type: 'FORM_VALIDATION_OPTIONS'
            })]).then(function () {
              getHook('ON_VERIFICATION_READY')(verificationResponse); // This hook is a special case
              // Do not call this hook again after the page has initially loaded, such as pending step's polling behavior

              // This hook is a special case
              // Do not call this hook again after the page has initially loaded, such as pending step's polling behavior
              removeHook('ON_VERIFICATION_READY');
            }));

          case 44:
            _context25.prev = 44;
            _context25.t0 = _context25["catch"](1);
            logger.error(_context25.t0, 'createFetchVerificationRequest');
            throw _context25.t0;

          case 48:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25, null, [[1, 44]]);
  }));

  return function createFetchVerificationRequest(_x60) {
    return _ref72.apply(this, arguments);
  };
}();
/**
 * @description Action creator to update the view model in redux.
 * @param dispatch
 */


var createUpdateViewModel = function createUpdateViewModel(dispatch) {
  return /*#__PURE__*/function () {
    var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(viewModel) {
      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return Promise.all([dispatch({
                viewModel: viewModel,
                type: 'VIEW_MODEL'
              }), dispatch({
                type: 'FORM_VALIDATION_OPTIONS'
              })]);

            case 2:
              return _context26.abrupt("return", _context26.sent);

            case 3:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));

    return function (_x61) {
      return _ref73.apply(this, arguments);
    };
  }();
};

var createUpdateLocale = function createUpdateLocale(dispatch, programId) {
  return /*#__PURE__*/function () {
    var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(viewModel, programTheme, segment) {
      var locale, newProgramTheme, themeMessages;
      return _regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              dispatch({
                type: 'IS_LOADING',
                isLoading: true
              });
              locale = getLocaleSafely(viewModel);
              _context27.next = 4;
              return VerificationApiClient.fetchProgramTheme(programId, locale);

            case 4:
              newProgramTheme = _context27.sent;
              themeMessages = getThemeMessages(newProgramTheme);
              return _context27.abrupt("return", getMessages(locale, themeMessages, segment).then(function (messages) {
                return Promise.all([dispatch({
                  messages: messages,
                  type: 'SET_MESSAGES'
                }), dispatch({
                  viewModel: viewModel,
                  type: 'VIEW_MODEL'
                }), dispatch({
                  type: 'IS_LOADING',
                  isLoading: false
                })]);
              }));

            case 7:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));

    return function (_x62, _x63, _x64) {
      return _ref74.apply(this, arguments);
    };
  }();
};
/**
 * @description Action creator to update the program theme in redux.
 * @param dispatch
 */


var createUpdateProgramTheme = function createUpdateProgramTheme(dispatch) {
  return /*#__PURE__*/function () {
    var _ref75 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(programTheme) {
      return _regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              return _context28.abrupt("return", dispatch({
                programTheme: programTheme,
                type: 'PROGRAM_THEME'
              }));

            case 1:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    return function (_x65) {
      return _ref75.apply(this, arguments);
    };
  }();
};
/**
 * @description Action creator to update the field validation errors, which are those that are shown to a user as they fill-in the HTML form.
 * @param dispatch
 */


var createUpdateFieldValidationErrors = function createUpdateFieldValidationErrors(dispatch) {
  return /*#__PURE__*/function () {
    var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(fieldValidationErrors) {
      return _regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              return _context29.abrupt("return", dispatch({
                fieldValidationErrors: fieldValidationErrors,
                type: 'FIELD_VALIDATION_ERRORS'
              }));

            case 1:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    return function (_x66) {
      return _ref76.apply(this, arguments);
    };
  }();
};
/**
 * @description Action creator to submit a step to the backend REST API
 * @param dispatch
 */


var createSubmitStep = function createSubmitStep(dispatch) {
  return /*#__PURE__*/function () {
    var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(stepName, viewModel, previousResponse) {
      var verificationResponse, newViewModel, promiseVerificationResponse, promiseViewModel, promiseIsLoading;
      return _regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              logger.log("submitStep(): submitting stepName ".concat(stepName, ", viewModel:"), viewModel);
              scrollToWindowTop();
              _context30.next = 4;
              return dispatch({
                type: 'IS_LOADING',
                isLoading: true,
                loadingStep: stepName
              });

            case 4:
              logger.info("submitting step ".concat(stepName), viewModel);
              setGaDimensionIsTest(viewModel);
              _context30.next = 8;
              return VerificationApiClient.submitStep(stepName, previousResponse, viewModel);

            case 8:
              verificationResponse = _context30.sent;
              newViewModel = handleSubmitResponse(verificationResponse, viewModel);
              promiseVerificationResponse = dispatch({
                verificationResponse: verificationResponse,
                type: 'VERIFICATION_RESPONSE'
              });
              promiseViewModel = dispatch({
                viewModel: newViewModel,
                type: 'VIEW_MODEL'
              });
              promiseIsLoading = dispatch({
                type: 'IS_LOADING',
                isLoading: false
              });
              getHook('ON_VERIFICATION_STEP_CHANGE')(verificationResponse);
              return _context30.abrupt("return", Promise.all([promiseVerificationResponse, promiseViewModel, promiseIsLoading]));

            case 15:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    return function (_x67, _x68, _x69) {
      return _ref77.apply(this, arguments);
    };
  }();
};
/**
 * Perform the actual viewModel reset actions
 * @private
 */


var doViewModelReset = function doViewModelReset(dispatch) {
  return function (verificationResponse) {
    return Promise.all([dispatch({
      type: 'VIEW_MODEL',
      viewModel: getEmptyViewModel(verificationResponse.currentStep)
    }), dispatch({
      type: 'PREVIOUS_VIEW_MODEL',
      previousViewModel: undefined
    }), dispatch({
      type: 'FIELD_VALIDATION_ERRORS',
      fieldValidationErrors: getFieldValidationErrorsEmpty()
    })]);
  };
};
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */


function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
} // Inlined version of the `symbol-observable` polyfill


var $$observable = function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */


var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */

function isPlainObject$1(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (process.env.NODE_ENV !== 'production') {
    // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
    var miniKindOf = function miniKindOf(val) {
      if (val === void 0) return 'undefined';
      if (val === null) return 'null';
      var type = typeof val;

      switch (type) {
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
          {
            return type;
          }
      }

      if (Array.isArray(val)) return 'array';
      if (isDate(val)) return 'date';
      if (_isError(val)) return 'error';
      var constructorName = ctorName(val);

      switch (constructorName) {
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
          return constructorName;
      } // other


      return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
    };

    var ctorName = function ctorName(val) {
      return typeof val.constructor === 'function' ? val.constructor.name : null;
    };

    var _isError = function _isError(val) {
      return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
    };

    var isDate = function isDate(val) {
      if (val instanceof Date) return true;
      return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
    };

    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */


function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject$1(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */


function warning$1(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */


function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning$1('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}
/**
 * The initial state of the verification service.
 */


var initialState$1 = Object.freeze({
  programId: undefined,
  programTheme: undefined,
  isLoading: true,
  isErrored: false,
  viewModel: undefined,
  previousViewModel: undefined,
  previousVerificationResponse: undefined,
  verificationResponse: undefined,
  fieldValidationErrors: getFieldValidationErrorsEmpty(),
  messages: undefined,
  orgList: undefined,
  formValidationOptions: {}
});

var getInitialState = function getInitialState() {
  return deepClone(initialState$1);
};
/**
 * @description Most of the state for the VerificationService
 * @example as a user fills-in the HTML form, we can track the data entered here in the view model.
 * @param state
 * @param action
 */


var verificationServiceReducer = function verificationServiceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'PROGRAM_ID':
      setDimension('programId', action.programId);
      return _objectSpread2({}, state, {
        programId: action.programId
      });

    case 'VERIFICATION_RESPONSE':
      var previousVerificationResponse;

      if (state.verificationResponse && (state.verificationResponse.currentStep === VerificationStepsEnum.collectMilitaryStatus || state.verificationResponse.currentStep === VerificationStepsEnum.sso || state.verificationResponse.currentStep === VerificationStepsEnum.docUpload)) {
        previousVerificationResponse = state.verificationResponse;
      } else if (state.previousVerificationResponse) {
        previousVerificationResponse = state.previousVerificationResponse;
      } else {
        previousVerificationResponse = state.verificationResponse;
      }

      recordVerificationResponse(action.verificationResponse);
      return _objectSpread2({}, state, {
        previousVerificationResponse: previousVerificationResponse,
        // When we get a verificationResponse, hold on to the last viewModel
        // before re-render, in case it needs to be referenced in the new step:
        previousViewModel: state.viewModel,
        verificationResponse: action.verificationResponse
      });

    case 'SET_MESSAGES':
      return _objectSpread2({}, state, {
        messages: action.messages
      });

    case 'FIELD_VALIDATION_ERRORS':
      return _objectSpread2({}, state, {
        fieldValidationErrors: action.fieldValidationErrors
      });

    case 'VIEW_MODEL':
      var newState = _objectSpread2({}, state);

      if (action.viewModel) {
        // Allow action.viewModel to be a sparse object. Bring along all previous viewModel
        newState.viewModel = _objectSpread2({}, action.viewModel);
      }

      if (action.viewModel && action.viewModel.metadata) {
        setMetadata(action.viewModel.metadata);

        var _metadata = getMetadata();

        newState.viewModel.metadata = _metadata;
      }

      recordViewModelChange(state, newState);
      return newState;

    case 'PRE_LOAD_ORGS':
      return _objectSpread2({}, state, {
        orgList: action.orgList
      });

    case 'PREVIOUS_VIEW_MODEL':
      return _objectSpread2({}, state, {
        previousViewModel: action.previousViewModel
      });

    case 'PROGRAM_THEME':
      setDimension('isTest', action.programTheme.isTestMode ? isTestValues.TRUE : isTestValues.FALSE);
      return _objectSpread2({}, state, {
        programTheme: action.programTheme
      });

    case 'FORM_VALIDATION_OPTIONS':
      return _objectSpread2({}, state, {
        formValidationOptions: {
          maxAge: state.verificationResponse.maxAge,
          minAge: state.verificationResponse.minAge,
          smsLoopEnabled: state.programTheme.smsLoopEnabled,
          currentStep: state.verificationResponse.currentStep,
          viewModel: state.viewModel
        }
      });

    case 'IS_LOADING':
      return _objectSpread2({}, state, {
        isLoading: action.isLoading,
        loadingStep: action.isLoading ? action.loadingStep : undefined
      });

    case 'IS_ERRORED':
      return _objectSpread2({}, state, {
        isErrored: action.isErrored
      });

    case 'RESET_STATE':
      return _objectSpread2({}, deepClone(getInitialState()));

    case 'FORCE_UPDATE':
      return deepClone(state);

    default:
      return state;
  }
};

var store$2;

var getStore = function getStore() {
  if (!store$2) {
    store$2 = createStore(verificationServiceReducer, // @ts-ignore
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
    logger.init(store$2);
  }

  return store$2;
};

var resetStore = function resetStore() {
  return getStore().dispatch({
    type: 'RESET_STATE'
  });
};

var refreshStore = function refreshStore() {
  // This prompts the form to re-render which it otherwise wouldn't because a new verification is requested only on mount
  if (getOptions().mockResponse) {
    getStore().dispatch({
      verificationResponse: getOptions().mockResponse,
      type: 'VERIFICATION_RESPONSE'
    });
  }

  getStore().dispatch({
    type: 'FORCE_UPDATE'
  });
};

var store$1 = getStore();
/**
 * @description Set the viewModel for the form or reset it by passing an empty object
 * @todo allow sparse viewModel to be provided
 */

var setViewModel = function setViewModel(newViewModel) {
  var state = store$1.getState();

  var doSet = function doSet() {
    var updatedViewModel = deepClone(newViewModel);
    logger.info('Setting viewModel', updatedViewModel);
    createUpdateViewModel(store$1.dispatch)(updatedViewModel);
  }; // The viewModel may not be set until later, and default messages may fail to load
  // so re-use setOptions to make sure we know about the desire to use this locale


  var locale = getSafe(function () {
    return newViewModel.localeChoice.value;
  });

  if (locale) {
    setOptions({
      locale: locale
    });
  }

  if (state.isLoading) {
    addHook({
      name: 'ON_VERIFICATION_READY',
      callback: function callback() {
        doSet();
      }
    });
  } else {
    doSet();
  }
};
/**
 * Schedule, or immediately perform a viewModel reset.
 * Resets fieldValidationErrors and previousViewModel as well.
 * @todo Return promise
 */


var resetViewModel = function resetViewModel() {
  var state = store$1.getState();

  if (state.isLoading) {
    addHook({
      name: 'ON_VERIFICATION_READY',
      callback: function callback(verificationResponse) {
        doViewModelReset(store$1.dispatch)(verificationResponse);
      }
    });
  } else {
    doViewModelReset(store$1.dispatch)(state.verificationResponse);
  }
};

var addFiles = function addFiles(viewModel, files, erroredFileNames) {
  return fn(viewModel, function (draft) {
    Object.keys(viewModel).filter(function (key) {
      return !!viewModel[key] && key.includes('file');
    }).map(function (key) {
      return viewModel[key];
    }).concat(files, Array(MAX_DOC_UPLOAD_DOCS_ALLOWED).fill(undefined)).splice(0, 3).forEach(function (file, index) {
      return draft["file".concat(index + 1)] = file;
    }); // eslint-disable-line

    if (erroredFileNames) {
      draft.erroredFileNames = erroredFileNames;
    } else {
      draft.erroredFileNames = undefined;
    }
  });
};

var removeFile = function removeFile(viewModel, fileNumber) {
  if (![1, 2, 3].includes(fileNumber)) {
    throw new Error("Expected either 1, 2 or 3 for argument \"fileNumber\", but received ".concat(fileNumber));
  }

  return fn(viewModel, function (draft) {
    Object.keys(viewModel).filter(function (key) {
      return key.includes('file') && !key.includes(fileNumber.toString());
    }).map(function (key) {
      return viewModel[key];
    }).concat(Array(MAX_DOC_UPLOAD_DOCS_ALLOWED).fill(undefined)).splice(0, 3).forEach(function (file, index) {
      return draft["file".concat(index + 1)] = file;
    }); // eslint-disable-line
  });
};

var removeAllFiles = function removeAllFiles(viewModel) {
  return fn(viewModel, function (draft) {
    for (var _i3 = 0; _i3 < MAX_DOC_UPLOAD_DOCS_ALLOWED; _i3++) {
      draft["file".concat(_i3 + 1)] = undefined;
    }
  });
};

var ReactReduxContext = React.createContext(null);

var Provider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Provider, _Component);

  function Provider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var store = props.store;
    _this.state = {
      storeState: store.getState(),
      store: store
    };
    return _this;
  }

  var _proto = Provider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.subscribe();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    this._isMounted = false;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.store !== prevProps.store) {
      if (this.unsubscribe) this.unsubscribe();
      this.subscribe();
    }
  };

  _proto.subscribe = function subscribe() {
    var _this2 = this;

    var store = this.props.store;
    this.unsubscribe = store.subscribe(function () {
      var newStoreState = store.getState();

      if (!_this2._isMounted) {
        return;
      }

      _this2.setState(function (providerState) {
        // If the value is the same, skip the unnecessary state update.
        if (providerState.storeState === newStoreState) {
          return null;
        }

        return {
          storeState: newStoreState
        };
      });
    }); // Actions might have been dispatched between render and mount - handle those

    var postMountStoreState = store.getState();

    if (postMountStoreState !== this.state.storeState) {
      this.setState({
        storeState: postMountStoreState
      });
    }
  };

  _proto.render = function render() {
    var Context = this.props.context || ReactReduxContext;
    return React.createElement(Context.Provider, {
      value: this.state
    }, this.props.children);
  };

  return Provider;
}(Component);

Provider.propTypes = {
  store: propTypes.shape({
    subscribe: propTypes.func.isRequired,
    dispatch: propTypes.func.isRequired,
    getState: propTypes.func.isRequired
  }),
  context: propTypes.object,
  children: propTypes.any
};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b$1 = "function" === typeof Symbol && Symbol.for,
    c$1 = b$1 ? Symbol.for("react.element") : 60103,
    d$1 = b$1 ? Symbol.for("react.portal") : 60106,
    e$1 = b$1 ? Symbol.for("react.fragment") : 60107,
    f$1 = b$1 ? Symbol.for("react.strict_mode") : 60108,
    g$1 = b$1 ? Symbol.for("react.profiler") : 60114,
    h$1 = b$1 ? Symbol.for("react.provider") : 60109,
    k$1 = b$1 ? Symbol.for("react.context") : 60110,
    l$1 = b$1 ? Symbol.for("react.async_mode") : 60111,
    m$1 = b$1 ? Symbol.for("react.concurrent_mode") : 60111,
    n$1 = b$1 ? Symbol.for("react.forward_ref") : 60112,
    p$1 = b$1 ? Symbol.for("react.suspense") : 60113,
    q$1 = b$1 ? Symbol.for("react.suspense_list") : 60120,
    r$1 = b$1 ? Symbol.for("react.memo") : 60115,
    t$1 = b$1 ? Symbol.for("react.lazy") : 60116,
    v$1 = b$1 ? Symbol.for("react.block") : 60121,
    w$1 = b$1 ? Symbol.for("react.fundamental") : 60117,
    x$1 = b$1 ? Symbol.for("react.responder") : 60118,
    y$1 = b$1 ? Symbol.for("react.scope") : 60119;

function z$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l$1:
          case m$1:
          case e$1:
          case g$1:
          case f$1:
          case p$1:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n$1:
              case t$1:
              case r$1:
              case h$1:
                return a;

              default:
                return u;
            }

        }

      case d$1:
        return u;
    }
  }
}

function A$1(a) {
  return z$1(a) === m$1;
}

var AsyncMode$1 = l$1;
var ConcurrentMode$1 = m$1;
var ContextConsumer$1 = k$1;
var ContextProvider$1 = h$1;
var Element$1 = c$1;
var ForwardRef$1 = n$1;
var Fragment$1 = e$1;
var Lazy$1 = t$1;
var Memo$1 = r$1;
var Portal$1 = d$1;
var Profiler$1 = g$1;
var StrictMode$1 = f$1;
var Suspense$1 = p$1;

var isAsyncMode$1 = function isAsyncMode$1(a) {
  return A$1(a) || z$1(a) === l$1;
};

var isConcurrentMode$1 = A$1;

var isContextConsumer$1 = function isContextConsumer$1(a) {
  return z$1(a) === k$1;
};

var isContextProvider$1 = function isContextProvider$1(a) {
  return z$1(a) === h$1;
};

var isElement$1 = function isElement$1(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1;
};

var isForwardRef$1 = function isForwardRef$1(a) {
  return z$1(a) === n$1;
};

var isFragment$1 = function isFragment$1(a) {
  return z$1(a) === e$1;
};

var isLazy$1 = function isLazy$1(a) {
  return z$1(a) === t$1;
};

var isMemo$1 = function isMemo$1(a) {
  return z$1(a) === r$1;
};

var isPortal$1 = function isPortal$1(a) {
  return z$1(a) === d$1;
};

var isProfiler$1 = function isProfiler$1(a) {
  return z$1(a) === g$1;
};

var isStrictMode$1 = function isStrictMode$1(a) {
  return z$1(a) === f$1;
};

var isSuspense$1 = function isSuspense$1(a) {
  return z$1(a) === p$1;
};

var isValidElementType$1 = function isValidElementType$1(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f$1 || a === p$1 || a === q$1 || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};

var typeOf$1 = z$1;
var reactIs_production_min$1 = {
  AsyncMode: AsyncMode$1,
  ConcurrentMode: ConcurrentMode$1,
  ContextConsumer: ContextConsumer$1,
  ContextProvider: ContextProvider$1,
  Element: Element$1,
  ForwardRef: ForwardRef$1,
  Fragment: Fragment$1,
  Lazy: Lazy$1,
  Memo: Memo$1,
  Portal: Portal$1,
  Profiler: Profiler$1,
  StrictMode: StrictMode$1,
  Suspense: Suspense$1,
  isAsyncMode: isAsyncMode$1,
  isConcurrentMode: isConcurrentMode$1,
  isContextConsumer: isContextConsumer$1,
  isContextProvider: isContextProvider$1,
  isElement: isElement$1,
  isForwardRef: isForwardRef$1,
  isFragment: isFragment$1,
  isLazy: isLazy$1,
  isMemo: isMemo$1,
  isPortal: isPortal$1,
  isProfiler: isProfiler$1,
  isStrictMode: isStrictMode$1,
  isSuspense: isSuspense$1,
  isValidElementType: isValidElementType$1,
  typeOf: typeOf$1
};
var reactIs_development$1 = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
reactIs_development$1.AsyncMode;
reactIs_development$1.ConcurrentMode;
reactIs_development$1.ContextConsumer;
reactIs_development$1.ContextProvider;
reactIs_development$1.Element;
reactIs_development$1.ForwardRef;
reactIs_development$1.Fragment;
reactIs_development$1.Lazy;
reactIs_development$1.Memo;
reactIs_development$1.Portal;
reactIs_development$1.Profiler;
reactIs_development$1.StrictMode;
reactIs_development$1.Suspense;
reactIs_development$1.isAsyncMode;
reactIs_development$1.isConcurrentMode;
reactIs_development$1.isContextConsumer;
reactIs_development$1.isContextProvider;
reactIs_development$1.isElement;
reactIs_development$1.isForwardRef;
reactIs_development$1.isFragment;
reactIs_development$1.isLazy;
reactIs_development$1.isMemo;
reactIs_development$1.isPortal;
reactIs_development$1.isProfiler;
reactIs_development$1.isStrictMode;
reactIs_development$1.isSuspense;
reactIs_development$1.isValidElementType;
reactIs_development$1.typeOf;
var reactIs$1 = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$1;
  } else {
    module.exports = reactIs_development$1;
  }
});
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs$1.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};

var invariant_1 = invariant;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r;
};

var isPortal = function isPortal(a) {
  return z(a) === d;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
reactIs_development.AsyncMode;
reactIs_development.ConcurrentMode;
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
reactIs_development.isValidElementType;
reactIs_development.typeOf;
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
var reactIs_1 = reactIs.isContextConsumer;
var reactIs_2 = reactIs.isValidElementType;

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose$1(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  invariant_1(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
  invariant_1(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
  var customStoreWarningMessage = 'To use a custom Redux store for specific components,  create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  invariant_1(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production') {
      invariant_1(reactIs_2(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;
    var OuterBaseComponent = Component;

    if (pure) {
      OuterBaseComponent = PureComponent;
    }

    function makeDerivedPropsSelector() {
      var lastProps;
      var lastState;
      var lastDerivedProps;
      var lastStore;
      var lastSelectorFactoryOptions;
      var sourceSelector;
      return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
        if (pure && lastProps === props && lastState === state) {
          return lastDerivedProps;
        }

        if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
          lastStore = store;
          lastSelectorFactoryOptions = selectorFactoryOptions;
          sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
        }

        lastProps = props;
        lastState = state;
        var nextProps = sourceSelector(state, props);
        lastDerivedProps = nextProps;
        return lastDerivedProps;
      };
    }

    function makeChildElementSelector() {
      var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
      return function selectChildElement(WrappedComponent, childProps, forwardRef) {
        if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
          lastChildProps = childProps;
          lastForwardRef = forwardRef;
          lastComponent = WrappedComponent;
          lastChildElement = React.createElement(WrappedComponent, _extends({}, childProps, {
            ref: forwardRef
          }));
        }

        return lastChildElement;
      };
    }

    var Connect = /*#__PURE__*/function (_OuterBaseComponent) {
      _inheritsLoose(Connect, _OuterBaseComponent);

      function Connect(props) {
        var _this;

        _this = _OuterBaseComponent.call(this, props) || this;
        invariant_1(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
        _this.selectDerivedProps = makeDerivedPropsSelector();
        _this.selectChildElement = makeChildElementSelector();
        _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind(_assertThisInitialized(_this));
        return _this;
      }

      var _proto = Connect.prototype;

      _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
        // calling renderWrappedComponent on prototype from indirectRenderWrappedComponent bound to `this`
        return this.renderWrappedComponent(value);
      };

      _proto.renderWrappedComponent = function renderWrappedComponent(value) {
        invariant_1(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
        var storeState = value.storeState,
            store = value.store;
        var wrapperProps = this.props;
        var forwardedRef;

        if (forwardRef) {
          wrapperProps = this.props.wrapperProps;
          forwardedRef = this.props.forwardedRef;
        }

        var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
        return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
      };

      _proto.render = function render() {
        var ContextToUse = this.props.context && this.props.context.Consumer && reactIs_1(React.createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
        return React.createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
      };

      return Connect;
    }(OuterBaseComponent);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        return React.createElement(Connect, {
          wrapperProps: props,
          forwardedRef: ref
        });
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }

    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}

var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */


function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */


function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject(value)) {
    warning(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..


function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//


function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}

var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}

var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      warning("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.


function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose$1(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */


function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose$1(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}

var connect = createConnect();
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var self$1;
var RtlDetectLib = self$1 = {
  // eslint-disable-line consistent-this
  // Private vars - star
  _regexEscape: /([\.\*\+\^\$\[\]\\\(\)\|\{\}\,\-\:\?])/g,
  // eslint-disable-line no-useless-escape
  _regexParseLocale: /^([a-zA-Z]*)([_\-a-zA-Z]*)$/,
  // Private vars - end
  // Private functions - star
  _escapeRegExpPattern: function _escapeRegExpPattern(str) {
    if (typeof str !== 'string') {
      return str;
    }

    return str.replace(self$1._regexEscape, '\\$1');
  },
  _toLowerCase: function _toLowerCase(str, reserveReturnValue) {
    if (typeof str !== 'string') {
      return reserveReturnValue && str;
    }

    return str.toLowerCase();
  },
  _toUpperCase: function _toUpperCase(str, reserveReturnValue) {
    if (typeof str !== 'string') {
      return reserveReturnValue && str;
    }

    return str.toUpperCase();
  },
  _trim: function _trim(str, delimiter, reserveReturnValue) {
    var patterns = [];
    var regexp;

    var addPatterns = function addPatterns(pattern) {
      // Build trim RegExp pattern and push it to patterns array
      patterns.push('^' + pattern + '+|' + pattern + '+$');
    }; // fix reserveReturnValue value


    if (typeof delimiter === 'boolean') {
      reserveReturnValue = delimiter;
      delimiter = null;
    }

    if (typeof str !== 'string') {
      return reserveReturnValue && str;
    } // Trim based on delimiter array values


    if (Array.isArray(delimiter)) {
      // Loop through delimiter array
      delimiter.map(function (item) {
        // Escape delimiter to be valid RegExp Pattern
        var pattern = self$1._escapeRegExpPattern(item); // Push pattern to patterns array


        addPatterns(pattern);
      });
    } // Trim based on delimiter string value


    if (typeof delimiter === 'string') {
      // Escape delimiter to be valid RegExp Pattern
      var patternDelimiter = self$1._escapeRegExpPattern(delimiter); // push pattern to patterns array


      addPatterns(patternDelimiter);
    } // If delimiter  is not defined, Trim white spaces


    if (!delimiter) {
      // Push white space pattern to patterns array
      addPatterns('\\s');
    } // Build RegExp pattern


    var pattern = '(' + patterns.join('|') + ')'; // Build RegExp object

    regexp = new RegExp(pattern, 'g'); // trim string for all patterns

    while (str.match(regexp)) {
      str = str.replace(regexp, '');
    } // Return trim string


    return str;
  },
  _parseLocale: function _parseLocale(strLocale) {
    var matches = self$1._regexParseLocale.exec(strLocale); // exec regex


    var parsedLocale;
    var lang;
    var countryCode;

    if (!strLocale || !matches) {
      return;
    } // fix countryCode string by trimming '-' and '_'


    matches[2] = self$1._trim(matches[2], ['-', '_']);
    lang = self$1._toLowerCase(matches[1]);
    countryCode = self$1._toUpperCase(matches[2]) || countryCode; // object with lang, countryCode properties

    parsedLocale = {
      lang: lang,
      countryCode: countryCode
    }; // return parsed locale object

    return parsedLocale;
  },
  // Private functions - End
  // Public functions - star
  isRtlLang: function isRtlLang(strLocale) {
    var objLocale = self$1._parseLocale(strLocale);

    if (!objLocale) {
      return;
    } // return true if the intel string lang exists in the BID RTL LANGS array else return false


    return self$1._BIDI_RTL_LANGS.indexOf(objLocale.lang) >= 0;
  },
  getLangDir: function getLangDir(strLocale) {
    // return 'rtl' if the intel string lang exists in the BID RTL LANGS array else return 'ltr'
    return self$1.isRtlLang(strLocale) ? 'rtl' : 'ltr';
  } // Public functions - End

}; // Const BIDI_RTL_LANGS Array
// BIDI_RTL_LANGS ref: http://en.wikipedia.org/wiki/Right-to-left
// Table of scripts in Unicode: https://en.wikipedia.org/wiki/Script_(Unicode)

Object.defineProperty(self$1, '_BIDI_RTL_LANGS', {
  value: ['ae',
  /* Avestan */
  'ar',
  /* 'العربية', Arabic */
  'arc',
  /* Aramaic */
  'bcc',
  /* 'بلوچی مکرانی', Southern Balochi */
  'bqi',
  /* 'بختياري', Bakthiari */
  'ckb',
  /* 'Soranî / کوردی', Sorani */
  'dv',
  /* Dhivehi */
  'fa',
  /* 'فارسی', Persian */
  'glk',
  /* 'گیلکی', Gilaki */
  'he',
  /* 'עברית', Hebrew */
  'ku',
  /* 'Kurdî / كوردی', Kurdish */
  'mzn',
  /* 'مازِرونی', Mazanderani */
  'nqo',
  /* N'Ko */
  'pnb',
  /* 'پنجابی', Western Punjabi */
  'ps',
  /* 'پښتو', Pashto, */
  'sd',
  /* 'سنڌي', Sindhi */
  'ug',
  /* 'Uyghurche / ئۇيغۇرچە', Uyghur */
  'ur',
  /* 'اردو', Urdu */
  'yi'
  /* 'ייִדיש', Yiddish */
  ],
  writable: false,
  enumerable: true,
  configurable: false
});
var rtlDetect = RtlDetectLib;
var rtlDetect_1 = {
  isRtlLang: rtlDetect.isRtlLang,
  getLangDir: rtlDetect.getLangDir
};
rtlDetect_1.isRtlLang;
rtlDetect_1.getLangDir;

var OptInInput = function OptInInput(_ref78) {
  var isErrored = _ref78.isErrored,
      _onChange7 = _ref78.onChange,
      value = _ref78.value;
  return React.createElement("div", {
    className: "sid-checkbox"
  }, React.createElement("input", {
    className: "sid-checkbox__input",
    id: "sid-opt-in",
    name: "sid-opt-in",
    type: "checkbox",
    checked: value,
    ref: function ref(_ref79) {
      return setRef('optIn', _ref79);
    },
    onChange: function onChange(e) {
      return _onChange7(e.target.checked);
    }
  }), React.createElement("span", {
    className: "sid-checkbox__input-like ".concat(isErrored ? 'sid-checkbox__input-like--error' : '')
  }));
};

var OptInInputComponent = OptInInput;

var OptInComponent = function OptInComponent(_ref80) {
  var isErrored = _ref80.isErrored,
      isRequired = _ref80.isRequired,
      onChange = _ref80.onChange,
      value = _ref80.value,
      verificationService = _ref80.verificationService;
  var optInFieldId = 'marketConsentValue';
  var getOptInValidationError = React.useCallback(function (value) {
    var invalidError = 'marketConsentRequired';

    if (isRequired && !value) {
      return invalidError;
    }
  }, [isRequired]);
  var marketConsentConfig = verificationService && verificationService.programTheme && getMarketConsent(verificationService.programTheme) || {};
  var defaultMessage = marketConsentConfig.message || 'Yes, send me {company} marketing communications about exclusive sales, special offers, latest products and more';
  React.useEffect(function () {
    setCustomValidator(optInFieldId, getOptInValidationError);
  }, [optInFieldId, getOptInValidationError]);
  return React.createElement("div", {
    className: "sid-field sid-opt-in"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("div", {
    className: "sid-l-position"
  }, React.createElement("label", {
    htmlFor: "sid-opt-in"
  }, React.createElement(OptInInputComponent, {
    isErrored: isErrored,
    onChange: onChange,
    value: value
  }), React.createElement("div", {
    className: "sid-field__label sid-checkbox__label"
  }, verificationService ? React.createElement(FormattedMessage, {
    id: "companyName",
    defaultMessage: "{Company}"
  }, function (companyName) {
    return React.createElement(FormattedHTMLMessage, {
      id: "optIn",
      values: {
        company: companyName
      },
      defaultMessage: defaultMessage
    });
  }) : React.createElement(FormattedHTMLMessage, {
    id: "optIn",
    defaultMessage: defaultMessage
  })), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidOptIn",
    defaultMessage: "Must be selected to continue"
  })) : null)));
};

var MarketConsentWrapperComponent = function MarketConsentWrapperComponent(_ref81) {
  var verificationService = _ref81.verificationService,
      isErrored = _ref81.isErrored,
      _onChange8 = _ref81.onChange,
      viewModel = _ref81.viewModel;
  var programTheme = verificationService.programTheme;
  var marketConsentConfig = getMarketConsent(programTheme);
  return marketConsentConfig.enabled ? React.createElement(OptInComponent, {
    isErrored: isErrored,
    isRequired: marketConsentConfig.required,
    verificationService: verificationService,
    value: viewModel.metadata && viewModel.metadata.marketConsentValue || false,
    onChange: function onChange(value) {
      return _onChange8(value);
    }
  }) : null;
};

var LogoComponent = function LogoComponent(_ref82) {
  var verificationService = _ref82.verificationService;
  var logoUrl = getLogoUrl(verificationService.programTheme);

  if (logoUrl) {
    return React.createElement("div", {
      className: "sid-logo sid-l-space-top-md"
    }, React.createElement(FormattedMessage, {
      id: "companyName",
      defaultMessage: "{Company}"
    }, function (companyName) {
      return React.createElement("img", {
        className: "sid-logo__img",
        alt: "".concat(companyName, " logo"),
        src: logoUrl
      });
    }));
  }

  return null;
};

var lib = createCommonjsModule(function (module) {
  module.exports = function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) {
        r.d(n, a, function (t) {
          return e[t];
        }.bind(null, a));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 9);
  }([function (e, t) {
    e.exports = React;
  }, function (e, t, r) {
    var n;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      var r = {}.hasOwnProperty;

      function a() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];

          if (n) {
            var o = typeof n;
            if ("string" === o || "number" === o) e.push(n);else if (Array.isArray(n) && n.length) {
              var i = a.apply(null, n);
              i && e.push(i);
            } else if ("object" === o) for (var u in n) {
              r.call(n, u) && n[u] && e.push(u);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (a.default = a, e.exports = a) : void 0 === (n = function () {
        return a;
      }.apply(t, [])) || (e.exports = n);
    }();
  }, function (e, t, r) {
    (function (t) {
      var r = /^\s+|\s+$/g,
          n = /^[-+]0x[0-9a-f]+$/i,
          a = /^0b[01]+$/i,
          o = /^0o[0-7]+$/i,
          i = parseInt,
          u = "object" == typeof t && t && t.Object === Object && t,
          c = "object" == typeof self && self && self.Object === Object && self,
          s = u || c || Function("return this")(),
          l = Object.prototype.toString,
          f = s.Symbol,
          d = f ? f.prototype : void 0,
          p = d ? d.toString : void 0;

      function h(e) {
        if ("string" == typeof e) return e;
        if (y(e)) return p ? p.call(e) : "";
        var t = e + "";
        return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
      }

      function m(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      function y(e) {
        return "symbol" == typeof e || function (e) {
          return !!e && "object" == typeof e;
        }(e) && "[object Symbol]" == l.call(e);
      }

      function b(e) {
        return e ? (e = function (e) {
          if ("number" == typeof e) return e;
          if (y(e)) return NaN;

          if (m(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = m(t) ? t + "" : t;
          }

          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(r, "");
          var u = a.test(e);
          return u || o.test(e) ? i(e.slice(2), u ? 2 : 8) : n.test(e) ? NaN : +e;
        }(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
      }

      e.exports = function (e, t, r) {
        var n, a, o, i;
        return e = null == (n = e) ? "" : h(n), a = function (e) {
          var t = b(e),
              r = t % 1;
          return t == t ? r ? t - r : t : 0;
        }(r), o = 0, i = e.length, a == a && (void 0 !== i && (a = a <= i ? a : i), void 0 !== o && (a = a >= o ? a : o)), r = a, t = h(t), e.slice(r, r + t.length) == t;
      };
    }).call(this, r(3));
  }, function (e, t) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (r = window);
    }

    e.exports = r;
  }, function (e, t, r) {
    (function (t) {
      var r = /^\[object .+?Constructor\]$/,
          n = "object" == typeof t && t && t.Object === Object && t,
          a = "object" == typeof self && self && self.Object === Object && self,
          o = n || a || Function("return this")();
      var i,
          u = Array.prototype,
          c = Function.prototype,
          s = Object.prototype,
          l = o["__core-js_shared__"],
          f = (i = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "")) ? "Symbol(src)_1." + i : "",
          d = c.toString,
          p = s.hasOwnProperty,
          h = s.toString,
          m = RegExp("^" + d.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          y = u.splice,
          b = x(o, "Map"),
          g = x(Object, "create");

      function v(e) {
        var t = -1,
            r = e ? e.length : 0;

        for (this.clear(); ++t < r;) {
          var n = e[t];
          this.set(n[0], n[1]);
        }
      }

      function C(e) {
        var t = -1,
            r = e ? e.length : 0;

        for (this.clear(); ++t < r;) {
          var n = e[t];
          this.set(n[0], n[1]);
        }
      }

      function _(e) {
        var t = -1,
            r = e ? e.length : 0;

        for (this.clear(); ++t < r;) {
          var n = e[t];
          this.set(n[0], n[1]);
        }
      }

      function w(e, t) {
        for (var r, n, a = e.length; a--;) {
          if ((r = e[a][0]) === (n = t) || r != r && n != n) return a;
        }

        return -1;
      }

      function S(e) {
        return !(!O(e) || (t = e, f && f in t)) && (function (e) {
          var t = O(e) ? h.call(e) : "";
          return "[object Function]" == t || "[object GeneratorFunction]" == t;
        }(e) || function (e) {
          var t = !1;
          if (null != e && "function" != typeof e.toString) try {
            t = !!(e + "");
          } catch (e) {}
          return t;
        }(e) ? m : r).test(function (e) {
          if (null != e) {
            try {
              return d.call(e);
            } catch (e) {}

            try {
              return e + "";
            } catch (e) {}
          }

          return "";
        }(e));
        var t;
      }

      function j(e, t) {
        var r,
            n,
            a = e.__data__;
        return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? a["string" == typeof t ? "string" : "hash"] : a.map;
      }

      function x(e, t) {
        var r = function (e, t) {
          return null == e ? void 0 : e[t];
        }(e, t);

        return S(r) ? r : void 0;
      }

      function N(e, t) {
        if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");

        var r = function r() {
          var n = arguments,
              a = t ? t.apply(this, n) : n[0],
              o = r.cache;
          if (o.has(a)) return o.get(a);
          var i = e.apply(this, n);
          return r.cache = o.set(a, i), i;
        };

        return r.cache = new (N.Cache || _)(), r;
      }

      function O(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      v.prototype.clear = function () {
        this.__data__ = g ? g(null) : {};
      }, v.prototype.delete = function (e) {
        return this.has(e) && delete this.__data__[e];
      }, v.prototype.get = function (e) {
        var t = this.__data__;

        if (g) {
          var r = t[e];
          return "__lodash_hash_undefined__" === r ? void 0 : r;
        }

        return p.call(t, e) ? t[e] : void 0;
      }, v.prototype.has = function (e) {
        var t = this.__data__;
        return g ? void 0 !== t[e] : p.call(t, e);
      }, v.prototype.set = function (e, t) {
        return this.__data__[e] = g && void 0 === t ? "__lodash_hash_undefined__" : t, this;
      }, C.prototype.clear = function () {
        this.__data__ = [];
      }, C.prototype.delete = function (e) {
        var t = this.__data__,
            r = w(t, e);
        return !(r < 0) && (r == t.length - 1 ? t.pop() : y.call(t, r, 1), !0);
      }, C.prototype.get = function (e) {
        var t = this.__data__,
            r = w(t, e);
        return r < 0 ? void 0 : t[r][1];
      }, C.prototype.has = function (e) {
        return w(this.__data__, e) > -1;
      }, C.prototype.set = function (e, t) {
        var r = this.__data__,
            n = w(r, e);
        return n < 0 ? r.push([e, t]) : r[n][1] = t, this;
      }, _.prototype.clear = function () {
        this.__data__ = {
          hash: new v(),
          map: new (b || C)(),
          string: new v()
        };
      }, _.prototype.delete = function (e) {
        return j(this, e).delete(e);
      }, _.prototype.get = function (e) {
        return j(this, e).get(e);
      }, _.prototype.has = function (e) {
        return j(this, e).has(e);
      }, _.prototype.set = function (e, t) {
        return j(this, e).set(e, t), this;
      }, N.Cache = _, e.exports = N;
    }).call(this, r(3));
  }, function (e, t, r) {
    (function (t) {
      var r = /^\s+|\s+$/g,
          n = /^[-+]0x[0-9a-f]+$/i,
          a = /^0b[01]+$/i,
          o = /^0o[0-7]+$/i,
          i = parseInt,
          u = "object" == typeof t && t && t.Object === Object && t,
          c = "object" == typeof self && self && self.Object === Object && self,
          s = u || c || Function("return this")(),
          l = Object.prototype.toString,
          f = Math.max,
          d = Math.min,
          p = function p() {
        return s.Date.now();
      };

      function h(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      function m(e) {
        if ("number" == typeof e) return e;
        if (function (e) {
          return "symbol" == typeof e || function (e) {
            return !!e && "object" == typeof e;
          }(e) && "[object Symbol]" == l.call(e);
        }(e)) return NaN;

        if (h(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = h(t) ? t + "" : t;
        }

        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(r, "");
        var u = a.test(e);
        return u || o.test(e) ? i(e.slice(2), u ? 2 : 8) : n.test(e) ? NaN : +e;
      }

      e.exports = function (e, t, r) {
        var n,
            a,
            o,
            i,
            u,
            c,
            s = 0,
            l = !1,
            y = !1,
            b = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");

        function g(t) {
          var r = n,
              o = a;
          return n = a = void 0, s = t, i = e.apply(o, r);
        }

        function v(e) {
          return s = e, u = setTimeout(_, t), l ? g(e) : i;
        }

        function C(e) {
          var r = e - c;
          return void 0 === c || r >= t || r < 0 || y && e - s >= o;
        }

        function _() {
          var e = p();
          if (C(e)) return w(e);
          u = setTimeout(_, function (e) {
            var r = t - (e - c);
            return y ? d(r, o - (e - s)) : r;
          }(e));
        }

        function w(e) {
          return u = void 0, b && n ? g(e) : (n = a = void 0, i);
        }

        function S() {
          var e = p(),
              r = C(e);

          if (n = arguments, a = this, c = e, r) {
            if (void 0 === u) return v(c);
            if (y) return u = setTimeout(_, t), g(c);
          }

          return void 0 === u && (u = setTimeout(_, t)), i;
        }

        return t = m(t) || 0, h(r) && (l = !!r.leading, o = (y = "maxWait" in r) ? f(m(r.maxWait) || 0, t) : o, b = "trailing" in r ? !!r.trailing : b), S.cancel = function () {
          void 0 !== u && clearTimeout(u), s = 0, n = c = a = u = void 0;
        }, S.flush = function () {
          return void 0 === u ? i : w(p());
        }, S;
      };
    }).call(this, r(3));
  }, function (e, t, r) {
    (function (e, r) {
      var n = "[object Arguments]",
          a = "[object Map]",
          o = "[object Object]",
          i = "[object Set]",
          u = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          c = /^\w*$/,
          s = /^\./,
          l = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          f = /\\(\\)?/g,
          d = /^\[object .+?Constructor\]$/,
          p = /^(?:0|[1-9]\d*)$/,
          h = {};
      h["[object Float32Array]"] = h["[object Float64Array]"] = h["[object Int8Array]"] = h["[object Int16Array]"] = h["[object Int32Array]"] = h["[object Uint8Array]"] = h["[object Uint8ClampedArray]"] = h["[object Uint16Array]"] = h["[object Uint32Array]"] = !0, h[n] = h["[object Array]"] = h["[object ArrayBuffer]"] = h["[object Boolean]"] = h["[object DataView]"] = h["[object Date]"] = h["[object Error]"] = h["[object Function]"] = h[a] = h["[object Number]"] = h[o] = h["[object RegExp]"] = h[i] = h["[object String]"] = h["[object WeakMap]"] = !1;

      var m = "object" == typeof e && e && e.Object === Object && e,
          y = "object" == typeof self && self && self.Object === Object && self,
          b = m || y || Function("return this")(),
          g = t && !t.nodeType && t,
          v = g && "object" == typeof r && r && !r.nodeType && r,
          C = v && v.exports === g && m.process,
          _ = function () {
        try {
          return C && C.binding("util");
        } catch (e) {}
      }(),
          w = _ && _.isTypedArray;

      function S(e, t, r, n) {
        var a = -1,
            o = e ? e.length : 0;

        for (n && o && (r = e[++a]); ++a < o;) {
          r = t(r, e[a], a, e);
        }

        return r;
      }

      function j(e, t) {
        for (var r = -1, n = e ? e.length : 0; ++r < n;) {
          if (t(e[r], r, e)) return !0;
        }

        return !1;
      }

      function x(e, t, r, n, a) {
        return a(e, function (e, a, o) {
          r = n ? (n = !1, e) : t(r, e, a, o);
        }), r;
      }

      function N(e) {
        var t = !1;
        if (null != e && "function" != typeof e.toString) try {
          t = !!(e + "");
        } catch (e) {}
        return t;
      }

      function O(e) {
        var t = -1,
            r = Array(e.size);
        return e.forEach(function (e, n) {
          r[++t] = [n, e];
        }), r;
      }

      function k(e) {
        var t = -1,
            r = Array(e.size);
        return e.forEach(function (e) {
          r[++t] = e;
        }), r;
      }

      var E,
          T,
          I,
          A = Array.prototype,
          D = Function.prototype,
          P = Object.prototype,
          F = b["__core-js_shared__"],
          M = (E = /[^.]+$/.exec(F && F.keys && F.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "",
          L = D.toString,
          R = P.hasOwnProperty,
          z = P.toString,
          B = RegExp("^" + L.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          G = b.Symbol,
          $ = b.Uint8Array,
          V = P.propertyIsEnumerable,
          K = A.splice,
          U = (T = Object.keys, I = Object, function (e) {
        return T(I(e));
      }),
          q = Ne(b, "DataView"),
          H = Ne(b, "Map"),
          W = Ne(b, "Promise"),
          J = Ne(b, "Set"),
          Z = Ne(b, "WeakMap"),
          Q = Ne(Object, "create"),
          Y = Pe(q),
          X = Pe(H),
          ee = Pe(W),
          te = Pe(J),
          re = Pe(Z),
          ne = G ? G.prototype : void 0,
          ae = ne ? ne.valueOf : void 0,
          oe = ne ? ne.toString : void 0;

      function ie(e) {
        var t = -1,
            r = e ? e.length : 0;

        for (this.clear(); ++t < r;) {
          var n = e[t];
          this.set(n[0], n[1]);
        }
      }

      function ue(e) {
        var t = -1,
            r = e ? e.length : 0;

        for (this.clear(); ++t < r;) {
          var n = e[t];
          this.set(n[0], n[1]);
        }
      }

      function ce(e) {
        var t = -1,
            r = e ? e.length : 0;

        for (this.clear(); ++t < r;) {
          var n = e[t];
          this.set(n[0], n[1]);
        }
      }

      function se(e) {
        var t = -1,
            r = e ? e.length : 0;

        for (this.__data__ = new ce(); ++t < r;) {
          this.add(e[t]);
        }
      }

      function le(e) {
        this.__data__ = new ue(e);
      }

      function fe(e, t) {
        var r = Re(e) || Le(e) ? function (e, t) {
          for (var r = -1, n = Array(e); ++r < e;) {
            n[r] = t(r);
          }

          return n;
        }(e.length, String) : [],
            n = r.length,
            a = !!n;

        for (var o in e) {
          !t && !R.call(e, o) || a && ("length" == o || ke(o, n)) || r.push(o);
        }

        return r;
      }

      function de(e, t) {
        for (var r = e.length; r--;) {
          if (Me(e[r][0], t)) return r;
        }

        return -1;
      }

      ie.prototype.clear = function () {
        this.__data__ = Q ? Q(null) : {};
      }, ie.prototype.delete = function (e) {
        return this.has(e) && delete this.__data__[e];
      }, ie.prototype.get = function (e) {
        var t = this.__data__;

        if (Q) {
          var r = t[e];
          return "__lodash_hash_undefined__" === r ? void 0 : r;
        }

        return R.call(t, e) ? t[e] : void 0;
      }, ie.prototype.has = function (e) {
        var t = this.__data__;
        return Q ? void 0 !== t[e] : R.call(t, e);
      }, ie.prototype.set = function (e, t) {
        return this.__data__[e] = Q && void 0 === t ? "__lodash_hash_undefined__" : t, this;
      }, ue.prototype.clear = function () {
        this.__data__ = [];
      }, ue.prototype.delete = function (e) {
        var t = this.__data__,
            r = de(t, e);
        return !(r < 0) && (r == t.length - 1 ? t.pop() : K.call(t, r, 1), !0);
      }, ue.prototype.get = function (e) {
        var t = this.__data__,
            r = de(t, e);
        return r < 0 ? void 0 : t[r][1];
      }, ue.prototype.has = function (e) {
        return de(this.__data__, e) > -1;
      }, ue.prototype.set = function (e, t) {
        var r = this.__data__,
            n = de(r, e);
        return n < 0 ? r.push([e, t]) : r[n][1] = t, this;
      }, ce.prototype.clear = function () {
        this.__data__ = {
          hash: new ie(),
          map: new (H || ue)(),
          string: new ie()
        };
      }, ce.prototype.delete = function (e) {
        return xe(this, e).delete(e);
      }, ce.prototype.get = function (e) {
        return xe(this, e).get(e);
      }, ce.prototype.has = function (e) {
        return xe(this, e).has(e);
      }, ce.prototype.set = function (e, t) {
        return xe(this, e).set(e, t), this;
      }, se.prototype.add = se.prototype.push = function (e) {
        return this.__data__.set(e, "__lodash_hash_undefined__"), this;
      }, se.prototype.has = function (e) {
        return this.__data__.has(e);
      }, le.prototype.clear = function () {
        this.__data__ = new ue();
      }, le.prototype.delete = function (e) {
        return this.__data__.delete(e);
      }, le.prototype.get = function (e) {
        return this.__data__.get(e);
      }, le.prototype.has = function (e) {
        return this.__data__.has(e);
      }, le.prototype.set = function (e, t) {
        var r = this.__data__;

        if (r instanceof ue) {
          var n = r.__data__;
          if (!H || n.length < 199) return n.push([e, t]), this;
          r = this.__data__ = new ce(n);
        }

        return r.set(e, t), this;
      };

      var pe,
          me = (pe = function pe(e, t) {
        return e && ye(e, t, qe);
      }, function (e, t) {
        if (null == e) return e;
        if (!ze(e)) return pe(e, t);

        for (var r = e.length, n = -1, a = Object(e); ++n < r && !1 !== t(a[n], n, a);) {
          ;
        }

        return e;
      }),
          ye = function (e) {
        return function (t, r, n) {
          for (var a = -1, o = Object(t), i = n(t), u = i.length; u--;) {
            var c = i[e ? u : ++a];
            if (!1 === r(o[c], c, o)) break;
          }

          return t;
        };
      }();

      function be(e, t) {
        for (var r = 0, n = (t = Ee(t, e) ? [t] : Se(t)).length; null != e && r < n;) {
          e = e[De(t[r++])];
        }

        return r && r == n ? e : void 0;
      }

      function ge(e, t) {
        return null != e && t in Object(e);
      }

      function ve(e, t, r, u, c) {
        return e === t || (null == e || null == t || !$e(e) && !Ve(t) ? e != e && t != t : function (e, t, r, u, c, s) {
          var l = Re(e),
              f = Re(t),
              d = "[object Array]",
              p = "[object Array]";
          l || (d = (d = Oe(e)) == n ? o : d);
          f || (p = (p = Oe(t)) == n ? o : p);
          var h = d == o && !N(e),
              m = p == o && !N(t),
              y = d == p;
          if (y && !h) return s || (s = new le()), l || Ue(e) ? je(e, t, r, u, c, s) : function (e, t, r, n, o, u, c) {
            switch (r) {
              case "[object DataView]":
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                e = e.buffer, t = t.buffer;

              case "[object ArrayBuffer]":
                return !(e.byteLength != t.byteLength || !n(new $(e), new $(t)));

              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return Me(+e, +t);

              case "[object Error]":
                return e.name == t.name && e.message == t.message;

              case "[object RegExp]":
              case "[object String]":
                return e == t + "";

              case a:
                var s = O;

              case i:
                var l = 2 & u;
                if (s || (s = k), e.size != t.size && !l) return !1;
                var f = c.get(e);
                if (f) return f == t;
                u |= 1, c.set(e, t);
                var d = je(s(e), s(t), n, o, u, c);
                return c.delete(e), d;

              case "[object Symbol]":
                if (ae) return ae.call(e) == ae.call(t);
            }

            return !1;
          }(e, t, d, r, u, c, s);

          if (!(2 & c)) {
            var b = h && R.call(e, "__wrapped__"),
                g = m && R.call(t, "__wrapped__");

            if (b || g) {
              var v = b ? e.value() : e,
                  C = g ? t.value() : t;
              return s || (s = new le()), r(v, C, u, c, s);
            }
          }

          if (!y) return !1;
          return s || (s = new le()), function (e, t, r, n, a, o) {
            var i = 2 & a,
                u = qe(e),
                c = u.length,
                s = qe(t).length;
            if (c != s && !i) return !1;
            var l = c;

            for (; l--;) {
              var f = u[l];
              if (!(i ? f in t : R.call(t, f))) return !1;
            }

            var d = o.get(e);
            if (d && o.get(t)) return d == t;
            var p = !0;
            o.set(e, t), o.set(t, e);
            var h = i;

            for (; ++l < c;) {
              f = u[l];
              var m = e[f],
                  y = t[f];
              if (n) var b = i ? n(y, m, f, t, e, o) : n(m, y, f, e, t, o);

              if (!(void 0 === b ? m === y || r(m, y, n, a, o) : b)) {
                p = !1;
                break;
              }

              h || (h = "constructor" == f);
            }

            if (p && !h) {
              var g = e.constructor,
                  v = t.constructor;
              g == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof g && g instanceof g && "function" == typeof v && v instanceof v || (p = !1);
            }

            return o.delete(e), o.delete(t), p;
          }(e, t, r, u, c, s);
        }(e, t, ve, r, u, c));
      }

      function Ce(e) {
        return !(!$e(e) || function (e) {
          return !!M && M in e;
        }(e)) && (Be(e) || N(e) ? B : d).test(Pe(e));
      }

      function _e(e) {
        return "function" == typeof e ? e : null == e ? He : "object" == typeof e ? Re(e) ? function (e, t) {
          if (Ee(e) && Te(t)) return Ie(De(e), t);
          return function (r) {
            var n = function (e, t, r) {
              var n = null == e ? void 0 : be(e, t);
              return void 0 === n ? r : n;
            }(r, e);

            return void 0 === n && n === t ? function (e, t) {
              return null != e && function (e, t, r) {
                t = Ee(t, e) ? [t] : Se(t);
                var n,
                    a = -1,
                    o = t.length;

                for (; ++a < o;) {
                  var i = De(t[a]);
                  if (!(n = null != e && r(e, i))) break;
                  e = e[i];
                }

                if (n) return n;
                return !!(o = e ? e.length : 0) && Ge(o) && ke(i, o) && (Re(e) || Le(e));
              }(e, t, ge);
            }(r, e) : ve(t, n, void 0, 3);
          };
        }(e[0], e[1]) : function (e) {
          var t = function (e) {
            var t = qe(e),
                r = t.length;

            for (; r--;) {
              var n = t[r],
                  a = e[n];
              t[r] = [n, a, Te(a)];
            }

            return t;
          }(e);

          if (1 == t.length && t[0][2]) return Ie(t[0][0], t[0][1]);
          return function (r) {
            return r === e || function (e, t, r, n) {
              var a = r.length,
                  o = a,
                  i = !n;
              if (null == e) return !o;

              for (e = Object(e); a--;) {
                var u = r[a];
                if (i && u[2] ? u[1] !== e[u[0]] : !(u[0] in e)) return !1;
              }

              for (; ++a < o;) {
                var c = (u = r[a])[0],
                    s = e[c],
                    l = u[1];

                if (i && u[2]) {
                  if (void 0 === s && !(c in e)) return !1;
                } else {
                  var f = new le();
                  if (n) var d = n(s, l, c, e, t, f);
                  if (!(void 0 === d ? ve(l, s, n, 3, f) : d)) return !1;
                }
              }

              return !0;
            }(r, e, t);
          };
        }(e) : Ee(t = e) ? (r = De(t), function (e) {
          return null == e ? void 0 : e[r];
        }) : function (e) {
          return function (t) {
            return be(t, e);
          };
        }(t);
        var t, r;
      }

      function we(e) {
        if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || P, t !== n) return U(e);
        var t,
            r,
            n,
            a = [];

        for (var o in Object(e)) {
          R.call(e, o) && "constructor" != o && a.push(o);
        }

        return a;
      }

      function Se(e) {
        return Re(e) ? e : Ae(e);
      }

      function je(e, t, r, n, a, o) {
        var i = 2 & a,
            u = e.length,
            c = t.length;
        if (u != c && !(i && c > u)) return !1;
        var s = o.get(e);
        if (s && o.get(t)) return s == t;
        var l = -1,
            f = !0,
            d = 1 & a ? new se() : void 0;

        for (o.set(e, t), o.set(t, e); ++l < u;) {
          var p = e[l],
              h = t[l];
          if (n) var m = i ? n(h, p, l, t, e, o) : n(p, h, l, e, t, o);

          if (void 0 !== m) {
            if (m) continue;
            f = !1;
            break;
          }

          if (d) {
            if (!j(t, function (e, t) {
              if (!d.has(t) && (p === e || r(p, e, n, a, o))) return d.add(t);
            })) {
              f = !1;
              break;
            }
          } else if (p !== h && !r(p, h, n, a, o)) {
            f = !1;
            break;
          }
        }

        return o.delete(e), o.delete(t), f;
      }

      function xe(e, t) {
        var r,
            n,
            a = e.__data__;
        return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? a["string" == typeof t ? "string" : "hash"] : a.map;
      }

      function Ne(e, t) {
        var r = function (e, t) {
          return null == e ? void 0 : e[t];
        }(e, t);

        return Ce(r) ? r : void 0;
      }

      var Oe = function Oe(e) {
        return z.call(e);
      };

      function ke(e, t) {
        return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || p.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }

      function Ee(e, t) {
        if (Re(e)) return !1;
        var r = typeof e;
        return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Ke(e)) || c.test(e) || !u.test(e) || null != t && e in Object(t);
      }

      function Te(e) {
        return e == e && !$e(e);
      }

      function Ie(e, t) {
        return function (r) {
          return null != r && r[e] === t && (void 0 !== t || e in Object(r));
        };
      }

      (q && "[object DataView]" != Oe(new q(new ArrayBuffer(1))) || H && Oe(new H()) != a || W && "[object Promise]" != Oe(W.resolve()) || J && Oe(new J()) != i || Z && "[object WeakMap]" != Oe(new Z())) && (Oe = function Oe(e) {
        var t = z.call(e),
            r = t == o ? e.constructor : void 0,
            n = r ? Pe(r) : void 0;
        if (n) switch (n) {
          case Y:
            return "[object DataView]";

          case X:
            return a;

          case ee:
            return "[object Promise]";

          case te:
            return i;

          case re:
            return "[object WeakMap]";
        }
        return t;
      });
      var Ae = Fe(function (e) {
        var t;
        e = null == (t = e) ? "" : function (e) {
          if ("string" == typeof e) return e;
          if (Ke(e)) return oe ? oe.call(e) : "";
          var t = e + "";
          return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
        }(t);
        var r = [];
        return s.test(e) && r.push(""), e.replace(l, function (e, t, n, a) {
          r.push(n ? a.replace(f, "$1") : t || e);
        }), r;
      });

      function De(e) {
        if ("string" == typeof e || Ke(e)) return e;
        var t = e + "";
        return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
      }

      function Pe(e) {
        if (null != e) {
          try {
            return L.call(e);
          } catch (e) {}

          try {
            return e + "";
          } catch (e) {}
        }

        return "";
      }

      function Fe(e, t) {
        if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");

        var r = function r() {
          var n = arguments,
              a = t ? t.apply(this, n) : n[0],
              o = r.cache;
          if (o.has(a)) return o.get(a);
          var i = e.apply(this, n);
          return r.cache = o.set(a, i), i;
        };

        return r.cache = new (Fe.Cache || ce)(), r;
      }

      function Me(e, t) {
        return e === t || e != e && t != t;
      }

      function Le(e) {
        return function (e) {
          return Ve(e) && ze(e);
        }(e) && R.call(e, "callee") && (!V.call(e, "callee") || z.call(e) == n);
      }

      Fe.Cache = ce;
      var Re = Array.isArray;

      function ze(e) {
        return null != e && Ge(e.length) && !Be(e);
      }

      function Be(e) {
        var t = $e(e) ? z.call(e) : "";
        return "[object Function]" == t || "[object GeneratorFunction]" == t;
      }

      function Ge(e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
      }

      function $e(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      function Ve(e) {
        return !!e && "object" == typeof e;
      }

      function Ke(e) {
        return "symbol" == typeof e || Ve(e) && "[object Symbol]" == z.call(e);
      }

      var Ue = w ? function (e) {
        return function (t) {
          return e(t);
        };
      }(w) : function (e) {
        return Ve(e) && Ge(e.length) && !!h[z.call(e)];
      };

      function qe(e) {
        return ze(e) ? fe(e) : we(e);
      }

      function He(e) {
        return e;
      }

      r.exports = function (e, t, r) {
        var n = Re(e) ? S : x,
            a = arguments.length < 3;
        return n(e, _e(t), r, a, me);
      };
    }).call(this, r(3), r(7)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t) {
    String.prototype.padEnd || (String.prototype.padEnd = function (e, t) {
      return e >>= 0, t = String(void 0 !== t ? t : " "), this.length > e ? String(this) : ((e -= this.length) > t.length && (t += t.repeat(e / t.length)), String(this) + t.slice(0, e));
    });
  }, function (e, t, r) {
    function n(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function a(e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }

    function o(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, r = new Array(e.length); t < e.length; t++) {
            r[t] = e[t];
          }

          return r;
        }
      }(e) || a(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function i(e) {
      if (Array.isArray(e)) return e;
    }

    function u() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }

    function c(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function s(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function l(e) {
      return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function f(e) {
      return (f = "function" == typeof Symbol && "symbol" === l(Symbol.iterator) ? function (e) {
        return l(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : l(e);
      })(e);
    }

    function d(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function p(e) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function h(e, t) {
      return (h = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    r.r(t);

    var m = r(0),
        y = r.n(m),
        b = r(5),
        g = r.n(b),
        v = r(4),
        C = r.n(v),
        _ = r(6),
        w = r.n(_),
        S = r(2),
        j = r.n(S),
        x = r(1),
        N = r.n(x);

    r(8);

    function O(e, t) {
      return i(e) || function (e, t) {
        var r = [],
            n = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, u = e[Symbol.iterator](); !(n = (i = u.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            n || null == u.return || u.return();
          } finally {
            if (a) throw o;
          }
        }

        return r;
      }(e, t) || u();
    }

    var k = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "(..) ........", 0, ["11", "221", "223", "261", "264", "2652", "280", "2905", "291", "2920", "2966", "299", "341", "342", "343", "351", "376", "379", "381", "3833", "385", "387", "388"]], ["Armenia", ["asia", "ex-ussr"], "am", "374"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "(..) .... ....", 0, ["2", "3", "4", "7", "8", "02", "03", "04", "07", "08"]], ["Austria", ["europe", "eu-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."], ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "eu-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "..-........."], ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225", ".. .. .. .."], ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"], ["Czech Republic", ["europe", "eu-union"], "cz", "420"], ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."], ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"], ["Ghana", ["africa"], "gh", "233"], ["Greece", ["europe", "eu-union"], "gr", "30"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", ".... ...."], ["Hungary", ["europe", "eu-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "... ...."], ["India", ["asia"], "in", "91", ".....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98", "... ... ...."], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."], ["Israel", ["middle-east"], "il", "972", "... ... ...."], ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", ".. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "... ...-..-..", 1, ["310", "311", "312", "313", "315", "318", "321", "324", "325", "326", "327", "336", "7172", "73622"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kosovo", ["europe", "ex-yugos"], "xk", "383"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996"], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371"], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"], ["Luxembourg", ["europe", "eu-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe", "ex-yugos"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "eu-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52", "... ... ....", 0, ["55", "81", "33", "656", "664", "998", "774", "229"]], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe", "ex-yugos"], "me", "382"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["North Korea", ["asia"], "kp", "850"], ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", ".... ......."], ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."], ["Portugal", ["europe", "eu-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "eu-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe", "ex-yugos"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "....-...."], ["Slovakia", ["europe", "eu-union"], "sk", "421"], ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."], ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Tuvalu", ["asia"], "tv", "688"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"], ["United States", ["america", "north-america"], "us", "1", "(...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998"], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]],
        E = [["American Samoa", ["oceania"], "as", "1684"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Cook Islands", ["oceania"], "ck", "682"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Gibraltar", ["europe"], "gi", "350"], ["Greenland", ["america"], "gl", "299"], ["Jersey", ["europe", "eu-union"], "je", "44", ".... ......"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Tokelau", ["oceania"], "tk", "690"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Wallis and Futuna", ["oceania"], "wf", "681"]];

    function T(e, t, r, n, a) {
      return !r || a ? e + "".padEnd(t.length, ".") + " " + n : e + "".padEnd(t.length, ".") + " " + r;
    }

    function I(e, t, r, a, i) {
      var u,
          c,
          s = [];
      return c = !0 === t, [(u = []).concat.apply(u, o(e.map(function (e) {
        var o = {
          name: e[0],
          regions: e[1],
          iso2: e[2],
          countryCode: e[3],
          dialCode: e[3],
          format: T(r, e[3], e[4], a, i),
          priority: e[5] || 0
        },
            u = [];
        return e[6] && e[6].map(function (t) {
          var r = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {},
                  a = Object.keys(r);
              "function" == typeof Object.getOwnPropertySymbols && (a = a.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
                return Object.getOwnPropertyDescriptor(r, e).enumerable;
              }))), a.forEach(function (t) {
                n(e, t, r[t]);
              });
            }

            return e;
          }({}, o);

          r.dialCode = e[3] + t, r.isAreaCode = !0, r.areaCodeLength = t.length, u.push(r);
        }), u.length > 0 ? (o.mainCode = !0, c || "Array" === t.constructor.name && t.includes(e[2]) ? (o.hasAreaCodes = !0, [o].concat(u)) : (s = s.concat(u), [o])) : [o];
      }))), s];
    }

    function A(e, t, r, n) {
      if (null !== r) {
        var a = Object.keys(r),
            o = Object.values(r);
        a.forEach(function (r, a) {
          if (n) return e.push([r, o[a]]);
          var i = e.findIndex(function (e) {
            return e[0] === r;
          });

          if (-1 === i) {
            var u = [r];
            u[t] = o[a], e.push(u);
          } else e[i][t] = o[a];
        });
      }
    }

    function D(e, t) {
      return 0 === t.length ? e : e.map(function (e) {
        var r = t.findIndex(function (t) {
          return t[0] === e[2];
        });
        if (-1 === r) return e;
        var n = t[r];
        return n[1] && (e[4] = n[1]), n[3] && (e[5] = n[3]), n[2] && (e[6] = n[2]), e;
      });
    }

    var P = function e(t, r, n, a, i, u, s, l, f, d, p, h, m, y) {
      c(this, e), this.filterRegions = function (e, t) {
        if ("string" == typeof e) {
          var r = e;
          return t.filter(function (e) {
            return e.regions.some(function (e) {
              return e === r;
            });
          });
        }

        return t.filter(function (t) {
          return e.map(function (e) {
            return t.regions.some(function (t) {
              return t === e;
            });
          }).some(function (e) {
            return e;
          });
        });
      }, this.sortTerritories = function (e, t) {
        var r = [].concat(o(e), o(t));
        return r.sort(function (e, t) {
          return e.name < t.name ? -1 : e.name > t.name ? 1 : 0;
        }), r;
      }, this.getFilteredCountryList = function (e, t, r) {
        return 0 === e.length ? t : r ? e.map(function (e) {
          var r = t.find(function (t) {
            return t.iso2 === e;
          });
          if (r) return r;
        }).filter(function (e) {
          return e;
        }) : t.filter(function (t) {
          return e.some(function (e) {
            return e === t.iso2;
          });
        });
      }, this.localizeCountries = function (e, t, r) {
        for (var n = 0; n < e.length; n++) {
          void 0 !== t[e[n].iso2] ? e[n].localName = t[e[n].iso2] : void 0 !== t[e[n].name] && (e[n].localName = t[e[n].name]);
        }

        return r || e.sort(function (e, t) {
          return e.localName < t.localName ? -1 : e.localName > t.localName ? 1 : 0;
        }), e;
      }, this.getCustomAreas = function (e, t) {
        for (var r = [], n = 0; n < t.length; n++) {
          var a = JSON.parse(JSON.stringify(e));
          a.dialCode += t[n], r.push(a);
        }

        return r;
      }, this.excludeCountries = function (e, t) {
        return 0 === t.length ? e : e.filter(function (e) {
          return !t.includes(e.iso2);
        });
      };

      var b = function (e, t, r) {
        var n = [];
        return A(n, 1, e, !0), A(n, 3, t), A(n, 2, r), n;
      }(l, f, d),
          g = D(JSON.parse(JSON.stringify(k)), b),
          v = D(JSON.parse(JSON.stringify(E)), b),
          C = O(I(g, t, h, m, y), 2),
          _ = C[0],
          w = C[1];

      if (r) {
        var S = O(I(v, t, h, m, y), 2),
            j = S[0];
        S[1];
        _ = this.sortTerritories(j, _);
      }

      n && (_ = this.filterRegions(n, _)), this.onlyCountries = this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(a, _, s.includes("onlyCountries")), u), p, s.includes("onlyCountries")), this.preferredCountries = 0 === i.length ? [] : this.localizeCountries(this.getFilteredCountryList(i, _, s.includes("preferredCountries")), p, s.includes("preferredCountries")), this.hiddenAreaCodes = this.excludeCountries(this.getFilteredCountryList(a, w), u);
    },
        F = function (e) {
      function t(e) {
        var r;
        c(this, t), (r = function (e, t) {
          return !t || "object" !== f(t) && "function" != typeof t ? d(e) : t;
        }(this, p(t).call(this, e))).getProbableCandidate = C()(function (e) {
          return e && 0 !== e.length ? r.state.onlyCountries.filter(function (t) {
            return j()(t.name.toLowerCase(), e.toLowerCase());
          }, d(d(r)))[0] : null;
        }), r.guessSelectedCountry = C()(function (e, t, n, a) {
          var o;
          if (!1 === r.props.enableAreaCodes && (a.some(function (t) {
            if (j()(e, t.dialCode)) return n.some(function (e) {
              if (t.iso2 === e.iso2 && e.mainCode) return o = e, !0;
            }), !0;
          }), o)) return o;
          var i = n.find(function (e) {
            return e.iso2 == t;
          });
          if ("" === e.trim()) return i;
          var u = n.reduce(function (t, r) {
            if (j()(e, r.dialCode)) {
              if (r.dialCode.length > t.dialCode.length) return r;
              if (r.dialCode.length === t.dialCode.length && r.priority < t.priority) return r;
            }

            return t;
          }, {
            dialCode: "",
            priority: 10001
          }, d(d(r)));
          return u.name ? u : i;
        }), r.updateCountry = function (e) {
          var t,
              n = r.state.onlyCountries;
          (t = e.indexOf(0) >= "0" && e.indexOf(0) <= "9" ? n.find(function (t) {
            return t.dialCode == +e;
          }) : n.find(function (t) {
            return t.iso2 == e;
          })) && t.dialCode && r.setState({
            selectedCountry: t,
            formattedNumber: r.props.disableCountryCode ? "" : r.formatNumber(t.dialCode, t)
          });
        }, r.scrollTo = function (e, t) {
          if (e) {
            var n = r.dropdownRef;

            if (n && document.body) {
              var a = n.offsetHeight,
                  o = n.getBoundingClientRect().top + document.body.scrollTop,
                  i = o + a,
                  u = e,
                  c = u.getBoundingClientRect(),
                  s = u.offsetHeight,
                  l = c.top + document.body.scrollTop,
                  f = l + s,
                  d = l - o + n.scrollTop,
                  p = a / 2 - s / 2;
              if (r.props.enableSearch ? l < o + 32 : l < o) t && (d -= p), n.scrollTop = d;else if (f > i) {
                t && (d += p);
                var h = a - s;
                n.scrollTop = d - h;
              }
            }
          }
        }, r.scrollToTop = function () {
          var e = r.dropdownRef;
          e && document.body && (e.scrollTop = 0);
        }, r.formatNumber = function (e, t) {
          if (!t) return e;
          var n,
              o = t.format,
              c = r.props,
              s = c.disableCountryCode,
              l = c.enableAreaCodeStretch,
              f = c.enableLongNumbers,
              d = c.autoFormat;
          if (s ? ((n = o.split(" ")).shift(), n = n.join(" ")) : l && t.isAreaCode ? ((n = o.split(" "))[1] = n[1].replace(/\.+/, "".padEnd(t.areaCodeLength, ".")), n = n.join(" ")) : n = o, !e || 0 === e.length) return s ? "" : r.props.prefix;
          if (e && e.length < 2 || !n || !d) return s ? e : r.props.prefix + e;
          var p,
              h = w()(n, function (e, t) {
            if (0 === e.remainingText.length) return e;
            if ("." !== t) return {
              formattedText: e.formattedText + t,
              remainingText: e.remainingText
            };
            var r,
                n = i(r = e.remainingText) || a(r) || u(),
                o = n[0],
                c = n.slice(1);
            return {
              formattedText: e.formattedText + o,
              remainingText: c
            };
          }, {
            formattedText: "",
            remainingText: e.split("")
          });
          return (p = f ? h.formattedText + h.remainingText.join("") : h.formattedText).includes("(") && !p.includes(")") && (p += ")"), p;
        }, r.cursorToEnd = function () {
          var e = r.numberInputRef;
          e.focus();
          var t = e.value.length;
          ")" === e.value.charAt(t - 1) && (t -= 1), e.setSelectionRange(t, t);
        }, r.getElement = function (e) {
          return r["flag_no_".concat(e)];
        }, r.getCountryData = function () {
          return r.state.selectedCountry ? {
            name: r.state.selectedCountry.name || "",
            dialCode: r.state.selectedCountry.dialCode || "",
            countryCode: r.state.selectedCountry.iso2 || "",
            format: r.state.selectedCountry.format || ""
          } : {};
        }, r.handleFlagDropdownClick = function (e) {
          if (e.preventDefault(), r.state.showDropdown || !r.props.disabled) {
            var t = r.state,
                n = t.preferredCountries,
                a = t.selectedCountry,
                o = n.concat(r.state.onlyCountries).findIndex(function (e) {
              return e.dialCode === a.dialCode && e.iso2 === a.iso2;
            });
            r.setState({
              showDropdown: !r.state.showDropdown,
              highlightCountryIndex: o
            }, function () {
              r.state.showDropdown && r.scrollTo(r.getElement(r.state.highlightCountryIndex));
            });
          }
        }, r.handleInput = function (e) {
          var t = e.target.value,
              n = r.props,
              a = n.prefix,
              o = n.onChange,
              i = r.props.disableCountryCode ? "" : a,
              u = r.state.selectedCountry,
              c = r.state.freezeSelection;

          if (!r.props.countryCodeEditable) {
            var s = a + (u.hasAreaCodes ? r.state.onlyCountries.find(function (e) {
              return e.iso2 === u.iso2 && e.mainCode;
            }).dialCode : u.dialCode);
            if (t.slice(0, s.length) !== s) return;
          }

          if (t === a) return o && o("", r.getCountryData(), e, ""), r.setState({
            formattedNumber: ""
          });

          if (t.replace(/\D/g, "").length > 15) {
            if (!1 === r.props.enableLongNumbers) return;
            if ("number" == typeof r.props.enableLongNumbers && t.replace(/\D/g, "").length > r.props.enableLongNumbers) return;
          }

          if (t !== r.state.formattedNumber) {
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;
            var l = r.props.country,
                f = r.state,
                d = f.onlyCountries,
                p = f.selectedCountry,
                h = f.hiddenAreaCodes;

            if (o && e.persist(), t.length > 0) {
              var m = t.replace(/\D/g, "");
              (!r.state.freezeSelection || p.dialCode.length > m.length) && (u = r.props.disableCountryGuess ? p : r.guessSelectedCountry(m.substring(0, 6), l, d, h) || p, c = !1), i = r.formatNumber(m, u), u = u.dialCode ? u : p;
            }

            var y = e.target.selectionStart,
                b = r.state.formattedNumber,
                g = i.length - b.length;
            r.setState({
              formattedNumber: i,
              freezeSelection: c,
              selectedCountry: u
            }, function () {
              g > 0 && (y -= g), ")" == i.charAt(i.length - 1) ? r.numberInputRef.setSelectionRange(i.length - 1, i.length - 1) : y > 0 && b.length >= i.length && r.numberInputRef.setSelectionRange(y, y), o && o(i.replace(/[^0-9]+/g, ""), r.getCountryData(), e, i);
            });
          }
        }, r.handleInputClick = function (e) {
          r.setState({
            showDropdown: !1
          }), r.props.onClick && r.props.onClick(e, r.getCountryData());
        }, r.handleDoubleClick = function (e) {
          var t = e.target.value.length;
          e.target.setSelectionRange(0, t);
        }, r.handleFlagItemClick = function (e, t) {
          var n = r.state.selectedCountry,
              a = r.state.onlyCountries.find(function (t) {
            return t == e;
          });

          if (a) {
            var o = r.state.formattedNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""),
                i = o.length > 1 ? o.replace(n.dialCode, a.dialCode) : a.dialCode,
                u = r.formatNumber(i.replace(/\D/g, ""), a);
            r.setState({
              showDropdown: !1,
              selectedCountry: a,
              freezeSelection: !0,
              formattedNumber: u
            }, function () {
              r.cursorToEnd(), r.props.onChange && r.props.onChange(u.replace(/[^0-9]+/g, ""), r.getCountryData(), t, u);
            });
          }
        }, r.handleInputFocus = function (e) {
          r.numberInputRef && r.numberInputRef.value === r.props.prefix && r.state.selectedCountry && !r.props.disableCountryCode && r.setState({
            formattedNumber: r.props.prefix + r.state.selectedCountry.dialCode
          }, function () {
            r.props.jumpCursorToEnd && setTimeout(r.cursorToEnd, 0);
          }), r.setState({
            placeholder: ""
          }), r.props.onFocus && r.props.onFocus(e, r.getCountryData()), r.props.jumpCursorToEnd && setTimeout(r.cursorToEnd, 0);
        }, r.handleInputBlur = function (e) {
          e.target.value || r.setState({
            placeholder: r.props.placeholder
          }), r.props.onBlur && r.props.onBlur(e, r.getCountryData());
        }, r.handleInputCopy = function (e) {
          if (r.props.copyNumbersOnly) {
            var t = window.getSelection().toString().replace(/[^0-9]+/g, "");
            e.clipboardData.setData("text/plain", t), e.preventDefault();
          }
        }, r.getHighlightCountryIndex = function (e) {
          var t = r.state.highlightCountryIndex + e;
          return t < 0 || t >= r.state.onlyCountries.length + r.state.preferredCountries.length ? t - e : r.props.enableSearch && t > r.getSearchFilteredCountries().length ? 0 : t;
        }, r.searchCountry = function () {
          var e = r.getProbableCandidate(r.state.queryString) || r.state.onlyCountries[0],
              t = r.state.onlyCountries.findIndex(function (t) {
            return t == e;
          }) + r.state.preferredCountries.length;
          r.scrollTo(r.getElement(t), !0), r.setState({
            queryString: "",
            highlightCountryIndex: t
          });
        }, r.handleKeydown = function (e) {
          var t = r.props.keys,
              n = e.target.className;
          if (n.includes("selected-flag") && e.which === t.ENTER && !r.state.showDropdown) return r.handleFlagDropdownClick(e);
          if (n.includes("form-control") && (e.which === t.ENTER || e.which === t.ESC)) return e.target.blur();

          if (r.state.showDropdown && !r.props.disabled && (!n.includes("search-box") || e.which === t.UP || e.which === t.DOWN || e.which === t.ENTER || e.which === t.ESC && "" === e.target.value)) {
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;

            var a = function a(e) {
              r.setState({
                highlightCountryIndex: r.getHighlightCountryIndex(e)
              }, function () {
                r.scrollTo(r.getElement(r.state.highlightCountryIndex), !0);
              });
            };

            switch (e.which) {
              case t.DOWN:
                a(1);
                break;

              case t.UP:
                a(-1);
                break;

              case t.ENTER:
                r.props.enableSearch ? r.handleFlagItemClick(r.getSearchFilteredCountries()[r.state.highlightCountryIndex] || r.getSearchFilteredCountries()[0], e) : r.handleFlagItemClick([].concat(o(r.state.preferredCountries), o(r.state.onlyCountries))[r.state.highlightCountryIndex], e);
                break;

              case t.ESC:
              case t.TAB:
                r.setState({
                  showDropdown: !1
                }, r.cursorToEnd);
                break;

              default:
                (e.which >= t.A && e.which <= t.Z || e.which === t.SPACE) && r.setState({
                  queryString: r.state.queryString + String.fromCharCode(e.which)
                }, r.state.debouncedQueryStingSearcher);
            }
          }
        }, r.handleInputKeyDown = function (e) {
          var t = r.props,
              n = t.keys,
              a = t.onEnterKeyPress,
              o = t.onKeyDown;
          e.which === n.ENTER && a && a(e), o && o(e);
        }, r.handleClickOutside = function (e) {
          r.dropdownRef && !r.dropdownContainerRef.contains(e.target) && r.state.showDropdown && r.setState({
            showDropdown: !1
          });
        }, r.handleSearchChange = function (e) {
          var t = e.currentTarget.value,
              n = r.state,
              a = n.preferredCountries,
              o = n.selectedCountry,
              i = 0;

          if ("" === t && o) {
            var u = r.state.onlyCountries;
            i = a.concat(u).findIndex(function (e) {
              return e == o;
            }), setTimeout(function () {
              return r.scrollTo(r.getElement(i));
            }, 100);
          }

          r.setState({
            searchValue: t,
            highlightCountryIndex: i
          });
        }, r.getDropdownCountryName = function (e) {
          return e.localName || e.name;
        }, r.getSearchFilteredCountries = function () {
          var e = r.state,
              t = e.preferredCountries,
              n = e.onlyCountries,
              a = e.searchValue,
              i = r.props.enableSearch,
              u = t.concat(n),
              c = a.trim().toLowerCase();

          if (i && c) {
            if (/^\d+$/.test(c)) return u.filter(function (e) {
              var t = e.dialCode;
              return ["".concat(t)].some(function (e) {
                return e.toLowerCase().includes(c);
              });
            });
            var s = u.filter(function (e) {
              var t = e.iso2;
              return ["".concat(t)].some(function (e) {
                return e.toLowerCase().includes(c);
              });
            }),
                l = u.filter(function (e) {
              var t = e.name,
                  r = e.localName;
              e.iso2;
              return ["".concat(t), "".concat(r || "")].some(function (e) {
                return e.toLowerCase().includes(c);
              });
            });
            return r.scrollToTop(), o(new Set([].concat(s, l)));
          }

          return u;
        }, r.getCountryDropdownList = function () {
          var e,
              t = r.state,
              a = t.preferredCountries,
              o = t.highlightCountryIndex,
              i = t.showDropdown,
              u = t.searchValue,
              c = r.props,
              s = c.disableDropdown,
              l = c.prefix,
              f = r.props,
              d = f.enableSearch,
              p = f.searchNotFound,
              h = f.disableSearchIcon,
              m = f.searchClass,
              b = f.searchStyle,
              g = f.searchPlaceholder,
              v = f.autocompleteSearch,
              C = r.getSearchFilteredCountries().map(function (e, t) {
            var n = o === t,
                a = N()({
              country: !0,
              preferred: "us" === e.iso2 || "gb" === e.iso2,
              active: "us" === e.iso2,
              highlight: n
            }),
                i = "flag ".concat(e.iso2);
            return y.a.createElement("li", Object.assign({
              ref: function ref(e) {
                return r["flag_no_".concat(t)] = e;
              },
              key: "flag_no_".concat(t),
              "data-flag-key": "flag_no_".concat(t),
              className: a,
              "data-dial-code": "1",
              tabIndex: s ? "-1" : "0",
              "data-country-code": e.iso2,
              onClick: function onClick(t) {
                return r.handleFlagItemClick(e, t);
              },
              role: "option"
            }, n ? {
              "aria-selected": !0
            } : {}), y.a.createElement("div", {
              className: i
            }), y.a.createElement("span", {
              className: "country-name"
            }, r.getDropdownCountryName(e)), y.a.createElement("span", {
              className: "dial-code"
            }, e.format ? r.formatNumber(e.dialCode, e) : l + e.dialCode));
          }),
              _ = y.a.createElement("li", {
            key: "dashes",
            className: "divider"
          });

          a.length > 0 && (!d || d && !u.trim()) && C.splice(a.length, 0, _);
          var w = N()((n(e = {}, r.props.dropdownClass, !0), n(e, "country-list", !0), n(e, "hide", !i), e));
          return y.a.createElement("ul", {
            ref: function ref(e) {
              return !d && e && e.focus(), r.dropdownRef = e;
            },
            className: w,
            style: r.props.dropdownStyle,
            role: "listbox",
            tabIndex: "0"
          }, d && y.a.createElement("li", {
            className: N()(n({
              search: !0
            }, m, m))
          }, !h && y.a.createElement("span", {
            className: N()(n({
              "search-emoji": !0
            }, "".concat(m, "-emoji"), m)),
            role: "img",
            "aria-label": "Magnifying glass"
          }, "🔎"), y.a.createElement("input", {
            className: N()(n({
              "search-box": !0
            }, "".concat(m, "-box"), m)),
            style: b,
            type: "search",
            placeholder: g,
            autoFocus: !0,
            autoComplete: v ? "on" : "off",
            value: u,
            onChange: r.handleSearchChange
          })), C.length > 0 ? C : y.a.createElement("li", {
            className: "no-entries-message"
          }, y.a.createElement("span", null, p)));
        };
        var s,
            l = new P(e.enableAreaCodes, e.enableTerritories, e.regions, e.onlyCountries, e.preferredCountries, e.excludeCountries, e.preserveOrder, e.masks, e.priority, e.areaCodes, e.localization, e.prefix, e.defaultMask, e.alwaysDefaultMask),
            h = l.onlyCountries,
            m = l.preferredCountries,
            b = l.hiddenAreaCodes,
            v = e.value ? e.value.replace(/\D/g, "") : "";
        s = e.disableInitialCountryGuess ? 0 : v.length > 1 ? r.guessSelectedCountry(v.substring(0, 6), e.country, h, b) || 0 : e.country && h.find(function (t) {
          return t.iso2 == e.country;
        }) || 0;

        var _,
            S = v.length < 2 && s && !j()(v, s.dialCode) ? s.dialCode : "";

        _ = "" === v && 0 === s ? "" : r.formatNumber((e.disableCountryCode ? "" : S) + v, s.name ? s : void 0);
        var x = h.findIndex(function (e) {
          return e == s;
        });
        return r.state = {
          showDropdown: e.showDropdown,
          formattedNumber: _,
          onlyCountries: h,
          preferredCountries: m,
          hiddenAreaCodes: b,
          selectedCountry: s,
          highlightCountryIndex: x,
          queryString: "",
          freezeSelection: !1,
          debouncedQueryStingSearcher: g()(r.searchCountry, 250),
          searchValue: ""
        }, r;
      }

      var r, l;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && h(e, t);
      }(t, e), r = t, (l = [{
        key: "componentDidMount",
        value: function value() {
          document.addEventListener && this.props.enableClickOutside && document.addEventListener("mousedown", this.handleClickOutside);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          document.removeEventListener && this.props.enableClickOutside && document.removeEventListener("mousedown", this.handleClickOutside);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, t, r) {
          e.country !== this.props.country ? this.updateCountry(this.props.country) : e.value !== this.props.value && this.updateFormattedNumber(this.props.value);
        }
      }, {
        key: "updateFormattedNumber",
        value: function value(e) {
          if (null === e) return this.setState({
            selectedCountry: 0,
            formattedNumber: ""
          });
          var t = this.state,
              r = t.onlyCountries,
              n = t.selectedCountry,
              a = t.hiddenAreaCodes,
              o = this.props,
              i = o.country,
              u = o.prefix;
          if ("" === e) return this.setState({
            selectedCountry: n,
            formattedNumber: ""
          });
          var c,
              s,
              l = e.replace(/\D/g, "");
          if (n && j()(e, u + n.dialCode)) s = this.formatNumber(l, n), this.setState({
            formattedNumber: s
          });else {
            var f = (c = this.props.disableCountryGuess ? n : this.guessSelectedCountry(l.substring(0, 6), i, r, a) || n) && j()(l, u + c.dialCode) ? c.dialCode : "";
            s = this.formatNumber((this.props.disableCountryCode ? "" : f) + l, c || void 0), this.setState({
              selectedCountry: c,
              formattedNumber: s
            });
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e,
              t,
              r,
              a,
              o,
              i = this,
              u = this.state,
              c = u.onlyCountries,
              s = u.selectedCountry,
              l = u.showDropdown,
              f = u.formattedNumber,
              d = u.hiddenAreaCodes,
              p = this.props,
              h = p.disableDropdown,
              m = p.renderStringAsFlag,
              b = p.isValid,
              g = p.defaultErrorMessage,
              v = p.specialLabel;
          if ("boolean" == typeof b) a = b;else {
            var C = b(f.replace(/\D/g, ""), s, c, d);
            "boolean" == typeof C ? !1 === (a = C) && (o = g) : (a = !1, o = C);
          }

          var _ = N()((n(e = {}, this.props.containerClass, !0), n(e, "react-tel-input", !0), e)),
              w = N()({
            arrow: !0,
            up: l
          }),
              S = N()((n(t = {}, this.props.inputClass, !0), n(t, "form-control", !0), n(t, "invalid-number", !a), n(t, "open", l), t)),
              j = N()({
            "selected-flag": !0,
            open: l
          }),
              x = N()((n(r = {}, this.props.buttonClass, !0), n(r, "flag-dropdown", !0), n(r, "invalid-number", !a), n(r, "open", l), r)),
              O = "flag ".concat(s && s.iso2);

          return y.a.createElement("div", {
            className: _,
            style: this.props.style || this.props.containerStyle,
            onKeyDown: this.handleKeydown
          }, v && y.a.createElement("div", {
            className: "special-label"
          }, v), o && y.a.createElement("div", {
            className: "invalid-number-message"
          }, o), y.a.createElement("input", Object.assign({
            className: S,
            style: this.props.inputStyle,
            onChange: this.handleInput,
            onClick: this.handleInputClick,
            onDoubleClick: this.handleDoubleClick,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onCopy: this.handleInputCopy,
            value: f,
            ref: function ref(e) {
              return i.numberInputRef = e;
            },
            onKeyDown: this.handleInputKeyDown,
            placeholder: this.props.placeholder,
            disabled: this.props.disabled,
            type: "tel"
          }, this.props.inputProps)), y.a.createElement("div", {
            className: x,
            style: this.props.buttonStyle,
            ref: function ref(e) {
              return i.dropdownContainerRef = e;
            }
          }, m ? y.a.createElement("div", {
            className: j
          }, m) : y.a.createElement("div", {
            onClick: h ? void 0 : this.handleFlagDropdownClick,
            className: j,
            title: s ? "".concat(s.name, ": + ").concat(s.dialCode) : "",
            tabIndex: h ? "-1" : "0",
            role: "button",
            "aria-haspopup": "listbox",
            "aria-expanded": !!l || void 0
          }, y.a.createElement("div", {
            className: O
          }, !h && y.a.createElement("div", {
            className: w
          }))), l && this.getCountryDropdownList()));
        }
      }]) && s(r.prototype, l), t;
    }(y.a.Component);

    F.defaultProps = {
      country: "",
      value: "",
      onlyCountries: [],
      preferredCountries: [],
      excludeCountries: [],
      placeholder: "1 (702) 123-4567",
      searchPlaceholder: "search",
      searchNotFound: "No entries to show",
      flagsImagePath: "./flags.png",
      disabled: !1,
      containerStyle: {},
      inputStyle: {},
      buttonStyle: {},
      dropdownStyle: {},
      searchStyle: {},
      containerClass: "",
      inputClass: "",
      buttonClass: "",
      dropdownClass: "",
      searchClass: "",
      autoFormat: !0,
      enableAreaCodes: !1,
      enableTerritories: !1,
      disableCountryCode: !1,
      disableDropdown: !1,
      enableLongNumbers: !1,
      countryCodeEditable: !0,
      enableSearch: !1,
      disableSearchIcon: !1,
      disableInitialCountryGuess: !1,
      disableCountryGuess: !1,
      regions: "",
      inputProps: {},
      localization: {},
      masks: null,
      priority: null,
      areaCodes: null,
      preserveOrder: [],
      defaultMask: "... ... ... ... ..",
      alwaysDefaultMask: !1,
      prefix: "+",
      copyNumbersOnly: !0,
      renderStringAsFlag: "",
      autocompleteSearch: !1,
      jumpCursorToEnd: !0,
      enableAreaCodeStretch: !1,
      enableClickOutside: !0,
      showDropdown: !1,
      isValid: !0,
      defaultErrorMessage: "",
      specialLabel: "Phone",
      onEnterKeyPress: null,
      keys: {
        UP: 38,
        DOWN: 40,
        RIGHT: 39,
        LEFT: 37,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        SPACE: 32,
        TAB: 9
      }
    };
    t.default = F;
  }]);
});
var PhoneInput = unwrapExports(lib);

var PhoneNumber = function PhoneNumber(_ref83) {
  var value = _ref83.value,
      isErrored = _ref83.isErrored,
      _onChange9 = _ref83.onChange,
      explanation = _ref83.explanation,
      onCarrierConsentChange = _ref83.onCarrierConsentChange,
      intl = _ref83.intl,
      _ref83$isRequired = _ref83.isRequired,
      isRequired = _ref83$isRequired === void 0 ? false : _ref83$isRequired,
      _ref83$onKeyDown = _ref83.onKeyDown,
      _onKeyDown = _ref83$onKeyDown === void 0 ? undefined : _ref83$onKeyDown,
      _ref83$placeholder = _ref83.placeholder,
      placeholder = _ref83$placeholder === void 0 ? '' : _ref83$placeholder,
      _ref83$displaySmsCons = _ref83.displaySmsConsent,
      displaySmsConsent = _ref83$displaySmsCons === void 0 ? true : _ref83$displaySmsCons,
      _ref83$requireCarrier = _ref83.requireCarrierConsent,
      requireCarrierConsent = _ref83$requireCarrier === void 0 ? false : _ref83$requireCarrier,
      _ref83$carrierConsent = _ref83.carrierConsent,
      carrierConsent = _ref83$carrierConsent === void 0 ? false : _ref83$carrierConsent,
      _ref83$internationalS = _ref83.internationalSupport,
      internationalSupport = _ref83$internationalS === void 0 ? false : _ref83$internationalS;

  var getDefaultExplanation = function getDefaultExplanation() {
    return !isRequired ? React.createElement(FormattedHTMLMessage, {
      id: "phoneNumberExplanation",
      defaultMessage: "Optional - get text notifications of status updates"
    }) : '';
  };

  return React.createElement("div", {
    className: "sid-field sid-phone-number"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-phone-number"
  }, React.createElement("div", {
    className: "sid-field__label-with-explanation sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement("div", {
    className: "sid-field__label".concat(isRequired ? ' sid-field__label--required' : '')
  }, React.createElement(FormattedHTMLMessage, {
    id: "phoneNumber",
    defaultMessage: "Mobile Number"
  })), React.createElement("div", {
    className: "sid-field__label-explanation"
  }, explanation || getDefaultExplanation()))), internationalSupport ? React.createElement(React.Fragment, null, React.createElement(InputTextComponent, {
    className: "sid-phone-number__placeholder",
    id: "phone-number-placeholder",
    isErrored: false
  }), React.createElement(PhoneInput, {
    country: "us",
    containerClass: "react-tel-input sid-phone-number__wrapper",
    inputClass: "sid-text-input sid-phone-number__field sid-phone-number__field--intl ".concat(isRequired ? 'sid-text-input--required' : '', "\n                                    sid-l-full-width ").concat(isErrored ? 'sid-text-input--error' : ''),
    autoFormat: false,
    value: value,
    onChange: function onChange(value) {
      return _onChange9(value);
    },
    placeholder: placeholder,
    // @ts-ignore
    ref: function ref(input) {
      return setRef('phoneNumber', input);
    },
    inputProps: {
      id: 'sid-phone-number',
      name: 'sid-phone-number',
      onKeyDown: function onKeyDown(e) {
        return _onKeyDown ? _onKeyDown(e) : undefined;
      }
    }
  })) : React.createElement(InputTextComponent, {
    className: "sid-phone-number__field",
    id: "phone-number",
    isErrored: isErrored,
    onChange: function onChange(e) {
      return _onChange9(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown ? _onKeyDown(e) : undefined;
    },
    placeholder: placeholder || intl.formatMessage({
      id: 'phoneUsPlaceholder',
      defaultMessage: '555-555-5555'
    }),
    refId: "phoneNumber",
    required: isRequired,
    type: "tel",
    value: value
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidPhoneNumber",
    defaultMessage: "Invalid mobile number"
  })) : null, displaySmsConsent && React.createElement("div", {
    className: "sid-h-small-text sid-l-space-top-md sid-sms-consent"
  }, React.createElement(FormattedMessage, {
    id: "phoneNumberWarnMessage1",
    defaultMessage: "By submitting this form with a mobile number, you consent to receive SMS/text messages for verification purposes. Standard phone carrier text messaging (SMS) and data rates may apply."
  })), requireCarrierConsent && React.createElement("div", {
    className: "sid-l-position sid-carrier-disclosure-consent"
  }, React.createElement("div", {
    className: "sid-h-small-text sid-l-space-top-md"
  }, React.createElement("label", {
    htmlFor: "sid-opt-in"
  }, React.createElement(OptInInputComponent, {
    isErrored: isErrored,
    value: carrierConsent,
    onChange: function onChange(value) {
      return onCarrierConsentChange(value);
    }
  }), React.createElement("div", {
    className: "sid-field__label sid-checkbox__label"
  }, React.createElement(FormattedMessage, {
    id: "phoneNumberWarnMessage2",
    defaultMessage: "You authorize your mobile service provider to disclose your mobile number and certain account information to SheerID, solely for identity verification and to avoid fraud."
  }))))));
};

var PhoneNumberComponent = injectIntl(PhoneNumber);
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;

      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }

  var debounced = function debounced() {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);

    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  debounced.flush = function () {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
} // Adds compatibility for ES modules


debounce.debounce = debounce;
var debounce_1 = debounce;
var debounce_2 = debounce_1.debounce;
var ROW_HEIGHT = 42;
var MAX_ITEMS = 25;

var OrganizationList = function OrganizationList(_ref84) {
  var getItemProps = _ref84.getItemProps,
      highlightedIndex = _ref84.highlightedIndex,
      organizations = _ref84.organizations,
      itemToString = _ref84.itemToString,
      children = _ref84.children,
      _ref84$maxItemsToDisp = _ref84.maxItemsToDisplay,
      maxItemsToDisplay = _ref84$maxItemsToDisp === void 0 ? MAX_ITEMS : _ref84$maxItemsToDisp;
  var fullHeight = organizations.length * ROW_HEIGHT;

  var item = function item(organization, index) {
    return React.createElement("div", Object.assign({
      className: "sid-organization-list__item ".concat(highlightedIndex === index ? 'sid-organization-list__item--highlighted' : ''),
      key: index
    }, getItemProps({
      index: index,
      item: organization
    })), itemToString(organization));
  };

  return React.createElement("div", {
    className: "sid-organization-list__menu",
    tabIndex: -1
  }, React.createElement("div", {
    style: {
      height: Math.min(fullHeight, 280)
    }
  }, organizations.filter(function (_, index) {
    return index <= maxItemsToDisplay - 1;
  }).map(function (organization, index) {
    return item(organization, index);
  })), children);
};

var OrganizationListComponent = OrganizationList;

var AddSchoolRequestRow = function AddSchoolRequestRow(_ref85) {
  var urlAddSchoolForm = _ref85.urlAddSchoolForm,
      programId = _ref85.programId,
      _ref85$locale = _ref85.locale,
      locale = _ref85$locale === void 0 ? DEFAULT_LOCALE : _ref85$locale;
  return React.createElement(LinkExternal, {
    className: "sid-organization-list__item sid-organization-list__request-school sid-link",
    href: "".concat(urlAddSchoolForm, "?pid=").concat(programId, "&locale=").concat(locale)
  }, React.createElement(FormattedHTMLMessage, {
    id: "requestSchool",
    defaultMessage: "Don't see your school? Request to have it added"
  }));
};

var FetchOrganizations = /*#__PURE__*/function (_React$Component2) {
  _inherits(FetchOrganizations, _React$Component2);

  function FetchOrganizations(props) {
    var _this10;

    _classCallCheck(this, FetchOrganizations);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(FetchOrganizations).call(this, props));
    _this10.mounted = false; // eslint-disable-next-line react/sort-comp

    _this10.fetch = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
      var _this10$props, orgSearchUrl, searchValue, countryCode, orgSearchTags;

      return _regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _this10$props = _this10.props, orgSearchUrl = _this10$props.orgSearchUrl, searchValue = _this10$props.searchValue, countryCode = _this10$props.countryCode, orgSearchTags = _this10$props.orgSearchTags;

              if (_this10.mounted) {
                _context31.next = 3;
                break;
              }

              return _context31.abrupt("return");

            case 3:
              _context31.next = 5;
              return fetchProgramOrganizations(orgSearchUrl, searchValue, countryCode, orgSearchTags).then(function (organizations) {
                if (organizations) {
                  var onLoaded = _this10.props.onLoaded;
                  onLoaded(organizations);

                  _this10.setState({
                    organizations: organizations,
                    loading: false
                  });
                }
              });

            case 5:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    })); // Prevent searching while user is actively typing
    // eslint-disable-next-line react/sort-comp

    _this10.debouncedFetch = debounce_2(_this10.fetch, 200);
    _this10.state = {
      isErrored: null,
      loading: false,
      organizations: null
    };
    return _this10;
  } // eslint-disable-next-line react/sort-comp


  _createClass(FetchOrganizations, [{
    key: "reset",
    value: function reset(overrides) {
      this.setState(_objectSpread2({}, FetchOrganizations.initialState, overrides));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          minimumSearchValueLength = _this$props3.minimumSearchValueLength,
          searchValue = _this$props3.searchValue;
      this.mounted = true;

      if (searchValue.length >= minimumSearchValueLength) {
        this.reset({
          loading: true
        });
        this.debouncedFetch();
      } else {
        logger.info("No organizations fetched. Search term \"".concat(searchValue, "\" is less than ").concat(minimumSearchValueLength, " characters."));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          minimumSearchValueLength = _this$props4.minimumSearchValueLength,
          searchValue = _this$props4.searchValue;

      if (prevProps.searchValue !== searchValue) {
        if (searchValue.length >= minimumSearchValueLength) {
          this.reset({
            loading: true
          });
          this.debouncedFetch();
        } else {
          this.reset({
            organizations: null,
            loading: false
          });
          logger.info("No organizations fetched. Search term \"".concat(searchValue, "\" is less than ").concat(minimumSearchValueLength, " characters."));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isErrored = _this$state.isErrored,
          loading = _this$state.loading,
          organizations = _this$state.organizations;
      var _this$props5 = this.props,
          getItemProps = _this$props5.getItemProps,
          getMenuProps = _this$props5.getMenuProps,
          highlightedIndex = _this$props5.highlightedIndex,
          itemToString = _this$props5.itemToString,
          searchValue = _this$props5.searchValue,
          programId = _this$props5.programId,
          locale = _this$props5.locale,
          urlAddSchoolForm = _this$props5.urlAddSchoolForm,
          openOrgSearchEnabled = _this$props5.openOrgSearchEnabled;

      if (loading) {
        return React.createElement("div", {
          className: "sid-organization-list__menu"
        }, React.createElement("div", {
          className: "sid-organization-list__message"
        }, React.createElement(FormattedHTMLMessage, {
          id: "loading",
          defaultMessage: "Loading..."
        })));
      }

      if (isErrored) {
        return React.createElement("div", {
          className: "sid-organization-list__menu"
        }, React.createElement("div", {
          className: "sid-organization-list__message"
        }, React.createElement(FormattedHTMLMessage, {
          id: "errorId.unknownError",
          defaultMessage: "An unknown error occurred"
        })));
      }

      if (organizations && organizations.length > 0) {
        return React.createElement(OrganizationListComponent, {
          getItemProps: getItemProps,
          getMenuProps: getMenuProps,
          highlightedIndex: highlightedIndex,
          itemToString: itemToString,
          organizations: organizations
        }, searchValue && !openOrgSearchEnabled && urlAddSchoolForm && (!organizations || organizations.length <= 5) && React.createElement(AddSchoolRequestRow, {
          urlAddSchoolForm: urlAddSchoolForm,
          programId: programId,
          locale: locale
        }));
      }

      if (searchValue && !openOrgSearchEnabled && urlAddSchoolForm && (!organizations || organizations.length === 0)) {
        return React.createElement("div", {
          className: "sid-organization-list__menu"
        }, React.createElement(AddSchoolRequestRow, {
          urlAddSchoolForm: urlAddSchoolForm,
          programId: programId,
          locale: locale
        }));
      }

      return null;
    }
  }]);

  return FetchOrganizations;
}(React.Component);

FetchOrganizations.initialState = {
  isErrored: null,
  loading: false,
  organizations: null
};
var FetchOrganizationsComponent = FetchOrganizations;

var handleStateChange = function handleStateChange(changes, onChange, openOrgSearchEnabled) {
  var keyUp = changes.hasOwnProperty('inputValue') && changes.type === useCombobox.stateChangeTypes.InputChange;

  if (changes.type === useCombobox.stateChangeTypes.FunctionSelectItem) {
    var selectedItem = changes.selectedItem;
    onChange(selectedItem);
  } else if (keyUp) {
    var _selectedItem2 = {
      id: 0,
      name: changes.inputValue
    };
    onChange(_selectedItem2);
  } else if (changes.type === useCombobox.stateChangeTypes.InputBlur) {
    if (!openOrgSearchEnabled) {
      onChange({
        id: undefined,
        name: ''
      });
    }
  }
};

var Typeahead = function Typeahead(_ref87) {
  var onChange = _ref87.onChange,
      programId = _ref87.programId,
      className = _ref87.className,
      countryCode = _ref87.countryCode,
      disabled = _ref87.disabled,
      minimumSearchValueLength = _ref87.minimumSearchValueLength,
      placeholder = _ref87.placeholder,
      value = _ref87.value,
      inputHtmlId = _ref87.inputHtmlId,
      openOrgSearchEnabled = _ref87.openOrgSearchEnabled,
      orgSearchUrl = _ref87.orgSearchUrl,
      orgSearchTags = _ref87.orgSearchTags,
      isRequired = _ref87.isRequired,
      locale = _ref87.locale,
      urlAddSchoolForm = _ref87.urlAddSchoolForm;

  var _useState = useState(''),
      _useState2 = _slicedToArray2(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray2(_useState3, 2),
      loadedOrgs = _useState4[0],
      setLoadedOrgs = _useState4[1];

  assertValidFunction(onChange);

  var itemToString = function itemToString(item) {
    return item ? item.name : '';
  };

  var _useCombobox = useCombobox({
    itemToString: itemToString,
    id: inputHtmlId,
    items: loadedOrgs,
    onStateChange: function onStateChange(changes) {
      return handleStateChange(changes, onChange, openOrgSearchEnabled);
    },
    onInputValueChange: function onInputValueChange(_ref88) {
      var inputValue = _ref88.inputValue;
      setInputValue(inputValue);
    },
    selectedItem: value,
    onSelectedItemChange: function onSelectedItemChange(_ref89) {
      var selectedItem = _ref89.selectedItem;
      onChange(selectedItem);
    }
  }),
      isOpen = _useCombobox.isOpen,
      highlightedIndex = _useCombobox.highlightedIndex,
      getMenuProps = _useCombobox.getMenuProps,
      getItemProps = _useCombobox.getItemProps,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps; // Maintain same labelledby value as previous versions even though label has "for" attribute


  var comboboxArgs = {
    'aria-labelledby': "".concat(inputHtmlId, "-label")
  };
  var inputRef = React.createRef();
  return React.createElement(React.Fragment, null, React.createElement("div", Object.assign({
    className: "sid-organization-list"
  }, getComboboxProps(comboboxArgs)), React.createElement("input", Object.assign({}, getInputProps({
    ref: inputRef
  }), {
    className: "sid-l-full-width sid-hidden-placeholder sid-text-input ".concat(className),
    disabled: disabled,
    id: inputHtmlId,
    placeholder: placeholder,
    "aria-required": isRequired,
    ref: function ref(input) {
      return setRef('organization', input);
    }
  })), React.createElement("div", Object.assign({}, getMenuProps()), isOpen ? React.createElement(FetchOrganizationsComponent, {
    countryCode: countryCode,
    getItemProps: getItemProps,
    highlightedIndex: highlightedIndex,
    itemToString: itemToString,
    minimumSearchValueLength: minimumSearchValueLength,
    onLoaded: function onLoaded(loadedOrganizations) {
      return setLoadedOrgs(loadedOrganizations);
    },
    programId: programId,
    searchValue: inputValue,
    orgSearchUrl: orgSearchUrl,
    orgSearchTags: orgSearchTags,
    locale: locale,
    urlAddSchoolForm: urlAddSchoolForm,
    openOrgSearchEnabled: openOrgSearchEnabled
  }) : null)));
};

var TypeaheadComponent = Typeahead;

var CollegeName = function CollegeName(_ref90) {
  var _onChange10 = _ref90.onChange,
      value = _ref90.value,
      isErrored = _ref90.isErrored,
      verificationService = _ref90.verificationService,
      intl = _ref90.intl,
      _ref90$placeholder = _ref90.placeholder,
      placeholder = _ref90$placeholder === void 0 ? '' : _ref90$placeholder;
  var programId = verificationService.programId,
      viewModel = verificationService.viewModel,
      verificationResponse = verificationService.verificationResponse;
  var locale = getLocaleSafely(viewModel, verificationResponse);
  var urlAddSchoolForm = (getOptions().urlAddSchoolForm || '').trim();
  var country = getSafe(function () {
    return verificationService.viewModel.countryChoice.value;
  });
  var searchTags = getOrgSearchCountryTags(verificationService.programTheme, country);
  return React.createElement("div", {
    className: "sid-field sid-college-name-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-college-name"
  }, React.createElement("div", {
    id: "sid-college-name-label",
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement(FormattedHTMLMessage, {
    id: "schoolName",
    defaultMessage: "University / College name"
  }))), React.createElement(TypeaheadComponent, {
    className: isErrored ? 'sid-text-input--error' : '',
    countryCode: country,
    minimumSearchValueLength: getOptions().minimumOrganizationSearchLength,
    onChange: function onChange(choice) {
      return _onChange10(choice);
    },
    placeholder: placeholder || intl.formatMessage({
      id: 'schoolNamePlaceholder',
      defaultMessage: 'University / College name*'
    }),
    programId: programId,
    value: value,
    inputHtmlId: "sid-college-name",
    openOrgSearchEnabled: verificationService.programTheme.openOrgSearchEnabled,
    orgSearchUrl: verificationService.programTheme.config.orgSearchUrl,
    orgSearchTags: searchTags,
    locale: locale,
    urlAddSchoolForm: urlAddSchoolForm
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidOrganization",
    defaultMessage: "You must select an organization from the list"
  })) : null);
};

var CollegeNameComponent = injectIntl(CollegeName);

var formatTwoDigitValues = function formatTwoDigitValues(value) {
  if (value) {
    return value < 10 ? "0".concat(value) : value.toString();
  }
};

var BirthDate = function BirthDate(_ref91) {
  var onChange = _ref91.onChange,
      intl = _ref91.intl,
      isErrored = _ref91.isErrored,
      _ref91$isRequired = _ref91.isRequired,
      isRequired = _ref91$isRequired === void 0 ? true : _ref91$isRequired,
      errorId = _ref91.errorId,
      value = _ref91.value;
  var birthDateParts = value.split('-');
  var birthDateYear = Number.parseInt(birthDateParts[0], 10) || undefined;
  var birthDateMonth = Number.parseInt(birthDateParts[1], 10) || undefined;
  var birthDateDay = Number.parseInt(birthDateParts[2], 10) || undefined;
  var minBirthYear = 1900;
  var thisYear = new Date().getFullYear();
  var months = [{
    value: '1',
    label: intl.formatMessage({
      id: 'dateTime.january',
      defaultMessage: 'January'
    })
  }, {
    value: '2',
    label: intl.formatMessage({
      id: 'dateTime.february',
      defaultMessage: 'February'
    })
  }, {
    value: '3',
    label: intl.formatMessage({
      id: 'dateTime.march',
      defaultMessage: 'March'
    })
  }, {
    value: '4',
    label: intl.formatMessage({
      id: 'dateTime.april',
      defaultMessage: 'April'
    })
  }, {
    value: '5',
    label: intl.formatMessage({
      id: 'dateTime.may',
      defaultMessage: 'May'
    })
  }, {
    value: '6',
    label: intl.formatMessage({
      id: 'dateTime.june',
      defaultMessage: 'June'
    })
  }, {
    value: '7',
    label: intl.formatMessage({
      id: 'dateTime.july',
      defaultMessage: 'July'
    })
  }, {
    value: '8',
    label: intl.formatMessage({
      id: 'dateTime.august',
      defaultMessage: 'August'
    })
  }, {
    value: '9',
    label: intl.formatMessage({
      id: 'dateTime.september',
      defaultMessage: 'September'
    })
  }, {
    value: '10',
    label: intl.formatMessage({
      id: 'dateTime.october',
      defaultMessage: 'October'
    })
  }, {
    value: '11',
    label: intl.formatMessage({
      id: 'dateTime.november',
      defaultMessage: 'November'
    })
  }, {
    value: '12',
    label: intl.formatMessage({
      id: 'dateTime.december',
      defaultMessage: 'December'
    })
  }];

  var isDateFieldEmpty = function isDateFieldEmpty(year, month, day) {
    return (!day || day === '') && (!month || month === '') && (!year || year === '');
  };

  var updateBirthMonth = function updateBirthMonth(month) {
    if (isDateFieldEmpty(birthDateYear, month, birthDateDay)) {
      onChange('');
      return;
    }

    if (month === '' || month === null) {
      onChange("".concat(birthDateYear, "--").concat(birthDateDay));
    }

    var newVal = Number.parseInt(month, 10);

    if (typeof newVal === 'number' && newVal >= 1 && newVal <= 12) {
      onChange("".concat(birthDateYear, "-").concat(formatTwoDigitValues(month), "-").concat(formatTwoDigitValues(birthDateDay)));
    } else {
      logger.warn("Value '".concat(newVal, "' is an invalid birth month"));
    }
  };

  var updateBirthDay = function updateBirthDay(day) {
    if (isDateFieldEmpty(birthDateYear, birthDateMonth, day)) {
      onChange('');
      return;
    }

    if (day === '') {
      onChange("".concat(birthDateYear, "-").concat(birthDateMonth, "-"));
    }

    var newVal = Number.parseInt(day, 10);

    if (typeof newVal === 'number' && newVal >= 1 && newVal <= 31) {
      onChange("".concat(birthDateYear, "-").concat(formatTwoDigitValues(birthDateMonth), "-").concat(formatTwoDigitValues(newVal)));
    } else {
      logger.warn("Value '".concat(newVal, "' is an invalid birth day"));
    }
  };

  var updateBirthYear = function updateBirthYear(year) {
    if (isDateFieldEmpty(year, birthDateMonth, birthDateDay)) {
      onChange('');
      return;
    }

    if (year === '') {
      onChange("-".concat(birthDateMonth, "-").concat(birthDateDay));
    }

    var newVal = Number.parseInt(year, 10);

    if (typeof newVal === 'number' && newVal >= 1 && newVal <= thisYear) {
      onChange("".concat(newVal, "-").concat(formatTwoDigitValues(birthDateMonth), "-").concat(formatTwoDigitValues(birthDateDay)));
    } else {
      logger.warn("Value '".concat(newVal, "' is an invalid birth year"));
    }
  };

  var getBirthDate = function getBirthDate() {
    if (!birthDateDay && !birthDateMonth && !birthDateYear) {
      onChange('');
    } else {
      onChange("".concat(birthDateYear, "-").concat(formatTwoDigitValues(birthDateMonth), "-").concat(formatTwoDigitValues(birthDateDay)));
    }
  };

  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      setFocus('inputSelectButtonBirthDate');
    }
  };

  var monthFieldId = 'sid-birthdate__month';
  var errMsg = errorId ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.".concat(errorId),
    defaultMessage: "Invalid birth date"
  })) : React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidBirthDate",
    defaultMessage: "Invalid birth date"
  }));
  return React.createElement("div", {
    className: "sid-field sid-birthdate"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: monthFieldId
  }, React.createElement("div", {
    id: "".concat(monthFieldId, "-label"),
    className: "sid-field__label-with-explanation sid-l-space-btm-sm"
  }, React.createElement("div", {
    id: "sid-birthdate",
    className: "sid-field__label".concat(isRequired ? ' sid-field__label--required' : '')
  }, React.createElement(FormattedHTMLMessage, {
    id: "birthDate",
    defaultMessage: "Date of birth"
  })), React.createElement("div", {
    className: "sid-field__label-explanation"
  }, React.createElement(FormattedHTMLMessage, {
    id: "verificationPurposesOnly",
    defaultMessage: "Used for verification purposes only"
  })))), React.createElement("div", {
    className: "sid-birthdate__inputs"
  }, React.createElement(InputSelectComponent, {
    className: "sid-birthdate__month",
    fieldId: "birthDate",
    inputId: monthFieldId,
    isErrored: isErrored,
    options: months,
    onKeyDown: function onKeyDown(event) {
      return handleOnKeyDown(event);
    },
    onChange: function onChange(choice) {
      if (choice) {
        updateBirthMonth(choice.value);
      } else {
        // clear the birth month
        updateBirthMonth(null);
      }
    },
    placeholder: intl.formatMessage({
      id: 'dateTime.month',
      defaultMessage: 'Month'
    }),
    suppressPlaceholder: false,
    value: birthDateMonth ? months[birthDateMonth - 1] : undefined,
    isRequired: isRequired,
    buttonRef: "inputSelectButtonBirthDate"
  }), React.createElement("input", {
    className: "sid-birthdate__day sid-text-input sid-text-input--required ".concat(isErrored ? 'sid-text-input--error' : ''),
    id: "sid-birthdate-day",
    min: 1,
    max: 31,
    name: "sid-birthdate-day",
    onChange: function onChange(e) {
      return updateBirthDay(e.target.value);
    },
    onBlur: getBirthDate,
    pattern: "\\d*",
    placeholder: intl.formatMessage({
      id: 'dateTime.day',
      defaultMessage: 'Day'
    }),
    "aria-label": intl.formatMessage({
      id: 'dateTime.day',
      defaultMessage: 'Day'
    }),
    "aria-labelledby": "sid-birthdate",
    "aria-required": isRequired,
    ref: function ref(input) {
      return setRef('birthDateDay', input);
    },
    type: "text",
    value: birthDateDay || ''
  }), React.createElement("input", {
    className: "sid-birthdate__year sid-text-input sid-text-input--required ".concat(isErrored ? 'sid-text-input--error' : ''),
    id: "sid-birthdate-year",
    name: "sid-birthdate-year",
    type: "text",
    min: minBirthYear,
    max: thisYear,
    value: birthDateYear || '',
    pattern: "\\d*",
    placeholder: intl.formatMessage({
      id: 'dateTime.year',
      defaultMessage: 'Year'
    }),
    "aria-label": intl.formatMessage({
      id: 'dateTime.year',
      defaultMessage: 'Year'
    }),
    "aria-labelledby": "sid-birthdate",
    "aria-required": isRequired,
    ref: function ref(input) {
      return setRef('birthDateYear', input);
    },
    onChange: function onChange(e) {
      return updateBirthYear(e.target.value);
    },
    onBlur: getBirthDate
  })), isErrored ? errMsg : null);
};

BirthDate.defaultProps = {
  value: '2000-01-01'
};
var BirthDateComponent = injectIntl(BirthDate);

var FaqLinkComponent = function FaqLinkComponent(_ref92) {
  var verificationService = _ref92.verificationService;
  var segment = verificationService.verificationResponse.segment;
  var programId = verificationService.programId,
      programTheme = verificationService.programTheme;

  if (segment) {
    var faqHref = getFaqLink(programTheme, segment, programId, getLocaleSafely(verificationService.viewModel));
    return React.createElement(LinkExternal, {
      className: "sid-faq sid-link",
      href: faqHref
    }, React.createElement(FormattedHTMLMessage, {
      id: "getHelp",
      defaultMessage: "Get help"
    }));
  }

  return null;
};

var PoweredByComponent = function PoweredByComponent(_ref93) {
  var verificationService = _ref93.verificationService,
      isCentered = _ref93.isCentered;
  return React.createElement("div", {
    className: isCentered ? 'sid-footer__powered-by-container--stacked sid-l-horz-center' : 'sid-footer__powered-by-container'
  }, React.createElement("div", {
    className: isCentered ? 'sid-footer__powered-by--stacked sid-l-horz-center' : 'sid-footer__powered-by'
  }, React.createElement(FormattedHTMLMessage, {
    id: "poweredBy",
    defaultMessage: "Verification services powered by SheerID."
  })), React.createElement("div", {
    className: isCentered ? 'sid-l-space-top-sm' : ''
  }, "\xA0", React.createElement(FaqLinkComponent, {
    verificationService: verificationService
  })));
};

var PrivacyPolicyLink = function PrivacyPolicyLink(_ref94) {
  var verificationService = _ref94.verificationService,
      includeCompanyName = _ref94.includeCompanyName,
      intl = _ref94.intl;
  var programTheme = verificationService.programTheme;
  var privacyPolicyHref = getPrivacyPolicyUrl(programTheme);
  var companyName = "".concat(getPrivacyPolicyCompanyName(programTheme, intl), " ");
  return React.createElement(LinkExternal, {
    className: "sid-privacy-policy sid-link",
    href: privacyPolicyHref
  }, includeCompanyName ? React.createElement("span", null, companyName) : null, React.createElement(FormattedHTMLMessage, {
    id: "privacyPolicy",
    defaultMessage: "Privacy Policy"
  }));
};

var PrivacyPolicyLinkComponent = injectIntl(PrivacyPolicyLink);

var FormFooterComponent = function FormFooterComponent(_ref95) {
  var verificationService = _ref95.verificationService,
      children = _ref95.children;
  var viewModel = verificationService.viewModel,
      updateViewModel = verificationService.updateViewModel;
  var countryChoice = getSafe(function () {
    return viewModel.countryChoice.value;
  }, undefined);
  var locale = getLocaleSafely(viewModel);
  var privacyPolicyRef = React.useRef({});
  var cleanupCommonTags = /(<div[^>]+>|<div>|<\/div>)|(<span[^>]+>|<span>|<\/span>)|(<p[^>]+>|<p>|<\/p>)/gm; // Store the footer message that the user was shown when the user submitted

  React.useEffect(function () {
    if (!privacyPolicyRef.current) {
      return;
    }

    var privacyPolicyText = privacyPolicyRef.current.innerHTML.replace(cleanupCommonTags, '');
    var updatedViewModel = fn(viewModel, function (draft) {
      if (!draft.metadata) {
        draft.metadata = {};
      }

      draft.metadata.submissionOptIn = privacyPolicyText;
    });
    updateViewModel(updatedViewModel);
  }, [privacyPolicyRef, locale]);
  return React.createElement("div", {
    className: "sid-footer sid-h-small-text sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-footer__shield"
  }, React.createElement("img", {
    title: "Powered by SheerID",
    alt: "design element",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/shield-check.svg"
  })), React.createElement("div", null, React.createElement("div", {
    className: "sid-footer__one",
    ref: privacyPolicyRef
  }, children || React.createElement("div", null, React.createElement(FormattedHTMLMessage, {
    id: "infoShared1",
    defaultMessage: "By clicking, I consent to processing my information for the purpose of verifying my eligibility as described within the {privacyPolicyLink}",
    values: {
      privacyPolicyLink: ''
    }
  }), React.createElement(PrivacyPolicyLinkComponent, {
    verificationService: verificationService,
    includeCompanyName: true
  }), React.createElement(FormattedMessage, {
    id: "companyName",
    defaultMessage: "{Company}"
  }, function (companyName) {
    return React.createElement(FormattedHTMLMessage, {
      id: "infoShared2",
      defaultMessage: ". I understand that my information will be shared with {companyName}. ",
      values: {
        companyName: companyName
      }
    });
  }), typeof countryChoice === 'string' && countryChoice.length > 0 && countryChoice !== 'US' ? React.createElement(FormattedHTMLMessage, {
    id: "informationTransferredToUS",
    defaultMessage: "Your information will be transferred to the United States and will be treated according to SheerID\u2019s privacy policy."
  }) : null)), React.createElement("div", {
    className: "sid-footer__two"
  }, React.createElement(PoweredByComponent, {
    verificationService: verificationService
  }))));
};

function howDoesVerifyingWorkMessages() {
  return {
    student: {
      default: studentMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: studentMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    teacher: {
      default: teacherMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: teacherMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    member: {
      default: memberMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: memberMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    military: {
      default: militaryMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: militaryMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    senior: {
      default: seniorMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: seniorMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    firstResponder: {
      default: firstResponderMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: firstResponderMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    medical: {
      default: medicalMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: medicalMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    age: {
      default: ageMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: ageMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    employment: {
      default: employmentMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: employmentMessages.step.personalInfo.howDoesVerifyingWorkDetails
    },
    identity: {
      default: identityMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: identityMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    licensedProfessional: {
      default: licensedProfessionalMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: licensedProfessionalMessages.step.docUpload.howDoesVerifyingWorkDetails
    },
    recentMover: {
      default: moverMessages.step.personalInfo.howDoesVerifyingWorkDetails,
      docUpload: moverMessages.step.docUpload.howDoesVerifyingWorkDetails
    }
  };
}

var getDefaultDetailsMessage = function getDefaultDetailsMessage(step, segment) {
  var messageType = step === VerificationStepsEnum.docUpload ? 'docUpload' : 'default';
  var defaultMessages = howDoesVerifyingWorkMessages();
  assertValidSegmentName(segment);
  var message = getSafe(function () {
    return defaultMessages[segment][messageType];
  }, '-');
  return message;
};

var HowDoesVerifyingWorkComponent = function HowDoesVerifyingWorkComponent(_ref96) {
  var verificationService = _ref96.verificationService,
      _ref96$initialVisibil = _ref96.initialVisibility,
      initialVisibility = _ref96$initialVisibil === void 0 ? false : _ref96$initialVisibil;

  var _useState5 = useState(initialVisibility),
      _useState6 = _slicedToArray2(_useState5, 2),
      tooltipVisibility = _useState6[0],
      setTooltipVisibility = _useState6[1];

  var segment = verificationService.verificationResponse.segment;
  var step = verificationService.verificationResponse.currentStep;
  var defaultMessage = "".concat(getDefaultDetailsMessage(step, segment));
  var timeoutId;

  var showTooltip = function showTooltip() {
    setTooltipVisibility(true);
    clearTimeout(timeoutId);
  };

  var hideTooltip = function hideTooltip() {
    timeoutId = window.setTimeout(function () {
      return setTooltipVisibility(false);
    });
  };

  var handleOnClick = function handleOnClick(tooltipIsOpen) {
    return tooltipIsOpen ? hideTooltip() : showTooltip();
  };

  return React.createElement("div", {
    className: "sid-how-verify-works",
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip
  }, React.createElement("a", {
    href: "#",
    className: "sid-link",
    "aria-expanded": tooltipVisibility,
    onClick: function onClick() {
      return handleOnClick(tooltipVisibility);
    },
    "aria-describedby": tooltipVisibility ? 'how-does-verifying-work-tooltip' : null,
    role: "button"
  }, React.createElement(FormattedHTMLMessage, {
    id: "howDoesVerifyingWork",
    defaultMessage: "How does verifying work?"
  })), tooltipVisibility ? React.createElement("div", {
    className: "sid-how-verify-works__container"
  }, React.createElement("div", {
    className: "sid-how-verify-works__caret"
  }), React.createElement("div", {
    className: "sid-how-verify-works__tooltip",
    "aria-live": "polite",
    role: "tooltip",
    id: "how-does-verifying-work"
  }, React.createElement(FormattedMessage, {
    id: "companyName",
    defaultMessage: "{Company}"
  }, function (companyName) {
    return React.createElement(FormattedHTMLMessage, {
      id: "step.".concat(step === VerificationStepsEnum.docUpload ? 'docUpload' : 'personalInfo', ".howDoesVerifyingWorkDetails"),
      defaultMessage: defaultMessage,
      values: {
        companyName: companyName
      }
    });
  }), "\xA0", React.createElement(FaqLinkComponent, {
    verificationService: verificationService
  }), "\xA0", React.createElement("span", null, "+"), "\xA0", React.createElement(PrivacyPolicyLinkComponent, {
    verificationService: verificationService,
    includeCompanyName: false
  }))) : null);
};

var BaseCountryComponentWrapper = function BaseCountryComponentWrapper(_ref97) {
  var verificationService = _ref97.verificationService,
      viewModel = _ref97.viewModel,
      intl = _ref97.intl,
      nextFocusField = _ref97.nextFocusField,
      viewModelDraftDecorator = _ref97.viewModelDraftDecorator;
  var countryChoices = getAvailableCountryChoices(verificationService.programTheme, intl);
  var defaultCountryChoice = getDefaultCountryChoice(countryChoices);
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var hasMultipleCountries = countryChoices.length > 1;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray2(_React$useState, 2),
      firstRender = _React$useState2[0],
      setFirstRender = _React$useState2[1];

  var updateCountryChoice = function updateCountryChoice(countryChoice) {
    var nextState = fn(viewModel, function (draft) {
      draft.countryChoice = countryChoice || undefined; // Adds backwards compatibility with Age and Employment programs

      draft.country = countryChoice ? countryChoice.value : undefined;

      if (viewModelDraftDecorator) {
        viewModelDraftDecorator(draft, countryChoice);
      }
    });
    verificationService.updateViewModel(nextState);
  };

  React.useEffect(function () {
    if (firstRender) {
      setFirstRender(false);
      var countryChoice = viewModel.countryChoice ? viewModel.countryChoice : defaultCountryChoice;
      updateCountryChoice(countryChoice);
      return;
    }

    if (!hasMultipleCountries) {
      var fieldsToSkip = viewModel.fieldsToSkipValidation ? [].concat(_toConsumableArray2(viewModel.fieldsToSkipValidation), ['country']) : ['country'];
      verificationService.updateViewModel(produceDraftViewModel(viewModel, 'fieldsToSkipValidation', fieldsToSkip));
    } else {
      var updatedFieldValidationErrors = fn(verificationService.fieldValidationErrors, function (draft) {
        if (draft.country) {
          draft.country = validateFieldById('country', viewModel.countryChoice, verificationService.formValidationOptions);
        }

        if ('postalCode' in viewModel && viewModel.postalCode) {
          draft.postalCode = validateFieldById('postalCode', viewModel.postalCode, verificationService.formValidationOptions);
        }
      });
      updateFieldValidationErrors(updatedFieldValidationErrors, verificationService);
    }
  }, [viewModel.countryChoice, hasMultipleCountries, firstRender]);

  if (!hasMultipleCountries) {
    return null;
  }

  return React.createElement(CountryComponent, {
    isRequired: true,
    options: countryChoices,
    value: viewModel.countryChoice,
    isErrored: Boolean(fieldValidationErrors.country),
    onKeyDown: function onKeyDown(event) {
      return handleCountryOnKeyDown(event);
    },
    onChange: function () {
      var _onChange11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(countryChoice) {
        var countryValue;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                countryValue = countryChoice ? countryChoice.value : undefined;
                updateCountryChoice(countryChoice);
                updateFieldValidationErrorsByFieldId('country', countryValue, verificationService);

                if (nextFocusField && countryValue) {
                  setFocus(nextFocusField);
                }

              case 4:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      function onChange(_x70) {
        return _onChange11.apply(this, arguments);
      }

      return onChange;
    }()
  });
};

var CountryComponentWrapper = injectIntl(BaseCountryComponentWrapper);

var RewardsRemainingComponent = function RewardsRemainingComponent(_ref98) {
  var verificationService = _ref98.verificationService;
  var offersRemaining = getSafe(function () {
    return verificationService.programTheme.remainingRewardCodes;
  }, null);

  if (typeof offersRemaining === 'number' && offersRemaining > 0) {
    return React.createElement("div", {
      className: "sid-rewards-remaining"
    }, React.createElement("div", {
      className: "sid-l-space-top-md"
    }), React.createElement(FormattedHTMLMessage, {
      id: "lowRewardPool",
      defaultMessage: verificationService.messages.lowRewardPool,
      values: {
        offersRemaining: offersRemaining
      }
    }), React.createElement("div", {
      className: "sid-l-space-top-sm"
    }));
  }

  return null;
};
/**
 * TODO - preamble
 */


var StepStudentPersonalInfo = function StepStudentPersonalInfo(_ref99) {
  var intl = _ref99.intl,
      verificationService = _ref99.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var localeChoices = getAvailableLocaleChoices(verificationService.programTheme, intl);
  var defaultLocaleChoice = {
    value: 'en-US',
    label: 'English'
  };
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  var updateStudentViewModel = function updateStudentViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  };

  var updateLocale = function updateLocale(localeChoice) {
    var nextState = fn(viewModel, function (draft) {
      draft.localeChoice = localeChoice;
    });
    verificationService.updateLocale(nextState, verificationService.programTheme, verificationService.verificationResponse.segment);
  };

  return React.createElement("div", {
    id: "sid-step-student-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name & Birthdate"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "Your full name and birthdate must match what is on your official school records."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Student-Only Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you're a student at a degree-granting school."
  }), "\xA0", React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), localeChoices.length > 1 ? React.createElement(ChangeLocaleComponent, {
    options: localeChoices,
    value: viewModel.localeChoice || defaultLocaleChoice,
    isErrored: false,
    onChange: function onChange(localeChoice) {
      return updateLocale(localeChoice);
    }
  }) : null, React.createElement(CountryComponentWrapper, {
    verificationService: verificationService,
    viewModel: viewModel,
    nextFocusField: "organization"
  }), React.createElement(CollegeNameComponent, {
    value: verificationService.viewModel.organization,
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.organization,
    onChange: function onChange(choice) {
      updateViewModelOrganization(choice, verificationService);
      updateFieldValidationErrorsByFieldId('organization', choice, verificationService);
    }
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateStudentViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateStudentViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateStudentViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Personal or school email is fine"
    }),
    onChange: function onChange(newValue) {
      updateStudentViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateStudentViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateStudentViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-wrapper__collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectStudentPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-label": "submit",
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyStudentStatus",
    defaultMessage: "Verify My Student Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepStudentPersonalInfoComponent = injectIntl(StepStudentPersonalInfo);

var PostalCodeInput = function PostalCodeInput(_ref100) {
  var _onChange12 = _ref100.onChange,
      value = _ref100.value,
      isValid = _ref100.isValid,
      intl = _ref100.intl,
      _ref100$placeholder = _ref100.placeholder,
      placeholder = _ref100$placeholder === void 0 ? '' : _ref100$placeholder;
  return React.createElement(InputTextComponent, {
    id: "postal-code",
    isErrored: !isValid,
    onChange: function onChange(e) {
      return _onChange12(e.target.value);
    },
    pattern: "[a-zA-Z0-9 ]*",
    placeholder: placeholder || intl.formatMessage({
      id: 'postalCodePlaceholder',
      defaultMessage: 'Postal Code*'
    }),
    refId: "postalCode",
    value: value,
    required: true
  });
};

PostalCodeInput.defaultProps = {
  isValid: true
};
var PostalCodeInputComponent = injectIntl(PostalCodeInput);

var PostalCodeComponent = function PostalCodeComponent(_ref101) {
  var value = _ref101.value,
      isErrored = _ref101.isErrored,
      onChange = _ref101.onChange,
      explanation = _ref101.explanation;
  return React.createElement("div", {
    className: "sid-field sid-postal-code"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-postal-code"
  }, React.createElement("div", {
    className: "sid-field__label-with-explanation sid-l-space-btm-sm"
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required"
  }, React.createElement(FormattedMessage, {
    id: "postalCode",
    defaultMessage: "Postal Code"
  })), explanation ? React.createElement("div", {
    className: "sid-field__label-explanation"
  }, explanation) : null)), React.createElement(PostalCodeInputComponent, {
    value: value,
    isValid: !isErrored,
    onChange: onChange
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidPostalCode",
    defaultMessage: "Invalid postal code"
  })) : null);
};
/**
 * TODO - preamble
 */


var StepSeniorPersonalInfo = function StepSeniorPersonalInfo(_ref102) {
  var verificationService = _ref102.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  var updateSeniorViewModel = function updateSeniorViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  };

  return React.createElement("div", {
    id: "sid-step-student-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name & Birthdate"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "Your full name and birthdate must match what is on your government-issued documents."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock Your Special Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify your current age."
  }), "\xA0", React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateSeniorViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateSeniorViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateSeniorViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(PostalCodeComponent, {
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateSeniorViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    },
    value: viewModel.postalCode
  }), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    onChange: function onChange(newValue) {
      updateSeniorViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateSeniorViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateSeniorViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectSeniorPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyAndContinue",
    defaultMessage: "Verify and continue"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
}; // TODO remove injectIntl, not used


var StepSeniorPersonalInfoComponent = injectIntl(StepSeniorPersonalInfo);

var phoneNumberValidator = function phoneNumberValidator(countryChoiceValue) {
  return function (value, programTheme) {
    var errorIfFalsy = programTheme && programTheme.smsLoopEnabled || countryChoiceValue !== 'US';
    return getPhoneNumberValidationError(errorIfFalsy)(value);
  };
};

var postalCodeValidator = function postalCodeValidator(countryChoiceValue) {
  return function (value) {
    if (countryChoiceValue !== 'US') {
      return;
    }

    if (!isValidUsPostalCode(value)) {
      return 'invalidPostalCode';
    }
  };
};

var carrierConsentValueValidator = function carrierConsentValueValidator(countryChoiceValue) {
  return function (value, programTheme) {
    var isRequired = programTheme && programTheme.smsLoopEnabled || countryChoiceValue !== 'US';

    if (isRequired && !value) {
      return 'invalidCarrierConsentValue';
    }
  };
};

var City = function City(_ref103) {
  var value = _ref103.value,
      isErrored = _ref103.isErrored,
      _onChange13 = _ref103.onChange,
      intl = _ref103.intl,
      _ref103$onKeyDown = _ref103.onKeyDown,
      onKeyDown = _ref103$onKeyDown === void 0 ? undefined : _ref103$onKeyDown,
      _ref103$placeholder = _ref103.placeholder,
      placeholder = _ref103$placeholder === void 0 ? '' : _ref103$placeholder;
  return React.createElement("div", {
    className: "sid-field sid-city"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-city"
  }, React.createElement("div", {
    className: "sid-field__label sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required"
  }, React.createElement(FormattedHTMLMessage, {
    id: "city",
    defaultMessage: "City"
  })))), React.createElement(InputTextComponent, {
    id: "city",
    isErrored: isErrored,
    onChange: function onChange(e) {
      return _onChange13(e.target.value);
    },
    onKeyDown: typeof onKeyDown === 'function' ? function (e) {
      return onKeyDown(e);
    } : undefined,
    placeholder: placeholder || intl.formatMessage({
      id: 'cityPlaceholder',
      defaultMessage: 'City*'
    }),
    value: value
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidCity",
    defaultMessage: "Invalid city"
  })) : null);
};

var CityComponent = injectIntl(City);

var Address = function Address(_ref104) {
  var value = _ref104.value,
      isErrored = _ref104.isErrored,
      _onChange14 = _ref104.onChange,
      intl = _ref104.intl,
      _ref104$onKeyDown = _ref104.onKeyDown,
      onKeyDown = _ref104$onKeyDown === void 0 ? undefined : _ref104$onKeyDown,
      _ref104$placeholder = _ref104.placeholder,
      placeholder = _ref104$placeholder === void 0 ? '' : _ref104$placeholder;
  return React.createElement("div", {
    className: "sid-field sid-address"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-address"
  }, React.createElement("div", {
    className: "sid-field__label sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required"
  }, React.createElement(FormattedHTMLMessage, {
    id: "address",
    defaultMessage: "Address"
  })))), React.createElement(InputTextComponent, {
    id: "address",
    isErrored: isErrored,
    onChange: function onChange(e) {
      return _onChange14(e.target.value);
    },
    onKeyDown: typeof onKeyDown === 'function' ? function (e) {
      return onKeyDown(e);
    } : undefined,
    placeholder: placeholder || intl.formatMessage({
      id: 'addressPlaceholder',
      defaultMessage: 'Address*'
    }),
    value: value
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidAddress",
    defaultMessage: "Invalid address"
  })) : null);
};

var AddressComponent = injectIntl(Address);
/**
 * TODO - preamble
 */

var StepAgePersonalInfo = function StepAgePersonalInfo(_ref105) {
  var verificationService = _ref105.verificationService,
      intl = _ref105.intl;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);
  var countryChoices = getAvailableCountryChoices(verificationService.programTheme, intl);
  var defaultCountryChoice = getDefaultCountryChoice(countryChoices);
  var _verificationService$ = verificationService.programTheme,
      isSmsNotifierConfigured = _verificationService$.isSmsNotifierConfigured,
      smsLoopEnabled = _verificationService$.smsLoopEnabled;
  var safeCountryValue = getSafe(function () {
    return viewModel.countryChoice.value;
  }, defaultCountryChoice.value);
  var defaultRequiredFields = safeCountryValue === 'US' ? [{
    key: 'postalCode'
  }] : [];

  var _React$useState3 = React.useState(defaultRequiredFields),
      _React$useState4 = _slicedToArray2(_React$useState3, 2),
      requiredFields = _React$useState4[0],
      setRequiredFields = _React$useState4[1];

  if (!fieldValidationErrors.phoneNumber && verificationResponse.errorIds && verificationResponse.errorIds.includes('invalidPhoneNumber')) {
    verificationService.updateFieldValidationErrors(_objectSpread2({}, fieldValidationErrors, {
      phoneNumber: 'invalidPhoneNumber'
    }));
  }

  var displayPhoneNumber = function displayPhoneNumber(country, displayForSmsLoop) {
    return country !== 'US' || displayForSmsLoop;
  };

  var updateAgeViewModel = function updateAgeViewModel(key, value) {
    var nextState = produceDraftViewModel(viewModel, key, value);
    verificationService.updateViewModel(nextState);
  };

  var updateViewModelWithRequiredFields = function updateViewModelWithRequiredFields(newRequiredFields, conditionalRequiredFieldKeys) {
    var nextState = produceDraftViewModelWithRequiredFields(viewModel, newRequiredFields, conditionalRequiredFieldKeys);
    verificationService.updateViewModel(nextState);
  };

  var isFieldRequired = function isFieldRequired(key) {
    return requiredFields.some(function (field) {
      return field.key === key;
    });
  };

  overrideValidator('phoneNumber', phoneNumberValidator(safeCountryValue));

  if (displayPhoneNumber(safeCountryValue, smsLoopEnabled)) {
    if (!customValidatorExists$1('carrierConsentValue')) {
      setCustomValidator('carrierConsentValue', carrierConsentValueValidator(safeCountryValue));
    }
  } else if (customValidatorExists$1('carrierConsentValue')) {
    removeCustomValidator('carrierConsentValue');
  }

  var onCarrierConsentChange = function onCarrierConsentChange(newValue) {
    updateAgeViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
      carrierConsentValue: newValue
    }));
    updateFieldValidationErrorsByFieldId('carrierConsentValue', newValue, verificationService);
  };

  React.useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
      var collectFieldsResponse, newRequiredFields;
      return _regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              _context33.prev = 0;
              _context33.next = 3;
              return getFieldsToCollect(verificationResponse.verificationId, verificationResponse.currentStep, viewModel);

            case 3:
              collectFieldsResponse = _context33.sent;
              newRequiredFields = getSafe(function () {
                return collectFieldsResponse.fieldsToCollect.required;
              }, []);
              updateViewModelWithRequiredFields(newRequiredFields, ['postalCode', 'city', 'address1']);
              setRequiredFields(newRequiredFields);
              _context33.next = 12;
              break;

            case 9:
              _context33.prev = 9;
              _context33.t0 = _context33["catch"](0);
              logger.error("Failed to determine fields to collect: ".concat(_context33.t0));

            case 12:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33, null, [[0, 9]]);
    }))();
  }, [viewModel.country]);
  return React.createElement("div", {
    id: "sid-step-student-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name & Birthdate"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "Your full name and birthdate must match what is on your government-issued documents."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock Your Special Offer"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify your current age."
  }), "\xA0", React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement(CountryComponentWrapper, {
    verificationService: verificationService,
    viewModel: viewModel,
    viewModelDraftDecorator: function viewModelDraftDecorator(draft, countryChoice) {
      var viewModelDraft = draft;
      var country = countryChoice ? countryChoice.value : undefined;

      if (!displayPhoneNumber(country, smsLoopEnabled)) {
        viewModelDraft.phoneNumber = '';
      }
    }
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateAgeViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateAgeViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateAgeViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), isFieldRequired('city') && React.createElement(CityComponent, {
    value: viewModel.city,
    isRequired: true,
    isErrored: !!fieldValidationErrors.city,
    errorId: fieldValidationErrors.city,
    onChange: function onChange(value) {
      updateAgeViewModel('city', value);
      updateFieldValidationErrorsByFieldId('city', value, verificationService);
    }
  }), isFieldRequired('address1') && React.createElement(AddressComponent, {
    value: viewModel.address1,
    isRequired: true,
    isErrored: !!fieldValidationErrors.address1,
    errorId: fieldValidationErrors.address1,
    onChange: function onChange(value) {
      updateAgeViewModel('address1', value);
      updateFieldValidationErrorsByFieldId('address1', value, verificationService);
    }
  }), isFieldRequired('postalCode') && React.createElement(PostalCodeComponent, {
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateAgeViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    },
    value: viewModel.postalCode
  }), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    onChange: function onChange(newValue) {
      updateAgeViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), (displayPhoneNumber(safeCountryValue, smsLoopEnabled) || isSmsNotifierConfigured) && React.createElement(PhoneNumberComponent, {
    value: viewModel.phoneNumber,
    internationalSupport: true,
    isRequired: verificationService.programTheme.smsLoopEnabled || safeCountryValue !== 'US',
    isErrored: !!fieldValidationErrors.phoneNumber,
    displaySmsConsent: isSmsNotifierConfigured,
    onChange: function onChange(value) {
      updateAgeViewModel('phoneNumber', value);
      updateFieldValidationErrorsByFieldId('phoneNumber', value, verificationService);
    },
    errorId: fieldValidationErrors.phoneNumber,
    requireCarrierConsent: verificationService.programTheme.smsLoopEnabled || safeCountryValue !== 'US',
    onCarrierConsentChange: onCarrierConsentChange,
    carrierConsent: Boolean(viewModel.metadata && viewModel.metadata.carrierConsentValue)
  }), React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateAgeViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectAgePersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyAndContinue",
    defaultMessage: "Verify and continue"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepAgePersonalInfoComponent = injectIntl(StepAgePersonalInfo);

var shouldCollectPostalCode = function shouldCollectPostalCode(programTheme, viewModel) {
  return getSafe(function () {
    return programTheme.openOrgSearchEnabled;
  }) && getSafe(function () {
    return viewModel.organization.id;
  }) === 0 && getSafe(function () {
    return viewModel.organization.name;
  }, '').length > 0;
};

var TeacherSchool = function TeacherSchool(_ref107) {
  var value = _ref107.value,
      isErrored = _ref107.isErrored,
      _onChange15 = _ref107.onChange,
      verificationService = _ref107.verificationService,
      intl = _ref107.intl,
      _ref107$placeholder = _ref107.placeholder,
      placeholder = _ref107$placeholder === void 0 ? '' : _ref107$placeholder;
  var programId = verificationService.programId,
      viewModel = verificationService.viewModel,
      verificationResponse = verificationService.verificationResponse;
  var id = 'sid-teacher-school';
  var locale = getLocaleSafely(viewModel, verificationResponse);
  var urlAddSchoolForm = (getOptions().urlAddSchoolForm || '').trim();
  var country = getSafe(function () {
    return verificationService.viewModel.countryChoice.value;
  });
  var searchTags = getOrgSearchCountryTags(verificationService.programTheme, country);
  return React.createElement("div", {
    className: "sid-field sid-teacher-school-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: id
  }, React.createElement("div", {
    id: "".concat(id, "-label"),
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "schoolName",
    defaultMessage: "School name"
  }))), React.createElement(TypeaheadComponent, {
    className: isErrored ? 'sid-text-input--error' : '',
    countryCode: country,
    onChange: function onChange(choice) {
      return _onChange15(choice);
    },
    minimumSearchValueLength: getOptions().minimumOrganizationSearchLength,
    placeholder: placeholder || intl.formatMessage({
      id: 'schoolNamePlaceholder',
      defaultMessage: 'University / College name*'
    }),
    programId: programId,
    value: value,
    inputHtmlId: id,
    openOrgSearchEnabled: verificationService.programTheme.openOrgSearchEnabled,
    orgSearchUrl: verificationService.programTheme.config.orgSearchUrl,
    orgSearchTags: searchTags,
    locale: locale,
    urlAddSchoolForm: urlAddSchoolForm,
    isRequired: true
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidOrganization",
    defaultMessage: "You must select an organization from the list"
  })) : null);
};

var TeacherSchoolComponent = injectIntl(TeacherSchool);
/**
 * Step Teacher Personal Info Component
 * TODO - We need to import more from es6
 */

var StepTeacherPersonalInfo = function StepTeacherPersonalInfo(_ref108) {
  var intl = _ref108.intl,
      verificationService = _ref108.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);
  var localeChoices = getAvailableLocaleChoices(verificationService.programTheme, intl);
  var defaultLocaleChoice = {
    value: 'en-US',
    label: 'English'
  };

  var updateTeacherViewModel = function updateTeacherViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  };

  var updateLocale = function updateLocale(localeChoice) {
    var nextState = fn(viewModel, function (draft) {
      draft.localeChoice = localeChoice;
    });
    verificationService.updateLocale(nextState, verificationService.programTheme, verificationService.verificationResponse.segment);
  }; // Don't validate DOB if ID Check is not enabled


  useEffect(function () {
    if (!verificationService.programTheme.idCheckAddOnEnabled) {
      updateTeacherViewModel('birthDate', '');
      updateTeacherViewModel('fieldsToSkipValidation', ['birthDate']);
    } else {
      updateTeacherViewModel('fieldsToSkipValidation', []);
    }
  }, [verificationService.programTheme.idCheckAddOnEnabled]);
  return React.createElement("div", {
    id: "sid-step-teacher-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name & Email"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "Your full name and email address must match what is on record with your school."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Teaching Staff-Only Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you're a teacher, faculty or staff at a K-12 or degree-granting university."
  }), "\xA0", React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), localeChoices.length > 1 ? React.createElement(ChangeLocaleComponent, {
    options: localeChoices,
    value: viewModel.localeChoice || defaultLocaleChoice,
    isErrored: false,
    onChange: function onChange(localeChoice) {
      return updateLocale(localeChoice);
    }
  }) : null, React.createElement(CountryComponentWrapper, {
    verificationService: verificationService,
    viewModel: viewModel,
    nextFocusField: "organization"
  }), React.createElement(TeacherSchoolComponent, {
    value: verificationService.viewModel.organization,
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.organization,
    onChange: function onChange(choice) {
      updateViewModelOrganization(choice, verificationService);
      updateFieldValidationErrorsByFieldId('organization', choice, verificationService);
    }
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateTeacherViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateTeacherViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), verificationService.programTheme.idCheckAddOnEnabled ? React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateTeacherViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }) : null, React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Must be your school-issued email address"
    }),
    onChange: function onChange(newValue) {
      updateTeacherViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateTeacherViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, shouldCollectPostalCode(verificationService.programTheme, viewModel) ? React.createElement(PostalCodeComponent, {
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateTeacherViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    },
    value: viewModel.postalCode
  }) : null, React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateTeacherViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectTeacherPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyTeacherStatus",
    defaultMessage: "Verify My Teacher Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepTeacherPersonalInfoComponent = injectIntl(StepTeacherPersonalInfo);

var MemberId = function MemberId(_ref109) {
  var value = _ref109.value,
      isErrored = _ref109.isErrored,
      _onChange16 = _ref109.onChange,
      explanation = _ref109.explanation,
      intl = _ref109.intl,
      _ref109$placeholder = _ref109.placeholder,
      placeholder = _ref109$placeholder === void 0 ? '' : _ref109$placeholder,
      _ref109$isRequired = _ref109.isRequired,
      isRequired = _ref109$isRequired === void 0 ? false : _ref109$isRequired,
      label = _ref109.label;

  var getDefaultExplanation = function getDefaultExplanation() {
    return !isRequired ? React.createElement(FormattedHTMLMessage, {
      id: "optional",
      defaultMessage: "Optional"
    }) : '';
  };

  return React.createElement("div", {
    className: "sid-field sid-member-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-member-id"
  }, React.createElement("div", {
    className: "sid-field__label-with-explanation sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement("div", {
    className: "sid-field__label".concat(isRequired ? ' sid-field__label--required' : '', " ")
  }, label || React.createElement(FormattedHTMLMessage, {
    id: "memberId",
    defaultMessage: "ID Number"
  })), React.createElement("div", {
    className: "sid-field__label-explanation"
  }, explanation || getDefaultExplanation()))), React.createElement(InputTextComponent, {
    id: "member-id",
    isErrored: isErrored,
    onChange: function onChange(e) {
      return _onChange16(e.target.value);
    },
    placeholder: placeholder || intl.formatMessage({
      id: 'memberIdPlaceholder',
      defaultMessage: 'ID Number*'
    }),
    refId: "memberId",
    value: value
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidMemberId",
    defaultMessage: "Invalid ID Number"
  })) : null);
};

var MemberIdComponent = injectIntl(MemberId);

var MembershipOrganization = function MembershipOrganization(_ref110) {
  var value = _ref110.value,
      isErrored = _ref110.isErrored,
      _onChange17 = _ref110.onChange,
      verificationService = _ref110.verificationService,
      intl = _ref110.intl,
      _ref110$placeholder = _ref110.placeholder,
      placeholder = _ref110$placeholder === void 0 ? '' : _ref110$placeholder;
  var programId = verificationService.programId;
  return React.createElement("div", {
    className: "sid-field sid-membership-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-membership"
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "organization",
    defaultMessage: "Organization name"
  }))), React.createElement(TypeaheadComponent, {
    className: isErrored ? 'sid-text-input--error' : '',
    countryCode: getSafe(function () {
      return verificationService.viewModel.countryChoice.value;
    }),
    onChange: function onChange(choice) {
      return _onChange17(choice);
    },
    minimumSearchValueLength: getOptions().minimumOrganizationSearchLength,
    placeholder: placeholder || intl.formatMessage({
      id: 'organizationNamePlaceholder',
      defaultMessage: 'Organization*'
    }),
    programId: programId,
    value: value,
    inputHtmlId: "sid-membership",
    openOrgSearchEnabled: verificationService.programTheme.openOrgSearchEnabled,
    orgSearchUrl: verificationService.programTheme.config.orgSearchUrl
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidOrganization",
    defaultMessage: "You must select an organization from the list"
  })) : null);
};

var MembershipOrganizationComponent = injectIntl(MembershipOrganization);
/**
 * Step Member Personal Info Component
 * TODO - We need to import more from es6
 */

var StepMemberPersonalInfo = function StepMemberPersonalInfo(_ref111) {
  var intl = _ref111.intl,
      verificationService = _ref111.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);
  var localeChoices = getAvailableLocaleChoices(verificationService.programTheme, intl);
  var defaultLocaleChoice = {
    value: 'en-US',
    label: 'English'
  };

  var updateMemberViewModel = function updateMemberViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  };

  var updateLocale = function updateLocale(localeChoice) {
    var nextState = fn(viewModel, function (draft) {
      draft.localeChoice = localeChoice;
    });
    verificationService.updateLocale(nextState, verificationService.programTheme, verificationService.verificationResponse.segment);
  };

  return React.createElement("div", {
    id: "sid-step-member-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name & Email"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "Your full name and email address must match what is on record with your school."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Members-Only Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you're a current member of an eligible organization."
  }), "\xA0", React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), localeChoices.length > 1 ? React.createElement(ChangeLocaleComponent, {
    options: localeChoices,
    value: viewModel.localeChoice || defaultLocaleChoice,
    isErrored: false,
    onChange: function onChange(localeChoice) {
      return updateLocale(localeChoice);
    }
  }) : null, React.createElement(CountryComponentWrapper, {
    verificationService: verificationService,
    viewModel: viewModel,
    nextFocusField: "organization"
  }), React.createElement(MembershipOrganizationComponent, {
    value: verificationService.viewModel.organization,
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.organization,
    onChange: function onChange(choice) {
      updateViewModelOrganization(choice, verificationService);
      updateFieldValidationErrorsByFieldId('organization', choice, verificationService);
    }
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateMemberViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateMemberViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Needed to send you your unique code"
    }),
    onChange: function onChange(newValue) {
      updateMemberViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    isRequired: false,
    onChange: function onChange(newValue) {
      updateMemberViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(MemberIdComponent, {
    value: viewModel.memberId,
    isErrored: !!fieldValidationErrors.memberId,
    isRequired: false,
    onChange: function onChange(newValue) {
      updateMemberViewModel('memberId', newValue);
      updateFieldValidationErrorsByFieldId('memberId', newValue, verificationService);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateMemberViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateMemberViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectMemberPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyMembershipStatus",
    defaultMessage: "Verify My Membership Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepMemberPersonalInfoComponent = injectIntl(StepMemberPersonalInfo);

var compareLabel = function compareLabel(a, b) {
  var sortValue;

  try {
    sortValue = a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
  } catch (e) {
    sortValue = 1;
  }

  return sortValue;
};

var SortByLabel = function SortByLabel(choices) {
  return choices.sort(compareLabel);
};

var MilitaryStatus = function MilitaryStatus(_ref112) {
  var value = _ref112.value,
      isErrored = _ref112.isErrored,
      options = _ref112.options,
      _onChange18 = _ref112.onChange,
      intl = _ref112.intl,
      _ref112$placeholder = _ref112.placeholder,
      placeholder = _ref112$placeholder === void 0 ? '' : _ref112$placeholder;
  return React.createElement("div", {
    className: "sid-field sid-military-status"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-military-status"
  }, React.createElement("div", {
    id: "sid-military-status-label",
    className: "sid-field__label sid-field__label--required sid-military-status__label sid-l-space-btm-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "status",
    defaultMessage: "Status"
  }))), React.createElement(InputSelectComponent, {
    fieldId: "status",
    inputId: "sid-military-status",
    isErrored: isErrored,
    options: SortByLabel(options),
    onChange: function onChange(status) {
      return _onChange18(status);
    },
    value: value,
    placeholder: placeholder || intl.formatMessage({
      id: 'statusPlaceholder',
      defaultMessage: 'Status*'
    })
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidStatus",
    defaultMessage: "Invalid military status"
  })) : null);
};

var MilitaryStatusComponent = injectIntl(MilitaryStatus);

var orgsInStatus = function orgsInStatus(status) {
  return function (org) {
    if (status === 'VETERAN') {
      return !!org.name;
    }

    if (status === 'RESERVIST') {
      return militaryReservistOrgNames.includes(org.name);
    }

    return !militaryReservistOrgNames.includes(org.name);
  };
};

var orgToOption = function orgToOption(org) {
  return {
    value: org.id,
    label: org.name
  };
};

var updateMilitaryViewModel = function updateMilitaryViewModel(key, value, verificationService, availableStatuses) {
  var viewModel = verificationService.viewModel;
  var nextState = fn(viewModel, function (draft) {
    draft[key] = value; // If there are no status choices, don't validate

    if (!availableStatuses) {
      draft.fieldsToSkipValidation = ['status'];
    }

    if (key === 'status') {
      draft.organization = {
        id: 0,
        name: ''
      };
    }
  });
  return nextState;
};

var BranchOfService = function BranchOfService(_ref113) {
  var autoFocus = _ref113.autoFocus,
      _onChange19 = _ref113.onChange,
      value = _ref113.value,
      isErrored = _ref113.isErrored,
      organizations = _ref113.organizations,
      verificationService = _ref113.verificationService,
      intl = _ref113.intl,
      _ref113$placeholder = _ref113.placeholder,
      placeholder = _ref113$placeholder === void 0 ? '' : _ref113$placeholder;
  var options = [];
  var status = verificationService.viewModel.status;
  if (organizations) options = organizations.filter(orgsInStatus(status)).map(orgToOption);

  var handleStateChange = function handleStateChange(selectedOrgOption, onChange) {
    if (selectedOrgOption) {
      onChange({
        id: selectedOrgOption.value,
        name: selectedOrgOption.label
      });
    } else {
      onChange({
        id: 0,
        name: ''
      });
    }
  };

  return React.createElement("div", {
    className: "sid-field sid-branch-of-service-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-branch-of-service"
  }, React.createElement("div", {
    id: "sid-branch-of-service-label",
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "branchOfService",
    defaultMessage: "Branch Of Service"
  }))), React.createElement(InputSelectComponent, {
    autoFocus: autoFocus,
    fieldId: "organization",
    inputId: "sid-branch-of-service",
    isErrored: isErrored,
    options: SortByLabel(options),
    onChange: function onChange(branch) {
      return handleStateChange(branch, _onChange19);
    },
    value: value,
    placeholder: placeholder || intl.formatMessage({
      id: 'branchOfServicePlaceholder',
      defaultMessage: 'Branch Of Service*'
    })
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidOrganization",
    defaultMessage: "You must select an organization from the list"
  })) : null);
};

var BranchOfServiceComponent = injectIntl(BranchOfService);
/**
 * TODO - preamble
 */

var StepActiveMilitaryPersonalInfo = function StepActiveMilitaryPersonalInfo(_ref114) {
  var intl = _ref114.intl,
      verificationService = _ref114.verificationService;
  var viewModel = verificationService.viewModel;
  var previousViewModel = verificationService.previousViewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);
  var status = verificationService.viewModel.status;
  var availableStatuses = getAvailableMilitaryStatuses(verificationService, intl);

  var updateActiveMilitaryViewModel = function updateActiveMilitaryViewModel(key, value) {
    verificationService.updateViewModel(updateMilitaryViewModel(key, value, verificationService, availableStatuses));
  };

  var submitStep = function submitStep() {
    var nextState = fn(viewModel, function () {});
    logger.info('StepMilitaryStatusComponent submitting form');
    verificationService.submitStep(VerificationStepsEnum.collectMilitaryStatus, nextState, verificationService.previousVerificationResponse || verificationService.verificationResponse);
  };

  if (viewModel.status && previousViewModel && previousViewModel.status !== viewModel.status || viewModel.status && verificationService.verificationResponse.currentStep === VerificationStepsEnum.collectMilitaryStatus) {
    submitStep();
  } // Refs should be reset to ensure the field order isn't affected by the previous step


  resetRefs();
  return React.createElement("div", {
    id: "sid-step-active-military-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name & Birthdate"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "\n                                Enter your first and last name on the form as it appears on your military document(s).\n                                Keep in mind that may be your given name."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Military-Only Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you're a member of the armed forces."
  })), React.createElement("div", {
    className: "sid-header__how-verifying-works sid-l-horz-center"
  }, React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement(CountryComponentWrapper, {
    verificationService: verificationService,
    viewModel: viewModel,
    nextFocusField: "status"
  }), availableStatuses ? React.createElement(MilitaryStatusComponent, {
    value: {
      value: viewModel.status,
      label: getStatusLabel(intl, viewModel.status, MilitaryStatusDefaultMessagesEnum)
    },
    isErrored: !!fieldValidationErrors.status,
    options: availableStatuses,
    onChange: function onChange(status) {
      updateActiveMilitaryViewModel('status', status ? status.value : '');
      updateFieldValidationErrorsByFieldId('status', status ? status.value : '', verificationService);
    }
  }) : null, status === 'MILITARY_FAMILY' ? React.createElement("div", {
    className: "sid-field-notice",
    "data-testid": "family-note"
  }, React.createElement(FormattedHTMLMessage, {
    id: "militaryFamilyCardNote",
    defaultMessage: "Note: this offer is only available to military family members with a Dependent ID card."
  })) : null, React.createElement(BranchOfServiceComponent, {
    isErrored: !!fieldValidationErrors.organization,
    onChange: function onChange(choice) {
      updateViewModelOrganization(choice, verificationService);
      updateFieldValidationErrorsByFieldId('organization', choice, verificationService);
    },
    value: {
      value: verificationService.viewModel.organization.id,
      label: verificationService.viewModel.organization.name
    },
    verificationService: verificationService,
    organizations: verificationService.orgList
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateActiveMilitaryViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateActiveMilitaryViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateActiveMilitaryViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Personal email address is recommended"
    }),
    onChange: function onChange(newValue) {
      updateActiveMilitaryViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateActiveMilitaryViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateActiveMilitaryViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectActiveMilitaryPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyMilitaryStatus",
    defaultMessage: "Verify My Military Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepActiveMilitaryPersonalInfoComponent = injectIntl(StepActiveMilitaryPersonalInfo);

var DischargeDate = function DischargeDate(_ref115) {
  var onChange = _ref115.onChange,
      intl = _ref115.intl,
      isErrored = _ref115.isErrored,
      value = _ref115.value;
  var dischargeDateParts = value.split('-');
  var dischargeDateYear = Number.parseInt(dischargeDateParts[0], 10) || undefined;
  var dischargeDateMonth = Number.parseInt(dischargeDateParts[1], 10) || undefined;
  var dischargeDateDay = 1;
  var minDischargeYear = 1900;
  var thisYear = new Date().getFullYear();
  var months = [{
    value: '1',
    label: intl.formatMessage({
      id: 'dateTime.january',
      defaultMessage: 'January'
    })
  }, {
    value: '2',
    label: intl.formatMessage({
      id: 'dateTime.february',
      defaultMessage: 'February'
    })
  }, {
    value: '3',
    label: intl.formatMessage({
      id: 'dateTime.march',
      defaultMessage: 'March'
    })
  }, {
    value: '4',
    label: intl.formatMessage({
      id: 'dateTime.april',
      defaultMessage: 'April'
    })
  }, {
    value: '5',
    label: intl.formatMessage({
      id: 'dateTime.may',
      defaultMessage: 'May'
    })
  }, {
    value: '6',
    label: intl.formatMessage({
      id: 'dateTime.june',
      defaultMessage: 'June'
    })
  }, {
    value: '7',
    label: intl.formatMessage({
      id: 'dateTime.july',
      defaultMessage: 'July'
    })
  }, {
    value: '8',
    label: intl.formatMessage({
      id: 'dateTime.august',
      defaultMessage: 'August'
    })
  }, {
    value: '9',
    label: intl.formatMessage({
      id: 'dateTime.september',
      defaultMessage: 'September'
    })
  }, {
    value: '10',
    label: intl.formatMessage({
      id: 'dateTime.october',
      defaultMessage: 'October'
    })
  }, {
    value: '11',
    label: intl.formatMessage({
      id: 'dateTime.november',
      defaultMessage: 'November'
    })
  }, {
    value: '12',
    label: intl.formatMessage({
      id: 'dateTime.december',
      defaultMessage: 'December'
    })
  }];

  var updateDischargeMonth = function updateDischargeMonth(month) {
    if (month === '' || month === null) {
      onChange("".concat(dischargeDateYear, "--").concat(dischargeDateDay));
    }

    var newVal = Number.parseInt(month, 10);

    if (typeof newVal === 'number' && newVal >= 1 && newVal <= 12) {
      onChange("".concat(dischargeDateYear, "-").concat(formatTwoDigitValues(month), "-").concat(formatTwoDigitValues(dischargeDateDay)));
    } else {
      logger.warn("Value '".concat(newVal, "' is an invalid discharge month"));
    }
  };

  var updateDischargeYear = function updateDischargeYear(year) {
    if (year === '') {
      onChange("-".concat(dischargeDateMonth, "-").concat(dischargeDateDay));
    }

    var newVal = Number.parseInt(year, 10);

    if (typeof newVal === 'number' && newVal >= 1 && newVal <= thisYear) {
      onChange("".concat(newVal, "-").concat(formatTwoDigitValues(dischargeDateMonth), "-").concat(formatTwoDigitValues(dischargeDateDay)));
    } else {
      logger.warn("Value '".concat(newVal, "' is an invalid discharge year"));
    }
  };

  var getDischargeDate = function getDischargeDate() {
    onChange("".concat(dischargeDateYear, "-").concat(formatTwoDigitValues(dischargeDateMonth), "-").concat(formatTwoDigitValues(dischargeDateDay)));
  };

  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (event.key === 'Tab') {
      if (!event.shiftKey) {
        event.preventDefault();
        setFocus('inputSelectButtonDischargeDate');
      }
    }
  };

  return React.createElement("div", {
    className: "sid-field sid-discharge-date"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-discharge-date__month"
  }, React.createElement("div", {
    className: "sid-field__label-with-explanation sid-l-space-btm-sm"
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required"
  }, React.createElement(FormattedHTMLMessage, {
    id: "dischargeDate",
    defaultMessage: "Discharge date"
  })), React.createElement("div", {
    className: "sid-field__label-explanation"
  }, React.createElement(FormattedHTMLMessage, {
    id: "verificationPurposesOnly",
    defaultMessage: "Used for verification purposes only"
  })))), React.createElement("div", {
    className: "sid-discharge-date__inputs"
  }, React.createElement(InputSelectComponent, {
    className: "sid-discharge-date__month",
    fieldId: "dischargeDate",
    inputId: "sid-discharge-date__month",
    isErrored: isErrored,
    options: months,
    onKeyDown: function onKeyDown(event) {
      return handleOnKeyDown(event);
    },
    onChange: function onChange(choice) {
      if (choice) {
        updateDischargeMonth(choice.value);
      } else {
        // clear the discharge month
        updateDischargeMonth(null);
      }
    },
    placeholder: intl.formatMessage({
      id: 'dateTime.month',
      defaultMessage: 'Month'
    }),
    suppressPlaceholder: false,
    value: dischargeDateMonth ? months[dischargeDateMonth - 1] : undefined,
    buttonRef: "inputSelectButtonDischargeDate"
  }), React.createElement(InputTextComponent, {
    className: "sid-discharge-date__year",
    id: "discharge-date-year",
    isErrored: isErrored,
    max: thisYear,
    min: minDischargeYear,
    onBlur: getDischargeDate,
    onChange: function onChange(e) {
      return updateDischargeYear(e.target.value);
    },
    pattern: "\\d*",
    placeholder: intl.formatMessage({
      id: 'dateTime.year',
      defaultMessage: 'Year'
    }),
    hidePlaceholder: false,
    refId: "dischargeDateYear",
    required: true,
    value: dischargeDateYear || ''
  })), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidDischargeDate",
    defaultMessage: "Invalid discharge date"
  })) : null);
};

DischargeDate.defaultProps = {
  value: '2000-01-01'
};
var DischargeDateComponent = injectIntl(DischargeDate);
/**
 * TODO - preamble
 */

var StepInactiveMilitaryPersonalInfo = function StepInactiveMilitaryPersonalInfo(_ref116) {
  var intl = _ref116.intl,
      verificationService = _ref116.verificationService;
  var viewModel = verificationService.viewModel;
  var previousViewModel = verificationService.previousViewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);
  var availableStatuses = getAvailableMilitaryStatuses(verificationService, intl);

  var updateInactiveMilitaryViewModel = function updateInactiveMilitaryViewModel(key, value) {
    verificationService.updateViewModel(updateMilitaryViewModel(key, value, verificationService, availableStatuses));
  };

  var submitStep = function submitStep() {
    var nextState = fn(viewModel, function () {});
    logger.info('StepMilitaryStatusComponent submitting form');
    verificationService.submitStep(VerificationStepsEnum.collectMilitaryStatus, nextState, verificationService.previousVerificationResponse || verificationService.verificationResponse);
  };

  if (viewModel.status && previousViewModel && previousViewModel.status !== viewModel.status || viewModel.status && verificationService.verificationResponse.currentStep === VerificationStepsEnum.collectMilitaryStatus) {
    submitStep();
  } // Refs should be reset to ensure the field order isn't affected by the previous step


  resetRefs();
  return React.createElement("div", {
    id: "sid-step-inactive-military-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name & Birthdate"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "\n                                Enter your first and last name on the form as it appears on your military document(s).\n                                Keep in mind that may be your given name."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Military-Only Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you're a member of the armed forces."
  }), "\xA0", React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement(CountryComponentWrapper, {
    verificationService: verificationService,
    viewModel: viewModel,
    nextFocusField: "status"
  }), availableStatuses ? React.createElement(MilitaryStatusComponent, {
    value: {
      value: viewModel.status,
      label: getStatusLabel(intl, viewModel.status, MilitaryStatusDefaultMessagesEnum)
    },
    isErrored: !!fieldValidationErrors.status,
    options: availableStatuses,
    onChange: function onChange(status) {
      updateInactiveMilitaryViewModel('status', status ? status.value : '');
      updateFieldValidationErrorsByFieldId('status', status ? status.value : '', verificationService);
    }
  }) : null, React.createElement(BranchOfServiceComponent, {
    isErrored: !!fieldValidationErrors.organization,
    onChange: function onChange(choice) {
      updateViewModelOrganization(choice, verificationService);
      updateFieldValidationErrorsByFieldId('organization', choice, verificationService);
    },
    value: {
      value: verificationService.viewModel.organization.id,
      label: verificationService.viewModel.organization.name
    },
    verificationService: verificationService,
    organizations: verificationService.orgList
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateInactiveMilitaryViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateInactiveMilitaryViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateInactiveMilitaryViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(DischargeDateComponent, {
    isErrored: !!fieldValidationErrors.dischargeDate,
    onChange: function onChange(newValue) {
      updateInactiveMilitaryViewModel('dischargeDate', newValue);
      updateFieldValidationErrorsByFieldId('dischargeDate', newValue, verificationService);
    },
    value: viewModel.dischargeDate
  }), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Personal email address is recommended"
    }),
    onChange: function onChange(newValue) {
      updateInactiveMilitaryViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateInactiveMilitaryViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateInactiveMilitaryViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectInactiveMilitaryPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyMilitaryStatus",
    defaultMessage: "Verify My Military Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepInactiveMilitaryPersonalInfoComponent = injectIntl(StepInactiveMilitaryPersonalInfo);

var FirstResponderStatus = function FirstResponderStatus(_ref117) {
  var value = _ref117.value,
      isErrored = _ref117.isErrored,
      options = _ref117.options,
      _onChange20 = _ref117.onChange,
      _ref117$placeholder = _ref117.placeholder,
      placeholder = _ref117$placeholder === void 0 ? '' : _ref117$placeholder,
      intl = _ref117.intl,
      _ref117$onKeyDown = _ref117.onKeyDown,
      onKeyDown = _ref117$onKeyDown === void 0 ? undefined : _ref117$onKeyDown;
  return React.createElement("div", {
    className: "sid-field sid-first-responder-status"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-first-responder-status"
  }, React.createElement("div", {
    id: "sid-first-responder-status-label",
    className: "sid-field__label sid-field__label--required sid-first-responder-status__label sid-l-space-btm-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "status",
    defaultMessage: "Status"
  }))), React.createElement(InputSelectComponent, {
    fieldId: "status",
    inputId: "sid-first-responder-status",
    isErrored: isErrored,
    options: options,
    onChange: function onChange(status) {
      return _onChange20(status);
    },
    onKeyDown: onKeyDown,
    value: value,
    placeholder: placeholder || intl.formatMessage({
      id: 'statusPlaceholder',
      defaultMessage: 'Status*'
    })
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidStatus",
    defaultMessage: "Invalid first responder status"
  })) : null);
};

var FirstResponderStatusComponent = injectIntl(FirstResponderStatus);

var FirstResponderOrganization = function FirstResponderOrganization(_ref118) {
  var _onChange21 = _ref118.onChange,
      value = _ref118.value,
      isErrored = _ref118.isErrored,
      verificationService = _ref118.verificationService,
      intl = _ref118.intl,
      _ref118$placeholder = _ref118.placeholder,
      placeholder = _ref118$placeholder === void 0 ? '' : _ref118$placeholder;
  var programId = verificationService.programId;
  return React.createElement("div", {
    className: "sid-field sid-first-responder-organization-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-first-responder-organization"
  }, React.createElement("div", {
    id: "sid-first-responder-organization-label",
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "organization",
    defaultMessage: "Organization"
  }))), React.createElement(TypeaheadComponent, {
    className: isErrored ? 'sid-text-input--error' : '',
    countryCode: getSafe(function () {
      return verificationService.viewModel.countryChoice.value;
    }),
    minimumSearchValueLength: getOptions().minimumOrganizationSearchLength,
    onChange: function onChange(choice) {
      return _onChange21(choice);
    },
    placeholder: placeholder || intl.formatMessage({
      id: 'organizationPlaceholder',
      defaultMessage: 'Organization*'
    }),
    programId: programId,
    value: value,
    inputHtmlId: "sid-first-responder-organization",
    openOrgSearchEnabled: verificationService.programTheme.openOrgSearchEnabled,
    orgSearchUrl: verificationService.programTheme.config.orgSearchUrl
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidOrganization",
    defaultMessage: "You must select an organization from the list"
  })) : null);
};

var FirstResponderOrganizationComponent = injectIntl(FirstResponderOrganization);
/**
 * TODO - preamble
 */

var StepFirstResponderPersonalInfo = function StepFirstResponderPersonalInfo(_ref119) {
  var intl = _ref119.intl,
      verificationService = _ref119.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  var updateFirstResponderViewModel = function updateFirstResponderViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  };

  var getAvailableFirstResponderStatuses = function getAvailableFirstResponderStatuses() {
    var availableStatusesResponse = verificationService.verificationResponse.availableStatuses;
    var availableStatuses = [];
    availableStatusesResponse.forEach(function (status) {
      availableStatuses.push({
        value: status,
        label: getStatusLabel(intl, status, FirstResponderStatusDefaultMessagesEnum)
      });
    });
    return availableStatuses;
  };

  var handleFirstResponderStatusOnKeyDown = function handleFirstResponderStatusOnKeyDown(event) {
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      setFocus('organization');
    }
  };

  var collectPostalCode = getSafe(function () {
    return verificationService.programTheme.openOrgSearchEnabled;
  }) && getSafe(function () {
    return viewModel.organization.id;
  }) === 0 && getSafe(function () {
    return viewModel.organization.name;
  }, '').length > 0;

  if (collectPostalCode) {
    viewModel.postalCode = viewModel.postalCode ? viewModel.postalCode : ''; // TODO Fixme. Don't side-effect the viewModel
  } else if (viewModel.postalCode || viewModel.postalCode === '') {
    delete viewModel.postalCode; // TODO Fixme. Don't side-effect the viewModel

    updateFieldValidationErrorsByFieldId('postalCode', undefined, verificationService);
  }

  return React.createElement("div", {
    id: "sid-step-active-first-responder-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name, Email & Organization"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "Your full name, organization name, and email must match what is on record with your agency."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this 1st Responder-Only Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you're an active first responder."
  })), React.createElement("div", {
    className: "sid-header__how-verifying-works sid-l-horz-center"
  }, React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement(CountryComponentWrapper, {
    verificationService: verificationService,
    viewModel: viewModel,
    nextFocusField: "status"
  }), React.createElement(FirstResponderStatusComponent, {
    value: {
      value: viewModel.status,
      label: getStatusLabel(intl, viewModel.status, FirstResponderStatusDefaultMessagesEnum)
    },
    isErrored: !!fieldValidationErrors.status,
    options: getAvailableFirstResponderStatuses(),
    onChange: function onChange(status) {
      updateFirstResponderViewModel('status', status ? status.value : '');
      updateFieldValidationErrorsByFieldId('status', status ? status.value : '', verificationService);

      if (status) {
        setFocus('organization');
      }
    },
    onKeyDown: function onKeyDown(event) {
      return handleFirstResponderStatusOnKeyDown(event);
    }
  }), React.createElement(FirstResponderOrganizationComponent, {
    isErrored: !!fieldValidationErrors.organization,
    onChange: function onChange(choice) {
      updateViewModelOrganization(choice, verificationService);
      updateFieldValidationErrorsByFieldId('organization', choice, verificationService);
    },
    value: verificationService.viewModel.organization,
    verificationService: verificationService
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateFirstResponderViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateFirstResponderViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateFirstResponderViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Needed to send you your unique code"
    }),
    onChange: function onChange(newValue) {
      updateFirstResponderViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateFirstResponderViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, collectPostalCode ? React.createElement(PostalCodeComponent, {
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateFirstResponderViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    },
    value: viewModel.postalCode
  }) : null, React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateFirstResponderViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectFirstResponderPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyFirstResponderStatus",
    defaultMessage: "Verify My First Responder Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepFirstResponderPersonalInfoComponent = injectIntl(StepFirstResponderPersonalInfo);

var MedicalStatus = function MedicalStatus(_ref120) {
  var value = _ref120.value,
      isErrored = _ref120.isErrored,
      options = _ref120.options,
      _onChange22 = _ref120.onChange,
      intl = _ref120.intl,
      _ref120$placeholder = _ref120.placeholder,
      placeholder = _ref120$placeholder === void 0 ? '' : _ref120$placeholder,
      _ref120$onKeyDown = _ref120.onKeyDown,
      onKeyDown = _ref120$onKeyDown === void 0 ? undefined : _ref120$onKeyDown;
  var id = 'sid-medical-status';
  return React.createElement("div", {
    className: "sid-field sid-medical-status"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: id
  }, React.createElement("div", {
    id: "".concat(id, "-label"),
    className: "sid-field__label sid-field__label--required sid-medical-status__label sid-l-space-btm-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "status",
    defaultMessage: "Status"
  }))), React.createElement(InputSelectComponent, {
    fieldId: "status",
    inputId: id,
    isErrored: isErrored,
    options: options,
    onChange: function onChange(status) {
      return _onChange22(status);
    },
    onKeyDown: onKeyDown,
    value: value,
    placeholder: placeholder || intl.formatMessage({
      id: 'statusPlaceholder',
      defaultMessage: 'Status*'
    }),
    isRequired: true
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidStatus",
    defaultMessage: "Invalid medical status"
  })) : null);
};

var MedicalStatusComponent = injectIntl(MedicalStatus);

var MedicalProfessionalOrganization = function MedicalProfessionalOrganization(_ref121) {
  var _onChange23 = _ref121.onChange,
      value = _ref121.value,
      isErrored = _ref121.isErrored,
      verificationService = _ref121.verificationService,
      intl = _ref121.intl,
      _ref121$placeholder = _ref121.placeholder,
      placeholder = _ref121$placeholder === void 0 ? '' : _ref121$placeholder;
  var programId = verificationService.programId;
  var id = 'sid-medical-professional-organization';
  return React.createElement("div", {
    className: "sid-field sid-medical-professional-organization-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: id
  }, React.createElement("div", {
    id: "".concat(id, "-label"),
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "organization",
    defaultMessage: "Organization"
  }))), React.createElement(TypeaheadComponent, {
    className: isErrored ? 'sid-text-input--error' : '',
    countryCode: getSafe(function () {
      return verificationService.viewModel.countryChoice.value;
    }),
    minimumSearchValueLength: getOptions().minimumOrganizationSearchLength,
    onChange: function onChange(choice) {
      return _onChange23(choice);
    },
    placeholder: placeholder || intl.formatMessage({
      id: 'organizationPlaceholder',
      defaultMessage: 'Organization*'
    }),
    programId: programId,
    value: value,
    inputHtmlId: id,
    openOrgSearchEnabled: verificationService.programTheme.openOrgSearchEnabled,
    orgSearchUrl: verificationService.programTheme.config.orgSearchUrl,
    isRequired: true
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidOrganization",
    defaultMessage: "You must select an organization from the list"
  })) : null);
};

var MedicalProfessionalOrganizationComponent = injectIntl(MedicalProfessionalOrganization);
/**
 * TODO - preamble
 */

var memberIdMessageKeysByCountry = {
  AT: 'gbrNummer',
  ES: 'numeroColegiado',
  DK: 'autorisationsId',
  CH: 'globalLocationNumber',
  IE: 'registrationNumber',
  GB: 'registrationNumber'
};

var StepMedicalProfessionalPersonalInfo = function StepMedicalProfessionalPersonalInfo(_ref122) {
  var intl = _ref122.intl,
      verificationService = _ref122.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  var _React$useState5 = React.useState(undefined),
      _React$useState6 = _slicedToArray2(_React$useState5, 2),
      memberIdMessageKeys = _React$useState6[0],
      setMemberIdMessageKeys = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray2(_React$useState7, 2),
      showMemberId = _React$useState8[0],
      setShowMemberId = _React$useState8[1];

  var updateMedicalProfessionalViewModel = function updateMedicalProfessionalViewModel(key, value) {
    var nextState = produceDraftViewModel(viewModel, key, value);
    verificationService.updateViewModel(nextState);
  };

  var getAvailableMedicalStatuses = function getAvailableMedicalStatuses() {
    var availableStatusesResponse = verificationResponse.availableStatuses;
    var availableStatuses = [];
    availableStatusesResponse.forEach(function (status) {
      availableStatuses.push({
        value: status,
        label: getStatusLabel(intl, status, MedicalProfessionalStatusDefaultMessagesEnum)
      });
    });
    return availableStatuses;
  };

  var handleMedicalStatusOnKeyDown = function handleMedicalStatusOnKeyDown(event) {
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      setFocus('organization');
    }
  };

  React.useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
      var collectFieldsResponse, optionalFields, memberIdFieldType;
      return _regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              if (!(viewModel.country && viewModel.status)) {
                _context34.next = 12;
                break;
              }

              _context34.prev = 1;
              _context34.next = 4;
              return getFieldsToCollect(verificationResponse.verificationId, verificationResponse.currentStep, viewModel);

            case 4:
              collectFieldsResponse = _context34.sent;
              optionalFields = getSafe(function () {
                return collectFieldsResponse.fieldsToCollect.optional;
              }, []);
              setShowMemberId(optionalFields.some(function (field) {
                return field.key === 'memberId';
              }));
              _context34.next = 12;
              break;

            case 9:
              _context34.prev = 9;
              _context34.t0 = _context34["catch"](1);
              logger.error("Failed to determine fields to collect: ".concat(_context34.t0));

            case 12:
              memberIdFieldType = memberIdMessageKeysByCountry[viewModel.country] ? memberIdMessageKeysByCountry[viewModel.country] : 'registrationNumber';

              if (memberIdFieldType) {
                setMemberIdMessageKeys({
                  labelKey: "step.collectMedicalPersonalInfo.".concat(memberIdFieldType, "Label"),
                  explanationKey: "step.collectMedicalPersonalInfo.".concat(memberIdFieldType, "Explanation")
                });
              }

            case 14:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34, null, [[1, 9]]);
    }))();
  }, [viewModel.country, viewModel.status]);
  return React.createElement("div", {
    id: "sid-step-active-medical-professional-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name, Email & Organization"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "Your full name, organization name, and email must match what is on record with your agency."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Medical Professional-Only Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you're a licensed medical professional."
  })), React.createElement("div", {
    className: "sid-header__how-verifying-works sid-l-horz-center"
  }, React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement(CountryComponentWrapper, {
    verificationService: verificationService,
    viewModel: viewModel
  }), React.createElement(MedicalStatusComponent, {
    value: {
      value: viewModel.status,
      label: getStatusLabel(intl, viewModel.status, MedicalProfessionalStatusDefaultMessagesEnum)
    },
    isErrored: !!fieldValidationErrors.status,
    options: getAvailableMedicalStatuses(),
    onChange: function onChange(status) {
      updateMedicalProfessionalViewModel('status', status ? status.value : '');
      updateFieldValidationErrorsByFieldId('status', status ? status.value : '', verificationService);

      if (status) {
        setFocus('organization');
      }
    },
    onKeyDown: function onKeyDown(event) {
      return handleMedicalStatusOnKeyDown(event);
    }
  }), React.createElement(MedicalProfessionalOrganizationComponent, {
    isErrored: !!fieldValidationErrors.organization,
    onChange: function onChange(choice) {
      updateViewModelOrganization(choice, verificationService);
      updateFieldValidationErrorsByFieldId('organization', choice, verificationService);
    },
    value: verificationService.viewModel.organization,
    verificationService: verificationService
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateMedicalProfessionalViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateMedicalProfessionalViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateMedicalProfessionalViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(PostalCodeComponent, {
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateMedicalProfessionalViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    },
    value: viewModel.postalCode,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "postalCodeExplanation",
      defaultMessage: "Use the location on file with your licensing body"
    })
  }), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Needed to send you your unique code"
    }),
    onChange: function onChange(newValue) {
      updateMedicalProfessionalViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateMedicalProfessionalViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, showMemberId && React.createElement(MemberIdComponent, {
    value: viewModel.memberId,
    isErrored: !!fieldValidationErrors.memberId,
    isRequired: false,
    onChange: function onChange(newValue) {
      updateMedicalProfessionalViewModel('memberId', newValue);
      updateFieldValidationErrorsByFieldId('memberId', newValue, verificationService);
    },
    explanation: memberIdMessageKeys && React.createElement(FormattedHTMLMessage, {
      id: memberIdMessageKeys.explanationKey,
      defaultMessage: "Your Professional Membership Registration Number"
    }),
    label: memberIdMessageKeys && React.createElement(FormattedHTMLMessage, {
      id: memberIdMessageKeys.labelKey,
      defaultMessage: "Registration Number"
    })
  }), React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateMedicalProfessionalViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectMedicalProfessionalPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyMedicalProfessionalStatus",
    defaultMessage: "Verify My Medical Professional Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepMedicalProfessionalPersonalInfoComponent = injectIntl(StepMedicalProfessionalPersonalInfo);

var State = function State(_ref124) {
  var value = _ref124.value,
      isErrored = _ref124.isErrored,
      _onChange24 = _ref124.onChange,
      intl = _ref124.intl,
      _ref124$onKeyDown = _ref124.onKeyDown,
      onKeyDown = _ref124$onKeyDown === void 0 ? undefined : _ref124$onKeyDown,
      _ref124$placeholder = _ref124.placeholder,
      placeholder = _ref124$placeholder === void 0 ? '' : _ref124$placeholder;
  return React.createElement("div", {
    className: "sid-field sid-state"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-state"
  }, React.createElement("div", {
    className: "sid-field__label sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required"
  }, React.createElement(FormattedHTMLMessage, {
    id: "state",
    defaultMessage: "State"
  })))), React.createElement(InputTextComponent, {
    id: "state",
    isErrored: isErrored,
    onChange: function onChange(e) {
      return _onChange24(e.target.value);
    },
    onKeyDown: typeof onKeyDown === 'function' ? function (e) {
      return onKeyDown(e);
    } : undefined,
    placeholder: placeholder || intl.formatMessage({
      id: 'statePlaceholder',
      defaultMessage: 'State*'
    }),
    value: value
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidState",
    defaultMessage: "Invalid state"
  })) : null);
};

var StateComponent = injectIntl(State);

var Company = function Company(_ref125) {
  var _onChange25 = _ref125.onChange,
      value = _ref125.value,
      isErrored = _ref125.isErrored,
      verificationService = _ref125.verificationService,
      intl = _ref125.intl,
      _ref125$placeholder = _ref125.placeholder,
      placeholder = _ref125$placeholder === void 0 ? '' : _ref125$placeholder;
  var programId = verificationService.programId;
  return React.createElement("div", {
    className: "sid-field sid-company-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-company"
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement(FormattedHTMLMessage, {
    id: "company",
    defaultMessage: "Company"
  }))), React.createElement(TypeaheadComponent, {
    className: isErrored ? 'sid-text-input--error' : '',
    countryCode: getSafe(function () {
      return verificationService.viewModel.countryChoice.value;
    }),
    minimumSearchValueLength: getOptions().minimumOrganizationSearchLength,
    onChange: function onChange(choice) {
      return _onChange25(choice);
    },
    placeholder: placeholder || intl.formatMessage({
      id: 'companyPlaceholder',
      defaultMessage: 'Company*'
    }),
    programId: programId,
    value: value,
    inputHtmlId: "sid-company",
    openOrgSearchEnabled: verificationService.programTheme.openOrgSearchEnabled,
    orgSearchUrl: verificationService.programTheme.config.orgSearchUrl
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidOrganization",
    defaultMessage: "You must select an organization from the list"
  })) : null);
};

var CompanyComponent = injectIntl(Company);
/**
 * TODO - preamble
 */

var StepEmploymentPersonalInfo = function StepEmploymentPersonalInfo(_ref126) {
  var verificationService = _ref126.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;

  var updateEmploymentViewModel = function updateEmploymentViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  };

  return React.createElement("div", {
    id: "sid-step-employment-personal-info",
    className: "sid-l-container"
  }, React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Employment-Only Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you're a current employee at an eligible company."
  }), "\xA0", React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement(CountryComponentWrapper, {
    verificationService: verificationService,
    viewModel: viewModel,
    nextFocusField: "organization",
    viewModelDraftDecorator: function viewModelDraftDecorator(draft, countryChoice) {
      var viewModel = draft;
      viewModel.shouldCollectAddress = shouldCollectAddressFields(countryChoice, verificationService.programTheme.config.countries);

      if (!viewModel.shouldCollectAddress) {
        viewModel.address1 = '';
        viewModel.city = '';
        viewModel.state = '';
        viewModel.postalCode = '';
        viewModel.fieldsToSkipValidation = ['address1', 'city', 'state', 'postalCode'];
      } else {
        viewModel.fieldsToSkipValidation = undefined;
      }
    }
  }), React.createElement(CompanyComponent, {
    value: verificationService.viewModel.organization,
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.organization,
    onChange: function onChange(choice) {
      updateViewModelOrganization(choice, verificationService);
      updateFieldValidationErrorsByFieldId('organization', choice, verificationService);
    }
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateEmploymentViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateEmploymentViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), shouldCollectAddressFields(viewModel.countryChoice, verificationService.programTheme.config.countries) ? React.createElement(AddressComponent, {
    isErrored: !!fieldValidationErrors.address1,
    errorId: fieldValidationErrors.address1,
    onChange: function onChange(newValue) {
      updateEmploymentViewModel('address1', newValue);
      updateFieldValidationErrorsByFieldId('address1', newValue, verificationService);
    },
    value: viewModel.address1
  }) : null, shouldCollectAddressFields(viewModel.countryChoice, verificationService.programTheme.config.countries) ? React.createElement("div", {
    className: "sid-thirds"
  }, React.createElement(CityComponent, {
    isErrored: !!fieldValidationErrors.city,
    errorId: fieldValidationErrors.city,
    onChange: function onChange(newValue) {
      updateEmploymentViewModel('city', newValue);
      updateFieldValidationErrorsByFieldId('city', newValue, verificationService);
    },
    value: viewModel.city
  }), React.createElement(StateComponent, {
    isErrored: !!fieldValidationErrors.state,
    errorId: fieldValidationErrors.state,
    onChange: function onChange(newValue) {
      updateEmploymentViewModel('state', newValue);
      updateFieldValidationErrorsByFieldId('state', newValue, verificationService);
    },
    value: viewModel.state
  }), React.createElement(PostalCodeComponent, {
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateEmploymentViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    },
    value: viewModel.postalCode
  })) : null, React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "employment.emailExplanation",
      defaultMessage: "Use your work email if you have one"
    }),
    onChange: function onChange(newValue) {
      updateEmploymentViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateEmploymentViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateEmploymentViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-wrapper__collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectEmployeePersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-label": "submit",
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, React.createElement(FormattedHTMLMessage, {
    id: "verifyMyEmploymentStatus",
    defaultMessage: "Verify My Employment Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
}; // TODO remove injectIntl, unused


var StepEmploymentPersonalInfoComponent = injectIntl(StepEmploymentPersonalInfo);

var DriverLicenseNumber = function DriverLicenseNumber(_ref127) {
  var value = _ref127.value,
      isErrored = _ref127.isErrored,
      _onChange26 = _ref127.onChange,
      explanation = _ref127.explanation,
      intl = _ref127.intl,
      _ref127$placeholder = _ref127.placeholder,
      placeholder = _ref127$placeholder === void 0 ? '' : _ref127$placeholder,
      _ref127$isRequired = _ref127.isRequired,
      isRequired = _ref127$isRequired === void 0 ? false : _ref127$isRequired;

  var getDefaultExplanation = function getDefaultExplanation() {
    return !isRequired ? React.createElement(FormattedHTMLMessage, {
      id: "optional",
      defaultMessage: "Optional"
    }) : '';
  };

  return React.createElement("div", {
    className: "sid-field sid-driver-license-number"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-driver-license-number"
  }, React.createElement("div", {
    className: "sid-field__label-with-explanation sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement("div", {
    className: "sid-field__label".concat(isRequired ? ' sid-field__label--required' : '', " ")
  }, React.createElement(FormattedHTMLMessage, {
    id: "driverLicenseNumber",
    defaultMessage: "Driver license number"
  })), React.createElement("div", {
    className: "sid-field__label-explanation"
  }, explanation || getDefaultExplanation()))), React.createElement(InputTextComponent, {
    id: "driver-license-number",
    isErrored: isErrored,
    onChange: function onChange(e) {
      return _onChange26(e.target.value);
    },
    placeholder: placeholder || intl.formatMessage({
      id: 'driverLicenseNumberPlaceholder',
      defaultMessage: isRequired ? 'Driver license number*' : 'Driver license number'
    }),
    refId: "driverLicenseNumber",
    value: value
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidDriverLicenseNumber",
    defaultMessage: "Invalid driver license number"
  })) : null);
};

var DriverLicenseNumberComponent = injectIntl(DriverLicenseNumber);

var StateSelect = function StateSelect(_ref128) {
  var value = _ref128.value,
      isErrored = _ref128.isErrored,
      options = _ref128.options,
      _onChange27 = _ref128.onChange,
      onKeyDown = _ref128.onKeyDown,
      intl = _ref128.intl,
      _ref128$placeholder = _ref128.placeholder,
      placeholder = _ref128$placeholder === void 0 ? '' : _ref128$placeholder,
      _ref128$label = _ref128.label,
      label = _ref128$label === void 0 ? '' : _ref128$label,
      _ref128$isRequired = _ref128.isRequired,
      isRequired = _ref128$isRequired === void 0 ? false : _ref128$isRequired;
  return React.createElement("div", {
    className: "sid-field sid-state"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-state"
  }, React.createElement("div", {
    className: "sid-field__label sid-state__label sid-l-space-btm-sm".concat(isRequired ? ' sid-field__label--required' : '')
  }, label || React.createElement(FormattedHTMLMessage, {
    id: "state",
    defaultMessage: "State where you live"
  }))), React.createElement(InputSelectComponent, {
    fieldId: "state",
    inputId: "sid-state",
    isErrored: isErrored,
    options: options,
    onChange: function onChange(state) {
      return _onChange27(state);
    },
    onKeyDown: onKeyDown,
    placeholder: placeholder || intl.formatMessage({
      id: 'statePlaceholder',
      defaultMessage: isRequired ? 'State*' : 'State'
    }),
    value: value ? {
      value: value.value,
      label: intl.formatMessage({
        id: "states.".concat(value.value),
        defaultMessage: value.label || value.value
      })
    } : undefined
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidState",
    defaultMessage: "Invalid state"
  })) : null);
};

var StateSelectComponent = injectIntl(StateSelect);
/**
 * TODO - preamble
 */

var StepDriverLicensePersonalInfo = function StepDriverLicensePersonalInfo(_ref129) {
  var intl = _ref129.intl,
      verificationService = _ref129.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  var updateIdentityViewModel = function updateIdentityViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  }; // Refs should be reset to ensure the field order isn't affected by the previous step


  resetRefs();
  return React.createElement("div", {
    id: "sid-step-driver-license-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name and other fields"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "\n                                    Enter your first and last name on the form as it appears on your official document(s).\n                                    Keep in mind that may be your given name."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Special Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you have a valid driver license"
  })), React.createElement("div", {
    className: "sid-header__how-verifying-works sid-l-horz-center"
  }, React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Personal email address is recommended"
    }),
    onChange: function onChange(newValue) {
      updateIdentityViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(StateSelectComponent, {
    isRequired: true,
    options: getAvailableStateChoices(verificationService.programTheme, intl),
    value: viewModel.state || undefined,
    isErrored: Boolean(fieldValidationErrors.state),
    onChange: function () {
      var _onChange28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(stateChoice) {
        var stateValue;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                stateValue = stateChoice ? stateChoice.value : undefined;
                updateIdentityViewModel('state', stateValue);
                updateFieldValidationErrorsByFieldId('state', stateValue, verificationService);

              case 3:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35);
      }));

      function onChange(_x71) {
        return _onChange28.apply(this, arguments);
      }

      return onChange;
    }(),
    label: React.createElement(FormattedHTMLMessage, {
      id: "driverLicenseState",
      defaultMessage: "Driver license state"
    })
  }), React.createElement(DriverLicenseNumberComponent, {
    value: viewModel.driverLicenseNumber,
    isErrored: !!fieldValidationErrors.driverLicenseNumber,
    isRequired: true,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('driverLicenseNumber', newValue);
      updateFieldValidationErrorsByFieldId('driverLicenseNumber', newValue, verificationService);
    }
  }), React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectDriverLicensePersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyIdentityStatus",
    defaultMessage: "Verify My Identity"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepDriverLicensePersonalInfoComponent = injectIntl(StepDriverLicensePersonalInfo);
/**
 * TODO - preamble
 */

var StepGeneralIdentityPersonalInfo = function StepGeneralIdentityPersonalInfo(_ref130) {
  var intl = _ref130.intl,
      verificationService = _ref130.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  var updateIdentityViewModel = function updateIdentityViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  }; // Refs should be reset to ensure the field order isn't affected by the previous step


  resetRefs();
  return React.createElement("div", {
    id: "sid-step-general-identity-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name and other fields"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "\n                                    Enter your first and last name on the form as it appears on your official document(s).\n                                    Keep in mind that may be your given name."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Special Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify your identity"
  })), React.createElement("div", {
    className: "sid-header__how-verifying-works sid-l-horz-center"
  }, React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Personal email address is recommended"
    }),
    onChange: function onChange(newValue) {
      updateIdentityViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(AddressComponent, {
    isErrored: !!fieldValidationErrors.address1,
    errorId: fieldValidationErrors.address1,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('address1', newValue);
      updateFieldValidationErrorsByFieldId('address1', newValue, verificationService);
    },
    value: viewModel.address1
  }), React.createElement("div", {
    className: "sid-thirds"
  }, React.createElement(CityComponent, {
    isErrored: !!fieldValidationErrors.city,
    errorId: fieldValidationErrors.city,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('city', newValue);
      updateFieldValidationErrorsByFieldId('city', newValue, verificationService);
    },
    value: viewModel.city
  }), React.createElement(StateSelectComponent, {
    isRequired: true,
    options: getAvailableStateChoices(verificationService.programTheme, intl),
    value: viewModel.state || undefined,
    isErrored: Boolean(fieldValidationErrors.state),
    onChange: function () {
      var _onChange29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(stateChoice) {
        var stateValue;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                stateValue = stateChoice ? stateChoice.value : undefined;
                updateIdentityViewModel('state', stateValue);
                updateFieldValidationErrorsByFieldId('state', stateValue, verificationService);

              case 3:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36);
      }));

      function onChange(_x72) {
        return _onChange29.apply(this, arguments);
      }

      return onChange;
    }()
  }), React.createElement(PostalCodeComponent, {
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    },
    value: viewModel.postalCode
  })), React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectGeneralIdentityPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyIdentityStatus",
    defaultMessage: "Verify My Identity"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepGeneralIdentityPersonalInfoComponent = injectIntl(StepGeneralIdentityPersonalInfo);
/**
 * TODO - preamble
 */

var StepHybridIdentityPersonalInfo = function StepHybridIdentityPersonalInfo(_ref131) {
  var intl = _ref131.intl,
      verificationService = _ref131.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  var updateIdentityViewModel = function updateIdentityViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  }; // Refs should be reset to ensure the field order isn't affected by the previous step


  resetRefs();
  return React.createElement("div", {
    id: "sid-step-hybrid-identity-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name and other fields"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "\n                                    Enter your first and last name on the form as it appears on your official document(s).\n                                    Keep in mind that may be your given name."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Special Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify your identity"
  })), React.createElement("div", {
    className: "sid-header__how-verifying-works sid-l-horz-center"
  }, React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Personal email address is recommended"
    }),
    onChange: function onChange(newValue) {
      updateIdentityViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(AddressComponent, {
    isErrored: !!fieldValidationErrors.address1,
    errorId: fieldValidationErrors.address1,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('address1', newValue);
      updateFieldValidationErrorsByFieldId('address1', newValue, verificationService);
    },
    value: viewModel.address1
  }), React.createElement("div", {
    className: "sid-thirds"
  }, React.createElement(CityComponent, {
    isErrored: !!fieldValidationErrors.city,
    errorId: fieldValidationErrors.city,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('city', newValue);
      updateFieldValidationErrorsByFieldId('city', newValue, verificationService);
    },
    value: viewModel.city
  }), React.createElement(StateSelectComponent, {
    isRequired: true,
    options: getAvailableStateChoices(verificationService.programTheme, intl),
    value: viewModel.state || undefined,
    isErrored: Boolean(fieldValidationErrors.state),
    onChange: function () {
      var _onChange30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(stateChoice) {
        var stateValue;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                stateValue = stateChoice ? stateChoice.value : undefined;
                updateIdentityViewModel('state', stateValue);
                updateFieldValidationErrorsByFieldId('state', stateValue, verificationService);

              case 3:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37);
      }));

      function onChange(_x73) {
        return _onChange30.apply(this, arguments);
      }

      return onChange;
    }()
  }), React.createElement(PostalCodeComponent, {
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    },
    value: viewModel.postalCode
  })), React.createElement(DriverLicenseNumberComponent, {
    value: viewModel.driverLicenseNumber,
    isErrored: !!fieldValidationErrors.driverLicenseNumber,
    isRequired: true,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('driverLicenseNumber', newValue);
      updateFieldValidationErrorsByFieldId('driverLicenseNumber', newValue, verificationService);
    }
  }), React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateIdentityViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectHybridIdentityPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyIdentityStatus",
    defaultMessage: "Verify My Identity"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepHybridIdentityPersonalInfoComponent = injectIntl(StepHybridIdentityPersonalInfo);

var Status = function Status(_ref132) {
  var value = _ref132.value,
      isErrored = _ref132.isErrored,
      options = _ref132.options,
      _onChange31 = _ref132.onChange,
      intl = _ref132.intl,
      _ref132$placeholder = _ref132.placeholder,
      placeholder = _ref132$placeholder === void 0 ? '' : _ref132$placeholder,
      _ref132$onKeyDown = _ref132.onKeyDown,
      onKeyDown = _ref132$onKeyDown === void 0 ? undefined : _ref132$onKeyDown,
      _ref132$segmentId = _ref132.segmentId,
      segmentId = _ref132$segmentId === void 0 ? '' : _ref132$segmentId;
  var id = "sid-".concat(segmentId, "-status");
  return React.createElement("div", {
    className: "sid-field sid-".concat(segmentId, "-status")
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: id
  }, React.createElement("div", {
    id: "".concat(id, "-label"),
    className: "sid-field__label sid-field__label--required sid-".concat(segmentId, "-status__label sid-l-space-btm-sm")
  }, React.createElement(FormattedHTMLMessage, {
    id: "status",
    defaultMessage: "Status"
  }))), React.createElement(InputSelectComponent, {
    fieldId: "status",
    inputId: id,
    isErrored: isErrored,
    options: options,
    onChange: function onChange(status) {
      return _onChange31(status);
    },
    onKeyDown: onKeyDown,
    value: value,
    placeholder: placeholder || intl.formatMessage({
      id: 'statusPlaceholder',
      defaultMessage: 'Status*'
    }),
    isRequired: true
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidStatus",
    defaultMessage: "Invalid status"
  })) : null);
};

var StatusComponent = injectIntl(Status);

var LicensedProfessionalOrganization = function LicensedProfessionalOrganization(_ref133) {
  var value = _ref133.value,
      isErrored = _ref133.isErrored,
      _onChange32 = _ref133.onChange,
      verificationService = _ref133.verificationService,
      intl = _ref133.intl,
      _ref133$placeholder = _ref133.placeholder,
      placeholder = _ref133$placeholder === void 0 ? '' : _ref133$placeholder;
  var programId = verificationService.programId;
  return React.createElement("div", {
    className: "sid-field sid-licensed-professional-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-licensed-professional"
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "organization",
    defaultMessage: "Organization or Licensing Body"
  }))), React.createElement(TypeaheadComponent, {
    className: isErrored ? 'sid-text-input--error' : '',
    countryCode: getSafe(function () {
      return verificationService.viewModel.countryChoice.value;
    }),
    onChange: function onChange(choice) {
      return _onChange32(choice);
    },
    minimumSearchValueLength: getOptions().minimumOrganizationSearchLength,
    placeholder: placeholder || intl.formatMessage({
      id: 'organizationNamePlaceholder',
      defaultMessage: 'Organization*'
    }),
    programId: programId,
    value: value,
    inputHtmlId: "sid-licensed-professional",
    openOrgSearchEnabled: verificationService.programTheme.openOrgSearchEnabled,
    orgSearchUrl: verificationService.programTheme.config.orgSearchUrl
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidOrganization",
    defaultMessage: "You must select an organization from the list"
  })) : null);
};

var LicensedProfessionalOrganizationComponent = injectIntl(LicensedProfessionalOrganization);
var SEGMENT_ID = 'licensed-professional';
var defaultStatusMessages = {
  LICENSED_COSMETOLOGIST: 'Licensed Cosmetologist',
  LICENSED_REAL_ESTATE_AGENT: 'Licensed Real Estate Agent',
  VETERINARIAN: 'Veterinarian'
};

var StepLicensedProfessionalPersonalInfo = function StepLicensedProfessionalPersonalInfo(_ref134) {
  var intl = _ref134.intl,
      verificationService = _ref134.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  var updateLicensedProfessionalViewModel = function updateLicensedProfessionalViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  };

  var getStatusLabel = function getStatusLabel(status) {
    if (!status) {
      return '';
    }

    return intl.formatMessage({
      id: status,
      defaultMessage: defaultStatusMessages[status]
    });
  };

  var getAvailableLicensedProfessionalStatuses = function getAvailableLicensedProfessionalStatuses() {
    var availableStatusesResponse = verificationResponse.availableStatuses;
    var availableStatuses = [];

    if (availableStatusesResponse) {
      var _iterator3 = _createForOfIteratorHelper(availableStatusesResponse),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var status = _step3.value;
          availableStatuses.push({
            value: status,
            label: getStatusLabel(status)
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    return availableStatuses;
  };

  var handleLicensedProfessionalStatusOnKeyDown = function handleLicensedProfessionalStatusOnKeyDown(event) {
    if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();
      setFocus('organization');
    }
  };

  return React.createElement("div", {
    id: "sid-step-licensed-professional-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("p", null, "Failied instant match") : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title***",
    defaultMessage: "Unlock this Special Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle***",
    defaultMessage: "Verify you have a professional license in your field."
  })), React.createElement("div", {
    className: "sid-header__how-verifying-works sid-l-horz-center"
  }, React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement(StatusComponent, {
    segmentId: SEGMENT_ID,
    value: {
      value: viewModel.statuses ? viewModel.statuses[0] : '',
      label: viewModel.statuses ? getStatusLabel(viewModel.statuses[0]) : ''
    },
    isErrored: !!fieldValidationErrors.statuses,
    options: getAvailableLicensedProfessionalStatuses(),
    onChange: function onChange(status) {
      var updatedStatuses = status ? [status.value] : [];
      updateLicensedProfessionalViewModel('statuses', updatedStatuses);
      updateFieldValidationErrorsByFieldId('statuses', status ? status.value : '', verificationService);

      if (status) {
        setFocus('organization');
      }
    },
    onKeyDown: function onKeyDown(event) {
      return handleLicensedProfessionalStatusOnKeyDown(event);
    }
  }), React.createElement(LicensedProfessionalOrganizationComponent, {
    isErrored: !!fieldValidationErrors.organization,
    onChange: function onChange(choice) {
      updateViewModelOrganization(choice, verificationService);
      updateFieldValidationErrorsByFieldId('organization', choice, verificationService);
    },
    value: verificationService.viewModel.organization,
    verificationService: verificationService
  }), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateLicensedProfessionalViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateLicensedProfessionalViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(BirthDateComponent, {
    isErrored: !!fieldValidationErrors.birthDate,
    errorId: fieldValidationErrors.birthDate,
    onChange: function onChange(newValue) {
      updateLicensedProfessionalViewModel('birthDate', newValue);
      updateFieldValidationErrorsByFieldId('birthDate', newValue, verificationService);
    },
    value: viewModel.birthDate
  }), React.createElement(PostalCodeComponent, {
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateLicensedProfessionalViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    },
    value: viewModel.postalCode,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "postalCodeExplanation",
      defaultMessage: "Use the location on file with your licensing body"
    })
  }), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Needed to send you your unique code"
    }),
    onChange: function onChange(newValue) {
      updateLicensedProfessionalViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateLicensedProfessionalViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-btn-collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectLicensedProfessionalPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyLicensedProfessionalStatus",
    defaultMessage: "Verify My Licensed Professional Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepLicensedProfessionalPersonalInfoComponent = injectIntl(StepLicensedProfessionalPersonalInfo);

var StepMoverPersonalInfo = function StepMoverPersonalInfo(_ref135) {
  var verificationService = _ref135.verificationService;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var verificationResponse = verificationService.verificationResponse;
  var failedInstantMatch = hasFailedInstantMatch(verificationResponse);

  var updateMoverViewModel = function updateMoverViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  }; // We do not want a drop down list, just apply available statuses to the viewModel


  useEffect(function () {
    updateMoverViewModel('statuses', verificationResponse.availableStatuses);
  }, []);
  return React.createElement("div", {
    id: "sid-step-mover-personal-info",
    className: "sid-l-container"
  }, failedInstantMatch ? React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.title",
    defaultMessage: "Check Your Name & Address"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-header__subtitle--error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.tryAgain.subtitle",
    defaultMessage: "Your full name and address must match what is on your official documentation."
  }))) : React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.title",
    defaultMessage: "Unlock this Special Offer",
    tagName: "h1"
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.personalInfo.subtitle",
    defaultMessage: "Verify you have recently moved."
  }), React.createElement("br", null), React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  }), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }))), React.createElement("div", {
    className: "sid-names"
  }, React.createElement(FirstNameComponent, {
    value: viewModel.firstName,
    isErrored: !!fieldValidationErrors.firstName,
    onChange: function onChange(newValue) {
      updateMoverViewModel('firstName', newValue);
      updateFieldValidationErrorsByFieldId('firstName', newValue, verificationService);
    }
  }), React.createElement(LastNameComponent, {
    value: viewModel.lastName,
    isErrored: !!fieldValidationErrors.lastName,
    onChange: function onChange(newValue) {
      updateMoverViewModel('lastName', newValue);
      updateFieldValidationErrorsByFieldId('lastName', newValue, verificationService);
    }
  })), React.createElement(AddressComponent, {
    value: viewModel.address1,
    isErrored: !!fieldValidationErrors.address1,
    errorId: fieldValidationErrors.address1,
    onChange: function onChange(newValue) {
      updateMoverViewModel('address1', newValue);
      updateFieldValidationErrorsByFieldId('address1', newValue, verificationService);
    }
  }), React.createElement(PostalCodeComponent, {
    value: viewModel.postalCode,
    isErrored: !!fieldValidationErrors.postalCode,
    onChange: function onChange(newValue) {
      updateMoverViewModel('postalCode', newValue);
      updateFieldValidationErrorsByFieldId('postalCode', newValue, verificationService);
    }
  }), React.createElement(EmailComponent, {
    value: viewModel.email,
    isErrored: !!fieldValidationErrors.email,
    explanation: React.createElement(FormattedHTMLMessage, {
      id: "emailExplanation",
      defaultMessage: "Needed to send you your unique code"
    }),
    onChange: function onChange(newValue) {
      updateMoverViewModel('email', newValue);
      updateFieldValidationErrorsByFieldId('email', newValue, verificationService);
    },
    onKeyDown: function onKeyDown(event) {
      return handleEmailOnKeyDown(event);
    }
  }), verificationService.programTheme.isSmsNotifierConfigured || verificationService.programTheme.smsLoopEnabled ? React.createElement(PhoneNumberComponent, {
    isRequired: !!verificationService.programTheme.smsLoopEnabled,
    value: viewModel.phoneNumber,
    isErrored: !!fieldValidationErrors.phoneNumber,
    onChange: function onChange(newValue) {
      updateMoverViewModel('phoneNumber', newValue);
      updateFieldValidationErrorsByFieldId('phoneNumber', newValue, verificationService);
    }
  }) : null, React.createElement(MarketConsentWrapperComponent, {
    verificationService: verificationService,
    isErrored: !!fieldValidationErrors.marketConsentValue,
    onChange: function onChange(newValue) {
      updateMoverViewModel('metadata', _objectSpread2({}, verificationService.viewModel.metadata, {
        marketConsentValue: newValue
      }));
      updateFieldValidationErrorsByFieldId('marketConsentValue', newValue, verificationService);
    },
    viewModel: viewModel
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-wrapper__collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectMoverPersonalInfo);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(!isFormFilled(viewModel, verificationService.formValidationOptions) ? 'sid-btn--disabled-like' : ''),
    "aria-label": "submit",
    "aria-labelledby": "verify-status-text",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement("span", {
    id: "verify-status-text"
  }, failedInstantMatch ? React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try Again"
  }) : React.createElement(FormattedHTMLMessage, {
    id: "verifyMyMoverStatus",
    defaultMessage: "Verify My Recent Mover Status"
  }))))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepMoverPersonalInfoComponent = injectIntl(StepMoverPersonalInfo); // Collect status is identical to Active at this time.

var StepCollectMilitaryStatusComponent = function StepCollectMilitaryStatusComponent(_ref136) {
  var verificationService = _ref136.verificationService;
  return React.createElement(StepActiveMilitaryPersonalInfoComponent, {
    verificationService: verificationService
  });
};
/**
 * Insert `newPart` into a string
 * Use:
 *      "Hi !".insertAt(3, "world"); // "Hi world!"
 */


String.prototype.insertAt = function (index, newPart) {
  if (index > this.length) {
    return this;
  }

  return "".concat(this.slice(0, index)).concat(newPart).concat(this.slice(index));
};

var displaySSN = function displaySSN(value) {
  var stringValue;

  try {
    stringValue = value.toString();
    if (!stringValue) throw new Error();
  } catch (e) {
    return '';
  }

  return stringValue.replace(/[^\d]/g, '') // replce non-digit chars
  .insertAt(3, '-') // for display
  .insertAt(6, '-').replace('--', '') // just in case
  .replace(/-$/, ''); // don't add trailing hyphen, breaks backspace
}; // The viewModel and API don't include hyphens. Also enforces max length, prior to setting viewModel, avoiding off-by-one error.


var unDisplaySSN = function unDisplaySSN(value) {
  return value.replace(/-/g, '').slice(0, SSN_STRING_LENGTH);
};

var SocialSecurity = function SocialSecurity(_ref137) {
  var value = _ref137.value,
      isErrored = _ref137.isErrored,
      onChange = _ref137.onChange,
      intl = _ref137.intl,
      _ref137$placeholder = _ref137.placeholder,
      placeholder = _ref137$placeholder === void 0 ? '' : _ref137$placeholder;

  var changeSsn = function changeSsn(value) {
    onChange(value);
  };

  return React.createElement("div", {
    className: "sid-field sid-ssn"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("label", {
    htmlFor: "sid-ssn"
  }, React.createElement("div", {
    className: "sid-field__label sid-field__label--required sid-l-space-btm-sm ".concat(placeholder ? 'sid-h-screen-reader-only' : '')
  }, React.createElement(FormattedHTMLMessage, {
    id: "ssn",
    defaultMessage: "Social Security Number"
  }))), React.createElement(InputTextComponent, {
    id: "ssn",
    refId: FieldIdEnum.socialSecurityNumber,
    className: "sid-ssn__input",
    isErrored: isErrored,
    required: true,
    placeholder: placeholder || intl.formatMessage({
      id: 'ssnPlaceholder',
      defaultMessage: '000-00-0000'
    }),
    value: displaySSN(value),
    hidePlaceholder: false,
    onChange: function onChange(e) {
      return changeSsn(unDisplaySSN(e.target.value));
    }
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.invalidSocialSecurityNumber",
    defaultMessage: "Invalid SSN"
  })) : null);
};

var SocialSecurityNumber = injectIntl(SocialSecurity);

var Step$1 = function Step$1(_ref138) {
  var useSsn = _ref138.useSsn,
      useDocUpload = _ref138.useDocUpload,
      verificationService = _ref138.verificationService;
  return React.createElement("div", {
    id: "sid-ssn-choice",
    className: "sid-l-container sid-l-horz-center"
  }, React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.collectSocialSecurityNumber.selectOption",
    defaultMessage: "Select an option"
  }))), React.createElement("div", {
    className: "sid-ssn-choice__choice1 sid-l-space-top-lg"
  }, React.createElement("button", {
    type: "button",
    onClick: useSsn,
    className: "sid-btn sid-btn--light sid-l-full-width sid-use-ssn"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.collectSocialSecurityNumber.useSsn",
    defaultMessage: "Verify using your social security number"
  }))), React.createElement("div", {
    className: "sid-ssn-choice__choice2 sid-l-space-top-md"
  }, React.createElement("button", {
    type: "button",
    onClick: useDocUpload,
    className: "sid-btn sid-btn--light sid-l-full-width sid-use-doc-upload"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.collectSocialSecurityNumber.uploadDoc",
    defaultMessage: "Upload a document"
  }))), React.createElement("div", {
    className: "sid-ssn-choice__footer sid-l-space-top-lg"
  }, React.createElement(FormFooterComponent, {
    verificationService: verificationService
  })));
};

var SsnChoice = Step$1;

var Step = function Step(_ref139) {
  var verificationService = _ref139.verificationService;

  var _React$useState9 = React.useState(true),
      _React$useState10 = _slicedToArray2(_React$useState9, 2),
      showChoice = _React$useState10[0],
      setShowChoice = _React$useState10[1];

  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;

  var doCancelStep = function doCancelStep() {
    return verificationService.submitStep(VerificationStepsEnum.cancelSocialSecurityNumber, viewModel, verificationService.verificationResponse);
  };

  var updateSSNViewModel = function updateSSNViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  };

  var isSubmittable = viewModel.socialSecurityNumber && viewModel.socialSecurityNumber.toString().length === 9;

  if (showChoice) {
    return React.createElement(SsnChoice, {
      useSsn: function useSsn() {
        return setShowChoice(false);
      },
      useDocUpload: doCancelStep,
      verificationService: verificationService
    });
  }

  return React.createElement("div", {
    id: "sid-step-social-security",
    className: "sid-l-container sid-l-horz-center"
  }, React.createElement("div", {
    className: "sid-header"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, React.createElement(LogoComponent, {
    verificationService: verificationService
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.collectSocialSecurityNumber.title",
    defaultMessage: "Enter your social security number"
  })), React.createElement("div", {
    className: "sid-ssn-wrapper"
  }, React.createElement(SocialSecurityNumber, {
    value: viewModel.socialSecurityNumber,
    onChange: function onChange(value) {
      updateSSNViewModel('socialSecurityNumber', value);
      updateFieldValidationErrorsByFieldId('socialSecurityNumber', value, verificationService);
    },
    isErrored: !!fieldValidationErrors[FieldIdEnum.socialSecurityNumber],
    placeholder: "000-00-0000"
  }))), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-submit"
  }, React.createElement("button", {
    id: "sid-submit-wrapper__collect-info",
    onClick: function onClick() {
      return submitForm(viewModel, verificationService, VerificationStepsEnum.collectSocialSecurityNumber);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width ".concat(isSubmittable ? '' : 'sid-btn--disabled-like'),
    "aria-label": "submit",
    ref: function ref(button) {
      return setRef('submitButton', button);
    }
  }, React.createElement(FormattedHTMLMessage, {
    id: "proceed",
    defaultMessage: "Proceed"
  })))), React.createElement("div", {
    className: "sid-form-region sid-l-space-top-md",
    role: "button",
    tabIndex: 0,
    onKeyUp: doCancelStep,
    onClick: doCancelStep
  }, React.createElement("div", {
    className: "sid-h-link-like"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.collectSocialSecurityNumber.uploadInstead",
    defaultMessage: "Upload a document instead"
  }))), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
}; // TODO remove injectIntl, it's not used


var StepSocialSecurityNumber = injectIntl(Step);

var TryAgainButtonComponent = function TryAgainButtonComponent(_ref140) {
  var verificationService = _ref140.verificationService;
  var currentSegment = getSafe(function () {
    return verificationService.verificationResponse.segment;
  });
  var fetchNewVerificationRequest = React.useCallback(function () {
    var trackingId = undefined;
    var forceNewVerificationRequest = true;
    verificationService.fetchNewVerificationRequest(verificationService.programId, currentSegment, verificationService.previousViewModel, trackingId, forceNewVerificationRequest);
  }, [verificationService.programId, currentSegment, verificationService.previousViewModel]);
  return React.createElement("button", {
    type: "button",
    className: "sid-btn sid-btn-light",
    "aria-label": "submit",
    onClick: fetchNewVerificationRequest,
    onKeyPress: fetchNewVerificationRequest,
    tabIndex: 0
  }, React.createElement(FormattedHTMLMessage, {
    id: "tryAgain",
    defaultMessage: "Try again"
  }));
};

var BtnContainer = function BtnContainer(_ref141) {
  var children = _ref141.children;
  return React.createElement("div", {
    className: "sid-l-space-top-lg sid-l-half-width sid-l-horz-center"
  }, children);
};

var StepError = function StepError(_ref142) {
  var verificationService = _ref142.verificationService,
      errorId = _ref142.errorId;
  var verificationResponse = verificationService.verificationResponse;
  var hasLogo = !!getLogoUrl(verificationService.programTheme);
  var errorIds = getSafe(function () {
    return verificationResponse.errorIds;
  }) || [];

  if (errorId) {
    errorIds = [errorId].concat(_toConsumableArray2(errorIds)); // Prefer passed in err over any others, so it goes first
  } // The first is considered the most important, and will drive the logic on this step


  var firstErrorId = getSafe(function () {
    return errorIds[0];
  }, 'error'); // defaults

  var errorTitle = {
    id: 'error',
    defaultMessage: 'Error'
  };
  var logoContainerClass = 'sid-l-horz-center';
  var button = React.createElement(BtnContainer, null, React.createElement(TryAgainButtonComponent, {
    verificationService: verificationService
  })); // special case

  if (errorIds.includes('verificationLimitExceeded')) {
    button = null;
    logoContainerClass += ' sid-l-space-top-xl';
  } // If there's an overriding title message, use it (UX-160):


  if (getSafe(function () {
    return verificationService.messages["step.error.errorId.".concat(firstErrorId, ".title")];
  })) {
    errorTitle = {
      id: "step.error.errorId.".concat(firstErrorId, ".title"),
      defaultMessage: verificationService.messages["step.error.errorId.".concat(firstErrorId, ".title")]
    };
  } // If there are the proper ingredients to override the button, do that too (UX-160):


  if (getSafe(function () {
    return verificationService.messages["step.error.errorId.".concat(firstErrorId, ".buttonText")];
  }) && getSafe(function () {
    return verificationResponse.redirectUrl;
  })) {
    button = React.createElement(BtnContainer, null, React.createElement(LinkExternal, {
      href: verificationResponse.redirectUrl,
      onClick: function onClick() {
        return recordEvent(VerificationStepsEnum.error, verificationResponse.redirectUrl);
      },
      className: "sid-btn sid-btn-light"
    }, React.createElement(FormattedHTMLMessage, {
      id: "step.error.errorId.".concat(firstErrorId, ".buttonText"),
      defaultMessage: verificationService.messages["step.error.errorId.".concat(firstErrorId, ".buttonText")]
    })));
  }

  return React.createElement("div", {
    id: "sid-step-error",
    className: "sid-l-container"
  }, React.createElement("div", {
    className: "sid-header sid-l-horz-center"
  }, React.createElement("div", {
    className: logoContainerClass
  }, hasLogo ? React.createElement(LogoComponent, {
    verificationService: verificationService
  }) : React.createElement("img", {
    className: "sid-l-lead-image",
    alt: "design element",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/circle-exclamation.svg"
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, Object.assign({}, errorTitle))), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-error-msg sid-l-horz-center"
  }, errorIds ? React.createElement("p", null, errorIds.map(function (errId) {
    return React.createElement(FormattedHTMLMessage, {
      key: errId,
      id: "errorId.".concat(errId),
      defaultMessage: errId,
      values: {
        feedbackUrl: requestOrganizationConstants.FEEDBACK_FORM_URL,
        programId: verificationService.programId || '',
        locale: getLocaleSafely(verificationService.viewModel, verificationResponse).replace('-', '_')
      }
    });
  })) : null), button)), React.createElement("div", {
    className: "sid-footer sid-l-horz-center sid-l-space-top-xl sid-h-small-text"
  }, React.createElement(PoweredByComponent, {
    verificationService: verificationService,
    isCentered: true
  })));
};

var StepErrorComponent = injectIntl(StepError);
var defaultSubtitle = "Please sign in to your school's web portal. It will open in a new tab.";
var defaultSubtitle2 = "Can't sign in to your school?";

var StepSSOComponent = function StepSSOComponent(_ref143) {
  var verificationService = _ref143.verificationService;
  var programId = verificationService.programId;
  var viewModel = verificationService.viewModel;
  var previousViewModel = verificationService.previousViewModel || undefined;
  var verificationResponse = verificationService.verificationResponse;
  var previousVerificationResponse = verificationService.previousVerificationResponse || undefined;
  var verificationId = verificationService.verificationResponse.verificationId;
  var hasLogo = !!getLogoUrl(verificationService.programTheme);
  var timeout;

  var pollForVerificationServiceUpdates = function pollForVerificationServiceUpdates() {
    return setTimeout(function () {
      verificationService.fetchExistingVerificationRequest(programId, verificationId, previousVerificationResponse);
    }, 1000);
  };

  var updateViewModel = function updateViewModel(key, value) {
    var nextState = fn(viewModel, function (draft) {
      draft[key] = value;
    });
    verificationService.updateViewModel(nextState);
  };

  var cancelSSOStep = function cancelSSOStep() {
    closeTabRef();
    var nextState = fn(viewModel, function () {});
    logger.info('StepSSOComponent submitting cancel request');
    clearTimeout(timeout);
    verificationService.submitStep(VerificationStepsEnum.sso, nextState, verificationService.verificationResponse);
  };

  var updateViewModelAndOpenLoginTab = function updateViewModelAndOpenLoginTab(key, value) {
    updateViewModel(key, value);
    openLoginTab();
  };

  var openLoginTab = function openLoginTab() {
    setTabRef(window.open(verificationResponse.loginUrl, '_blank'));
    getTabRef().focus();
  };

  if (viewModel.isSSOActive) {
    timeout = pollForVerificationServiceUpdates();
  }

  if (!viewModel.countryChoice && previousViewModel && previousViewModel.countryChoice) {
    updateViewModel('countryChoice', previousViewModel.countryChoice);
  }

  return React.createElement("div", {
    id: "sid-step-sso",
    className: "sid-l-container"
  }, viewModel.isSSOActive ? React.createElement("div", {
    className: "sid-header sid-l-horz-center"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, hasLogo ? React.createElement(LogoComponent, {
    verificationService: verificationService
  }) : React.createElement("img", {
    className: "sid-l-lead-image",
    alt: "design element",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/doc-pending.svg"
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.title",
    defaultMessage: "Verify using your school credentials"
  })), React.createElement("div", {
    className: "sid-header__subtitle-one"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.subtitle",
    defaultMessage: defaultSubtitle
  })), React.createElement("div", {
    className: "sid-l-space-top-xl"
  }), React.createElement("div", {
    className: "sid-header__subtitle-two sid-h-small-text sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.subtitle2",
    defaultMessage: defaultSubtitle2
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("button", {
    onClick: cancelSSOStep,
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width",
    "aria-label": "submit"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.cancel",
    defaultMessage: "Upload Proof of Enrollment"
  })))), React.createElement("div", {
    className: "sid-l-space-top-xl"
  })) : React.createElement("div", {
    className: "sid-header sid-l-horz-center"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, hasLogo ? React.createElement(LogoComponent, {
    verificationService: verificationService
  }) : React.createElement("img", {
    className: "sid-l-lead-image",
    alt: "design element",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/sso-step.svg"
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.title",
    defaultMessage: "Verify using your school credentials"
  })), React.createElement("div", {
    className: "sid-header__subtitle-one"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.subtitle",
    defaultMessage: defaultSubtitle
  })), React.createElement("div", {
    className: "sid-l-space-top-xl"
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("button", {
    id: "sid-submit-btn-sso",
    onClick: function onClick() {
      return updateViewModelAndOpenLoginTab('isSSOActive', true);
    },
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width",
    "aria-label": "submit"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.login",
    defaultMessage: "Sign in to my school"
  }))), React.createElement("div", {
    className: "sid-l-space-top-xl"
  })), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var redirect = function redirect(redirectDestination) {
  var win = window.open(redirectDestination, '_parent');
  win.focus();
};

var StepSuccess = function StepSuccess(_ref144) {
  var verificationService = _ref144.verificationService;
  var hasLogo = !!getLogoUrl(verificationService.programTheme);
  var redirectDestination = verificationService.verificationResponse.redirectUrl;
  var showRedirect = Boolean(redirectDestination);
  var rewardCode = verificationService.verificationResponse.rewardCode || '${rewardCode}'; // eslint-disable-line no-template-curly-in-string

  var noCodeType = verificationService.programTheme.config.offerType === 'noCode';
  return React.createElement("div", {
    id: "sid-step-success",
    className: "sid-l-container"
  }, React.createElement("div", {
    className: "sid-header sid-l-horz-center sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, hasLogo ? React.createElement(LogoComponent, {
    verificationService: verificationService
  }) : React.createElement("img", {
    className: "sid-l-lead-image",
    alt: "design element",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/circle-check.svg"
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.success.title",
    defaultMessage: "Success! You've been verified."
  })), React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.success.subtitle",
    defaultMessage: "Here is your personal coupon code.\n                        It is unique to you and can only be used once."
  }))), noCodeType ? null : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center"
  }, rewardCode), React.createElement("div", {
    className: "sid-l-space-top-md sid-h-bold-text sid-l-horz-center"
  }, React.createElement(CopyToClipboard, {
    textToCopy: rewardCode,
    notificationText: React.createElement(FormattedHTMLMessage, {
      id: "copied",
      defaultMessage: "Copied"
    })
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.success.copyCouponCode",
    defaultMessage: "Copy Coupon code"
  })))), React.createElement("div", {
    className: "sid-footer sid-l-horz-center ".concat(noCodeType ? 'sid-l-space-top-md' : 'sid-l-space-top-lg')
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.success.emailNotification",
    defaultMessage: "\n                    We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com\n                "
  })), showRedirect ? React.createElement("div", {
    className: "sid-submit sid-l-space-top-md"
  }, React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return redirect(redirectDestination);
    },
    className: "sid-btn sid-btn--dark"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.success.redirectButtonText",
    defaultMessage: "Use code now"
  }))) : '', React.createElement("div", {
    className: "sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text"
  }, React.createElement(FormattedMessage, {
    id: "companyName",
    defaultMessage: "{Company}"
  }, function (companyName) {
    return React.createElement(FormattedHTMLMessage, {
      id: "step.success.verificationOnly",
      defaultMessage: "\n                                SheerID handles verification only.\n                                Now that you've been approved, please direct all questions about the\n                                promotion terms and/or code use to {companyName} customer service.\n                            ",
      values: {
        companyName: companyName
      }
    });
  })));
};

var StepSuccessComponent = StepSuccess;
var CountDown = React.memo(function (_ref145) {
  var countdownSeconds = _ref145.countdownSeconds,
      onCountdownFinish = _ref145.onCountdownFinish,
      logo = _ref145.logo;

  var _React$useState11 = React.useState(countdownSeconds),
      _React$useState12 = _slicedToArray2(_React$useState11, 2),
      timeRemaining = _React$useState12[0],
      setTimeRemaining = _React$useState12[1];

  var timeRemainingRef = React.useRef(timeRemaining);
  var timerRef = React.useRef(null);

  var tickTimer = function tickTimer() {
    var newTime = timeRemainingRef.current - 1;
    setTimeRemaining(newTime);
    timeRemainingRef.current = newTime;

    if (newTime < 0) {
      onCountdownFinish();
      clearInterval(timerRef.current);
    }
  };

  var formatSeconds = function formatSeconds() {
    var seconds = "0".concat(timeRemaining).slice(-2);
    return "00:".concat(seconds);
  };

  React.useEffect(function () {
    timerRef.current = setInterval(tickTimer, 1000);
    return function () {
      return clearInterval(timerRef.current);
    };
  }, []);
  return React.createElement("div", {
    className: "sid-header sid-l-horz-center",
    "data-testid": "sid-countdown-pending"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, logo), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.pending.titleCountdown",
    defaultMessage: "Processing"
  })), React.createElement("div", {
    className: "sid-header__subtitle-one"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.pending.subtitleCountdown",
    defaultMessage: "Hang tight while we upload and scan your documents."
  })), React.createElement("div", {
    id: "sid-step-pending",
    className: "sid-l-container"
  }, React.createElement("div", {
    className: "sid-countdown"
  }, formatSeconds())), React.createElement("div", {
    className: "sid-l-space-top-xl"
  }));
});
var CountDownComponent = CountDown;
var defaultSSOSubtitle = "Please sign in to your school's web portal. It will open in a new tab.";
var defaultSSOSubtitle2 = "Can't sign in to your school?";

var SSOPending = function SSOPending(_ref146) {
  var logo = _ref146.logo,
      cancelSSO = _ref146.cancelSSO;
  return React.createElement("div", {
    className: "sid-header sid-l-horz-center"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, logo), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.title",
    defaultMessage: "Verify using your school credentials"
  })), React.createElement("div", {
    className: "sid-header__subtitle-one"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.subtitle",
    defaultMessage: defaultSSOSubtitle
  })), React.createElement("div", {
    className: "sid-l-space-top-xl"
  }), React.createElement("div", {
    className: "sid-header__subtitle-two sid-h-small-text sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.subtitle2",
    defaultMessage: defaultSSOSubtitle2
  }), React.createElement("div", {
    className: "sid-form-region sid-submit-wrapper sid-l-space-top-md"
  }, React.createElement("button", {
    onClick: cancelSSO,
    type: "submit",
    className: "sid-btn sid-btn--dark sid-l-full-width",
    "aria-label": "submit"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.sso.cancel",
    defaultMessage: "Upload Proof of Enrollment"
  })))), React.createElement("div", {
    className: "sid-l-space-top-xl"
  }));
};

var SSOPendingComponent = SSOPending;

var timesChanged = function timesChanged(previousResponse, currentResponse) {
  var previousEst = getSafe(function () {
    return previousResponse.estimatedReviewTime;
  });
  var previousMax = getSafe(function () {
    return previousResponse.maxReviewTime;
  });
  var newEst = getSafe(function () {
    return currentResponse.estimatedReviewTime;
  });
  var newMax = getSafe(function () {
    return currentResponse.maxReviewTime;
  });
  return previousEst !== undefined && previousEst !== newEst || previousMax !== undefined && previousMax !== newMax;
};

var ReviewPending = function ReviewPending(_ref147) {
  var intl = _ref147.intl,
      logo = _ref147.logo,
      verificationService = _ref147.verificationService;
  var verificationResponse = verificationService.verificationResponse;

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray2(_React$useState13, 2),
      isAlerting = _React$useState14[0],
      setAlertState = _React$useState14[1];

  if (!isAlerting && timesChanged(verificationService.previousVerificationResponse, verificationResponse)) {
    setAlertState(true);
  }

  var estAndMaxTimes = getEstAndMaxReviewTimes(_objectSpread2({}, verificationResponse), verificationService.programTheme, intl);
  return React.createElement("div", {
    className: "sid-header sid-l-horz-center",
    "data-testid": "sid-review-pending"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, logo), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.pending.titleReview",
    defaultMessage: "Reviewing"
  })), React.createElement("div", {
    className: "sid-header__subtitle-one"
  }, isAlerting ? React.createElement(FormattedHTMLMessage, {
    id: "step.pending.subtitleAlt",
    defaultMessage: "SheerID is reviewing your documents, to confirm your status."
  }) : React.createElement(FormattedHTMLMessage, {
    id: "step.pending.turnaroundTime",
    defaultMessage: "Turnaround time for your language is typically {estReviewTime}, and in rare times of high volume may take up to {maxReviewTime}.",
    values: estAndMaxTimes
  })), React.createElement("div", {
    className: "sid-header__subtitle-two sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.pending.subtitle2",
    defaultMessage: "Wait here or let us notify you of the outcome."
  })), React.createElement("div", {
    className: "sid-header__subtitle-three sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.pending.subtitle3",
    defaultMessage: "You will be contacted via email."
  })), isAlerting ? React.createElement("div", {
    className: "sid-pending-red-box"
  }, React.createElement("ul", null, React.createElement("li", null, React.createElement(FormattedHTMLMessage, {
    id: "step.pending.docDiffLang",
    defaultMessage: "We identified your document is in a different language."
  })), React.createElement("li", null, React.createElement(FormattedHTMLMessage, {
    id: "step.pending.turnaroundTime",
    defaultMessage: "Turnaround time for your language is typically {estReviewTime}, and in rare times of high volume may take up to {maxReviewTime}.",
    values: estAndMaxTimes
  })))) : null, React.createElement("div", {
    className: "sid-l-space-top-xl"
  }));
};

var ReviewPendingComponent = ReviewPending;

var usePollingInterval = function usePollingInterval(callback, pollTime) {
  var timerRef = React.useRef(null);

  function stopInterval() {
    clearInterval(timerRef.current);
  }

  React.useEffect(function () {
    timerRef.current = setInterval(callback, pollTime);
    return function () {
      return stopInterval();
    };
  }, [callback, pollTime]);
  return stopInterval;
};
/* eslint-disable no-nested-ternary */


var DOC_UPLOAD_POLL_DURATION_DURING_COUNTDOWN = 5000;
var DOC_UPLOAD_POLL_DURATION = 20000;
var SSO_POLL_DURATION = 5000;

var StepPending = function StepPending(_ref148) {
  var verificationService = _ref148.verificationService,
      intl = _ref148.intl;
  var programId = verificationService.programId;
  var viewModel = verificationService.viewModel;
  var previousViewModel = verificationService.previousViewModel || undefined;
  var verificationLastResponse = verificationService.verificationResponse.lastResponse || verificationService.previousVerificationResponse || undefined;
  var verificationId = verificationService.verificationResponse.verificationId;
  var hasLogo = !!getLogoUrl(verificationService.programTheme);
  var countdownSeconds = 20;

  var isPreviousStepSSO = function isPreviousStepSSO() {
    if (verificationLastResponse && verificationLastResponse.currentStep === VerificationStepsEnum.sso) {
      return true;
    }

    return false;
  };

  var _React$useState15 = React.useState(!isPreviousStepSSO()),
      _React$useState16 = _slicedToArray2(_React$useState15, 2),
      showCountDown = _React$useState16[0],
      setShowCountDown = _React$useState16[1];

  var getLogo = function getLogo() {
    return hasLogo ? React.createElement(LogoComponent, {
      verificationService: verificationService
    }) : React.createElement("img", {
      className: "sid-l-lead-image",
      alt: "design element",
      src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/doc-pending.svg"
    });
  };

  var pollTime = isPreviousStepSSO() ? SSO_POLL_DURATION : showCountDown ? DOC_UPLOAD_POLL_DURATION_DURING_COUNTDOWN : DOC_UPLOAD_POLL_DURATION;
  var stopPollingInterval = usePollingInterval(function () {
    verificationService.fetchExistingVerificationRequest(programId, verificationId, verificationLastResponse, previousViewModel, false);
  }, pollTime);

  var cancelSSOStep = function cancelSSOStep() {
    var nextState = fn(viewModel, function () {});
    logger.info('StepSSOComponent submitting cancel request');
    stopPollingInterval();
    verificationService.submitStep(VerificationStepsEnum.sso, nextState, verificationLastResponse);
  };

  var onCountdownFinish = function onCountdownFinish() {
    setShowCountDown(false);
  };

  var logo = getLogo();
  var isMockingPreviousStepSSO = getPreviousStepOverride() && getPreviousStepOverride() === VerificationStepsEnum.sso;
  return React.createElement("div", {
    id: "sid-step-pending",
    className: "sid-l-container"
  }, isPreviousStepSSO() || isMockingPreviousStepSSO ? React.createElement(SSOPendingComponent, {
    logo: logo,
    cancelSSO: cancelSSOStep
  }) : showCountDown ? React.createElement(CountDownComponent, {
    logo: logo,
    onCountdownFinish: onCountdownFinish,
    countdownSeconds: countdownSeconds
  }) : React.createElement(ReviewPendingComponent, {
    verificationService: verificationService,
    logo: logo,
    intl: intl,
    maxReviewTime: getMaxReviewTime(verificationService.programTheme)
  }), showCountDown ? React.createElement(PoweredByComponent, {
    verificationService: verificationService,
    isCentered: true
  }) : React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }, React.createElement("div", null), ' '));
};

var StepPendingComponent = injectIntl(StepPending);

var SMSCode = function SMSCode(_ref149) {
  var _onChange33 = _ref149.onChange,
      value = _ref149.value,
      isErrored = _ref149.isErrored,
      errorId = _ref149.errorId,
      intl = _ref149.intl,
      _ref149$placeholder = _ref149.placeholder,
      placeholder = _ref149$placeholder === void 0 ? '' : _ref149$placeholder;

  var getErrorMessage = function getErrorMessage(errorId) {
    switch (errorId) {
      case 'invalidSMSCode':
        return React.createElement(FormattedMessage, {
          id: "step.smsLoop.errors.codeVerification",
          defaultMessage: "Verification code could not be validated."
        });

      case 'expiredSMSCode':
        return React.createElement(FormattedMessage, {
          id: "step.smsLoop.errors.codeExpired",
          defaultMessage: "Verification code expired."
        });

      default:
        return React.createElement(FormattedMessage, {
          id: "errorId.unknownError",
          defaultMessage: "Unknown Error"
        });
    }
  };

  return React.createElement("div", {
    className: "sid-field sid-sms-code-id"
  }, React.createElement("div", {
    className: "sid-l-space-top-md"
  }), isErrored ? React.createElement("div", {
    className: "sid-field-error"
  }, getErrorMessage(errorId)) : null, React.createElement(InputTextComponent, {
    id: "sms-code",
    isErrored: isErrored,
    required: true,
    placeholder: placeholder || intl.formatMessage({
      id: 'smsCodePlaceholder',
      defaultMessage: 'SMS Code*'
    }),
    value: value,
    onChange: function onChange(e) {
      return _onChange33(e.target.value);
    }
  }));
};

var SMSCodeComponent = injectIntl(SMSCode);

var StepSMSLoop = function StepSMSLoop(_ref150) {
  var intl = _ref150.intl,
      verificationService = _ref150.verificationService;
  var viewModel = verificationService.viewModel;
  var verificationResponse = verificationService.verificationResponse;
  var isErrored = Boolean(verificationService.fieldValidationErrors.smsCode);
  var previousViewModel = verificationService.previousViewModel || undefined;

  var _React$useState17 = React.useState(''),
      _React$useState18 = _slicedToArray2(_React$useState17, 2),
      stepResultMessage = _React$useState18[0],
      setStepResultMessage = _React$useState18[1];

  var _React$useState19 = React.useState(verificationResponse.errorIds && verificationResponse.errorIds.includes('incorrectSMSCodeAttemptLimitExceeded')),
      _React$useState20 = _slicedToArray2(_React$useState19, 2),
      isAttemptLimitExceeded = _React$useState20[0],
      setAttemptLimitExceeded = _React$useState20[1];

  var stepSuccessMessage = intl.formatMessage({
    id: 'step.smsLoop.successResend',
    defaultMessage: 'SMS message re-sent successfully'
  });
  var maxTotalRetriesMessage = intl.formatMessage({
    id: 'step.smsLoop.errors.codeResendLimit',
    defaultMessage: 'Maximum number of re-tries has been reached.'
  });
  var maxRetriesPerCodeMessage = intl.formatMessage({
    id: 'step.smsLoop.errors.codeResendLimit',
    defaultMessage: 'Maximum number of re-tries has been reached.'
  });
  var errorResendingSMSMessage = intl.formatMessage({
    id: 'step.smsLoop.errors.resend',
    defaultMessage: 'Error sending the SMS message'
  });
  React.useEffect(function () {
    if (isAttemptLimitExceeded) {
      setStepResultMessage(maxRetriesPerCodeMessage);
    }
  }, []);

  if (getSafe(function () {
    return verificationResponse.errorIds.length;
  }) && !verificationService.fieldValidationErrors.smsCode) {
    verificationService.updateFieldValidationErrors(_objectSpread2({}, verificationService.fieldValidationErrors, {
      smsCode: verificationResponse.errorIds[0]
    }));
  }

  var updateSmsCode = function updateSmsCode(value) {
    var nextState = fn(viewModel, function (draft) {
      draft.smsCode = value;
      draft.phoneNumber = previousViewModel && previousViewModel.phoneNumber;
    });
    verificationService.updateViewModel(nextState);
  };

  var submitForm = function submitForm() {
    logger.info('StepSMSLoop submitting form');
    verificationService.submitStep(VerificationStepsEnum.smsLoop, viewModel, verificationService.verificationResponse);
  };

  var resendSmsCode = /*#__PURE__*/function () {
    var _ref151 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(verificationId) {
      var response;
      return _regeneratorRuntime.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              _context38.next = 2;
              return VerificationApiClient.getResendNewSmsCode(verificationId);

            case 2:
              response = _context38.sent;

              if (response) {
                setAttemptLimitExceeded(false);
                setStepResultMessage(response.status === 204 ? stepSuccessMessage : maxTotalRetriesMessage);
              } else {
                setStepResultMessage(errorResendingSMSMessage);
              }

            case 4:
            case "end":
              return _context38.stop();
          }
        }
      }, _callee38);
    }));

    return function resendSmsCode(_x74) {
      return _ref151.apply(this, arguments);
    };
  }();

  return React.createElement("div", {
    id: "sid-step-sms-loop",
    className: "sid-l-container"
  }, React.createElement("div", {
    className: "sid-header__title sid-l-horz-center"
  }, React.createElement(FormattedMessage, {
    id: "step.smsLoop.verificationCode",
    defaultMessage: "Verification Code"
  })), React.createElement("div", {
    className: "sid-header__subtitle"
  }, getSafe(function () {
    return previousViewModel.phoneNumber;
  }) ? React.createElement(FormattedMessage, {
    id: "step.smsLoop.titleWithNumber",
    defaultMessage: "We've sent an SMS message to the mobile number ending in {number}. Enter your code here.",
    values: {
      number: getSafe(function () {
        return previousViewModel.phoneNumber.slice(-4);
      }, '')
    }
  }) : React.createElement(FormattedMessage, {
    id: "step.smsLoop.titleWithoutNumber",
    defaultMessage: "We've sent an SMS to your mobile number. Please enter the code here."
  })), React.createElement("div", {
    className: "sid-sms-code-id-wrapper sid-l-horz-center"
  }, React.createElement(SMSCodeComponent, {
    onChange: updateSmsCode,
    value: viewModel.smsCode,
    isErrored: isErrored,
    errorId: verificationService.fieldValidationErrors.smsCode
  })), stepResultMessage && React.createElement("div", null, React.createElement("p", null, stepResultMessage)), React.createElement("div", {
    className: "sid-submit sid-l-space-top-md sid-l-horz-center"
  }, React.createElement("button", {
    id: "sid-submit-sms-code",
    onClick: submitForm,
    type: "button",
    className: "sid-btn sid-btn--dark sid-submit__continue",
    "aria-label": "submit",
    disabled: !!(!viewModel.smsCode || viewModel.smsCode.length <= 0 || isAttemptLimitExceeded)
  }, React.createElement(FormattedMessage, {
    id: "step.smsLoop.submitButton",
    defaultMessage: "Submit"
  })), React.createElement("div", {
    className: "sid-l-space-left-sm"
  }, "\xA0"), React.createElement("button", {
    id: "sid-resend-sms-code",
    onClick: function onClick() {
      return resendSmsCode(verificationResponse.verificationId);
    },
    type: "submit",
    className: "sid-btn sid-btn--light sid-submit__cancel",
    "aria-label": "re-send"
  }, React.createElement(FormattedMessage, {
    id: "step.smsLoop.resendButton",
    defaultMessage: "Re-send"
  }))), React.createElement("div", {
    className: "sid-incorrect-number sid-l-horz-center"
  }, React.createElement(FormattedMessage, {
    id: "step.smsLoop.incorrectNumber.incorrectNumber1",
    defaultMessage: "Incorrect number? Click "
  }), React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return window.location.reload();
    },
    className: "sid-incorrect-number__refresh-link"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.smsLoop.incorrectNumber.incorrectNumber2",
    defaultMessage: "here "
  })), React.createElement(FormattedMessage, {
    id: "companyName",
    defaultMessage: "{Company}"
  }, function (companyName) {
    return React.createElement(FormattedMessage, {
      id: "step.smsLoop.incorrectNumber.incorrectNumber3",
      defaultMessage: "to return to {companyName}",
      values: {
        companyName: companyName
      }
    });
  })));
};

var StepSMSLoopComponent = injectIntl(StepSMSLoop);
var EMAIL_LOOP_POLL_DURATION = 10000;

var StepEmailLoop = function StepEmailLoop(_ref152) {
  var intl = _ref152.intl,
      verificationService = _ref152.verificationService;
  var verificationResponse = verificationService.verificationResponse;
  var programId = verificationService.programId;
  var verificationId = verificationResponse.verificationId;
  var canResendEmailLoop = verificationResponse.canResendEmailLoop;
  var canCancelEmailLoop = verificationResponse.cancelUrl;
  var viewModel = verificationService.viewModel;
  var previousViewModel = verificationService.previousViewModel || undefined;
  var previousVerificationResponse = verificationService.previousVerificationResponse || undefined;

  var _React$useState21 = React.useState(''),
      _React$useState22 = _slicedToArray2(_React$useState21, 2),
      resendMessage = _React$useState22[0],
      setResendMessage = _React$useState22[1];

  var hasLogo = !!getLogoUrl(verificationService.programTheme);
  var logo = hasLogo ? React.createElement(LogoComponent, {
    verificationService: verificationService
  }) : React.createElement("img", {
    className: "sid-l-lead-image",
    alt: "design element",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/doc-pending.svg"
  });
  var email = getSafe(function () {
    return previousViewModel.email;
  });

  var submitForm = function submitForm() {
    logger.info('StepEmailLoopComponent submitting form');
    verificationService.submitStep(VerificationStepsEnum.emailLoop, viewModel, verificationService.verificationResponse);
  };

  React.useEffect(function () {
    populateViewModelFromQueryParams(verificationService);
  }, []);
  React.useEffect(function () {
    if (viewModel.emailToken) {
      submitForm();
    }
  }, [viewModel.emailToken]);
  usePollingInterval(function () {
    verificationService.fetchExistingVerificationRequest(programId, verificationId, previousVerificationResponse, previousViewModel, false);
  }, EMAIL_LOOP_POLL_DURATION);

  var resendEmail = /*#__PURE__*/function () {
    var _ref153 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(verificationId) {
      var response, successMsgObject, maxRetriesMsgObject, message;
      return _regeneratorRuntime.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return VerificationApiClient.getResendNewEmailCode(verificationId);

            case 2:
              response = _context39.sent;

              if (response) {
                successMsgObject = {
                  id: 'step.emailLoop.successResend',
                  defaultMessage: 'Email re-sent successfully.'
                };
                maxRetriesMsgObject = {
                  id: 'step.emailLoop.errors.resend',
                  defaultMessage: 'Error sending email'
                };
                message = response.status === 204 ? intl.formatMessage(successMsgObject) : intl.formatMessage(maxRetriesMsgObject);
                setResendMessage(message);
              } else {
                setResendMessage(intl.formatMessage({
                  id: 'step.emailLoop.errors.resend',
                  defaultMessage: 'Error sending email'
                }));
              }

            case 4:
            case "end":
              return _context39.stop();
          }
        }
      }, _callee39);
    }));

    return function resendEmail(_x75) {
      return _ref153.apply(this, arguments);
    };
  }();

  var cancelEmailLoop = /*#__PURE__*/function () {
    var _ref154 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
      var nextState;
      return _regeneratorRuntime.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              logger.info('StepEmailLoopComponent submitting form after skipping email loop');
              nextState = fn(viewModel, function () {});
              verificationService.submitStep(VerificationStepsEnum.cancelEmailLoop, nextState, verificationService.verificationResponse);

            case 3:
            case "end":
              return _context40.stop();
          }
        }
      }, _callee40);
    }));

    return function cancelEmailLoop() {
      return _ref154.apply(this, arguments);
    };
  }();

  return React.createElement("div", {
    id: "sid-step-email-loop",
    className: "sid-l-container"
  }, React.createElement("div", {
    className: "sid-header sid-l-horz-center"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, logo), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center sid-l-space-top-md"
  }, React.createElement(FormattedMessage, {
    id: "step.emailLoop.title",
    defaultMessage: "Check your email"
  })), React.createElement("div", {
    className: "sid-header__subtitle-one"
  }, email ? React.createElement(FormattedMessage, {
    id: "step.emailLoop.subtitleWithEmail",
    defaultMessage: "An email has been sent to {email} with a personalized link to complete the verification process.",
    values: {
      email: email
    }
  }) : React.createElement(FormattedMessage, {
    id: "step.emailLoop.subtitleWithoutEmail",
    defaultMessage: "An email has been sent to your email account with a personalized link to complete the verification process."
  })), React.createElement("div", {
    className: "sid-l-space-top-md"
  }), React.createElement("div", {
    className: "sid-header__subtitle-two sid-h-small-text sid-l-space-top-md"
  }, React.createElement(FormattedMessage, {
    id: "step.emailLoop.subtitle2",
    defaultMessage: "Please check for an email from us (verify@sheerid.com) for all the details."
  })), canCancelEmailLoop && React.createElement("div", {
    className: "sid-skip-email sid-l-space-top-lg"
  }, React.createElement(FormattedMessage, {
    id: "step.emailLoop.skipEmail",
    defaultMessage: "Unable to retrieve this email? Click "
  }), React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return cancelEmailLoop();
    },
    className: "sid-incorrect-number__refresh-link"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.emailLoop.skipEmailCTA",
    defaultMessage: "here"
  })), React.createElement(FormattedMessage, {
    id: "step.emailLoop.skipEmail2",
    defaultMessage: " to proceed."
  })), canResendEmailLoop && React.createElement("div", {
    className: "sid-header__resend-btn sid-l-space-top-md"
  }, React.createElement("button", {
    id: "sid-resend-email",
    onClick: function onClick() {
      return resendEmail(verificationId);
    },
    type: "submit",
    className: "sid-btn sid-btn--light sid-submit__cancel sid-l-horz-center",
    "aria-label": "re-send"
  }, React.createElement(FormattedMessage, {
    id: "step.emailLoop.resendButton",
    defaultMessage: "Re-send"
  }))), resendMessage && React.createElement("div", null, React.createElement("p", null, resendMessage)), React.createElement("div", {
    className: "sid-l-space-top-xl"
  })));
};

var StepEmailLoopComponent = injectIntl(StepEmailLoop);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
/** @deprecated */


function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}

var COMMON_MIME_TYPES = new Map([['avi', 'video/avi'], ['gif', 'image/gif'], ['ico', 'image/x-icon'], ['jpeg', 'image/jpeg'], ['jpg', 'image/jpeg'], ['mkv', 'video/x-matroska'], ['mov', 'video/quicktime'], ['mp4', 'video/mp4'], ['pdf', 'application/pdf'], ['png', 'image/png'], ['zip', 'application/zip'], ['doc', 'application/msword'], ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']]);

function toFileWithPath(file, path) {
  var f = withMimeType(file);

  if (typeof f.path !== 'string') {
    // on electron, path is already set to the absolute path
    var webkitRelativePath = file.webkitRelativePath;
    Object.defineProperty(f, 'path', {
      value: typeof path === 'string' ? path // If <input webkitdirectory> is set,
      // the File will have a {webkitRelativePath} property
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
      : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
      writable: false,
      configurable: false,
      enumerable: true
    });
  }

  return f;
}

function withMimeType(file) {
  var name = file.name;
  var hasExtension = name && name.lastIndexOf('.') !== -1;

  if (hasExtension && !file.type) {
    var ext = name.split('.').pop().toLowerCase();
    var type = COMMON_MIME_TYPES.get(ext);

    if (type) {
      Object.defineProperty(file, 'type', {
        value: type,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }

  return file;
}

var FILES_TO_IGNORE = [// Thumbnail cache files for macOS and Windows
'.DS_Store', 'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */

function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , isDragEvt(evt) && evt.dataTransfer ? getDataTransferFiles(evt.dataTransfer, evt.type) : getInputFiles(evt)];
    });
  });
}

function isDragEvt(value) {
  return !!value.dataTransfer;
}

function getInputFiles(evt) {
  var files = isInput(evt.target) ? evt.target.files ? fromList(evt.target.files) : [] : [];
  return files.map(function (file) {
    return toFileWithPath(file);
  });
}

function isInput(value) {
  return value !== null;
}

function getDataTransferFiles(dt, type) {
  return __awaiter(this, void 0, void 0, function () {
    var items, files;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!dt.items) return [3
          /*break*/
          , 2];
          items = fromList(dt.items).filter(function (item) {
            return item.kind === 'file';
          }); // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
          // only 'dragstart' and 'drop' has access to the data (source node)

          if (type !== 'drop') {
            return [2
            /*return*/
            , items];
          }

          return [4
          /*yield*/
          , Promise.all(items.map(toFilePromises))];

        case 1:
          files = _a.sent();
          return [2
          /*return*/
          , noIgnoredFiles(flatten(files))];

        case 2:
          return [2
          /*return*/
          , noIgnoredFiles(fromList(dt.files).map(function (file) {
            return toFileWithPath(file);
          }))];
      }
    });
  });
}

function noIgnoredFiles(files) {
  return files.filter(function (file) {
    return FILES_TO_IGNORE.indexOf(file.name) === -1;
  });
} // IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList


function fromList(items) {
  var files = []; // tslint:disable: prefer-for-of

  for (var i = 0; i < items.length; i++) {
    var file = items[i];
    files.push(file);
  }

  return files;
} // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem


function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== 'function') {
    return fromDataTransferItem(item);
  }

  var entry = item.webkitGetAsEntry(); // Safari supports dropping an image node from a different window and can be retrieved using
  // the DataTransferItem.getAsFile() API
  // NOTE: FileSystemEntry.file() throws if trying to get the file

  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }

  return fromDataTransferItem(item);
}

function flatten(items) {
  return items.reduce(function (acc, files) {
    return __spread(acc, Array.isArray(files) ? flatten(files) : [files]);
  }, []);
}

function fromDataTransferItem(item) {
  var file = item.getAsFile();

  if (!file) {
    return Promise.reject(item + " is not a File");
  }

  var fwp = toFileWithPath(file);
  return Promise.resolve(fwp);
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry


function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
    });
  });
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry


function fromDirEntry(entry) {
  var reader = entry.createReader();
  return new Promise(function (resolve, reject) {
    var entries = [];

    function readEntries() {
      var _this = this; // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
      // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries


      reader.readEntries(function (batch) {
        return __awaiter(_this, void 0, void 0, function () {
          var files, err_1, items;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!!batch.length) return [3
                /*break*/
                , 5];
                _a.label = 1;

              case 1:
                _a.trys.push([1, 3,, 4]);

                return [4
                /*yield*/
                , Promise.all(entries)];

              case 2:
                files = _a.sent();
                resolve(files);
                return [3
                /*break*/
                , 4];

              case 3:
                err_1 = _a.sent();
                reject(err_1);
                return [3
                /*break*/
                , 4];

              case 4:
                return [3
                /*break*/
                , 6];

              case 5:
                items = Promise.all(batch.map(fromEntry));
                entries.push(items); // Continue reading

                readEntries();
                _a.label = 6;

              case 6:
                return [2
                /*return*/
                ];
            }
          });
        });
      }, function (err) {
        reject(err);
      });
    }

    readEntries();
  });
} // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry


function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , new Promise(function (resolve, reject) {
        entry.file(function (file) {
          var fwp = toFileWithPath(file, entry.fullPath);
          resolve(fwp);
        }, function (err) {
          reject(err);
        });
      })];
    });
  });
}

var es = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  exports.default = function (file, acceptedFiles) {
    if (file && acceptedFiles) {
      var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
      var fileName = file.name || '';
      var mimeType = (file.type || '').toLowerCase();
      var baseMimeType = mimeType.replace(/\/.*$/, '');
      return acceptedFilesArray.some(function (type) {
        var validType = type.trim().toLowerCase();

        if (validType.charAt(0) === '.') {
          return fileName.toLowerCase().endsWith(validType);
        } else if (validType.endsWith('/*')) {
          // This is something like a image/* mime type
          return baseMimeType === validType.replace(/\/.*$/, '');
        }

        return mimeType === validType;
      });
    }

    return true;
  };
});
var accepts = unwrapExports(es);

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit$1(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files'; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};

var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " bytes")
  };
};

var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " bytes")
  };
};

var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || accepts(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}

function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble


function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}

function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */


function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */


var Dropzone = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, ["open"]);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React.createElement(Fragment$4, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: propTypes.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: propTypes.oneOfType([propTypes.string, propTypes.arrayOf(propTypes.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: propTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: propTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: propTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: propTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: propTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: propTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: propTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: propTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: propTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: propTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: propTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: propTypes.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: propTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: propTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: propTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: propTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: propTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: propTypes.func,

  /**
   * Custom validation function 
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: propTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$options = _objectSpread(_objectSpread({}, defaultProps), options),
      accept = _defaultProps$options.accept,
      disabled = _defaultProps$options.disabled,
      getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
      maxSize = _defaultProps$options.maxSize,
      minSize = _defaultProps$options.minSize,
      multiple = _defaultProps$options.multiple,
      maxFiles = _defaultProps$options.maxFiles,
      onDragEnter = _defaultProps$options.onDragEnter,
      onDragLeave = _defaultProps$options.onDragLeave,
      onDragOver = _defaultProps$options.onDragOver,
      onDrop = _defaultProps$options.onDrop,
      onDropAccepted = _defaultProps$options.onDropAccepted,
      onDropRejected = _defaultProps$options.onDropRejected,
      onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
      preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
      noClick = _defaultProps$options.noClick,
      noKeyboard = _defaultProps$options.noKeyboard,
      noDrag = _defaultProps$options.noDrag,
      noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
      validator = _defaultProps$options.validator;

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function (file) {
          var _fileAccepted = fileAccepted(file, accept),
              _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
              accepted = _fileAccepted2[0],
              acceptError = _fileAccepted2[1];

          var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
              _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
              sizeMatch = _fileMatchSize2[0],
              sizeError = _fileMatchSize2[1];

          var customErrors = validator ? validator(file) : null;

          if (accepted && sizeMatch && !customErrors) {
            acceptedFiles.push(file);
          } else {
            var errors = [acceptError, sizeError];

            if (customErrors) {
              errors = errors.concat(customErrors);
            }

            fileRejections.push({
              file: file,
              errors: errors.filter(function (e) {
                return e;
              })
            });
          }
        });

        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
          // Reject everything and empty accepted files
          acceptedFiles.forEach(function (file) {
            fileRejections.push({
              file: file,
              errors: [TOO_MANY_FILES_REJECTION]
            });
          });
          acceptedFiles.splice(0);
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          fileRejections: fileRejections,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, fileRejections, event);
        }

        if (fileRejections.length > 0 && onDropRejected) {
          onDropRejected(fileRejections, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [multiple, accept, minSize, maxSize, maxFiles, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread(_objectSpread({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread(_objectSpread({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: [],
        fileRejections: []
      });

    default:
      return state;
  }
}

var nameChanged = React.createElement("li", {
  className: "sid-acceptable-uploads-list__li"
}, React.createElement(FormattedHTMLMessage, {
  id: "step.docUpload.nameChanged",
  defaultMessage: "If your name has changed since the document was issued, upload a 2nd document showing your official name change."
}));

var AcceptableUploadsComponent = function AcceptableUploadsComponent(_ref155) {
  var verificationService = _ref155.verificationService;
  var segment = verificationService.verificationResponse.segment;
  var subSegment = verificationService.verificationResponse.subSegment;
  assertValidSegmentName(segment);
  var acceptableUploads;

  switch (segment) {
    case SegmentEnum.STUDENT:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.student.idCard",
        defaultMessage: "School ID card with expiration date"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.student.classSchedule",
        defaultMessage: "Class schedule"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.student.tuitionReceipt",
        defaultMessage: "Tuition receipt"
      })));
      break;

    case SegmentEnum.TEACHER:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.teacher.idCard",
        defaultMessage: "Teacher ID card with valid date"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.teacher.payStub",
        defaultMessage: "Pay stub from within last 60 days"
      })));
      break;

    case SegmentEnum.MEMBER:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.member.idCard",
        defaultMessage: "Membership Document"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.member.payStub",
        defaultMessage: "Pay stub from within last 90 days"
      })));
      break;

    case SegmentEnum.SENIOR:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.senior.birthCertificate",
        defaultMessage: "Your birth certificate"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.senior.driversLicense",
        defaultMessage: "Your drivers license"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.senior.passport",
        defaultMessage: "Your passport"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.senior.stateId",
        defaultMessage: "Your state-issued ID"
      })));
      break;

    case SegmentEnum.AGE:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.age.birthCertificate",
        defaultMessage: "Your birth certificate"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.age.driversLicense",
        defaultMessage: "Your drivers license"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.age.passport",
        defaultMessage: "Your passport"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.age.stateId",
        defaultMessage: "Your state-issued ID"
      })));
      break;

    case SegmentEnum.MILITARY:
      switch (subSegment) {
        case SubSegmentEnum.ACTIVE_DUTY:
          acceptableUploads = React.createElement("ul", {
            className: "sid-acceptable-uploads-list"
          }, React.createElement("li", {
            className: "sid-acceptable-uploads-list__li"
          }, React.createElement(FormattedHTMLMessage, {
            id: "step.docUpload.acceptableUploads.military.activeDuty",
            defaultMessage: "Any document that proves you are currently serving as active duty in the armed forces for 30 days or more"
          })), nameChanged);
          break;

        case SubSegmentEnum.VETERAN:
          acceptableUploads = React.createElement("ul", {
            className: "sid-list"
          }, React.createElement("li", {
            className: "sid-li"
          }, React.createElement(FormattedHTMLMessage, {
            id: "step.docUpload.acceptableUploads.military.veteran",
            defaultMessage: "Any document that proves you met the qualifications of military service and were honorably discharged"
          })), nameChanged);
          break;

        case SubSegmentEnum.RESERVIST:
          acceptableUploads = React.createElement("ul", {
            className: "sid-list"
          }, React.createElement("li", {
            className: "sid-li"
          }, React.createElement(FormattedHTMLMessage, {
            id: "step.docUpload.acceptableUploads.military.reservistA",
            defaultMessage: "Any document that shows you are currently serving in a reserve component of the armed forces"
          })), nameChanged);
          break;

        case SubSegmentEnum.MILITARY_RETIREE:
          acceptableUploads = React.createElement("ul", {
            className: "sid-list"
          }, React.createElement("li", {
            className: "sid-li"
          }, React.createElement(FormattedHTMLMessage, {
            id: "step.docUpload.acceptableUploads.military.retiree",
            defaultMessage: "Any document that proves you are a retiree from the armed forces"
          })), nameChanged);
          break;

        case SubSegmentEnum.MILITARY_FAMILY:
          acceptableUploads = React.createElement("ul", {
            className: "sid-list"
          }, React.createElement("li", {
            className: "sid-li"
          }, React.createElement(FormattedHTMLMessage, {
            id: "step.docUpload.acceptableUploads.military.dependent",
            defaultMessage: "Any document that proves you are a Registered Military Dependent"
          })), nameChanged);
          break;

        default:
          return null;
      }

      break;

    case SegmentEnum.FIRST_RESPONDER:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.firstResponder.idCard",
        defaultMessage: "ID Card"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.firstResponder.payStub",
        defaultMessage: "Pay stub from within last 60 days"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.firstResponder.letter",
        defaultMessage: "An official letter"
      })));
      break;

    case SegmentEnum.MEDICAL:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.medical.licenseCertificate",
        defaultMessage: "Certificate of license"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.medical.idCard",
        defaultMessage: "Nursing ID card with expiration date"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.medical.photoPayStub",
        defaultMessage: "Photo ID and recent Pay Stub"
      })));
      break;

    case SegmentEnum.EMPLOYMENT:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.employment.employeeIdCard",
        defaultMessage: "Employee ID Card"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.employment.payStub",
        defaultMessage: "Pay stub from within last 60 days"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.employment.officialLetter",
        defaultMessage: "An official letter"
      })));
      break;

    case SegmentEnum.LICENSED_PROFESSIONAL:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.licensedProfessional.license",
        defaultMessage: "Certificate of license"
      })));
      break;

    case SegmentEnum.RECENT_MOVER:
      acceptableUploads = React.createElement("ul", {
        className: "sid-acceptable-uploads-list"
      }, React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.recentMover.changeOfAddress",
        defaultMessage: "U.S. Postal Service change of address confirmation letter"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.recentMover.mortgageDeed",
        defaultMessage: "Mortgage deed"
      })), React.createElement("li", {
        className: "sid-acceptable-uploads-list__li"
      }, React.createElement(FormattedHTMLMessage, {
        id: "step.docUpload.acceptableUploads.recentMover.rentalAgreement",
        defaultMessage: "Lease or rental agreement"
      })));
      break;

    default:
      return null;
  }

  return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
    id: "step.docUpload.acceptableUploadExamples",
    defaultMessage: "Acceptable examples include:"
  }))), acceptableUploads);
};

var UploadInfoComponent = function UploadInfoComponent(_ref156) {
  var verificationService = _ref156.verificationService;
  var segment = verificationService.verificationResponse.segment;
  var subSegment = verificationService.verificationResponse.subSegment;
  assertValidSegmentName(segment);

  switch (segment) {
    case SegmentEnum.STUDENT:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload your school-issued document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.student.school",
        defaultMessage: "Your school"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.student.enrollmentDate",
        defaultMessage: "Date proving enrollment for the current term (or within last 3 months)"
      }))));

    case SegmentEnum.TEACHER:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload your school-issued document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.teacher.school",
        defaultMessage: "Your school"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.teacher.currentSchoolYear",
        defaultMessage: "A date in the current school year"
      }))));

    case SegmentEnum.MEMBER:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload an official document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.organization",
        defaultMessage: "Your organization"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.affiliation",
        defaultMessage: "Your current affiliation with that organization"
      }))));

    case SegmentEnum.MILITARY:
      switch (subSegment) {
        case SubSegmentEnum.MILITARY_FAMILY:
          return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
            id: "step.docUpload.uploadInfo.military.uploadInstructionsDependent",
            defaultMessage: "Please upload a Dependent ID card that clearly shows your first name, last name, valid dates and status"
          }))));

        default:
          return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
            id: "step.docUpload.uploadInstructions",
            defaultMessage: "Upload your government-issued document that shows:"
          }))), React.createElement("ul", {
            className: "sid-upload-info-list"
          }, React.createElement("li", {
            className: "sid-upload-info-list__li"
          }, React.createElement(FormattedMessage, {
            id: "step.docUpload.uploadInfo.fullName",
            defaultMessage: "Your full name"
          })), React.createElement("li", {
            className: "sid-upload-info-list__li"
          }, React.createElement(FormattedMessage, {
            id: "step.docUpload.uploadInfo.military.serviceBranch",
            defaultMessage: "Your branch of service"
          })), React.createElement("li", {
            className: "sid-upload-info-list__li"
          }, React.createElement(FormattedMessage, {
            id: "step.docUpload.uploadInfo.military.dischargeDate",
            defaultMessage: "Your discharge date (if applicable)"
          })), React.createElement("li", {
            className: "sid-upload-info-list__li"
          }, React.createElement(FormattedMessage, {
            id: "step.docUpload.uploadInfo.military.currentAffiliation",
            defaultMessage: "Your current affiliation with the armed services"
          }))));
      }

    case SegmentEnum.SENIOR:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload a government-issued document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.senior.birthDate",
        defaultMessage: "Your date of birth"
      }))));

    case SegmentEnum.AGE:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload a government-issued document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.age.birthDate",
        defaultMessage: "Your date of birth"
      }))));

    case SegmentEnum.FIRST_RESPONDER:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload an official document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.firstResponder.organization",
        defaultMessage: "Your organization"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.firstResponder.currentAffiliation",
        defaultMessage: "Your current affiliation with that organization"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.firstResponder.license",
        defaultMessage: "Your status or license as a First Responder"
      }))));

    case SegmentEnum.MEDICAL:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload an official document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.medical.status",
        defaultMessage: "Your nursing status"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.medical.validDate",
        defaultMessage: "A currently valid date"
      }))));

    case SegmentEnum.EMPLOYMENT:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload an official document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.employment.company",
        defaultMessage: "Your company"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.employment.currentAffiliation",
        defaultMessage: "Your current affiliation with that company"
      }))));

    case SegmentEnum.IDENTITY:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload an official document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.identity.validDate",
        defaultMessage: "A currently valid date"
      }))));

    case SegmentEnum.LICENSED_PROFESSIONAL:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload an official document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.licensedProfessional.licenseStatus",
        defaultMessage: "Your professional license and/or certification status"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.identity.validDate",
        defaultMessage: "A currently valid date"
      }))));

    case SegmentEnum.RECENT_MOVER:
      return React.createElement("div", null, React.createElement("span", null, React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInstructions",
        defaultMessage: "Upload an official document that shows:"
      }))), React.createElement("ul", {
        className: "sid-upload-info-list"
      }, React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.fullName",
        defaultMessage: "Your full name"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.recentMover.address",
        defaultMessage: "Your new address"
      })), React.createElement("li", {
        className: "sid-upload-info-list__li"
      }, React.createElement(FormattedMessage, {
        id: "step.docUpload.uploadInfo.recentMover.validDate",
        defaultMessage: "A valid date for your recent move"
      }))));

    default:
      return null;
  }
};

var StepDocUpload = function StepDocUpload(_ref157) {
  var verificationService = _ref157.verificationService,
      intl = _ref157.intl;
  var verificationResponse = verificationService.verificationResponse;
  var rejectionReasons = verificationResponse.rejectionReasons;
  var programTheme = verificationService.programTheme;
  var viewModel = verificationService.viewModel;
  var fieldValidationErrors = verificationService.fieldValidationErrors;
  var hasLogo = !!getLogoUrl(programTheme);
  var subSegment = getSafe(function () {
    return verificationService.verificationResponse.subSegment;
  });

  var getFileForView = function getFileForView(file) {
    return {
      name: file.name,
      url: file.type.includes('image') ? URL.createObjectURL(file) : ''
    };
  };

  var currentFileNames = [];

  if (viewModel.file1 && viewModel.file1.name) {
    currentFileNames.push(getFileForView(viewModel.file1));
  }

  if (viewModel.file2 && viewModel.file2.name) {
    currentFileNames.push(getFileForView(viewModel.file2));
  }

  if (viewModel.file3 && viewModel.file3.name) {
    currentFileNames.push(getFileForView(viewModel.file3));
  }

  var addFilesAndUpdate = function addFilesAndUpdate(files, erroredFilenames) {
    verificationService.updateViewModel(addFiles(viewModel, files, erroredFilenames));
  };

  var removeFileAndUpdate = function removeFileAndUpdate(arrayIndex) {
    var fileNumber = arrayIndex + 1;
    verificationService.updateViewModel(removeFile(viewModel, fileNumber));
  };

  var removeFilesAndUpdate = function removeFilesAndUpdate() {
    var nextFieldValidationErrors = fn(fieldValidationErrors, function (draft) {
      draft.docUpload = undefined;
    });
    verificationService.updateFieldValidationErrors(nextFieldValidationErrors);
    verificationService.updateViewModel(removeAllFiles(viewModel));
  };

  var updateFieldValidationErrorsAndAddFiles = function updateFieldValidationErrorsAndAddFiles(files) {
    var acceptedFiles = [];
    var errors = [];
    var erroredFilenames = [];

    var _iterator4 = _createForOfIteratorHelper(files),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var file = _step4.value;
        var fileValidationError = validateFieldById(VerificationStepsEnum.docUpload, file);

        if (fileValidationError === undefined) {
          acceptedFiles.push(file);
        } else {
          erroredFilenames.push(file.name);
          errors.push(fileValidationError);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    var nextFieldValidationErrors;

    if (errors) {
      nextFieldValidationErrors = fn(fieldValidationErrors, function (draft) {
        draft.docUpload = errors[0]; // we only care about one error at a time
      });
    }

    verificationService.updateFieldValidationErrors(nextFieldValidationErrors);
    addFilesAndUpdate(acceptedFiles, erroredFilenames);
  };

  var submitForm = function submitForm() {
    logger.info('StepDocUploadComponent submitting form');
    verificationService.submitStep(VerificationStepsEnum.docUpload, viewModel, verificationService.verificationResponse);
  };

  var onFileDrop = function onFileDrop(draggedFiles) {
    if (draggedFiles.length > 0) {
      updateFieldValidationErrorsAndAddFiles(draggedFiles);
    } else if (draggedFiles.length <= 0) {
      logger.error('No files were accepted or rejected. Unknown error.', 'docUpload drag n drop');
    }
  };

  var fileHandler = function fileHandler(e) {
    onFileDrop(Array.from(e.target.files));
  };

  var handleAddFileOnKeyDown = function handleAddFileOnKeyDown(e) {
    var addFileRef = getRefByFieldId('addFile');

    if (e.key === 'Enter' || e.key === ' ') {
      addFileRef.click();
    }
  };

  var errorId = fieldValidationErrors.docUpload || getSafe(function () {
    return verificationService.verificationResponse.errorIds[0];
  }, undefined);
  var conditionalErrorMsg = errorId ? React.createElement("div", {
    className: "sid-field-error sid-field-error__doc-upload sid-l-horz-center"
  }, React.createElement(FormattedHTMLMessage, {
    id: "errorId.".concat(fieldValidationErrors.docUpload),
    defaultMessage: "No valid files"
  }), viewModel.erroredFileNames ? viewModel.erroredFileNames.map(function (filename) {
    return React.createElement("div", null, filename);
  }) : null) : null;
  return React.createElement("div", {
    id: "sid-step-doc-upload",
    className: "sid-l-container"
  }, React.createElement("div", {
    className: "sid-header sid-l-horz-center sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-l-horz-center"
  }, hasLogo ? React.createElement(LogoComponent, {
    verificationService: verificationService
  }) : React.createElement("img", {
    className: "sid-l-lead-image",
    alt: "design element",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/doc-upload2.svg"
  })), React.createElement("div", {
    className: "sid-header__title sid-l-horz-center sid-l-space-top-md"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.docUpload.title",
    defaultMessage: "We need more information"
  })), React.createElement(RewardsRemainingComponent, {
    verificationService: verificationService
  }), rejectionReasons && rejectionReasons.length > 0 ? React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-l-position"
  }, React.createElement("div", null, React.createElement(FormattedMessage, {
    id: "step.docUpload.rejectedSubtitle",
    defaultMessage: "We were unable to confirm your eligibility due to:"
  })), React.createElement("ul", {
    className: "sid-upload-rejection-list"
  }, rejectionReasons.map(function (rejectionReason) {
    return React.createElement("li", {
      key: rejectionReason,
      className: "sid-upload-rejection-list__li"
    }, React.createElement(FormattedMessage, {
      id: "step.docUpload.rejectionReasons.".concat(rejectionReason),
      defaultMessage: "".concat(rejectionReason)
    }));
  }))) : React.createElement("div", {
    className: "sid-header__subtitle sid-l-horz-center sid-l-position"
  }, React.createElement("div", null, React.createElement(FormattedMessage, {
    id: "step.docUpload.subtitle",
    defaultMessage: "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
    values: {
      estimatedWaitTime: getEstAndMaxReviewTimes(verificationResponse, programTheme, intl).estReviewTime
    }
  }), "\xA0", React.createElement(HowDoesVerifyingWorkComponent, {
    verificationService: verificationService
  })))), currentFileNames.length === 0 ? React.createElement("div", null, React.createElement("div", {
    className: "sid-upload-info sid-l-space-top-md"
  }, React.createElement("div", {
    className: "sid-l-space-top-sm"
  }, React.createElement(UploadInfoComponent, {
    verificationService: verificationService
  })), subSegment === SubSegmentEnum.MILITARY_FAMILY ? null : React.createElement("div", {
    className: "sid-l-space-top-md"
  }, React.createElement(AcceptableUploadsComponent, {
    verificationService: verificationService
  }))), React.createElement("div", {
    className: "sid-upload-wrap sid-l-space-top-sm"
  }, React.createElement("div", {
    className: "sid-dropzone-wrap"
  }, conditionalErrorMsg, React.createElement(Dropzone, {
    onDrop: onFileDrop
  }, function (_ref158) {
    var getRootProps = _ref158.getRootProps,
        getInputProps = _ref158.getInputProps;
    return React.createElement("section", Object.assign({}, getRootProps(), {
      className: "sid-dropzone-wrap__dropzone"
    }), React.createElement("input", Object.assign({}, getInputProps())), React.createElement("p", {
      className: "sid-dropzone-wrap__instructions sid-l-horz-center"
    }, React.createElement(FormattedHTMLMessage, {
      id: "step.docUpload.fileInstructions",
      defaultMessage: 'Drag & drop your files here or <span class="sid-dropzone-wrap__link">browse</span>'
    })));
  }), React.createElement("div", {
    className: "sid-dropzone-wrap__accepted-types sid-l-space-top-sm"
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.docUpload.acceptedTypes",
    defaultMessage: "Acceptable file types: png, gif, jpg, bmp, pdf"
  }))))) : null, React.createElement("div", {
    className: "sid-upload-wrap sid-l-space-top-sm"
  }, currentFileNames.length > 0 ? React.createElement("div", {
    className: "sid-file-list sid-l-space-top-md"
  }, currentFileNames.map(function (file, arrayIndex) {
    return React.createElement("div", {
      className: "sid-file-list__file",
      key: file.name
    }, file.url ? React.createElement("img", {
      className: "sid-file-list__thumbnail",
      src: file.url,
      alt: "File thumbnail"
    }) : React.createElement("div", {
      className: "sid-file-list__no-thumbnail"
    }, React.createElement("img", {
      alt: "File thumbnail",
      src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/default-image.svg"
    })), React.createElement("div", {
      className: "sid-file-list__name"
    }, file.name), React.createElement("div", {
      role: "button",
      tabIndex: 0,
      "aria-label": "Remove file ".concat(file.name),
      className: "sid-file-list__remove-btn",
      onClick: function onClick() {
        return removeFileAndUpdate(arrayIndex);
      },
      onKeyPress: function onKeyPress() {
        return removeFileAndUpdate(arrayIndex);
      }
    }));
  }), conditionalErrorMsg, currentFileNames.length < MAX_DOC_UPLOAD_DOCS_ALLOWED ? React.createElement("div", {
    className: "sid-add-more-files"
  }, React.createElement("label", {
    className: "sid-add-more-files__label sid-add-more-files--selectable",
    htmlFor: "file",
    "aria-label": "add file",
    id: "sid-add-file",
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    role: "button",
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      return handleAddFileOnKeyDown(e);
    }
  }, React.createElement("input", {
    type: "file",
    id: "file",
    tabIndex: -1,
    className: "sid-add-more-files__input",
    "aria-describedby": "sid-add-file",
    onChange: fileHandler,
    accept: "image/jpeg,image/gif,image/png,application/pdf,image/bmp,image/gif",
    ref: function ref(input) {
      return setRef('addFile', input);
    }
  }), React.createElement("img", {
    className: "sid-add-more-files__image",
    alt: "add more files",
    src: "https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/add-file.svg"
  }), React.createElement(FormattedMessage, {
    id: "step.docUpload.addFile",
    defaultMessage: "Add file"
  }))) : null, React.createElement("div", {
    className: "sid-submit sid-l-space-top-md"
  }, React.createElement("button", {
    id: "sid-submit-doc-upload",
    onClick: submitForm,
    type: "submit",
    className: "sid-btn sid-btn--dark sid-submit__continue",
    "aria-label": intl.formatMessage({
      id: 'step.docUpload.submitButtonLabel',
      defaultMessage: 'Continue'
    }),
    disabled: currentFileNames.length <= 0
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.docUpload.submitButtonLabel",
    defaultMessage: "Continue"
  })), React.createElement("button", {
    onClick: removeFilesAndUpdate,
    type: "button",
    className: "sid-btn sid-btn--light sid-submit__cancel sid-l-space-left-sm",
    "aria-label": "cancel",
    disabled: currentFileNames.length <= 0
  }, React.createElement(FormattedHTMLMessage, {
    id: "step.docUpload.cancelButtonLabel",
    defaultMessage: "Cancel"
  })))) : null), React.createElement(FormFooterComponent, {
    verificationService: verificationService
  }));
};

var StepDocUploadComponent = injectIntl(StepDocUpload);
/**
 * TODO - preamble
 */

var defaultComponents = {
  StepStudentPersonalInfoComponent: StepStudentPersonalInfoComponent,
  StepSeniorPersonalInfoComponent: StepSeniorPersonalInfoComponent,
  StepAgePersonalInfoComponent: StepAgePersonalInfoComponent,
  StepTeacherPersonalInfoComponent: StepTeacherPersonalInfoComponent,
  StepMemberPersonalInfoComponent: StepMemberPersonalInfoComponent,
  StepCollectMilitaryStatusComponent: StepCollectMilitaryStatusComponent,
  StepActiveMilitaryPersonalInfoComponent: StepActiveMilitaryPersonalInfoComponent,
  StepInactiveMilitaryPersonalInfoComponent: StepInactiveMilitaryPersonalInfoComponent,
  StepFirstResponderPersonalInfoComponent: StepFirstResponderPersonalInfoComponent,
  StepMedicalProfessionalPersonalInfoComponent: StepMedicalProfessionalPersonalInfoComponent,
  StepEmploymentPersonalInfoComponent: StepEmploymentPersonalInfoComponent,
  StepDriverLicensePersonalInfoComponent: StepDriverLicensePersonalInfoComponent,
  StepGeneralIdentityPersonalInfoComponent: StepGeneralIdentityPersonalInfoComponent,
  StepHybridIdentityPersonalInfoComponent: StepHybridIdentityPersonalInfoComponent,
  StepLicensedProfessionalPersonalInfoComponent: StepLicensedProfessionalPersonalInfoComponent,
  StepMoverPersonalInfoComponent: StepMoverPersonalInfoComponent,
  StepSocialSecurityNumber: StepSocialSecurityNumber,
  StepSuccessComponent: StepSuccessComponent,
  StepDocUploadComponent: StepDocUploadComponent,
  StepPendingComponent: StepPendingComponent,
  StepSSOComponent: StepSSOComponent,
  StepErrorComponent: StepErrorComponent,
  StepSMSLoopComponent: StepSMSLoopComponent,
  StepEmailLoopComponent: StepEmailLoopComponent
};

var getComponent = function getComponent(componentName) {
  logger.info('getComponent', componentName);
  var overriddenComponent = getOverridenComponent(componentName);

  if (overriddenComponent) {
    return overriddenComponent;
  }

  return defaultComponents[componentName];
};

var getLoadingScreen = function getLoadingScreen() {
  return React.createElement(LoadingScreenComponent, null);
};

var LoadStepComponent = function LoadStepComponent(_ref159) {
  var stepToLoad = _ref159.stepToLoad,
      verificationService = _ref159.verificationService;
  logger.info("LoadStepComponent: rendering step: ".concat(stepToLoad));
  var Component;
  var isSecondaryStep = false;

  switch (stepToLoad) {
    case VerificationStepsEnum.collectStudentPersonalInfo:
      Component = getComponent('StepStudentPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectSeniorPersonalInfo:
      Component = getComponent('StepSeniorPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectAgePersonalInfo:
      Component = getComponent('StepAgePersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectTeacherPersonalInfo:
      Component = getComponent('StepTeacherPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectMemberPersonalInfo:
      Component = getComponent('StepMemberPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectMilitaryStatus:
      Component = getComponent('StepCollectMilitaryStatusComponent');
      break;

    case VerificationStepsEnum.collectActiveMilitaryPersonalInfo:
      Component = getComponent('StepActiveMilitaryPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectInactiveMilitaryPersonalInfo:
      Component = getComponent('StepInactiveMilitaryPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectFirstResponderPersonalInfo:
      Component = getComponent('StepFirstResponderPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectMedicalProfessionalPersonalInfo:
      Component = getComponent('StepMedicalProfessionalPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectEmployeePersonalInfo:
      Component = getComponent('StepEmploymentPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectDriverLicensePersonalInfo:
      Component = getComponent('StepDriverLicensePersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectGeneralIdentityPersonalInfo:
      Component = getComponent('StepGeneralIdentityPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectHybridIdentityPersonalInfo:
      Component = getComponent('StepHybridIdentityPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectLicensedProfessionalPersonalInfo:
      Component = getComponent('StepLicensedProfessionalPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectMoverPersonalInfo:
      Component = getComponent('StepMoverPersonalInfoComponent');
      break;

    case VerificationStepsEnum.collectSocialSecurityNumber:
      Component = getComponent('StepSocialSecurityNumber');
      break;

    case VerificationStepsEnum.success:
      Component = getComponent('StepSuccessComponent');
      isSecondaryStep = true;
      break;

    case VerificationStepsEnum.docUpload:
      Component = getComponent('StepDocUploadComponent');
      isSecondaryStep = true;
      break;

    case VerificationStepsEnum.pending:
      Component = getComponent('StepPendingComponent');
      isSecondaryStep = true;
      break;

    case VerificationStepsEnum.sso:
      Component = getComponent('StepSSOComponent');
      break;

    case VerificationStepsEnum.smsLoop:
      Component = getComponent('StepSMSLoopComponent');
      isSecondaryStep = true;
      break;

    case VerificationStepsEnum.emailLoop:
      Component = getComponent('StepEmailLoopComponent');
      isSecondaryStep = true;
      break;
    // If explicitly trying to render the error component, such as when testing/styling

    case VerificationStepsEnum.error:
      Component = getComponent('StepErrorComponent');
      break;

    default:
      var msg = "Error: Unknown step to render in LoadStepComponent.\n                Unable to render step name \"".concat(stepToLoad, "\". Possible steps are [").concat(VerificationSteps.join(', '), "]");
      logger.error(msg, 'Unknown step in LoadStepComponent');
      return React.createElement(StepErrorComponent, {
        verificationService: verificationService,
        errorId: "invalidStep"
      });
  }

  return !isSecondaryStep ? React.createElement(Component, {
    verificationService: verificationService
  }) : React.createElement(Suspense$4, {
    fallback: getLoadingScreen()
  }, React.createElement(Component, {
    verificationService: verificationService
  }));
};

var removePollutingStyles = function removePollutingStyles(styles) {
  if (window.self === window.top) {
    return styles.replace(/body,/g, '').replace(/label,/g, '').replace(/button\[type=('|")submit('|")\]\s*?\{[\s\S]*?\}\n?/g, '') // button type submit overwrites
    .replace(/a:link,\s+a:visited,\s+a:hover,\s+a:active\s*?\{[\s\S]*?\}\n?/g, '') // links overwrites
    .replace(/h1\s*?\{[\s\S]*?\}\n?/g, ''); // h1 overwrites
  }

  return styles;
};

var CustomCssWrapperComponent = function CustomCssWrapperComponent(_ref160) {
  var styles = _ref160.styles,
      children = _ref160.children;
  return React.createElement("div", null, styles ? React.createElement("style", null, removePollutingStyles(styles)) : null, children);
};

CustomCssWrapperComponent.defaultProps = {
  styles: '',
  children: ''
};

var TestModeFlagComponent = function TestModeFlagComponent(_ref161) {
  var verificationService = _ref161.verificationService;
  return verificationService.programTheme && verificationService.programTheme.isTestMode ? React.createElement("div", {
    className: "sid-test-mode-flag sid-l-container sid-l-horz-center"
  }, "Test Mode", React.createElement(LinkExternal, {
    className: "sid-test-mode-flag__link sid-link",
    href: "http://developer.sheerid.com/getting-started#test-program"
  }, "(learn more)")) : null;
};

var loadIPQSDeviceFingerprintScript = /*#__PURE__*/function () {
  var _ref162 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
    var existingScript;
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            existingScript = document.getElementById('ipqs');

            if (existingScript) {
              _context41.next = 3;
              break;
            }

            return _context41.abrupt("return", new Promise(function (resolve) {
              var scriptTag = document.createElement('script');
              scriptTag.src = 'https://fd.sheerid.com/api/*/BJOvvIiNpZnA9XHXIHVc0S4FO87k4eub6NLOfmShTU7nRqamLKTzQixwD7XETz7bvtNHmicHNx9hEtOJ9NPo3kUJBl7o1jpwcbcXeOMDJjvulAWSrRnO7WYq9gxL6xNT0xnfou5UlshUGWQ2g68qBuWajMWbxZ25JELntxaP0neiVUbephG5E79ES89qBo4uIGBDvykdJb75hpo0URvJ0Fm1j6fuEqHQBq64Mi390KC9XoQwiFxyboxQ5lSooY4p/learn.js';
              scriptTag.async = true;
              scriptTag.id = 'ipqs';
              document.body.appendChild(scriptTag);

              scriptTag.onload = function () {
                resolve();
              };
            }));

          case 3:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41);
  }));

  return function loadIPQSDeviceFingerprintScript() {
    return _ref162.apply(this, arguments);
  };
}();

var includeIPQSDeviceFingerprintScript = /*#__PURE__*/function () {
  var _ref163 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(programTheme, verificationId) {
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            if (!getSafe(function () {
              return programTheme.ipqsDeviceFingerprintEnabled;
            }, false)) {
              _context42.next = 4;
              break;
            }

            _context42.next = 3;
            return loadIPQSDeviceFingerprintScript();

          case 3:
            window.IPQ = {
              Callback: function Callback() {
                window.Startup.Store('transactionID', verificationId);
                window.Startup.Init();
              }
            };

          case 4:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42);
  }));

  return function includeIPQSDeviceFingerprintScript(_x76, _x77) {
    return _ref163.apply(this, arguments);
  };
}();

var NewVerificationInnerComponent = function NewVerificationInnerComponent(_ref164) {
  var locale = _ref164.locale,
      messages = _ref164.messages,
      programTheme = _ref164.programTheme,
      verificationService = _ref164.verificationService;
  React.useEffect(function () {
    includeIPQSDeviceFingerprintScript(programTheme, verificationService.verificationResponse.verificationId);
  }, [verificationService.verificationResponse.verificationId]);

  var messagesWithOptions = _objectSpread2({}, messages, flat(getOptionsMessages(locale)));

  return (// Don't change locale, so we don't have to load pluralization data, which has complications. HD-560
    React.createElement(IntlProvider, {
      locale: "en",
      key: locale,
      messages: messagesWithOptions,
      textComponent: CustomTextWrapper
    }, React.createElement(CustomCssWrapperComponent, {
      styles: getCustomCss(programTheme)
    }, verificationService.isLoading ? React.createElement(LoadingScreenComponent, {
      step: verificationService.loadingStep
    }) : React.createElement("div", {
      className: rtlDetect_1.isRtlLang(modernizeLocale(locale)) ? 'sid-rtl' : 'sid-ltr'
    }, React.createElement(TestModeFlagComponent, {
      verificationService: verificationService
    }), React.createElement(LoadStepComponent, {
      stepToLoad: verificationService.verificationResponse.currentStep,
      verificationService: verificationService
    }))))
  );
};
/* eslint-disable */


var NewVerification = /*#__PURE__*/function (_React$Component3) {
  _inherits(NewVerification, _React$Component3);

  function NewVerification(props) {
    var _this11;

    _classCallCheck(this, NewVerification);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(NewVerification).call(this, props));
    logger.info('NewVerificationComponent: constructing');

    if (_this11.props.trackingId && _this11.props.trackingId.length) {
      logger.info("Attaching a trackingId to this verification request ".concat(_this11.props.trackingId));
    } else {
      logger.info('No trackingId to associate with the verification request');
    }

    return _this11;
  }

  _createClass(NewVerification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this12 = this;

      N(); // https://sheerid.atlassian.net/browse/UX-362
      // Special-case, mocking the loading psuedo-step

      if (isMockingLoading()) {
        logger.info('Mocking loading screen. Not fetching new verification request.');
      } else {
        logger.info('NewVerificationComponent: fetchNewVerificationRequest');
        var currentSegment = getSafe(function () {
          return _this12.props.verificationService.verificationResponse.segment;
        });
        this.props.verificationService.fetchNewVerificationRequest(this.props.programId, currentSegment, this.props.verificationService.previousViewModel, this.props.trackingId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // Note: If we have a loadingStep set we don't use this loading screen, we use the one inside
      // the inner component that is inside the internationalization provoder.
      if (this.props.verificationService.isLoading && !this.props.verificationService.loadingStep) {
        logger.info('NewVerificationComponent: VerificationService is loading');
        return React.createElement(LoadingScreenComponent, null);
      }

      var programTheme = this.props.verificationService.programTheme;
      var verificationResponse = this.props.verificationService.verificationResponse;
      var viewModel = this.props.verificationService.viewModel;
      logger.info('NewVerificationComponent: verificationResponse, viewModel', verificationResponse, viewModel);
      var locale = getLocaleSafely(viewModel);
      var messages; // optional param `messages`. If we do not have it, all <FormattedMessages /> should use default fallback anyway.

      if (this.props.messages) {
        messages = this.props.messages;
      }

      logger.info("NewVerificationComponent: locale: ".concat(locale, ", currentStep: ").concat(verificationResponse.currentStep, ", messages: "), messages);
      return React.createElement(NewVerificationInnerComponent, {
        locale: locale,
        messages: messages,
        programTheme: programTheme,
        verificationService: this.props.verificationService
      });
    }
  }]);

  return NewVerification;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return _objectSpread2({}, state);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchNewVerificationRequest: createFetchNewVerificationRequest(dispatch),
    fetchExistingVerificationRequest: createFetchExistingVerificationRequest(dispatch),
    updateViewModel: createUpdateViewModel(dispatch),
    updateLocale: createUpdateLocale(dispatch, ownProps.programId),
    updateProgramTheme: createUpdateProgramTheme(dispatch),
    updateFieldValidationErrors: createUpdateFieldValidationErrors(dispatch),
    submitStep: createSubmitStep(dispatch)
  };
}; // Return a VerificationService


var mergeProps = function mergeProps(propsFromState, propsFromDispatch, ownProps) {
  return _objectSpread2({
    verificationService: _objectSpread2({}, propsFromState, propsFromDispatch),
    messages: propsFromState.messages
  }, ownProps);
};

var NewVerificationComponent = connect(mapStateToProps, mapDispatchToProps, mergeProps)(NewVerification);
var store = getStore(); // This call can take place at any time after the jslib .js file is parsed
// It only needs to be called once per page-load

setDimension('jslibVersionActual', getSafe(function () {
  return getPublishedVersion();
}, '?'));
var VerificationForm = React.forwardRef(function (_ref165, ref) {
  var programId = _ref165.programId,
      _ref165$trackingId = _ref165.trackingId,
      trackingId = _ref165$trackingId === void 0 ? undefined : _ref165$trackingId;
  addPredefinedHooks(); // keep this as early as possible in the jslib initialization

  store.dispatch({
    programId: programId,
    type: 'PROGRAM_ID'
  });

  if (ref) {
    ref.current = {
      refresh: React.useCallback(function () {
        return store.dispatch({
          type: 'FORCE_UPDATE'
        });
      }, []),
      reset: React.useCallback(function () {
        return store.dispatch({
          type: 'RESET_STATE'
        });
      }, [])
    };
  }

  return React.createElement(Provider, {
    store: store
  }, React.createElement(FormWrapperComponent, null, React.createElement(NewVerificationComponent, {
    programId: programId,
    trackingId: trackingId
  })));
});
var postalCodeMatchers = {
  US: '(^\\d{5}-?$)|(^\\d{5}-\\d{4}$)',
  AU: '^\\d{4}$',
  CA: '^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d$',
  FR: '^\\d{2} ?\\d{3}$',
  DE: '^\\d{5}$',
  IT: '^\\d{5}$',
  MX: '^\\d{5}$',
  NL: '^\\d{4} ?[A-Z]{2}$',
  ES: '^\\d{5}$',
  GB: '^GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\\d{1,4}$'
};

var fadeInElements = function fadeInElements(elements) {
  elements.forEach(function (element) {
    element.classList.add('fade-in');
  });
};

var removeElement = function removeElement(element, transitionTimeout) {
  element.classList.remove('fade-in');
  window.setTimeout(function () {
    document.body.style.overflow = 'auto';
    element.parentNode.removeChild(element);
  }, transitionTimeout);
};

var getVerificationUrl = function getVerificationUrl(url) {
  var newUrl = new URL(url);
  var parentUrl = new URL(window.location.href); // Combine query parameters from parent window and provided url.
  // If duplicates, provided url parameters supercede.

  parentUrl.searchParams.forEach(function (value, key) {
    if (!newUrl.searchParams.has(key)) {
      newUrl.searchParams.set(key, value);
    }
  });
  return newUrl.href;
};

var Iframe = /*#__PURE__*/function () {
  function Iframe(containerElement, url) {
    _classCallCheck(this, Iframe);

    if (Iframe.isValidHttpUrl(url)) {
      var _options = {
        className: iframeConstants.CLASS_NAMES.INLINE_IFRAME_CONTENT
      };
      this.containerElement = containerElement;
      this.verificationUrl = new URL(getVerificationUrl(url));
      this.verificationIframeUid = Iframe.createUniqueId();
      this.createIframe(_options);
      this.addVerificationSizeUpdatesListener();
    } else {
      logger.error('Invalid URL. Provide a proper URL: https://example.com/', 'iframe url');
    }
  }

  _createClass(Iframe, [{
    key: "createIframe",
    value: function createIframe(options) {
      this.iframe = document.createElement('iframe');
      this.iframe.classList.add(options.className);
      this.iframe.title = this.verificationUrl.href;
      var mark = '?';

      if (this.verificationUrl.search) {
        mark = '&';
      }

      this.iframe.src = "".concat(this.verificationUrl.href).concat(mark, "verificationIframeUid=").concat(this.verificationIframeUid, "&").concat(QUERY_STRING_INSTALL_PAGE_URL, "=").concat(encodeURIComponent(getCurrentUrl()));
      return this.iframe;
    }
  }, {
    key: "addVerificationSizeUpdatesListener",
    value: function addVerificationSizeUpdatesListener() {
      var _this13 = this;

      window.addEventListener('message', function (event) {
        if (_this13.verificationUrl.origin !== event.origin) {
          return;
        }

        var message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

        if (message.verificationIframeUid !== _this13.verificationIframeUid) {
          return;
        }

        switch (message.action) {
          case 'updateHeight':
            _this13.iframe.style.height = "".concat(message.height, "px");
            break;

          default:
            logger.error('Unsupported message.action');
        }
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.containerElement.appendChild(this.iframe);
    }
  }], [{
    key: "createUniqueId",
    value: function createUniqueId() {
      return Math.random().toString(36).substr(2, 9);
    }
  }, {
    key: "isValidHttpUrl",
    value: function isValidHttpUrl(urlString) {
      try {
        var url = new URL(urlString);
        return url.protocol === 'http:' || url.protocol === 'https:';
      } catch (_unused2) {
        return false;
      }
    }
  }]);

  return Iframe;
}();

var Modal = /*#__PURE__*/function () {
  function Modal(url, userConfig) {
    var _this14 = this;

    _classCallCheck(this, Modal);

    this.popStateEventHandler = function () {
      return _this14.closeModal(true);
    };

    var thresholdConfig = userConfig.mobileThreshold ? userConfig.mobileThreshold : iframeConstants.DEFAULT_MOBILE_THRESHOLD_WIDTH;
    this.verificationUrl = getVerificationUrl(url);
    this.redirectOnMobile = userConfig.mobileRedirect || false;
    this.isMobileDevice = window.innerWidth <= thresholdConfig;
    this.closeButtonText = userConfig.closeButtonText ? userConfig.closeButtonText : '';
    this.stopPropagation = userConfig.stopPropagation || false;
    this.overlay = Modal.createOverlay();
    this.wrapper = this.createWrapper();
  }

  _createClass(Modal, [{
    key: "createCloseBtn",
    value: function createCloseBtn() {
      var _this15 = this;

      var closeButton = document.createElement('a');
      closeButton.classList.add(iframeConstants.CLASS_NAMES.CLOSE_BUTTON);
      closeButton.href = '#';

      if (this.closeButtonText) {
        var closeTxt = document.createElement('div');
        closeTxt.classList.add(iframeConstants.CLASS_NAMES.CLOSE_TEXT);
        closeTxt.innerHTML = this.closeButtonText;
        closeButton.appendChild(closeTxt);
      }

      var closeIcon = document.createElement('span');
      closeIcon.classList.add(iframeConstants.CLASS_NAMES.CLOSE_ICON);
      closeIcon.setAttribute('role', 'img');
      closeIcon.setAttribute('aria-label', 'Close');
      closeButton.appendChild(closeIcon);
      closeButton.addEventListener('click', function (e) {
        e.preventDefault();

        if (_this15.stopPropagation) {
          e.stopPropagation();
        }

        _this15.closeModal();
      });
      return closeButton;
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      var historyEventTrigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      window.removeEventListener('popstate', this.popStateEventHandler);
      var transitionTimeout = iframeConstants.MODAL_OPACITY_TRANSITION_PERIOD;
      removeElement(this.overlay, transitionTimeout);
      removeElement(this.wrapper, transitionTimeout);

      if (!historyEventTrigger) {
        window.history.back();
      }
    }
  }, {
    key: "createWrapper",
    value: function createWrapper() {
      var wrapper = document.createElement('div');
      wrapper.classList.add(iframeConstants.CLASS_NAMES.MODAL_WRAPPER);
      wrapper.tabIndex = -1;
      wrapper.setAttribute('role', 'dialog');
      wrapper.appendChild(this.createCloseBtn());
      var iframe = new Iframe(wrapper, this.verificationUrl);
      var options = {
        className: iframeConstants.CLASS_NAMES.MODAL_IFRAME
      };
      this.iframe = iframe.createIframe(options);
      wrapper.appendChild(this.iframe);
      return wrapper;
    }
  }, {
    key: "addPopStateListener",
    value: function addPopStateListener() {
      window.addEventListener('popstate', this.popStateEventHandler);
    }
  }, {
    key: "displayModal",
    value: function displayModal() {
      var _this16 = this;

      this.iframe.addEventListener('load', function () {
        fadeInElements([_this16.overlay, _this16.wrapper]);
        document.body.style.overflow = 'hidden';
      });
      document.body.appendChild(this.overlay);
      document.body.appendChild(this.wrapper);
      window.history.pushState({}, document.title);
      this.addPopStateListener();
    }
  }, {
    key: "init",
    value: function init() {
      if (this.redirectOnMobile && this.isMobileDevice) {
        window.top.location.href = this.verificationUrl;
      } else {
        this.displayModal();
      }
    }
  }], [{
    key: "createOverlay",
    value: function createOverlay() {
      var overlay = document.createElement('div');
      overlay.classList.add(iframeConstants.CLASS_NAMES.OVERLAY);
      return overlay;
    }
  }]);

  return Modal;
}();

function loadInlineIframe(containerElement, url) {
  var iframe = new Iframe(containerElement, url);
  iframe.init();
}

function loadInModal(url) {
  var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var modal = new Modal(url, userConfig);
  modal.init();
}

function postVerificationSizeUpdates() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    origin: '*',
    interval: 100
  };

  if (window.self !== window.top) {
    var bodyHeight = document.body.offsetHeight;
    var interval = window.setInterval(function () {
      if (bodyHeight !== document.body.offsetHeight) {
        bodyHeight = document.body.offsetHeight;
        var heightWithComputedMargins = bodyHeight + parseInt(window.getComputedStyle(document.body).marginTop, 10) + parseInt(window.getComputedStyle(document.body).marginBottom, 10);
        var verificationUrl = new URL(window.location.href);
        var verificationIframeUid = verificationUrl.searchParams.get('verificationIframeUid');
        window.parent.postMessage({
          verificationIframeUid: verificationIframeUid,
          action: 'updateHeight',
          height: heightWithComputedMargins
        }, options.origin);
      }
    }, options.interval);
    return function () {
      return clearInterval(interval);
    };
  }
}

var collectDeviceProfile = /*#__PURE__*/function () {
  var _ref166 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(verificationId, programId) {
    var programTheme;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            _context43.next = 2;
            return VerificationApiClient.fetchProgramTheme(programId);

          case 2:
            programTheme = _context43.sent;

            if (getSafe(function () {
              return programTheme.threatMetrixEnabled;
            }, false)) {
              collectThreatMetrixProfile(verificationId);
            }

            includeIPQSDeviceFingerprintScript(programTheme, verificationId);

          case 5:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43);
  }));

  return function collectDeviceProfile(_x78, _x79) {
    return _ref166.apply(this, arguments);
  };
}();

export { ACCEPTED_DOC_MIME_TYPES, AcceptableUploadsComponent, AddressComponent, BirthDateComponent, BranchOfServiceComponent, ChangeLocaleComponent, CityComponent, CollegeNameComponent, CompanyComponent, CopyToClipboard, CountDownComponent, CountryComponent, CountryComponentWrapper, DEFAULT_LOCALE, DEFAULT_MINIMUM_ORG_SEARCH_VALUE_LENGTH, DEFAULT_PRIVACY_POLICY_URL, DeleteJson, DischargeDateComponent, DriverLicenseNumberComponent, EmailComponent, FaqLinkComponent, FetchOrganizationsComponent, FieldIdEnum, FieldIds, FirstNameComponent, FirstResponderOrganizationComponent, FirstResponderStatusComponent, FirstResponderStatusDefaultMessagesEnum, FormFooterComponent, GetEmptyTheme, GetJson, GetResponse, HTTP_REQUEST_TIMEOUT, HookNameEnum, HookNames, HowDoesVerifyingWorkComponent, InputSelectButtonComponent, InputSelectComponent, InputSelectListComponent, InputTextComponent, LastNameComponent, LicensedProfessionalOrganizationComponent, LinkExternal, LoadingSpinnerComponent, Locales, LogoComponent, MAX_DOC_UPLOAD_DOCS_ALLOWED, MarketConsentWrapperComponent as MarketConsentWrapper, MedicalProfessionalOrganizationComponent, MedicalProfessionalStatusDefaultMessagesEnum, MedicalStatusComponent, MemberIdComponent, MembershipOrganizationComponent, MilitaryStatusComponent, MilitaryStatusDefaultMessagesEnum, MockSteps, MockStepsEnum, OptInComponent, OptInInputComponent, OrganizationListComponent, OrganizationResultComponent, PhoneNumberComponent, PostFiles, PostJson, PostalCodeComponent, PostalCodeInputComponent, PoweredByComponent, PrivacyPolicyLinkComponent, QUERY_STRING_ERRORID_OVERRIDE, QUERY_STRING_INSTALL_PAGE_URL, QUERY_STRING_SEGMENT_OVERRIDE, QUERY_STRING_STEP_OVERRIDE, QUERY_STRING_SUBSEGMENT_OVERRIDE, RequestOrganizationContext, RequestOrganizationErrorComponent, RequestOrganizationForm, RequestOrganizationFormFooterComponent, RequestOrganizationSearchComponent, RequestOrganizationSearchResultComponent, RequestOrganizationSuccessComponent, ReviewPendingComponent, RewardsRemainingComponent, SHEERID, SMSCodeComponent, SSN_STRING_LENGTH, SSOPendingComponent, SearchFieldComponent, SegmentEnum, Segments, SelectButtonComponent, SelectComponent, SelectListComponent, SocialSecurityNumber, SortByLabel, SsnChoice, StateComponent, StateEnum, StateSelectComponent, StatusComponent, StepActiveMilitaryPersonalInfoComponent, StepDriverLicensePersonalInfoComponent, StepGeneralIdentityPersonalInfoComponent, StepHybridIdentityPersonalInfoComponent, SubSegmentEnum, TeacherSchoolComponent, TryAgainButtonComponent, TryAgainSteps, TypeaheadComponent, UPLOAD_FILE_PREFIX, UploadInfoComponent, VerificationApiClient, VerificationForm, VerificationSteps, VerificationStepsEnum, addFiles, addHook, allMockedResponses, arrayUnique, assertValidConversionRequest, assertValidDatabaseId, assertValidFieldId, assertValidFunction, assertValidHook, assertValidHookName, assertValidHtmlElement, assertValidLocale, assertValidMockStepName, assertValidProgramId, assertValidSegmentName, assertValidTrackingId, assertValidTryAgainStep, assertValidVerificationStepName, carrierConsentValueValidator, closeTabRef, collectDeviceProfile, conversion, convertByTrackingId, convertByVerificationId, customValidatorExists$1 as customValidatorExists, deepClone, deepMerge, displaySSN, employmentPInfoReqEmpty, ensureMaxMetadataKeyValueLengths, ensureTrailingSlash, fetchExistingVerificationRequest, fetchProgramOrganizations, fetchRequestOrganizations, formatTwoDigitValues, getAddSchoolRequestUrl, getAllEmptyViewModels, getAvailableCountryChoices, getAvailableLocaleChoices, getAvailableLocales, getAvailableMilitaryStatuses, getAvailableStateChoices, getCompanyName, getConfiguredCountries, getConfiguredStates, getCustomValidator, getCustomValidatorFields, getDefaultCountryChoice, getDomainFromUrl, getEmptyViewModel, getEstAndMaxReviewTimes, getEstimatedReviewTime, getExtendedFieldValidationErrorsEmpty, getFaqLink, getFieldDisplayOrderFromRefs, getFieldValidationErrors, getFieldValidationErrorsEmpty, getFingerprint, getFirstErroredFieldId, getHook, getLocaleSafely, getLogoUrl, getMarketConsent, getMaxReviewTime, getMessages, getMetadata, getNewEmailCodeResendUrl, getNewSmsCodeResendUrl, getNewVerificationRequestUrl, getOptions, getOrgSearchCountryTags, getOverriddenMock, getOverridenValidator, getPhoneNumberValidationError, getPrivacyPolicyCompanyName, getPrivacyPolicyUrl, getProgramThemeUrl, getQueryParamsFromUrl, getRefByFieldId, getRefs, getRouteOverride, getSafe, getSheerIdScriptBasePath, getStatusLabel, getTabRef, getTrackingIdFromQueryString, getVerificationIdFromQueryString, getVerificationStatusUrl, handleCountryOnKeyDown, handleEmailOnKeyDown, handleStateChange, hasFailedInstantMatch, howDoesVerifyingWorkMessages, isFormErrored, isFormFilled, isTestEmailDomains, isValidLocale, isValidUsPostalCode, listenToSheerIdFrame, loadInModal, loadInlineIframe, logger, orgToOption, orgsInStatus, overrideComponent, overrideValidator, phoneNumberValidator, populateViewModelFromQueryParams, postVerificationSizeUpdates, postalCodeMatchers, postalCodeValidator, produceDraftViewModel, produceDraftViewModelWithRequiredFields, recordEvent, recordVerificationResponse, recordViewModelChange, refreshStore, registerAdditionalLocales, removeAllFiles, removeCustomValidator, removeFile, requestOrganizationConstants, resetCustomValidators, resetHooks, resetMetadata, resetOptions, resetOverriddenComponents, resetOverriddenValidators, resetRefs, resetStore, resetTabRef, resetViewModel, resolveTrackingId, setCustomValidator, setDimension, setFocus, setGaDimensionIsTest, setMetadata, setOptions, setRef, setTabRef, setViewModel, shouldCollectAddressFields, shouldCollectPostalCode, socialSecurityEmpty, speakToOuterFrame, submitAddSchoolRequest, submitForm, unDisplaySSN, updateFieldValidationErrors, updateFieldValidationErrorsByFieldId, updateMilitaryViewModel, updateViewModelOrganization, usePollingInterval, validateFieldById, validateMetadata };